import { KP_AYANAMSHA_PREFERENCE_TRANSLATIONS } from './kpAyanamshaPreference';
import { DEFAULT_CHART_SECTION_TRANSLATIONS } from './defaultChartSectionTranslations';
import { normalizeLanguage, SupportedLanguage } from './languages';
import { MODULE_INLINE_TRANSLATIONS } from './moduleInlineTranslations';

export const INLINE_TRANSLATIONS: Partial<Record<SupportedLanguage, Record<string, string>>> = {
  "ta": {
    "Client Management": "வாடிக்கையாளர் மேலாண்மை",
    "Dashboard": "டாஷ்போர்டு",
    "Clients": "வாடிக்கையாளர்கள்",
    "Consultations": "ஆலோசனைகள்",
    "Notes": "குறிப்புகள்",
    "Follow-ups": "பின்தொடர்தல்",
    "Reports": "அறிக்கைகள்",
    "Remedies": "பரிகாரங்கள்",
    "Predictions": "கணிப்புகள்",
    "Planner": "திட்டமிடுபவர்",
    "Templates": "வார்ப்புருக்கள்",
    "Analytics": "பகுப்பாய்வு",
    "Payments": "கொடுப்பனவுகள்",
    "Settings": "அமைப்புகள்",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings இல் இயல்புநிலை நகரத்தை சேமிக்கலாம். தேர்வு செய்யும் வரை நகர புலங்கள் காலியாக இருக்கும்.",
    "is now your default city.": "இப்போது உங்கள் இயல்புநிலை நகரமாக உள்ளது.",
    "Search your default city": "உங்கள் இயல்புநிலை நகரத்தைத் தேடுங்கள்",
    "This color is saved for the website theme and PDF report accent.": "இந்த நிறம் இணையதள தீம் மற்றும் PDF அறிக்கை accent க்கு சேமிக்கப்படும்.",
    "Turn All off to include only the checked modules in the report.": "அறிக்கையில் தேர்ந்தெடுத்த தொகுதிகள் மட்டும் வர All ஐ ஆஃப் செய்யவும்.",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All ஆன் இருந்தால் PDF இல் அனைத்து தொகுதிகளும் வரும். தேர்ந்தெடுத்தவற்றை மட்டும் சேர்க்க அதை ஆஃப் செய்யவும்.",
    "Uranus, Neptune and Pluto stay hidden by default.": "யுரேனஸ், நெப்ட்யூன் மற்றும் ப்ளூட்டோ இயல்பாக மறைக்கப்பட்டிருக்கும்.",
    "Show Uranus, Neptune and Pluto": "யுரேனஸ், நெப்ட்யூன் மற்றும் ப்ளூட்டோவை காட்டவும்",
    "When off, Nadi and KP also use the selected global ayanamsha.": "ஆஃப் செய்தால், நாடி மற்றும் KP தேர்ந்தெடுத்த உலகளாவிய அயனாம்சத்தையே பயன்படுத்தும்.",
    "Use KP for Nadi and KP": "நாடி மற்றும் KP க்கு KP பயன்படுத்தவும்",
    "Use KP ayanamsha for Nadi and KP": "நாடி மற்றும் KP க்கு KP அயனாம்சம் பயன்படுத்தவும்",
    "Night": "இரவு",
    "Dark": "இருள்",
    "Light": "ஒளி",
    "Clear default city": "இயல்புநிலை நகரத்தை நீக்கவும்",
    "Default City": "இயல்புநிலை நகரம்",
    "Default city": "இயல்புநிலை நகரம்",
    "Theme Color": "தீம் நிறம்",
    "Theme color": "தீம் நிறம்",
    "Include all modules": "அனைத்து தொகுதிகளையும் சேர்க்கவும்",
    "PDF Report Modules": "PDF அறிக்கை தொகுதிகள்",
    "PDF report modules": "PDF அறிக்கை தொகுதிகள்",
    "Show": "காட்டவும்",
    "Hide": "மறைக்கவும்",
    "Outer Planets": "வெளிப்புற கிரகங்கள்",
    "Outer planets": "வெளிப்புற கிரகங்கள்",
    "Ayanamsha": "அயனாம்சம்",
    "Mean Node": "சராசரி நோடு",
    "True Node": "உண்மை நோடு",
    "Rahu/Ketu Calculation": "ராகு/கேது கணக்கீடு",
    "Rahu/Ketu calculation": "ராகு/கேது கணக்கீடு",
    "East": "கிழக்கு இந்திய",
    "South": "தென் இந்திய",
    "North": "வட இந்திய",
    "Chart Style": "விளக்கப்பட பாணி",
    "Chart style": "விளக்கப்பட பாணி",
    "Language": "மொழி",
    "Records": "பதிவுகள்",
    "Relations": "உறவுகள்",
    "Relation": "உறவு",
    "Add Client": "கிளையண்டைச் சேர்க்கவும்",
    "Add Consultation": "ஆலோசனையைச் சேர்க்கவும்",
    "Add Note": "குறிப்பைச் சேர்க்கவும்",
    "Add Follow-up": "பின்தொடர்வதைச் சேர்க்கவும்",
    "Create Report": "அறிக்கையை உருவாக்கவும்",
    "Assign Remedy": "பரிகாரத்தை ஒதுக்குங்கள்",
    "Add Prediction": "கணிப்புகளைச் சேர்க்கவும்",
    "Add Payment": "கட்டணத்தைச் சேர்க்கவும்",
    "Assign Chart": "விளக்கப்படத்தை ஒதுக்கவும்",
    "Add Relation": "உறவைச் சேர்க்கவும்",
    "CMS Action": "CMS செயல்",
    "Client": "வாடிக்கையாளர்",
    "Chart": "விளக்கப்படம்",
    "Related Client": "தொடர்புடைய வாடிக்கையாளர்",
    "Full Name": "முழுப் பெயர்",
    "Phone Number": "தொலைபேசி எண்",
    "WhatsApp Number": "வாட்ஸ்அப் எண்",
    "Email": "மின்னஞ்சல்",
    "Birth Place": "பிறந்த இடம்",
    "Current City": "தற்போதைய நகரம்",
    "Main Topic": "முக்கிய தலைப்பு",
    "Status": "நிலை",
    "Source": "ஆதாரம்",
    "Tags": "குறிச்சொற்கள்",
    "Internal Note": "உள் குறிப்பு",
    "Purpose": "நோக்கம்",
    "Relation Type": "உறவு வகை",
    "Title": "தலைப்பு",
    "Topic": "தலைப்பு",
    "Date": "தேதி",
    "Time": "நேரம்",
    "Amount": "தொகை",
    "Mode": "பயன்முறை",
    "Payment Status": "கட்டண நிலை",
    "Note / Summary": "குறிப்பு / சுருக்கம்",
    "Close": "மூடு",
    "Cancel": "ரத்து செய்",
    "Save": "சேமிக்கவும்",
    "Saving": "சேமிப்பு",
    "Save Changes": "மாற்றங்களைச் சேமிக்கவும்",
    "Edit Client": "கிளையண்டைத் திருத்து",
    "Client Chart": "வாடிக்கையாளர் விளக்கப்படம்",
    "Comma separated": "கமா பிரிக்கப்பட்டது",
    "Search by name, phone, email, topic, or tag": "பெயர், தொலைபேசி, மின்னஞ்சல், தலைப்பு அல்லது குறிச்சொல் மூலம் தேடவும்",
    "Search clients, phone, topic": "வாடிக்கையாளர்கள், தொலைபேசி, தலைப்பு ஆகியவற்றைத் தேடுங்கள்",
    "Search your saved charts by chart name": "உங்கள் சேமித்த விளக்கப்படங்களை விளக்கப்படத்தின் பெயரால் தேடுங்கள்",
    "Linked Chart": "இணைக்கப்பட்ட விளக்கப்படம்",
    "Select linked chart": "இணைக்கப்பட்ட விளக்கப்படத்தைத் தேர்ந்தெடுக்கவும்",
    "Link a chart to this client before adding records.": "பதிவுகளைச் சேர்ப்பதற்கு முன் இந்தக் கிளையண்டுடன் விளக்கப்படத்தை இணைக்கவும்.",
    "Connect this client with another saved client profile": "இந்த கிளையண்டை மற்றொரு சேமித்த கிளையன்ட் சுயவிவரத்துடன் இணைக்கவும்",
    "CMS for astrologer client work": "ஜோதிடர் வாடிக்கையாளர் பணிக்கான CMS",
    "Premium Pro unlocks Client Management": "பிரீமியம் ப்ரோ வாடிக்கையாளர் நிர்வாகத்தைத் திறக்கிறது",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "கிளையன்ட் சுயவிவரங்கள், ஆலோசனைகள், குறிப்புகள், பின்தொடர்தல்கள், அறிக்கைகள், தீர்வுகள், கணிப்புகள், பகுப்பாய்வு மற்றும் கட்டண கண்காணிப்பு ஆகியவற்றை ஒரே பணியிடத்தில் நிர்வகிக்க மேம்படுத்தவும்.",
    "Upgrade to Premium Pro": "பிரீமியம் ப்ரோவுக்கு மேம்படுத்தவும்",
    "CMS modules included": "CMS தொகுதிகள் சேர்க்கப்பட்டுள்ளது",
    "Please login to use Client Management. CMS data is stored per account.": "கிளையண்ட் மேனேஜ்மென்ட்டைப் பயன்படுத்த உள்நுழையவும். ஒரு கணக்கிற்கு CMS தரவு சேமிக்கப்படுகிறது.",
    "Login": "உள்நுழைக",
    "Loading live CMS data...": "நேரடி CMS தரவை ஏற்றுகிறது...",
    "Quick Actions": "விரைவான செயல்கள்",
    "Client Records": "வாடிக்கையாளர் பதிவுகள்",
    "Client Record": "வாடிக்கையாளர் பதிவு",
    "Client Profile": "வாடிக்கையாளர் சுயவிவரம்",
    "Back to Clients": "வாடிக்கையாளர்களுக்குத் திரும்பு",
    "View": "காண்க",
    "Edit": "திருத்தவும்",
    "Delete": "நீக்கு",
    "Note": "குறிப்பு",
    "Archive": "காப்பகம்",
    "Download PDF": "PDF ஐப் பதிவிறக்கவும்",
    "Delete this record?": "இந்தப் பதிவை நீக்கவா?",
    "Unable to edit this CMS record.": "இந்த CMS பதிவைத் திருத்த முடியவில்லை.",
    "Unable to update CMS record.": "CMS பதிவைப் புதுப்பிக்க முடியவில்லை.",
    "Unable to delete CMS record.": "CMS பதிவை நீக்க முடியவில்லை.",
    "No contact added": "தொடர்பு எதுவும் சேர்க்கப்படவில்லை",
    "No topic": "தலைப்பு இல்லை",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "இன்னும் வாடிக்கையாளர்கள் இல்லை. CMS டாஷ்போர்டை நிரப்பத் தொடங்க உங்கள் முதல் உண்மையான கிளையண்டைச் சேர்க்கவும்.",
    "Last Consultation": "கடைசி ஆலோசனை",
    "Next Follow-up": "அடுத்த பின்தொடர்தல்",
    "Date of Birth": "பிறந்த தேதி",
    "Time of Birth": "பிறந்த நேரம்",
    "Client Details": "வாடிக்கையாளர் விவரங்கள்",
    "No connected profiles yet.": "இணைக்கப்பட்ட சுயவிவரங்கள் எதுவும் இல்லை.",
    "Select a client record to view details.": "விவரங்களைக் காண கிளையன்ட் பதிவைத் தேர்ந்தெடுக்கவும்.",
    "Record": "பதிவு",
    "Consultation Summary": "ஆலோசனை சுருக்கம்",
    "Client Note": "வாடிக்கையாளர் குறிப்பு",
    "Start a consultation record with summary, topic, mode and payment fields.": "சுருக்கம், தலைப்பு, முறை மற்றும் கட்டணப் புலங்களுடன் ஆலோசனைப் பதிவைத் தொடங்கவும்.",
    "Start a private note attached to a client profile.": "கிளையன்ட் சுயவிவரத்துடன் இணைக்கப்பட்ட தனிப்பட்ட குறிப்பைத் தொடங்கவும்.",
    "Start a pending follow-up with due date and topic.": "நிலுவையிலுள்ள ஃபாலோ-அப் தேதி மற்றும் தலைப்புடன் தொடங்கவும்.",
    "Start a report record connected to the client timeline.": "கிளையன்ட் காலவரிசையுடன் இணைக்கப்பட்ட அறிக்கை பதிவைத் தொடங்கவும்.",
    "Start an active remedy record for client guidance.": "கிளையன்ட் வழிகாட்டுதலுக்கான செயலில் உள்ள தீர்வு பதிவைத் தொடங்கவும்.",
    "Start an open prediction record with notes and follow-up date.": "குறிப்புகள் மற்றும் பின்தொடர்தல் தேதியுடன் திறந்த கணிப்புப் பதிவைத் தொடங்கவும்.",
    "Statuses": "நிலைகள்",
    "Topics": "தலைப்புகள்",
    "Sources": "ஆதாரங்கள்",
    "No records found for the current filters.": "தற்போதைய வடிப்பான்களுக்கான பதிவுகள் எதுவும் இல்லை.",
    "Total Clients": "மொத்த வாடிக்கையாளர்கள்",
    "New Clients This Month": "இந்த மாதம் புதிய வாடிக்கையாளர்கள்",
    "Consultations This Month": "இந்த மாதம் கலந்தாய்வு",
    "Today's Consultations": "இன்றைய ஆலோசனைகள்",
    "Consultations scheduled for today from real client records.": "உண்மையான வாடிக்கையாளர் பதிவுகளிலிருந்து இன்று திட்டமிடப்பட்ட ஆலோசனைகள்.",
    "No consultations scheduled for today.": "இன்று கலந்தாய்வு எதுவும் திட்டமிடப்படவில்லை.",
    "Pending Follow-ups": "நிலுவையில் உள்ள பின்தொடர்தல்கள்",
    "Reports Created": "அறிக்கைகள் உருவாக்கப்பட்டன",
    "Active Remedies": "செயலில் உள்ள வைத்தியம்",
    "Open Predictions": "கணிப்புகளைத் திறக்கவும்",
    "Pending Payments": "நிலுவையில் உள்ள கொடுப்பனவுகள்",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "கிளையன்ட் செயல்பாடு, சமீபத்திய வேலை, பின்தொடர்தல்கள், அறிக்கைகள், கணிப்புகள், தீர்வுகள் மற்றும் நிலுவையில் உள்ள கட்டணங்களை ஒரே இடத்தில் பார்க்கவும்.",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "பிறப்பு விவரங்கள், தலைப்புகள், குறிச்சொற்கள், நிலை மற்றும் காப்பக/மீட்டெடுக்கும் செயல்களுடன் ஜோதிட கிளையன்ட் பதிவுகளை நிர்வகிக்கவும்.",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "அமர்வு விவரங்கள், இணைக்கப்பட்ட விளக்கப்படங்கள், தலைப்புகள், அவதானிப்புகள், கணிப்புகள், தீர்வுகள் மற்றும் பின்தொடர்தல் தேதிகளை சேமிக்கவும்.",
    "Keep private consultation notes and chart observations attached to client profiles.": "வாடிக்கையாளர் சுயவிவரங்களுடன் தனிப்பட்ட ஆலோசனைக் குறிப்புகள் மற்றும் விளக்கப்பட அவதானிப்புகளை இணைக்கவும்.",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "புஷ், எஸ்எம்எஸ், மின்னஞ்சல் அல்லது வாட்ஸ்அப் விழிப்பூட்டல்கள் இல்லாமல் கிளையண்ட் மேனேஜ்மென்ட்டில் இன்று மற்றும் வரவிருக்கும் பின்தொடர்தல்களைக் கண்காணிக்கவும்.",
    "Create and organize client reports generated from saved charts and consultation context.": "சேமிக்கப்பட்ட விளக்கப்படங்கள் மற்றும் ஆலோசனை சூழலில் இருந்து உருவாக்கப்பட்ட கிளையன்ட் அறிக்கைகளை உருவாக்கி ஒழுங்கமைக்கவும்.",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "தீர்வுகளை ஒதுக்கவும், செயலில் உள்ள வழிகாட்டுதலைக் குறிக்கவும் மற்றும் தீர்வு வரலாற்றை கிளையன்ட் காலவரிசையுடன் இணைக்கவும்.",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "ஒவ்வொரு வாடிக்கையாளருக்கும் திறந்த கணிப்புகள், தேதிகள், நம்பிக்கைக் குறிப்புகள் மற்றும் விளைவு புதுப்பிப்புகளைக் கண்காணிக்கவும்.",
    "Plan consultations, follow-ups and payment dates in one working view.": "ஆலோசனைகள், பின்தொடர்தல்கள் மற்றும் பணம் செலுத்தும் தேதிகளை ஒரே பார்வையில் திட்டமிடுங்கள்.",
    "Prepare reusable consultation, report, remedy and prediction templates.": "மீண்டும் பயன்படுத்தக்கூடிய ஆலோசனை, அறிக்கை, தீர்வு மற்றும் முன்கணிப்பு வார்ப்புருவைத் தயாரிக்கவும்.",
    "Review client activity, consultation volume, reports created and pending work.": "கிளையன்ட் செயல்பாடு, ஆலோசனை அளவு, உருவாக்கப்பட்ட அறிக்கைகள் மற்றும் நிலுவையில் உள்ள பணிகளை மதிப்பாய்வு செய்யவும்.",
    "Track consultation amounts and payment status without plan or pricing rules.": "திட்டம் அல்லது விலை விதிகள் இல்லாமல் ஆலோசனைத் தொகைகள் மற்றும் கட்டண நிலையைக் கண்காணிக்கவும்.",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "கிளையன்ட் ஆதாரங்கள், நிலைகள், தலைப்புகள், குறிச்சொற்கள் மற்றும் உள் CMS விருப்பங்களை உள்ளமைக்கவும்.",
    "Showing saved records connected to client records.": "கிளையன்ட் பதிவுகளுடன் இணைக்கப்பட்ட சேமித்த பதிவுகளைக் காட்டுகிறது.",
    "No Status": "நிலை இல்லை",
    "No Mode": "பயன்முறை இல்லை",
    "No Payment Status": "கட்டணம் செலுத்தும் நிலை இல்லை",
    "No Topic": "தலைப்பு இல்லை",
    "No Source": "ஆதாரம் இல்லை",
    "All Statuses": "அனைத்து நிலைகள்",
    "All Topics": "அனைத்து தலைப்புகள்",
    "No clients found": "வாடிக்கையாளர்கள் இல்லை",
    "Type to search clients": "வாடிக்கையாளர்களைத் தேட தட்டச்சு செய்யவும்",
    "No charts found": "விளக்கப்படங்கள் எதுவும் இல்லை",
    "Type to search saved charts": "சேமித்த விளக்கப்படங்களைத் தேட தட்டச்சு செய்யவும்",
    "Type to search related client": "தொடர்புடைய கிளையண்டைத் தேட தட்டச்சு செய்யவும்",
    "Open": "திற",
    "Pending": "நிலுவையில் உள்ளது",
    "Scheduled": "திட்டமிடப்பட்டது",
    "Completed": "முடிக்கப்பட்டது",
    "Follow-up Pending": "பின்தொடர்தல் நிலுவையில் உள்ளது",
    "Cancelled": "ரத்து செய்யப்பட்டது",
    "Closed": "மூடப்பட்டது",
    "No-show": "நிகழ்ச்சி இல்லை",
    "Not Applicable": "பொருந்தாது",
    "Paid": "செலுத்தப்பட்டது",
    "Partially Paid": "பகுதி ஊதியம்",
    "Refunded": "திருப்பி கொடுக்கப்பட்டது",
    "Phone": "தொலைபேசி",
    "WhatsApp Call": "வாட்ஸ்அப் அழைப்பு",
    "Video Call": "வீடியோ அழைப்பு",
    "In-person": "நேரில்",
    "Chat": "அரட்டை",
    "Other": "மற்றவை",
    "New": "புதியது",
    "VIP": "விஐபி",
    "Inactive": "செயலற்றது",
    "Consultation Completed": "கலந்தாய்வு முடிந்தது",
    "WhatsApp": "வாட்ஸ்அப்",
    "Instagram": "Instagram",
    "YouTube": "YouTube",
    "Referral": "பரிந்துரை",
    "Website": "இணையதளம்",
    "Walk-in": "வாக்-இன்",
    "Repeat Client": "மீண்டும் கிளையண்ட்",
    "Family Referral": "குடும்ப பரிந்துரை",
    "Business": "வணிகம்",
    "Finance": "நிதி",
    "Property": "சொத்து",
    "Children": "குழந்தைகள்",
    "Foreign Settlement": "வெளிநாட்டு குடியேற்றம்",
    "Legal": "சட்டபூர்வமானது",
    "Remedy": "பரிகாரம்",
    "General": "பொது",
    "Active": "செயலில்",
    "Past": "கடந்த",
    "Potential": "சாத்தியம்",
    "Archived": "காப்பகப்படுத்தப்பட்டது",
    "Spouse": "மனைவி",
    "Husband": "கணவன்",
    "Wife": "மனைவி",
    "Child": "குழந்தை",
    "Son": "மகன்",
    "Daughter": "மகள்",
    "Father": "அப்பா",
    "Mother": "அம்மா",
    "Sibling": "உடன்பிறப்பு",
    "Brother": "அண்ணன்",
    "Sister": "சகோதரி",
    "Marriage Prospect": "திருமண வாய்ப்பு",
    "Fiance": "வருங்கால மனைவி",
    "Business Partner": "வணிக பங்குதாரர்",
    "Friend": "நண்பர்",
    "Relative": "உறவினர்",
    "Upgrade": "மேம்படுத்து",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "நீங்கள் 2 வாடிக்கையாளர்களை மட்டுமே சேர்க்க முடியும். அதிக வாடிக்கையாளர்களுக்கு Premium க்கு மேம்படுத்தவும்.",
    "None": "இல்லை",
    "Education": "கல்வி",
    "Awards": "விருதுகள்",
    "Prize": "பரிசு",
    "Career": "தொழில்",
    "Love": "அன்பு",
    "Marriage": "திருமணம்",
    "Dowry or Legacy": "வரதட்சணை அல்லது மரபு",
    "Divorce": "விவாகரத்து",
    "Abortion": "கருக்கலைப்பு",
    "Child Birth": "குழந்தை பிறப்பு",
    "Property/Vehicle Purchase": "சொத்து/வாகனம் வாங்குதல்",
    "Property/Vehicle Sale": "சொத்து/வாகன விற்பனை",
    "Love and Caring": "அன்பு மற்றும் அக்கறை",
    "Depression": "மனச்சோர்வு",
    "Aggression": "ஆக்கிரமிப்பு",
    "Health": "ஆரோக்கியம்",
    "Travel": "பயணம்",
    "Homecoming": "வீடு திரும்புதல்",
    "Litigation": "வழக்கு",
    "Arrest": "கைது செய்",
    "Locked": "பூட்டப்பட்டது",
    "Strong": "வலுவான",
    "Weak": "பலவீனமான",
    "Supportive": "ஆதரவான",
    "Avoid": "தவிர்க்கவும்",
    "Premium": "பிரீமியம்",
    " UTC": "UTC",
    "Unable to calculate Tithi Pravesh": "திதி பிரவேசத்தை கணக்கிட முடியவில்லை",
    "IANA timezone": "IANA நேர மண்டலம்",
    "TP Local": "TP உள்ளூர்",
    "TP UTC": "TP UTC",
    "Next TP Local": "அடுத்த TP உள்ளூர்",
    "Models: KP + Vedic": "மாதிரிகள்: கேபி + வேதிக்",
    "Overall Year Theme": "ஒட்டுமொத்த ஆண்டு தீம்",
    "Career & Job": "தொழில் & வேலை",
    "Finance & Savings": "நிதி & சேமிப்பு",
    "Relationship & Marriage": "உறவு & திருமணம்",
    "Family Matters": "குடும்ப விஷயங்கள்",
    "Property & Vehicle": "சொத்து & வாகனம்",
    "Health & Wellness": "உடல்நலம் & ஆரோக்கியம்",
    "Spiritual Growth": "ஆன்மீக வளர்ச்சி",
    "Social Status & Recognition": "சமூக நிலை & அங்கீகாரம்",
    "Please select a saved chart first.": "சேமித்த விளக்கப்படத்தை முதலில் தேர்ந்தெடுக்கவும்.",
    "Unable to generate Tajika Varshphal": "Tajika Varshpal ஐ உருவாக்க முடியவில்லை",
    "Premium yearly module": "பிரீமியம் வருடாந்திர தொகுதி",
    "Tajika Varshphal": "தாஜிகா வர்ஷ்பால்",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "வர்ஷ லக்னம், முந்தா, வர்ஷ பகவான், சஹம்ஸ், மாதாந்திர வழிகாட்டுதல், பரிகாரங்கள் மற்றும் நடைமுறை வாழ்க்கைத் தீம்கள் ஆகியவற்றைக் கொண்ட சூரிய ரிட்டர்ன் அடிப்படையிலான வருடாந்திர ஜாதகம் இந்த சேமிக்கப்பட்ட குண்ட்லியிலிருந்து தனிப்பயனாக்கப்பட்டது.",
    "Saved chart": "சேமிக்கப்பட்ட விளக்கப்படம்",
    "Untitled Chart": "பெயரிடப்படாத விளக்கப்படம்",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "உங்களின் 4 இலவச பிரீமியம் கிரெடிட்கள் பயன்படுத்தப்படுகின்றன. வரம்பற்ற பிரீமியம் அணுகலுக்கு Kundlistar பிரீமியத்திற்கு மேம்படுத்தவும்.",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "நீங்கள் 4 நிஷுல்க் ப்ரீமியம் கிரெடிட் பயன்பாடு அல்லது சுகே உள்ளது. அசீமித் ப்ரீமியம் எக்ஸ்சேஸ் Kundlistar பிரீமியம் லென்.",
    "Core Year Markers": "முக்கிய ஆண்டு குறிப்பான்கள்",
    "Solar Return": "சோலார் ரிட்டர்ன்",
    "Varsha Lagna": "வர்ஷ லக்னம்",
    "Muntha Lord": "முந்தா அதிபதி",
    "Varsha Lord": "வர்ஷா பகவான்",
    "Varshesh Method": "வர்ஷேஷ் முறை",
    "Yearly Summary": "வருடாந்திர சுருக்கம்",
    "Not available yet.": "இன்னும் கிடைக்கவில்லை.",
    "Varshesh Candidates": "வர்ஷேஷ் வேட்பாளர்கள்",
    "Risk Areas": "ஆபத்து பகுதிகள்",
    "Favourable Periods": "சாதகமான காலகட்டங்கள்",
    "Challenging Periods": "சவாலான காலகட்டங்கள்",
    "Remedies & Final Advice": "பரிகாரங்கள் & இறுதி ஆலோசனை",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "தாஜிகா வர்ஷ்பால் விளக்கமான வருடாந்திர வழிகாட்டுதலை வழங்குகிறது. இது மருத்துவ, சட்ட, நிதி அல்லது சில கணிப்பு ஆலோசனையாக கருதப்படக்கூடாது.",
    "Griha Pravesh": "க்ரிஹ பிரவேஷ்",
    "Purva Phalguni": "பூரம்",
    "Uttara Phalguni": "உத்திரம்",
    "Purva Ashadha": "பூராடம்",
    "Uttara Ashadha": "உத்திராடம்",
    "Purva Bhadrapada": "பூரட்டாதி",
    "Uttara Bhadrapada": "உத்திரட்டாதி",
    "Param Mitra": "பரம் மித்ரா",
    "Kundli birthplace": "குண்ட்லி பிறந்த இடம்",
    "Selected city": "தேர்ந்தெடுக்கப்பட்ட நகரம்",
    "Muhurat - Kundlistar": "முஹுரத் - Kundlistar",
    "Please select a city first.": "முதலில் ஒரு நகரத்தைத் தேர்ந்தெடுக்கவும்.",
    "Unable to calculate Muhurat.": "முஹூர்த்தத்தை கணக்கிட முடியவில்லை.",
    "Unable to calculate personalized Muhurat.": "தனிப்பயனாக்கப்பட்ட முஹுரத்தை கணக்கிட முடியவில்லை.",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "பஞ்சாங்கம், சோகாடியா, ஹோரா, தாராபலா மற்றும் சந்திரபாலா ஆகியவற்றைப் பயன்படுத்தி பொதுவான மற்றும் தனிப்பயனாக்கப்பட்ட முஹுரத்தை கண்டறியவும்.",
    "Muhurat Finder": "முஹுரத் தேடுபவர்",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "பஞ்சாங்கம், சோகடியா மற்றும் பிரீமியம் தனிப்பட்ட பிறப்பு காரணிகளைப் பயன்படுத்தி பயனுள்ள நேர சாளரங்களைக் கண்டறியவும்.",
    "Search city...": "நகரத்தைத் தேடு...",
    "Using selected Kundli": "தேர்ந்தெடுக்கப்பட்ட குண்ட்லியைப் பயன்படுத்துதல்",
    "Find Free": "இலவசத்தைக் கண்டுபிடி",
    "Free General Muhurat": "இலவச ஜெனரல் முஹுரத்",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "அடுத்த 7 நாட்களுக்கு முதல் 3 இடங்கள். ராகு காலம், யமகண்டா, குலிகா ஆகியவை நீங்கும்.",
    "Today's Muhurat": "இன்றைய முஹூர்த்தம்",
    "Daily Muhurat by Kundlistar": "Kundlistar மூலம் தினசரி முஹுரத்",
    "Shared via Kundlistar": "Kundlistar வழியாக பகிரப்பட்டது",
    "Kundlistar Muhurat": "Kundlistar முஹுரத்",
    "Share Image": "படத்தைப் பகிரவும்",
    "Share Text": "உரையைப் பகிரவும்",
    "Copy Text": "உரையை நகலெடுக்கவும்",
    "Click Find Free to use the selected Kundli birthplace.": "தேர்ந்தெடுக்கப்பட்ட குண்ட்லி பிறந்த இடத்தைப் பயன்படுத்த, இலவசம் என்பதைக் கிளிக் செய்யவும்.",
    "Select a city and click Find Free.": "ஒரு நகரத்தைத் தேர்ந்தெடுத்து, இலவசத்தைக் கண்டுபிடி என்பதைக் கிளிக் செய்யவும்.",
    "Premium Personalized Muhurat": "பிரீமியம் தனிப்பயனாக்கப்பட்ட முஹுரத்",
    "Loading Kundli details...": "குண்ட்லி விவரங்களை ஏற்றுகிறது...",
    "Birth Nakshatra": "பிறந்த நட்சத்திரம்",
    "Birth Moon Rashi": "பிறந்த சந்திரன் ராசி",
    "Include night slots": "இரவு இடங்களைச் சேர்க்கவும்",
    "Find Premium": "பிரீமியத்தைக் கண்டறியவும்",
    "Your grounding and foundation energy appears strong in this chart.": "இந்த விளக்கப்படத்தில் உங்கள் அடிப்படை மற்றும் அடித்தள ஆற்றல் வலுவாக உள்ளது.",
    "Your grounding energy appears generally balanced in this chart.": "இந்த விளக்கப்படத்தில் உங்கள் அடிப்படை ஆற்றல் பொதுவாக சமநிலையில் உள்ளது.",
    "Reflection on routine, discipline, and inner stability may be useful.": "வழக்கமான, ஒழுக்கம் மற்றும் உள் நிலைத்தன்மை பற்றிய பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "Your creative and emotional flow energy appears strong in this chart.": "உங்கள் படைப்பு மற்றும் உணர்ச்சி ஓட்ட ஆற்றல் இந்த விளக்கப்படத்தில் வலுவாகத் தெரிகிறது.",
    "Your creative energy appears balanced in this chart.": "இந்த விளக்கப்படத்தில் உங்கள் படைப்பு ஆற்றல் சமநிலையில் உள்ளது.",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "படைப்பாற்றல், உணர்ச்சி வெளிப்பாடு மற்றும் உள் ஓட்டம் பற்றிய பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "Your confidence and willpower energy appears strong in this chart.": "உங்கள் நம்பிக்கையும் மன உறுதியும் இந்த அட்டவணையில் வலுவாகத் தெரிகிறது.",
    "Your action-taking energy appears balanced in this chart.": "இந்த விளக்கப்படத்தில் நீங்கள் செயல்படும் ஆற்றல் சமநிலையில் உள்ளது.",
    "Reflection on confidence, discipline, and decision power may be useful.": "நம்பிக்கை, ஒழுக்கம் மற்றும் முடிவெடுக்கும் திறன் ஆகியவற்றைப் பிரதிபலிப்பது பயனுள்ளதாக இருக்கும்.",
    "Your connection and compassion energy appears strong in this chart.": "உங்கள் இணைப்பு மற்றும் இரக்க ஆற்றல் இந்த விளக்கப்படத்தில் வலுவாகத் தெரிகிறது.",
    "Your emotional connection energy appears balanced in this chart.": "இந்த விளக்கப்படத்தில் உங்கள் உணர்ச்சி இணைப்பு ஆற்றல் சமநிலையில் உள்ளது.",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "நல்லிணக்கம், மன்னிப்பு மற்றும் உணர்ச்சி சமநிலை ஆகியவற்றின் பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "Your communication and expression energy appears strong in this chart.": "இந்த விளக்கப்படத்தில் உங்கள் தொடர்பு மற்றும் வெளிப்பாடு ஆற்றல் வலுவாக உள்ளது.",
    "Your expression energy appears balanced in this chart.": "இந்த விளக்கப்படத்தில் உங்கள் வெளிப்பாடு ஆற்றல் சமநிலையில் உள்ளது.",
    "Reflection on clear communication and self-expression may be useful.": "தெளிவான தொடர்பு மற்றும் சுய வெளிப்பாடு பற்றிய பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "Your intuition and inner clarity appears strong in this chart.": "உங்கள் உள்ளுணர்வு மற்றும் உள் தெளிவு இந்த விளக்கப்படத்தில் வலுவாகத் தெரிகிறது.",
    "Your intuitive clarity appears balanced in this chart.": "உங்கள் உள்ளுணர்வு தெளிவு இந்த விளக்கப்படத்தில் சமநிலையில் உள்ளது.",
    "Reflection on focus, intuition, and inner guidance may be useful.": "கவனம், உள்ளுணர்வு மற்றும் உள் வழிகாட்டுதல் ஆகியவற்றின் பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "A strong Fire element supports action, courage, and leadership energy.": "ஒரு வலுவான தீ உறுப்பு நடவடிக்கை, தைரியம் மற்றும் தலைமை ஆற்றலை ஆதரிக்கிறது.",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "தீ சீரானதாக தோன்றுகிறது, செயலுக்கும் பொறுமைக்கும் இடையே ஒரு நிலையான தாளத்தை ஆதரிக்கிறது.",
    "Reflection on confidence and action-taking may be useful.": "நம்பிக்கை மற்றும் செயலில் ஈடுபடுவது பயனுள்ளதாக இருக்கும்.",
    "A strong Earth element supports practicality, patience, and stability.": "ஒரு வலுவான பூமி உறுப்பு நடைமுறை, பொறுமை மற்றும் நிலைத்தன்மையை ஆதரிக்கிறது.",
    "Earth appears balanced, supporting practical thinking with flexibility.": "பூமி சீரானதாக தோன்றுகிறது, நெகிழ்வுத்தன்மையுடன் நடைமுறை சிந்தனையை ஆதரிக்கிறது.",
    "Reflection on grounding, consistency, and planning may be useful.": "அடித்தளம், நிலைத்தன்மை மற்றும் திட்டமிடல் பற்றிய பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "A strong Air element supports ideas, communication, and adaptability.": "ஒரு வலுவான காற்று உறுப்பு யோசனைகள், தொடர்பு மற்றும் தழுவல் ஆகியவற்றை ஆதரிக்கிறது.",
    "Air appears balanced, supporting harmony between thinking and action.": "காற்று சீரானதாக தோன்றுகிறது, சிந்தனைக்கும் செயலுக்கும் இடையில் நல்லிணக்கத்தை ஆதரிக்கிறது.",
    "Reflection on communication and flexibility may be useful.": "தொடர்பு மற்றும் நெகிழ்வுத்தன்மை பற்றிய பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "ஒரு வலுவான நீர் உறுப்பு உள்ளுணர்வு, உணர்திறன் மற்றும் உணர்ச்சி ஆழத்தை ஆதரிக்கிறது.",
    "Water appears balanced, supporting harmony between emotions and logic.": "நீர் சமநிலையுடன் தோன்றுகிறது, உணர்ச்சிகளுக்கும் தர்க்கத்திற்கும் இடையில் இணக்கத்தை ஆதரிக்கிறது.",
    "Reflection on emotional expression and inner connection may be useful.": "உணர்ச்சி வெளிப்பாடு மற்றும் உள் தொடர்பு பற்றிய பிரதிபலிப்பு பயனுள்ளதாக இருக்கும்.",
    "A strong Ether element supports spiritual awareness and broader vision.": "ஒரு வலுவான ஈதர் உறுப்பு ஆன்மீக விழிப்புணர்வு மற்றும் பரந்த பார்வையை ஆதரிக்கிறது.",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ஈதர் சமநிலையானதாக தோன்றுகிறது, ஆன்மீக மற்றும் நடைமுறை அணுகுமுறைக்கு இடையே நல்லிணக்கத்தை ஆதரிக்கிறது.",
    "Reflection, silence, and spiritual discipline may be useful.": "பிரதிபலிப்பு, அமைதி மற்றும் ஆன்மீக ஒழுக்கம் பயனுள்ளதாக இருக்கும்.",
    "For inner confidence, clarity, and soul strength.": "உள் நம்பிக்கை, தெளிவு மற்றும் ஆன்மா வலிமைக்கு.",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "இந்த இஷ்ட தேவதா அறிகுறி, கிரக பலம், லக்ன அதிபதி, சந்திரன் லக்ன அதிபதி, மற்றும் ஆத்மகாரகத்தை ஜாதகத்தில் இருந்து அடிப்படையாகக் கொண்டது.",
    "For calmness, emotional balance, and softness.": "அமைதி, உணர்ச்சி சமநிலை மற்றும் மென்மைக்காக.",
    "For courage, protection, and discipline.": "தைரியம், பாதுகாப்பு மற்றும் ஒழுக்கத்திற்காக.",
    "For intellect, speech, learning, and obstacle removal.": "அறிவுத்திறன், பேச்சு, கற்றல் மற்றும் தடைகளை நீக்குவதற்கு.",
    "For knowledge, guidance, dharma, and blessings.": "அறிவு, வழிகாட்டுதல், தர்மம் மற்றும் ஆசீர்வாதங்களுக்காக.",
    "Mahalakshmi Ji": "மகாலட்சுமி ஜி",
    "For harmony, beauty, comfort, and prosperity.": "நல்லிணக்கம், அழகு, ஆறுதல் மற்றும் செழிப்புக்காக.",
    "For karma, patience, discipline, and protection.": "கர்மா, பொறுமை, ஒழுக்கம் மற்றும் பாதுகாப்புக்காக.",
    "For protection from confusion, fear, and illusion.": "குழப்பம், பயம் மற்றும் மாயையிலிருந்து பாதுகாப்பிற்காக.",
    "Lord Ganesha": "விநாயகப் பெருமான்",
    "For spiritual clarity, detachment, and obstacle removal.": "ஆன்மீக தெளிவு, பற்றின்மை மற்றும் தடை நீக்கம்.",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "சக்ரா நுண்ணறிவுக்கு விளக்கப்படத் தரவு தேவை.",
    "Unable to load Chakra insight.": "சக்ரா நுண்ணறிவை ஏற்ற முடியவில்லை.",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "யஹ கேவல் ஜென்ம குண்டலி ஆதாரித் ஆத்யாத்மிக் ஆற்றல் நுண்ணறிவு மற்றும் சுய பிரதிபலிப்பு உள்ளது. இது தொழில்முறை ஆலோசனை இல்லை.",
    "Spiritual energy insights from Kundli": "குண்ட்லியில் இருந்து ஆன்மீக ஆற்றல் நுண்ணறிவு",
    "Calculated from your individual birth chart": "உங்கள் தனிப்பட்ட பிறப்பு விளக்கப்படத்திலிருந்து கணக்கிடப்பட்டது",
    "Chakra Balance": "சக்ரா இருப்பு",
    "Panch Tatva Balance": "பஞ்ச தத்வ இருப்பு",
    "Ishta Devata": "இஷ்ட தேவதா",
    "Signal planet": "சமிக்ஞை கிரகம்",
    "Very Good": "மிகவும் நல்லது",
    "Very Bad": "மிகவும் மோசமானது",
    "Panch Pakshi Calculator - Kundlistar": "பஞ்ச் பக்ஷி கால்குலேட்டர் - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "விளக்கப்படத்திலிருந்து பஞ்ச பக்ஷியை முன் நிரப்ப முடியவில்லை. நீங்கள் இன்னும் கைமுறையாக கணக்கிடலாம்.",
    "Could not load sunrise and sunset from Panchang for this chart location.": "இந்த விளக்கப்பட இருப்பிடத்திற்காக பஞ்சாங்கில் இருந்து சூரிய உதயம் மற்றும் சூரிய அஸ்தமனத்தை ஏற்ற முடியவில்லை.",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "பஞ்சாங்கில் இருந்து சூரிய உதயம், சூரிய அஸ்தமனம் மற்றும் அடுத்த சூரிய உதயத்தை ஏற்ற முடியவில்லை.",
    "Panch Pakshi calculation failed.": "பஞ்ச பக்ஷி கணக்கீடு தோல்வியடைந்தது.",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "பஞ்ச பக்ஷி பறவை, செயல்பாடு, யமம், அபஹார காலம், உறவு, மதிப்பெண் மற்றும் முடிவு ஆகியவற்றைக் கணக்கிடுங்கள்.",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "உங்கள் இலவச பிரீமியம் கிரெடிட்கள் முடிந்துவிட்டன. தொடர, Premium க்கு மேம்படுத்தவும்.",
    "This is a premium feature. You can use 1 free premium credit to continue.": "இது ஒரு பிரீமியம் அம்சமாகும். தொடர, 1 இலவச பிரீமியம் கிரெடிட்டைப் பயன்படுத்தலாம்.",
    "Selected Date": "தேர்ந்தெடுக்கப்பட்ட தேதி",
    "repeat(3, 1fr)": "மீண்டும் (3, 1fr)",
    "Birth Paksha": "பிறப்பு பக்ஷா",
    "Current Paksha": "தற்போதைய பக்ஷா",
    "repeat(4, 1fr)": "மீண்டும் (4, 1fr)",
    "Target Date Time": "இலக்கு தேதி நேரம்",
    "Next Sunrise": "அடுத்த சூரிய உதயம்",
    "Calculate Panch Pakshi": "பஞ்ச பக்ஷியைக் கணக்கிடுங்கள்",
    "repeat(2, 1fr)": "மீண்டும் (2, 1fr)",
    "repeat(6, 1fr)": "மீண்டும் (6, 1fr)",
    "Birth Pakshi": "பிறப்பு பக்ஷி",
    "Current Period": "தற்போதைய காலம்",
    "Current Yamam": "தற்போதைய யாமம்",
    "Main Activity": "முக்கிய செயல்பாடு",
    "Natal Western Chart": "நடால் மேற்கத்திய விளக்கப்படம்",
    "Life Phase Progression": "வாழ்க்கை கட்ட முன்னேற்றம்",
    "Self-focus, identity change, body awareness and personal reset.": "சுய கவனம், அடையாள மாற்றம், உடல் விழிப்புணர்வு மற்றும் தனிப்பட்ட மீட்டமைப்பு.",
    "Money, values, family, speech and security become emotionally important.": "பணம், மதிப்புகள், குடும்பம், பேச்சு மற்றும் பாதுகாப்பு உணர்வு ரீதியாக முக்கியமானதாகிறது.",
    "Communication, learning, siblings, writing and short travel become important.": "தொடர்பு, கற்றல், உடன்பிறந்தவர்கள், எழுத்து மற்றும் குறுகிய பயணம் ஆகியவை முக்கியமானதாகிறது.",
    "Home, mother, property, family and emotional roots become important.": "வீடு, தாய், சொத்து, குடும்பம் மற்றும் உணர்ச்சி வேர்கள் முக்கியமானதாகிறது.",
    "Creativity, romance, children, hobbies and self-expression become important.": "படைப்பாற்றல், காதல், குழந்தைகள், பொழுதுபோக்குகள் மற்றும் சுய வெளிப்பாடு ஆகியவை முக்கியமானவை.",
    "Work routine, health habits, service and discipline become important.": "பணி வழக்கம், சுகாதாரப் பழக்கம், சேவை மற்றும் ஒழுக்கம் ஆகியவை முக்கியமானதாகிறது.",
    "Relationship, marriage, partnership and public dealing become important.": "உறவு, திருமணம், கூட்டாண்மை மற்றும் பொது பரிவர்த்தனை ஆகியவை முக்கியமானவை.",
    "Deep emotional change, intimacy, shared money and transformation become important.": "ஆழ்ந்த உணர்ச்சி மாற்றம், நெருக்கம், பகிரப்பட்ட பணம் மற்றும் மாற்றம் ஆகியவை முக்கியமானவை.",
    "Learning, travel, teaching, belief and higher wisdom become important.": "கற்றல், பயணம், கற்பித்தல், நம்பிக்கை மற்றும் உயர்ந்த ஞானம் ஆகியவை முக்கியமானதாகிறது.",
    "Career, status, public image and responsibility become emotionally important.": "தொழில், அந்தஸ்து, பொது உருவம் மற்றும் பொறுப்பு ஆகியவை உணர்ச்சி ரீதியாக முக்கியமானதாகிறது.",
    "Income, friends, networking, community and ambitions become important.": "வருமானம், நண்பர்கள், நெட்வொர்க்கிங், சமூகம் மற்றும் லட்சியங்கள் முக்கியம்.",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "ஓய்வு, தனிமை, ஆன்மீகம், வெளிநாட்டு தொடர்பு மற்றும் உள் சிகிச்சை ஆகியவை முக்கியமானதாகிறது.",
    "Identity development and self-expression are central.": "அடையாள வளர்ச்சி மற்றும் சுய வெளிப்பாடு ஆகியவை மையமாக உள்ளன.",
    "Values, money and self-worth become central.": "மதிப்புகள், பணம் மற்றும் சுய மதிப்பு ஆகியவை மையமாகின்றன.",
    "Communication, learning and skills become central.": "தொடர்பு, கற்றல் மற்றும் திறன் ஆகியவை மையமாகின்றன.",
    "Home, roots and emotional foundation become central.": "வீடு, வேர்கள் மற்றும் உணர்ச்சி அடித்தளம் ஆகியவை மையமாகின்றன.",
    "Creativity, love and self-expression become central.": "படைப்பாற்றல், அன்பு மற்றும் சுய வெளிப்பாடு ஆகியவை மையமாகின்றன.",
    "Work, discipline and health routines become central.": "வேலை, ஒழுக்கம் மற்றும் சுகாதார நடைமுறைகள் மையமாகின்றன.",
    "Partnerships and relationship identity become central.": "கூட்டாண்மை மற்றும் உறவு அடையாளம் மையமாகிறது.",
    "Transformation, deep healing and shared resources become central.": "மாற்றம், ஆழ்ந்த சிகிச்சைமுறை மற்றும் பகிரப்பட்ட வளங்கள் ஆகியவை மையமாகின்றன.",
    "Wisdom, travel, belief and higher learning become central.": "ஞானம், பயணம், நம்பிக்கை மற்றும் உயர் கல்வி ஆகியவை மையமாகின்றன.",
    "Career, authority and public role become central.": "தொழில், அதிகாரம் மற்றும் பொது பங்கு ஆகியவை மையமாகின்றன.",
    "Community, income, goals and networks become central.": "சமூகம், வருமானம், இலக்குகள் மற்றும் நெட்வொர்க்குகள் ஆகியவை மையமாகின்றன.",
    "Spirituality, closure, retreat and inner development become central.": "ஆன்மீகம், மூடல், பின்வாங்கல் மற்றும் உள் வளர்ச்சி ஆகியவை மையமாகின்றன.",
    "This house becomes emotionally important.": "இந்த வீடு உணர்வு ரீதியாக முக்கியத்துவம் பெறுகிறது.",
    "This house becomes central for identity development.": "அடையாள வளர்ச்சிக்கு இந்த வீடு மையமாகிறது.",
    "Thinking, communication, learning and decisions are developing through this house.": "இந்த வீட்டின் மூலம் சிந்தனை, தொடர்பு, கற்றல் மற்றும் முடிவுகள் உருவாகின்றன.",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "இந்த வீட்டின் மூலம் அன்பு, ஆறுதல், மதிப்புகள், அழகு மற்றும் பண விருப்பங்கள் உருவாகின்றன.",
    "Action style, courage, ambition and drive are developing through this house.": "இந்த வீட்டின் மூலம் ஆக்ஷன் ஸ்டைல், தைரியம், லட்சியம் மற்றும் உந்துதல் ஆகியவை உருவாகின்றன.",
    "Growth, faith, learning and expansion themes develop through this house.": "இந்த வீட்டின் மூலம் வளர்ச்சி, நம்பிக்கை, கற்றல் மற்றும் விரிவாக்க கருப்பொருள்கள் உருவாகின்றன.",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "இந்த வீட்டின் மூலம் முதிர்ச்சி, பொறுப்பு, ஒழுக்கம் மற்றும் நீண்ட கால அமைப்பு உருவாகிறது.",
    "This progressed planet shows an inner life phase through this house.": "இந்த முன்னேற்றமடைந்த கிரகம் இந்த வீட்டின் மூலம் ஒரு உள் வாழ்க்கை கட்டத்தைக் காட்டுகிறது.",
    "New Moon Phase": "அமாவாசை கட்டம்",
    "New beginning, identity reset and fresh internal cycle.": "புதிய ஆரம்பம், அடையாள மீட்டமைப்பு மற்றும் புதிய உள் சுழற்சி.",
    "Crescent Phase": "பிறை கட்டம்",
    "Growth, effort, learning and building confidence.": "வளர்ச்சி, முயற்சி, கற்றல் மற்றும் நம்பிக்கையை வளர்ப்பது.",
    "First Quarter Phase": "முதல் காலாண்டு கட்டம்",
    "Action, decision-making, pressure and development.": "நடவடிக்கை, முடிவெடுத்தல், அழுத்தம் மற்றும் வளர்ச்சி.",
    "Gibbous Phase": "கிப்பஸ் கட்டம்",
    "Refinement, improvement, preparation and skill-building.": "சுத்திகரிப்பு, மேம்பாடு, தயாரிப்பு மற்றும் திறன்-கட்டிடம்.",
    "Full Moon Phase": "முழு நிலவு கட்டம்",
    "Visibility, relationship awareness, emotional clarity and results.": "பார்வை, உறவு விழிப்புணர்வு, உணர்ச்சி தெளிவு மற்றும் முடிவுகள்.",
    "Disseminating Phase": "பரப்புதல் கட்டம்",
    "Sharing, teaching, communication and distributing experience.": "பகிர்தல், கற்பித்தல், தொடர்பு மற்றும் அனுபவத்தை விநியோகித்தல்.",
    "Last Quarter Phase": "கடைசி காலாண்டு கட்டம்",
    "Reorientation, correction, release and mature decision-making.": "மறுசீரமைப்பு, திருத்தம், வெளியீடு மற்றும் முதிர்ந்த முடிவெடுத்தல்.",
    "Balsamic Phase": "பால்சாமிக் கட்டம்",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "மூடல், ஆன்மீக பிரதிபலிப்பு, ஓய்வு மற்றும் ஒரு புதிய சுழற்சிக்கான தயாரிப்பு.",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "ஒரு பெரிய உணர்ச்சி மற்றும் அடையாள கட்டம் தொடங்குகிறது. ஒரு நபர் ஒரு புதிய அத்தியாயத்திற்கு தயாராக இருப்பதாக உணரலாம்.",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "உணர்ச்சி ரீசெட் காலம். குடும்பம், ஆறுதல், உள் அமைதி மற்றும் உணர்ச்சித் தேவைகள் முக்கியமானதாகிறது.",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "அன்பு, உறவு, ஆறுதல், அழகு மற்றும் உணர்ச்சிப் பிணைப்பு ஆகியவை முக்கியமானதாகிறது.",
    "Emotional needs and relationship expectations may need adjustment.": "உணர்ச்சி தேவைகள் மற்றும் உறவு எதிர்பார்ப்புகள் சரிசெய்தல் தேவைப்படலாம்.",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "ஆற்றல், ஆர்வம், பொறுமையின்மை மற்றும் செயல் அதிகரிக்கும். உணர்ச்சி எதிர்வினைகள் விரைவாக இருக்கலாம்.",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "உணர்ச்சி அமைதியின்மை, கோபம், மோதல் அல்லது அவசர நடவடிக்கை அதிகரிக்கும்.",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "ஒரு தீவிர உணர்ச்சி நிலை. பொறுப்பு, முதிர்ச்சி, குடும்ப அழுத்தம் அல்லது உள் ஒழுக்கம் அதிகரிக்கலாம்.",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "உணர்ச்சி கனம் அல்லது பொறுப்பு உணரப்படலாம். பொறுமையும் முதிர்ச்சியும் தேவை.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "ஆதரவு உணர்வு வளர்ச்சி, நம்பிக்கை, பயணம், கற்றல் மற்றும் ஆசீர்வாதம் அதிகரிக்கும்.",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "வளர்ச்சி சார்ந்த உணர்ச்சி நிலை. கற்றல், விரிவாக்கம், ஆதரவு மற்றும் நேர்மறையான முடிவுகளுக்கு நல்லது.",
    "Identity, love, beauty, money values and creative expression become highlighted.": "அடையாளம், அன்பு, அழகு, பண மதிப்புகள் மற்றும் ஆக்கப்பூர்வமான வெளிப்பாடு ஆகியவை முன்னிலைப்படுத்தப்படுகின்றன.",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "தன்னம்பிக்கை, தைரியம், லட்சியம் மற்றும் செயல் அதிகரிக்கும். புதிய செயலில் கட்டத்தைத் தொடங்குவது நல்லது.",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "ஒரு முதிர்வு சோதனை. பொறுப்பு, தாமதம், அழுத்தம் அல்லது தொழில் மறுசீரமைப்பு ஏற்படலாம்.",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "வளர்ச்சி, நம்பிக்கை, ஞானம், அங்கீகாரம் மற்றும் வாய்ப்பு அதிகரிக்கும்.",
    "Mental clarity, communication, study, writing and business decisions become important.": "மனத் தெளிவு, தொடர்பு, படிப்பு, எழுத்து மற்றும் வணிக முடிவுகள் முக்கியமானதாகிறது.",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "ஒரு புதிய மன சுழற்சி தொடங்குகிறது. கற்றல், தொடர்பு, எழுதுதல் மற்றும் திறன் மேம்பாட்டிற்கு நல்லது.",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "அன்பு, அழகு, ஆறுதல், சமூக வாழ்க்கை மற்றும் மதிப்புகள் ஆகியவை அடையாளத்துடன் வலுவாக இணைக்கப்படுகின்றன.",
    "Action, confidence, ambition and personal drive become stronger.": "செயல், நம்பிக்கை, லட்சியம் மற்றும் தனிப்பட்ட உந்துதல் ஆகியவை வலுவடைகின்றன.",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "முன்னேற்றமடைந்த புதன் கற்றல், தொடர்பு, வணிகம், எழுதுதல், சந்தைப்படுத்துதல், குறியீட்டு முறை அல்லது பகுப்பாய்வுப் பணிகளை ஆதரிக்கிறது.",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "முன்னேற்றமடைந்த செவ்வாய் செயல், தைரியம், போட்டி, தொழில்நுட்ப வேலை மற்றும் சுறுசுறுப்பான தொழில் முடிவுகளை ஆதரிக்கிறது.",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "முன்னேறிய வீனஸ் நிதி மதிப்புகள், ஆறுதல், ஆதாயங்கள், ஆடம்பரம், கலை அல்லது உறவு சார்ந்த வருமான கருப்பொருள்களை ஆதரிக்கிறது.",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "முன்னேறிய வியாழன் வளர்ச்சி சார்ந்த நிதிச் சிந்தனை மற்றும் வளங்களின் விரிவாக்கத்தைக் காட்ட முடியும்.",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "தொழில் நிலை முன்னேற்றமடைந்த சூரியன், சந்திரன், புதன், செவ்வாய் மற்றும் ஜன்ம சூரியன், சனி மற்றும் நடுவானில் இருந்து தீர்மானிக்கப்பட வேண்டும்.",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "காதல் கட்டம் முன்னேற்றமடைந்த சந்திரன், சுக்கிரன், செவ்வாய் மற்றும் ஜன்ம சந்திரன், சுக்கிரன், செவ்வாய் மற்றும் 7 ஆம் வீட்டிற்கு அம்சங்களில் இருந்து தீர்மானிக்கப்பட வேண்டும்.",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "முன்னேற்றமடைந்த சந்திரன், சுக்கிரன், வியாழன் மற்றும் ஜனன 2, 8 மற்றும் 11 வது வீட்டு இணைப்புகளிலிருந்து பண கட்டத்தை தீர்மானிக்க வேண்டும்.",
    "Western Astrology - Kundlistar": "மேற்கத்திய ஜோதிடம் - Kundlistar",
    "No chart data available for preview": "மாதிரிக்காட்சிக்கு விளக்கப்படத் தரவு எதுவும் இல்லை",
    "Failed to load chart": "விளக்கப்படத்தை ஏற்றுவதில் தோல்வி",
    "Chart not found": "விளக்கப்படம் கிடைக்கவில்லை",
    "Western Astrology Module | Kundlistar": "மேற்கத்திய ஜோதிட தொகுதி | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "Kundlistar க்குள் மேற்கத்திய ஜோதிடத்தை நேட்டல் சார்ட் பொசிஷன்கள், பிளாசிடஸ் ஹவுஸ் கஸ்ப்ஸ், வெளிப்புற கிரகங்கள் மற்றும் பிரீமியம் டிரான்சிட்கள், சோலார் ரிட்டர்ன் மற்றும் சினாஸ்ட்ரி அம்சங்களுடன் ஆராயுங்கள்.",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "மேற்கத்திய ஜோதிடம், நேட்டல் சார்ட், டிரான்சிட்ஸ், சோலார் ரிட்டர்ன், சினாஸ்ட்ரி, Kundlistar",
    "New section": "புதிய பிரிவு",
    "Premium active": "பிரீமியம் செயலில் உள்ளது",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "வீட்டு அமைப்பு",
    "Placidus cusps": "பிளாசிடஸ் கஸ்ப்ஸ்",
    "Part of Fortune": "பார்ச்சூன் பகுதி",
    "Natal Western Aspects": "நடால் மேற்கத்திய அம்சங்கள்",
    "No major Western aspects found within the configured orbs.": "கட்டமைக்கப்பட்ட உருண்டைகளுக்குள் பெரிய மேற்கத்திய அம்சங்கள் எதுவும் காணப்படவில்லை.",
    "Western natal astrology wheel": "மேற்கத்திய ஜாதக ஜோதிட சக்கரம்",
    "Western Transits": "மேற்கு போக்குவரத்து",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "ஏற்றப்பட்ட விளக்கப்பட பிறந்த இடத்தைப் பயன்படுத்தி நடப்பு டிரான்சிட்-டு-நேட்டல் கணக்கீடுகள்.",
    "Natal points available": "நடால் புள்ளிகள் கிடைக்கும்",
    "Transit planets loaded": "போக்குவரத்து கிரகங்கள் ஏற்றப்பட்டன",
    "Loading current transit positions...": "தற்போதைய போக்குவரத்து நிலைகளை ஏற்றுகிறது...",
    "Aspect method": "அம்ச முறை",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "மேற்கத்திய உருண்டைகளுடன் இணைப்பு, செக்ஸ்டைல், சதுரம், முக்கோணம் மற்றும் எதிர்ப்பு",
    "Primary focus": "முதன்மை கவனம்",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "பிறந்த சூரியன், சந்திரன், ஏறுவரிசை, வீனஸ், செவ்வாய், வியாழன், சனி மற்றும் வெளி கிரகங்களுக்கு போக்குவரத்து தொடர்புகள்",
    "Natal inner wheel": "நடால் உள் சக்கரம்",
    "Transit outer wheel": "போக்குவரத்து வெளிப்புற சக்கரம்",
    "Current Transit Positions": "தற்போதைய போக்குவரத்து நிலைகள்",
    "Transit positions are not available.": "போக்குவரத்து நிலைகள் கிடைக்கவில்லை.",
    "Current Transit Aspects to Natal Chart": "நடால் விளக்கப்படத்திற்கான தற்போதைய போக்குவரத்து அம்சங்கள்",
    "Loading transit aspects...": "போக்குவரத்து அம்சங்களை ஏற்றுகிறது...",
    "No major transit aspects found within the configured orbs.": "கட்டமைக்கப்பட்ட உருண்டைகளுக்குள் பெரிய போக்குவரத்து அம்சங்கள் எதுவும் இல்லை.",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "நேட்டல் சன் இலிருந்து வருடாந்திர மேற்கத்திய ரிட்டர்ன் குறிப்பு, நேட்டல் அம்ச சூழலை ஆதரிக்கிறது.",
    "Solar return date": "சூரிய ஒளி திரும்பும் தேதி",
    "Calculation time": "கணக்கீடு நேரம்",
    "Birth date not available": "பிறந்த தேதி கிடைக்கவில்லை",
    "Natal Sun": "நடால் சூரியன்",
    "Natal Sun house": "நடால் சன் வீடு",
    "Return planets loaded": "திரும்ப கிரகங்கள் ஏற்றப்பட்டன",
    "Loading solar return chart...": "சோலார் ரிட்டர்ன் சார்ட்டை ஏற்றுகிறது...",
    "Annual focus": "வருடாந்திர கவனம்",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "சூரிய கருப்பொருள்கள் பிறந்த சூரியன், திரும்பும் அசென்டென்ட் மற்றும் வருடாந்திர ரிட்டர்ன் சார்ட் ஆகியவற்றிலிருந்து படிக்கப்படுகின்றன.",
    "Solar Return Planet Positions": "சோலார் ரிட்டர்ன் பிளானட் நிலைகள்",
    "Loading solar return planets...": "சூரிய திரும்பும் கிரகங்களை ஏற்றுகிறது...",
    "Solar return positions are not available.": "சோலார் ரிட்டர்ன் நிலைகள் கிடைக்கவில்லை.",
    "Solar Return House Cusps": "சோலார் ரிட்டர்ன் ஹவுஸ் கஸ்ப்ஸ்",
    "Loading solar return cusps...": "சோலார் ரிட்டர்ன் கப்ஸ்களை ஏற்றுகிறது...",
    "Solar return house cusps are not available.": "சோலார் ரிட்டர்ன் ஹவுஸ் கஸ்ப்கள் கிடைக்கவில்லை.",
    "Solar Return Aspects to Natal Chart": "நேட்டல் விளக்கப்படத்திற்கு சூரிய திரும்பும் அம்சங்கள்",
    "Loading solar return aspects...": "சோலார் ரிட்டர்ன் அம்சங்களை ஏற்றுகிறது...",
    "No major solar return aspects found within the configured orbs.": "கட்டமைக்கப்பட்ட உருண்டைகளுக்குள் பெரிய சூரிய திரும்பும் அம்சங்கள் எதுவும் இல்லை.",
    "Natal Sun Aspects for Solar Return Focus": "சோலார் ரிட்டர்ன் ஃபோகஸிற்கான நேட்டல் சன் அம்சங்கள்",
    "No major natal Sun aspects found within the configured orbs.": "கட்டமைக்கப்பட்ட உருண்டைகளுக்குள் முக்கிய நேட்டல் சன் அம்சங்கள் எதுவும் காணப்படவில்லை.",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "கிரகத்திலிருந்து கிரகத்தின் அம்சங்கள், கோணத் தொடர்புகள் மற்றும் வீட்டின் மேலடுக்குகளைப் பயன்படுத்தி உறவு மேலடுக்கு கட்டமைப்பு.",
    "Loaded first chart": "முதல் விளக்கப்படம் ஏற்றப்பட்டது",
    "Second chart": "இரண்டாவது விளக்கப்படம்",
    "Select or load partner chart to calculate full synastry overlay": "முழு ஒத்திசைவு மேலோட்டத்தைக் கணக்கிட கூட்டாளர் விளக்கப்படத்தைத் தேர்ந்தெடுக்கவும் அல்லது ஏற்றவும்",
    "Major inter-chart aspects with tight orb priority": "இறுக்கமான உருண்டை முன்னுரிமையுடன் முக்கிய இடைப்பட்ட அட்டவணை அம்சங்கள்",
    "House overlay method": "வீட்டின் மேலடுக்கு முறை",
    "Partner planets are placed into the first chart houses after second chart is selected": "இரண்டாவது விளக்கப்படம் தேர்ந்தெடுக்கப்பட்ட பிறகு கூட்டாளர் கிரகங்கள் முதல் விளக்கப்பட வீடுகளில் வைக்கப்படும்",
    "Relationship Pattern Aspects from Loaded Chart": "ஏற்றப்பட்ட விளக்கப்படத்திலிருந்து உறவு முறை அம்சங்கள்",
    "No major relationship-focused natal aspects found within the configured orbs.": "கட்டமைக்கப்பட்ட உருண்டைகளுக்குள் எந்த முக்கிய உறவை மையமாகக் கொண்ட நேட்டல் அம்சங்கள் காணப்படவில்லை.",
    "Understand your current inner life phase through Western Secondary Progressions.": "மேற்கத்திய இரண்டாம் நிலை முன்னேற்றங்கள் மூலம் உங்கள் தற்போதைய உள் வாழ்க்கைக் கட்டத்தைப் புரிந்து கொள்ளுங்கள்.",
    "Secondary Progression": "இரண்டாம் நிலை முன்னேற்றம்",
    "1 day after birth = 1 year of life": "பிறந்த 1 நாள் = வாழ்க்கையின் 1 வருடம்",
    "Current age used": "தற்போதைய வயது பயன்படுத்தப்படுகிறது",
    "Progressed date": "முன்னேறிய தேதி",
    "Progressed Moon": "முன்னேற்றமடைந்த சந்திரன்",
    "Loading progressed Moon...": "சந்திரனை ஏற்றுகிறது...",
    "Progressed Moon phase": "முன்னேற்றமடைந்த சந்திரன் கட்டம்",
    "Loading Moon phase...": "சந்திர கட்டத்தை ஏற்றுகிறது...",
    "Current Life Phase": "தற்போதைய வாழ்க்கை கட்டம்",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "இரண்டாம் நிலை முன்னேற்றங்கள் வாழ்க்கையின் உள் கட்டம், உணர்ச்சி முதிர்ச்சி, அடையாள வளர்ச்சி மற்றும் முன்னுரிமைகளை மாற்றுவதைக் காட்டுகின்றன.",
    "Progressed Career Phase": "முன்னேறிய தொழில் நிலை",
    "Progressed Love Phase": "முன்னேறிய காதல் கட்டம்",
    "Progressed Money Phase": "முன்னேறிய பணம் கட்டம்",
    "Loading progressed planets...": "முன்னேற்றமடைந்த கிரகங்களை ஏற்றுகிறது...",
    "Progressed planets are not available.": "முன்னேறிய கிரகங்கள் கிடைக்கவில்லை.",
    "Loading progressed aspects...": "முன்னேறிய அம்சங்களை ஏற்றுகிறது...",
    "No tight progressed-to-natal aspects found right now.": "இறுக்கமான முன்னேற்றம்-பிறப்பு அம்சங்கள் எதுவும் இப்போது கண்டறியப்படவில்லை.",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "இந்த கட்டம் முன்னேற்றமடைந்த கிரகங்கள், முன்னேற்றமடைந்த சந்திரன் கட்டம் மற்றும் இறுக்கமான முன்னேற்றத்திலிருந்து பிறப்பு அம்சங்களிலிருந்து தீர்மானிக்கப்பட வேண்டும்.",
    "Vastu Analysis - Kundlistar": "வாஸ்து பகுப்பாய்வு - Kundlistar",
    "Failed to load selected chart.": "தேர்ந்தெடுக்கப்பட்ட விளக்கப்படத்தை ஏற்றுவதில் தோல்வி.",
    "Facing Direction": "எதிர்கொள்ளும் திசை",
    "Entrance Direction": "நுழைவு திசை",
    "Kitchen Direction": "சமையலறை திசை",
    "Master Bedroom": "மாஸ்டர் பெட்ரூம்",
    "Children Bedroom": "குழந்தைகள் படுக்கையறை",
    "Toilet Direction": "கழிப்பறை திசை",
    "Pooja Direction": "பூஜை இயக்கம்",
    "Water Tank": "தண்ணீர் தொட்டி",
    "Underground Water": "நிலத்தடி நீர்",
    "Heavy Storage": "அதிக சேமிப்பு",
    "Living Room": "வாழ்க்கை அறை",
    "Study Room": "படிப்பு அறை",
    "Vastu report generation failed.": "வாஸ்து அறிக்கை உருவாக்கம் தோல்வியடைந்தது.",
    "Please generate the Vastu report before downloading.": "பதிவிறக்கும் முன் வாஸ்து அறிக்கையை உருவாக்கவும்.",
    "Failed to download Vastu report.": "வாஸ்து அறிக்கையைப் பதிவிறக்க முடியவில்லை.",
    "Premium Feature": "பிரீமியம் அம்சம்",
    "Selected Chart": "தேர்ந்தெடுக்கப்பட்ட விளக்கப்படம்",
    "Basic + KP + BNN from chart": "விளக்கப்படத்திலிருந்து அடிப்படை + KP + BNN",
    "Basic shown, KP + BNN locked": "அடிப்படை காட்டப்பட்டுள்ளது, KP + BNN பூட்டப்பட்டது",
    "Property Type": "சொத்து வகை",
    "Center Area": "மையப் பகுதி",
    "Generate Vastu Report": "வாஸ்து அறிக்கையை உருவாக்கவும்",
    "Basic Vastu Analysis": "அடிப்படை வாஸ்து பகுப்பாய்வு",
    "KP Vastu Analysis": "கேபி வாஸ்து பகுப்பாய்வு",
    "BNN Vastu Analysis": "பிஎன்என் வாஸ்து பகுப்பாய்வு",
    "North East": "வடக்கு கிழக்கு",
    "South East": "தென் கிழக்கு",
    "South West": "தென் மேற்கு",
    "North West": "வட மேற்கு",
    "Red Coral": "சிவப்பு பவளம்",
    "Yellow Sapphire": "மஞ்சள் நீலக்கல்",
    "Blue Sapphire": "நீல சபையர்",
    "Cat's Eye": "பூனையின் கண்",
    "Additional Option": "கூடுதல் விருப்பம்",
    "Lagna rule supports this gemstone option.": "லக்னா விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Moon sign rule supports this gemstone option.": "சந்திரன் அடையாளம் விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Birth date rule supports this gemstone option.": "பிறந்த தேதி விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Birth weekday rule supports this gemstone option.": "பிறந்த வார நாள் விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Current dasha rule supports this gemstone option.": "தற்போதைய டாஷா விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Age-band rule supports this gemstone option.": "வயது வரம்பு விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Selected goal supports this gemstone option.": "தேர்ந்தெடுக்கப்பட்ட இலக்கு இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Profession rule supports this gemstone option.": "தொழில் விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Name-initial rule supports this gemstone option.": "பெயர்-ஆரம்ப விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Moolank rule supports this gemstone option.": "மூலங்க் விதி இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Chart condition check was considered for this option.": "இந்த விருப்பத்திற்கு விளக்கப்பட நிலை சரிபார்ப்பு பரிசீலிக்கப்பட்டது.",
    "Rule-based chart match supports this gemstone option.": "விதி அடிப்படையிலான விளக்கப்படப் பொருத்தம் இந்த ரத்தினக் கல் விருப்பத்தை ஆதரிக்கிறது.",
    "Expert kundli review is recommended before wearing this gemstone.": "இந்த ரத்தினத்தை அணிவதற்கு முன் நிபுணர் குண்ட்லி மதிப்பாய்வு பரிந்துரைக்கப்படுகிறது.",
    "Ring finger": "மோதிர விரல்",
    "Little finger": "சிறிய விரல்",
    "Index finger": "ஆள்காட்டி விரல்",
    "Middle finger": "நடு விரல்",
    "Why recommended": "ஏன் பரிந்துரைக்கப்படுகிறது",
    "Approx weight": "தோராயமான எடை",
    "Could not load chart.": "விளக்கப்படத்தை ஏற்ற முடியவில்லை.",
    "Gemstone Recommendations | Kundlistar": "ரத்தின பரிந்துரைகள் | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar இன் விதி அடிப்படையிலான குண்ட்லி பகுப்பாய்வு இயந்திரத்திலிருந்து வேத ரத்தினக் கற்கள் பரிந்துரைகளை ஆராயுங்கள்.",
    "noindex,nofollow": "noindex,nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "ரத்தினம் பரிந்துரை, வேத ரத்தினக் கற்கள், குண்டலி ரத்தினம், Kundlistar",
    "Gemstone Recommendations": "ரத்தின பரிந்துரைகள்",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "லக்னம், சந்திர ராசி, தசா, DOB, தொழில் மற்றும் இலக்குகளின் அடிப்படையில் வேத ரத்தின வழிகாட்டுதலுக்கான தனி Kundlistar தொகுதி.",
    "Personalized Gemstone Recommendations are available for Premium users.": "பிரீமியம் பயனர்களுக்கு தனிப்பயனாக்கப்பட்ட ஜெம்ஸ்டோன் பரிந்துரைகள் கிடைக்கின்றன.",
    "Upgrade to Premium": "பிரீமியத்திற்கு மேம்படுத்தவும்",
    "Login to Upgrade": "மேம்படுத்த உள்நுழைக",
    "Select Goal": "இலக்கைத் தேர்ந்தெடுக்கவும்",
    "Business, government job, teacher...": "தொழில், அரசு வேலை, ஆசிரியர்...",
    "Weight kg": "எடை கிலோ",
    "वजन kg": "வஜன் கிலோ",
    "Optional ratti estimate": "விருப்ப ரட்டி மதிப்பீடு",
    "Click Calculate to apply these values.": "இந்த மதிப்புகளைப் பயன்படுத்த, கணக்கிடு என்பதைக் கிளிக் செய்யவும்.",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi ?",
    "Nadi Analysis": "நாடி பகுப்பாய்வு",
    "KP Analysis": "கேபி பகுப்பாய்வு",
    "Vedic Analysis": "வேத பகுப்பாய்வு",
    "BNN Analysis": "பிஎன்என் பகுப்பாய்வு",
    "Jaimini Analysis": "ஜைமினி அலசல்",
    "Western Astrology": "மேற்கத்திய ஜோதிடம்",
    "Panch Pakshi": "பஞ்ச பக்ஷி",
    "Tithi Pravesh": "திதி பிரவேஷ்",
    "Lal Kitab": "லால் கிதாப்",
    "Astro Logo": "ஆஸ்ட்ரோ லோகோ",
    "Download failed": "பதிவிறக்கம் தோல்வியடைந்தது",
    "Could not download PDF report.": "PDF அறிக்கையைப் பதிவிறக்க முடியவில்லை.",
    "Please login to download PDF reports.": "PDF அறிக்கைகளைப் பதிவிறக்க உள்நுழையவும்.",
    "Failed to generate personalised report": "தனிப்பயனாக்கப்பட்ட அறிக்கையை உருவாக்க முடியவில்லை",
    "Could not download personalised report.": "தனிப்பயனாக்கப்பட்ட அறிக்கையைப் பதிவிறக்க முடியவில்லை.",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--kundlistar-navbar-height, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(--kundlistar-navbar-height, 160px))",
    "width 0.2s ease": "அகலம் 0.2வி எளிதாக",
    "Collapse sidebar": "பக்கப்பட்டியைச் சுருக்கவும்",
    "Expand sidebar": "பக்கப்பட்டியை விரிவாக்கு",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-root",
    "Download PDF Report": "PDF அறிக்கையைப் பதிவிறக்கவும்",
    "Login to download": "பதிவிறக்கம் செய்ய உள்நுழைக",
    "PDF Report": "PDF அறிக்கை",
    "Download Personal Report": "தனிப்பட்ட அறிக்கையைப் பதிவிறக்கவும்",
    "Buy Premium to download": "பதிவிறக்கம் செய்ய Premium வாங்கவும்",
    "Login to buy Premium": "பிரீமியம் வாங்க உள்நுழைக",
    "Buy Premium": "பிரீமியம் வாங்கவும்",
    "& .MuiTab-root": "& .MuiTab-root",
    "& .Mui-selected": "& .முய்-தேர்ந்தெடுக்கப்பட்டது",
    "Unable to load Client Management data.": "கிளையண்ட் மேனேஜ்மென்ட் தரவை ஏற்ற முடியவில்லை.",
    "Unable to download PDF.": "PDF ஐப் பதிவிறக்க முடியவில்லை.",
    "Free client limit reached": "இலவச கிளையன்ட் வரம்பை அடைந்துவிட்டது",
    "Welcome": "வரவேற்கிறோம்",
    "Hello": "வணக்கம்",
    "Your saved charts are shown below.": "நீங்கள் சேமித்த விளக்கப்படங்கள் கீழே காட்டப்பட்டுள்ளன.",
    "All Features": "அனைத்து அம்சங்கள்",
    "New Chart": "புதிய விளக்கப்படம்",
    "Vedic Chart": "வேத விளக்கப்படம்",
    "Chakra": "சக்ரா",
    "Daily Panchang": "தினசரி பஞ்சாங்கம்",
    "Choghadiya": "சோகடியா",
    "Daily Horoscope": "தினசரி ஜாதகம்",
    "Gochar Alerts": "Gochar எச்சரிக்கைகள்",
    "Matching": "பொருத்தம்",
    "Ruling Planets": "ஆளும் கிரகங்கள்",
    "Horary Chart": "ஹாரரி விளக்கப்படம்",
    "Astro-Vastu": "ஆஸ்ட்ரோ-வாஸ்து",
    "Vedic Numerology": "வேத எண் கணிதம்",
    "My Charts": "எனது விளக்கப்படங்கள்",
    "Search by Name": "பெயர் மூலம் தேடவும்",
    "Type": "வகை",
    "All": "அனைத்து",
    "Individual": "தனிநபர்",
    "Horary": "ஹாரரி",
    "Clear": "தெளிவு",
    "Name": "பெயர்",
    "DOB": "DOB",
    "Place": "இடம்",
    "Gender": "பாலினம்",
    "Created": "உருவாக்கப்பட்டது",
    "Actions": "செயல்கள்",
    "Male": "ஆண்",
    "Female": "பெண்",
    "No matching charts found": "பொருந்தும் விளக்கப்படங்கள் எதுவும் இல்லை",
    "Create First Chart": "முதல் விளக்கப்படத்தை உருவாக்கவும்",
    "View Chart": "விளக்கப்படத்தைப் பார்க்கவும்",
    "Copy Share Link": "பகிர்வு இணைப்பை நகலெடுக்கவும்",
    "Use premium credit: Download PDF Report": "பிரீமியம் கிரெடிட்டைப் பயன்படுத்தவும்: PDF அறிக்கையைப் பதிவிறக்கவும்",
    "Download Personalised Report": "தனிப்பயனாக்கப்பட்ட அறிக்கையைப் பதிவிறக்கவும்",
    "Premium: Download Personalised Report": "பிரீமியம்: தனிப்பயனாக்கப்பட்ட அறிக்கையைப் பதிவிறக்கவும்",
    "Hide Chart": "விளக்கப்படத்தை மறை",
    "Personalised": "தனிப்பயனாக்கப்பட்டது",
    "Generating your Personalised Report": "உங்கள் தனிப்பயனாக்கப்பட்ட அறிக்கையை உருவாக்குதல்",
    "Please do not leave this page till the report is generated. This can take a little while.": "அறிக்கை உருவாக்கப்படும் வரை இந்தப் பக்கத்தை விட்டு வெளியேற வேண்டாம். இதற்கு சிறிது நேரம் ஆகலாம்.",
    "Please don't leave this page till the report is generated. This can take a little while.": "அறிக்கை உருவாக்கப்படும் வரை இந்தப் பக்கத்தை விட்டு வெளியேற வேண்டாம். இதற்கு சிறிது நேரம் ஆகலாம்.",
    "Update": "புதுப்பிக்கவும்",
    "Complete your billing address. Required for generating invoice.": "உங்கள் பில்லிங் முகவரியை நிரப்பவும். விலைப்பட்டியல் உருவாக்குவதற்குத் தேவை.",
    "Report this report": "இந்த அறிக்கையை தெரிவிக்கவும்",
    "Reason": "காரணம்",
    "Optional comment": "விருப்ப கருத்து",
    "Submit": "சமர்ப்பிக்கவும்",
    "Incorrect info": "தவறான தகவல்",
    "Offensive": "தாக்குதல்",
    "Harmful": "தீங்கு விளைவிக்கும்",
    "This report has been sent for review.": "இந்த அறிக்கை ஆய்வுக்கு அனுப்பப்பட்டுள்ளது.",
    "Failed to submit report feedback": "அறிக்கையின் கருத்தைச் சமர்ப்பிக்க முடியவில்லை",
    "Failed to download PDF": "PDF ஐப் பதிவிறக்க முடியவில்லை",
    "Failed to download personalised report": "தனிப்பயனாக்கப்பட்ட அறிக்கையைப் பதிவிறக்குவதில் தோல்வி",
    "Failed to load charts": "விளக்கப்படங்களை ஏற்றுவதில் தோல்வி",
    "Failed to hide chart": "விளக்கப்படத்தை மறைக்க முடியவில்லை",
    "Failed to delete chart": "விளக்கப்படத்தை நீக்க முடியவில்லை",
    "Share link copied to clipboard!": "பகிர்வு இணைப்பு கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது!",
    "Delete Chart": "விளக்கப்படத்தை நீக்கு",
    "Delete chart": "விளக்கப்படத்தை நீக்கு",
    "Error": "பிழை",
    "OK": "சரி",
    "Thanks": "நன்றி",
    "Report failed": "அறிக்கை தோல்வியடைந்தது",
    "Could not submit report feedback.": "அறிக்கையின் கருத்தைச் சமர்ப்பிக்க முடியவில்லை.",
    "Personalised report ready": "தனிப்பயனாக்கப்பட்ட அறிக்கை தயார்",
    "Personalised report failed": "தனிப்பயனாக்கப்பட்ட அறிக்கை தோல்வியடைந்தது",
    "Could not generate personalised report.": "தனிப்பயனாக்கப்பட்ட அறிக்கையை உருவாக்க முடியவில்லை.",
    "Could not generate personalised PDF report.": "தனிப்பயனாக்கப்பட்ட PDF அறிக்கையை உருவாக்க முடியவில்லை.",
    "Monthly limit reached": "மாதாந்திர வரம்பை அடைந்துவிட்டது",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "உங்கள் மாதாந்திர தனிப்பயனாக்கப்பட்ட அறிக்கை வரம்பை அடைந்துவிட்டது. துணை நிரலுக்கு குழுசேரவும்: 20 அறிக்கைகளுக்கு மாதம் ₹299 அல்லது 40 அறிக்கைகளுக்கு ₹499/மாதம்.",
    "Buy Add-on": "செருகு நிரலை வாங்கவும்",
    "Manage": "நிர்வகிக்கவும்",
    "Add-on active: Unlimited reports": "ஆட்-ஆன் செயலில்: வரம்பற்ற அறிக்கைகள்",
    "Add-on active: 40 reports/month": "ஆட்-ஆன் செயலில் உள்ளது: 40 அறிக்கைகள்/மாதம்",
    "Add-on active: 20 reports/month": "ஆட்-ஆன் செயலில்: 20 அறிக்கைகள்/மாதம்",
    "reports remaining this cycle": "இந்த சுழற்சியில் மீதமுள்ள அறிக்கைகள்",
    "Add-on active": "ஆட்-ஆன் செயலில் உள்ளது",
    "Personalised reports remaining this month": "இந்த மாதம் மீதமுள்ள தனிப்பயனாக்கப்பட்ட அறிக்கைகள்",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "பிரீமியத்தில் 2/மாதம் அடங்கும். துணை நிரல்கள்: மாதம் 20 அறிக்கைகளுக்கு ₹299/மாதம் அல்லது 40 அறிக்கைகளுக்கு மாதம் ₹499.",
    "AI Disclaimer": "AI மறுப்பு",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "AI மற்றும் ஜோதிட விளக்கங்களைப் பயன்படுத்தி இந்த அறிக்கை உருவாக்கப்பட்டுள்ளது. இது தகவல் மற்றும் பொழுதுபோக்கு நோக்கங்களுக்காக மட்டுமே. இது மருத்துவ, சட்ட அல்லது நிதி ஆலோசனையாக கருதப்படக்கூடாது.",
    "A copy of this report has also been sent to your registered email address as a PDF.": "இந்த அறிக்கையின் நகல் உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சல் முகவரிக்கும் PDF ஆக அனுப்பப்பட்டுள்ளது.",
    "Report this AI-generated report?": "இந்த AI-உருவாக்கிய அறிக்கையைப் புகாரளிக்கவா?",
    "charts": "விளக்கப்படங்கள்",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "சுயாதீன குறிப்புகள், தேதி மற்றும் நேர திட்டமிடல். சேமிக்க உள்நுழைவு தேவை; இலவச பயனர்களுக்கு முழு திட்டமிடல் அணுகல் கிடைக்கும்.",
    "Independent notes, date and time planning.": "சுயாதீன குறிப்புகள், தேதி மற்றும் நேர திட்டமிடல்.",
    "Add Plan": "திட்டத்தைச் சேர்க்கவும்",
    "Save Plan": "திட்டத்தை சேமிக்கவும்",
    "Saved Plans": "சேமிக்கப்பட்ட திட்டங்கள்",
    "Planner Entry": "திட்டமிடுபவர் நுழைவு",
    "Plan": "திட்டம்",
    "Saving...": "சேமிக்கிறது...",
    "Refresh": "புதுப்பிக்கவும்",
    "No plans saved yet.": "இதுவரை எந்த திட்டமும் சேமிக்கப்படவில்லை.",
    "Planner layout is available. Login only when you want to save.": "திட்டமிடுபவர் தளவமைப்பு கிடைக்கிறது. நீங்கள் சேமிக்க விரும்பும் போது மட்டும் உள்நுழையவும்.",
    "No matching plans.": "பொருந்தக்கூடிய திட்டங்கள் இல்லை.",
    "Search Plans": "தேடல் திட்டங்கள்",
    "Search title, note, date or status": "தலைப்பு, குறிப்பு, தேதி அல்லது நிலையைத் தேடுங்கள்",
    "Login is required only when you want to save planner entries.": "நீங்கள் திட்டமிடுபவர் உள்ளீடுகளைச் சேமிக்க விரும்பினால் மட்டுமே உள்நுழைவு தேவைப்படுகிறது.",
    "Planner entry saved.": "திட்டமிடுபவர் நுழைவு சேமிக்கப்பட்டது.",
    "Unable to load planner.": "பிளானரை ஏற்ற முடியவில்லை.",
    "Unable to save planner entry.": "திட்டமிடுபவர் உள்ளீட்டைச் சேமிக்க முடியவில்லை.",
    "Could not load planner.": "பிளானரை ஏற்ற முடியவில்லை.",
    "Could not save planner entry.": "திட்டமிடுபவர் உள்ளீட்டைச் சேமிக்க முடியவில்லை.",
    "Login required to save": "சேமிக்க உள்நுழைய வேண்டும்",
    "You can explore Planner now. Login when you want to save entries.": "நீங்கள் இப்போது Planner ஐ ஆராயலாம். உள்ளீடுகளைச் சேமிக்க விரும்பும் போது உள்நுழைக.",
    "Prev": "முந்தைய",
    "Next": "அடுத்து",
    "Page": "பக்கம்",
    "of": "இன்",
    "Child Birth Mahoorat": "குழந்தை பிறப்பு மஹூரத்",
    "Child Birth Mahoorat | Kundlistar Premium": "குழந்தை பிறப்பு மஹூரத் | குண்ட்லிஸ்டார் பிரீமியம்",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "பஞ்சாங்கம், சோகாடியா மற்றும் ஹோரா அடிப்படையிலான வழிகாட்டுதலுடன் கூடிய பிரீமியம் குழந்தை பிறப்பு மஹூரத் ஜன்னல்கள்.",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "திட்டமிடப்பட்ட குழந்தை-பிறப்பு நேர வழிகாட்டுதலுக்காக, கிடைக்கக்கூடிய நல்ல சாளரங்களை ஆராய தேதி மற்றும் இடத்தைத் தேர்ந்தெடுக்கவும்.",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "குழந்தை பிறப்பு மஹூரத் ஆன்மீக மற்றும் ஜோதிட வழிகாட்டுதலுக்காக மட்டுமே.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "குழந்தை பிறப்பு மஹூரத் ஒரு பிரீமியம் அம்சமாகும். பஞ்சாங்கம், சோகாடியா மற்றும் ஹோரா காசோலைகள் மூலம் நல்ல வழிகாட்டுதல் சாளரங்களைத் திறக்க மேம்படுத்தவும்.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "குழந்தை பிறப்பு மஹூரத் ஒரு பிரீமியம் அம்சமாகும். பஞ்சாங்கம், சோகாடியா மற்றும் ஹோரா காசோலைகள் மூலம் வழிகாட்டுதல் சாளரங்களைத் திறக்க மேம்படுத்தவும்.",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "தேதி, இடம், பஞ்சாங்கம், சோகாடியா மற்றும் ஹோரா ஆகியவற்றின் பிரீமியம் வழிகாட்டுதல் சாளரங்கள்.",
    "Premium feature": "பிரீமியம் அம்சம்",
    "Upgrade to Kundlistar Premium": "குண்ட்லிஸ்டார் பிரீமியத்திற்கு மேம்படுத்தவும்",
    "Previous": "முந்தைய",
    "Today": "இன்று",
    "Birth place / City": "பிறந்த இடம் / நகரம்",
    "Birth place / city": "பிறந்த இடம் / நகரம்",
    "Select country, then search city": "நாட்டைத் தேர்ந்தெடுக்கவும், பின்னர் நகரத்தைத் தேடவும்",
    "Preferred start": "விருப்பமான தொடக்கம்",
    "Preferred end": "விருப்பமான முடிவு",
    "Mother Moon sign (optional)": "தாய் சந்திரன் அடையாளம் (விரும்பினால்)",
    "Cancer": "கடகம்",
    "Load Kundli": "குண்ட்லியை ஏற்றவும்",
    "Find Premium Windows": "பிரீமியம் விண்டோஸைக் கண்டறியவும்",
    "Date (DD/MM/YYYY)": "தேதி (DD/MM/YYYY)",
    "Invalid Date": "தவறான தேதி",
    "Date must be in DD/MM/YYYY format.": "தேதி DD/MM/YYYY வடிவத்தில் இருக்க வேண்டும்.",
    "Required": "தேவை",
    "Please select a city.": "ஒரு நகரத்தைத் தேர்ந்தெடுக்கவும்.",
    "Kundli": "குண்ட்லி",
    "Unable to load kundli.": "குண்ட்லியை ஏற்ற முடியவில்லை.",
    "Unable to calculate Child Birth Mahoorat.": "குழந்தை பிறப்பு மஹூரத்தை கணக்கிட முடியவில்லை.",
    "Kundli Preview": "குண்ட்லி முன்னோட்டம்",
    "Loaded for": "ஏற்றப்பட்டது",
    "Doshas & Yogas": "தோஷங்கள் மற்றும் யோகாக்கள்",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "ஏற்றப்பட்ட லஹிரி குண்ட்லியில் இருந்து விதி அடிப்படையிலான அறிகுறிகள். மறுஆய்வு மற்றும் ஆன்மீக வழிகாட்டுதலுக்காக அவற்றைப் பயன்படுத்துங்கள், இறுதித் தீர்ப்பாக அல்ல.",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "ஏற்றப்பட்ட லஹிரி குண்ட்லியில் இருந்து விதி அடிப்படையிலான அறிகுறிகள். மதிப்பாய்வு மற்றும் ஆன்மீக வழிகாட்டலுக்கு பயன்படுத்தவும்.",
    "Detected": "கண்டறியப்பட்டது",
    "Not detected": "கண்டறியப்படவில்லை",
    "Review": "மதிப்பாய்வு",
    "Dosha": "தோசை",
    "Yoga": "யோகா",
    "Full Yoga Scan": "முழு யோகா ஸ்கேன்",
    "Checking yogas...": "யோகாவை சரிபார்க்கிறது...",
    "No major yogas were detected by the premium yoga scan.": "பிரீமியம் யோகா ஸ்கேன் மூலம் பெரிய யோகாக்கள் எதுவும் கண்டறியப்படவில்லை.",
    "No suitable premium windows found for the selected date and time range.": "தேர்ந்தெடுக்கப்பட்ட தேதி மற்றும் நேர வரம்பிற்கு பொருத்தமான பிரீமியம் சாளரங்கள் இல்லை.",
    "No suitable windows found": "பொருத்தமான ஜன்னல்கள் இல்லை",
    "Try changing the time range or select previous/next date.": "நேர வரம்பை மாற்ற முயற்சிக்கவும் அல்லது முந்தைய/அடுத்த தேதியைத் தேர்ந்தெடுக்கவும்.",
    "Try changing the date or time range.": "தேதி அல்லது நேர வரம்பை மாற்ற முயற்சிக்கவும்.",
    "Try the Previous or Next date button to find a better option.": "சிறந்த விருப்பத்தைக் கண்டறிய முந்தைய அல்லது அடுத்த தேதி பொத்தானை முயற்சிக்கவும்.",
    "Use Previous or Next date to find a better option.": "சிறந்த விருப்பத்தைக் கண்டறிய முந்தைய அல்லது அடுத்த தேதியைப் பயன்படுத்தவும்.",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "தேர்ந்தெடுக்கப்பட்ட தேதி மற்றும் நகரத்திற்கான சிறந்த பிரீமியம் சாளரங்களைக் கணக்கிட, பிரீமியம் விண்டோஸைக் கண்டுபிடி என்பதைக் கிளிக் செய்யவும்.",
    "Tap Find Premium Windows for the selected date and city.": "தேர்ந்தெடுக்கப்பட்ட தேதி மற்றும் நகரத்திற்கான பிரீமியம் விண்டோஸைக் கண்டுபிடி என்பதைத் தட்டவும்.",
    "Good tithi": "நல்ல திதி",
    "Supportive nakshatra": "துணை நக்ஷத்திரம்",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "நக்ஷத்ரா உணர்திறன் கொண்டது. படா மற்றும் கந்தன்தாவை கவனமாக சரிபார்க்கவும்.",
    "Supportive weekday": "ஆதரவான வார நாள்",
    "Good Choghadiya": "நல்ல சோகடியா",
    "Weak Choghadiya": "பலவீனமான சோகடியா",
    "Supportive Hora": "ஆதரவான ஹோரா",
    "Baby Moon matches mother's Moon sign.": "குழந்தை நிலவு தாயின் சந்திரன் அடையாளத்துடன் பொருந்துகிறது.",
    "Hora": "ஹோரா",
    "slots": "இடங்கள்",
    "min": "நிமி",
    "Good": "நல்லது",
    "Excellent": "சிறப்பானது",
    "Usable": "பயன்படுத்தக்கூடியது",
    "Rejected": "நிராகரிக்கப்பட்டது",
    "Sunday": "ஞாயிற்றுக்கிழமை",
    "Monday": "திங்கட்கிழமை",
    "Tuesday": "செவ்வாய்க்கிழமை",
    "Wednesday": "புதன்கிழமை",
    "Thursday": "வியாழக்கிழமை",
    "Friday": "வெள்ளிக்கிழமை",
    "Saturday": "சனிக்கிழமை",
    "Sun": "சூரியன்",
    "Moon": "சந்திரன்",
    "Mars": "செவ்வாய்",
    "Mercury": "புதன்",
    "Jupiter": "வியாழன்",
    "Venus": "சுக்கிரன்",
    "Saturn": "சனி",
    "Rahu": "ராகு",
    "Ketu": "கேது",
    "Chal": "சால்",
    "Labh": "லாபம்",
    "Amrit": "அம்ரித்",
    "Shubh": "சுப்",
    "Udveg": "உத்வேக்",
    "Rog": "ரோக்",
    "Kaal": "கால்",
    "Krishna Navami": "கிருஷ்ண நவமி",
    "Ashwini": "அசுவினி",
    "Bharani": "பரணி",
    "Krittika": "கார்த்திகை",
    "Rohini": "ரோகிணி",
    "Mrigashira": "மிருகசீரிஷம்",
    "Ardra": "திருவாதிரை",
    "Punarvasu": "புனர்பூசம்",
    "Pushya": "பூசம்",
    "Ashlesha": "ஆயில்யம்",
    "Magha": "மகம்",
    "Jyeshtha": "கேட்டை",
    "Moola": "மூலம்",
    "Mula": "மூலம்",
    "Revati": "ரேவதி",
    "Hasta": "ஹஸ்தம்",
    "Chitra": "சித்திரை",
    "Swati": "சுவாதி",
    "Vishakha": "விசாகம்",
    "Anuradha": "அனுஷம்",
    "Shravana": "திருவோணம்",
    "Dhanishta": "அவிட்டம்",
    "Shatabhisha": "சதயம்",
    "Aries": "மேஷம்",
    "Taurus": "ரிஷபம்",
    "Gemini": "மிதுனம்",
    "Leo": "சிம்மம்",
    "Virgo": "கன்னி",
    "Libra": "துலாம்",
    "Scorpio": "விருச்சிகம்",
    "Sagittarius": "தனுசு",
    "Capricorn": "மகரம்",
    "Aquarius": "கும்பம்",
    "Pisces": "மீனம்",
    "Mrigashirsha": "மிருகசீரிஷம்",
    "Mrigashirsham": "மிருகசீரிஷம்",
    "Aswini": "அசுவினி",
    "Ashvini": "அசுவினி",
    "Kritika": "கார்த்திகை",
    "Visakha": "விசாகம்",
    "Shatabhishak": "சதயம்",
    "Satabhisha": "சதயம்",
    "Sravana": "திருவோணம்",
    "Ascendant": "லக்னம்",
    "Asc": "லக்னம்",
    "Lagna": "லக்னம்",
    "Lord": "அதிபதி",
    "House Lordships": "பாவ அதிபதிகள்",
    "Sign": "ராசி",
    "Signs": "ராசிகள்",
    "House": "பாவம்",
    "Houses": "பாவங்கள்",
    "Nakshatra": "நட்சத்திரம்",
    "Nakshatram": "நட்சத்திரம்",
    "Lagna Chart (Rashi)": "லக்ன ஜாதகம் (ராசி)",
    "Bhava": "பாவம்",
    "Navamsha": "நவாம்சம்",
    "Dasha": "தசை",
    "Mahadasha": "மகாதசை",
    "Antardasha": "புத்தி",
    "Pratyantardasha": "அந்தரம்",
    "Sookshma": "சூட்சுமம்",
    "Transit": "கோச்சாரம்",
    "Sign Lord": "ராசி அதிபதி",
    "Star Lord": "நட்சத்திர அதிபதி",
    "Sub Lord": "உப அதிபதி",
    "Sub-Sub Lord": "உப உப அதிபதி",
    "Cusp Lord": "பாவமுனை அதிபதி",
    "Previous Sign Lord": "முந்தைய ராசி அதிபதி",
    "Own sign": "சொந்த ராசி",
    "Previous Sign": "முந்தைய ராசி",
    "Moon Sign": "சந்திர ராசி",
    "Sun Sign": "சூரிய ராசி",
    "Ravivara": "ஞாயிற்றுக்கிழமை",
    "Somavara": "திங்கட்கிழமை",
    "Mangalavara": "செவ்வாய்க்கிழமை",
    "Budhavara": "புதன்கிழமை",
    "Guruvara": "வியாழக்கிழமை",
    "Shukravara": "வெள்ளிக்கிழமை",
    "Shanivara": "சனிக்கிழமை"
  },
  "te": {
    "Client Management": "క్లయింట్ నిర్వహణ",
    "Dashboard": "డాష్‌బోర్డ్",
    "Clients": "క్లయింట్లు",
    "Consultations": "సంప్రదింపులు",
    "Notes": "గమనికలు",
    "Follow-ups": "అనుసరణలు",
    "Reports": "నివేదికలు",
    "Remedies": "నివారణలు",
    "Predictions": "అంచనాలు",
    "Planner": "ప్లానర్",
    "Templates": "టెంప్లేట్లు",
    "Analytics": "విశ్లేషణలు",
    "Payments": "చెల్లింపులు",
    "Settings": "సెట్టింగ్‌లు",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings లో డిఫాల్ట్ నగరాన్ని సేవ్ చేయవచ్చు. డిఫాల్ట్ నగరం ఎంచుకునే వరకు నగర ఫీల్డులు ఖాళీగా ఉంటాయి.",
    "is now your default city.": "ఇప్పుడు మీ డిఫాల్ట్ నగరం.",
    "Search your default city": "మీ డిఫాల్ట్ నగరాన్ని వెతకండి",
    "This color is saved for the website theme and PDF report accent.": "ఈ రంగు వెబ్‌సైట్ థీమ్ మరియు PDF రిపోర్ట్ యాక్సెంట్ కోసం సేవ్ అవుతుంది.",
    "Turn All off to include only the checked modules in the report.": "నివేదికలో ఎంపిక చేసిన మాడ్యూల్స్ మాత్రమే చేర్చడానికి All ఆఫ్ చేయండి.",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All ఆన్‌లో ఉంటే PDF అన్ని మాడ్యూల్స్‌ను కలిగి ఉంటుంది. ఎంపిక చేసినవాటిని మాత్రమే చేర్చడానికి దాన్ని ఆఫ్ చేయండి.",
    "Uranus, Neptune and Pluto stay hidden by default.": "యురేనస్, నెప్ట్యూన్ మరియు ప్లూటో డిఫాల్ట్‌గా దాచబడతాయి.",
    "Show Uranus, Neptune and Pluto": "యురేనస్, నెప్ట్యూన్ మరియు ప్లూటోను చూపించండి",
    "When off, Nadi and KP also use the selected global ayanamsha.": "ఆఫ్‌లో ఉంటే, నాడి మరియు KP కూడా ఎంచుకున్న గ్లోబల్ అయనాంశాన్ని ఉపయోగిస్తాయి.",
    "Use KP for Nadi and KP": "నాడి మరియు KP కోసం KP ఉపయోగించండి",
    "Use KP ayanamsha for Nadi and KP": "నాడి మరియు KP కోసం KP అయనాంశం ఉపయోగించండి",
    "Night": "నైట్",
    "Dark": "డార్క్",
    "Light": "లైట్",
    "Clear default city": "డిఫాల్ట్ నగరాన్ని తొలగించండి",
    "Default City": "డిఫాల్ట్ నగరం",
    "Default city": "డిఫాల్ట్ నగరం",
    "Theme Color": "థీమ్ రంగు",
    "Theme color": "థీమ్ రంగు",
    "Include all modules": "అన్ని మాడ్యూల్స్ చేర్చండి",
    "PDF Report Modules": "PDF నివేదిక మాడ్యూల్స్",
    "PDF report modules": "PDF నివేదిక మాడ్యూల్స్",
    "Show": "చూపించు",
    "Hide": "దాచు",
    "Outer Planets": "బాహ్య గ్రహాలు",
    "Outer planets": "బాహ్య గ్రహాలు",
    "Ayanamsha": "అయనాంశం",
    "Mean Node": "మీన్ నోడ్",
    "True Node": "ట్రూ నోడ్",
    "Rahu/Ketu Calculation": "రాహు/కేతు గణన",
    "Rahu/Ketu calculation": "రాహు/కేతు గణన",
    "East": "తూర్పు భారతీయ",
    "South": "దక్షిణ భారతీయ",
    "North": "ఉత్తర భారతీయ",
    "Chart Style": "చార్ట్ శైలి",
    "Chart style": "చార్ట్ శైలి",
    "Language": "భాష",
    "Records": "రికార్డులు",
    "Relations": "సంబంధాలు",
    "Relation": "సంబంధం",
    "Add Client": "క్లయింట్‌ని జోడించండి",
    "Add Consultation": "సంప్రదింపులను జోడించండి",
    "Add Note": "గమనికను జోడించండి",
    "Add Follow-up": "ఫాలో-అప్‌ని జోడించండి",
    "Create Report": "నివేదికను సృష్టించండి",
    "Assign Remedy": "నివారణను కేటాయించండి",
    "Add Prediction": "ప్రిడిక్షన్ జోడించండి",
    "Add Payment": "చెల్లింపును జోడించండి",
    "Assign Chart": "చార్ట్ కేటాయించండి",
    "Add Relation": "సంబంధాన్ని జోడించండి",
    "CMS Action": "CMS చర్య",
    "Client": "క్లయింట్",
    "Chart": "చార్ట్",
    "Related Client": "సంబంధిత క్లయింట్",
    "Full Name": "పూర్తి పేరు",
    "Phone Number": "ఫోన్ నంబర్",
    "WhatsApp Number": "వాట్సాప్ నంబర్",
    "Email": "ఇమెయిల్",
    "Birth Place": "పుట్టిన ప్రదేశం",
    "Current City": "ప్రస్తుత నగరం",
    "Main Topic": "ప్రధాన అంశం",
    "Status": "స్థితి",
    "Source": "మూలం",
    "Tags": "ట్యాగ్‌లు",
    "Internal Note": "అంతర్గత గమనిక",
    "Purpose": "ప్రయోజనం",
    "Relation Type": "సంబంధం రకం",
    "Title": "శీర్షిక",
    "Topic": "అంశం",
    "Date": "తేదీ",
    "Time": "సమయం",
    "Amount": "మొత్తం",
    "Mode": "మోడ్",
    "Payment Status": "చెల్లింపు స్థితి",
    "Note / Summary": "గమనిక / సారాంశం",
    "Close": "మూసివేయి",
    "Cancel": "రద్దు చేయి",
    "Save": "సేవ్ చేయండి",
    "Saving": "పొదుపు చేస్తోంది",
    "Save Changes": "మార్పులను సేవ్ చేయండి",
    "Edit Client": "క్లయింట్‌ని సవరించండి",
    "Client Chart": "క్లయింట్ చార్ట్",
    "Comma separated": "కామా వేరు",
    "Search by name, phone, email, topic, or tag": "పేరు, ఫోన్, ఇమెయిల్, టాపిక్ లేదా ట్యాగ్ ద్వారా శోధించండి",
    "Search clients, phone, topic": "క్లయింట్‌లు, ఫోన్, టాపిక్‌లను శోధించండి",
    "Search your saved charts by chart name": "చార్ట్ పేరు ద్వారా మీ సేవ్ చేసిన చార్ట్‌లను శోధించండి",
    "Linked Chart": "లింక్డ్ చార్ట్",
    "Select linked chart": "లింక్ చేయబడిన చార్ట్‌ని ఎంచుకోండి",
    "Link a chart to this client before adding records.": "రికార్డ్‌లను జోడించే ముందు ఈ క్లయింట్‌కి చార్ట్‌ను లింక్ చేయండి.",
    "Connect this client with another saved client profile": "ఈ క్లయింట్‌ని మరొక సేవ్ చేయబడిన క్లయింట్ ప్రొఫైల్‌తో కనెక్ట్ చేయండి",
    "CMS for astrologer client work": "జ్యోతిష్యుడు క్లయింట్ పని కోసం CMS",
    "Premium Pro unlocks Client Management": "ప్రీమియం ప్రో క్లయింట్ నిర్వహణను అన్‌లాక్ చేస్తుంది",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "క్లయింట్ ప్రొఫైల్‌లు, సంప్రదింపులు, గమనికలు, ఫాలో-అప్‌లు, నివేదికలు, నివారణలు, అంచనాలు, విశ్లేషణలు మరియు చెల్లింపు ట్రాకింగ్‌లను ఒకే వర్క్‌స్పేస్‌లో నిర్వహించడానికి అప్‌గ్రేడ్ చేయండి.",
    "Upgrade to Premium Pro": "ప్రీమియం ప్రోకి అప్‌గ్రేడ్ చేయండి",
    "CMS modules included": "CMS మాడ్యూల్స్ చేర్చబడ్డాయి",
    "Please login to use Client Management. CMS data is stored per account.": "దయచేసి క్లయింట్ మేనేజ్‌మెంట్‌ని ఉపయోగించడానికి లాగిన్ చేయండి. ఒక్కో ఖాతాకు CMS డేటా నిల్వ చేయబడుతుంది.",
    "Login": "లాగిన్ చేయండి",
    "Loading live CMS data...": "ప్రత్యక్ష CMS డేటాను లోడ్ చేస్తోంది...",
    "Quick Actions": "త్వరిత చర్యలు",
    "Client Records": "క్లయింట్ రికార్డులు",
    "Client Record": "క్లయింట్ రికార్డ్",
    "Client Profile": "క్లయింట్ ప్రొఫైల్",
    "Back to Clients": "తిరిగి ఖాతాదారులకు",
    "View": "చూడండి",
    "Edit": "సవరించు",
    "Delete": "తొలగించు",
    "Note": "గమనిక",
    "Archive": "ఆర్కైవ్",
    "Download PDF": "PDFని డౌన్‌లోడ్ చేయండి",
    "Delete this record?": "ఈ రికార్డును తొలగించాలా?",
    "Unable to edit this CMS record.": "ఈ CMS రికార్డ్‌ని సవరించడం సాధ్యం కాలేదు.",
    "Unable to update CMS record.": "CMS రికార్డ్‌ని నవీకరించడం సాధ్యం కాలేదు.",
    "Unable to delete CMS record.": "CMS రికార్డ్‌ను తొలగించడం సాధ్యపడలేదు.",
    "No contact added": "పరిచయం ఏదీ జోడించబడలేదు",
    "No topic": "టాపిక్ లేదు",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "క్లయింట్‌లు ఎవరూ కనుగొనబడలేదు. CMS డాష్‌బోర్డ్‌ను పూరించడం ప్రారంభించడానికి మీ మొదటి నిజమైన క్లయింట్‌ని జోడించండి.",
    "Last Consultation": "చివరి సంప్రదింపులు",
    "Next Follow-up": "తదుపరి ఫాలో-అప్",
    "Date of Birth": "పుట్టిన తేదీ",
    "Time of Birth": "పుట్టిన సమయం",
    "Client Details": "క్లయింట్ వివరాలు",
    "No connected profiles yet.": "ఇంకా కనెక్ట్ చేయబడిన ప్రొఫైల్‌లు లేవు.",
    "Select a client record to view details.": "వివరాలను వీక్షించడానికి క్లయింట్ రికార్డ్‌ను ఎంచుకోండి.",
    "Record": "రికార్డ్ చేయండి",
    "Consultation Summary": "సంప్రదింపుల సారాంశం",
    "Client Note": "క్లయింట్ గమనిక",
    "Start a consultation record with summary, topic, mode and payment fields.": "సారాంశం, అంశం, మోడ్ మరియు చెల్లింపు ఫీల్డ్‌లతో సంప్రదింపుల రికార్డును ప్రారంభించండి.",
    "Start a private note attached to a client profile.": "క్లయింట్ ప్రొఫైల్‌కు జోడించబడిన ప్రైవేట్ గమనికను ప్రారంభించండి.",
    "Start a pending follow-up with due date and topic.": "గడువు తేదీ మరియు అంశంతో పెండింగ్‌లో ఉన్న ఫాలో-అప్‌ను ప్రారంభించండి.",
    "Start a report record connected to the client timeline.": "క్లయింట్ టైమ్‌లైన్‌కి కనెక్ట్ చేయబడిన నివేదిక రికార్డ్‌ను ప్రారంభించండి.",
    "Start an active remedy record for client guidance.": "క్లయింట్ మార్గదర్శకత్వం కోసం యాక్టివ్ రెమెడీ రికార్డ్‌ను ప్రారంభించండి.",
    "Start an open prediction record with notes and follow-up date.": "గమనికలు మరియు తదుపరి తేదీతో ఓపెన్ ప్రిడిక్షన్ రికార్డ్‌ను ప్రారంభించండి.",
    "Statuses": "స్థితిగతులు",
    "Topics": "అంశాలు",
    "Sources": "మూలాలు",
    "No records found for the current filters.": "ప్రస్తుత ఫిల్టర్‌ల కోసం రికార్డులు ఏవీ కనుగొనబడలేదు.",
    "Total Clients": "మొత్తం క్లయింట్లు",
    "New Clients This Month": "ఈ నెల కొత్త క్లయింట్లు",
    "Consultations This Month": "ఈ నెల సంప్రదింపులు",
    "Today's Consultations": "ఈరోజు సంప్రదింపులు",
    "Consultations scheduled for today from real client records.": "నిజమైన క్లయింట్ రికార్డుల నుండి ఈరోజు సంప్రదింపులు షెడ్యూల్ చేయబడ్డాయి.",
    "No consultations scheduled for today.": "ఈరోజు సంప్రదింపులు షెడ్యూల్ చేయబడలేదు.",
    "Pending Follow-ups": "పెండింగ్‌లో ఉన్న ఫాలో-అప్‌లు",
    "Reports Created": "నివేదికలు రూపొందించబడ్డాయి",
    "Active Remedies": "క్రియాశీల నివారణలు",
    "Open Predictions": "అంచనాలను తెరవండి",
    "Pending Payments": "పెండింగ్ చెల్లింపులు",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "క్లయింట్ కార్యాచరణ, ఇటీవలి పని, ఫాలో-అప్‌లు, నివేదికలు, అంచనాలు, నివారణలు మరియు పెండింగ్‌లో ఉన్న చెల్లింపులను ఒకే చోట చూడండి.",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "జనన వివరాలు, అంశాలు, ట్యాగ్‌లు, స్థితి మరియు ఆర్కైవ్/పునరుద్ధరణ చర్యలతో జ్యోతిష్కుడు క్లయింట్ రికార్డ్‌లను నిర్వహించండి.",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "సెషన్ వివరాలు, లింక్ చేయబడిన చార్ట్‌లు, అంశాలు, పరిశీలనలు, అంచనాలు, నివారణలు మరియు తదుపరి తేదీలను స్టోర్ చేయండి.",
    "Keep private consultation notes and chart observations attached to client profiles.": "క్లయింట్ ప్రొఫైల్‌లకు ప్రైవేట్ కన్సల్టేషన్ నోట్స్ మరియు చార్ట్ పరిశీలనలను జోడించి ఉంచండి.",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "క్లయింట్ మేనేజ్‌మెంట్‌లో పుష్, SMS, ఇమెయిల్ లేదా WhatsApp హెచ్చరికలు లేకుండా ఈరోజు మరియు రాబోయే ఫాలో-అప్‌లను ట్రాక్ చేయండి.",
    "Create and organize client reports generated from saved charts and consultation context.": "సేవ్ చేయబడిన చార్ట్‌లు మరియు సంప్రదింపుల సందర్భం నుండి రూపొందించబడిన క్లయింట్ నివేదికలను సృష్టించండి మరియు నిర్వహించండి.",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "నివారణలను కేటాయించండి, యాక్టివ్ గైడెన్స్‌ను గుర్తించండి మరియు క్లయింట్ టైమ్‌లైన్‌కి రెమెడీ హిస్టరీని కనెక్ట్ చేయండి.",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "ప్రతి క్లయింట్ కోసం బహిరంగ అంచనాలు, తేదీలు, విశ్వాస గమనికలు మరియు ఫలిత నవీకరణలను ట్రాక్ చేయండి.",
    "Plan consultations, follow-ups and payment dates in one working view.": "ఒకే పని వీక్షణలో సంప్రదింపులు, ఫాలో-అప్‌లు మరియు చెల్లింపు తేదీలను ప్లాన్ చేయండి.",
    "Prepare reusable consultation, report, remedy and prediction templates.": "పునర్వినియోగ సంప్రదింపులు, నివేదిక, నివారణ మరియు అంచనా టెంప్లేట్‌లను సిద్ధం చేయండి.",
    "Review client activity, consultation volume, reports created and pending work.": "క్లయింట్ కార్యాచరణ, సంప్రదింపుల వాల్యూమ్, సృష్టించిన నివేదికలు మరియు పెండింగ్‌లో ఉన్న పనిని సమీక్షించండి.",
    "Track consultation amounts and payment status without plan or pricing rules.": "ప్లాన్ లేదా ధర నియమాలు లేకుండా కన్సల్టేషన్ మొత్తాలను మరియు చెల్లింపు స్థితిని ట్రాక్ చేయండి.",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "క్లయింట్ సోర్స్‌లు, స్టేటస్‌లు, టాపిక్‌లు, ట్యాగ్‌లు మరియు అంతర్గత CMS ప్రాధాన్యతలను కాన్ఫిగర్ చేయండి.",
    "Showing saved records connected to client records.": "క్లయింట్ రికార్డ్‌లకు కనెక్ట్ చేయబడిన సేవ్ చేయబడిన రికార్డ్‌లను చూపుతోంది.",
    "No Status": "స్థితి లేదు",
    "No Mode": "మోడ్ లేదు",
    "No Payment Status": "చెల్లింపు స్థితి లేదు",
    "No Topic": "అంశం లేదు",
    "No Source": "మూలం లేదు",
    "All Statuses": "అన్ని స్థితిగతులు",
    "All Topics": "అన్ని అంశాలు",
    "No clients found": "క్లయింట్లు కనుగొనబడలేదు",
    "Type to search clients": "క్లయింట్‌లను శోధించడానికి టైప్ చేయండి",
    "No charts found": "చార్ట్‌లు ఏవీ కనుగొనబడలేదు",
    "Type to search saved charts": "సేవ్ చేసిన చార్ట్‌లను శోధించడానికి టైప్ చేయండి",
    "Type to search related client": "సంబంధిత క్లయింట్‌ని శోధించడానికి టైప్ చేయండి",
    "Open": "తెరవండి",
    "Pending": "పెండింగ్‌లో ఉంది",
    "Scheduled": "షెడ్యూల్ చేయబడింది",
    "Completed": "పూర్తయింది",
    "Follow-up Pending": "ఫాలో-అప్ పెండింగ్‌లో ఉంది",
    "Cancelled": "రద్దు చేయబడింది",
    "Closed": "మూసివేయబడింది",
    "No-show": "నో-షో",
    "Not Applicable": "వర్తించదు",
    "Paid": "చెల్లించారు",
    "Partially Paid": "పాక్షికంగా చెల్లించబడింది",
    "Refunded": "వాపసు ఇచ్చారు",
    "Phone": "ఫోన్",
    "WhatsApp Call": "WhatsApp కాల్",
    "Video Call": "వీడియో కాల్",
    "In-person": "వ్యక్తిగతంగా",
    "Chat": "చాట్ చేయండి",
    "Other": "ఇతర",
    "New": "కొత్తది",
    "VIP": "VIP",
    "Inactive": "నిష్క్రియ",
    "Consultation Completed": "సంప్రదింపులు పూర్తయ్యాయి",
    "WhatsApp": "WhatsApp",
    "Instagram": "Instagram",
    "YouTube": "YouTube",
    "Referral": "రెఫరల్",
    "Website": "వెబ్సైట్",
    "Walk-in": "వాక్-ఇన్",
    "Repeat Client": "రిపీట్ క్లయింట్",
    "Family Referral": "కుటుంబ రెఫరల్",
    "Business": "వ్యాపారం",
    "Finance": "ఫైనాన్స్",
    "Property": "ఆస్తి",
    "Children": "పిల్లలు",
    "Foreign Settlement": "విదేశీ సెటిల్మెంట్",
    "Legal": "చట్టపరమైన",
    "Remedy": "నివారణ",
    "General": "జనరల్",
    "Active": "చురుకుగా",
    "Past": "గతం",
    "Potential": "సంభావ్య",
    "Archived": "ఆర్కైవ్ చేయబడింది",
    "Spouse": "జీవిత భాగస్వామి",
    "Husband": "భర్త",
    "Wife": "భార్య",
    "Child": "పిల్లవాడు",
    "Son": "కొడుకు",
    "Daughter": "కూతురు",
    "Father": "తండ్రి",
    "Mother": "తల్లి",
    "Sibling": "తోబుట్టువు",
    "Brother": "సోదరుడు",
    "Sister": "సోదరి",
    "Marriage Prospect": "వివాహ ప్రాస్పెక్ట్",
    "Fiance": "కాబోయే భర్త",
    "Business Partner": "వ్యాపార భాగస్వామి",
    "Friend": "స్నేహితుడు",
    "Relative": "బంధువు",
    "Upgrade": "అప్‌గ్రేడ్ చేయండి",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "మీరు 2 క్లయింట్‌లను మాత్రమే జోడించగలరు. ఎక్కువ మంది క్లయింట్‌ల కోసం ప్రీమియంకు అప్‌గ్రేడ్ చేయండి.",
    "None": "ఏదీ లేదు",
    "Education": "విద్య",
    "Awards": "అవార్డులు",
    "Prize": "బహుమతి",
    "Career": "కెరీర్",
    "Love": "ప్రేమ",
    "Marriage": "వివాహం",
    "Dowry or Legacy": "కట్నం లేదా వారసత్వం",
    "Divorce": "విడాకులు",
    "Abortion": "అబార్షన్",
    "Child Birth": "చైల్డ్ బర్త్",
    "Property/Vehicle Purchase": "ఆస్తి/వాహనం కొనుగోలు",
    "Property/Vehicle Sale": "ఆస్తి/వాహన విక్రయం",
    "Love and Caring": "ప్రేమ మరియు సంరక్షణ",
    "Depression": "డిప్రెషన్",
    "Aggression": "దూకుడు",
    "Health": "ఆరోగ్యం",
    "Travel": "ప్రయాణం",
    "Homecoming": "గృహప్రవేశం",
    "Litigation": "వ్యాజ్యం",
    "Arrest": "అరెస్టు",
    "Locked": "లాక్ చేయబడింది",
    "Strong": "బలమైన",
    "Weak": "బలహీనమైనది",
    "Supportive": "సపోర్టివ్",
    "Avoid": "నివారించండి",
    "Premium": "ప్రీమియం",
    " UTC": "UTC",
    "Unable to calculate Tithi Pravesh": "తిథి ప్రవేశాన్ని లెక్కించడం సాధ్యం కాలేదు",
    "IANA timezone": "IANA సమయ క్షేత్రం",
    "TP Local": "TP స్థానిక",
    "TP UTC": "TP UTC",
    "Next TP Local": "తదుపరి TP స్థానికం",
    "Models: KP + Vedic": "మోడల్స్: KP + వేద",
    "Overall Year Theme": "మొత్తం సంవత్సరం థీమ్",
    "Career & Job": "కెరీర్ & ఉద్యోగం",
    "Finance & Savings": "ఫైనాన్స్ & సేవింగ్స్",
    "Relationship & Marriage": "సంబంధం & వివాహం",
    "Family Matters": "కుటుంబ విషయాలు",
    "Property & Vehicle": "ఆస్తి & వాహనం",
    "Health & Wellness": "ఆరోగ్యం & ఆరోగ్యం",
    "Spiritual Growth": "ఆధ్యాత్మిక వృద్ధి",
    "Social Status & Recognition": "సామాజిక స్థితి & గుర్తింపు",
    "Please select a saved chart first.": "దయచేసి ముందుగా సేవ్ చేసిన చార్ట్‌ని ఎంచుకోండి.",
    "Unable to generate Tajika Varshphal": "తజికా వర్ష్‌ఫాల్‌ని రూపొందించడం సాధ్యం కాలేదు",
    "Premium yearly module": "ప్రీమియం వార్షిక మాడ్యూల్",
    "Tajika Varshphal": "తాజికా వర్ష్‌ఫాల్",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "ఈ సేవ్ చేయబడిన కుండ్లి నుండి వ్యక్తిగతీకరించబడిన వర్ష లగ్న, ముంత, వర్ష దేవుడు, సహములు, నెలవారీ మార్గదర్శకత్వం, నివారణలు మరియు ఆచరణాత్మక జీవిత థీమ్‌లతో సౌర రాబడి ఆధారిత వార్షిక జాతకం.",
    "Saved chart": "సేవ్ చేయబడిన చార్ట్",
    "Untitled Chart": "శీర్షికలేని చార్ట్",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "మీ 4 ఉచిత ప్రీమియం క్రెడిట్‌లు ఉపయోగించబడతాయి. అపరిమిత ప్రీమియం యాక్సెస్ కోసం Kundlistar ప్రీమియమ్‌కి అప్‌గ్రేడ్ చేయండి.",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "మీరు 4 నిశ్శుల్క్ ప్రీమియం క్రెడిట్ ఉపయోగము లేదా చుకే ఉంది. అసిమిత్ ప్రీమియం ఎక్సెస్ కోసం Kundlistar ప్రీమియం లెం.",
    "Core Year Markers": "కోర్ ఇయర్ మార్కర్స్",
    "Solar Return": "సోలార్ రిటర్న్",
    "Varsha Lagna": "వర్ష లగ్నం",
    "Muntha Lord": "ముంత ప్రభువు",
    "Varsha Lord": "వర్ష ప్రభువు",
    "Varshesh Method": "వర్షేష్ పద్ధతి",
    "Yearly Summary": "వార్షిక సారాంశం",
    "Not available yet.": "ఇంకా అందుబాటులో లేదు.",
    "Varshesh Candidates": "వర్షేష్ అభ్యర్థులు",
    "Risk Areas": "ప్రమాద ప్రాంతాలు",
    "Favourable Periods": "అనుకూలమైన కాలాలు",
    "Challenging Periods": "ఛాలెంజింగ్ పీరియడ్స్",
    "Remedies & Final Advice": "నివారణలు & తుది సలహా",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "Tajika Varshphal వివరణాత్మక వార్షిక మార్గదర్శకత్వం ఇస్తుంది. ఇది వైద్య, చట్టపరమైన, ఆర్థిక లేదా నిర్దిష్ట అంచనా సలహాగా పరిగణించరాదు.",
    "Griha Pravesh": "గృహ ప్రవేశ్",
    "Purva Phalguni": "పూర్వ ఫాల్గుణి",
    "Uttara Phalguni": "ఉత్తర ఫాల్గుణి",
    "Purva Ashadha": "పూర్వ ఆషాఢ",
    "Uttara Ashadha": "ఉత్తర ఆషాఢ",
    "Purva Bhadrapada": "పూర్వ భాద్రపద",
    "Uttara Bhadrapada": "ఉత్తర భాద్రపద",
    "Param Mitra": "పరమ మిత్ర",
    "Kundli birthplace": "కుండ్లి జన్మస్థలం",
    "Selected city": "ఎంచుకున్న నగరం",
    "Muhurat - Kundlistar": "ముహూర్తం - Kundlistar",
    "Please select a city first.": "దయచేసి ముందుగా ఒక నగరాన్ని ఎంచుకోండి.",
    "Unable to calculate Muhurat.": "ముహూర్తం గణించడం సాధ్యం కాలేదు.",
    "Unable to calculate personalized Muhurat.": "వ్యక్తిగతీకరించిన ముహూర్తాన్ని లెక్కించడం సాధ్యపడలేదు.",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "పంచాంగ్, చోఘడియ, హోరా, తారాబలా మరియు చంద్రబాలలను ఉపయోగించి సాధారణ మరియు వ్యక్తిగతీకరించిన ముహూర్తాన్ని కనుగొనండి.",
    "Muhurat Finder": "ముహూర్తం శోధకుడు",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "పంచాంగ్, చోగడియా మరియు ప్రీమియం వ్యక్తిగత జనన కారకాలను ఉపయోగించి ఉపయోగకరమైన సమయ విండోలను కనుగొనండి.",
    "Search city...": "నగరాన్ని శోధించండి...",
    "Using selected Kundli": "ఎంచుకున్న కుండలిని ఉపయోగించడం",
    "Find Free": "ఉచితంగా కనుగొనండి",
    "Free General Muhurat": "ఉచిత జనరల్ ముహూర్తం",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "తదుపరి 7 రోజులలో టాప్ 3 స్లాట్‌లు. రాహుకాలం, యమగండ, గుళిక తొలగిపోతాయి.",
    "Today's Muhurat": "ఈరోజు ముహూర్తం",
    "Daily Muhurat by Kundlistar": "Kundlistar ద్వారా రోజువారీ ముహూర్తం",
    "Shared via Kundlistar": "Kundlistar ద్వారా భాగస్వామ్యం చేయబడింది",
    "Kundlistar Muhurat": "Kundlistar ముహూర్తం",
    "Share Image": "చిత్రాన్ని భాగస్వామ్యం చేయండి",
    "Share Text": "వచనాన్ని భాగస్వామ్యం చేయండి",
    "Copy Text": "వచనాన్ని కాపీ చేయండి",
    "Click Find Free to use the selected Kundli birthplace.": "ఎంచుకున్న కుండ్లి జన్మస్థలాన్ని ఉపయోగించడానికి ఉచితంగా కనుగొను క్లిక్ చేయండి.",
    "Select a city and click Find Free.": "నగరాన్ని ఎంచుకుని, ఉచితంగా కనుగొను క్లిక్ చేయండి.",
    "Premium Personalized Muhurat": "ప్రీమియం వ్యక్తిగతీకరించిన ముహూర్తం",
    "Loading Kundli details...": "కుండ్లి వివరాలను లోడ్ చేస్తోంది...",
    "Birth Nakshatra": "జన్మ నక్షత్రం",
    "Birth Moon Rashi": "జన్మ చంద్ర రాశి",
    "Include night slots": "నైట్ స్లాట్‌లను చేర్చండి",
    "Find Premium": "ప్రీమియం కనుగొనండి",
    "Your grounding and foundation energy appears strong in this chart.": "ఈ చార్ట్‌లో మీ గ్రౌండింగ్ మరియు ఫౌండేషన్ ఎనర్జీ బలంగా కనిపిస్తుంది.",
    "Your grounding energy appears generally balanced in this chart.": "ఈ చార్ట్‌లో మీ గ్రౌండింగ్ ఎనర్జీ సాధారణంగా బ్యాలెన్స్‌గా కనిపిస్తుంది.",
    "Reflection on routine, discipline, and inner stability may be useful.": "దినచర్య, క్రమశిక్షణ మరియు అంతర్గత స్థిరత్వంపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "Your creative and emotional flow energy appears strong in this chart.": "మీ సృజనాత్మక మరియు భావోద్వేగ ప్రవాహ శక్తి ఈ చార్ట్‌లో బలంగా కనిపిస్తుంది.",
    "Your creative energy appears balanced in this chart.": "ఈ చార్ట్‌లో మీ సృజనాత్మక శక్తి సమతుల్యంగా కనిపిస్తుంది.",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "సృజనాత్మకత, భావోద్వేగ వ్యక్తీకరణ మరియు అంతర్గత ప్రవాహంపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "Your confidence and willpower energy appears strong in this chart.": "మీ విశ్వాసం మరియు సంకల్ప శక్తి ఈ చార్ట్‌లో బలంగా కనిపిస్తుంది.",
    "Your action-taking energy appears balanced in this chart.": "ఈ చార్ట్‌లో మీ చర్య తీసుకునే శక్తి సమతుల్యంగా కనిపిస్తుంది.",
    "Reflection on confidence, discipline, and decision power may be useful.": "విశ్వాసం, క్రమశిక్షణ మరియు నిర్ణయ శక్తిపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "Your connection and compassion energy appears strong in this chart.": "మీ కనెక్షన్ మరియు కారుణ్య శక్తి ఈ చార్ట్‌లో బలంగా కనిపిస్తుంది.",
    "Your emotional connection energy appears balanced in this chart.": "ఈ చార్ట్‌లో మీ భావోద్వేగ కనెక్షన్ శక్తి సమతుల్యంగా కనిపిస్తుంది.",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "సామరస్యం, క్షమాపణ మరియు భావోద్వేగ సమతుల్యతపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "Your communication and expression energy appears strong in this chart.": "మీ కమ్యూనికేషన్ మరియు వ్యక్తీకరణ శక్తి ఈ చార్ట్‌లో బలంగా కనిపిస్తుంది.",
    "Your expression energy appears balanced in this chart.": "ఈ చార్ట్‌లో మీ వ్యక్తీకరణ శక్తి సమతుల్యంగా కనిపిస్తుంది.",
    "Reflection on clear communication and self-expression may be useful.": "స్పష్టమైన కమ్యూనికేషన్ మరియు స్వీయ వ్యక్తీకరణపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "Your intuition and inner clarity appears strong in this chart.": "ఈ చార్ట్‌లో మీ అంతర్ దృష్టి మరియు అంతర్గత స్పష్టత బలంగా కనిపిస్తాయి.",
    "Your intuitive clarity appears balanced in this chart.": "ఈ చార్ట్‌లో మీ సహజమైన స్పష్టత సమతుల్యంగా కనిపిస్తుంది.",
    "Reflection on focus, intuition, and inner guidance may be useful.": "దృష్టి, అంతర్ దృష్టి మరియు అంతర్గత మార్గదర్శకత్వంపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "A strong Fire element supports action, courage, and leadership energy.": "బలమైన ఫైర్ ఎలిమెంట్ చర్య, ధైర్యం మరియు నాయకత్వ శక్తికి మద్దతు ఇస్తుంది.",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "అగ్ని సమతుల్యంగా కనిపిస్తుంది, చర్య మరియు సహనం మధ్య స్థిరమైన లయకు మద్దతు ఇస్తుంది.",
    "Reflection on confidence and action-taking may be useful.": "విశ్వాసం మరియు చర్య తీసుకోవడంపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "A strong Earth element supports practicality, patience, and stability.": "బలమైన భూమి మూలకం ఆచరణాత్మకత, సహనం మరియు స్థిరత్వానికి మద్దతు ఇస్తుంది.",
    "Earth appears balanced, supporting practical thinking with flexibility.": "భూమి సమతుల్యంగా కనిపిస్తుంది, వశ్యతతో ఆచరణాత్మక ఆలోచనకు మద్దతు ఇస్తుంది.",
    "Reflection on grounding, consistency, and planning may be useful.": "గ్రౌండింగ్, స్థిరత్వం మరియు ప్రణాళికపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "A strong Air element supports ideas, communication, and adaptability.": "బలమైన గాలి మూలకం ఆలోచనలు, కమ్యూనికేషన్ మరియు అనుకూలతకు మద్దతు ఇస్తుంది.",
    "Air appears balanced, supporting harmony between thinking and action.": "గాలి సమతుల్యంగా కనిపిస్తుంది, ఆలోచన మరియు చర్య మధ్య సామరస్యానికి మద్దతు ఇస్తుంది.",
    "Reflection on communication and flexibility may be useful.": "కమ్యూనికేషన్ మరియు వశ్యతపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "బలమైన నీటి మూలకం అంతర్ దృష్టి, సున్నితత్వం మరియు భావోద్వేగ లోతుకు మద్దతు ఇస్తుంది.",
    "Water appears balanced, supporting harmony between emotions and logic.": "నీరు సమతుల్యంగా కనిపిస్తుంది, భావోద్వేగాలు మరియు తర్కం మధ్య సామరస్యానికి మద్దతు ఇస్తుంది.",
    "Reflection on emotional expression and inner connection may be useful.": "భావోద్వేగ వ్యక్తీకరణ మరియు అంతర్గత అనుసంధానంపై ప్రతిబింబం ఉపయోగకరంగా ఉండవచ్చు.",
    "A strong Ether element supports spiritual awareness and broader vision.": "బలమైన ఈథర్ మూలకం ఆధ్యాత్మిక అవగాహన మరియు విస్తృత దృష్టికి మద్దతు ఇస్తుంది.",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ఈథర్ సమతుల్యంగా కనిపిస్తుంది, ఆధ్యాత్మిక మరియు ఆచరణాత్మక విధానం మధ్య సామరస్యానికి మద్దతు ఇస్తుంది.",
    "Reflection, silence, and spiritual discipline may be useful.": "ప్రతిబింబం, నిశ్శబ్దం మరియు ఆధ్యాత్మిక క్రమశిక్షణ ఉపయోగకరంగా ఉండవచ్చు.",
    "For inner confidence, clarity, and soul strength.": "అంతర్గత విశ్వాసం, స్పష్టత మరియు ఆత్మ బలం కోసం.",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "ఈ ఇష్ట దేవతా సూచన జన్మ చార్ట్ నుండి గ్రహ బలం, లగ్నాధిపతి, చంద్ర రాశి అధిపతి మరియు ఆత్మకారక ఆధారంగా ఉంటుంది.",
    "For calmness, emotional balance, and softness.": "ప్రశాంతత, భావోద్వేగ సమతుల్యత మరియు మృదుత్వం కోసం.",
    "For courage, protection, and discipline.": "ధైర్యం, రక్షణ మరియు క్రమశిక్షణ కోసం.",
    "For intellect, speech, learning, and obstacle removal.": "తెలివి, వాక్కు, అభ్యాసం మరియు అడ్డంకుల తొలగింపు కోసం.",
    "For knowledge, guidance, dharma, and blessings.": "జ్ఞానం, మార్గదర్శకత్వం, ధర్మం మరియు ఆశీర్వాదం కోసం.",
    "Mahalakshmi Ji": "మహాలక్ష్మి జీ",
    "For harmony, beauty, comfort, and prosperity.": "సామరస్యం, అందం, సౌలభ్యం మరియు శ్రేయస్సు కోసం.",
    "For karma, patience, discipline, and protection.": "కర్మ, సహనం, క్రమశిక్షణ మరియు రక్షణ కోసం.",
    "For protection from confusion, fear, and illusion.": "గందరగోళం, భయం మరియు భ్రాంతి నుండి రక్షణ కోసం.",
    "Lord Ganesha": "గణేశుడు",
    "For spiritual clarity, detachment, and obstacle removal.": "ఆధ్యాత్మిక స్పష్టత, నిర్లిప్తత మరియు అడ్డంకి తొలగింపు కోసం.",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "చక్ర అంతర్దృష్టి కోసం చార్ట్ డేటా అవసరం.",
    "Unable to load Chakra insight.": "చక్ర అంతర్దృష్టిని లోడ్ చేయడం సాధ్యపడలేదు.",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "యః కేవలం జన్మ కుండలి ఆధారిత ఆధ్యాత్మిక శక్తి అంతర్దృష్టి మరియు స్వీయ ప్రతిబింబం ఉంది. ఇహ ప్రొఫెషనల్ సలహా లేదు.",
    "Spiritual energy insights from Kundli": "కుండ్లి నుండి ఆధ్యాత్మిక శక్తి అంతర్దృష్టులు",
    "Calculated from your individual birth chart": "మీ వ్యక్తిగత బర్త్ చార్ట్ నుండి గణించబడింది",
    "Chakra Balance": "చక్ర బ్యాలెన్స్",
    "Panch Tatva Balance": "పంచ తత్వ సంతులనం",
    "Ishta Devata": "ఇష్ట దేవతా",
    "Signal planet": "సిగ్నల్ గ్రహం",
    "Very Good": "చాలా బాగుంది",
    "Very Bad": "చాలా చెడ్డది",
    "Panch Pakshi Calculator - Kundlistar": "పంచ పక్షి కాలిక్యులేటర్ - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "చార్ట్ నుండి పంచ పక్షిని ముందుగా పూరించలేకపోయింది. మీరు ఇప్పటికీ మాన్యువల్‌గా లెక్కించవచ్చు.",
    "Could not load sunrise and sunset from Panchang for this chart location.": "ఈ చార్ట్ స్థానం కోసం పంచాంగ్ నుండి సూర్యోదయం మరియు సూర్యాస్తమయాన్ని లోడ్ చేయడం సాధ్యపడలేదు.",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "పంచాంగ్ నుండి సూర్యోదయం, సూర్యాస్తమయం మరియు తదుపరి సూర్యోదయాన్ని లోడ్ చేయడం సాధ్యపడలేదు.",
    "Panch Pakshi calculation failed.": "పంచ పక్షి గణన విఫలమైంది.",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "పంచ పక్షి పక్షి, కార్యాచరణ, యమం, అపహార కాలం, సంబంధం, స్కోర్ మరియు ఫలితాన్ని లెక్కించండి.",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "మీ ఉచిత ప్రీమియం క్రెడిట్‌లు పూర్తయ్యాయి. కొనసాగించడానికి Premiumకి అప్‌గ్రేడ్ చేయండి.",
    "This is a premium feature. You can use 1 free premium credit to continue.": "ఇది ప్రీమియం ఫీచర్. మీరు కొనసాగించడానికి 1 ఉచిత ప్రీమియం క్రెడిట్‌ని ఉపయోగించవచ్చు.",
    "Selected Date": "ఎంచుకున్న తేదీ",
    "repeat(3, 1fr)": "పునరావృతం (3, 1fr)",
    "Birth Paksha": "జన్మ పక్షం",
    "Current Paksha": "ప్రస్తుత పక్షం",
    "repeat(4, 1fr)": "పునరావృతం (4, 1fr)",
    "Target Date Time": "లక్ష్య తేదీ సమయం",
    "Next Sunrise": "తదుపరి సూర్యోదయం",
    "Calculate Panch Pakshi": "పంచ పక్షిని లెక్కించండి",
    "repeat(2, 1fr)": "పునరావృతం (2, 1fr)",
    "repeat(6, 1fr)": "పునరావృతం (6, 1fr)",
    "Birth Pakshi": "జన్మ పక్షి",
    "Current Period": "ప్రస్తుత కాలం",
    "Current Yamam": "ప్రస్తుత యమం",
    "Main Activity": "ప్రధాన కార్యాచరణ",
    "Natal Western Chart": "నాటల్ వెస్ట్రన్ చార్ట్",
    "Life Phase Progression": "జీవిత దశ పురోగతి",
    "Self-focus, identity change, body awareness and personal reset.": "స్వీయ దృష్టి, గుర్తింపు మార్పు, శరీర అవగాహన మరియు వ్యక్తిగత రీసెట్.",
    "Money, values, family, speech and security become emotionally important.": "డబ్బు, విలువలు, కుటుంబం, మాటలు మరియు భద్రత మానసికంగా ముఖ్యమైనవి.",
    "Communication, learning, siblings, writing and short travel become important.": "కమ్యూనికేషన్, నేర్చుకోవడం, తోబుట్టువులు, రచన మరియు చిన్న ప్రయాణాలు ముఖ్యమైనవి.",
    "Home, mother, property, family and emotional roots become important.": "ఇల్లు, తల్లి, ఆస్తి, కుటుంబం మరియు భావోద్వేగ మూలాలు ముఖ్యమైనవి.",
    "Creativity, romance, children, hobbies and self-expression become important.": "సృజనాత్మకత, శృంగారం, పిల్లలు, అభిరుచులు మరియు స్వీయ వ్యక్తీకరణ ముఖ్యమైనవి.",
    "Work routine, health habits, service and discipline become important.": "పని దినచర్య, ఆరోగ్య అలవాట్లు, సేవ మరియు క్రమశిక్షణ ముఖ్యమైనవి.",
    "Relationship, marriage, partnership and public dealing become important.": "సంబంధం, వివాహం, భాగస్వామ్యం మరియు పబ్లిక్ డీలింగ్ ముఖ్యమైనవి.",
    "Deep emotional change, intimacy, shared money and transformation become important.": "లోతైన భావోద్వేగ మార్పు, సాన్నిహిత్యం, భాగస్వామ్య డబ్బు మరియు పరివర్తన ముఖ్యమైనవి.",
    "Learning, travel, teaching, belief and higher wisdom become important.": "నేర్చుకోవడం, ప్రయాణం, బోధన, నమ్మకం మరియు ఉన్నత జ్ఞానం ముఖ్యమైనవి.",
    "Career, status, public image and responsibility become emotionally important.": "కెరీర్, హోదా, పబ్లిక్ ఇమేజ్ మరియు బాధ్యత మానసికంగా ముఖ్యమైనవి.",
    "Income, friends, networking, community and ambitions become important.": "ఆదాయం, స్నేహితులు, నెట్‌వర్కింగ్, సంఘం మరియు ఆశయాలు ముఖ్యమైనవి.",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "విశ్రాంతి, ఒంటరితనం, ఆధ్యాత్మికత, విదేశీ సంబంధం మరియు అంతర్గత వైద్యం ముఖ్యమైనవి.",
    "Identity development and self-expression are central.": "గుర్తింపు అభివృద్ధి మరియు స్వీయ వ్యక్తీకరణ ప్రధానమైనవి.",
    "Values, money and self-worth become central.": "విలువలు, డబ్బు మరియు స్వీయ-విలువ ప్రధానమైనవి.",
    "Communication, learning and skills become central.": "కమ్యూనికేషన్, లెర్నింగ్ మరియు స్కిల్స్ ప్రధానమైనవి.",
    "Home, roots and emotional foundation become central.": "ఇల్లు, మూలాలు మరియు భావోద్వేగ పునాది కేంద్రంగా మారతాయి.",
    "Creativity, love and self-expression become central.": "సృజనాత్మకత, ప్రేమ మరియు స్వీయ-వ్యక్తీకరణ ప్రధానమైనవి.",
    "Work, discipline and health routines become central.": "పని, క్రమశిక్షణ మరియు ఆరోగ్య దినచర్యలు ప్రధానమైనవి.",
    "Partnerships and relationship identity become central.": "భాగస్వామ్యాలు మరియు సంబంధాల గుర్తింపు కేంద్రంగా మారతాయి.",
    "Transformation, deep healing and shared resources become central.": "పరివర్తన, లోతైన వైద్యం మరియు భాగస్వామ్య వనరులు కేంద్రంగా మారాయి.",
    "Wisdom, travel, belief and higher learning become central.": "జ్ఞానం, ప్రయాణం, నమ్మకం మరియు ఉన్నత విద్య ప్రధానమైనవి.",
    "Career, authority and public role become central.": "వృత్తి, అధికారం మరియు ప్రజా పాత్ర ప్రధానమైనవి.",
    "Community, income, goals and networks become central.": "సంఘం, ఆదాయం, లక్ష్యాలు మరియు నెట్‌వర్క్‌లు కేంద్రంగా మారతాయి.",
    "Spirituality, closure, retreat and inner development become central.": "ఆధ్యాత్మికత, మూసివేత, తిరోగమనం మరియు అంతర్గత అభివృద్ధి ప్రధానమైనవి.",
    "This house becomes emotionally important.": "ఈ ఇల్లు మానసికంగా ముఖ్యమైనదిగా మారుతుంది.",
    "This house becomes central for identity development.": "ఈ ఇల్లు గుర్తింపు అభివృద్ధికి కేంద్రంగా మారుతుంది.",
    "Thinking, communication, learning and decisions are developing through this house.": "ఈ ఇంటి ద్వారా ఆలోచన, కమ్యూనికేషన్, అభ్యాసం మరియు నిర్ణయాలు అభివృద్ధి చెందుతాయి.",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "ఈ ఇంటి ద్వారా ప్రేమ, సౌఖ్యం, విలువలు, అందం మరియు డబ్బు ప్రాధాన్యతలు అభివృద్ధి చెందుతాయి.",
    "Action style, courage, ambition and drive are developing through this house.": "ఈ ఇంటి ద్వారా యాక్షన్ స్టైల్, ధైర్యం, ఆశయం మరియు డ్రైవ్ అభివృద్ధి చెందుతాయి.",
    "Growth, faith, learning and expansion themes develop through this house.": "ఈ ఇంటి ద్వారా వృద్ధి, విశ్వాసం, అభ్యాసం మరియు విస్తరణ థీమ్‌లు అభివృద్ధి చెందుతాయి.",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "పరిపక్వత, బాధ్యత, క్రమశిక్షణ మరియు దీర్ఘకాలిక నిర్మాణం ఈ ఇంటి ద్వారా అభివృద్ధి చెందుతాయి.",
    "This progressed planet shows an inner life phase through this house.": "ఈ అభివృద్ధి చెందిన గ్రహం ఈ ఇంటి ద్వారా అంతర్గత జీవిత దశను చూపుతుంది.",
    "New Moon Phase": "అమావాస్య దశ",
    "New beginning, identity reset and fresh internal cycle.": "కొత్త ప్రారంభం, గుర్తింపు రీసెట్ మరియు తాజా అంతర్గత చక్రం.",
    "Crescent Phase": "నెలవంక దశ",
    "Growth, effort, learning and building confidence.": "ఎదుగుదల, కృషి, నేర్చుకోవడం మరియు విశ్వాసాన్ని పెంపొందించడం.",
    "First Quarter Phase": "మొదటి త్రైమాసిక దశ",
    "Action, decision-making, pressure and development.": "చర్య, నిర్ణయం తీసుకోవడం, ఒత్తిడి మరియు అభివృద్ధి.",
    "Gibbous Phase": "గిబ్బస్ దశ",
    "Refinement, improvement, preparation and skill-building.": "శుద్ధీకరణ, మెరుగుదల, తయారీ మరియు నైపుణ్యం-నిర్మాణం.",
    "Full Moon Phase": "పౌర్ణమి దశ",
    "Visibility, relationship awareness, emotional clarity and results.": "దృశ్యమానత, సంబంధాల అవగాహన, భావోద్వేగ స్పష్టత మరియు ఫలితాలు.",
    "Disseminating Phase": "వ్యాప్తి దశ",
    "Sharing, teaching, communication and distributing experience.": "అనుభవాన్ని పంచుకోవడం, బోధించడం, కమ్యూనికేషన్ మరియు పంపిణీ చేయడం.",
    "Last Quarter Phase": "చివరి త్రైమాసిక దశ",
    "Reorientation, correction, release and mature decision-making.": "రీఓరియెంటేషన్, దిద్దుబాటు, విడుదల మరియు పరిణతి చెందిన నిర్ణయం తీసుకోవడం.",
    "Balsamic Phase": "బాల్సమిక్ దశ",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "మూసివేత, ఆధ్యాత్మిక ప్రతిబింబం, విశ్రాంతి మరియు కొత్త చక్రం కోసం తయారీ.",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "ఒక ప్రధాన భావోద్వేగ మరియు గుర్తింపు దశ ప్రారంభమవుతుంది. వ్యక్తి కొత్త అధ్యాయానికి సిద్ధంగా ఉన్నట్లు భావించవచ్చు.",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "భావోద్వేగ రీసెట్ కాలం. కుటుంబం, సౌకర్యం, అంతర్గత శాంతి మరియు భావోద్వేగ అవసరాలు ముఖ్యమైనవి.",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "ప్రేమ, సంబంధం, సౌకర్యం, అందం మరియు భావోద్వేగ బంధం ముఖ్యమైనవి.",
    "Emotional needs and relationship expectations may need adjustment.": "భావోద్వేగ అవసరాలు మరియు సంబంధాల అంచనాలకు సర్దుబాటు అవసరం కావచ్చు.",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "శక్తి, అభిరుచి, అసహనం మరియు చర్య పెరుగుతాయి. భావోద్వేగ ప్రతిచర్యలు త్వరగా మారవచ్చు.",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "భావోద్వేగ అశాంతి, కోపం, సంఘర్షణ లేదా అత్యవసర చర్య పెరుగుతుంది.",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "తీవ్రమైన భావోద్వేగ దశ. బాధ్యత, పరిపక్వత, కుటుంబ ఒత్తిడి లేదా అంతర్గత క్రమశిక్షణ పెరగవచ్చు.",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "భావోద్వేగ భారం లేదా బాధ్యతను అనుభవించవచ్చు. సహనం మరియు పరిపక్వత అవసరం.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "సహాయక భావోద్వేగ పెరుగుదల, ఆశావాదం, ప్రయాణం, అభ్యాసం మరియు ఆశీర్వాదాలు పెరుగుతాయి.",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "వృద్ధి-ఆధారిత భావోద్వేగ దశ. నేర్చుకోవడం, విస్తరణ, మద్దతు మరియు సానుకూల నిర్ణయాలకు మంచిది.",
    "Identity, love, beauty, money values and creative expression become highlighted.": "గుర్తింపు, ప్రేమ, అందం, డబ్బు విలువలు మరియు సృజనాత్మక వ్యక్తీకరణలు హైలైట్ అవుతాయి.",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "విశ్వాసం, ధైర్యం, ఆశయం మరియు చర్య పెరుగుతాయి. కొత్త క్రియాశీల దశను ప్రారంభించడం మంచిది.",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "పరిపక్వత పరీక్ష. బాధ్యత, ఆలస్యం, ఒత్తిడి లేదా కెరీర్ పునర్నిర్మాణం సంభవించవచ్చు.",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "ఎదుగుదల, విశ్వాసం, జ్ఞానం, గుర్తింపు మరియు అవకాశం పెరుగుతుంది.",
    "Mental clarity, communication, study, writing and business decisions become important.": "మానసిక స్పష్టత, కమ్యూనికేషన్, అధ్యయనం, రచన మరియు వ్యాపార నిర్ణయాలు ముఖ్యమైనవి.",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "కొత్త మానసిక చక్రం ప్రారంభమవుతుంది. నేర్చుకోవడం, కమ్యూనికేషన్, రాయడం మరియు నైపుణ్యం అభివృద్ధికి మంచిది.",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "ప్రేమ, అందం, సౌకర్యం, సామాజిక జీవితం మరియు విలువలు గుర్తింపుతో బలంగా అనుసంధానించబడతాయి.",
    "Action, confidence, ambition and personal drive become stronger.": "చర్య, విశ్వాసం, ఆశయం మరియు వ్యక్తిగత డ్రైవ్ బలంగా మారతాయి.",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "మెర్క్యురీ నేర్చుకోవడం, కమ్యూనికేషన్, వ్యాపారం, రాయడం, మార్కెటింగ్, కోడింగ్ లేదా విశ్లేషణాత్మక పనికి మద్దతు ఇస్తుంది.",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "పురోగతి చెందిన మార్స్ చర్య, ధైర్యం, పోటీ, సాంకేతిక పని మరియు క్రియాశీల కెరీర్ నిర్ణయాలకు మద్దతు ఇస్తుంది.",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "పురోగమించిన వీనస్ ఆర్థిక విలువలు, సౌలభ్యం, లాభాలు, లగ్జరీ, కళ లేదా సంబంధాల ఆధారిత ఆదాయ థీమ్‌లకు మద్దతు ఇస్తుంది.",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "పురోగమించిన బృహస్పతి వృద్ధి-ఆధారిత ఆర్థిక ఆలోచన మరియు వనరుల విస్తరణను చూపగలదు.",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "వృత్తి దశను పురోగమించిన సూర్యుడు, చంద్రుడు, బుధుడు, అంగారక గ్రహం మరియు జన్మ సూర్యుడు, శని మరియు మధ్యాకాశం వరకు అంచనా వేయాలి.",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "ప్రేమ దశను పురోగమించిన చంద్రుడు, శుక్రుడు, కుజుడు మరియు జన్మ చంద్రుడు, శుక్రుడు, అంగారకుడు మరియు 7వ ఇంటికి సంబంధించిన అంశాల నుండి అంచనా వేయాలి.",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "పురోగమించిన చంద్రుడు, శుక్రుడు, బృహస్పతి మరియు జన్మ 2వ, 8వ మరియు 11వ గృహాల కనెక్షన్ల నుండి డబ్బు దశను అంచనా వేయాలి.",
    "Western Astrology - Kundlistar": "పాశ్చాత్య జ్యోతిష్యం - Kundlistar",
    "No chart data available for preview": "ప్రివ్యూ కోసం చార్ట్ డేటా అందుబాటులో లేదు",
    "Failed to load chart": "చార్ట్‌ను లోడ్ చేయడంలో విఫలమైంది",
    "Chart not found": "చార్ట్ కనుగొనబడలేదు",
    "Western Astrology Module | Kundlistar": "పాశ్చాత్య జ్యోతిష్య మాడ్యూల్ | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "నాటల్ చార్ట్ స్థానాలు, ప్లాసిడస్ హౌస్ కస్ప్స్, బాహ్య గ్రహాలు మరియు ప్రీమియం ట్రాన్సిట్‌లు, సోలార్ రిటర్న్ మరియు సినాస్ట్రీ లక్షణాలతో Kundlistar లోపల పాశ్చాత్య జ్యోతిష్యాన్ని అన్వేషించండి.",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "పాశ్చాత్య జ్యోతిష్యం, జన్మ చార్ట్, ట్రాన్సిట్‌లు, సోలార్ రిటర్న్, సినాస్ట్రీ, Kundlistar",
    "New section": "కొత్త విభాగం",
    "Premium active": "ప్రీమియం సక్రియంగా ఉంది",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "గృహ వ్యవస్థ",
    "Placidus cusps": "ప్లాసిడస్ కస్ప్స్",
    "Part of Fortune": "ఫార్చ్యూన్‌లో భాగం",
    "Natal Western Aspects": "నాటల్ వెస్ట్రన్ కోణాలు",
    "No major Western aspects found within the configured orbs.": "కాన్ఫిగర్ చేయబడిన ఆర్బ్స్‌లో ప్రధాన పాశ్చాత్య అంశాలు ఏవీ కనుగొనబడలేదు.",
    "Western natal astrology wheel": "పాశ్చాత్య జన్మ జ్యోతిష్య చక్రం",
    "Western Transits": "పశ్చిమ రవాణా",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "లోడ్ చేయబడిన చార్ట్ జన్మస్థలాన్ని ఉపయోగించి ప్రస్తుత ట్రాన్సిట్-టు-నేటల్ లెక్కలు.",
    "Natal points available": "నాటల్ పాయింట్లు అందుబాటులో ఉన్నాయి",
    "Transit planets loaded": "రవాణా గ్రహాలు లోడ్ చేయబడ్డాయి",
    "Loading current transit positions...": "ప్రస్తుత రవాణా స్థానాలను లోడ్ చేస్తోంది...",
    "Aspect method": "కారక పద్ధతి",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "వెస్ట్రన్ ఆర్బ్స్‌తో సంయోగం, సెక్స్‌టైల్, స్క్వేర్, త్రిభుజం మరియు వ్యతిరేకత",
    "Primary focus": "ప్రాథమిక దృష్టి",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "జన్మ సూర్యుడు, చంద్రుడు, లగ్నము, శుక్రుడు, అంగారకుడు, బృహస్పతి, శని మరియు బాహ్య గ్రహాలకు రవాణా పరిచయాలు",
    "Natal inner wheel": "నాటల్ లోపలి చక్రం",
    "Transit outer wheel": "రవాణా బాహ్య చక్రం",
    "Current Transit Positions": "ప్రస్తుత రవాణా స్థానాలు",
    "Transit positions are not available.": "రవాణా స్థానాలు అందుబాటులో లేవు.",
    "Current Transit Aspects to Natal Chart": "నాటల్ చార్ట్‌కు ప్రస్తుత రవాణా అంశాలు",
    "Loading transit aspects...": "రవాణా అంశాలను లోడ్ చేస్తోంది...",
    "No major transit aspects found within the configured orbs.": "కాన్ఫిగర్ చేయబడిన ఆర్బ్స్‌లో ప్రధాన రవాణా అంశాలు ఏవీ కనుగొనబడలేదు.",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "పుట్టిన సూర్యుని నుండి వార్షిక వెస్ట్రన్ రిటర్న్ రిఫరెన్స్, సపోర్టింగ్ నేటల్ యాస్పెక్ట్ కాంటెక్స్ట్.",
    "Solar return date": "సౌర వాపసు తేదీ",
    "Calculation time": "గణన సమయం",
    "Birth date not available": "పుట్టిన తేదీ అందుబాటులో లేదు",
    "Natal Sun": "నాటల్ సన్",
    "Natal Sun house": "నాటల్ సన్ హౌస్",
    "Return planets loaded": "తిరిగి గ్రహాలు లోడ్ చేయబడ్డాయి",
    "Loading solar return chart...": "సోలార్ రిటర్న్ చార్ట్ లోడ్ అవుతోంది...",
    "Annual focus": "వార్షిక దృష్టి",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "సోలార్ థీమ్‌లు పుట్టిన సూర్యుడు, రిటర్న్ అసెండెంట్ మరియు వార్షిక రిటర్న్ చార్ట్ నుండి చదవబడతాయి.",
    "Solar Return Planet Positions": "సోలార్ రిటర్న్ ప్లానెట్ పొజిషన్స్",
    "Loading solar return planets...": "సౌర తిరిగి వచ్చే గ్రహాలను లోడ్ చేస్తోంది...",
    "Solar return positions are not available.": "సోలార్ రిటర్న్ స్థానాలు అందుబాటులో లేవు.",
    "Solar Return House Cusps": "సోలార్ రిటర్న్ హౌస్ కస్ప్స్",
    "Loading solar return cusps...": "సోలార్ రిటర్న్ కస్ప్స్ లోడ్ అవుతోంది...",
    "Solar return house cusps are not available.": "సోలార్ రిటర్న్ హౌస్ కస్ప్స్ అందుబాటులో లేవు.",
    "Solar Return Aspects to Natal Chart": "నాటల్ చార్ట్‌కు సోలార్ రిటర్న్ అంశాలు",
    "Loading solar return aspects...": "సోలార్ రిటర్న్ అంశాలను లోడ్ చేస్తోంది...",
    "No major solar return aspects found within the configured orbs.": "కాన్ఫిగర్ చేయబడిన ఆర్బ్స్‌లో ప్రధాన సౌర రిటర్న్ అంశాలు ఏవీ కనుగొనబడలేదు.",
    "Natal Sun Aspects for Solar Return Focus": "సోలార్ రిటర్న్ ఫోకస్ కోసం నాటల్ సన్ కోణాలు",
    "No major natal Sun aspects found within the configured orbs.": "కాన్ఫిగర్ చేయబడిన ఆర్బ్స్‌లో ప్రధాన జన్మ సూర్య కోణాలు ఏవీ కనుగొనబడలేదు.",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "ప్లానెట్-టు-ప్లానెట్ అంశాలు, యాంగిల్ కాంటాక్ట్‌లు మరియు హౌస్ ఓవర్‌లేలను ఉపయోగించి రిలేషన్ షిప్ ఓవర్‌లే ఫ్రేమ్‌వర్క్.",
    "Loaded first chart": "మొదటి చార్ట్ లోడ్ చేయబడింది",
    "Second chart": "రెండవ చార్ట్",
    "Select or load partner chart to calculate full synastry overlay": "పూర్తి సినాస్ట్రీ ఓవర్‌లేను లెక్కించడానికి భాగస్వామి చార్ట్‌ను ఎంచుకోండి లేదా లోడ్ చేయండి",
    "Major inter-chart aspects with tight orb priority": "టైట్ ఆర్బ్ ప్రాధాన్యతతో ప్రధాన ఇంటర్-చార్ట్ అంశాలు",
    "House overlay method": "హౌస్ ఓవర్లే పద్ధతి",
    "Partner planets are placed into the first chart houses after second chart is selected": "రెండవ చార్ట్ ఎంచుకున్న తర్వాత భాగస్వామి గ్రహాలు మొదటి చార్ట్ హౌస్‌లలో ఉంచబడతాయి",
    "Relationship Pattern Aspects from Loaded Chart": "లోడ్ చేయబడిన చార్ట్ నుండి సంబంధాల నమూనా అంశాలు",
    "No major relationship-focused natal aspects found within the configured orbs.": "కాన్ఫిగర్ చేయబడిన ఆర్బ్స్‌లో ప్రధాన సంబంధం-కేంద్రీకృత జన్మసంబంధ అంశాలు ఏవీ కనుగొనబడలేదు.",
    "Understand your current inner life phase through Western Secondary Progressions.": "వెస్ట్రన్ సెకండరీ ప్రోగ్రెషన్స్ ద్వారా మీ ప్రస్తుత అంతర్గత జీవిత దశను అర్థం చేసుకోండి.",
    "Secondary Progression": "సెకండరీ ప్రోగ్రెషన్",
    "1 day after birth = 1 year of life": "పుట్టిన 1 రోజు = 1 సంవత్సరం జీవితం",
    "Current age used": "ఉపయోగించిన ప్రస్తుత వయస్సు",
    "Progressed date": "పురోగమించిన తేదీ",
    "Progressed Moon": "పురోగమించిన చంద్రుడు",
    "Loading progressed Moon...": "చంద్రుని లోడ్ అవుతోంది...",
    "Progressed Moon phase": "పురోగమించిన చంద్ర దశ",
    "Loading Moon phase...": "చంద్ర దశ లోడ్ అవుతోంది...",
    "Current Life Phase": "ప్రస్తుత జీవిత దశ",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "ద్వితీయ పురోగమనాలు జీవితంలోని అంతర్గత దశ, భావోద్వేగ పరిపక్వత, గుర్తింపు అభివృద్ధి మరియు మారుతున్న ప్రాధాన్యతలను చూపుతాయి.",
    "Progressed Career Phase": "పురోగమించిన కెరీర్ దశ",
    "Progressed Love Phase": "అభివృద్ధి చెందిన ప్రేమ దశ",
    "Progressed Money Phase": "ప్రోగ్రెస్డ్ మనీ ఫేజ్",
    "Loading progressed planets...": "అభివృద్ధి చెందిన గ్రహాలను లోడ్ చేస్తోంది...",
    "Progressed planets are not available.": "పురోగమించిన గ్రహాలు అందుబాటులో లేవు.",
    "Loading progressed aspects...": "అభివృద్ధి చెందిన అంశాలను లోడ్ చేస్తోంది...",
    "No tight progressed-to-natal aspects found right now.": "ప్రస్తుతం ఎటువంటి గట్టి పురోగతి-ప్రసవ అంశాలు కనుగొనబడలేదు.",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "ఈ దశను పురోగమించిన గ్రహాలు, పురోగమించిన చంద్ర దశ మరియు గట్టి పురోగమించిన-నాటల్ అంశాల నుండి అంచనా వేయాలి.",
    "Vastu Analysis - Kundlistar": "వాస్తు విశ్లేషణ - Kundlistar",
    "Failed to load selected chart.": "ఎంచుకున్న చార్ట్‌ను లోడ్ చేయడంలో విఫలమైంది.",
    "Facing Direction": "ఫేసింగ్ డైరెక్షన్",
    "Entrance Direction": "ప్రవేశ దిశ",
    "Kitchen Direction": "వంటగది దిశ",
    "Master Bedroom": "మాస్టర్ బెడ్ రూమ్",
    "Children Bedroom": "పిల్లల బెడ్ రూమ్",
    "Toilet Direction": "టాయిలెట్ దిశ",
    "Pooja Direction": "పూజా దర్శకత్వం",
    "Water Tank": "వాటర్ ట్యాంక్",
    "Underground Water": "భూగర్భ జలం",
    "Heavy Storage": "భారీ నిల్వ",
    "Living Room": "లివింగ్ రూమ్",
    "Study Room": "స్టడీ రూమ్",
    "Vastu report generation failed.": "వాస్తు నివేదిక రూపొందించడం విఫలమైంది.",
    "Please generate the Vastu report before downloading.": "దయచేసి డౌన్‌లోడ్ చేయడానికి ముందు వాస్తు నివేదికను రూపొందించండి.",
    "Failed to download Vastu report.": "వాస్తు నివేదికను డౌన్‌లోడ్ చేయడంలో విఫలమైంది.",
    "Premium Feature": "ప్రీమియం ఫీచర్",
    "Selected Chart": "ఎంచుకున్న చార్ట్",
    "Basic + KP + BNN from chart": "చార్ట్ నుండి ప్రాథమిక + KP + BNN",
    "Basic shown, KP + BNN locked": "ప్రాథమికంగా చూపబడింది, KP + BNN లాక్ చేయబడింది",
    "Property Type": "ఆస్తి రకం",
    "Center Area": "సెంటర్ ఏరియా",
    "Generate Vastu Report": "వాస్తు నివేదికను రూపొందించండి",
    "Basic Vastu Analysis": "ప్రాథమిక వాస్తు విశ్లేషణ",
    "KP Vastu Analysis": "KP వాస్తు విశ్లేషణ",
    "BNN Vastu Analysis": "BNN వాస్తు విశ్లేషణ",
    "North East": "ఈశాన్య",
    "South East": "సౌత్ ఈస్ట్",
    "South West": "నైరుతి",
    "North West": "నార్త్ వెస్ట్",
    "Red Coral": "రెడ్ కోరల్",
    "Yellow Sapphire": "పసుపు నీలమణి",
    "Blue Sapphire": "బ్లూ నీలమణి",
    "Cat's Eye": "పిల్లి కన్ను",
    "Additional Option": "అదనపు ఎంపిక",
    "Lagna rule supports this gemstone option.": "లగ్న నియమం ఈ రత్న ఎంపికకు మద్దతు ఇస్తుంది.",
    "Moon sign rule supports this gemstone option.": "మూన్ సైన్ రూల్ ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Birth date rule supports this gemstone option.": "పుట్టిన తేదీ నియమం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Birth weekday rule supports this gemstone option.": "పుట్టిన వారం రోజుల నియమం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Current dasha rule supports this gemstone option.": "ప్రస్తుత దశ నియమం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Age-band rule supports this gemstone option.": "ఏజ్-బ్యాండ్ నియమం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Selected goal supports this gemstone option.": "ఎంచుకున్న లక్ష్యం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Profession rule supports this gemstone option.": "వృత్తి నియమం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Name-initial rule supports this gemstone option.": "పేరు-ప్రారంభ నియమం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Moolank rule supports this gemstone option.": "మూలాంక్ నియమం ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Chart condition check was considered for this option.": "ఈ ఎంపిక కోసం చార్ట్ కండిషన్ చెక్ పరిగణించబడింది.",
    "Rule-based chart match supports this gemstone option.": "నియమ-ఆధారిత చార్ట్ మ్యాచ్ ఈ రత్నం ఎంపికకు మద్దతు ఇస్తుంది.",
    "Expert kundli review is recommended before wearing this gemstone.": "ఈ రత్నాన్ని ధరించే ముందు నిపుణుల కుండలి సమీక్ష సిఫార్సు చేయబడింది.",
    "Ring finger": "ఉంగరపు వేలు",
    "Little finger": "చిన్న వేలు",
    "Index finger": "చూపుడు వేలు",
    "Middle finger": "మధ్య వేలు",
    "Why recommended": "ఎందుకు సిఫార్సు చేయబడింది",
    "Approx weight": "సుమారు బరువు",
    "Could not load chart.": "చార్ట్‌ను లోడ్ చేయడం సాధ్యపడలేదు.",
    "Gemstone Recommendations | Kundlistar": "రత్నాల సిఫార్సులు | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar యొక్క నియమ-ఆధారిత కుండలి విశ్లేషణ ఇంజిన్ నుండి వేద రత్నాల సిఫార్సులను అన్వేషించండి.",
    "noindex,nofollow": "noindex,nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "రత్నాల సిఫార్సు, వేద రత్నాలు, కుండలి రత్నం, Kundlistar",
    "Gemstone Recommendations": "రత్నాల సిఫార్సులు",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "లగ్న, చంద్ర రాశి, దశ, DOB, వృత్తి మరియు లక్ష్యాల ఆధారంగా వేద రత్న మార్గదర్శకత్వం కోసం Kundlistar మాడ్యూల్‌ను వేరు చేయండి.",
    "Personalized Gemstone Recommendations are available for Premium users.": "ప్రీమియం వినియోగదారుల కోసం వ్యక్తిగతీకరించిన రత్నం సిఫార్సులు అందుబాటులో ఉన్నాయి.",
    "Upgrade to Premium": "ప్రీమియంకు అప్‌గ్రేడ్ చేయండి",
    "Login to Upgrade": "అప్‌గ్రేడ్ చేయడానికి లాగిన్ చేయండి",
    "Select Goal": "లక్ష్యాన్ని ఎంచుకోండి",
    "Business, government job, teacher...": "వ్యాపారం, ప్రభుత్వ ఉద్యోగం, ఉపాధ్యాయుడు...",
    "Weight kg": "బరువు కేజీ",
    "वजन kg": "వజన్ కేజీ",
    "Optional ratti estimate": "ఐచ్ఛిక రట్టి అంచనా",
    "Click Calculate to apply these values.": "ఈ విలువలను వర్తింపజేయడానికి లెక్కించు క్లిక్ చేయండి.",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi ?",
    "Nadi Analysis": "నాడి విశ్లేషణ",
    "KP Analysis": "KP విశ్లేషణ",
    "Vedic Analysis": "వేద విశ్లేషణ",
    "BNN Analysis": "BNN విశ్లేషణ",
    "Jaimini Analysis": "జైమిని విశ్లేషణ",
    "Western Astrology": "పాశ్చాత్య జ్యోతిష్యం",
    "Panch Pakshi": "పంచ పక్షి",
    "Tithi Pravesh": "తిథి ప్రవేశం",
    "Lal Kitab": "లాల్ కితాబ్",
    "Astro Logo": "ఆస్ట్రో లోగో",
    "Download failed": "డౌన్‌లోడ్ విఫలమైంది",
    "Could not download PDF report.": "PDF నివేదికను డౌన్‌లోడ్ చేయడం సాధ్యపడలేదు.",
    "Please login to download PDF reports.": "దయచేసి PDF నివేదికలను డౌన్‌లోడ్ చేయడానికి లాగిన్ చేయండి.",
    "Failed to generate personalised report": "వ్యక్తిగతీకరించిన నివేదికను రూపొందించడంలో విఫలమైంది",
    "Could not download personalised report.": "వ్యక్తిగతీకరించిన నివేదికను డౌన్‌లోడ్ చేయడం సాధ్యపడలేదు.",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--కుండలిస్టార్-నవబార్-ఎత్తు, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(--kundlistar-navbar-height, 160px))",
    "width 0.2s ease": "వెడల్పు 0.2సె సౌలభ్యం",
    "Collapse sidebar": "సైడ్‌బార్‌ను కుదించు",
    "Expand sidebar": "సైడ్‌బార్‌ని విస్తరించండి",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-root",
    "Download PDF Report": "PDF నివేదికను డౌన్‌లోడ్ చేయండి",
    "Login to download": "డౌన్‌లోడ్ చేయడానికి లాగిన్ చేయండి",
    "PDF Report": "PDF నివేదిక",
    "Download Personal Report": "వ్యక్తిగత నివేదికను డౌన్‌లోడ్ చేయండి",
    "Buy Premium to download": "డౌన్‌లోడ్ చేయడానికి ప్రీమియం కొనండి",
    "Login to buy Premium": "ప్రీమియం కొనుగోలు చేయడానికి లాగిన్ చేయండి",
    "Buy Premium": "ప్రీమియం కొనండి",
    "& .MuiTab-root": "& .MuiTab-రూట్",
    "& .Mui-selected": "& .Mui-ఎంచుకున్నారు",
    "Unable to load Client Management data.": "క్లయింట్ మేనేజ్‌మెంట్ డేటాను లోడ్ చేయడం సాధ్యపడలేదు.",
    "Unable to download PDF.": "PDFని డౌన్‌లోడ్ చేయడం సాధ్యపడలేదు.",
    "Free client limit reached": "ఉచిత క్లయింట్ పరిమితిని చేరుకున్నారు",
    "Welcome": "స్వాగతం",
    "Hello": "నమస్కారం",
    "Your saved charts are shown below.": "మీరు సేవ్ చేసిన చార్ట్‌లు క్రింద చూపబడ్డాయి.",
    "All Features": "అన్ని ఫీచర్లు",
    "New Chart": "కొత్త చార్ట్",
    "Vedic Chart": "వేద చార్ట్",
    "Chakra": "చక్రం",
    "Daily Panchang": "రోజువారీ పంచాంగ్",
    "Choghadiya": "చోఘడియా",
    "Daily Horoscope": "రోజువారీ జాతకం",
    "Gochar Alerts": "గోచార్ హెచ్చరికలు",
    "Matching": "సరిపోలిక",
    "Ruling Planets": "పాలించే గ్రహాలు",
    "Horary Chart": "హారరీ చార్ట్",
    "Astro-Vastu": "ఆస్ట్రో-వాస్తు",
    "Vedic Numerology": "వేద సంఖ్యాశాస్త్రం",
    "My Charts": "నా చార్ట్‌లు",
    "Search by Name": "పేరు ద్వారా శోధించండి",
    "Type": "టైప్ చేయండి",
    "All": "అన్నీ",
    "Individual": "వ్యక్తిగత",
    "Horary": "హారరీ",
    "Clear": "క్లియర్",
    "Name": "పేరు",
    "DOB": "DOB",
    "Place": "స్థలం",
    "Gender": "లింగం",
    "Created": "సృష్టించబడింది",
    "Actions": "చర్యలు",
    "Male": "పురుషుడు",
    "Female": "స్త్రీ",
    "No matching charts found": "సరిపోలే చార్ట్‌లు ఏవీ కనుగొనబడలేదు",
    "Create First Chart": "మొదటి చార్ట్ సృష్టించండి",
    "View Chart": "చార్ట్ చూడండి",
    "Copy Share Link": "షేర్ లింక్‌ని కాపీ చేయండి",
    "Use premium credit: Download PDF Report": "ప్రీమియం క్రెడిట్‌ని ఉపయోగించండి: PDF నివేదికను డౌన్‌లోడ్ చేయండి",
    "Download Personalised Report": "వ్యక్తిగతీకరించిన నివేదికను డౌన్‌లోడ్ చేయండి",
    "Premium: Download Personalised Report": "ప్రీమియం: వ్యక్తిగతీకరించిన నివేదికను డౌన్‌లోడ్ చేయండి",
    "Hide Chart": "చార్ట్‌ను దాచండి",
    "Personalised": "వ్యక్తిగతీకరించబడింది",
    "Generating your Personalised Report": "మీ వ్యక్తిగతీకరించిన నివేదికను రూపొందిస్తోంది",
    "Please do not leave this page till the report is generated. This can take a little while.": "నివేదిక రూపొందించబడే వరకు దయచేసి ఈ పేజీని వదిలివేయవద్దు. దీనికి కొంత సమయం పట్టవచ్చు.",
    "Please don't leave this page till the report is generated. This can take a little while.": "నివేదిక రూపొందించబడే వరకు దయచేసి ఈ పేజీని వదిలివేయవద్దు. దీనికి కొంత సమయం పట్టవచ్చు.",
    "Update": "నవీకరించు",
    "Complete your billing address. Required for generating invoice.": "మీ బిల్లింగ్ చిరునామాను పూర్తి చేయండి. ఇన్‌వాయిస్‌ని రూపొందించడానికి అవసరం.",
    "Report this report": "ఈ నివేదికను నివేదించండి",
    "Reason": "కారణం",
    "Optional comment": "ఐచ్ఛిక వ్యాఖ్య",
    "Submit": "సమర్పించండి",
    "Incorrect info": "తప్పు సమాచారం",
    "Offensive": "అప్రియమైనది",
    "Harmful": "హానికరం",
    "This report has been sent for review.": "ఈ నివేదిక సమీక్ష కోసం పంపబడింది.",
    "Failed to submit report feedback": "నివేదిక అభిప్రాయాన్ని సమర్పించడంలో విఫలమైంది",
    "Failed to download PDF": "PDFని డౌన్‌లోడ్ చేయడంలో విఫలమైంది",
    "Failed to download personalised report": "వ్యక్తిగతీకరించిన నివేదికను డౌన్‌లోడ్ చేయడంలో విఫలమైంది",
    "Failed to load charts": "చార్ట్‌లను లోడ్ చేయడంలో విఫలమైంది",
    "Failed to hide chart": "చార్ట్‌ను దాచడంలో విఫలమైంది",
    "Failed to delete chart": "చార్ట్‌ను తొలగించడంలో విఫలమైంది",
    "Share link copied to clipboard!": "షేర్ లింక్ క్లిప్‌బోర్డ్‌కి కాపీ చేయబడింది!",
    "Delete Chart": "చార్ట్‌ను తొలగించండి",
    "Delete chart": "చార్ట్‌ను తొలగించండి",
    "Error": "లోపం",
    "OK": "సరే",
    "Thanks": "ధన్యవాదాలు",
    "Report failed": "నివేదిక విఫలమైంది",
    "Could not submit report feedback.": "నివేదిక అభిప్రాయాన్ని సమర్పించడం సాధ్యపడలేదు.",
    "Personalised report ready": "వ్యక్తిగతీకరించిన నివేదిక సిద్ధంగా ఉంది",
    "Personalised report failed": "వ్యక్తిగతీకరించిన నివేదిక విఫలమైంది",
    "Could not generate personalised report.": "వ్యక్తిగతీకరించిన నివేదికను రూపొందించడం సాధ్యపడలేదు.",
    "Could not generate personalised PDF report.": "వ్యక్తిగతీకరించిన PDF నివేదికను రూపొందించడం సాధ్యపడలేదు.",
    "Monthly limit reached": "నెలవారీ పరిమితిని చేరుకున్నారు",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "మీ నెలవారీ వ్యక్తిగతీకరించిన నివేదిక పరిమితిని చేరుకున్నారు. యాడ్-ఆన్‌కి సభ్యత్వం పొందండి: 20 నివేదికల కోసం నెలకు ₹299 లేదా 40 నివేదికలకు నెలకు ₹499.",
    "Buy Add-on": "యాడ్-ఆన్‌ని కొనుగోలు చేయండి",
    "Manage": "నిర్వహించండి",
    "Add-on active: Unlimited reports": "యాడ్-ఆన్ సక్రియం: అపరిమిత నివేదికలు",
    "Add-on active: 40 reports/month": "యాడ్-ఆన్ సక్రియం: 40 నివేదికలు/నెలకు",
    "Add-on active: 20 reports/month": "యాడ్-ఆన్ సక్రియం: 20 నివేదికలు/నెలకు",
    "reports remaining this cycle": "ఈ చక్రంలో మిగిలి ఉన్న నివేదికలు",
    "Add-on active": "యాడ్-ఆన్ సక్రియంగా ఉంది",
    "Personalised reports remaining this month": "ఈ నెలలో వ్యక్తిగతీకరించిన నివేదికలు మిగిలి ఉన్నాయి",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "ప్రీమియంలో 2/నెల ఉంటుంది. యాడ్-ఆన్‌లు: నెలకు 20 నివేదికలకు ₹299/నెల లేదా 40 నివేదికలకు నెలకు ₹499.",
    "AI Disclaimer": "AI నిరాకరణ",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "ఈ నివేదిక AI మరియు జ్యోతిష్య వివరణలను ఉపయోగించి రూపొందించబడింది. ఇది సమాచార మరియు వినోద ప్రయోజనాల కోసం మాత్రమే. ఇది వైద్య, న్యాయ, లేదా ఆర్థిక సలహాగా పరిగణించరాదు.",
    "A copy of this report has also been sent to your registered email address as a PDF.": "ఈ నివేదిక యొక్క నకలు మీ నమోదిత ఇమెయిల్ చిరునామాకు PDFగా కూడా పంపబడింది.",
    "Report this AI-generated report?": "ఈ AI రూపొందించిన నివేదికను నివేదించాలా?",
    "charts": "పటాలు",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "స్వతంత్ర గమనికలు, తేదీ మరియు సమయ ప్రణాళిక. సేవ్ చేయడానికి లాగిన్ అవసరం; ఉచిత వినియోగదారులు పూర్తి ప్లానర్ యాక్సెస్‌ను పొందుతారు.",
    "Independent notes, date and time planning.": "స్వతంత్ర గమనికలు, తేదీ మరియు సమయ ప్రణాళిక.",
    "Add Plan": "ప్రణాళికను జోడించండి",
    "Save Plan": "ప్లాన్‌ను సేవ్ చేయండి",
    "Saved Plans": "సేవ్ చేసిన ప్లాన్‌లు",
    "Planner Entry": "ప్లానర్ ఎంట్రీ",
    "Plan": "ప్లాన్ చేయండి",
    "Saving...": "సేవ్ చేస్తోంది...",
    "Refresh": "రిఫ్రెష్ చేయండి",
    "No plans saved yet.": "ఇంకా ప్లాన్‌లు ఏవీ సేవ్ చేయబడలేదు.",
    "Planner layout is available. Login only when you want to save.": "ప్లానర్ లేఅవుట్ అందుబాటులో ఉంది. మీరు సేవ్ చేయాలనుకున్నప్పుడు మాత్రమే లాగిన్ చేయండి.",
    "No matching plans.": "సరిపోలే ప్రణాళికలు లేవు.",
    "Search Plans": "శోధన ప్రణాళికలు",
    "Search title, note, date or status": "శీర్షిక, గమనిక, తేదీ లేదా స్థితిని శోధించండి",
    "Login is required only when you want to save planner entries.": "మీరు ప్లానర్ ఎంట్రీలను సేవ్ చేయాలనుకున్నప్పుడు మాత్రమే లాగిన్ అవసరం.",
    "Planner entry saved.": "ప్లానర్ ఎంట్రీ సేవ్ చేయబడింది.",
    "Unable to load planner.": "ప్లానర్‌ని లోడ్ చేయడం సాధ్యపడలేదు.",
    "Unable to save planner entry.": "ప్లానర్ ఎంట్రీని సేవ్ చేయడం సాధ్యపడలేదు.",
    "Could not load planner.": "ప్లానర్‌ని లోడ్ చేయడం సాధ్యపడలేదు.",
    "Could not save planner entry.": "ప్లానర్ ఎంట్రీని సేవ్ చేయడం సాధ్యపడలేదు.",
    "Login required to save": "సేవ్ చేయడానికి లాగిన్ అవసరం",
    "You can explore Planner now. Login when you want to save entries.": "మీరు ఇప్పుడు ప్లానర్‌ను అన్వేషించవచ్చు. మీరు ఎంట్రీలను సేవ్ చేయాలనుకున్నప్పుడు లాగిన్ చేయండి.",
    "Prev": "మునుపటి",
    "Next": "తదుపరి",
    "Page": "పేజీ",
    "of": "యొక్క",
    "Child Birth Mahoorat": "బిడ్డ జననం మహూరత్",
    "Child Birth Mahoorat | Kundlistar Premium": "శిశు జననం మహూరత్ | కుండ్లిస్టార్ ప్రీమియం",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "పంచాంగ్, చోఘడియా మరియు హోరా ఆధారిత మార్గదర్శకత్వంతో ప్రీమియం చైల్డ్ బర్త్ మహూరత్ విండోస్.",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "ప్లాన్డ్ చైల్డ్-బర్త్ టైమింగ్ గైడెన్స్ కోసం అందుబాటులో ఉన్న పవిత్ర విండోలను అన్వేషించడానికి తేదీ మరియు స్థలాన్ని ఎంచుకోండి.",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "చైల్డ్ బర్త్ మహోరత్ ఆధ్యాత్మిక మరియు జ్యోతిష్య మార్గదర్శకత్వం కోసం మాత్రమే.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "చైల్డ్ బర్త్ మహూరత్ ప్రీమియం ఫీచర్. పంచాంగ్, చోఘడియా మరియు హోరా చెక్‌లతో శుభ మార్గదర్శక విండోలను అన్‌లాక్ చేయడానికి అప్‌గ్రేడ్ చేయండి.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "చైల్డ్ బర్త్ మహూరత్ ప్రీమియం ఫీచర్. పంచాంగ్, చోఘడియా మరియు హోరా చెక్‌లతో గైడెన్స్ విండోలను అన్‌లాక్ చేయడానికి అప్‌గ్రేడ్ చేయండి.",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "తేదీ, స్థలం, పంచాంగ్, చోఘడియా మరియు హోరా వారీగా ప్రీమియం మార్గదర్శక విండోలు.",
    "Premium feature": "ప్రీమియం ఫీచర్",
    "Upgrade to Kundlistar Premium": "కుండ్లిస్టార్ ప్రీమియంకు అప్‌గ్రేడ్ చేయండి",
    "Previous": "మునుపటి",
    "Today": "ఈరోజు",
    "Birth place / City": "పుట్టిన ప్రదేశం / నగరం",
    "Birth place / city": "పుట్టిన ప్రదేశం / నగరం",
    "Select country, then search city": "దేశాన్ని ఎంచుకోండి, ఆపై నగరాన్ని శోధించండి",
    "Preferred start": "ప్రాధాన్య ప్రారంభం",
    "Preferred end": "ఇష్టపడే ముగింపు",
    "Mother Moon sign (optional)": "తల్లి చంద్రుని గుర్తు (ఐచ్ఛికం)",
    "Cancer": "క్యాన్సర్",
    "Load Kundli": "కుండ్లిని లోడ్ చేయండి",
    "Find Premium Windows": "ప్రీమియం విండోస్‌ను కనుగొనండి",
    "Date (DD/MM/YYYY)": "తేదీ (DD/MM/YYYY)",
    "Invalid Date": "చెల్లని తేదీ",
    "Date must be in DD/MM/YYYY format.": "తేదీ తప్పనిసరిగా DD/MM/YYYY ఆకృతిలో ఉండాలి.",
    "Required": "అవసరం",
    "Please select a city.": "దయచేసి ఒక నగరాన్ని ఎంచుకోండి.",
    "Kundli": "కుండ్లి",
    "Unable to load kundli.": "కుండ్లీని లోడ్ చేయడం సాధ్యపడలేదు.",
    "Unable to calculate Child Birth Mahoorat.": "పిల్లల జనన మహూరత్‌ను లెక్కించడం సాధ్యపడలేదు.",
    "Kundli Preview": "కుండ్లి ప్రివ్యూ",
    "Loaded for": "కోసం లోడ్ చేయబడింది",
    "Doshas & Yogas": "దోషాలు & యోగాలు",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "లోడ్ చేయబడిన లాహిరి కుండ్లి నుండి నియమ-ఆధారిత సూచనలు. సమీక్ష మరియు ఆధ్యాత్మిక మార్గదర్శకత్వం కోసం వాటిని ఉపయోగించండి, తుది తీర్పుగా కాదు.",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "లోడ్ చేయబడిన లాహిరి కుండ్లి నుండి నియమ-ఆధారిత సూచనలు. సమీక్ష మరియు ఆధ్యాత్మిక మార్గదర్శకత్వం కోసం ఉపయోగించండి.",
    "Detected": "గుర్తించబడింది",
    "Not detected": "గుర్తించబడలేదు",
    "Review": "సమీక్షించండి",
    "Dosha": "దోశ",
    "Yoga": "యోగా",
    "Full Yoga Scan": "పూర్తి యోగా స్కాన్",
    "Checking yogas...": "యోగాలను తనిఖీ చేస్తోంది...",
    "No major yogas were detected by the premium yoga scan.": "ప్రీమియం యోగా స్కాన్ ద్వారా పెద్ద యోగాలు ఏవీ కనుగొనబడలేదు.",
    "No suitable premium windows found for the selected date and time range.": "ఎంచుకున్న తేదీ మరియు సమయ పరిధికి తగిన ప్రీమియం విండోలు ఏవీ కనుగొనబడలేదు.",
    "No suitable windows found": "తగిన విండోలు ఏవీ కనుగొనబడలేదు",
    "Try changing the time range or select previous/next date.": "సమయ పరిధిని మార్చడానికి ప్రయత్నించండి లేదా మునుపటి/తదుపరి తేదీని ఎంచుకోండి.",
    "Try changing the date or time range.": "తేదీ లేదా సమయ పరిధిని మార్చడానికి ప్రయత్నించండి.",
    "Try the Previous or Next date button to find a better option.": "మెరుగైన ఎంపికను కనుగొనడానికి మునుపటి లేదా తదుపరి తేదీ బటన్‌ను ప్రయత్నించండి.",
    "Use Previous or Next date to find a better option.": "మెరుగైన ఎంపికను కనుగొనడానికి మునుపటి లేదా తదుపరి తేదీని ఉపయోగించండి.",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "ఎంచుకున్న తేదీ మరియు నగరం కోసం ఉత్తమ ప్రీమియం విండోలను లెక్కించడానికి ప్రీమియం విండోస్‌ను కనుగొను క్లిక్ చేయండి.",
    "Tap Find Premium Windows for the selected date and city.": "ఎంచుకున్న తేదీ మరియు నగరం కోసం ప్రీమియం విండోలను కనుగొను నొక్కండి.",
    "Good tithi": "మంచి తిథి",
    "Supportive nakshatra": "సహాయక నక్షత్రం",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "నక్షత్రం సున్నితమైనది. పద మరియు గండంతలను జాగ్రత్తగా తనిఖీ చేయండి.",
    "Supportive weekday": "సహాయక వారపు రోజు",
    "Good Choghadiya": "బాగుంది చోఘడియా",
    "Weak Choghadiya": "బలహీనమైన చోఘడియా",
    "Supportive Hora": "మద్దతు హోరా",
    "Baby Moon matches mother's Moon sign.": "బేబీ మూన్ తల్లి చంద్రుని గుర్తుతో సరిపోలుతుంది.",
    "Hora": "హోరా",
    "slots": "స్లాట్లు",
    "min": "ని",
    "Good": "బాగుంది",
    "Excellent": "అద్భుతమైన",
    "Usable": "ఉపయోగించదగినది",
    "Rejected": "తిరస్కరించబడింది",
    "Sunday": "ఆదివారం",
    "Monday": "సోమవారం",
    "Tuesday": "మంగళవారం",
    "Wednesday": "బుధవారం",
    "Thursday": "గురువారం",
    "Friday": "శుక్రవారం",
    "Saturday": "శనివారం",
    "Sun": "సూర్యుడు",
    "Moon": "చంద్రుడు",
    "Mars": "అంగారకుడు",
    "Mercury": "బుధుడు",
    "Jupiter": "బృహస్పతి",
    "Venus": "శుక్రుడు",
    "Saturn": "శని",
    "Rahu": "రాహువు",
    "Ketu": "కేతువు",
    "Chal": "చల్",
    "Labh": "లాభ్",
    "Amrit": "అమృత్",
    "Shubh": "శుభ్",
    "Udveg": "ఉద్వేగ్",
    "Rog": "రోగ్",
    "Kaal": "కాల్",
    "Krishna Navami": "కృష్ణ నవమి",
    "Ashwini": "అశ్విని",
    "Bharani": "భరణి",
    "Krittika": "కృత్తికా",
    "Rohini": "రోహిణి",
    "Mrigashira": "మృగశిర",
    "Ardra": "ఆర్ద్ర",
    "Punarvasu": "పునర్వసు",
    "Pushya": "పుష్య",
    "Ashlesha": "ఆశ్లేష",
    "Magha": "మాఘ",
    "Jyeshtha": "జ్యేష్ఠ",
    "Moola": "మూలా",
    "Mula": "మూల",
    "Revati": "రేవతి"
  },
  "mr": {
    "Client Management": "क्लायंट व्यवस्थापन",
    "Dashboard": "डॅशबोर्ड",
    "Clients": "क्लायंट",
    "Consultations": "सल्लामसलत",
    "Notes": "नोट्स",
    "Follow-ups": "पाठपुरावा",
    "Reports": "अहवाल",
    "Remedies": "उपाय",
    "Predictions": "अंदाज",
    "Planner": "नियोजक",
    "Templates": "टेम्पलेट्स",
    "Analytics": "विश्लेषण",
    "Payments": "देयके",
    "Settings": "सेटिंग्ज",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings मध्ये डीफॉल्ट शहर जतन करू शकता. डीफॉल्ट शहर निवडेपर्यंत शहर फील्ड रिकामे राहतील.",
    "is now your default city.": "आता तुमचे डीफॉल्ट शहर आहे.",
    "Search your default city": "तुमचे डीफॉल्ट शहर शोधा",
    "This color is saved for the website theme and PDF report accent.": "हा रंग वेबसाइट थीम आणि PDF रिपोर्ट accent साठी जतन होईल.",
    "Turn All off to include only the checked modules in the report.": "रिपोर्टमध्ये फक्त निवडलेले मॉड्यूल्स ठेवण्यासाठी All बंद करा.",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All चालू असल्यास PDF मध्ये सर्व मॉड्यूल्स येतात. फक्त निवडलेले मॉड्यूल्स ठेवण्यासाठी ते बंद करा.",
    "Uranus, Neptune and Pluto stay hidden by default.": "युरेनस, नेपच्यून आणि प्लूटो डीफॉल्टने लपलेले राहतात.",
    "Show Uranus, Neptune and Pluto": "युरेनस, नेपच्यून आणि प्लूटो दाखवा",
    "When off, Nadi and KP also use the selected global ayanamsha.": "बंद असल्यास, नाडी आणि KP निवडलेला जागतिक अयनांश वापरतील.",
    "Use KP for Nadi and KP": "नाडी आणि KP साठी KP वापरा",
    "Use KP ayanamsha for Nadi and KP": "नाडी आणि KP साठी KP अयनांश वापरा",
    "Night": "नाईट",
    "Dark": "डार्क",
    "Light": "लाईट",
    "Clear default city": "डीफॉल्ट शहर काढा",
    "Default City": "डीफॉल्ट शहर",
    "Default city": "डीफॉल्ट शहर",
    "Theme Color": "थीम रंग",
    "Theme color": "थीम रंग",
    "Include all modules": "सर्व मॉड्यूल समाविष्ट करा",
    "PDF Report Modules": "PDF रिपोर्ट मॉड्यूल्स",
    "PDF report modules": "PDF रिपोर्ट मॉड्यूल्स",
    "Show": "दाखवा",
    "Hide": "लपवा",
    "Outer Planets": "बाह्य ग्रह",
    "Outer planets": "बाह्य ग्रह",
    "Ayanamsha": "अयनांश",
    "Mean Node": "मीन नोड",
    "True Node": "ट्रू नोड",
    "Rahu/Ketu Calculation": "राहू/केतू गणना",
    "Rahu/Ketu calculation": "राहू/केतू गणना",
    "East": "पूर्व भारतीय",
    "South": "दक्षिण भारतीय",
    "North": "उत्तर भारतीय",
    "Chart Style": "चार्ट शैली",
    "Chart style": "चार्ट शैली",
    "Language": "भाषा",
    "Records": "रेकॉर्ड",
    "Relations": "संबंध",
    "Relation": "संबंध",
    "Add Client": "क्लायंट जोडा",
    "Add Consultation": "सल्ला जोडा",
    "Add Note": "टीप जोडा",
    "Add Follow-up": "फॉलो-अप जोडा",
    "Create Report": "अहवाल तयार करा",
    "Assign Remedy": "उपाय नियुक्त करा",
    "Add Prediction": "अंदाज जोडा",
    "Add Payment": "पेमेंट जोडा",
    "Assign Chart": "चार्ट नियुक्त करा",
    "Add Relation": "संबंध जोडा",
    "CMS Action": "CMS क्रिया",
    "Client": "क्लायंट",
    "Chart": "तक्ता",
    "Related Client": "संबंधित क्लायंट",
    "Full Name": "पूर्ण नाव",
    "Phone Number": "फोन नंबर",
    "WhatsApp Number": "व्हॉट्सॲप नंबर",
    "Email": "ईमेल",
    "Birth Place": "जन्मस्थान",
    "Current City": "सध्याचे शहर",
    "Main Topic": "मुख्य विषय",
    "Status": "स्थिती",
    "Source": "स्त्रोत",
    "Tags": "टॅग्ज",
    "Internal Note": "अंतर्गत टीप",
    "Purpose": "उद्देश",
    "Relation Type": "संबंध प्रकार",
    "Title": "शीर्षक",
    "Topic": "विषय",
    "Date": "तारीख",
    "Time": "वेळ",
    "Amount": "रक्कम",
    "Mode": "मोड",
    "Payment Status": "देयक स्थिती",
    "Note / Summary": "टीप / सारांश",
    "Close": "बंद करा",
    "Cancel": "रद्द करा",
    "Save": "जतन करा",
    "Saving": "बचत करत आहे",
    "Save Changes": "बदल जतन करा",
    "Edit Client": "क्लायंट संपादित करा",
    "Client Chart": "क्लायंट चार्ट",
    "Comma separated": "स्वल्पविराम विभक्त",
    "Search by name, phone, email, topic, or tag": "नाव, फोन, ईमेल, विषय किंवा टॅगद्वारे शोधा",
    "Search clients, phone, topic": "क्लायंट, फोन, विषय शोधा",
    "Search your saved charts by chart name": "चार्ट नावाने तुमचे सेव्ह केलेले चार्ट शोधा",
    "Linked Chart": "लिंक केलेला चार्ट",
    "Select linked chart": "लिंक केलेला चार्ट निवडा",
    "Link a chart to this client before adding records.": "रेकॉर्ड जोडण्यापूर्वी या क्लायंटशी चार्ट लिंक करा.",
    "Connect this client with another saved client profile": "या क्लायंटला दुसऱ्या सेव्ह केलेल्या क्लायंट प्रोफाइलशी कनेक्ट करा",
    "CMS for astrologer client work": "ज्योतिषी क्लायंटच्या कामासाठी CMS",
    "Premium Pro unlocks Client Management": "प्रीमियम प्रो क्लायंट व्यवस्थापन अनलॉक करते",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "क्लायंट प्रोफाइल, सल्लामसलत, नोट्स, फॉलो-अप, अहवाल, उपाय, अंदाज, विश्लेषणे आणि पेमेंट ट्रॅकिंग एकाच वर्कस्पेसमध्ये व्यवस्थापित करण्यासाठी अपग्रेड करा.",
    "Upgrade to Premium Pro": "Premium Pro वर अपग्रेड करा",
    "CMS modules included": "CMS मॉड्यूल्स समाविष्ट",
    "Please login to use Client Management. CMS data is stored per account.": "कृपया क्लायंट व्यवस्थापन वापरण्यासाठी लॉग इन करा. CMS डेटा प्रति खाते संग्रहित केला जातो.",
    "Login": "लॉगिन करा",
    "Loading live CMS data...": "थेट CMS डेटा लोड करत आहे...",
    "Quick Actions": "जलद क्रिया",
    "Client Records": "क्लायंट रेकॉर्ड",
    "Client Record": "क्लायंट रेकॉर्ड",
    "Client Profile": "क्लायंट प्रोफाइल",
    "Back to Clients": "ग्राहकांकडे परत",
    "View": "पहा",
    "Edit": "संपादित करा",
    "Delete": "हटवा",
    "Note": "नोंद",
    "Archive": "संग्रहण",
    "Download PDF": "PDF डाउनलोड करा",
    "Delete this record?": "हा रेकॉर्ड हटवायचा?",
    "Unable to edit this CMS record.": "हे CMS रेकॉर्ड संपादित करण्यात अक्षम.",
    "Unable to update CMS record.": "CMS रेकॉर्ड अपडेट करण्यात अक्षम.",
    "Unable to delete CMS record.": "CMS रेकॉर्ड हटवण्यात अक्षम.",
    "No contact added": "कोणताही संपर्क जोडला नाही",
    "No topic": "विषय नाही",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "अद्याप कोणतेही क्लायंट सापडले नाहीत. CMS डॅशबोर्ड भरणे सुरू करण्यासाठी तुमचा पहिला खरा क्लायंट जोडा.",
    "Last Consultation": "शेवटचा सल्ला",
    "Next Follow-up": "पुढील पाठपुरावा",
    "Date of Birth": "जन्मतारीख",
    "Time of Birth": "जन्माची वेळ",
    "Client Details": "क्लायंट तपशील",
    "No connected profiles yet.": "अद्याप कोणतेही कनेक्ट केलेले प्रोफाइल नाहीत.",
    "Select a client record to view details.": "तपशील पाहण्यासाठी क्लायंट रेकॉर्ड निवडा.",
    "Record": "रेकॉर्ड",
    "Consultation Summary": "सल्ला सारांश",
    "Client Note": "क्लायंट नोट",
    "Start a consultation record with summary, topic, mode and payment fields.": "सारांश, विषय, मोड आणि पेमेंट फील्डसह सल्लामसलत रेकॉर्ड सुरू करा.",
    "Start a private note attached to a client profile.": "क्लायंट प्रोफाइलशी संलग्न खाजगी नोट सुरू करा.",
    "Start a pending follow-up with due date and topic.": "देय तारीख आणि विषयासह प्रलंबित पाठपुरावा सुरू करा.",
    "Start a report record connected to the client timeline.": "क्लायंट टाइमलाइनशी कनेक्ट केलेला अहवाल रेकॉर्ड सुरू करा.",
    "Start an active remedy record for client guidance.": "क्लायंट मार्गदर्शनासाठी सक्रिय उपाय रेकॉर्ड सुरू करा.",
    "Start an open prediction record with notes and follow-up date.": "नोट्स आणि फॉलो-अप तारखेसह ओपन प्रेडिक्शन रेकॉर्ड सुरू करा.",
    "Statuses": "स्थिती",
    "Topics": "विषय",
    "Sources": "स्रोत",
    "No records found for the current filters.": "वर्तमान फिल्टरसाठी कोणतेही रेकॉर्ड आढळले नाहीत.",
    "Total Clients": "एकूण ग्राहक",
    "New Clients This Month": "या महिन्यात नवीन ग्राहक",
    "Consultations This Month": "या महिन्यात सल्लामसलत",
    "Today's Consultations": "आजचे सल्लामसलत",
    "Consultations scheduled for today from real client records.": "रिअल क्लायंटच्या रेकॉर्डवरून आजसाठी सल्लामसलत.",
    "No consultations scheduled for today.": "आजसाठी कोणतेही सल्लामसलत शेड्यूल केलेली नाही.",
    "Pending Follow-ups": "प्रलंबित पाठपुरावा",
    "Reports Created": "अहवाल तयार केले",
    "Active Remedies": "सक्रिय उपाय",
    "Open Predictions": "अंदाज उघडा",
    "Pending Payments": "प्रलंबित देयके",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "क्लायंट क्रियाकलाप, अलीकडील कार्य, फॉलो-अप, अहवाल, अंदाज, उपाय आणि प्रलंबित पेमेंट एकाच ठिकाणी पहा.",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "जन्म तपशील, विषय, टॅग, स्थिती आणि संग्रहण/पुनर्संचयित क्रियांसह ज्योतिषी क्लायंट रेकॉर्ड व्यवस्थापित करा.",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "सत्र तपशील, लिंक केलेले चार्ट, विषय, निरीक्षणे, अंदाज, उपाय आणि फॉलो-अप तारखा संग्रहित करा.",
    "Keep private consultation notes and chart observations attached to client profiles.": "खाजगी सल्ला टिपा आणि चार्ट निरीक्षणे क्लायंट प्रोफाइलशी संलग्न ठेवा.",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "पुश, एसएमएस, ईमेल किंवा व्हॉट्सॲप अलर्टशिवाय क्लायंट मॅनेजमेंटमध्ये आज आणि आगामी फॉलो-अपचा मागोवा घ्या.",
    "Create and organize client reports generated from saved charts and consultation context.": "जतन केलेले चार्ट आणि सल्लामसलत संदर्भातून व्युत्पन्न केलेले क्लायंट अहवाल तयार करा आणि व्यवस्थापित करा.",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "उपाय नियुक्त करा, सक्रिय मार्गदर्शन चिन्हांकित करा आणि उपाय इतिहास क्लायंट टाइमलाइनशी जोडलेला ठेवा.",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "प्रत्येक क्लायंटसाठी खुल्या अंदाज, तारखा, आत्मविश्वास नोट्स आणि परिणाम अद्यतनांचा मागोवा घ्या.",
    "Plan consultations, follow-ups and payment dates in one working view.": "योजना सल्लामसलत, पाठपुरावा आणि पेमेंट तारखा एकाच कार्य दृश्यात.",
    "Prepare reusable consultation, report, remedy and prediction templates.": "पुन्हा वापरता येण्याजोगे सल्ला, अहवाल, उपाय आणि अंदाज टेम्पलेट्स तयार करा.",
    "Review client activity, consultation volume, reports created and pending work.": "क्लायंट क्रियाकलाप, सल्लामसलत खंड, तयार केलेले अहवाल आणि प्रलंबित कामाचे पुनरावलोकन करा.",
    "Track consultation amounts and payment status without plan or pricing rules.": "योजना किंवा किंमत नियमांशिवाय सल्लामसलत रक्कम आणि देयक स्थितीचा मागोवा घ्या.",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "क्लायंट स्रोत, स्थिती, विषय, टॅग आणि अंतर्गत CMS प्राधान्ये कॉन्फिगर करा.",
    "Showing saved records connected to client records.": "क्लायंट रेकॉर्डशी कनेक्ट केलेले जतन केलेले रेकॉर्ड दाखवत आहे.",
    "No Status": "स्थिती नाही",
    "No Mode": "मोड नाही",
    "No Payment Status": "पेमेंट स्थिती नाही",
    "No Topic": "विषय नाही",
    "No Source": "स्रोत नाही",
    "All Statuses": "सर्व स्थिती",
    "All Topics": "सर्व विषय",
    "No clients found": "कोणतेही क्लायंट आढळले नाहीत",
    "Type to search clients": "क्लायंट शोधण्यासाठी टाइप करा",
    "No charts found": "कोणतेही चार्ट आढळले नाहीत",
    "Type to search saved charts": "जतन केलेले चार्ट शोधण्यासाठी टाइप करा",
    "Type to search related client": "संबंधित क्लायंट शोधण्यासाठी टाइप करा",
    "Open": "उघडा",
    "Pending": "प्रलंबित",
    "Scheduled": "अनुसूचित",
    "Completed": "पूर्ण झाले",
    "Follow-up Pending": "पाठपुरावा प्रलंबित",
    "Cancelled": "रद्द केले",
    "Closed": "बंद",
    "No-show": "नो-शो",
    "Not Applicable": "लागू नाही",
    "Paid": "पैसे दिले",
    "Partially Paid": "अर्धवट पैसे दिले",
    "Refunded": "परतावा दिला",
    "Phone": "फोन",
    "WhatsApp Call": "व्हॉट्सॲप कॉल",
    "Video Call": "व्हिडिओ कॉल",
    "In-person": "व्यक्तीगत",
    "Chat": "गप्पा",
    "Other": "इतर",
    "New": "नवीन",
    "VIP": "व्हीआयपी",
    "Inactive": "निष्क्रिय",
    "Consultation Completed": "सल्लामसलत पूर्ण झाली",
    "WhatsApp": "WhatsApp",
    "Instagram": "इंस्टाग्राम",
    "YouTube": "YouTube",
    "Referral": "रेफरल",
    "Website": "वेबसाइट",
    "Walk-in": "वॉक-इन",
    "Repeat Client": "क्लायंटची पुनरावृत्ती करा",
    "Family Referral": "कौटुंबिक संदर्भ",
    "Business": "व्यवसाय",
    "Finance": "वित्त",
    "Property": "मालमत्ता",
    "Children": "मुले",
    "Foreign Settlement": "परदेशी सेटलमेंट",
    "Legal": "कायदेशीर",
    "Remedy": "उपाय",
    "General": "सामान्य",
    "Active": "सक्रिय",
    "Past": "भूतकाळ",
    "Potential": "संभाव्य",
    "Archived": "संग्रहित",
    "Spouse": "जोडीदार",
    "Husband": "नवरा",
    "Wife": "बायको",
    "Child": "मूल",
    "Son": "मुलगा",
    "Daughter": "कन्या",
    "Father": "वडील",
    "Mother": "आई",
    "Sibling": "भावंड",
    "Brother": "भाऊ",
    "Sister": "बहीण",
    "Marriage Prospect": "विवाहाची शक्यता",
    "Fiance": "मंगेतर",
    "Business Partner": "व्यवसाय भागीदार",
    "Friend": "मित्र",
    "Relative": "नातेवाईक",
    "Upgrade": "अपग्रेड करा",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "तुम्ही फक्त 2 क्लायंट जोडू शकता. अधिक क्लायंटसाठी प्रीमियम वर श्रेणीसुधारित करा.",
    "None": "काहीही नाही",
    "Education": "शिक्षण",
    "Awards": "पुरस्कार",
    "Prize": "बक्षीस",
    "Career": "करिअर",
    "Love": "प्रेम",
    "Marriage": "लग्न",
    "Dowry or Legacy": "हुंडा किंवा वारसा",
    "Divorce": "घटस्फोट",
    "Abortion": "गर्भपात",
    "Child Birth": "बाळाचा जन्म",
    "Property/Vehicle Purchase": "मालमत्ता/वाहन खरेदी",
    "Property/Vehicle Sale": "मालमत्ता/वाहन विक्री",
    "Love and Caring": "प्रेम आणि काळजी",
    "Depression": "नैराश्य",
    "Aggression": "आक्रमकता",
    "Health": "आरोग्य",
    "Travel": "प्रवास",
    "Homecoming": "घरवापसी",
    "Litigation": "खटला",
    "Arrest": "अटक",
    "Locked": "कुलूपबंद",
    "Strong": "मजबूत",
    "Weak": "कमकुवत",
    "Supportive": "आश्वासक",
    "Avoid": "टाळा",
    "Premium": "प्रीमियम",
    " UTC": "UTC",
    "Unable to calculate Tithi Pravesh": "तिथी प्रवेश मोजता येत नाही",
    "IANA timezone": "IANA टाइमझोन",
    "TP Local": "TP लोकल",
    "TP UTC": "TP UTC",
    "Next TP Local": "पुढील TP लोकल",
    "Models: KP + Vedic": "मॉडेल: केपी + वैदिक",
    "Overall Year Theme": "एकूण वर्षाची थीम",
    "Career & Job": "करिअर आणि नोकरी",
    "Finance & Savings": "वित्त आणि बचत",
    "Relationship & Marriage": "नाते आणि विवाह",
    "Family Matters": "कौटुंबिक बाबी",
    "Property & Vehicle": "मालमत्ता आणि वाहन",
    "Health & Wellness": "आरोग्य आणि निरोगीपणा",
    "Spiritual Growth": "आध्यात्मिक वाढ",
    "Social Status & Recognition": "सामाजिक स्थिती आणि ओळख",
    "Please select a saved chart first.": "कृपया प्रथम जतन केलेला चार्ट निवडा.",
    "Unable to generate Tajika Varshphal": "Tajika Varshphal जनरेट करण्यात अक्षम",
    "Premium yearly module": "प्रीमियम वार्षिक मॉड्यूल",
    "Tajika Varshphal": "ताजिका वर्षाफळ",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "या जतन केलेल्या कुंडलीतून वैयक्तिकृत वर्षा लग्न, मुंथा, वर्षा भगवान, सहम्स, मासिक मार्गदर्शन, उपाय आणि व्यावहारिक जीवन थीमसह सौर परतावा आधारित वार्षिक कुंडली.",
    "Saved chart": "जतन केलेला चार्ट",
    "Untitled Chart": "शीर्षक नसलेला चार्ट",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "तुमची 4 मोफत प्रीमियम क्रेडिट्स वापरली जातात. अमर्यादित प्रीमियम प्रवेशासाठी Kundlistar प्रीमियम वर श्रेणीसुधारित करा.",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "तुमचे ४ फ्री प्रिमियम क्रेडिट वापरा. असीमित प्रीमियम एक्सेससाठी Kundlistar प्रीमियम लें.",
    "Core Year Markers": "कोर वर्ष मार्कर",
    "Solar Return": "सौर परतावा",
    "Varsha Lagna": "वर्षा लग्न",
    "Muntha Lord": "मुंठा प्रभू",
    "Varsha Lord": "वर्षा प्रभू",
    "Varshesh Method": "वर्षेश पद्धत",
    "Yearly Summary": "वार्षिक सारांश",
    "Not available yet.": "अजून उपलब्ध नाही.",
    "Varshesh Candidates": "वर्षेश उमेदवार",
    "Risk Areas": "जोखीम क्षेत्रे",
    "Favourable Periods": "अनुकूल कालावधी",
    "Challenging Periods": "आव्हानात्मक कालावधी",
    "Remedies & Final Advice": "उपाय आणि अंतिम सल्ला",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "ताजिका वर्षाफळ व्याख्यात्मक वार्षिक मार्गदर्शन देते. हे वैद्यकीय, कायदेशीर, आर्थिक किंवा विशिष्ट अंदाज सल्ला म्हणून मानले जाऊ नये.",
    "Griha Pravesh": "गृहप्रवेश",
    "Purva Phalguni": "पूर्वा फाल्गुनी",
    "Uttara Phalguni": "उत्तरा फाल्गुनी",
    "Purva Ashadha": "पूर्वा आषाढ",
    "Uttara Ashadha": "उत्तरा आषाढ",
    "Purva Bhadrapada": "पूर्वा भाद्रपद",
    "Uttara Bhadrapada": "उत्तरा भाद्रपद",
    "Param Mitra": "परम मित्र",
    "Kundli birthplace": "कुंडली जन्मस्थान",
    "Selected city": "निवडलेले शहर",
    "Muhurat - Kundlistar": "मुहूर्त - Kundlistar",
    "Please select a city first.": "कृपया प्रथम शहर निवडा.",
    "Unable to calculate Muhurat.": "मुहूर्त काढता येत नाही.",
    "Unable to calculate personalized Muhurat.": "वैयक्तिक मुहूर्त मोजण्यात अक्षम.",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "पंचांग, ​​चोघडिया, होरा, तारबाला आणि चंद्रबाला वापरून सामान्य आणि वैयक्तिक मुहूर्त शोधा.",
    "Muhurat Finder": "मुहूर्त शोधणारा",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "पंचांग, ​​चोघडिया आणि प्रीमियम वैयक्तिक जन्म घटक वापरून उपयुक्त वेळ शोधा.",
    "Search city...": "शहर शोधा...",
    "Using selected Kundli": "निवडलेल्या कुंडली वापरणे",
    "Find Free": "मोफत शोधा",
    "Free General Muhurat": "मोफत सामान्य मुहूर्त",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "पुढील 7 दिवसांसाठी शीर्ष 3 स्लॉट. राहू काल, यमगंड आणि गुलिका काढून टाकतात.",
    "Today's Muhurat": "आजचा मुहूर्त",
    "Daily Muhurat by Kundlistar": "Kundlistar द्वारे दैनिक मुहूर्त",
    "Shared via Kundlistar": "Kundlistar द्वारे सामायिक केले",
    "Kundlistar Muhurat": "Kundlistar मुहूर्त",
    "Share Image": "प्रतिमा सामायिक करा",
    "Share Text": "मजकूर सामायिक करा",
    "Copy Text": "मजकूर कॉपी करा",
    "Click Find Free to use the selected Kundli birthplace.": "निवडलेल्या कुंडली जन्मस्थान वापरण्यासाठी विनामूल्य शोधा क्लिक करा.",
    "Select a city and click Find Free.": "एक शहर निवडा आणि विनामूल्य शोधा क्लिक करा.",
    "Premium Personalized Muhurat": "प्रीमियम वैयक्तिकृत मुहूर्त",
    "Loading Kundli details...": "कुंडली तपशील लोड करत आहे...",
    "Birth Nakshatra": "जन्म नक्षत्र",
    "Birth Moon Rashi": "जन्म चंद्र राशी",
    "Include night slots": "रात्रीचे स्लॉट समाविष्ट करा",
    "Find Premium": "प्रीमियम शोधा",
    "Your grounding and foundation energy appears strong in this chart.": "तुमची ग्राउंडिंग आणि फाउंडेशन एनर्जी या चार्टमध्ये मजबूत दिसते.",
    "Your grounding energy appears generally balanced in this chart.": "या चार्टमध्ये तुमची ग्राउंडिंग एनर्जी साधारणपणे संतुलित दिसते.",
    "Reflection on routine, discipline, and inner stability may be useful.": "दिनचर्या, शिस्त आणि आंतरिक स्थिरता यावर विचार करणे उपयुक्त ठरू शकते.",
    "Your creative and emotional flow energy appears strong in this chart.": "तुमची सर्जनशील आणि भावनिक प्रवाह ऊर्जा या तक्त्यामध्ये मजबूत दिसते.",
    "Your creative energy appears balanced in this chart.": "तुमची सर्जनशील ऊर्जा या तक्त्यामध्ये संतुलित दिसते.",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "सर्जनशीलता, भावनिक अभिव्यक्ती आणि आंतरिक प्रवाह यावर प्रतिबिंब उपयुक्त असू शकते.",
    "Your confidence and willpower energy appears strong in this chart.": "तुमचा आत्मविश्वास आणि इच्छाशक्ती या तक्त्यामध्ये मजबूत दिसते.",
    "Your action-taking energy appears balanced in this chart.": "तुमची कृती करण्याची उर्जा या तक्त्यामध्ये संतुलित दिसते.",
    "Reflection on confidence, discipline, and decision power may be useful.": "आत्मविश्वास, शिस्त आणि निर्णय शक्तीचे प्रतिबिंब उपयुक्त ठरू शकते.",
    "Your connection and compassion energy appears strong in this chart.": "या चार्टमध्ये तुमचे कनेक्शन आणि करुणा ऊर्जा मजबूत दिसते.",
    "Your emotional connection energy appears balanced in this chart.": "तुमची भावनिक जोडणी ऊर्जा या तक्त्यामध्ये संतुलित दिसते.",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "सुसंवाद, क्षमा आणि भावनिक संतुलन यावर विचार करणे उपयुक्त ठरू शकते.",
    "Your communication and expression energy appears strong in this chart.": "तुमची संवाद आणि अभिव्यक्ती ऊर्जा या तक्त्यामध्ये मजबूत दिसते.",
    "Your expression energy appears balanced in this chart.": "तुमची अभिव्यक्ती ऊर्जा या तक्त्यामध्ये संतुलित दिसते.",
    "Reflection on clear communication and self-expression may be useful.": "स्पष्ट संप्रेषण आणि आत्म-अभिव्यक्तीचे प्रतिबिंब उपयुक्त असू शकते.",
    "Your intuition and inner clarity appears strong in this chart.": "तुमची अंतर्ज्ञान आणि आंतरिक स्पष्टता या तक्त्यामध्ये मजबूत दिसते.",
    "Your intuitive clarity appears balanced in this chart.": "तुमची अंतर्ज्ञानी स्पष्टता या तक्त्यामध्ये संतुलित दिसते.",
    "Reflection on focus, intuition, and inner guidance may be useful.": "फोकस, अंतर्ज्ञान आणि आंतरिक मार्गदर्शन यावर प्रतिबिंब उपयुक्त असू शकते.",
    "A strong Fire element supports action, courage, and leadership energy.": "एक मजबूत अग्नि घटक कृती, धैर्य आणि नेतृत्व उर्जेला समर्थन देतो.",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "अग्नी संतुलित दिसतो, कृती आणि संयम यांच्यातील स्थिर लयला आधार देतो.",
    "Reflection on confidence and action-taking may be useful.": "आत्मविश्वास आणि कृतीवर विचार करणे उपयुक्त ठरू शकते.",
    "A strong Earth element supports practicality, patience, and stability.": "एक मजबूत पृथ्वी घटक व्यावहारिकता, संयम आणि स्थिरतेचे समर्थन करते.",
    "Earth appears balanced, supporting practical thinking with flexibility.": "पृथ्वी संतुलित दिसते, लवचिकतेसह व्यावहारिक विचारांना समर्थन देते.",
    "Reflection on grounding, consistency, and planning may be useful.": "ग्राउंडिंग, सातत्य आणि नियोजन यावर विचार करणे उपयुक्त ठरू शकते.",
    "A strong Air element supports ideas, communication, and adaptability.": "एक मजबूत वायु घटक कल्पना, संप्रेषण आणि अनुकूलतेस समर्थन देते.",
    "Air appears balanced, supporting harmony between thinking and action.": "हवा संतुलित दिसते, विचार आणि कृती यांच्यात सुसंवाद साधते.",
    "Reflection on communication and flexibility may be useful.": "संवाद आणि लवचिकता यावर विचार करणे उपयुक्त ठरू शकते.",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "एक मजबूत जल घटक अंतर्ज्ञान, संवेदनशीलता आणि भावनिक खोलीला समर्थन देतो.",
    "Water appears balanced, supporting harmony between emotions and logic.": "पाणी संतुलित दिसते, भावना आणि तर्क यांच्यात सुसंवाद साधते.",
    "Reflection on emotional expression and inner connection may be useful.": "भावनिक अभिव्यक्ती आणि आतील संबंधांचे प्रतिबिंब उपयुक्त असू शकते.",
    "A strong Ether element supports spiritual awareness and broader vision.": "एक मजबूत ईथर घटक आध्यात्मिक जागरूकता आणि व्यापक दृष्टीचे समर्थन करते.",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ईथर संतुलित दिसतो, आध्यात्मिक आणि व्यावहारिक दृष्टिकोन यांच्यातील सुसंवादाचे समर्थन करतो.",
    "Reflection, silence, and spiritual discipline may be useful.": "चिंतन, मौन आणि आध्यात्मिक शिस्त उपयुक्त ठरू शकते.",
    "For inner confidence, clarity, and soul strength.": "आंतरिक आत्मविश्वास, स्पष्टता आणि आत्मीय शक्तीसाठी.",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "हे इष्ट देवता संकेत जन्मपत्रिकेतील ग्रहशक्ती, लग्नाचा स्वामी, चंद्र राशीचा स्वामी आणि आत्माकारावर आधारित आहे.",
    "For calmness, emotional balance, and softness.": "शांतता, भावनिक संतुलन आणि मऊपणासाठी.",
    "For courage, protection, and discipline.": "धैर्य, संरक्षण आणि शिस्तीसाठी.",
    "For intellect, speech, learning, and obstacle removal.": "बुद्धी, वाणी, शिकणे आणि अडथळे दूर करण्यासाठी.",
    "For knowledge, guidance, dharma, and blessings.": "ज्ञान, मार्गदर्शन, धर्म आणि आशीर्वाद यासाठी.",
    "Mahalakshmi Ji": "महालक्ष्मी जी",
    "For harmony, beauty, comfort, and prosperity.": "सुसंवाद, सौंदर्य, आराम आणि समृद्धीसाठी.",
    "For karma, patience, discipline, and protection.": "कर्म, संयम, शिस्त आणि संरक्षण यासाठी.",
    "For protection from confusion, fear, and illusion.": "गोंधळ, भीती आणि भ्रम यापासून संरक्षणासाठी.",
    "Lord Ganesha": "भगवान गणेश",
    "For spiritual clarity, detachment, and obstacle removal.": "आध्यात्मिक स्पष्टता, अलिप्तता आणि अडथळे दूर करण्यासाठी.",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "चक्र अंतर्दृष्टीसाठी चार्ट डेटा आवश्यक आहे.",
    "Unable to load Chakra insight.": "चक्र अंतर्दृष्टी लोड करण्यात अक्षम.",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "हे फक्त जन्म कुंडली आधारित आध्यात्मिक ऊर्जा अंतर्दृष्टी आणि आत्म-चिंतन आहे. हा व्यावसायिक सल्ला नाही.",
    "Spiritual energy insights from Kundli": "कुंडलीतून आध्यात्मिक ऊर्जा अंतर्दृष्टी",
    "Calculated from your individual birth chart": "तुमच्या वैयक्तिक जन्म तक्त्यावरून गणना केली जाते",
    "Chakra Balance": "चक्र शिल्लक",
    "Panch Tatva Balance": "पंच तत्व संतुलन",
    "Ishta Devata": "इष्ट देवता",
    "Signal planet": "सिग्नल ग्रह",
    "Very Good": "खूप छान",
    "Very Bad": "खूप वाईट",
    "Panch Pakshi Calculator - Kundlistar": "पंच पक्षी कॅल्क्युलेटर - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "चार्टमधून पंच पक्षी प्रीफिल करू शकलो नाही. तुम्ही अजूनही मॅन्युअली गणना करू शकता.",
    "Could not load sunrise and sunset from Panchang for this chart location.": "या चार्ट स्थानासाठी पंचांगवरून सूर्योदय आणि सूर्यास्त लोड करता आला नाही.",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "पंचांग पासून सूर्योदय, सूर्यास्त आणि पुढील सूर्योदय लोड करण्यात अक्षम.",
    "Panch Pakshi calculation failed.": "पंचपक्षी गणना अयशस्वी.",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "पंचपक्षी पक्षी, क्रियाकलाप, यमम, अपहाराचा कालावधी, संबंध, गुण आणि परिणाम यांची गणना करा.",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "तुमचे मोफत प्रीमियम क्रेडिट्स पूर्ण झाले आहेत. सुरू ठेवण्यासाठी Premium वर अपग्रेड करा.",
    "This is a premium feature. You can use 1 free premium credit to continue.": "हे एक प्रीमियम वैशिष्ट्य आहे. सुरू ठेवण्यासाठी तुम्ही 1 मोफत प्रीमियम क्रेडिट वापरू शकता.",
    "Selected Date": "निवडलेली तारीख",
    "repeat(3, 1fr)": "पुनरावृत्ती (3, 1fr)",
    "Birth Paksha": "जन्म पक्ष",
    "Current Paksha": "सध्याचा पक्ष",
    "repeat(4, 1fr)": "पुनरावृत्ती (4, 1fr)",
    "Target Date Time": "लक्ष्य तारीख वेळ",
    "Next Sunrise": "पुढील सूर्योदय",
    "Calculate Panch Pakshi": "पंचपक्षी मोजा",
    "repeat(2, 1fr)": "पुनरावृत्ती (2, 1fr)",
    "repeat(6, 1fr)": "पुनरावृत्ती (6, 1fr)",
    "Birth Pakshi": "जन्म पक्षी",
    "Current Period": "चालू कालावधी",
    "Current Yamam": "वर्तमान यमम",
    "Main Activity": "मुख्य क्रियाकलाप",
    "Natal Western Chart": "नेटल वेस्टर्न चार्ट",
    "Life Phase Progression": "जीवन टप्प्यात प्रगती",
    "Self-focus, identity change, body awareness and personal reset.": "स्व-फोकस, ओळख बदल, शरीर जागरूकता आणि वैयक्तिक रीसेट.",
    "Money, values, family, speech and security become emotionally important.": "पैसा, मूल्ये, कुटुंब, वाणी आणि सुरक्षितता भावनिकदृष्ट्या महत्त्वाची ठरतात.",
    "Communication, learning, siblings, writing and short travel become important.": "संवाद, शिकणे, भावंडं, लेखन आणि छोटा प्रवास महत्त्वाचा ठरतो.",
    "Home, mother, property, family and emotional roots become important.": "घर, आई, मालमत्ता, कुटुंब आणि भावनिक मुळे महत्त्वाची ठरतात.",
    "Creativity, romance, children, hobbies and self-expression become important.": "सर्जनशीलता, प्रणय, मुले, छंद आणि स्वत: ची अभिव्यक्ती महत्त्वपूर्ण बनतात.",
    "Work routine, health habits, service and discipline become important.": "कामाची दिनचर्या, आरोग्याच्या सवयी, सेवा आणि शिस्त महत्त्वाची ठरते.",
    "Relationship, marriage, partnership and public dealing become important.": "नातेसंबंध, लग्न, भागीदारी आणि सार्वजनिक व्यवहार महत्त्वाचे ठरतात.",
    "Deep emotional change, intimacy, shared money and transformation become important.": "सखोल भावनिक बदल, जवळीक, शेअर केलेले पैसे आणि परिवर्तन महत्त्वाचे बनतात.",
    "Learning, travel, teaching, belief and higher wisdom become important.": "शिकणे, प्रवास, शिकवणे, विश्वास आणि उच्च शहाणपण महत्त्वाचे ठरतात.",
    "Career, status, public image and responsibility become emotionally important.": "करिअर, स्टेटस, सार्वजनिक प्रतिमा आणि जबाबदारी भावनिकदृष्ट्या महत्त्वाची ठरते.",
    "Income, friends, networking, community and ambitions become important.": "उत्पन्न, मित्र, नेटवर्किंग, समुदाय आणि महत्त्वाकांक्षा महत्त्वाच्या ठरतात.",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "विश्रांती, अलगाव, अध्यात्म, परकीय कनेक्शन आणि आंतरिक उपचार हे महत्त्वाचे बनतात.",
    "Identity development and self-expression are central.": "ओळख विकास आणि आत्म-अभिव्यक्ती मध्यवर्ती आहेत.",
    "Values, money and self-worth become central.": "मूल्ये, पैसा आणि स्व-मूल्य हे केंद्रस्थानी बनतात.",
    "Communication, learning and skills become central.": "संवाद, शिक्षण आणि कौशल्ये केंद्रस्थानी आहेत.",
    "Home, roots and emotional foundation become central.": "घर, मुळे आणि भावनिक पाया मध्यवर्ती बनतात.",
    "Creativity, love and self-expression become central.": "सर्जनशीलता, प्रेम आणि आत्म-अभिव्यक्ती मध्यवर्ती बनतात.",
    "Work, discipline and health routines become central.": "काम, शिस्त आणि आरोग्य दिनचर्या केंद्रस्थानी बनतात.",
    "Partnerships and relationship identity become central.": "भागीदारी आणि नातेसंबंध ओळख मध्यवर्ती बनतात.",
    "Transformation, deep healing and shared resources become central.": "परिवर्तन, खोल उपचार आणि सामायिक संसाधने मध्यवर्ती बनतात.",
    "Wisdom, travel, belief and higher learning become central.": "शहाणपण, प्रवास, विश्वास आणि उच्च शिक्षण केंद्रस्थानी आहेत.",
    "Career, authority and public role become central.": "करिअर, अधिकार आणि सार्वजनिक भूमिका मध्यवर्ती बनतात.",
    "Community, income, goals and networks become central.": "समुदाय, उत्पन्न, उद्दिष्टे आणि नेटवर्क मध्यवर्ती बनतात.",
    "Spirituality, closure, retreat and inner development become central.": "अध्यात्म, बंदिस्त, माघार आणि आंतरिक विकास मध्यवर्ती बनतात.",
    "This house becomes emotionally important.": "हे घर भावनिकदृष्ट्या महत्त्वाचे बनते.",
    "This house becomes central for identity development.": "हे घर ओळख विकासासाठी केंद्रस्थानी बनते.",
    "Thinking, communication, learning and decisions are developing through this house.": "या घरातून विचार, संवाद, शिकणे आणि निर्णय विकसित होत आहेत.",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "या घरातून प्रेम, आराम, मूल्ये, सौंदर्य आणि पैशाची प्राधान्ये विकसित होत आहेत.",
    "Action style, courage, ambition and drive are developing through this house.": "या घरातून कृतीशैली, धाडस, महत्त्वाकांक्षा आणि ड्राइव्ह विकसित होत आहे.",
    "Growth, faith, learning and expansion themes develop through this house.": "या घरातून वाढ, विश्वास, शिक्षण आणि विस्ताराच्या थीम विकसित होतात.",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "या घरातून परिपक्वता, जबाबदारी, शिस्त आणि दीर्घकालीन रचना विकसित होते.",
    "This progressed planet shows an inner life phase through this house.": "हा प्रगतीशील ग्रह या घराद्वारे आंतरिक जीवनाचा टप्पा दर्शवतो.",
    "New Moon Phase": "नवीन चंद्राचा टप्पा",
    "New beginning, identity reset and fresh internal cycle.": "नवीन सुरुवात, ओळख रीसेट आणि नवीन अंतर्गत चक्र.",
    "Crescent Phase": "चंद्रकोर टप्पा",
    "Growth, effort, learning and building confidence.": "वाढ, प्रयत्न, शिकणे आणि आत्मविश्वास वाढवणे.",
    "First Quarter Phase": "पहिला तिमाही टप्पा",
    "Action, decision-making, pressure and development.": "कृती, निर्णयक्षमता, दबाव आणि विकास.",
    "Gibbous Phase": "गिबस फेज",
    "Refinement, improvement, preparation and skill-building.": "परिष्करण, सुधारणा, तयारी आणि कौशल्य-निर्मिती.",
    "Full Moon Phase": "पूर्ण चंद्र टप्पा",
    "Visibility, relationship awareness, emotional clarity and results.": "दृश्यमानता, नातेसंबंध जागरूकता, भावनिक स्पष्टता आणि परिणाम.",
    "Disseminating Phase": "प्रसार टप्पा",
    "Sharing, teaching, communication and distributing experience.": "अनुभव सामायिक करणे, शिकवणे, संप्रेषण करणे आणि वितरण करणे.",
    "Last Quarter Phase": "शेवटचा तिमाही टप्पा",
    "Reorientation, correction, release and mature decision-making.": "पुनर्रचना, सुधारणा, प्रकाशन आणि परिपक्व निर्णय घेणे.",
    "Balsamic Phase": "बाल्सामिक टप्पा",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "बंद, आध्यात्मिक प्रतिबिंब, विश्रांती आणि नवीन चक्राची तयारी.",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "एक मोठा भावनिक आणि ओळखीचा टप्पा सुरू होतो. एखाद्या व्यक्तीला नवीन अध्यायासाठी तयार वाटू शकते.",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "भावनिक रीसेट कालावधी. कौटुंबिक, सांत्वन, आंतरिक शांती आणि भावनिक गरजा महत्त्वाच्या बनतात.",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "प्रेम, नातेसंबंध, आराम, सौंदर्य आणि भावनिक बंध महत्त्वाचे ठरतात.",
    "Emotional needs and relationship expectations may need adjustment.": "भावनिक गरजा आणि नातेसंबंधांच्या अपेक्षांना समायोजन आवश्यक असू शकते.",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "ऊर्जा, उत्कटता, अधीरता आणि कृती वाढते. भावनिक प्रतिक्रिया जलद होऊ शकतात.",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "भावनिक अस्वस्थता, राग, संघर्ष किंवा तातडीची कारवाई वाढू शकते.",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "एक गंभीर भावनिक टप्पा. जबाबदारी, परिपक्वता, कौटुंबिक दबाव किंवा आंतरिक शिस्त वाढू शकते.",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "भावनिक जडपणा किंवा जबाबदारी जाणवू शकते. संयम आणि परिपक्वता आवश्यक आहे.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "सहाय्यक भावनिक वाढ, आशावाद, प्रवास, शिक्षण आणि आशीर्वाद वाढू शकतात.",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "वाढ-उन्मुख भावनिक टप्पा. शिकण्यासाठी, विस्तारासाठी, समर्थनासाठी आणि सकारात्मक निर्णयांसाठी चांगले.",
    "Identity, love, beauty, money values and creative expression become highlighted.": "ओळख, प्रेम, सौंदर्य, पैशाची मूल्ये आणि सर्जनशील अभिव्यक्ती हायलाइट होतात.",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "आत्मविश्वास, धैर्य, महत्त्वाकांक्षा आणि कृती वाढते. नवीन सक्रिय टप्पा सुरू करण्यासाठी चांगले.",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "एक परिपक्वता चाचणी. जबाबदारी, विलंब, दबाव किंवा करिअरची पुनर्रचना होऊ शकते.",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "वाढ, आत्मविश्वास, शहाणपण, ओळख आणि संधी वाढू शकतात.",
    "Mental clarity, communication, study, writing and business decisions become important.": "मानसिक स्पष्टता, संवाद, अभ्यास, लेखन आणि व्यावसायिक निर्णय महत्त्वाचे ठरतात.",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "एक नवीन मानसिक चक्र सुरू होते. शिकणे, संवाद, लेखन आणि कौशल्य विकासासाठी चांगले.",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "प्रेम, सौंदर्य, आराम, सामाजिक जीवन आणि मूल्ये ओळखीशी घट्ट जोडली जातात.",
    "Action, confidence, ambition and personal drive become stronger.": "कृती, आत्मविश्वास, महत्त्वाकांक्षा आणि वैयक्तिक ड्राइव्ह मजबूत होतात.",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "प्रगतीशील बुध शिक्षण, संप्रेषण, व्यवसाय, लेखन, विपणन, कोडिंग किंवा विश्लेषणात्मक कार्यास समर्थन देतो.",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "प्रगतीशील मंगळ कृती, धैर्य, स्पर्धा, तांत्रिक कार्य आणि सक्रिय करिअर निर्णयांना समर्थन देतो.",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "प्रगतीशील शुक्र आर्थिक मूल्ये, आराम, नफा, लक्झरी, कला किंवा नातेसंबंध-आधारित उत्पन्न थीमला समर्थन देतो.",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "प्रगतीशील बृहस्पति विकास-उन्मुख आर्थिक विचार आणि संसाधनांचा विस्तार दर्शवू शकतो.",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "करिअरचा टप्पा प्रगतीशील सूर्य, चंद्र, बुध, मंगळ आणि जन्मजात सूर्य, शनि आणि मध्यहवन या पैलूंवरून न्यायला पाहिजे.",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "प्रगल्भ चंद्र, शुक्र, मंगळ आणि जन्म चंद्र, शुक्र, मंगळ आणि 7 व्या घरापर्यंतच्या पैलूंवरून प्रेमाचा टप्पा निश्चित केला पाहिजे.",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "प्रगतीशील चंद्र, शुक्र, गुरू आणि जन्मत: 2रा, 8वा आणि 11वा घरातील संबंधांवरून पैशाची अवस्था ठरवली पाहिजे.",
    "Western Astrology - Kundlistar": "पाश्चात्य ज्योतिष - Kundlistar",
    "No chart data available for preview": "पूर्वावलोकनासाठी कोणताही चार्ट डेटा उपलब्ध नाही",
    "Failed to load chart": "चार्ट लोड करण्यात अयशस्वी",
    "Chart not found": "चार्ट सापडला नाही",
    "Western Astrology Module | Kundlistar": "पाश्चात्य ज्योतिष विभाग | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "Kundlistar मध्ये नेटल चार्ट पोझिशन्स, प्लॅसिडस हाऊस कस्प्स, बाह्य ग्रह आणि प्रीमियम ट्रान्झिट्स, सोलर रिटर्न आणि सिनेस्ट्री वैशिष्ट्यांसह पाश्चात्य ज्योतिषशास्त्र एक्सप्लोर करा.",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "पाश्चात्य ज्योतिष, नेटल चार्ट, संक्रमण, सौर परतावा, सिनेस्ट्री, Kundlistar",
    "New section": "नवीन विभाग",
    "Premium active": "प्रीमियम सक्रिय",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "घर प्रणाली",
    "Placidus cusps": "Placidus cusps",
    "Part of Fortune": "भाग्याचा भाग",
    "Natal Western Aspects": "नेटल पाश्चात्य पैलू",
    "No major Western aspects found within the configured orbs.": "कॉन्फिगर केलेल्या ऑर्ब्समध्ये कोणतेही प्रमुख पाश्चात्य पैलू आढळले नाहीत.",
    "Western natal astrology wheel": "पाश्चात्य जन्मजात ज्योतिष चक्र",
    "Western Transits": "वेस्टर्न ट्रांझिट्स",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "लोड केलेले चार्ट जन्मस्थान वापरून वर्तमान संक्रमण-ते-जन्म गणना.",
    "Natal points available": "नेटल पॉइंट्स उपलब्ध",
    "Transit planets loaded": "पारगमन ग्रह भारले",
    "Loading current transit positions...": "वर्तमान संक्रमण पोझिशन्स लोड करत आहे...",
    "Aspect method": "पैलू पद्धत",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "पाश्चात्य ऑर्ब्ससह संयोग, सेक्स्टाइल, स्क्वेअर, ट्राइन आणि विरोध",
    "Primary focus": "प्राथमिक फोकस",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "जन्मजात सूर्य, चंद्र, आरोह, शुक्र, मंगळ, गुरू, शनि आणि बाह्य ग्रहांशी संक्रमण संपर्क",
    "Natal inner wheel": "जन्मजात आतील चाक",
    "Transit outer wheel": "पारगमन बाह्य चाक",
    "Current Transit Positions": "वर्तमान संक्रमण पोझिशन्स",
    "Transit positions are not available.": "ट्रान्झिट पोझिशन्स उपलब्ध नाहीत.",
    "Current Transit Aspects to Natal Chart": "नेटल चार्टवरील वर्तमान संक्रमण पैलू",
    "Loading transit aspects...": "परिवहन पैलू लोड करत आहे...",
    "No major transit aspects found within the configured orbs.": "कॉन्फिगर केलेल्या orbs मध्ये कोणतेही प्रमुख संक्रमण पैलू आढळले नाहीत.",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "जन्मजात सूर्याचा वार्षिक पाश्चात्य परतीचा संदर्भ, सपोर्टिंग नेटल आस्पेक्ट संदर्भासह.",
    "Solar return date": "सौर परतावा तारीख",
    "Calculation time": "गणना वेळ",
    "Birth date not available": "जन्मतारीख उपलब्ध नाही",
    "Natal Sun": "जन्मजात सूर्य",
    "Natal Sun house": "जन्मजात सूर्य घर",
    "Return planets loaded": "भारलेले ग्रह परत करा",
    "Loading solar return chart...": "सौर परतावा चार्ट लोड करत आहे...",
    "Annual focus": "वार्षिक फोकस",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "सौर थीम जन्मजात सूर्य, रिटर्न असेंडंट आणि वार्षिक रिटर्न चार्ट पासून वाचल्या जातात.",
    "Solar Return Planet Positions": "सौर परतावा ग्रह स्थिती",
    "Loading solar return planets...": "सौर परतावा ग्रह लोड करत आहे...",
    "Solar return positions are not available.": "सोलर रिटर्न पोझिशन्स उपलब्ध नाहीत.",
    "Solar Return House Cusps": "सौर रिटर्न हाऊस Cusps",
    "Loading solar return cusps...": "सोलर रिटर्न कस्प लोड करत आहे...",
    "Solar return house cusps are not available.": "सोलर रिटर्न हाऊस कस्प उपलब्ध नाहीत.",
    "Solar Return Aspects to Natal Chart": "नेटल चार्टवर सौर परतावा पैलू",
    "Loading solar return aspects...": "सौर परतावा पैलू लोड करत आहे...",
    "No major solar return aspects found within the configured orbs.": "कॉन्फिगर केलेल्या ऑर्ब्समध्ये कोणतेही प्रमुख सौर परतावा पैलू आढळले नाहीत.",
    "Natal Sun Aspects for Solar Return Focus": "सोलर रिटर्न फोकससाठी जन्मजात सूर्य पैलू",
    "No major natal Sun aspects found within the configured orbs.": "कॉन्फिगर केलेल्या ऑर्ब्समध्ये जन्मजात सूर्याचे कोणतेही प्रमुख पैलू आढळले नाहीत.",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "ग्रह-ते-ग्रह पैलू, कोन संपर्क आणि घर आच्छादन वापरून नातेसंबंध आच्छादन फ्रेमवर्क.",
    "Loaded first chart": "पहिला चार्ट लोड केला",
    "Second chart": "दुसरा तक्ता",
    "Select or load partner chart to calculate full synastry overlay": "पूर्ण सिनेस्ट्री आच्छादनाची गणना करण्यासाठी भागीदार चार्ट निवडा किंवा लोड करा",
    "Major inter-chart aspects with tight orb priority": "घट्ट ऑर्ब प्राधान्यासह प्रमुख आंतर-चार्ट पैलू",
    "House overlay method": "घर आच्छादन पद्धत",
    "Partner planets are placed into the first chart houses after second chart is selected": "दुसरा चार्ट निवडल्यानंतर भागीदार ग्रह पहिल्या चार्ट हाऊसमध्ये ठेवले जातात",
    "Relationship Pattern Aspects from Loaded Chart": "लोड केलेल्या चार्टवरून नातेसंबंध नमुना पैलू",
    "No major relationship-focused natal aspects found within the configured orbs.": "कॉन्फिगर केलेल्या ऑर्ब्समध्ये कोणतेही प्रमुख संबंध-केंद्रित जन्मजात पैलू आढळले नाहीत.",
    "Understand your current inner life phase through Western Secondary Progressions.": "पाश्चात्य दुय्यम प्रगतीद्वारे तुमचा सध्याचा अंतर्गत जीवनाचा टप्पा समजून घ्या.",
    "Secondary Progression": "दुय्यम प्रगती",
    "1 day after birth = 1 year of life": "जन्मानंतर 1 दिवस = आयुष्याचे 1 वर्ष",
    "Current age used": "वर्तमान वय वापरले",
    "Progressed date": "प्रगती तारीख",
    "Progressed Moon": "प्रगती झालेला चंद्र",
    "Loading progressed Moon...": "प्रगतीशील चंद्र लोड करत आहे...",
    "Progressed Moon phase": "प्रगती झालेला चंद्र टप्पा",
    "Loading Moon phase...": "चंद्राचा टप्पा लोड करत आहे...",
    "Current Life Phase": "चालू जीवनाचा टप्पा",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "दुय्यम प्रगती जीवनाचा अंतर्गत टप्पा, भावनिक परिपक्वता, ओळख विकास आणि बदलत्या प्राधान्यक्रम दर्शविते.",
    "Progressed Career Phase": "प्रगतीशील करिअरचा टप्पा",
    "Progressed Love Phase": "प्रगत प्रेम टप्पा",
    "Progressed Money Phase": "प्रगत मनी टप्पा",
    "Loading progressed planets...": "प्रगती केलेले ग्रह लोड करत आहे...",
    "Progressed planets are not available.": "प्रगतीशील ग्रह उपलब्ध नाहीत.",
    "Loading progressed aspects...": "प्रगती केलेले पैलू लोड करत आहे...",
    "No tight progressed-to-natal aspects found right now.": "आत्ता कोणतेही घट्ट प्रगती-ते-जन्म पैलू आढळले नाहीत.",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "हा टप्पा प्रगतीशील ग्रह, प्रगतीशील चंद्राचा टप्पा आणि घट्ट प्रगती-ते-जन्म पैलूंवरून न्यायला पाहिजे.",
    "Vastu Analysis - Kundlistar": "वास्तु विश्लेषण - Kundlistar",
    "Failed to load selected chart.": "निवडलेला चार्ट लोड करण्यात अयशस्वी.",
    "Facing Direction": "दिशेला तोंड",
    "Entrance Direction": "प्रवेशाची दिशा",
    "Kitchen Direction": "स्वयंपाकघर दिशा",
    "Master Bedroom": "मास्टर बेडरूम",
    "Children Bedroom": "मुलांची शयनकक्ष",
    "Toilet Direction": "शौचालयाची दिशा",
    "Pooja Direction": "पूजा दिग्दर्शन",
    "Water Tank": "पाण्याची टाकी",
    "Underground Water": "भूगर्भातील पाणी",
    "Heavy Storage": "हेवी स्टोरेज",
    "Living Room": "लिव्हिंग रूम",
    "Study Room": "अभ्यास कक्ष",
    "Vastu report generation failed.": "वास्तू अहवाल निर्मिती अयशस्वी.",
    "Please generate the Vastu report before downloading.": "कृपया डाउनलोड करण्यापूर्वी वास्तु अहवाल तयार करा.",
    "Failed to download Vastu report.": "वास्तु अहवाल डाउनलोड करण्यात अयशस्वी.",
    "Premium Feature": "प्रीमियम वैशिष्ट्य",
    "Selected Chart": "निवडलेला तक्ता",
    "Basic + KP + BNN from chart": "चार्टवरून बेसिक + KP + BNN",
    "Basic shown, KP + BNN locked": "मूळ दाखवले, KP + BNN लॉक केले",
    "Property Type": "मालमत्तेचा प्रकार",
    "Center Area": "केंद्र क्षेत्र",
    "Generate Vastu Report": "वास्तु अहवाल तयार करा",
    "Basic Vastu Analysis": "मूलभूत वास्तु विश्लेषण",
    "KP Vastu Analysis": "केपी वास्तु विश्लेषण",
    "BNN Vastu Analysis": "BNN वास्तू विश्लेषण",
    "North East": "उत्तर पूर्व",
    "South East": "दक्षिण पूर्व",
    "South West": "दक्षिण पश्चिम",
    "North West": "उत्तर पश्चिम",
    "Red Coral": "लाल कोरल",
    "Yellow Sapphire": "पिवळा नीलमणी",
    "Blue Sapphire": "निळा नीलम",
    "Cat's Eye": "मांजर डोळा",
    "Additional Option": "अतिरिक्त पर्याय",
    "Lagna rule supports this gemstone option.": "लग्नाचा नियम या रत्न पर्यायाला समर्थन देतो.",
    "Moon sign rule supports this gemstone option.": "चंद्र चिन्हाचा नियम या रत्न पर्यायाला समर्थन देतो.",
    "Birth date rule supports this gemstone option.": "जन्मतारीख नियम या रत्न पर्यायाचे समर्थन करतो.",
    "Birth weekday rule supports this gemstone option.": "जन्मदिवसाचा नियम या रत्न पर्यायाला समर्थन देतो.",
    "Current dasha rule supports this gemstone option.": "सध्याचा दशा नियम या रत्न पर्यायाला समर्थन देतो.",
    "Age-band rule supports this gemstone option.": "वय-बँड नियम या रत्न पर्यायाला समर्थन देतो.",
    "Selected goal supports this gemstone option.": "निवडलेले ध्येय या रत्न पर्यायाचे समर्थन करते.",
    "Profession rule supports this gemstone option.": "व्यवसाय नियम या रत्न पर्यायाचे समर्थन करतो.",
    "Name-initial rule supports this gemstone option.": "नाव-प्रारंभिक नियम या रत्न पर्यायाला समर्थन देतो.",
    "Moolank rule supports this gemstone option.": "मूलांक नियम या रत्न पर्यायाचे समर्थन करतो.",
    "Chart condition check was considered for this option.": "या पर्यायासाठी चार्ट कंडिशन चेकचा विचार केला गेला.",
    "Rule-based chart match supports this gemstone option.": "नियम-आधारित चार्ट जुळणी या रत्न पर्यायाला समर्थन देते.",
    "Expert kundli review is recommended before wearing this gemstone.": "हे रत्न परिधान करण्यापूर्वी तज्ञ कुंडलीचे पुनरावलोकन करण्याची शिफारस केली जाते.",
    "Ring finger": "अनामिका",
    "Little finger": "करंगळी",
    "Index finger": "तर्जनी",
    "Middle finger": "मधले बोट",
    "Why recommended": "का शिफारस केली",
    "Approx weight": "अंदाजे वजन",
    "Could not load chart.": "चार्ट लोड करू शकलो नाही.",
    "Gemstone Recommendations | Kundlistar": "रत्न शिफारशी | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar च्या नियम-आधारित कुंडली विश्लेषण इंजिनकडून वैदिक रत्न शिफारशींचे अन्वेषण करा.",
    "noindex,nofollow": "noindex, nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "रत्न शिफारस, वैदिक रत्न, कुंडली रत्न, Kundlistar",
    "Gemstone Recommendations": "रत्न शिफारशी",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "लग्न, चंद्र राशी, दशा, DOB, व्यवसाय आणि ध्येयांवर आधारित वैदिक रत्न मार्गदर्शनासाठी वेगळे Kundlistar मॉड्यूल.",
    "Personalized Gemstone Recommendations are available for Premium users.": "प्रीमियम वापरकर्त्यांसाठी वैयक्तिकृत रत्न शिफारशी उपलब्ध आहेत.",
    "Upgrade to Premium": "प्रीमियम वर श्रेणीसुधारित करा",
    "Login to Upgrade": "अपग्रेड करण्यासाठी लॉग इन करा",
    "Select Goal": "ध्येय निवडा",
    "Business, government job, teacher...": "व्यवसाय, सरकारी नोकरी, शिक्षक...",
    "Weight kg": "वजन किलो",
    "वजन kg": "२ किलो",
    "Optional ratti estimate": "पर्यायी रत्ती अंदाज",
    "Click Calculate to apply these values.": "ही मूल्ये लागू करण्यासाठी गणना करा क्लिक करा.",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi ?",
    "Nadi Analysis": "नाडी विश्लेषण",
    "KP Analysis": "केपी विश्लेषण",
    "Vedic Analysis": "वैदिक विश्लेषण",
    "BNN Analysis": "BNN विश्लेषण",
    "Jaimini Analysis": "जैमिनी विश्लेषण",
    "Western Astrology": "पाश्चात्य ज्योतिष",
    "Panch Pakshi": "पंचपक्षी",
    "Tithi Pravesh": "तिथी प्रवेश",
    "Lal Kitab": "लाल किताब",
    "Astro Logo": "खगोल लोगो",
    "Download failed": "डाउनलोड अयशस्वी",
    "Could not download PDF report.": "PDF अहवाल डाउनलोड करू शकलो नाही.",
    "Please login to download PDF reports.": "कृपया PDF अहवाल डाउनलोड करण्यासाठी लॉग इन करा.",
    "Failed to generate personalised report": "वैयक्तिकृत अहवाल व्युत्पन्न करण्यात अयशस्वी",
    "Could not download personalised report.": "वैयक्तिकृत अहवाल डाउनलोड करू शकलो नाही.",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--कुंडलिस्टर-नवबार-उंची, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "कॅल्क(100vh - var(--कुंडलिस्टर-नवबार-उंची, 160px))",
    "width 0.2s ease": "रुंदी 0.2s सहज",
    "Collapse sidebar": "साइडबार संकुचित करा",
    "Expand sidebar": "साइडबार विस्तृत करा",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-रूट",
    "Download PDF Report": "पीडीएफ अहवाल डाउनलोड करा",
    "Login to download": "डाउनलोड करण्यासाठी लॉग इन करा",
    "PDF Report": "पीडीएफ अहवाल",
    "Download Personal Report": "वैयक्तिक अहवाल डाउनलोड करा",
    "Buy Premium to download": "डाउनलोड करण्यासाठी प्रीमियम खरेदी करा",
    "Login to buy Premium": "प्रीमियम खरेदी करण्यासाठी लॉग इन करा",
    "Buy Premium": "प्रीमियम खरेदी करा",
    "& .MuiTab-root": "& .MuiTab-रूट",
    "& .Mui-selected": "& .Mui-निवडलेले",
    "Unable to load Client Management data.": "क्लायंट व्यवस्थापन डेटा लोड करण्यात अक्षम.",
    "Unable to download PDF.": "PDF डाउनलोड करण्यात अक्षम.",
    "Free client limit reached": "मोफत क्लायंट मर्यादा गाठली",
    "Welcome": "स्वागत आहे",
    "Hello": "नमस्कार",
    "Your saved charts are shown below.": "तुमचे सेव्ह केलेले चार्ट खाली दाखवले आहेत.",
    "All Features": "सर्व वैशिष्ट्ये",
    "New Chart": "नवीन चार्ट",
    "Vedic Chart": "वैदिक तक्ता",
    "Chakra": "चक्र",
    "Daily Panchang": "रोजचे पंचांग",
    "Choghadiya": "चोघडिया",
    "Daily Horoscope": "दैनिक पत्रिका",
    "Gochar Alerts": "गोचर अलर्ट",
    "Matching": "जुळणारे",
    "Ruling Planets": "सत्ताधारी ग्रह",
    "Horary Chart": "Horary चार्ट",
    "Astro-Vastu": "खगोल-वास्तू",
    "Vedic Numerology": "वैदिक अंकशास्त्र",
    "My Charts": "माझे चार्ट",
    "Search by Name": "नावाने शोधा",
    "Type": "प्रकार",
    "All": "सर्व",
    "Individual": "वैयक्तिक",
    "Horary": "होररी",
    "Clear": "साफ",
    "Name": "नाव",
    "DOB": "डीओबी",
    "Place": "ठिकाण",
    "Gender": "लिंग",
    "Created": "तयार केले",
    "Actions": "क्रिया",
    "Male": "पुरुष",
    "Female": "स्त्री",
    "No matching charts found": "कोणतेही जुळणारे चार्ट आढळले नाहीत",
    "Create First Chart": "प्रथम चार्ट तयार करा",
    "View Chart": "चार्ट पहा",
    "Copy Share Link": "शेअर लिंक कॉपी करा",
    "Use premium credit: Download PDF Report": "प्रीमियम क्रेडिट वापरा: PDF अहवाल डाउनलोड करा",
    "Download Personalised Report": "वैयक्तिकृत अहवाल डाउनलोड करा",
    "Premium: Download Personalised Report": "प्रीमियम: वैयक्तिकृत अहवाल डाउनलोड करा",
    "Hide Chart": "चार्ट लपवा",
    "Personalised": "वैयक्तिकृत",
    "Generating your Personalised Report": "तुमचा वैयक्तिकृत अहवाल व्युत्पन्न करत आहे",
    "Please do not leave this page till the report is generated. This can take a little while.": "अहवाल तयार होईपर्यंत कृपया हे पृष्ठ सोडू नका. यास थोडा वेळ लागू शकतो.",
    "Please don't leave this page till the report is generated. This can take a little while.": "अहवाल तयार होईपर्यंत कृपया हे पृष्ठ सोडू नका. यास थोडा वेळ लागू शकतो.",
    "Update": "अपडेट करा",
    "Complete your billing address. Required for generating invoice.": "तुमचा बिलिंग पत्ता पूर्ण करा. बीजक व्युत्पन्न करण्यासाठी आवश्यक.",
    "Report this report": "हा अहवाल कळवा",
    "Reason": "कारण",
    "Optional comment": "पर्यायी टिप्पणी",
    "Submit": "सबमिट करा",
    "Incorrect info": "चुकीची माहिती",
    "Offensive": "आक्षेपार्ह",
    "Harmful": "हानीकारक",
    "This report has been sent for review.": "हा अहवाल पुनरावलोकनासाठी पाठवण्यात आला आहे.",
    "Failed to submit report feedback": "अहवाल फीडबॅक सबमिट करण्यात अयशस्वी",
    "Failed to download PDF": "PDF डाउनलोड करण्यात अयशस्वी",
    "Failed to download personalised report": "वैयक्तिकृत अहवाल डाउनलोड करण्यात अयशस्वी",
    "Failed to load charts": "चार्ट लोड करण्यात अयशस्वी",
    "Failed to hide chart": "चार्ट लपवण्यात अयशस्वी",
    "Failed to delete chart": "चार्ट हटवण्यात अयशस्वी",
    "Share link copied to clipboard!": "लिंक शेअर करा क्लिपबोर्डवर कॉपी केली!",
    "Delete Chart": "चार्ट हटवा",
    "Delete chart": "चार्ट हटवा",
    "Error": "त्रुटी",
    "OK": "ठीक आहे",
    "Thanks": "धन्यवाद",
    "Report failed": "अहवाल अयशस्वी",
    "Could not submit report feedback.": "अहवाल अभिप्राय सबमिट करू शकलो नाही.",
    "Personalised report ready": "वैयक्तिकृत अहवाल तयार आहे",
    "Personalised report failed": "वैयक्तिकृत अहवाल अयशस्वी",
    "Could not generate personalised report.": "वैयक्तिकृत अहवाल व्युत्पन्न करू शकलो नाही.",
    "Could not generate personalised PDF report.": "वैयक्तिकृत PDF अहवाल व्युत्पन्न करू शकलो नाही.",
    "Monthly limit reached": "मासिक मर्यादा गाठली",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "तुमची मासिक वैयक्तिकृत अहवाल मर्यादा गाठली आहे. ॲड-ऑनची सदस्यता घ्या: 20 अहवालांसाठी ₹299/महिना किंवा 40 अहवालांसाठी ₹499/महिना.",
    "Buy Add-on": "ॲड-ऑन खरेदी करा",
    "Manage": "व्यवस्थापित करा",
    "Add-on active: Unlimited reports": "ऍड-ऑन सक्रिय: अमर्यादित अहवाल",
    "Add-on active: 40 reports/month": "ऍड-ऑन सक्रिय: 40 अहवाल/महिना",
    "Add-on active: 20 reports/month": "ऍड-ऑन सक्रिय: 20 अहवाल/महिना",
    "reports remaining this cycle": "हे चक्र बाकीचे अहवाल",
    "Add-on active": "ॲड-ऑन सक्रिय",
    "Personalised reports remaining this month": "वैयक्तिकृत अहवाल या महिन्यात शिल्लक आहेत",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "प्रीमियममध्ये २/महिना समाविष्ट आहे. ॲड-ऑन: 20 रिपोर्ट्स/महिनासाठी ₹299/महिना किंवा 40 रिपोर्ट्स/महिन्यासाठी ₹499/महिना.",
    "AI Disclaimer": "AI अस्वीकरण",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "हा अहवाल AI आणि ज्योतिषशास्त्रीय व्याख्या वापरून तयार केला आहे. हे केवळ माहिती आणि मनोरंजनाच्या उद्देशाने आहे. तो वैद्यकीय, कायदेशीर किंवा आर्थिक सल्ला मानला जाऊ नये.",
    "A copy of this report has also been sent to your registered email address as a PDF.": "या अहवालाची एक प्रत पीडीएफ म्हणून तुमच्या नोंदणीकृत ईमेल पत्त्यावरही पाठवली आहे.",
    "Report this AI-generated report?": "या AI-व्युत्पन्न अहवालाची तक्रार करायची?",
    "charts": "तक्ते",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "स्वतंत्र नोट्स, तारीख आणि वेळेचे नियोजन. जतन करण्यासाठी लॉगिन आवश्यक आहे; विनामूल्य वापरकर्त्यांना पूर्ण नियोजक प्रवेश मिळतो.",
    "Independent notes, date and time planning.": "स्वतंत्र नोट्स, तारीख आणि वेळेचे नियोजन.",
    "Add Plan": "योजना जोडा",
    "Save Plan": "योजना जतन करा",
    "Saved Plans": "जतन केलेल्या योजना",
    "Planner Entry": "प्लॅनर एंट्री",
    "Plan": "योजना",
    "Saving...": "सेव्ह करत आहे...",
    "Refresh": "रिफ्रेश करा",
    "No plans saved yet.": "अद्याप कोणतीही योजना जतन केलेली नाही.",
    "Planner layout is available. Login only when you want to save.": "प्लॅनर लेआउट उपलब्ध आहे. जेव्हा तुम्हाला सेव्ह करायचे असेल तेव्हाच लॉग इन करा.",
    "No matching plans.": "जुळणाऱ्या योजना नाहीत.",
    "Search Plans": "योजना शोधा",
    "Search title, note, date or status": "शीर्षक, टीप, तारीख किंवा स्थिती शोधा",
    "Login is required only when you want to save planner entries.": "जेव्हा तुम्हाला प्लॅनर नोंदी जतन करायच्या असतील तेव्हाच लॉगिन आवश्यक आहे.",
    "Planner entry saved.": "प्लॅनर एंट्री सेव्ह केली.",
    "Unable to load planner.": "प्लॅनर लोड करण्यात अक्षम.",
    "Unable to save planner entry.": "प्लॅनर एंट्री जतन करण्यात अक्षम.",
    "Could not load planner.": "प्लॅनर लोड करू शकलो नाही.",
    "Could not save planner entry.": "प्लॅनर एंट्री सेव्ह करू शकलो नाही.",
    "Login required to save": "सेव्ह करण्यासाठी लॉगिन आवश्यक आहे",
    "You can explore Planner now. Login when you want to save entries.": "तुम्ही आता प्लॅनर एक्सप्लोर करू शकता. तुम्हाला नोंदी जतन करायच्या असतील तेव्हा लॉगिन करा.",
    "Prev": "मागील",
    "Next": "पुढे",
    "Page": "पान",
    "of": "च्या",
    "Child Birth Mahoorat": "बाळंतपण महूरत",
    "Child Birth Mahoorat | Kundlistar Premium": "बाळंतपण महूरत | कुंडलिस्टर प्रीमियम",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "पंचांग, ​​चोघडिया आणि होरा आधारित मार्गदर्शनासह प्रीमियम चाइल्ड बर्थ माहूरत विंडो.",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "नियोजित बाळाच्या जन्माच्या वेळेच्या मार्गदर्शनासाठी शुभ उपलब्ध विंडो एक्सप्लोर करण्यासाठी तारीख आणि ठिकाण निवडा.",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "बाल जन्म महूरत फक्त आध्यात्मिक आणि ज्योतिषीय मार्गदर्शनासाठी आहे.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "चाइल्ड बर्थ माहूरत हे प्रिमियम फीचर आहे. पंचांग, ​​चोघडिया आणि होरा चेकसह शुभ मार्गदर्शन विंडो अनलॉक करण्यासाठी अपग्रेड करा.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "चाइल्ड बर्थ माहूरत हे प्रिमियम फीचर आहे. पंचांग, ​​चोघडिया आणि होरा चेकसह मार्गदर्शन विंडो अनलॉक करण्यासाठी अपग्रेड करा.",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "तारीख, ठिकाण, पंचांग, ​​चोघडिया आणि होरा यानुसार प्रीमियम मार्गदर्शन विंडो.",
    "Premium feature": "प्रीमियम वैशिष्ट्य",
    "Upgrade to Kundlistar Premium": "Kundlistar Premium वर श्रेणीसुधारित करा",
    "Previous": "मागील",
    "Today": "आज",
    "Birth place / City": "जन्म ठिकाण / शहर",
    "Birth place / city": "जन्म ठिकाण / शहर",
    "Select country, then search city": "देश निवडा, नंतर शहर शोधा",
    "Preferred start": "पसंतीची सुरुवात",
    "Preferred end": "पसंतीचा शेवट",
    "Mother Moon sign (optional)": "मदर चंद्र चिन्ह (पर्यायी)",
    "Cancer": "कर्करोग",
    "Load Kundli": "कुंडली लोड करा",
    "Find Premium Windows": "प्रीमियम विंडोज शोधा",
    "Date (DD/MM/YYYY)": "तारीख (DD/MM/YYYY)",
    "Invalid Date": "अवैध तारीख",
    "Date must be in DD/MM/YYYY format.": "तारीख DD/MM/YYYY फॉरमॅटमध्ये असणे आवश्यक आहे.",
    "Required": "आवश्यक आहे",
    "Please select a city.": "कृपया शहर निवडा.",
    "Kundli": "कुंडली",
    "Unable to load kundli.": "कुंडली लोड करण्यात अक्षम.",
    "Unable to calculate Child Birth Mahoorat.": "मुलाच्या जन्माच्या माहूराची गणना करण्यात अक्षम.",
    "Kundli Preview": "कुंडली पूर्वावलोकन",
    "Loaded for": "साठी लोड केले",
    "Doshas & Yogas": "दोष आणि योग",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "लोड केलेल्या लाहिरी कुंडलीमधून नियम-आधारित संकेत. अंतिम निर्णय म्हणून नव्हे तर पुनरावलोकन आणि आध्यात्मिक मार्गदर्शनासाठी त्यांचा वापर करा.",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "लोड केलेल्या लाहिरी कुंडलीमधून नियम-आधारित संकेत. पुनरावलोकन आणि आध्यात्मिक मार्गदर्शनासाठी वापरा.",
    "Detected": "शोधले",
    "Not detected": "आढळले नाही",
    "Review": "पुनरावलोकन करा",
    "Dosha": "दोष",
    "Yoga": "योग",
    "Full Yoga Scan": "पूर्ण योग स्कॅन",
    "Checking yogas...": "योगासने तपासत आहे...",
    "No major yogas were detected by the premium yoga scan.": "प्रीमियम योग स्कॅनद्वारे कोणतेही मोठे योग आढळले नाहीत.",
    "No suitable premium windows found for the selected date and time range.": "निवडलेल्या तारीख आणि वेळ श्रेणीसाठी योग्य प्रीमियम विंडो आढळल्या नाहीत.",
    "No suitable windows found": "योग्य खिडक्या सापडल्या नाहीत",
    "Try changing the time range or select previous/next date.": "वेळ श्रेणी बदलण्याचा प्रयत्न करा किंवा मागील/पुढील तारीख निवडा.",
    "Try changing the date or time range.": "तारीख किंवा वेळ श्रेणी बदलण्याचा प्रयत्न करा.",
    "Try the Previous or Next date button to find a better option.": "एक चांगला पर्याय शोधण्यासाठी मागील किंवा पुढील तारीख बटण वापरून पहा.",
    "Use Previous or Next date to find a better option.": "चांगला पर्याय शोधण्यासाठी मागील किंवा पुढील तारीख वापरा.",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "निवडलेल्या तारखेसाठी आणि शहरासाठी सर्वोत्तम प्रीमियम विंडोची गणना करण्यासाठी प्रीमियम विंडोज शोधा क्लिक करा.",
    "Tap Find Premium Windows for the selected date and city.": "निवडलेल्या तारीख आणि शहरासाठी प्रीमियम विंडोज शोधा वर टॅप करा.",
    "Good tithi": "शुभ तिथी",
    "Supportive nakshatra": "सहाय्यक नक्षत्र",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "नक्षत्र संवेदनशील आहे. पाडा आणि गंडता काळजीपूर्वक तपासा.",
    "Supportive weekday": "सहाय्यक आठवड्याचा दिवस",
    "Good Choghadiya": "छान चोघडिया",
    "Weak Choghadiya": "दुर्बल चोघडिया",
    "Supportive Hora": "आश्वासक होरा",
    "Baby Moon matches mother's Moon sign.": "बेबी मून आईच्या चंद्र चिन्हाशी जुळतो.",
    "Hora": "होरा",
    "slots": "स्लॉट",
    "min": "मिनिटे",
    "Good": "चांगले",
    "Excellent": "उत्कृष्ट",
    "Usable": "वापरण्यायोग्य",
    "Rejected": "नाकारले",
    "Sunday": "रविवार",
    "Monday": "सोमवार",
    "Tuesday": "मंगळवार",
    "Wednesday": "बुधवार",
    "Thursday": "गुरुवार",
    "Friday": "शुक्रवार",
    "Saturday": "शनिवार",
    "Sun": "रवि",
    "Moon": "चंद्र",
    "Mars": "मंगळ",
    "Mercury": "बुध",
    "Jupiter": "बृहस्पति",
    "Venus": "शुक्र",
    "Saturn": "शनि",
    "Rahu": "राहू",
    "Ketu": "केतू",
    "Chal": "चाल",
    "Labh": "लभ",
    "Amrit": "अमृत",
    "Shubh": "शुभ",
    "Udveg": "उदवेग",
    "Rog": "रोग",
    "Kaal": "काळ",
    "Krishna Navami": "कृष्ण नवमी",
    "Ashwini": "अश्विनी",
    "Bharani": "भरणी",
    "Krittika": "कृतिका",
    "Rohini": "रोहिणी",
    "Mrigashira": "मृगाशिरा",
    "Ardra": "आर्द्रा",
    "Punarvasu": "पुनर्वसु",
    "Pushya": "पुष्य",
    "Ashlesha": "आश्लेषा",
    "Magha": "मघा",
    "Jyeshtha": "ज्येष्ठा",
    "Moola": "मुळा",
    "Mula": "मुळा",
    "Revati": "रेवती"
  },
  "gu": {
    "Client Management": "ક્લાયન્ટ મેનેજમેન્ટ",
    "Dashboard": "ડેશબોર્ડ",
    "Clients": "ગ્રાહકો",
    "Consultations": "પરામર્શ",
    "Notes": "નોંધો",
    "Follow-ups": "ફોલો-અપ્સ",
    "Reports": "અહેવાલો",
    "Remedies": "ઉપાયો",
    "Predictions": "અનુમાનો",
    "Planner": "પ્લાનર",
    "Templates": "નમૂનાઓ",
    "Analytics": "એનાલિટિક્સ",
    "Payments": "ચુકવણીઓ",
    "Settings": "સેટિંગ્સ",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings માં ડિફોલ્ટ શહેર સાચવી શકો છો. પસંદ ન થાય ત્યાં સુધી શહેર ફીલ્ડ ખાલી રહેશે.",
    "is now your default city.": "હવે તમારું ડિફોલ્ટ શહેર છે.",
    "Search your default city": "તમારું ડિફોલ્ટ શહેર શોધો",
    "This color is saved for the website theme and PDF report accent.": "આ રંગ વેબસાઇટ થીમ અને PDF રિપોર્ટ accent માટે સાચવાશે.",
    "Turn All off to include only the checked modules in the report.": "રિપોર્ટમાં ફક્ત પસંદ કરેલ મોડ્યુલ્સ માટે All બંધ કરો.",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All ચાલુ હોય ત્યારે PDF માં બધા મોડ્યુલ્સ આવશે. ફક્ત પસંદ કરેલ માટે તેને બંધ કરો.",
    "Uranus, Neptune and Pluto stay hidden by default.": "યુરેનસ, નેપચ્યુન અને પ્લૂટો ડિફોલ્ટથી છુપાયેલા રહે છે.",
    "Show Uranus, Neptune and Pluto": "યુરેનસ, નેપચ્યુન અને પ્લૂટો બતાવો",
    "When off, Nadi and KP also use the selected global ayanamsha.": "બંધ હોય ત્યારે નાડી અને KP પણ પસંદ કરેલ વૈશ્વિક અયનાંશ વાપરે છે.",
    "Use KP for Nadi and KP": "નાડી અને KP માટે KP વાપરો",
    "Use KP ayanamsha for Nadi and KP": "નાડી અને KP માટે KP અયનાંશ વાપરો",
    "Night": "નાઇટ",
    "Dark": "ડાર્ક",
    "Light": "લાઇટ",
    "Clear default city": "ડિફોલ્ટ શહેર દૂર કરો",
    "Default City": "ડિફોલ્ટ શહેર",
    "Default city": "ડિફોલ્ટ શહેર",
    "Theme Color": "થીમ રંગ",
    "Theme color": "થીમ રંગ",
    "Include all modules": "બધા મોડ્યુલ્સ સામેલ કરો",
    "PDF Report Modules": "PDF રિપોર્ટ મોડ્યુલ્સ",
    "PDF report modules": "PDF રિપોર્ટ મોડ્યુલ્સ",
    "Show": "બતાવો",
    "Hide": "છુપાવો",
    "Outer Planets": "બાહ્ય ગ્રહો",
    "Outer planets": "બાહ્ય ગ્રહો",
    "Ayanamsha": "અયનાંશ",
    "Mean Node": "મીન નોડ",
    "True Node": "ટ્રૂ નોડ",
    "Rahu/Ketu Calculation": "રાહુ/કેતુ ગણતરી",
    "Rahu/Ketu calculation": "રાહુ/કેતુ ગણતરી",
    "East": "પૂર્વ ભારતીય",
    "South": "દક્ષિણ ભારતીય",
    "North": "ઉત્તર ભારતીય",
    "Chart Style": "ચાર્ટ શૈલી",
    "Chart style": "ચાર્ટ શૈલી",
    "Language": "ભાષા",
    "Records": "રેકોર્ડ્સ",
    "Relations": "સંબંધો",
    "Relation": "સંબંધ",
    "Add Client": "ક્લાયન્ટ ઉમેરો",
    "Add Consultation": "પરામર્શ ઉમેરો",
    "Add Note": "નોંધ ઉમેરો",
    "Add Follow-up": "ફોલો-અપ ઉમેરો",
    "Create Report": "રિપોર્ટ બનાવો",
    "Assign Remedy": "ઉપાય સોંપો",
    "Add Prediction": "અનુમાન ઉમેરો",
    "Add Payment": "ચુકવણી ઉમેરો",
    "Assign Chart": "ચાર્ટ સોંપો",
    "Add Relation": "સંબંધ ઉમેરો",
    "CMS Action": "CMS ક્રિયા",
    "Client": "ક્લાયન્ટ",
    "Chart": "ચાર્ટ",
    "Related Client": "સંબંધિત ક્લાયન્ટ",
    "Full Name": "પૂરું નામ",
    "Phone Number": "ફોન નંબર",
    "WhatsApp Number": "વોટ્સએપ નંબર",
    "Email": "ઈમેલ",
    "Birth Place": "જન્મસ્થળ",
    "Current City": "વર્તમાન શહેર",
    "Main Topic": "મુખ્ય વિષય",
    "Status": "સ્થિતિ",
    "Source": "સ્ત્રોત",
    "Tags": "ટૅગ્સ",
    "Internal Note": "આંતરિક નોંધ",
    "Purpose": "હેતુ",
    "Relation Type": "સંબંધનો પ્રકાર",
    "Title": "શીર્ષક",
    "Topic": "વિષય",
    "Date": "તારીખ",
    "Time": "સમય",
    "Amount": "રકમ",
    "Mode": "મોડ",
    "Payment Status": "ચુકવણી સ્થિતિ",
    "Note / Summary": "નોંધ / સારાંશ",
    "Close": "બંધ કરો",
    "Cancel": "રદ કરો",
    "Save": "સાચવો",
    "Saving": "બચત",
    "Save Changes": "ફેરફારો સાચવો",
    "Edit Client": "ક્લાયંટ સંપાદિત કરો",
    "Client Chart": "ક્લાયન્ટ ચાર્ટ",
    "Comma separated": "અલ્પવિરામ અલગ",
    "Search by name, phone, email, topic, or tag": "નામ, ફોન, ઇમેઇલ, વિષય અથવા ટેગ દ્વારા શોધો",
    "Search clients, phone, topic": "ક્લાયંટ, ફોન, વિષય શોધો",
    "Search your saved charts by chart name": "ચાર્ટ નામ દ્વારા તમારા સાચવેલા ચાર્ટ્સ શોધો",
    "Linked Chart": "લિંક કરેલ ચાર્ટ",
    "Select linked chart": "લિંક કરેલ ચાર્ટ પસંદ કરો",
    "Link a chart to this client before adding records.": "રેકોર્ડ ઉમેરતા પહેલા આ ક્લાયન્ટ સાથે ચાર્ટ લિંક કરો.",
    "Connect this client with another saved client profile": "આ ક્લાયન્ટને બીજી સેવ કરેલી ક્લાયન્ટ પ્રોફાઇલ સાથે કનેક્ટ કરો",
    "CMS for astrologer client work": "જ્યોતિષ ક્લાયન્ટના કામ માટે CMS",
    "Premium Pro unlocks Client Management": "પ્રીમિયમ પ્રો ક્લાયન્ટ મેનેજમેન્ટને અનલૉક કરે છે",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ક્લાયંટ પ્રોફાઇલ્સ, પરામર્શ, નોંધો, ફોલો-અપ્સ, રિપોર્ટ્સ, ઉપાયો, આગાહીઓ, વિશ્લેષણો અને ચુકવણી ટ્રેકિંગને એક કાર્યસ્થળમાં સંચાલિત કરવા માટે અપગ્રેડ કરો.",
    "Upgrade to Premium Pro": "Premium Pro પર અપગ્રેડ કરો",
    "CMS modules included": "CMS મોડ્યુલો સમાવેશ થાય છે",
    "Please login to use Client Management. CMS data is stored per account.": "કૃપા કરીને ક્લાયન્ટ મેનેજમેન્ટનો ઉપયોગ કરવા માટે લૉગિન કરો. CMS ડેટા એકાઉન્ટ દીઠ સંગ્રહિત થાય છે.",
    "Login": "લૉગિન કરો",
    "Loading live CMS data...": "લાઇવ CMS ડેટા લોડ કરી રહ્યું છે...",
    "Quick Actions": "ઝડપી ક્રિયાઓ",
    "Client Records": "ક્લાયન્ટ રેકોર્ડ્સ",
    "Client Record": "ક્લાયન્ટ રેકોર્ડ",
    "Client Profile": "ક્લાયન્ટ પ્રોફાઇલ",
    "Back to Clients": "ગ્રાહકો પર પાછા",
    "View": "જુઓ",
    "Edit": "સંપાદિત કરો",
    "Delete": "કાઢી નાખો",
    "Note": "નોંધ",
    "Archive": "આર્કાઇવ",
    "Download PDF": "PDF ડાઉનલોડ કરો",
    "Delete this record?": "આ રેકોર્ડ ડિલીટ કરીએ?",
    "Unable to edit this CMS record.": "આ CMS રેકોર્ડ સંપાદિત કરવામાં અસમર્થ.",
    "Unable to update CMS record.": "CMS રેકોર્ડ અપડેટ કરવામાં અસમર્થ.",
    "Unable to delete CMS record.": "CMS રેકોર્ડ કાઢી નાખવામાં અસમર્થ.",
    "No contact added": "કોઈ સંપર્ક ઉમેર્યો નથી",
    "No topic": "કોઈ વિષય નથી",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "હજુ સુધી કોઈ ગ્રાહકો મળ્યા નથી. CMS ડેશબોર્ડ ભરવાનું શરૂ કરવા માટે તમારા પ્રથમ વાસ્તવિક ક્લાયન્ટને ઉમેરો.",
    "Last Consultation": "છેલ્લું કન્સલ્ટેશન",
    "Next Follow-up": "આગામી ફોલો-અપ",
    "Date of Birth": "જન્મ તારીખ",
    "Time of Birth": "જન્મ સમય",
    "Client Details": "ક્લાયન્ટ વિગતો",
    "No connected profiles yet.": "હજી સુધી કોઈ કનેક્ટેડ પ્રોફાઇલ નથી.",
    "Select a client record to view details.": "વિગતો જોવા માટે ક્લાયંટ રેકોર્ડ પસંદ કરો.",
    "Record": "રેકોર્ડ",
    "Consultation Summary": "પરામર્શ સારાંશ",
    "Client Note": "ગ્રાહક નોંધ",
    "Start a consultation record with summary, topic, mode and payment fields.": "સારાંશ, વિષય, મોડ અને ચુકવણી ક્ષેત્રો સાથે પરામર્શ રેકોર્ડ શરૂ કરો.",
    "Start a private note attached to a client profile.": "ક્લાયન્ટ પ્રોફાઇલ સાથે જોડાયેલ ખાનગી નોંધ શરૂ કરો.",
    "Start a pending follow-up with due date and topic.": "નિયત તારીખ અને વિષય સાથે બાકી ફોલો-અપ શરૂ કરો.",
    "Start a report record connected to the client timeline.": "ક્લાયંટ સમયરેખા સાથે જોડાયેલ રિપોર્ટ રેકોર્ડ શરૂ કરો.",
    "Start an active remedy record for client guidance.": "ક્લાયંટ માર્ગદર્શન માટે સક્રિય ઉપાય રેકોર્ડ શરૂ કરો.",
    "Start an open prediction record with notes and follow-up date.": "નોંધો અને ફોલો-અપ તારીખ સાથે ખુલ્લું અનુમાન રેકોર્ડ શરૂ કરો.",
    "Statuses": "સ્ટેટસ",
    "Topics": "વિષયો",
    "Sources": "સ્ત્રોતો",
    "No records found for the current filters.": "વર્તમાન ફિલ્ટર્સ માટે કોઈ રેકોર્ડ્સ મળ્યા નથી.",
    "Total Clients": "કુલ ગ્રાહકો",
    "New Clients This Month": "આ મહિને નવા ગ્રાહકો",
    "Consultations This Month": "આ મહિને પરામર્શ",
    "Today's Consultations": "આજની પરામર્શ",
    "Consultations scheduled for today from real client records.": "વાસ્તવિક ક્લાયંટ રેકોર્ડ્સમાંથી આજે માટે સુનિશ્ચિત થયેલ પરામર્શ.",
    "No consultations scheduled for today.": "આજે માટે કોઈ પરામર્શ સુનિશ્ચિત થયેલ નથી.",
    "Pending Follow-ups": "બાકી ફોલો-અપ્સ",
    "Reports Created": "અહેવાલો બનાવ્યા",
    "Active Remedies": "સક્રિય ઉપાયો",
    "Open Predictions": "આગાહીઓ ખોલો",
    "Pending Payments": "બાકી ચુકવણીઓ",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "ક્લાયંટની પ્રવૃત્તિ, તાજેતરનું કાર્ય, ફોલો-અપ્સ, રિપોર્ટ્સ, આગાહીઓ, ઉપાયો અને બાકી ચૂકવણીઓ એક જ જગ્યાએ જુઓ.",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "જન્મ વિગતો, વિષયો, ટૅગ્સ, સ્થિતિ અને આર્કાઇવ/પુનઃસ્થાપિત ક્રિયાઓ સાથે જ્યોતિષી ક્લાયંટ રેકોર્ડ્સનું સંચાલન કરો.",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "સત્રની વિગતો, લિંક કરેલ ચાર્ટ, વિષયો, અવલોકનો, આગાહીઓ, ઉપાયો અને ફોલો-અપ તારીખો સ્ટોર કરો.",
    "Keep private consultation notes and chart observations attached to client profiles.": "ખાનગી પરામર્શ નોંધો અને ચાર્ટ અવલોકનો ક્લાયન્ટ પ્રોફાઇલ્સ સાથે જોડાયેલ રાખો.",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "ક્લાઈન્ટ મેનેજમેન્ટની અંદર પુશ, એસએમએસ, ઈમેલ અથવા વોટ્સએપ ચેતવણીઓ વિના આજે અને આગામી ફોલો-અપ્સને ટ્રૅક કરો.",
    "Create and organize client reports generated from saved charts and consultation context.": "સાચવેલા ચાર્ટ અને પરામર્શ સંદર્ભમાંથી જનરેટ કરાયેલ ક્લાયન્ટ રિપોર્ટ્સ બનાવો અને ગોઠવો.",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "ઉપાયો સોંપો, સક્રિય માર્ગદર્શનને ચિહ્નિત કરો અને ઉપાયના ઇતિહાસને ક્લાયંટ સમયરેખા સાથે જોડાયેલ રાખો.",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "દરેક ક્લાયંટ માટે ખુલ્લી આગાહીઓ, તારીખો, આત્મવિશ્વાસ નોંધો અને પરિણામ અપડેટ્સને ટ્રૅક કરો.",
    "Plan consultations, follow-ups and payment dates in one working view.": "એક કાર્યકારી દૃશ્યમાં પરામર્શ, ફોલો-અપ્સ અને ચુકવણીની તારીખોની યોજના બનાવો.",
    "Prepare reusable consultation, report, remedy and prediction templates.": "ફરીથી વાપરી શકાય તેવા પરામર્શ, અહેવાલ, ઉપાય અને આગાહી નમૂનાઓ તૈયાર કરો.",
    "Review client activity, consultation volume, reports created and pending work.": "ક્લાયંટની પ્રવૃત્તિ, પરામર્શ વોલ્યુમ, બનાવેલા અહેવાલો અને બાકી કામની સમીક્ષા કરો.",
    "Track consultation amounts and payment status without plan or pricing rules.": "યોજના અથવા કિંમતના નિયમો વિના પરામર્શની રકમ અને ચુકવણીની સ્થિતિને ટ્રૅક કરો.",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "ક્લાયંટ સ્ત્રોતો, સ્થિતિઓ, વિષયો, ટૅગ્સ અને આંતરિક CMS પસંદગીઓને ગોઠવો.",
    "Showing saved records connected to client records.": "ક્લાયંટ રેકોર્ડ્સ સાથે જોડાયેલ સાચવેલા રેકોર્ડ્સ બતાવી રહ્યું છે.",
    "No Status": "કોઈ સ્ટેટસ નથી",
    "No Mode": "કોઈ મોડ નથી",
    "No Payment Status": "કોઈ ચુકવણી સ્થિતિ નથી",
    "No Topic": "કોઈ વિષય નથી",
    "No Source": "કોઈ સ્ત્રોત નથી",
    "All Statuses": "બધા સ્ટેટસ",
    "All Topics": "બધા વિષયો",
    "No clients found": "કોઈ ક્લાયન્ટ મળ્યા નથી",
    "Type to search clients": "ક્લાયંટ શોધવા માટે ટાઇપ કરો",
    "No charts found": "કોઈ ચાર્ટ મળ્યા નથી",
    "Type to search saved charts": "સાચવેલા ચાર્ટ શોધવા માટે ટાઇપ કરો",
    "Type to search related client": "સંબંધિત ક્લાયંટને શોધવા માટે ટાઇપ કરો",
    "Open": "ખોલો",
    "Pending": "બાકી છે",
    "Scheduled": "સુનિશ્ચિત",
    "Completed": "પૂર્ણ થયું",
    "Follow-up Pending": "ફોલો-અપ બાકી છે",
    "Cancelled": "રદ કરેલ",
    "Closed": "બંધ",
    "No-show": "નો-શો",
    "Not Applicable": "લાગુ પડતું નથી",
    "Paid": "ચૂકવેલ",
    "Partially Paid": "આંશિક ચૂકવણી",
    "Refunded": "રિફંડ",
    "Phone": "ફોન",
    "WhatsApp Call": "વોટ્સએપ કોલ",
    "Video Call": "વિડિઓ કૉલ",
    "In-person": "રૂબરૂમાં",
    "Chat": "ચેટ",
    "Other": "અન્ય",
    "New": "નવી",
    "VIP": "વી.આઈ.પી",
    "Inactive": "નિષ્ક્રિય",
    "Consultation Completed": "પરામર્શ પૂર્ણ",
    "WhatsApp": "વોટ્સએપ",
    "Instagram": "ઇન્સ્ટાગ્રામ",
    "YouTube": "YouTube",
    "Referral": "રેફરલ",
    "Website": "વેબસાઈટ",
    "Walk-in": "વૉક-ઇન",
    "Repeat Client": "ક્લાયંટનું પુનરાવર્તન કરો",
    "Family Referral": "કૌટુંબિક રેફરલ",
    "Business": "વ્યાપાર",
    "Finance": "ફાયનાન્સ",
    "Property": "મિલકત",
    "Children": "બાળકો",
    "Foreign Settlement": "વિદેશી વસાહત",
    "Legal": "કાનૂની",
    "Remedy": "ઉપાય",
    "General": "જનરલ",
    "Active": "સક્રિય",
    "Past": "ભૂતકાળ",
    "Potential": "સંભવિત",
    "Archived": "આર્કાઇવ",
    "Spouse": "જીવનસાથી",
    "Husband": "પતિ",
    "Wife": "પત્ની",
    "Child": "બાળક",
    "Son": "પુત્ર",
    "Daughter": "દીકરી",
    "Father": "પિતા",
    "Mother": "માતા",
    "Sibling": "બહેન",
    "Brother": "ભાઈ",
    "Sister": "બહેન",
    "Marriage Prospect": "લગ્નની સંભાવના",
    "Fiance": "મંગેતર",
    "Business Partner": "બિઝનેસ પાર્ટનર",
    "Friend": "મિત્ર",
    "Relative": "સંબંધી",
    "Upgrade": "અપગ્રેડ કરો",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "તમે ફક્ત 2 ક્લાયંટ ઉમેરી શકો છો. વધુ ગ્રાહકો માટે પ્રીમિયમમાં અપગ્રેડ કરો.",
    "None": "કોઈ નહિ",
    "Education": "શિક્ષણ",
    "Awards": "પુરસ્કારો",
    "Prize": "પુરસ્કાર",
    "Career": "કારકિર્દી",
    "Love": "પ્રેમ",
    "Marriage": "લગ્ન",
    "Dowry or Legacy": "દહેજ કે વારસો",
    "Divorce": "છૂટાછેડા",
    "Abortion": "ગર્ભપાત",
    "Child Birth": "બાળજન્મ",
    "Property/Vehicle Purchase": "મિલકત/વાહન ખરીદી",
    "Property/Vehicle Sale": "મિલકત/વાહનનું વેચાણ",
    "Love and Caring": "પ્રેમ અને સંભાળ",
    "Depression": "ડિપ્રેશન",
    "Aggression": "આક્રમકતા",
    "Health": "આરોગ્ય",
    "Travel": "પ્રવાસ",
    "Homecoming": "ઘર વાપસી",
    "Litigation": "મુકદ્દમા",
    "Arrest": "ધરપકડ",
    "Locked": "તાળું મારેલું",
    "Strong": "મજબૂત",
    "Weak": "નબળા",
    "Supportive": "સહાયક",
    "Avoid": "ટાળો",
    "Premium": "પ્રીમિયમ",
    " UTC": "યુટીસી",
    "Unable to calculate Tithi Pravesh": "તિથિ પ્રવેશની ગણતરી કરવામાં અસમર્થ",
    "IANA timezone": "IANA ટાઇમઝોન",
    "TP Local": "ટીપી લોકલ",
    "TP UTC": "ટીપી યુટીસી",
    "Next TP Local": "આગામી ટીપી લોકલ",
    "Models: KP + Vedic": "મોડલ્સ: KP + વૈદિક",
    "Overall Year Theme": "એકંદર વર્ષની થીમ",
    "Career & Job": "કારકિર્દી અને નોકરી",
    "Finance & Savings": "નાણા અને બચત",
    "Relationship & Marriage": "સંબંધ અને લગ્ન",
    "Family Matters": "કૌટુંબિક બાબતો",
    "Property & Vehicle": "મિલકત અને વાહન",
    "Health & Wellness": "આરોગ્ય અને સુખાકારી",
    "Spiritual Growth": "આધ્યાત્મિક વૃદ્ધિ",
    "Social Status & Recognition": "સામાજિક સ્થિતિ અને માન્યતા",
    "Please select a saved chart first.": "કૃપા કરીને પહેલા સાચવેલ ચાર્ટ પસંદ કરો.",
    "Unable to generate Tajika Varshphal": "Tajika Varshphal જનરેટ કરવામાં અસમર્થ",
    "Premium yearly module": "પ્રીમિયમ વાર્ષિક મોડ્યુલ",
    "Tajika Varshphal": "તાજિકા વર્ષફલ",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "વર્ષા લગ્ન, મુન્થા, વર્ષા ભગવાન, સહમ્સ, માસિક માર્ગદર્શન, ઉપાયો અને આ સાચવેલી કુંડળીમાંથી વ્યક્તિગત કરેલ વ્યવહારુ જીવન થીમ્સ સાથે સૌર વળતર આધારિત વાર્ષિક જન્માક્ષર.",
    "Saved chart": "સાચવેલ ચાર્ટ",
    "Untitled Chart": "શીર્ષક વિનાનો ચાર્ટ",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "તમારી 4 મફત પ્રીમિયમ ક્રેડિટનો ઉપયોગ કરવામાં આવે છે. અમર્યાદિત પ્રીમિયમ ઍક્સેસ માટે Kundlistar પ્રીમિયમ પર અપગ્રેડ કરો.",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "તમારા 4 ફ્રી પ્રીમિયમ ક્રેડિટનો ઉપયોગ કરો. અસ્મિત પ્રીમિયમ એક્સેસ માટે __KDL_MASK__0__ પ્રીમિયમ લે છે.",
    "Core Year Markers": "મુખ્ય વર્ષ માર્કર્સ",
    "Solar Return": "સૌર વળતર",
    "Varsha Lagna": "વર્ષા લગન",
    "Muntha Lord": "મુન્થા ભગવાન",
    "Varsha Lord": "વર્ષા ભગવાન",
    "Varshesh Method": "વર્ષેશ પદ્ધતિ",
    "Yearly Summary": "વાર્ષિક સારાંશ",
    "Not available yet.": "હજુ સુધી ઉપલબ્ધ નથી.",
    "Varshesh Candidates": "વર્ષેશ ઉમેદવારો",
    "Risk Areas": "જોખમ વિસ્તારો",
    "Favourable Periods": "અનુકૂળ સમયગાળો",
    "Challenging Periods": "પડકારજનક સમયગાળો",
    "Remedies & Final Advice": "ઉપાયો અને અંતિમ સલાહ",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "તાજિકા વર્ષફલ અર્થઘટનાત્મક વાર્ષિક માર્ગદર્શન આપે છે. તેને તબીબી, કાનૂની, નાણાકીય અથવા ચોક્કસ આગાહી સલાહ તરીકે ગણવામાં આવવી જોઈએ નહીં.",
    "Griha Pravesh": "ગૃહ પ્રવેશ",
    "Purva Phalguni": "પૂર્વા ફાલ્ગુની",
    "Uttara Phalguni": "ઉત્તરા ફાલ્ગુની",
    "Purva Ashadha": "પૂર્વા અષાઢ",
    "Uttara Ashadha": "ઉત્તરા અષાઢ",
    "Purva Bhadrapada": "પૂર્વા ભાદ્રપદ",
    "Uttara Bhadrapada": "ઉત્તરા ભાદ્રપદ",
    "Param Mitra": "પરમ મિત્ર",
    "Kundli birthplace": "કુંડલી જન્મસ્થળ",
    "Selected city": "પસંદ કરેલ શહેર",
    "Muhurat - Kundlistar": "મુહૂર્ત - Kundlistar",
    "Please select a city first.": "કૃપા કરીને પહેલા એક શહેર પસંદ કરો.",
    "Unable to calculate Muhurat.": "મુહૂર્તની ગણતરી કરવામાં અસમર્થ.",
    "Unable to calculate personalized Muhurat.": "વ્યક્તિગત મુહૂર્તની ગણતરી કરવામાં અસમર્થ.",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "પંચાંગ, ચોઘડિયા, હોરા, તારાબાલા અને ચંદ્રબાલાનો ઉપયોગ કરીને સામાન્ય અને વ્યક્તિગત મુહૂર્ત શોધો.",
    "Muhurat Finder": "મુહૂર્ત શોધનાર",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "પંચાંગ, ચોઘડિયા અને પ્રીમિયમ વ્યક્તિગત જન્મના પરિબળોનો ઉપયોગ કરીને ઉપયોગી સમય વિન્ડો શોધો.",
    "Search city...": "શહેર શોધો...",
    "Using selected Kundli": "પસંદ કરેલી કુંડળીનો ઉપયોગ કરવો",
    "Find Free": "મફત શોધો",
    "Free General Muhurat": "મફત સામાન્ય મુહૂર્ત",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "આગામી 7 દિવસ માટે ટોચના 3 સ્લોટ. રાહુ કાલ, યમગંડા અને ગુલિકા દૂર થાય છે.",
    "Today's Muhurat": "આજનું મુહૂર્ત",
    "Daily Muhurat by Kundlistar": "__KDL_MASK__0__ દ્વારા દૈનિક મુહૂર્ત",
    "Shared via Kundlistar": "Kundlistar દ્વારા શેર કરેલ",
    "Kundlistar Muhurat": "Kundlistar મુહૂર્ત",
    "Share Image": "છબી શેર કરો",
    "Share Text": "ટેક્સ્ટ શેર કરો",
    "Copy Text": "ટેક્સ્ટ કૉપિ કરો",
    "Click Find Free to use the selected Kundli birthplace.": "પસંદ કરેલ કુંડળી જન્મસ્થળનો ઉપયોગ કરવા માટે ફ્રી શોધો પર ક્લિક કરો.",
    "Select a city and click Find Free.": "એક શહેર પસંદ કરો અને મફત શોધો ક્લિક કરો.",
    "Premium Personalized Muhurat": "પ્રીમિયમ વ્યક્તિગત મુહૂર્ત",
    "Loading Kundli details...": "કુંડળીની વિગતો લોડ કરી રહ્યું છે...",
    "Birth Nakshatra": "જન્મ નક્ષત્ર",
    "Birth Moon Rashi": "જન્મ ચંદ્ર રાશી",
    "Include night slots": "નાઇટ સ્લોટ્સ શામેલ કરો",
    "Find Premium": "પ્રીમિયમ શોધો",
    "Your grounding and foundation energy appears strong in this chart.": "આ ચાર્ટમાં તમારી ગ્રાઉન્ડિંગ અને ફાઉન્ડેશન એનર્જી મજબૂત દેખાય છે.",
    "Your grounding energy appears generally balanced in this chart.": "આ ચાર્ટમાં તમારી ગ્રાઉન્ડિંગ એનર્જી સામાન્ય રીતે સંતુલિત દેખાય છે.",
    "Reflection on routine, discipline, and inner stability may be useful.": "દિનચર્યા, શિસ્ત અને આંતરિક સ્થિરતા પર પ્રતિબિંબ ઉપયોગી થઈ શકે છે.",
    "Your creative and emotional flow energy appears strong in this chart.": "તમારી રચનાત્મક અને ભાવનાત્મક પ્રવાહ ઊર્જા આ ચાર્ટમાં મજબૂત દેખાય છે.",
    "Your creative energy appears balanced in this chart.": "તમારી સર્જનાત્મક ઉર્જા આ ચાર્ટમાં સંતુલિત દેખાય છે.",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "સર્જનાત્મકતા, ભાવનાત્મક અભિવ્યક્તિ અને આંતરિક પ્રવાહ પર પ્રતિબિંબ ઉપયોગી હોઈ શકે છે.",
    "Your confidence and willpower energy appears strong in this chart.": "તમારો આત્મવિશ્વાસ અને ઈચ્છાશક્તિ આ ચાર્ટમાં મજબૂત દેખાય છે.",
    "Your action-taking energy appears balanced in this chart.": "તમારી ક્રિયા કરવાની ઉર્જા આ ચાર્ટમાં સંતુલિત દેખાય છે.",
    "Reflection on confidence, discipline, and decision power may be useful.": "આત્મવિશ્વાસ, શિસ્ત અને નિર્ણય શક્તિ પર પ્રતિબિંબ ઉપયોગી થઈ શકે છે.",
    "Your connection and compassion energy appears strong in this chart.": "આ ચાર્ટમાં તમારું જોડાણ અને કરુણા ઊર્જા મજબૂત દેખાય છે.",
    "Your emotional connection energy appears balanced in this chart.": "તમારી ભાવનાત્મક જોડાણ ઊર્જા આ ચાર્ટમાં સંતુલિત દેખાય છે.",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "સંવાદિતા, ક્ષમા અને ભાવનાત્મક સંતુલન પર પ્રતિબિંબ ઉપયોગી હોઈ શકે છે.",
    "Your communication and expression energy appears strong in this chart.": "આ ચાર્ટમાં તમારી સંચાર અને અભિવ્યક્તિ ઊર્જા મજબૂત દેખાય છે.",
    "Your expression energy appears balanced in this chart.": "તમારી અભિવ્યક્તિ ઊર્જા આ ચાર્ટમાં સંતુલિત દેખાય છે.",
    "Reflection on clear communication and self-expression may be useful.": "સ્પષ્ટ સંચાર અને સ્વ-અભિવ્યક્તિ પર પ્રતિબિંબ ઉપયોગી હોઈ શકે છે.",
    "Your intuition and inner clarity appears strong in this chart.": "તમારી અંતર્જ્ઞાન અને આંતરિક સ્પષ્ટતા આ ચાર્ટમાં મજબૂત દેખાય છે.",
    "Your intuitive clarity appears balanced in this chart.": "તમારી સાહજિક સ્પષ્ટતા આ ચાર્ટમાં સંતુલિત દેખાય છે.",
    "Reflection on focus, intuition, and inner guidance may be useful.": "ધ્યાન, અંતર્જ્ઞાન અને આંતરિક માર્ગદર્શન પર પ્રતિબિંબ ઉપયોગી થઈ શકે છે.",
    "A strong Fire element supports action, courage, and leadership energy.": "મજબૂત અગ્નિ તત્વ ક્રિયા, હિંમત અને નેતૃત્વ ઊર્જાને સમર્થન આપે છે.",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "અગ્નિ સંતુલિત દેખાય છે, ક્રિયા અને ધીરજ વચ્ચે સ્થિર લયને ટેકો આપે છે.",
    "Reflection on confidence and action-taking may be useful.": "આત્મવિશ્વાસ અને પગલાં લેવાનું પ્રતિબિંબ ઉપયોગી થઈ શકે છે.",
    "A strong Earth element supports practicality, patience, and stability.": "મજબૂત પૃથ્વી તત્વ વ્યવહારિકતા, ધીરજ અને સ્થિરતાને સમર્થન આપે છે.",
    "Earth appears balanced, supporting practical thinking with flexibility.": "પૃથ્વી સંતુલિત દેખાય છે, લવચીકતા સાથે વ્યવહારિક વિચારસરણીને ટેકો આપે છે.",
    "Reflection on grounding, consistency, and planning may be useful.": "ગ્રાઉન્ડિંગ, સુસંગતતા અને આયોજન પર પ્રતિબિંબ ઉપયોગી થઈ શકે છે.",
    "A strong Air element supports ideas, communication, and adaptability.": "મજબૂત હવા તત્વ વિચારો, સંચાર અને અનુકૂલનક્ષમતાને સમર્થન આપે છે.",
    "Air appears balanced, supporting harmony between thinking and action.": "હવા સંતુલિત દેખાય છે, વિચાર અને ક્રિયા વચ્ચે સંવાદિતાને ટેકો આપે છે.",
    "Reflection on communication and flexibility may be useful.": "સંચાર અને સુગમતા પર પ્રતિબિંબ ઉપયોગી થઈ શકે છે.",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "મજબૂત જળ તત્વ અંતર્જ્ઞાન, સંવેદનશીલતા અને ભાવનાત્મક ઊંડાણને સમર્થન આપે છે.",
    "Water appears balanced, supporting harmony between emotions and logic.": "પાણી સંતુલિત દેખાય છે, લાગણીઓ અને તર્ક વચ્ચે સંવાદિતાને ટેકો આપે છે.",
    "Reflection on emotional expression and inner connection may be useful.": "ભાવનાત્મક અભિવ્યક્તિ અને આંતરિક જોડાણ પર પ્રતિબિંબ ઉપયોગી હોઈ શકે છે.",
    "A strong Ether element supports spiritual awareness and broader vision.": "મજબૂત ઈથર તત્વ આધ્યાત્મિક જાગૃતિ અને વ્યાપક દ્રષ્ટિને સમર્થન આપે છે.",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ઈથર સંતુલિત દેખાય છે, આધ્યાત્મિક અને વ્યવહારુ અભિગમ વચ્ચે સંવાદિતાને ટેકો આપે છે.",
    "Reflection, silence, and spiritual discipline may be useful.": "ચિંતન, મૌન અને આધ્યાત્મિક શિસ્ત ઉપયોગી થઈ શકે છે.",
    "For inner confidence, clarity, and soul strength.": "આંતરિક આત્મવિશ્વાસ, સ્પષ્ટતા અને આત્માની શક્તિ માટે.",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "આ ઈષ્ટ દેવતા સંકેત જન્મ પત્રિકામાંથી ગ્રહોની શક્તિ, લગન સ્વામી, ચંદ્ર રાશિના સ્વામી અને આત્મકાર પર આધારિત છે.",
    "For calmness, emotional balance, and softness.": "શાંતિ, ભાવનાત્મક સંતુલન અને નરમાઈ માટે.",
    "For courage, protection, and discipline.": "હિંમત, રક્ષણ અને શિસ્ત માટે.",
    "For intellect, speech, learning, and obstacle removal.": "બુદ્ધિ, વાણી, અધ્યયન અને અવરોધ દૂર કરવા માટે.",
    "For knowledge, guidance, dharma, and blessings.": "જ્ઞાન, માર્ગદર્શન, ધર્મ અને આશીર્વાદ માટે.",
    "Mahalakshmi Ji": "મહાલક્ષ્મી જી",
    "For harmony, beauty, comfort, and prosperity.": "સંવાદિતા, સુંદરતા, આરામ અને સમૃદ્ધિ માટે.",
    "For karma, patience, discipline, and protection.": "કર્મ, ધીરજ, શિસ્ત અને રક્ષણ માટે.",
    "For protection from confusion, fear, and illusion.": "મૂંઝવણ, ભય અને ભ્રમથી રક્ષણ માટે.",
    "Lord Ganesha": "ભગવાન ગણેશ",
    "For spiritual clarity, detachment, and obstacle removal.": "આધ્યાત્મિક સ્પષ્ટતા, ટુકડી અને અવરોધ દૂર કરવા માટે.",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "ચક્ર સૂઝ માટે ચાર્ટ ડેટા જરૂરી છે.",
    "Unable to load Chakra insight.": "ચક્ર આંતરદૃષ્ટિ લોડ કરવામાં અસમર્થ.",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "આ માત્ર જન્મ કુંડલી આધારિત આધ્યાત્મિક ઉર્જા આંતરદૃષ્ટિ અને આત્મ-ચિંતન છે. આ વ્યાવસાયિક સલાહ નથી.",
    "Spiritual energy insights from Kundli": "કુંડળીમાંથી આધ્યાત્મિક ઊર્જાની આંતરદૃષ્ટિ",
    "Calculated from your individual birth chart": "તમારા વ્યક્તિગત જન્મ ચાર્ટ પરથી ગણતરી કરવામાં આવે છે",
    "Chakra Balance": "ચક્ર સંતુલન",
    "Panch Tatva Balance": "પંચ તત્વ સંતુલન",
    "Ishta Devata": "ઈષ્ટ દેવતા",
    "Signal planet": "સંકેત ગ્રહ",
    "Very Good": "વેરી ગુડ",
    "Very Bad": "વેરી બેડ",
    "Panch Pakshi Calculator - Kundlistar": "પંચ પક્ષી કેલ્ક્યુલેટર - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "ચાર્ટમાંથી પંચ પક્ષીને પ્રીફિલ કરી શકાયું નથી. તમે હજી પણ મેન્યુઅલી ગણતરી કરી શકો છો.",
    "Could not load sunrise and sunset from Panchang for this chart location.": "આ ચાર્ટ સ્થાન માટે પંચાંગથી સૂર્યોદય અને સૂર્યાસ્ત લોડ કરી શકાયો નથી.",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "પંચાંગથી સૂર્યોદય, સૂર્યાસ્ત અને આગામી સૂર્યોદય લોડ કરવામાં અસમર્થ.",
    "Panch Pakshi calculation failed.": "પંચ પક્ષી ગણતરી નિષ્ફળ.",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "પંચ પક્ષી, પ્રવૃત્તિ, યમમ, અપહારા સમયગાળો, સંબંધ, સ્કોર અને પરિણામની ગણતરી કરો.",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "તમારી મફત પ્રીમિયમ ક્રેડિટ્સ સમાપ્ત થઈ ગઈ છે. ચાલુ રાખવા માટે પ્રીમિયમ પર અપગ્રેડ કરો.",
    "This is a premium feature. You can use 1 free premium credit to continue.": "આ એક પ્રીમિયમ ફીચર છે. ચાલુ રાખવા માટે તમે 1 મફત પ્રીમિયમ ક્રેડિટનો ઉપયોગ કરી શકો છો.",
    "Selected Date": "પસંદ કરેલ તારીખ",
    "repeat(3, 1fr)": "પુનરાવર્તન (3, 1fr)",
    "Birth Paksha": "જન્મ પક્ષ",
    "Current Paksha": "વર્તમાન પક્ષ",
    "repeat(4, 1fr)": "પુનરાવર્તન (4, 1fr)",
    "Target Date Time": "લક્ષ્ય તારીખ સમય",
    "Next Sunrise": "આગામી સૂર્યોદય",
    "Calculate Panch Pakshi": "પંચ પક્ષીની ગણતરી કરો",
    "repeat(2, 1fr)": "પુનરાવર્તન (2, 1fr)",
    "repeat(6, 1fr)": "પુનરાવર્તન (6, 1fr)",
    "Birth Pakshi": "જન્મ પક્ષી",
    "Current Period": "વર્તમાન સમયગાળો",
    "Current Yamam": "વર્તમાન યમમ",
    "Main Activity": "મુખ્ય પ્રવૃત્તિ",
    "Natal Western Chart": "નેટલ વેસ્ટર્ન ચાર્ટ",
    "Life Phase Progression": "જીવન તબક્કાની પ્રગતિ",
    "Self-focus, identity change, body awareness and personal reset.": "સ્વ-ધ્યાન, ઓળખ પરિવર્તન, શરીર જાગૃતિ અને વ્યક્તિગત રીસેટ.",
    "Money, values, family, speech and security become emotionally important.": "પૈસા, મૂલ્યો, કુટુંબ, વાણી અને સુરક્ષા ભાવનાત્મક રીતે મહત્વપૂર્ણ બની જાય છે.",
    "Communication, learning, siblings, writing and short travel become important.": "વાતચીત, ભણતર, ભાઈ-બહેન, લેખન અને ટૂંકી મુસાફરી મહત્વની બની જાય છે.",
    "Home, mother, property, family and emotional roots become important.": "ઘર, માતા, મિલકત, કુટુંબ અને ભાવનાત્મક મૂળ મહત્વપૂર્ણ બની જાય છે.",
    "Creativity, romance, children, hobbies and self-expression become important.": "સર્જનાત્મકતા, રોમાંસ, બાળકો, શોખ અને સ્વ-અભિવ્યક્તિ મહત્વપૂર્ણ બની જાય છે.",
    "Work routine, health habits, service and discipline become important.": "કામની દિનચર્યા, આરોગ્યની આદતો, સેવા અને શિસ્ત મહત્વપૂર્ણ બને છે.",
    "Relationship, marriage, partnership and public dealing become important.": "સંબંધ, લગ્ન, ભાગીદારી અને જાહેર વ્યવહાર મહત્વપૂર્ણ બની જાય છે.",
    "Deep emotional change, intimacy, shared money and transformation become important.": "ઊંડા ભાવનાત્મક પરિવર્તન, આત્મીયતા, વહેંચાયેલ નાણાં અને પરિવર્તન મહત્વપૂર્ણ બની જાય છે.",
    "Learning, travel, teaching, belief and higher wisdom become important.": "શીખવું, મુસાફરી, શિક્ષણ, માન્યતા અને ઉચ્ચ શાણપણ મહત્વપૂર્ણ બને છે.",
    "Career, status, public image and responsibility become emotionally important.": "કારકિર્દી, સ્થિતિ, જાહેર છબી અને જવાબદારી ભાવનાત્મક રીતે મહત્વપૂર્ણ બની જાય છે.",
    "Income, friends, networking, community and ambitions become important.": "આવક, મિત્રો, નેટવર્કિંગ, સમુદાય અને મહત્વાકાંક્ષાઓ મહત્વપૂર્ણ બની જાય છે.",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "આરામ, અલગતા, આધ્યાત્મિકતા, વિદેશી જોડાણ અને આંતરિક ઉપચાર મહત્વપૂર્ણ બની જાય છે.",
    "Identity development and self-expression are central.": "ઓળખ વિકાસ અને સ્વ-અભિવ્યક્તિ કેન્દ્રિય છે.",
    "Values, money and self-worth become central.": "મૂલ્યો, પૈસા અને સ્વ-મૂલ્ય કેન્દ્રિય બની જાય છે.",
    "Communication, learning and skills become central.": "સંદેશાવ્યવહાર, શિક્ષણ અને કૌશલ્યો કેન્દ્રિય બને છે.",
    "Home, roots and emotional foundation become central.": "ઘર, મૂળ અને ભાવનાત્મક પાયા કેન્દ્રીય બને છે.",
    "Creativity, love and self-expression become central.": "સર્જનાત્મકતા, પ્રેમ અને સ્વ-અભિવ્યક્તિ કેન્દ્રિય બની જાય છે.",
    "Work, discipline and health routines become central.": "કાર્ય, શિસ્ત અને આરોગ્યની દિનચર્યાઓ કેન્દ્રિય બની જાય છે.",
    "Partnerships and relationship identity become central.": "ભાગીદારી અને સંબંધની ઓળખ કેન્દ્રીય બની જાય છે.",
    "Transformation, deep healing and shared resources become central.": "પરિવર્તન, ઊંડા ઉપચાર અને વહેંચાયેલ સંસાધનો કેન્દ્રિય બને છે.",
    "Wisdom, travel, belief and higher learning become central.": "શાણપણ, પ્રવાસ, માન્યતા અને ઉચ્ચ શિક્ષણ કેન્દ્રિય બને છે.",
    "Career, authority and public role become central.": "કારકિર્દી, સત્તા અને જાહેર ભૂમિકા કેન્દ્રીય બની જાય છે.",
    "Community, income, goals and networks become central.": "સમુદાય, આવક, ધ્યેયો અને નેટવર્ક કેન્દ્રિય બને છે.",
    "Spirituality, closure, retreat and inner development become central.": "આધ્યાત્મિકતા, બંધ, એકાંત અને આંતરિક વિકાસ કેન્દ્રિય બને છે.",
    "This house becomes emotionally important.": "આ ઘર ભાવનાત્મક રીતે મહત્વપૂર્ણ બની જાય છે.",
    "This house becomes central for identity development.": "આ ઘર ઓળખ વિકાસ માટે કેન્દ્રીય બની જાય છે.",
    "Thinking, communication, learning and decisions are developing through this house.": "આ ઘર દ્વારા વિચાર, સંદેશાવ્યવહાર, શિક્ષણ અને નિર્ણયોનો વિકાસ થાય છે.",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "આ ઘર દ્વારા પ્રેમ, આરામ, મૂલ્યો, સુંદરતા અને પૈસાની પસંદગીઓ વિકસી રહી છે.",
    "Action style, courage, ambition and drive are developing through this house.": "આ ઘર દ્વારા એક્શન સ્ટાઈલ, હિંમત, મહત્વાકાંક્ષા અને ડ્રાઈવનો વિકાસ થઈ રહ્યો છે.",
    "Growth, faith, learning and expansion themes develop through this house.": "આ ઘર દ્વારા વૃદ્ધિ, વિશ્વાસ, શિક્ષણ અને વિસ્તરણ થીમ્સ વિકસિત થાય છે.",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "પરિપક્વતા, જવાબદારી, શિસ્ત અને લાંબા ગાળાનું માળખું આ ઘર દ્વારા વિકસિત થાય છે.",
    "This progressed planet shows an inner life phase through this house.": "આ પ્રગતિશીલ ગ્રહ આ ઘર દ્વારા આંતરિક જીવનનો તબક્કો દર્શાવે છે.",
    "New Moon Phase": "નવા ચંદ્રનો તબક્કો",
    "New beginning, identity reset and fresh internal cycle.": "નવી શરૂઆત, ઓળખ રીસેટ અને તાજી આંતરિક ચક્ર.",
    "Crescent Phase": "અર્ધચંદ્રાકાર તબક્કો",
    "Growth, effort, learning and building confidence.": "વૃદ્ધિ, પ્રયત્ન, શીખવું અને આત્મવિશ્વાસ કેળવવો.",
    "First Quarter Phase": "પ્રથમ ત્રિમાસિક તબક્કો",
    "Action, decision-making, pressure and development.": "ક્રિયા, નિર્ણય, દબાણ અને વિકાસ.",
    "Gibbous Phase": "ગીબ્બોઅસ તબક્કો",
    "Refinement, improvement, preparation and skill-building.": "સંસ્કારિતા, સુધારણા, તૈયારી અને કૌશલ્ય-નિર્માણ.",
    "Full Moon Phase": "પૂર્ણ ચંદ્ર તબક્કો",
    "Visibility, relationship awareness, emotional clarity and results.": "દૃશ્યતા, સંબંધ જાગૃતિ, ભાવનાત્મક સ્પષ્ટતા અને પરિણામો.",
    "Disseminating Phase": "પ્રસાર તબક્કો",
    "Sharing, teaching, communication and distributing experience.": "વહેંચણી, શિક્ષણ, સંચાર અને વિતરણ અનુભવ.",
    "Last Quarter Phase": "છેલ્લો ક્વાર્ટર તબક્કો",
    "Reorientation, correction, release and mature decision-making.": "પુનઃઓરિએન્ટેશન, કરેક્શન, રિલીઝ અને પરિપક્વ નિર્ણય.",
    "Balsamic Phase": "બાલ્સમિક તબક્કો",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "બંધ, આધ્યાત્મિક પ્રતિબિંબ, આરામ અને નવા ચક્ર માટેની તૈયારી.",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "એક મુખ્ય ભાવનાત્મક અને ઓળખનો તબક્કો શરૂ થાય છે. વ્યક્તિ નવા અધ્યાય માટે તૈયાર અનુભવી શકે છે.",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "ભાવનાત્મક રીસેટ સમયગાળો. કુટુંબ, આરામ, આંતરિક શાંતિ અને ભાવનાત્મક જરૂરિયાતો મહત્વપૂર્ણ બની જાય છે.",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "પ્રેમ, સંબંધ, આરામ, સુંદરતા અને ભાવનાત્મક બંધન મહત્વપૂર્ણ બની જાય છે.",
    "Emotional needs and relationship expectations may need adjustment.": "ભાવનાત્મક જરૂરિયાતો અને સંબંધોની અપેક્ષાઓને ગોઠવણની જરૂર પડી શકે છે.",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "ઉર્જા, જુસ્સો, અધીરાઈ અને ક્રિયા વધે છે. ભાવનાત્મક પ્રતિક્રિયાઓ ઝડપી બની શકે છે.",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "ભાવનાત્મક બેચેની, ગુસ્સો, સંઘર્ષ અથવા તાત્કાલિક પગલાં વધી શકે છે.",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "ગંભીર ભાવનાત્મક તબક્કો. જવાબદારી, પરિપક્વતા, પારિવારિક દબાણ અથવા આંતરિક શિસ્ત વધી શકે છે.",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "ભાવનાત્મક ભારેપણું અથવા જવાબદારી અનુભવાઈ શકે છે. ધીરજ અને પરિપક્વતા જરૂરી છે.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "સહાયક ભાવનાત્મક વૃદ્ધિ, આશાવાદ, મુસાફરી, શિક્ષણ અને આશીર્વાદ વધી શકે છે.",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "વૃદ્ધિ લક્ષી ભાવનાત્મક તબક્કો. શીખવા, વિસ્તરણ, સમર્થન અને સકારાત્મક નિર્ણયો માટે સારું.",
    "Identity, love, beauty, money values and creative expression become highlighted.": "ઓળખ, પ્રેમ, સૌંદર્ય, પૈસાના મૂલ્યો અને સર્જનાત્મક અભિવ્યક્તિ પ્રકાશિત થાય છે.",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "આત્મવિશ્વાસ, હિંમત, મહત્વાકાંક્ષા અને કાર્યમાં વધારો થાય છે. નવો સક્રિય તબક્કો શરૂ કરવા માટે સારું.",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "પરિપક્વતા પરીક્ષણ. જવાબદારી, વિલંબ, દબાણ અથવા કારકિર્દીનું પુનર્ગઠન થઈ શકે છે.",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "વૃદ્ધિ, આત્મવિશ્વાસ, ડહાપણ, ઓળખ અને તક વધી શકે છે.",
    "Mental clarity, communication, study, writing and business decisions become important.": "માનસિક સ્પષ્ટતા, વાતચીત, અભ્યાસ, લેખન અને વ્યવસાયિક નિર્ણયો મહત્વપૂર્ણ બને છે.",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "એક નવું માનસિક ચક્ર શરૂ થાય છે. શીખવા, સંચાર, લેખન અને કૌશલ્ય વિકાસ માટે સારું.",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "પ્રેમ, સુંદરતા, આરામ, સામાજિક જીવન અને મૂલ્યો ઓળખ સાથે મજબૂત રીતે જોડાયેલા બને છે.",
    "Action, confidence, ambition and personal drive become stronger.": "કાર્ય, આત્મવિશ્વાસ, મહત્વાકાંક્ષા અને વ્યક્તિગત ડ્રાઈવ વધુ મજબૂત બને છે.",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "પ્રગતિશીલ બુધ શિક્ષણ, સંચાર, વ્યવસાય, લેખન, માર્કેટિંગ, કોડિંગ અથવા વિશ્લેષણાત્મક કાર્યને સમર્થન આપે છે.",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "પ્રગતિશીલ મંગળ ક્રિયા, હિંમત, સ્પર્ધા, તકનીકી કાર્ય અને સક્રિય કારકિર્દી નિર્ણયોને સમર્થન આપે છે.",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "પ્રગતિશીલ શુક્ર નાણાકીય મૂલ્યો, આરામ, લાભ, વૈભવી, કલા અથવા સંબંધ આધારિત આવક થીમ્સને સમર્થન આપે છે.",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "પ્રગતિશીલ ગુરુ વૃદ્ધિ-લક્ષી નાણાકીય વિચારસરણી અને સંસાધનોના વિસ્તરણને બતાવી શકે છે.",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "કારકિર્દીનો તબક્કો પ્રગતિશીલ સૂર્ય, ચંદ્ર, બુધ, મંગળ અને જન્મજાત સૂર્ય, શનિ અને મધ્યઆવનના પાસાઓથી નક્કી કરવો જોઈએ.",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "પ્રેમનો તબક્કો પ્રગતિશીલ ચંદ્ર, શુક્ર, મંગળ અને જન્મના ચંદ્ર, શુક્ર, મંગળ અને 7મા ઘરના પાસાઓથી નક્કી કરવો જોઈએ.",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "પૈસાનો તબક્કો પ્રગતિશીલ ચંદ્ર, શુક્ર, ગુરુ અને જન્મના બીજા, 8મા અને 11મા ઘરના જોડાણો પરથી નક્કી કરવો જોઈએ.",
    "Western Astrology - Kundlistar": "પશ્ચિમી જ્યોતિષ - __KDL_MASK__0__",
    "No chart data available for preview": "પૂર્વાવલોકન માટે કોઈ ચાર્ટ ડેટા ઉપલબ્ધ નથી",
    "Failed to load chart": "ચાર્ટ લોડ કરવામાં નિષ્ફળ",
    "Chart not found": "ચાર્ટ મળ્યો નથી",
    "Western Astrology Module | Kundlistar": "પશ્ચિમી જ્યોતિષ મોડ્યુલ | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "Kundlistar ની અંદર નેટલ ચાર્ટ પોઝિશન, પ્લેસીડસ હાઉસ કપ્સ, બાહ્ય ગ્રહો અને પ્રીમિયમ ટ્રાન્ઝિટ, સોલર રીટર્ન અને સિનેસ્ટ્રી સુવિધાઓ સાથે પશ્ચિમી જ્યોતિષવિદ્યાનું અન્વેષણ કરો.",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "પાશ્ચાત્ય જ્યોતિષશાસ્ત્ર, નેટલ ચાર્ટ, ટ્રાન્ઝિટ, સોલર રીટર્ન, સિનેસ્ટ્રી, Kundlistar",
    "New section": "નવો વિભાગ",
    "Premium active": "પ્રીમિયમ સક્રિય",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "હાઉસ સિસ્ટમ",
    "Placidus cusps": "પ્લેસીડસ કપ્સ",
    "Part of Fortune": "ભાગ્યનો ભાગ",
    "Natal Western Aspects": "નેટલ વેસ્ટર્ન પાસાઓ",
    "No major Western aspects found within the configured orbs.": "રૂપરેખાંકિત ઓર્બ્સમાં કોઈ મુખ્ય પશ્ચિમી પાસાં મળ્યાં નથી.",
    "Western natal astrology wheel": "પશ્ચિમી જન્મજાત જ્યોતિષ ચક્ર",
    "Western Transits": "પશ્ચિમી પરિવહન",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "લોડ થયેલ ચાર્ટ જન્મસ્થળનો ઉપયોગ કરીને વર્તમાન સંક્રમણ-થી-પ્રસૂતિ ગણતરીઓ.",
    "Natal points available": "નેટલ પોઈન્ટ ઉપલબ્ધ છે",
    "Transit planets loaded": "પરિવહન ગ્રહો લોડ",
    "Loading current transit positions...": "વર્તમાન પરિવહન સ્થિતિ લોડ કરી રહ્યું છે...",
    "Aspect method": "પાસા પદ્ધતિ",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "જોડાણ, સેક્સટાઇલ, ચોરસ, ટ્રાઈન અને પશ્ચિમી ઓર્બ્સ સાથે વિરોધ",
    "Primary focus": "પ્રાથમિક ધ્યાન",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "જન્મજાત સૂર્ય, ચંદ્ર, ચડતી, શુક્ર, મંગળ, ગુરુ, શનિ અને બાહ્ય ગ્રહો માટે સંક્રમણ સંપર્કો",
    "Natal inner wheel": "નેટલ આંતરિક ચક્ર",
    "Transit outer wheel": "પરિવહન બાહ્ય ચક્ર",
    "Current Transit Positions": "વર્તમાન પરિવહન સ્થિતિઓ",
    "Transit positions are not available.": "ટ્રાન્ઝિટ પોઝિશન્સ ઉપલબ્ધ નથી.",
    "Current Transit Aspects to Natal Chart": "નેટલ ચાર્ટમાં વર્તમાન પરિવહન પાસાઓ",
    "Loading transit aspects...": "પરિવહન પાસાઓ લોડ કરી રહ્યું છે...",
    "No major transit aspects found within the configured orbs.": "રૂપરેખાંકિત ઓર્બ્સમાં કોઈ મુખ્ય પરિવહન પાસાં મળ્યાં નથી.",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "નેટલ સન તરફથી વાર્ષિક પાશ્ચાત્ય વળતર સંદર્ભ, સહાયક જન્મજાત પાસા સંદર્ભ સાથે.",
    "Solar return date": "સૌર વળતર તારીખ",
    "Calculation time": "ગણતરી સમય",
    "Birth date not available": "જન્મ તારીખ ઉપલબ્ધ નથી",
    "Natal Sun": "નેટલ સન",
    "Natal Sun house": "નેટલ સન હાઉસ",
    "Return planets loaded": "ભરેલા ગ્રહો પાછા ફરો",
    "Loading solar return chart...": "સૌર વળતર ચાર્ટ લોડ કરી રહ્યું છે...",
    "Annual focus": "વાર્ષિક ફોકસ",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "સૌર થીમ્સ જન્મજાત સૂર્ય, વળતર ચડતા અને વાર્ષિક વળતર ચાર્ટમાંથી વાંચવામાં આવે છે.",
    "Solar Return Planet Positions": "સોલર રીટર્ન પ્લેનેટ પોઝિશન્સ",
    "Loading solar return planets...": "સૌર વળતર ગ્રહો લોડ કરી રહ્યાં છીએ...",
    "Solar return positions are not available.": "સૌર વળતરની સ્થિતિ ઉપલબ્ધ નથી.",
    "Solar Return House Cusps": "સોલાર રીટર્ન હાઉસ Cusps",
    "Loading solar return cusps...": "સોલર રીટર્ન કપ્સ લોડ કરી રહ્યું છે...",
    "Solar return house cusps are not available.": "સોલાર રીટર્ન હાઉસ કપ્સ ઉપલબ્ધ નથી.",
    "Solar Return Aspects to Natal Chart": "નેટલ ચાર્ટમાં સૌર વળતર પાસાઓ",
    "Loading solar return aspects...": "સૌર વળતર પાસાઓ લોડ કરી રહ્યું છે...",
    "No major solar return aspects found within the configured orbs.": "રૂપરેખાંકિત ઓર્બ્સમાં કોઈ મુખ્ય સૌર વળતર પાસાં મળ્યાં નથી.",
    "Natal Sun Aspects for Solar Return Focus": "સૌર વળતર ફોકસ માટે નેટલ સન પાસાઓ",
    "No major natal Sun aspects found within the configured orbs.": "રૂપરેખાંકિત ઓર્બ્સમાં કોઈ મુખ્ય જન્મજાત સૂર્યના પાસાઓ મળ્યા નથી.",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "ગ્રહ-થી-ગ્રહ પાસાઓ, કોણ સંપર્કો અને ઘરના ઓવરલેનો ઉપયોગ કરીને સંબંધ ઓવરલે ફ્રેમવર્ક.",
    "Loaded first chart": "પ્રથમ ચાર્ટ લોડ કર્યો",
    "Second chart": "બીજો ચાર્ટ",
    "Select or load partner chart to calculate full synastry overlay": "સંપૂર્ણ સિનેસ્ટ્રી ઓવરલેની ગણતરી કરવા માટે ભાગીદાર ચાર્ટ પસંદ કરો અથવા લોડ કરો",
    "Major inter-chart aspects with tight orb priority": "ચુસ્ત ઓર્બ અગ્રતા સાથે મુખ્ય આંતર-ચાર્ટ પાસાઓ",
    "House overlay method": "હાઉસ ઓવરલે પદ્ધતિ",
    "Partner planets are placed into the first chart houses after second chart is selected": "બીજો ચાર્ટ પસંદ કર્યા પછી ભાગીદાર ગ્રહોને પ્રથમ ચાર્ટ ગૃહોમાં મૂકવામાં આવે છે",
    "Relationship Pattern Aspects from Loaded Chart": "લોડ કરેલા ચાર્ટમાંથી સંબંધ પેટર્નના પાસાઓ",
    "No major relationship-focused natal aspects found within the configured orbs.": "રૂપરેખાંકિત ઓર્બ્સમાં કોઈ મુખ્ય સંબંધ-કેન્દ્રિત જન્મજાત પાસાં મળ્યાં નથી.",
    "Understand your current inner life phase through Western Secondary Progressions.": "પશ્ચિમી માધ્યમિક પ્રગતિ દ્વારા તમારા વર્તમાન આંતરિક જીવનના તબક્કાને સમજો.",
    "Secondary Progression": "ગૌણ પ્રગતિ",
    "1 day after birth = 1 year of life": "જન્મ પછી 1 દિવસ = જીવનનું 1 વર્ષ",
    "Current age used": "વર્તમાન વય વપરાય છે",
    "Progressed date": "પ્રગતિ તારીખ",
    "Progressed Moon": "પ્રગતિ કરેલ ચંદ્ર",
    "Loading progressed Moon...": "પ્રગતિશીલ ચંદ્ર લોડ કરી રહ્યું છે...",
    "Progressed Moon phase": "પ્રગતિ કરેલ ચંદ્ર તબક્કો",
    "Loading Moon phase...": "ચંદ્રનો તબક્કો લોડ કરી રહ્યું છે...",
    "Current Life Phase": "વર્તમાન જીવન તબક્કો",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "ગૌણ પ્રગતિ જીવનના આંતરિક તબક્કા, ભાવનાત્મક પરિપક્વતા, ઓળખ વિકાસ અને બદલાતી પ્રાથમિકતાઓ દર્શાવે છે.",
    "Progressed Career Phase": "પ્રગતિ કરેલ કારકિર્દી તબક્કો",
    "Progressed Love Phase": "પ્રેમનો તબક્કો આગળ વધ્યો",
    "Progressed Money Phase": "પ્રોગ્રેસ્ડ મની ફેઝ",
    "Loading progressed planets...": "પ્રગતિશીલ ગ્રહો લોડ કરી રહ્યાં છે...",
    "Progressed planets are not available.": "પ્રગતિશીલ ગ્રહો ઉપલબ્ધ નથી.",
    "Loading progressed aspects...": "પ્રગતિશીલ પાસાઓ લોડ કરી રહ્યું છે...",
    "No tight progressed-to-natal aspects found right now.": "અત્યારે કોઈ ચુસ્ત પ્રોગ્રેસ-ટુ-નેટલ પાસાઓ મળ્યા નથી.",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "આ તબક્કો પ્રગતિશીલ ગ્રહો, પ્રગતિશીલ ચંદ્રનો તબક્કો અને ચુસ્ત પ્રગતિથી જન્મના પાસાઓ પરથી નક્કી થવો જોઈએ.",
    "Vastu Analysis - Kundlistar": "વાસ્તુ વિશ્લેષણ - Kundlistar",
    "Failed to load selected chart.": "પસંદ કરેલ ચાર્ટ લોડ કરવામાં નિષ્ફળ.",
    "Facing Direction": "દિશાનો સામનો કરવો",
    "Entrance Direction": "પ્રવેશ દિશા",
    "Kitchen Direction": "રસોડું દિશા",
    "Master Bedroom": "માસ્ટર બેડરૂમ",
    "Children Bedroom": "બાળકોનો બેડરૂમ",
    "Toilet Direction": "શૌચાલય દિશા",
    "Pooja Direction": "પૂજા દિશા",
    "Water Tank": "પાણીની ટાંકી",
    "Underground Water": "ભૂગર્ભ જળ",
    "Heavy Storage": "ભારે સંગ્રહ",
    "Living Room": "લિવિંગ રૂમ",
    "Study Room": "અભ્યાસ ખંડ",
    "Vastu report generation failed.": "વાસ્તુ રિપોર્ટ જનરેશન નિષ્ફળ.",
    "Please generate the Vastu report before downloading.": "ડાઉનલોડ કરતા પહેલા કૃપા કરીને વાસ્તુ રિપોર્ટ જનરેટ કરો.",
    "Failed to download Vastu report.": "વાસ્તુ રિપોર્ટ ડાઉનલોડ કરવામાં નિષ્ફળ.",
    "Premium Feature": "પ્રીમિયમ લક્ષણ",
    "Selected Chart": "પસંદ કરેલ ચાર્ટ",
    "Basic + KP + BNN from chart": "ચાર્ટમાંથી મૂળભૂત + KP + BNN",
    "Basic shown, KP + BNN locked": "મૂળભૂત બતાવેલ, KP + BNN લૉક કરેલું",
    "Property Type": "મિલકતનો પ્રકાર",
    "Center Area": "કેન્દ્ર વિસ્તાર",
    "Generate Vastu Report": "વાસ્તુ રિપોર્ટ જનરેટ કરો",
    "Basic Vastu Analysis": "મૂળભૂત વાસ્તુ વિશ્લેષણ",
    "KP Vastu Analysis": "કેપી વાસ્તુ વિશ્લેષણ",
    "BNN Vastu Analysis": "BNN વાસ્તુ વિશ્લેષણ",
    "North East": "ઉત્તર પૂર્વ",
    "South East": "દક્ષિણ પૂર્વ",
    "South West": "દક્ષિણ પશ્ચિમ",
    "North West": "ઉત્તર પશ્ચિમ",
    "Red Coral": "લાલ કોરલ",
    "Yellow Sapphire": "પીળો નીલમ",
    "Blue Sapphire": "વાદળી નીલમ",
    "Cat's Eye": "બિલાડીની આંખ",
    "Additional Option": "વધારાનો વિકલ્પ",
    "Lagna rule supports this gemstone option.": "લગના નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Moon sign rule supports this gemstone option.": "ચંદ્ર ચિહ્નનો નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Birth date rule supports this gemstone option.": "જન્મ તારીખ નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Birth weekday rule supports this gemstone option.": "જન્મ સપ્તાહનો નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Current dasha rule supports this gemstone option.": "વર્તમાન દશા નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Age-band rule supports this gemstone option.": "ઉંમર-બેન્ડ નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Selected goal supports this gemstone option.": "પસંદ કરેલ ધ્યેય આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Profession rule supports this gemstone option.": "વ્યવસાય નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Name-initial rule supports this gemstone option.": "નામ-પ્રારંભિક નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Moolank rule supports this gemstone option.": "મૂલંક નિયમ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Chart condition check was considered for this option.": "આ વિકલ્પ માટે ચાર્ટ શરત તપાસને ધ્યાનમાં લેવામાં આવી હતી.",
    "Rule-based chart match supports this gemstone option.": "નિયમ-આધારિત ચાર્ટ મેચ આ રત્ન વિકલ્પને સમર્થન આપે છે.",
    "Expert kundli review is recommended before wearing this gemstone.": "આ રત્ન પહેરતા પહેલા નિષ્ણાત કુંડળીની સમીક્ષા કરવાની ભલામણ કરવામાં આવે છે.",
    "Ring finger": "રીંગ આંગળી",
    "Little finger": "નાની આંગળી",
    "Index finger": "તર્જની",
    "Middle finger": "મધ્ય આંગળી",
    "Why recommended": "શા માટે ભલામણ કરી",
    "Approx weight": "આશરે વજન",
    "Could not load chart.": "ચાર્ટ લોડ કરી શકાયો નથી.",
    "Gemstone Recommendations | Kundlistar": "રત્ન ભલામણો | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar ના નિયમ-આધારિત કુંડલી વિશ્લેષણ એન્જિનમાંથી વૈદિક રત્ન ભલામણોનું અન્વેષણ કરો.",
    "noindex,nofollow": "noindex,nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "રત્ન ભલામણ, વૈદિક રત્ન, કુંડલી રત્ન, Kundlistar",
    "Gemstone Recommendations": "રત્ન ભલામણો",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "લગ્ન, ચંદ્ર રાશિ, દશા, DOB, વ્યવસાય અને લક્ષ્યો પર આધારિત વૈદિક રત્ન માર્ગદર્શન માટે અલગ Kundlistar મોડ્યુલ.",
    "Personalized Gemstone Recommendations are available for Premium users.": "પ્રીમિયમ વપરાશકર્તાઓ માટે વ્યક્તિગત રત્ન ભલામણો ઉપલબ્ધ છે.",
    "Upgrade to Premium": "પ્રીમિયમ પર અપગ્રેડ કરો",
    "Login to Upgrade": "અપગ્રેડ કરવા માટે લોગિન કરો",
    "Select Goal": "લક્ષ્ય પસંદ કરો",
    "Business, government job, teacher...": "વેપાર, સરકારી નોકરી, શિક્ષક...",
    "Weight kg": "વજન કિલો",
    "वजन kg": "૫ કિલો",
    "Optional ratti estimate": "વૈકલ્પિક રત્તી અંદાજ",
    "Click Calculate to apply these values.": "આ મૂલ્યો લાગુ કરવા માટે ગણતરી પર ક્લિક કરો.",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{is હિન્દી ?",
    "Nadi Analysis": "નાડી વિશ્લેષણ",
    "KP Analysis": "કેપી વિશ્લેષણ",
    "Vedic Analysis": "વૈદિક વિશ્લેષણ",
    "BNN Analysis": "BNN વિશ્લેષણ",
    "Jaimini Analysis": "જૈમિની વિશ્લેષણ",
    "Western Astrology": "પશ્ચિમી જ્યોતિષ",
    "Panch Pakshi": "પંચ પક્ષી",
    "Tithi Pravesh": "તિથિ પ્રવેશ",
    "Lal Kitab": "લાલ કિતાબ",
    "Astro Logo": "એસ્ટ્રો લોગો",
    "Download failed": "ડાઉનલોડ નિષ્ફળ થયું",
    "Could not download PDF report.": "PDF રિપોર્ટ ડાઉનલોડ કરી શકાયો નથી.",
    "Please login to download PDF reports.": "પીડીએફ રિપોર્ટ્સ ડાઉનલોડ કરવા માટે કૃપા કરીને લોગિન કરો.",
    "Failed to generate personalised report": "વ્યક્તિગત રિપોર્ટ જનરેટ કરવામાં નિષ્ફળ",
    "Could not download personalised report.": "વ્યક્તિગત રિપોર્ટ ડાઉનલોડ કરી શકાયો નથી.",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--કુંડલિસ્ટાર-નવબાર-ઊંચાઈ, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(--કુંડલિસ્ટાર-નવબાર-ઊંચાઈ, 160px))",
    "width 0.2s ease": "પહોળાઈ 0.2s સરળતા",
    "Collapse sidebar": "સાઇડબારને સંકુચિત કરો",
    "Expand sidebar": "સાઇડબાર વિસ્તૃત કરો",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-રુટ",
    "Download PDF Report": "પીડીએફ રિપોર્ટ ડાઉનલોડ કરો",
    "Login to download": "ડાઉનલોડ કરવા માટે લોગિન કરો",
    "PDF Report": "પીડીએફ રિપોર્ટ",
    "Download Personal Report": "વ્યક્તિગત રિપોર્ટ ડાઉનલોડ કરો",
    "Buy Premium to download": "ડાઉનલોડ કરવા માટે પ્રીમિયમ ખરીદો",
    "Login to buy Premium": "પ્રીમિયમ ખરીદવા માટે લોગિન કરો",
    "Buy Premium": "પ્રીમિયમ ખરીદો",
    "& .MuiTab-root": "& .MuiTab-રુટ",
    "& .Mui-selected": "& .Mui-પસંદ કરેલ",
    "Unable to load Client Management data.": "ક્લાયન્ટ મેનેજમેન્ટ ડેટા લોડ કરવામાં અસમર્થ.",
    "Unable to download PDF.": "PDF ડાઉનલોડ કરવામાં અસમર્થ.",
    "Free client limit reached": "મફત ગ્રાહક મર્યાદા પહોંચી",
    "Welcome": "સ્વાગત છે",
    "Hello": "હેલો",
    "Your saved charts are shown below.": "તમારા સાચવેલા ચાર્ટ નીચે દર્શાવેલ છે.",
    "All Features": "તમામ સુવિધાઓ",
    "New Chart": "નવો ચાર્ટ",
    "Vedic Chart": "વૈદિક ચાર્ટ",
    "Chakra": "ચક્ર",
    "Daily Panchang": "દૈનિક પંચાંગ",
    "Choghadiya": "ચોઘડિયા",
    "Daily Horoscope": "દૈનિક જન્માક્ષર",
    "Gochar Alerts": "ગોચર ચેતવણીઓ",
    "Matching": "મેચિંગ",
    "Ruling Planets": "શાસક ગ્રહો",
    "Horary Chart": "હોરી ચાર્ટ",
    "Astro-Vastu": "એસ્ટ્રો-વાસ્તુ",
    "Vedic Numerology": "વૈદિક અંકશાસ્ત્ર",
    "My Charts": "મારા ચાર્ટ્સ",
    "Search by Name": "નામ દ્વારા શોધો",
    "Type": "પ્રકાર",
    "All": "બધા",
    "Individual": "વ્યક્તિગત",
    "Horary": "હોરી",
    "Clear": "સાફ કરો",
    "Name": "નામ",
    "DOB": "ડીઓબી",
    "Place": "સ્થળ",
    "Gender": "જાતિ",
    "Created": "બનાવ્યું",
    "Actions": "ક્રિયાઓ",
    "Male": "પુરુષ",
    "Female": "સ્ત્રી",
    "No matching charts found": "કોઈ મેળ ખાતો ચાર્ટ મળ્યો નથી",
    "Create First Chart": "પ્રથમ ચાર્ટ બનાવો",
    "View Chart": "ચાર્ટ જુઓ",
    "Copy Share Link": "શેર લિંક કૉપિ કરો",
    "Use premium credit: Download PDF Report": "પ્રીમિયમ ક્રેડિટનો ઉપયોગ કરો: PDF રિપોર્ટ ડાઉનલોડ કરો",
    "Download Personalised Report": "વ્યક્તિગત રિપોર્ટ ડાઉનલોડ કરો",
    "Premium: Download Personalised Report": "પ્રીમિયમ: વ્યક્તિગત રિપોર્ટ ડાઉનલોડ કરો",
    "Hide Chart": "ચાર્ટ છુપાવો",
    "Personalised": "વ્યક્તિગત કરેલ",
    "Generating your Personalised Report": "તમારી વ્યક્તિગત રિપોર્ટ જનરેટ કરી રહ્યા છીએ",
    "Please do not leave this page till the report is generated. This can take a little while.": "રિપોર્ટ જનરેટ ન થાય ત્યાં સુધી કૃપા કરીને આ પૃષ્ઠ છોડશો નહીં. આમાં થોડો સમય લાગી શકે છે.",
    "Please don't leave this page till the report is generated. This can take a little while.": "રિપોર્ટ જનરેટ ન થાય ત્યાં સુધી કૃપા કરીને આ પૃષ્ઠ છોડશો નહીં. આમાં થોડો સમય લાગી શકે છે.",
    "Update": "અપડેટ કરો",
    "Complete your billing address. Required for generating invoice.": "તમારું બિલિંગ સરનામું પૂર્ણ કરો. ઇન્વૉઇસ જનરેટ કરવા માટે જરૂરી છે.",
    "Report this report": "આ અહેવાલ જણાવો",
    "Reason": "કારણ",
    "Optional comment": "વૈકલ્પિક ટિપ્પણી",
    "Submit": "સબમિટ કરો",
    "Incorrect info": "ખોટી માહિતી",
    "Offensive": "અપમાનજનક",
    "Harmful": "હાનિકારક",
    "This report has been sent for review.": "આ રિપોર્ટ સમીક્ષા માટે મોકલવામાં આવ્યો છે.",
    "Failed to submit report feedback": "રિપોર્ટ પ્રતિસાદ સબમિટ કરવામાં નિષ્ફળ",
    "Failed to download PDF": "PDF ડાઉનલોડ કરવામાં નિષ્ફળ",
    "Failed to download personalised report": "વ્યક્તિગત રિપોર્ટ ડાઉનલોડ કરવામાં નિષ્ફળ",
    "Failed to load charts": "ચાર્ટ લોડ કરવામાં નિષ્ફળ",
    "Failed to hide chart": "ચાર્ટ છુપાવવામાં નિષ્ફળ",
    "Failed to delete chart": "ચાર્ટ કાઢી નાખવામાં નિષ્ફળ",
    "Share link copied to clipboard!": "શેર લિંક ક્લિપબોર્ડ પર કૉપિ કરી!",
    "Delete Chart": "ચાર્ટ કાઢી નાખો",
    "Delete chart": "ચાર્ટ કાઢી નાખો",
    "Error": "ભૂલ",
    "OK": "ઠીક છે",
    "Thanks": "આભાર",
    "Report failed": "રિપોર્ટ નિષ્ફળ ગયો",
    "Could not submit report feedback.": "રિપોર્ટ પ્રતિસાદ સબમિટ કરી શકાયો નથી.",
    "Personalised report ready": "વ્યક્તિગત રિપોર્ટ તૈયાર છે",
    "Personalised report failed": "વ્યક્તિગત રિપોર્ટ નિષ્ફળ થયો",
    "Could not generate personalised report.": "વ્યક્તિગત રિપોર્ટ જનરેટ કરી શકાયો નથી.",
    "Could not generate personalised PDF report.": "વ્યક્તિગત PDF રિપોર્ટ જનરેટ કરી શકાયો નથી.",
    "Monthly limit reached": "માસિક મર્યાદા પહોંચી",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "તમારી માસિક વ્યક્તિગત રિપોર્ટ મર્યાદા પહોંચી ગઈ છે. એડ-ઓન પર સબ્સ્ક્રાઇબ કરો: 20 રિપોર્ટ્સ માટે ₹299/મહિને અથવા 40 રિપોર્ટ્સ માટે ₹499/મહિને.",
    "Buy Add-on": "એડ-ઓન ખરીદો",
    "Manage": "મેનેજ કરો",
    "Add-on active: Unlimited reports": "ઍડ-ઑન સક્રિય: અમર્યાદિત રિપોર્ટ્સ",
    "Add-on active: 40 reports/month": "ઍડ-ઑન સક્રિય: 40 રિપોર્ટ્સ/મહિને",
    "Add-on active: 20 reports/month": "ઍડ-ઑન સક્રિય: 20 રિપોર્ટ્સ/મહિને",
    "reports remaining this cycle": "આ ચક્ર બાકીના અહેવાલો",
    "Add-on active": "ઍડ-ઑન સક્રિય",
    "Personalised reports remaining this month": "આ મહિને બાકી રહેલા વ્યક્તિગત અહેવાલ",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "પ્રીમિયમમાં 2/મહિનો શામેલ છે. એડ-ઓન્સ: 20 રિપોર્ટ્સ/મહિના માટે ₹299/મહિને અથવા 40 રિપોર્ટ્સ/મહિના માટે ₹499/મહિને.",
    "AI Disclaimer": "AI ડિસ્ક્લેમર",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "આ રિપોર્ટ AI અને જ્યોતિષીય અર્થઘટનનો ઉપયોગ કરીને બનાવવામાં આવ્યો છે. તે માત્ર માહિતી અને મનોરંજન હેતુ માટે છે. તેને તબીબી, કાનૂની અથવા નાણાકીય સલાહ ન ગણવી જોઈએ.",
    "A copy of this report has also been sent to your registered email address as a PDF.": "આ રિપોર્ટની એક નકલ પીડીએફ તરીકે તમારા રજિસ્ટર્ડ ઈમેલ એડ્રેસ પર પણ મોકલવામાં આવી છે.",
    "Report this AI-generated report?": "આ AI-જનરેટેડ રિપોર્ટની જાણ કરીએ?",
    "charts": "ચાર્ટ",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "સ્વતંત્ર નોંધો, તારીખ અને સમયનું આયોજન. સાચવવા માટે લોગિન જરૂરી છે; મફત વપરાશકર્તાઓ સંપૂર્ણ પ્લાનર ઍક્સેસ મેળવે છે.",
    "Independent notes, date and time planning.": "સ્વતંત્ર નોંધો, તારીખ અને સમયનું આયોજન.",
    "Add Plan": "યોજના ઉમેરો",
    "Save Plan": "યોજના સાચવો",
    "Saved Plans": "સાચવેલી યોજનાઓ",
    "Planner Entry": "પ્લાનર એન્ટ્રી",
    "Plan": "યોજના",
    "Saving...": "સાચવી રહ્યું છે...",
    "Refresh": "તાજું કરો",
    "No plans saved yet.": "હજુ સુધી કોઈ પ્લાન સાચવ્યો નથી.",
    "Planner layout is available. Login only when you want to save.": "પ્લાનર લેઆઉટ ઉપલબ્ધ છે. જ્યારે તમે સેવ કરવા માંગતા હોવ ત્યારે જ લોગિન કરો.",
    "No matching plans.": "કોઈ મેળ ખાતી યોજનાઓ નથી.",
    "Search Plans": "શોધ યોજનાઓ",
    "Search title, note, date or status": "શીર્ષક, નોંધ, તારીખ અથવા સ્થિતિ શોધો",
    "Login is required only when you want to save planner entries.": "જ્યારે તમે પ્લાનર એન્ટ્રીઝ સેવ કરવા માંગતા હોવ ત્યારે જ લોગિન જરૂરી છે.",
    "Planner entry saved.": "પ્લાનર એન્ટ્રી સાચવી.",
    "Unable to load planner.": "પ્લાનર લોડ કરવામાં અસમર્થ.",
    "Unable to save planner entry.": "પ્લાનર એન્ટ્રી સાચવવામાં અસમર્થ.",
    "Could not load planner.": "પ્લાનર લોડ કરી શકાયું નથી.",
    "Could not save planner entry.": "પ્લાનર એન્ટ્રી સાચવી શકાઈ નથી.",
    "Login required to save": "સાચવવા માટે લોગિન જરૂરી છે",
    "You can explore Planner now. Login when you want to save entries.": "તમે હવે પ્લાનરનું અન્વેષણ કરી શકો છો. જ્યારે તમે એન્ટ્રી સાચવવા માંગતા હોવ ત્યારે લોગિન કરો.",
    "Prev": "ગત",
    "Next": "આગળ",
    "Page": "પૃષ્ઠ",
    "of": "ના",
    "Child Birth Mahoorat": "બાળજન્મ મહુરત",
    "Child Birth Mahoorat | Kundlistar Premium": "બાળજન્મ મહુરત | કુંડલિસ્ટાર પ્રીમિયમ",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "પંચાંગ, ચોઘડિયા અને હોરા આધારિત માર્ગદર્શન સાથે પ્રીમિયમ બાળજન્મ મહૂરત વિન્ડો.",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "આયોજિત બાળક-જન્મ સમય માર્ગદર્શન માટે શુભ ઉપલબ્ધ વિન્ડો શોધવા માટે તારીખ અને સ્થળ પસંદ કરો.",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "બાળજન્મ મહૂરત માત્ર આધ્યાત્મિક અને જ્યોતિષીય માર્ગદર્શન માટે છે.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "બાળજન્મ મહૂરત એ પ્રીમિયમ ફીચર છે. પંચાંગ, ચોઘડિયા અને હોરા ચેક સાથે શુભ માર્ગદર્શન વિન્ડોને અનલૉક કરવા માટે અપગ્રેડ કરો.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "બાળજન્મ મહૂરત એ પ્રીમિયમ ફીચર છે. પંચાંગ, ચોઘડિયા અને હોરા ચેક સાથે માર્ગદર્શન વિન્ડોને અનલૉક કરવા માટે અપગ્રેડ કરો.",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "તારીખ, સ્થળ, પંચાંગ, ચોઘડિયા અને હોરા દ્વારા પ્રીમિયમ માર્ગદર્શન વિન્ડો.",
    "Premium feature": "પ્રીમિયમ સુવિધા",
    "Upgrade to Kundlistar Premium": "કુંડલિસ્ટાર પ્રીમિયમ પર અપગ્રેડ કરો",
    "Previous": "ગત",
    "Today": "આજે",
    "Birth place / City": "જન્મ સ્થળ / શહેર",
    "Birth place / city": "જન્મ સ્થળ / શહેર",
    "Select country, then search city": "દેશ પસંદ કરો, પછી શહેર શોધો",
    "Preferred start": "પસંદગીની શરૂઆત",
    "Preferred end": "મનપસંદ અંત",
    "Mother Moon sign (optional)": "માતા ચંદ્ર ચિહ્ન (વૈકલ્પિક)",
    "Cancer": "કેન્સર",
    "Load Kundli": "કુંડલી લોડ કરો",
    "Find Premium Windows": "પ્રીમિયમ વિન્ડોઝ શોધો",
    "Date (DD/MM/YYYY)": "તારીખ (DD/MM/YYYY)",
    "Invalid Date": "અમાન્ય તારીખ",
    "Date must be in DD/MM/YYYY format.": "તારીખ DD/MM/YYYY ફોર્મેટમાં હોવી આવશ્યક છે.",
    "Required": "જરૂરી છે",
    "Please select a city.": "કૃપા કરીને એક શહેર પસંદ કરો.",
    "Kundli": "કુંડલી",
    "Unable to load kundli.": "કુંડળી લોડ કરવામાં અસમર્થ.",
    "Unable to calculate Child Birth Mahoorat.": "બાળજન્મ મહૂરતની ગણતરી કરવામાં અસમર્થ.",
    "Kundli Preview": "કુંડલી પૂર્વાવલોકન",
    "Loaded for": "માટે લોડ",
    "Doshas & Yogas": "દોષ અને યોગ",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "લોડ કરેલી લાહિરી કુંડળીમાંથી નિયમ-આધારિત સંકેતો. તેનો ઉપયોગ સમીક્ષા અને આધ્યાત્મિક માર્ગદર્શન માટે કરો, અંતિમ નિર્ણય તરીકે નહીં.",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "લોડ કરેલી લાહિરી કુંડળીમાંથી નિયમ-આધારિત સંકેતો. સમીક્ષા અને આધ્યાત્મિક માર્ગદર્શન માટે ઉપયોગ કરો.",
    "Detected": "શોધાયેલ",
    "Not detected": "શોધાયેલ નથી",
    "Review": "સમીક્ષા",
    "Dosha": "દોષા",
    "Yoga": "યોગ",
    "Full Yoga Scan": "સંપૂર્ણ યોગા સ્કેન",
    "Checking yogas...": "યોગ તપાસી રહ્યાં છીએ...",
    "No major yogas were detected by the premium yoga scan.": "પ્રીમિયમ યોગ સ્કેન દ્વારા કોઈ મોટા યોગો મળ્યા નથી.",
    "No suitable premium windows found for the selected date and time range.": "પસંદ કરેલ તારીખ અને સમય શ્રેણી માટે કોઈ યોગ્ય પ્રીમિયમ વિન્ડો મળી નથી.",
    "No suitable windows found": "કોઈ યોગ્ય વિન્ડો મળી નથી",
    "Try changing the time range or select previous/next date.": "સમય શ્રેણી બદલવાનો પ્રયાસ કરો અથવા પાછલી/આગલી તારીખ પસંદ કરો.",
    "Try changing the date or time range.": "તારીખ અથવા સમય શ્રેણી બદલવાનો પ્રયાસ કરો.",
    "Try the Previous or Next date button to find a better option.": "વધુ સારો વિકલ્પ શોધવા માટે પહેલાની અથવા આગલી તારીખ બટનનો પ્રયાસ કરો.",
    "Use Previous or Next date to find a better option.": "વધુ સારો વિકલ્પ શોધવા માટે અગાઉની અથવા આગલી તારીખનો ઉપયોગ કરો.",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "પસંદ કરેલ તારીખ અને શહેર માટે શ્રેષ્ઠ પ્રીમિયમ વિન્ડોઝની ગણતરી કરવા માટે પ્રીમિયમ વિન્ડોઝ શોધો પર ક્લિક કરો.",
    "Tap Find Premium Windows for the selected date and city.": "પસંદ કરેલી તારીખ અને શહેર માટે પ્રીમિયમ વિન્ડોઝ શોધો પર ટૅપ કરો.",
    "Good tithi": "શુભ તિથિ",
    "Supportive nakshatra": "સહાયક નક્ષત્ર",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "નક્ષત્ર સંવેદનશીલ છે. પાડા અને ગાંડાંને કાળજીપૂર્વક તપાસો.",
    "Supportive weekday": "સહાયક સપ્તાહનો દિવસ",
    "Good Choghadiya": "સારું ચોઘડિયા",
    "Weak Choghadiya": "નબળા ચોઘડિયા",
    "Supportive Hora": "સહાયક હોરા",
    "Baby Moon matches mother's Moon sign.": "બેબી મૂન માતાના ચંદ્ર ચિહ્ન સાથે મેળ ખાય છે.",
    "Hora": "હોરા",
    "slots": "સ્લોટ્સ",
    "min": "મિનિટ",
    "Good": "સારું",
    "Excellent": "ઉત્તમ",
    "Usable": "ઉપયોગી",
    "Rejected": "ફગાવી દીધી",
    "Sunday": "રવિવાર",
    "Monday": "સોમવાર",
    "Tuesday": "મંગળવાર",
    "Wednesday": "બુધવાર",
    "Thursday": "ગુરુવાર",
    "Friday": "શુક્રવાર",
    "Saturday": "શનિવાર",
    "Sun": "સૂર્ય",
    "Moon": "ચંદ્ર",
    "Mars": "મંગળ",
    "Mercury": "બુધ",
    "Jupiter": "ગુરુ",
    "Venus": "શુક્ર",
    "Saturn": "શનિ",
    "Rahu": "રાહુ",
    "Ketu": "કેતુ",
    "Chal": "ચાલ",
    "Labh": "લભ",
    "Amrit": "અમૃત",
    "Shubh": "શુભ",
    "Udveg": "ઉદ્વેગ",
    "Rog": "રોગ",
    "Kaal": "કાલ",
    "Krishna Navami": "કૃષ્ણ નવમી",
    "Ashwini": "અશ્વિની",
    "Bharani": "ભરણી",
    "Krittika": "કૃતિકા",
    "Rohini": "રોહિણી",
    "Mrigashira": "મૃગશિરા",
    "Ardra": "આર્દ્રા",
    "Punarvasu": "પુનર્વસુ",
    "Pushya": "પુષ્ય",
    "Ashlesha": "આશ્લેષા",
    "Magha": "માગા",
    "Jyeshtha": "જ્યેષ્ઠા",
    "Moola": "મૂલા",
    "Mula": "મુલા",
    "Revati": "રેવતી"
  },
  "bn": {
    "Client Management": "ক্লায়েন্ট ম্যানেজমেন্ট",
    "Dashboard": "ড্যাশবোর্ড",
    "Clients": "ক্লায়েন্ট",
    "Consultations": "পরামর্শ",
    "Notes": "নোট",
    "Follow-ups": "ফলো-আপ",
    "Reports": "রিপোর্ট",
    "Remedies": "প্রতিকার",
    "Predictions": "ভবিষ্যদ্বাণী",
    "Planner": "পরিকল্পনাকারী",
    "Templates": "টেমপ্লেট",
    "Analytics": "বিশ্লেষণ",
    "Payments": "পেমেন্ট",
    "Settings": "সেটিংস",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings-এ ডিফল্ট শহর সংরক্ষণ করতে পারেন। ডিফল্ট শহর নির্বাচন না করা পর্যন্ত শহরের ঘর খালি থাকবে।",
    "is now your default city.": "এখন আপনার ডিফল্ট শহর।",
    "Search your default city": "আপনার ডিফল্ট শহর খুঁজুন",
    "This color is saved for the website theme and PDF report accent.": "এই রঙ ওয়েবসাইট থিম এবং PDF রিপোর্ট accent-এর জন্য সংরক্ষিত হবে।",
    "Turn All off to include only the checked modules in the report.": "রিপোর্টে শুধু নির্বাচিত মডিউল রাখতে All বন্ধ করুন।",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All চালু থাকলে PDF-এ সব মডিউল থাকবে। শুধু নির্বাচিত মডিউল রাখতে এটি বন্ধ করুন।",
    "Uranus, Neptune and Pluto stay hidden by default.": "ইউরেনাস, নেপচুন এবং প্লুটো ডিফল্টভাবে লুকানো থাকে।",
    "Show Uranus, Neptune and Pluto": "ইউরেনাস, নেপচুন এবং প্লুটো দেখান",
    "When off, Nadi and KP also use the selected global ayanamsha.": "বন্ধ থাকলে নাড়ি এবং KP-ও নির্বাচিত গ্লোবাল অয়নাংশ ব্যবহার করবে।",
    "Use KP for Nadi and KP": "নাড়ি এবং KP-এর জন্য KP ব্যবহার করুন",
    "Use KP ayanamsha for Nadi and KP": "নাড়ি এবং KP-এর জন্য KP অয়নাংশ ব্যবহার করুন",
    "Night": "নাইট",
    "Dark": "ডার্ক",
    "Light": "লাইট",
    "Clear default city": "ডিফল্ট শহর মুছুন",
    "Default City": "ডিফল্ট শহর",
    "Default city": "ডিফল্ট শহর",
    "Theme Color": "থিম রঙ",
    "Theme color": "থিম রঙ",
    "Include all modules": "সব মডিউল অন্তর্ভুক্ত করুন",
    "PDF Report Modules": "PDF রিপোর্ট মডিউল",
    "PDF report modules": "PDF রিপোর্ট মডিউল",
    "Show": "দেখান",
    "Hide": "লুকান",
    "Outer Planets": "বহিঃগ্রহ",
    "Outer planets": "বহিঃগ্রহ",
    "Ayanamsha": "অয়নাংশ",
    "Mean Node": "মিন নোড",
    "True Node": "ট্রু নোড",
    "Rahu/Ketu Calculation": "রাহু/কেতু গণনা",
    "Rahu/Ketu calculation": "রাহু/কেতু গণনা",
    "East": "পূর্ব ভারতীয়",
    "South": "দক্ষিণ ভারতীয়",
    "North": "উত্তর ভারতীয়",
    "Chart Style": "চার্ট স্টাইল",
    "Chart style": "চার্ট স্টাইল",
    "Language": "ভাষা",
    "Records": "রেকর্ডস",
    "Relations": "সম্পর্ক",
    "Relation": "সম্পর্ক",
    "Add Client": "ক্লায়েন্ট যোগ করুন",
    "Add Consultation": "পরামর্শ যোগ করুন",
    "Add Note": "নোট যোগ করুন",
    "Add Follow-up": "ফলো-আপ যোগ করুন",
    "Create Report": "রিপোর্ট তৈরি করুন",
    "Assign Remedy": "প্রতিকার বরাদ্দ করুন",
    "Add Prediction": "ভবিষ্যদ্বাণী যোগ করুন",
    "Add Payment": "পেমেন্ট যোগ করুন",
    "Assign Chart": "চার্ট বরাদ্দ করুন",
    "Add Relation": "সম্পর্ক যোগ করুন",
    "CMS Action": "সিএমএস অ্যাকশন",
    "Client": "ক্লায়েন্ট",
    "Chart": "চার্ট",
    "Related Client": "সম্পর্কিত ক্লায়েন্ট",
    "Full Name": "পুরো নাম",
    "Phone Number": "ফোন নম্বর",
    "WhatsApp Number": "হোয়াটসঅ্যাপ নম্বর",
    "Email": "ইমেইল",
    "Birth Place": "জন্মস্থান",
    "Current City": "বর্তমান শহর",
    "Main Topic": "মূল বিষয়",
    "Status": "স্ট্যাটাস",
    "Source": "উৎস",
    "Tags": "ট্যাগ",
    "Internal Note": "অভ্যন্তরীণ নোট",
    "Purpose": "উদ্দেশ্য",
    "Relation Type": "সম্পর্কের ধরন",
    "Title": "শিরোনাম",
    "Topic": "বিষয়",
    "Date": "তারিখ",
    "Time": "সময়",
    "Amount": "পরিমাণ",
    "Mode": "মোড",
    "Payment Status": "পেমেন্ট স্ট্যাটাস",
    "Note / Summary": "নোট/সারাংশ",
    "Close": "বন্ধ",
    "Cancel": "বাতিল করুন",
    "Save": "সংরক্ষণ করুন",
    "Saving": "সংরক্ষণ",
    "Save Changes": "পরিবর্তনগুলি সংরক্ষণ করুন",
    "Edit Client": "ক্লায়েন্ট সম্পাদনা করুন",
    "Client Chart": "ক্লায়েন্ট চার্ট",
    "Comma separated": "কমা বিচ্ছিন্ন",
    "Search by name, phone, email, topic, or tag": "নাম, ফোন, ইমেল, বিষয় বা ট্যাগ দ্বারা অনুসন্ধান করুন",
    "Search clients, phone, topic": "ক্লায়েন্ট, ফোন, বিষয় অনুসন্ধান করুন",
    "Search your saved charts by chart name": "চার্ট নামের দ্বারা আপনার সংরক্ষিত চার্ট অনুসন্ধান করুন",
    "Linked Chart": "লিঙ্ক করা চার্ট",
    "Select linked chart": "লিঙ্ক করা চার্ট নির্বাচন করুন",
    "Link a chart to this client before adding records.": "রেকর্ড যোগ করার আগে এই ক্লায়েন্টের সাথে একটি চার্ট লিঙ্ক করুন।",
    "Connect this client with another saved client profile": "এই ক্লায়েন্টটিকে অন্য সংরক্ষিত ক্লায়েন্ট প্রোফাইলের সাথে সংযুক্ত করুন",
    "CMS for astrologer client work": "জ্যোতিষী ক্লায়েন্ট কাজের জন্য সিএমএস",
    "Premium Pro unlocks Client Management": "প্রিমিয়াম প্রো ক্লায়েন্ট ম্যানেজমেন্ট আনলক করে",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ক্লায়েন্ট প্রোফাইল, পরামর্শ, নোট, ফলো-আপ, রিপোর্ট, প্রতিকার, ভবিষ্যদ্বাণী, বিশ্লেষণ এবং অর্থপ্রদান ট্র্যাকিং এক কর্মক্ষেত্রে পরিচালনা করতে আপগ্রেড করুন।",
    "Upgrade to Premium Pro": "প্রিমিয়াম প্রোতে আপগ্রেড করুন",
    "CMS modules included": "CMS মডিউল অন্তর্ভুক্ত",
    "Please login to use Client Management. CMS data is stored per account.": "ক্লায়েন্ট ম্যানেজমেন্ট ব্যবহার করতে লগইন করুন. প্রতি অ্যাকাউন্টে CMS ডেটা সংরক্ষণ করা হয়।",
    "Login": "লগইন করুন",
    "Loading live CMS data...": "লাইভ CMS ডেটা লোড হচ্ছে...",
    "Quick Actions": "দ্রুত অ্যাকশন",
    "Client Records": "ক্লায়েন্ট রেকর্ডস",
    "Client Record": "ক্লায়েন্ট রেকর্ড",
    "Client Profile": "ক্লায়েন্ট প্রোফাইল",
    "Back to Clients": "ক্লায়েন্টে ফিরে যান",
    "View": "দেখুন",
    "Edit": "সম্পাদনা করুন",
    "Delete": "মুছে দিন",
    "Note": "দ্রষ্টব্য",
    "Archive": "সংরক্ষণাগার",
    "Download PDF": "PDF ডাউনলোড করুন",
    "Delete this record?": "এই রেকর্ড মুছে ফেলবেন?",
    "Unable to edit this CMS record.": "এই CMS রেকর্ড সম্পাদনা করতে অক্ষম.",
    "Unable to update CMS record.": "CMS রেকর্ড আপডেট করতে অক্ষম।",
    "Unable to delete CMS record.": "CMS রেকর্ড মুছতে অক্ষম৷",
    "No contact added": "কোনো পরিচিতি যোগ করা হয়নি",
    "No topic": "কোন টপিক নেই",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "এখনও কোন ক্লায়েন্ট পাওয়া যায়নি. CMS ড্যাশবোর্ড পূরণ করতে আপনার প্রথম আসল ক্লায়েন্ট যোগ করুন।",
    "Last Consultation": "শেষ পরামর্শ",
    "Next Follow-up": "পরবর্তী ফলো-আপ",
    "Date of Birth": "জন্ম তারিখ",
    "Time of Birth": "জন্মের সময়",
    "Client Details": "ক্লায়েন্ট বিবরণ",
    "No connected profiles yet.": "এখনো কোনো সংযুক্ত প্রোফাইল নেই.",
    "Select a client record to view details.": "বিবরণ দেখতে একটি ক্লায়েন্ট রেকর্ড নির্বাচন করুন.",
    "Record": "রেকর্ড",
    "Consultation Summary": "পরামর্শের সারাংশ",
    "Client Note": "ক্লায়েন্ট নোট",
    "Start a consultation record with summary, topic, mode and payment fields.": "সারাংশ, বিষয়, মোড এবং অর্থপ্রদানের ক্ষেত্রগুলির সাথে একটি পরামর্শ রেকর্ড শুরু করুন।",
    "Start a private note attached to a client profile.": "একটি ক্লায়েন্ট প্রোফাইল সংযুক্ত একটি ব্যক্তিগত নোট শুরু করুন.",
    "Start a pending follow-up with due date and topic.": "নির্ধারিত তারিখ এবং বিষয় সহ একটি মুলতুবি ফলো-আপ শুরু করুন।",
    "Start a report record connected to the client timeline.": "ক্লায়েন্ট টাইমলাইনের সাথে সংযুক্ত একটি রিপোর্ট রেকর্ড শুরু করুন।",
    "Start an active remedy record for client guidance.": "ক্লায়েন্ট গাইডেন্সের জন্য একটি সক্রিয় প্রতিকার রেকর্ড শুরু করুন।",
    "Start an open prediction record with notes and follow-up date.": "নোট এবং ফলো-আপ তারিখ সহ একটি খোলা ভবিষ্যদ্বাণী রেকর্ড শুরু করুন।",
    "Statuses": "স্ট্যাটাস",
    "Topics": "বিষয়",
    "Sources": "সূত্র",
    "No records found for the current filters.": "বর্তমান ফিল্টারগুলির জন্য কোনও রেকর্ড পাওয়া যায়নি৷",
    "Total Clients": "মোট ক্লায়েন্ট",
    "New Clients This Month": "এই মাসে নতুন ক্লায়েন্ট",
    "Consultations This Month": "এই মাসে পরামর্শ",
    "Today's Consultations": "আজকের পরামর্শ",
    "Consultations scheduled for today from real client records.": "বাস্তব ক্লায়েন্ট রেকর্ড থেকে আজকের জন্য নির্ধারিত পরামর্শ.",
    "No consultations scheduled for today.": "আজকের জন্য নির্ধারিত কোন পরামর্শ.",
    "Pending Follow-ups": "মুলতুবি ফলো আপ",
    "Reports Created": "প্রতিবেদন তৈরি করা হয়েছে",
    "Active Remedies": "সক্রিয় প্রতিকার",
    "Open Predictions": "খোলা ভবিষ্যদ্বাণী",
    "Pending Payments": "মুলতুবি পেমেন্ট",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "এক জায়গায় ক্লায়েন্ট কার্যকলাপ, সাম্প্রতিক কাজ, ফলো-আপ, রিপোর্ট, পূর্বাভাস, প্রতিকার এবং মুলতুবি পেমেন্ট দেখুন।",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "জন্মের বিবরণ, বিষয়, ট্যাগ, স্থিতি এবং সংরক্ষণাগার/পুনরুদ্ধার ক্রিয়া সহ জ্যোতিষী ক্লায়েন্ট রেকর্ডগুলি পরিচালনা করুন।",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "সেশনের বিশদ বিবরণ, সংযুক্ত চার্ট, বিষয়, পর্যবেক্ষণ, ভবিষ্যদ্বাণী, প্রতিকার এবং ফলো-আপ তারিখ সংরক্ষণ করুন।",
    "Keep private consultation notes and chart observations attached to client profiles.": "ব্যক্তিগত পরামর্শ নোট এবং চার্ট পর্যবেক্ষণ ক্লায়েন্ট প্রোফাইল সংযুক্ত রাখুন.",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "পুশ, এসএমএস, ইমেল বা হোয়াটসঅ্যাপ সতর্কতা ছাড়াই ক্লায়েন্ট ম্যানেজমেন্টের মধ্যে আজ এবং আসন্ন ফলো-আপগুলি ট্র্যাক করুন।",
    "Create and organize client reports generated from saved charts and consultation context.": "সংরক্ষিত চার্ট এবং পরামর্শের প্রসঙ্গ থেকে জেনারেট করা ক্লায়েন্ট রিপোর্ট তৈরি এবং সংগঠিত করুন।",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "প্রতিকার বরাদ্দ করুন, সক্রিয় নির্দেশিকা চিহ্নিত করুন এবং প্রতিকারের ইতিহাস ক্লায়েন্ট টাইমলাইনের সাথে সংযুক্ত রাখুন।",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "প্রতিটি ক্লায়েন্টের জন্য খোলা ভবিষ্যদ্বাণী, তারিখ, আস্থা নোট এবং ফলাফল আপডেট ট্র্যাক করুন।",
    "Plan consultations, follow-ups and payment dates in one working view.": "পরিকল্পনা পরামর্শ, ফলো-আপ এবং অর্থপ্রদানের তারিখগুলি এক কাজের দৃশ্যে।",
    "Prepare reusable consultation, report, remedy and prediction templates.": "পুনরায় ব্যবহারযোগ্য পরামর্শ, প্রতিবেদন, প্রতিকার এবং ভবিষ্যদ্বাণী টেমপ্লেট প্রস্তুত করুন।",
    "Review client activity, consultation volume, reports created and pending work.": "ক্লায়েন্ট কার্যকলাপ পর্যালোচনা করুন, পরামর্শ ভলিউম, রিপোর্ট তৈরি এবং মুলতুবি কাজ.",
    "Track consultation amounts and payment status without plan or pricing rules.": "পরিকল্পনা বা মূল্যের নিয়ম ছাড়াই পরামর্শের পরিমাণ এবং অর্থপ্রদানের স্থিতি ট্র্যাক করুন।",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "ক্লায়েন্ট উত্স, স্থিতি, বিষয়, ট্যাগ এবং অভ্যন্তরীণ CMS পছন্দগুলি কনফিগার করুন৷",
    "Showing saved records connected to client records.": "ক্লায়েন্ট রেকর্ডের সাথে সংযুক্ত সংরক্ষিত রেকর্ড দেখানো হচ্ছে।",
    "No Status": "কোন স্ট্যাটাস নেই",
    "No Mode": "কোন মোড নেই",
    "No Payment Status": "পেমেন্ট স্থিতি নেই",
    "No Topic": "কোন টপিক নেই",
    "No Source": "কোন উৎস নেই",
    "All Statuses": "সমস্ত স্ট্যাটাস",
    "All Topics": "সমস্ত বিষয়",
    "No clients found": "কোন ক্লায়েন্ট পাওয়া যায়নি",
    "Type to search clients": "ক্লায়েন্ট অনুসন্ধান করতে টাইপ করুন",
    "No charts found": "কোনো চার্ট পাওয়া যায়নি",
    "Type to search saved charts": "সংরক্ষিত চার্ট অনুসন্ধান করতে টাইপ করুন",
    "Type to search related client": "সম্পর্কিত ক্লায়েন্ট অনুসন্ধান করতে টাইপ করুন",
    "Open": "খোলা",
    "Pending": "মুলতুবি",
    "Scheduled": "নির্ধারিত",
    "Completed": "সম্পন্ন",
    "Follow-up Pending": "ফলো-আপ মুলতুবি",
    "Cancelled": "বাতিল",
    "Closed": "বন্ধ",
    "No-show": "নো-শো",
    "Not Applicable": "প্রযোজ্য নয়",
    "Paid": "পেড",
    "Partially Paid": "আংশিক অর্থ প্রদান",
    "Refunded": "ফেরত দেওয়া হয়েছে",
    "Phone": "ফোন",
    "WhatsApp Call": "হোয়াটসঅ্যাপ কল",
    "Video Call": "ভিডিও কল",
    "In-person": "ব্যক্তিগতভাবে",
    "Chat": "চ্যাট",
    "Other": "অন্যান্য",
    "New": "নতুন",
    "VIP": "ভিআইপি",
    "Inactive": "নিষ্ক্রিয়",
    "Consultation Completed": "পরামর্শ সম্পন্ন",
    "WhatsApp": "হোয়াটসঅ্যাপ",
    "Instagram": "ইনস্টাগ্রাম",
    "YouTube": "YouTube",
    "Referral": "রেফারেল",
    "Website": "ওয়েবসাইট",
    "Walk-in": "ওয়াক-ইন",
    "Repeat Client": "ক্লায়েন্ট পুনরাবৃত্তি করুন",
    "Family Referral": "পারিবারিক রেফারেল",
    "Business": "ব্যবসা",
    "Finance": "অর্থ",
    "Property": "সম্পত্তি",
    "Children": "শিশুরা",
    "Foreign Settlement": "বিদেশী বসতি",
    "Legal": "আইনি",
    "Remedy": "প্রতিকার",
    "General": "সাধারণ",
    "Active": "সক্রিয়",
    "Past": "অতীত",
    "Potential": "সম্ভাব্য",
    "Archived": "সংরক্ষণাগারভুক্ত",
    "Spouse": "পত্নী",
    "Husband": "স্বামী",
    "Wife": "স্ত্রী",
    "Child": "শিশু",
    "Son": "পুত্র",
    "Daughter": "কন্যা",
    "Father": "বাবা",
    "Mother": "মা",
    "Sibling": "ভাইবোন",
    "Brother": "ভাই",
    "Sister": "বোন",
    "Marriage Prospect": "বিবাহ সম্ভাবনা",
    "Fiance": "বাগদত্তা",
    "Business Partner": "ব্যবসায়িক অংশীদার",
    "Friend": "বন্ধু",
    "Relative": "আপেক্ষিক",
    "Upgrade": "আপগ্রেড করুন",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "আপনি শুধুমাত্র 2 ক্লায়েন্ট যোগ করতে পারেন. আরও ক্লায়েন্টদের জন্য প্রিমিয়ামে আপগ্রেড করুন।",
    "None": "কোনোটিই নয়",
    "Education": "শিক্ষা",
    "Awards": "পুরস্কার",
    "Prize": "পুরস্কার",
    "Career": "কর্মজীবন",
    "Love": "প্রেম",
    "Marriage": "বিবাহ",
    "Dowry or Legacy": "যৌতুক বা উত্তরাধিকার",
    "Divorce": "ডিভোর্স",
    "Abortion": "গর্ভপাত",
    "Child Birth": "শিশুর জন্ম",
    "Property/Vehicle Purchase": "সম্পত্তি/যানবাহন ক্রয়",
    "Property/Vehicle Sale": "সম্পত্তি / যানবাহন বিক্রয়",
    "Love and Caring": "প্রেম এবং যত্ন",
    "Depression": "বিষণ্নতা",
    "Aggression": "আগ্রাসন",
    "Health": "স্বাস্থ্য",
    "Travel": "ভ্রমণ",
    "Homecoming": "স্বদেশ প্রত্যাবর্তন",
    "Litigation": "মোকদ্দমা",
    "Arrest": "গ্রেফতার",
    "Locked": "তালাবদ্ধ",
    "Strong": "শক্তিশালী",
    "Weak": "দুর্বল",
    "Supportive": "সহায়ক",
    "Avoid": "এড়িয়ে চলুন",
    "Premium": "প্রিমিয়াম",
    " UTC": "ইউটিসি",
    "Unable to calculate Tithi Pravesh": "তিথি প্রবেশের হিসাব করতে পারছে না",
    "IANA timezone": "IANA টাইমজোন",
    "TP Local": "টিপি স্থানীয়",
    "TP UTC": "টিপি ইউটিসি",
    "Next TP Local": "পরবর্তী টিপি লোকাল",
    "Models: KP + Vedic": "মডেল: কেপি + বৈদিক",
    "Overall Year Theme": "সামগ্রিক বছরের থিম",
    "Career & Job": "পেশা এবং চাকরি",
    "Finance & Savings": "অর্থ ও সঞ্চয়",
    "Relationship & Marriage": "সম্পর্ক এবং বিবাহ",
    "Family Matters": "পারিবারিক বিষয়",
    "Property & Vehicle": "সম্পত্তি এবং যানবাহন",
    "Health & Wellness": "স্বাস্থ্য ও সুস্থতা",
    "Spiritual Growth": "আধ্যাত্মিক বৃদ্ধি",
    "Social Status & Recognition": "সামাজিক অবস্থা এবং স্বীকৃতি",
    "Please select a saved chart first.": "অনুগ্রহ করে প্রথমে একটি সংরক্ষিত চার্ট নির্বাচন করুন।",
    "Unable to generate Tajika Varshphal": "তাজিকা ভার্শফল তৈরি করতে অক্ষম৷",
    "Premium yearly module": "প্রিমিয়াম বার্ষিক মডিউল",
    "Tajika Varshphal": "তাজিকা বর্ষফল",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "এই সংরক্ষিত কুন্ডলি থেকে ব্যক্তিগতকৃত বর্ষা লগ্ন, মুনথা, বর্ষা অধিপতি, সহমস, মাসিক নির্দেশিকা, প্রতিকার এবং ব্যবহারিক জীবনের থিম সহ সৌর রিটার্ন ভিত্তিক বার্ষিক রাশিফল।",
    "Saved chart": "সংরক্ষিত চার্ট",
    "Untitled Chart": "শিরোনামহীন চার্ট",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "আপনার 4টি বিনামূল্যের প্রিমিয়াম ক্রেডিট ব্যবহার করা হয়েছে৷ সীমাহীন প্রিমিয়াম অ্যাক্সেসের জন্য Kundlistar প্রিমিয়ামে আপগ্রেড করুন।",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "আপনার 4 ফ্রি প্রিমিয়াম ক্রেডিট ব্যবহার করতে পারেন। অসীম প্রমাস অ্যাক্সেসের জন্য __KDL_MASK__0__ প্রিমিয়াম নিন।",
    "Core Year Markers": "মূল বছরের চিহ্নিতকারী",
    "Solar Return": "সোলার রিটার্ন",
    "Varsha Lagna": "বর্ষা লগ্ন",
    "Muntha Lord": "মুনথা অধিপতি",
    "Varsha Lord": "বর্ষা অধিপতি",
    "Varshesh Method": "বর্ষেশ পদ্ধতি",
    "Yearly Summary": "বার্ষিক সারাংশ",
    "Not available yet.": "এখনো পাওয়া যায় নি।",
    "Varshesh Candidates": "বর্ষেশ প্রার্থীরা",
    "Risk Areas": "ঝুঁকিপূর্ণ এলাকা",
    "Favourable Periods": "অনুকূল সময়কাল",
    "Challenging Periods": "চ্যালেঞ্জিং সময়কাল",
    "Remedies & Final Advice": "প্রতিকার ও চূড়ান্ত পরামর্শ",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "তাজিকা বর্ষফল ব্যাখ্যামূলক বার্ষিক নির্দেশিকা দেয়। এটিকে চিকিৎসা, আইনি, আর্থিক বা নির্দিষ্ট ভবিষ্যদ্বাণী পরামর্শ হিসাবে বিবেচনা করা উচিত নয়।",
    "Griha Pravesh": "গৃহপ্রবেশ",
    "Purva Phalguni": "পূর্বফাল্গুনী",
    "Uttara Phalguni": "উত্তরফাল্গুনী",
    "Purva Ashadha": "পূর্বাষাঢ়া",
    "Uttara Ashadha": "উত্তরাষাঢ়া",
    "Purva Bhadrapada": "পূর্বভাদ্রপদ",
    "Uttara Bhadrapada": "উত্তরভাদ্রপদ",
    "Param Mitra": "পরম মিত্র",
    "Kundli birthplace": "কুন্ডলি জন্মস্থান",
    "Selected city": "নির্বাচিত শহর",
    "Muhurat - Kundlistar": "মুহুর্ত - Kundlistar",
    "Please select a city first.": "প্রথমে একটি শহর নির্বাচন করুন.",
    "Unable to calculate Muhurat.": "মুহুর্ত গণনা করতে অক্ষম।",
    "Unable to calculate personalized Muhurat.": "ব্যক্তিগতকৃত মুহুর্ত গণনা করতে অক্ষম।",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "পঞ্চং, চোঘদিয়া, হোরা, তারাবালা এবং চন্দ্রবালা ব্যবহার করে সাধারণ এবং ব্যক্তিগতকৃত মুহুর্ত খুঁজুন।",
    "Muhurat Finder": "মুহুর্ত ফাইন্ডার",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "Panchang, Choghadiya এবং প্রিমিয়াম ব্যক্তিগত জন্মের কারণগুলি ব্যবহার করে দরকারী সময় উইন্ডো খুঁজুন।",
    "Search city...": "শহর অনুসন্ধান করুন...",
    "Using selected Kundli": "নির্বাচিত কুন্ডলি ব্যবহার করে",
    "Find Free": "বিনামূল্যে খুঁজুন",
    "Free General Muhurat": "বিনামূল্যে সাধারণ মুহুর্ত",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "পরবর্তী 7 দিনের জন্য শীর্ষ 3 স্লট। রাহু কাল, যমাগন্ডা ও গুলিকা দূর হয়।",
    "Today's Muhurat": "আজকের মুহুর্ত",
    "Daily Muhurat by Kundlistar": "Kundlistar দ্বারা দৈনিক মুহুর্ত",
    "Shared via Kundlistar": "Kundlistar এর মাধ্যমে ভাগ করা হয়েছে",
    "Kundlistar Muhurat": "Kundlistar মুহুর্ত",
    "Share Image": "ছবি শেয়ার করুন",
    "Share Text": "টেক্সট শেয়ার করুন",
    "Copy Text": "টেক্সট কপি করুন",
    "Click Find Free to use the selected Kundli birthplace.": "নির্বাচিত কুন্ডলি জন্মস্থান ব্যবহার করতে বিনামূল্যে খুঁজুন ক্লিক করুন।",
    "Select a city and click Find Free.": "একটি শহর নির্বাচন করুন এবং বিনামূল্যে খুঁজুন ক্লিক করুন.",
    "Premium Personalized Muhurat": "প্রিমিয়াম ব্যক্তিগতকৃত মুহুর্ত",
    "Loading Kundli details...": "কুন্ডলির বিবরণ লোড হচ্ছে...",
    "Birth Nakshatra": "জন্ম নক্ষত্র",
    "Birth Moon Rashi": "জন্ম চন্দ্র রাশি",
    "Include night slots": "রাতের স্লট অন্তর্ভুক্ত করুন",
    "Find Premium": "প্রিমিয়াম খুঁজুন",
    "Your grounding and foundation energy appears strong in this chart.": "এই চার্টে আপনার গ্রাউন্ডিং এবং ফাউন্ডেশন শক্তি শক্তিশালী বলে মনে হচ্ছে।",
    "Your grounding energy appears generally balanced in this chart.": "এই চার্টে আপনার গ্রাউন্ডিং শক্তি সাধারণত ভারসাম্যপূর্ণ বলে মনে হয়।",
    "Reflection on routine, discipline, and inner stability may be useful.": "রুটিন, শৃঙ্খলা এবং অভ্যন্তরীণ স্থিতিশীলতার প্রতিফলন কার্যকর হতে পারে।",
    "Your creative and emotional flow energy appears strong in this chart.": "আপনার সৃজনশীল এবং মানসিক প্রবাহ শক্তি এই চার্টে শক্তিশালী প্রদর্শিত হবে।",
    "Your creative energy appears balanced in this chart.": "আপনার সৃজনশীল শক্তি এই চার্টে ভারসাম্যপূর্ণ প্রদর্শিত হবে।",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "সৃজনশীলতা, মানসিক অভিব্যক্তি এবং অভ্যন্তরীণ প্রবাহের প্রতিফলন কার্যকর হতে পারে।",
    "Your confidence and willpower energy appears strong in this chart.": "আপনার আত্মবিশ্বাস এবং ইচ্ছাশক্তি শক্তি এই চার্টে শক্তিশালী প্রদর্শিত হবে।",
    "Your action-taking energy appears balanced in this chart.": "আপনার অ্যাকশন-টেকিং এনার্জি এই চার্টে ভারসাম্যপূর্ণ দেখাচ্ছে।",
    "Reflection on confidence, discipline, and decision power may be useful.": "আত্মবিশ্বাস, শৃঙ্খলা এবং সিদ্ধান্তের ক্ষমতার প্রতিফলন কার্যকর হতে পারে।",
    "Your connection and compassion energy appears strong in this chart.": "আপনার সংযোগ এবং সমবেদনা শক্তি এই চার্টে শক্তিশালী প্রদর্শিত হবে।",
    "Your emotional connection energy appears balanced in this chart.": "আপনার মানসিক সংযোগ শক্তি এই চার্টে ভারসাম্যপূর্ণ প্রদর্শিত হবে।",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "সম্প্রীতি, ক্ষমা এবং মানসিক ভারসাম্যের প্রতিফলন কার্যকর হতে পারে।",
    "Your communication and expression energy appears strong in this chart.": "আপনার যোগাযোগ এবং অভিব্যক্তি শক্তি এই চার্টে শক্তিশালী প্রদর্শিত হবে।",
    "Your expression energy appears balanced in this chart.": "আপনার অভিব্যক্তি শক্তি এই চার্টে ভারসাম্যপূর্ণ প্রদর্শিত হবে।",
    "Reflection on clear communication and self-expression may be useful.": "স্পষ্ট যোগাযোগ এবং আত্ম-প্রকাশের উপর প্রতিফলন দরকারী হতে পারে।",
    "Your intuition and inner clarity appears strong in this chart.": "আপনার অন্তর্দৃষ্টি এবং অভ্যন্তরীণ স্বচ্ছতা এই চার্টে শক্তিশালী প্রদর্শিত হয়।",
    "Your intuitive clarity appears balanced in this chart.": "আপনার স্বজ্ঞাত স্বচ্ছতা এই চার্টে ভারসাম্যপূর্ণ প্রদর্শিত হবে।",
    "Reflection on focus, intuition, and inner guidance may be useful.": "ফোকাস, অন্তর্দৃষ্টি এবং অভ্যন্তরীণ নির্দেশনার প্রতিফলন কার্যকর হতে পারে।",
    "A strong Fire element supports action, courage, and leadership energy.": "একটি শক্তিশালী অগ্নি উপাদান কর্ম, সাহস এবং নেতৃত্ব শক্তি সমর্থন করে।",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "আগুন ভারসাম্যপূর্ণ দেখায়, কর্ম এবং ধৈর্যের মধ্যে একটি স্থির ছন্দ সমর্থন করে।",
    "Reflection on confidence and action-taking may be useful.": "আত্মবিশ্বাস এবং অ্যাকশন গ্রহণের প্রতিফলন কার্যকর হতে পারে।",
    "A strong Earth element supports practicality, patience, and stability.": "একটি শক্তিশালী পৃথিবীর উপাদান ব্যবহারিকতা, ধৈর্য এবং স্থায়িত্ব সমর্থন করে।",
    "Earth appears balanced, supporting practical thinking with flexibility.": "পৃথিবী ভারসাম্যপূর্ণ, নমনীয়তার সাথে ব্যবহারিক চিন্তাভাবনাকে সমর্থন করে।",
    "Reflection on grounding, consistency, and planning may be useful.": "গ্রাউন্ডিং, ধারাবাহিকতা এবং পরিকল্পনার প্রতিফলন কার্যকর হতে পারে।",
    "A strong Air element supports ideas, communication, and adaptability.": "একটি শক্তিশালী বায়ু উপাদান ধারণা, যোগাযোগ এবং অভিযোজনযোগ্যতা সমর্থন করে।",
    "Air appears balanced, supporting harmony between thinking and action.": "বায়ু ভারসাম্যপূর্ণ, চিন্তাভাবনা এবং কর্মের মধ্যে সাদৃশ্য সমর্থন করে।",
    "Reflection on communication and flexibility may be useful.": "যোগাযোগ এবং নমনীয়তার প্রতিফলন দরকারী হতে পারে।",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "একটি শক্তিশালী জল উপাদান অন্তর্দৃষ্টি, সংবেদনশীলতা, এবং মানসিক গভীরতা সমর্থন করে।",
    "Water appears balanced, supporting harmony between emotions and logic.": "জল ভারসাম্যপূর্ণ দেখায়, আবেগ এবং যুক্তির মধ্যে সাদৃশ্য সমর্থন করে।",
    "Reflection on emotional expression and inner connection may be useful.": "মানসিক অভিব্যক্তি এবং অভ্যন্তরীণ সংযোগের প্রতিফলন কার্যকর হতে পারে।",
    "A strong Ether element supports spiritual awareness and broader vision.": "একটি শক্তিশালী ইথার উপাদান আধ্যাত্মিক সচেতনতা এবং বিস্তৃত দৃষ্টি সমর্থন করে।",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ইথার ভারসাম্যপূর্ণ, আধ্যাত্মিক এবং ব্যবহারিক পদ্ধতির মধ্যে সাদৃশ্য সমর্থন করে।",
    "Reflection, silence, and spiritual discipline may be useful.": "প্রতিফলন, নীরবতা এবং আধ্যাত্মিক শৃঙ্খলা কার্যকর হতে পারে।",
    "For inner confidence, clarity, and soul strength.": "অভ্যন্তরীণ আত্মবিশ্বাস, স্বচ্ছতা এবং আত্মার শক্তির জন্য।",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "এই ইষ্ট দেবতা ইঙ্গিতটি জন্ম তালিকা থেকে গ্রহের শক্তি, লগ্ন অধিপতি, চন্দ্র রাশির অধিপতি এবং আত্মকারকের উপর ভিত্তি করে।",
    "For calmness, emotional balance, and softness.": "প্রশান্তি, মানসিক ভারসাম্য এবং স্নিগ্ধতার জন্য।",
    "For courage, protection, and discipline.": "সাহস, সুরক্ষা এবং শৃঙ্খলার জন্য।",
    "For intellect, speech, learning, and obstacle removal.": "বুদ্ধি, বক্তৃতা, শেখার এবং বাধা অপসারণের জন্য।",
    "For knowledge, guidance, dharma, and blessings.": "জ্ঞান, নির্দেশনা, ধর্ম এবং আশীর্বাদের জন্য।",
    "Mahalakshmi Ji": "মহালক্ষ্মী জি",
    "For harmony, beauty, comfort, and prosperity.": "সাদৃশ্য, সৌন্দর্য, আরাম এবং সমৃদ্ধির জন্য।",
    "For karma, patience, discipline, and protection.": "কর্ম, ধৈর্য, ​​শৃঙ্খলা এবং সুরক্ষার জন্য।",
    "For protection from confusion, fear, and illusion.": "বিভ্রান্তি, ভয় এবং বিভ্রম থেকে সুরক্ষার জন্য।",
    "Lord Ganesha": "প্রভু গণেশ",
    "For spiritual clarity, detachment, and obstacle removal.": "আধ্যাত্মিক স্বচ্ছতা, বিচ্ছিন্নতা এবং বাধা অপসারণের জন্য।",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "চক্র অন্তর্দৃষ্টি জন্য চার্ট তথ্য প্রয়োজন.",
    "Unable to load Chakra insight.": "চক্র অন্তর্দৃষ্টি লোড করতে অক্ষম.",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "এটি শুধুমাত্র জন্ম কুন্ডলীর উপর ভিত্তি করে আধ্যাত্মিক শক্তির অন্তর্দৃষ্টি এবং আত্ম-প্রতিফলন। এটা পেশাদার পরামর্শ নেই।",
    "Spiritual energy insights from Kundli": "কুন্ডলি থেকে আধ্যাত্মিক শক্তির অন্তর্দৃষ্টি",
    "Calculated from your individual birth chart": "আপনার ব্যক্তিগত জন্ম তালিকা থেকে গণনা করা হয়েছে",
    "Chakra Balance": "চক্র ব্যালেন্স",
    "Panch Tatva Balance": "পঞ্চ তত্ত্ব ভারসাম্য",
    "Ishta Devata": "ইষ্ট দেবতা",
    "Signal planet": "সংকেত গ্রহ",
    "Very Good": "খুব ভালো",
    "Very Bad": "খুব খারাপ",
    "Panch Pakshi Calculator - Kundlistar": "পঞ্চ পাকশী ক্যালকুলেটর - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "চার্ট থেকে পঞ্চ পাকশি প্রিফিল করা যায়নি। আপনি এখনও ম্যানুয়ালি গণনা করতে পারেন।",
    "Could not load sunrise and sunset from Panchang for this chart location.": "এই চার্ট অবস্থানের জন্য পঞ্চং থেকে সূর্যোদয় এবং সূর্যাস্ত লোড করা যায়নি।",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "পঞ্চং থেকে সূর্যোদয়, সূর্যাস্ত এবং পরবর্তী সূর্যোদয় লোড করতে অক্ষম।",
    "Panch Pakshi calculation failed.": "পঞ্চ পাকশী গণনা ব্যর্থ।",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "পঞ্চ পাকশী পাখি, কার্যকলাপ, ইয়ামাম, অপহারা সময়কাল, সম্পর্ক, স্কোর এবং ফলাফল গণনা করুন।",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "আপনার বিনামূল্যে প্রিমিয়াম ক্রেডিট সমাপ্ত. চালিয়ে যেতে প্রিমিয়ামে আপগ্রেড করুন।",
    "This is a premium feature. You can use 1 free premium credit to continue.": "এটি একটি প্রিমিয়াম বৈশিষ্ট্য। আপনি চালিয়ে যেতে 1টি বিনামূল্যের প্রিমিয়াম ক্রেডিট ব্যবহার করতে পারেন৷",
    "Selected Date": "নির্বাচিত তারিখ",
    "repeat(3, 1fr)": "পুনরাবৃত্তি (3, 1fr)",
    "Birth Paksha": "জন্ম পক্ষ",
    "Current Paksha": "বর্তমান পাকশা",
    "repeat(4, 1fr)": "পুনরাবৃত্তি (4, 1fr)",
    "Target Date Time": "টার্গেট তারিখ সময়",
    "Next Sunrise": "পরবর্তী সূর্যোদয়",
    "Calculate Panch Pakshi": "পঞ্চ পাকশী গণনা করুন",
    "repeat(2, 1fr)": "পুনরাবৃত্তি (2, 1fr)",
    "repeat(6, 1fr)": "পুনরাবৃত্তি (6, 1fr)",
    "Birth Pakshi": "জন্ম পাকশী",
    "Current Period": "বর্তমান সময়কাল",
    "Current Yamam": "বর্তমান ইয়ামাম",
    "Main Activity": "প্রধান কার্যকলাপ",
    "Natal Western Chart": "নেটাল ওয়েস্টার্ন চার্ট",
    "Life Phase Progression": "জীবনের পর্যায় অগ্রগতি",
    "Self-focus, identity change, body awareness and personal reset.": "স্ব-ফোকাস, পরিচয় পরিবর্তন, শরীরের সচেতনতা এবং ব্যক্তিগত রিসেট।",
    "Money, values, family, speech and security become emotionally important.": "অর্থ, মূল্যবোধ, পরিবার, বক্তৃতা এবং নিরাপত্তা আবেগগতভাবে গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Communication, learning, siblings, writing and short travel become important.": "যোগাযোগ, শেখা, ভাইবোন, লেখালেখি এবং ছোট ভ্রমণ গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Home, mother, property, family and emotional roots become important.": "বাড়ি, মা, সম্পত্তি, পরিবার এবং আবেগের শিকড় গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Creativity, romance, children, hobbies and self-expression become important.": "সৃজনশীলতা, রোম্যান্স, শিশু, শখ এবং আত্ম-প্রকাশ গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Work routine, health habits, service and discipline become important.": "কাজের রুটিন, স্বাস্থ্য অভ্যাস, সেবা এবং শৃঙ্খলা গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Relationship, marriage, partnership and public dealing become important.": "সম্পর্ক, বিয়ে, অংশীদারিত্ব এবং পাবলিক ডিলিং গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Deep emotional change, intimacy, shared money and transformation become important.": "গভীর মানসিক পরিবর্তন, অন্তরঙ্গতা, ভাগ করা অর্থ এবং রূপান্তর গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Learning, travel, teaching, belief and higher wisdom become important.": "শিক্ষা, ভ্রমণ, শিক্ষা, বিশ্বাস এবং উচ্চতর প্রজ্ঞা গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Career, status, public image and responsibility become emotionally important.": "ক্যারিয়ার, স্ট্যাটাস, পাবলিক ইমেজ এবং দায়িত্ব আবেগগতভাবে গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Income, friends, networking, community and ambitions become important.": "আয়, বন্ধু, নেটওয়ার্কিং, সম্প্রদায় এবং উচ্চাকাঙ্ক্ষা গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "বিশ্রাম, বিচ্ছিন্নতা, আধ্যাত্মিকতা, বিদেশী সংযোগ এবং অভ্যন্তরীণ নিরাময় গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Identity development and self-expression are central.": "পরিচয় বিকাশ এবং আত্ম-প্রকাশ কেন্দ্রীয় বিষয়।",
    "Values, money and self-worth become central.": "মূল্যবোধ, অর্থ এবং স্ব-মূল্য কেন্দ্রীয় হয়ে ওঠে।",
    "Communication, learning and skills become central.": "যোগাযোগ, শেখার এবং দক্ষতা কেন্দ্রীয় হয়ে ওঠে।",
    "Home, roots and emotional foundation become central.": "বাড়ি, শিকড় এবং আবেগের ভিত্তি কেন্দ্রীয় হয়ে ওঠে।",
    "Creativity, love and self-expression become central.": "সৃজনশীলতা, ভালবাসা এবং আত্ম-প্রকাশ কেন্দ্রীয় হয়ে ওঠে।",
    "Work, discipline and health routines become central.": "কাজ, শৃঙ্খলা এবং স্বাস্থ্যের রুটিনগুলি কেন্দ্রীয় হয়ে ওঠে।",
    "Partnerships and relationship identity become central.": "অংশীদারিত্ব এবং সম্পর্কের পরিচয় কেন্দ্রীয় হয়ে ওঠে।",
    "Transformation, deep healing and shared resources become central.": "রূপান্তর, গভীর নিরাময় এবং ভাগ করা সম্পদ কেন্দ্রীয় হয়ে ওঠে।",
    "Wisdom, travel, belief and higher learning become central.": "প্রজ্ঞা, ভ্রমণ, বিশ্বাস এবং উচ্চতর শিক্ষা কেন্দ্রীয় হয়ে ওঠে।",
    "Career, authority and public role become central.": "কর্মজীবন, কর্তৃত্ব এবং জনসাধারণের ভূমিকা কেন্দ্রীয় হয়ে ওঠে।",
    "Community, income, goals and networks become central.": "সম্প্রদায়, আয়, লক্ষ্য এবং নেটওয়ার্কগুলি কেন্দ্রীয় হয়ে ওঠে।",
    "Spirituality, closure, retreat and inner development become central.": "আধ্যাত্মিকতা, বন্ধ, পশ্চাদপসরণ এবং অভ্যন্তরীণ বিকাশ কেন্দ্রীয় হয়ে ওঠে।",
    "This house becomes emotionally important.": "এই ঘর আবেগগতভাবে গুরুত্বপূর্ণ হয়ে ওঠে।",
    "This house becomes central for identity development.": "এই বাড়ি পরিচয় বিকাশের জন্য কেন্দ্রীয় হয়ে ওঠে।",
    "Thinking, communication, learning and decisions are developing through this house.": "এই বাড়ির মাধ্যমে চিন্তাভাবনা, যোগাযোগ, শেখার এবং সিদ্ধান্তের বিকাশ ঘটছে।",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "ভালবাসা, আরাম, মূল্যবোধ, সৌন্দর্য এবং অর্থের পছন্দগুলি এই বাড়ির মাধ্যমে বিকাশ করছে।",
    "Action style, courage, ambition and drive are developing through this house.": "অ্যাকশন স্টাইল, সাহস, উচ্চাকাঙ্ক্ষা এবং ড্রাইভ এই বাড়ির মাধ্যমে বিকাশ করছে।",
    "Growth, faith, learning and expansion themes develop through this house.": "বৃদ্ধি, বিশ্বাস, শিক্ষা এবং সম্প্রসারণ থিম এই বাড়ির মাধ্যমে বিকাশ.",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "পরিপক্কতা, দায়িত্ব, শৃঙ্খলা এবং দীর্ঘমেয়াদী কাঠামো গড়ে ওঠে এই বাড়ির মাধ্যমে।",
    "This progressed planet shows an inner life phase through this house.": "এই প্রগতিশীল গ্রহটি এই বাড়ির মাধ্যমে একটি অভ্যন্তরীণ জীবনের পর্যায় দেখায়।",
    "New Moon Phase": "নতুন চাঁদের পর্ব",
    "New beginning, identity reset and fresh internal cycle.": "নতুন শুরু, পরিচয় রিসেট এবং তাজা অভ্যন্তরীণ চক্র।",
    "Crescent Phase": "ক্রিসেন্ট ফেজ",
    "Growth, effort, learning and building confidence.": "বৃদ্ধি, প্রচেষ্টা, শেখার এবং আত্মবিশ্বাস তৈরি করা।",
    "First Quarter Phase": "প্রথম কোয়ার্টার ফেজ",
    "Action, decision-making, pressure and development.": "কর্ম, সিদ্ধান্ত গ্রহণ, চাপ এবং উন্নয়ন।",
    "Gibbous Phase": "গিব্বাস ফেজ",
    "Refinement, improvement, preparation and skill-building.": "পরিমার্জন, উন্নতি, প্রস্তুতি এবং দক্ষতা-নির্মাণ।",
    "Full Moon Phase": "পূর্ণিমার পর্যায়",
    "Visibility, relationship awareness, emotional clarity and results.": "দৃশ্যমানতা, সম্পর্কের সচেতনতা, মানসিক স্বচ্ছতা এবং ফলাফল।",
    "Disseminating Phase": "ছড়িয়ে পড়া ফেজ",
    "Sharing, teaching, communication and distributing experience.": "ভাগাভাগি, শিক্ষাদান, যোগাযোগ এবং অভিজ্ঞতা বিতরণ।",
    "Last Quarter Phase": "শেষ কোয়ার্টার ফেজ",
    "Reorientation, correction, release and mature decision-making.": "পুনর্বিন্যাস, সংশোধন, মুক্তি এবং পরিণত সিদ্ধান্ত গ্রহণ।",
    "Balsamic Phase": "বালসামিক ফেজ",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "বন্ধ, আধ্যাত্মিক প্রতিফলন, বিশ্রাম এবং একটি নতুন চক্রের জন্য প্রস্তুতি।",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "একটি প্রধান মানসিক এবং পরিচয় পর্ব শুরু হয়। ব্যক্তি একটি নতুন অধ্যায়ের জন্য প্রস্তুত বোধ করতে পারে.",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "মানসিক রিসেট সময়কাল। পরিবার, সান্ত্বনা, অভ্যন্তরীণ শান্তি এবং মানসিক চাহিদা গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "প্রেম, সম্পর্ক, আরাম, সৌন্দর্য এবং মানসিক বন্ধন গুরুত্বপূর্ণ হয়ে ওঠে।",
    "Emotional needs and relationship expectations may need adjustment.": "মানসিক চাহিদা এবং সম্পর্কের প্রত্যাশা সামঞ্জস্যের প্রয়োজন হতে পারে।",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "শক্তি, আবেগ, অধৈর্যতা এবং কর্ম বৃদ্ধি। মানসিক প্রতিক্রিয়া দ্রুত হয়ে উঠতে পারে।",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "মানসিক অস্থিরতা, রাগ, দ্বন্দ্ব বা জরুরী কাজ বাড়তে পারে।",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "একটি গুরুতর মানসিক পর্যায়। দায়িত্ব, পরিপক্কতা, পারিবারিক চাপ বা অভ্যন্তরীণ শৃঙ্খলা বাড়তে পারে।",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "মানসিক ভারীতা বা দায়িত্ব অনুভূত হতে পারে। ধৈর্য এবং পরিপক্কতা প্রয়োজন.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "সহায়ক মানসিক বৃদ্ধি, আশাবাদ, ভ্রমণ, শিক্ষা এবং আশীর্বাদ বৃদ্ধি পেতে পারে।",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "একটি বৃদ্ধি-ভিত্তিক মানসিক পর্যায়। শেখার জন্য ভাল, সম্প্রসারণ, সমর্থন এবং ইতিবাচক সিদ্ধান্ত.",
    "Identity, love, beauty, money values and creative expression become highlighted.": "পরিচয়, প্রেম, সৌন্দর্য, অর্থমূল্য এবং সৃজনশীল অভিব্যক্তি তুলে ধরা হয়।",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "আত্মবিশ্বাস, সাহস, উচ্চাকাঙ্ক্ষা ও কর্ম বৃদ্ধি পায়। একটি নতুন সক্রিয় পর্ব শুরু করার জন্য ভাল।",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "একটি পরিপক্কতা পরীক্ষা। দায়িত্ব, বিলম্ব, চাপ বা ক্যারিয়ার পুনর্গঠন ঘটতে পারে।",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "বৃদ্ধি, আত্মবিশ্বাস, প্রজ্ঞা, স্বীকৃতি এবং সুযোগ বাড়তে পারে।",
    "Mental clarity, communication, study, writing and business decisions become important.": "মানসিক স্বচ্ছতা, যোগাযোগ, অধ্যয়ন, লেখালেখি এবং ব্যবসায়িক সিদ্ধান্ত গুরুত্বপূর্ণ হয়ে ওঠে।",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "একটি নতুন মানসিক চক্র শুরু হয়। শেখার, যোগাযোগ, লেখা এবং দক্ষতা বিকাশের জন্য ভাল।",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "প্রেম, সৌন্দর্য, স্বাচ্ছন্দ্য, সামাজিক জীবন এবং মূল্যবোধগুলি পরিচয়ের সাথে দৃঢ়ভাবে যুক্ত হয়।",
    "Action, confidence, ambition and personal drive become stronger.": "কর্ম, আত্মবিশ্বাস, উচ্চাকাঙ্ক্ষা এবং ব্যক্তিগত ড্রাইভ শক্তিশালী হয়ে ওঠে।",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "প্রগতিশীল বুধ শিক্ষা, যোগাযোগ, ব্যবসা, লেখা, বিপণন, কোডিং বা বিশ্লেষণমূলক কাজ সমর্থন করে।",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "প্রগতিশীল মঙ্গল কর্ম, সাহস, প্রতিযোগিতা, প্রযুক্তিগত কাজ এবং সক্রিয় কর্মজীবনের সিদ্ধান্তগুলিকে সমর্থন করে।",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "অগ্রগতি শুক্র আর্থিক মূল্যবোধ, স্বাচ্ছন্দ্য, লাভ, বিলাসিতা, শিল্প বা সম্পর্ক-ভিত্তিক আয় থিম সমর্থন করে।",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "প্রগতিশীল বৃহস্পতি বৃদ্ধি-ভিত্তিক আর্থিক চিন্তাভাবনা এবং সম্পদের সম্প্রসারণ দেখাতে পারে।",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "কর্মজীবনের পর্যায় প্রগতিশীল সূর্য, চন্দ্র, বুধ, মঙ্গল এবং জন্মগত সূর্য, শনি এবং মধ্য আকাশের দিক থেকে বিচার করা উচিত।",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "প্রগতিশীল চাঁদ, শুক্র, মঙ্গল এবং জন্মগত চাঁদ, শুক্র, মঙ্গল এবং সপ্তম ঘরের দিক থেকে প্রেমের পর্ব বিচার করা উচিত।",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "প্রগতিশীল চাঁদ, শুক্র, বৃহস্পতি এবং জন্মের দ্বিতীয়, অষ্টম এবং 11 তম বাড়ির সংযোগ থেকে অর্থ পর্ব বিচার করা উচিত।",
    "Western Astrology - Kundlistar": "পাশ্চাত্য জ্যোতিষ - Kundlistar",
    "No chart data available for preview": "পূর্বরূপের জন্য কোনো চার্ট ডেটা উপলব্ধ নয়",
    "Failed to load chart": "চার্ট লোড করতে ব্যর্থ হয়েছে৷",
    "Chart not found": "চার্ট পাওয়া যায়নি",
    "Western Astrology Module | Kundlistar": "পশ্চিমী জ্যোতিষ মডিউল | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "Kundlistar-এর ভিতরে পশ্চিমী জ্যোতিষশাস্ত্র অন্বেষণ করুন নেটাল চার্ট পজিশন, প্লাসিডাস হাউস কুপস, বাইরের গ্রহ এবং প্রিমিয়াম ট্রানজিট, সৌর প্রত্যাবর্তন এবং সিনাস্ট্রি বৈশিষ্ট্য সহ।",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "পাশ্চাত্য জ্যোতিষ, নেটাল চার্ট, ট্রানজিট, সৌর রিটার্ন, সিনাস্ট্রি, Kundlistar",
    "New section": "নতুন বিভাগ",
    "Premium active": "প্রিমিয়াম সক্রিয়",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "হাউস সিস্টেম",
    "Placidus cusps": "Placidus cusps",
    "Part of Fortune": "ভাগ্যের অংশ",
    "Natal Western Aspects": "ন্যাটাল পশ্চিম দিক",
    "No major Western aspects found within the configured orbs.": "কনফিগার করা orbs মধ্যে কোন প্রধান পশ্চিম দিক পাওয়া যায় না.",
    "Western natal astrology wheel": "পশ্চিমা জন্মগত জ্যোতিষ চাকা",
    "Western Transits": "ওয়েস্টার্ন ট্রানজিট",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "লোড করা চার্ট জন্মস্থান ব্যবহার করে বর্তমান ট্রানজিট-টু-নেটাল গণনা।",
    "Natal points available": "নেটাল পয়েন্ট উপলব্ধ",
    "Transit planets loaded": "ট্রানজিট গ্রহ লোড",
    "Loading current transit positions...": "বর্তমান ট্রানজিট অবস্থান লোড হচ্ছে...",
    "Aspect method": "দৃষ্টিভঙ্গি পদ্ধতি",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "সংযোগ, সেক্সটাইল, বর্গক্ষেত্র, ট্রাইন এবং পশ্চিমী orbs সঙ্গে বিরোধিতা",
    "Primary focus": "প্রাথমিক ফোকাস",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "জন্মগত সূর্য, চাঁদ, আরোহণ, শুক্র, মঙ্গল, বৃহস্পতি, শনি এবং বাইরের গ্রহের যোগাযোগ",
    "Natal inner wheel": "নেটাল ইনার হুইল",
    "Transit outer wheel": "ট্রানজিট বাইরের চাকা",
    "Current Transit Positions": "বর্তমান ট্রানজিট অবস্থান",
    "Transit positions are not available.": "ট্রানজিট অবস্থান উপলব্ধ নেই.",
    "Current Transit Aspects to Natal Chart": "নেটাল চার্টের বর্তমান ট্রানজিট দিক",
    "Loading transit aspects...": "ট্রানজিট দিক লোড হচ্ছে...",
    "No major transit aspects found within the configured orbs.": "কনফিগার করা orbs মধ্যে কোন প্রধান ট্রানজিট দিক পাওয়া যায় না.",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "নেটাল সান থেকে বার্ষিক ওয়েস্টার্ন রিটার্ন রেফারেন্স, সহ প্রসবগত দিক প্রসঙ্গ।",
    "Solar return date": "সৌর ফেরত তারিখ",
    "Calculation time": "গণনার সময়",
    "Birth date not available": "জন্ম তারিখ উপলব্ধ নেই",
    "Natal Sun": "নাটাল সান",
    "Natal Sun house": "নাটাল সূর্য ঘর",
    "Return planets loaded": "গ্রহ লোড ফেরত",
    "Loading solar return chart...": "সৌর রিটার্ন চার্ট লোড হচ্ছে...",
    "Annual focus": "বার্ষিক ফোকাস",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "সৌর থিমগুলি জন্মগত সূর্য, রিটার্ন অ্যাসেন্ড্যান্ট এবং বার্ষিক রিটার্ন চার্ট থেকে পড়া হয়।",
    "Solar Return Planet Positions": "সৌর প্রত্যাবর্তন গ্রহের অবস্থান",
    "Loading solar return planets...": "সৌর রিটার্ন গ্রহ লোড হচ্ছে...",
    "Solar return positions are not available.": "সোলার রিটার্ন পজিশন পাওয়া যায় না।",
    "Solar Return House Cusps": "সৌর রিটার্ন হাউস Cusps",
    "Loading solar return cusps...": "সৌর রিটার্ন কাপ লোড হচ্ছে...",
    "Solar return house cusps are not available.": "সৌর রিটার্ন হাউস cusps পাওয়া যায় না.",
    "Solar Return Aspects to Natal Chart": "নেটাল চার্টে সৌর প্রত্যাবর্তনের দিক",
    "Loading solar return aspects...": "সৌর রিটার্ন দিক লোড হচ্ছে...",
    "No major solar return aspects found within the configured orbs.": "কনফিগার করা orbs মধ্যে কোন প্রধান সৌর রিটার্ন দিক পাওয়া যায় না.",
    "Natal Sun Aspects for Solar Return Focus": "সৌর প্রত্যাবর্তন ফোকাসের জন্য ন্যাটাল সূর্যের দিক",
    "No major natal Sun aspects found within the configured orbs.": "কনফিগার করা orbs মধ্যে কোন প্রধান জন্মগত সূর্যের দিক পাওয়া যায় নি।",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "গ্রহ-থেকে-গ্রহের দিক, কোণ পরিচিতি এবং ঘরের ওভারলে ব্যবহার করে সম্পর্ক ওভারলে কাঠামো।",
    "Loaded first chart": "প্রথম চার্ট লোড করা হয়েছে",
    "Second chart": "দ্বিতীয় চার্ট",
    "Select or load partner chart to calculate full synastry overlay": "সম্পূর্ণ সিনাস্ট্রি ওভারলে গণনা করতে অংশীদার চার্ট নির্বাচন করুন বা লোড করুন",
    "Major inter-chart aspects with tight orb priority": "টাইট orb অগ্রাধিকার সহ প্রধান আন্তঃ-চার্ট দিক",
    "House overlay method": "হাউস ওভারলে পদ্ধতি",
    "Partner planets are placed into the first chart houses after second chart is selected": "দ্বিতীয় চার্ট নির্বাচন করার পরে অংশীদার গ্রহগুলিকে প্রথম চার্ট হাউসে রাখা হয়",
    "Relationship Pattern Aspects from Loaded Chart": "লোড করা চার্ট থেকে সম্পর্ক প্যাটার্ন দিক",
    "No major relationship-focused natal aspects found within the configured orbs.": "কনফিগার করা orbs মধ্যে কোন বড় সম্পর্ক-কেন্দ্রিক জন্মগত দিক পাওয়া যায় নি।",
    "Understand your current inner life phase through Western Secondary Progressions.": "পশ্চিমা মাধ্যমিক অগ্রগতির মাধ্যমে আপনার বর্তমান অভ্যন্তরীণ জীবনের পর্বটি বুঝুন।",
    "Secondary Progression": "মাধ্যমিক অগ্রগতি",
    "1 day after birth = 1 year of life": "জন্মের 1 দিন = জীবনের 1 বছর",
    "Current age used": "বর্তমান বয়স ব্যবহৃত",
    "Progressed date": "অগ্রগতি তারিখ",
    "Progressed Moon": "প্রগতিশীল চাঁদ",
    "Loading progressed Moon...": "প্রগতিশীল চাঁদ লোড হচ্ছে...",
    "Progressed Moon phase": "অগ্রসরিত চাঁদ পর্ব",
    "Loading Moon phase...": "চাঁদের পর্ব লোড হচ্ছে...",
    "Current Life Phase": "বর্তমান জীবনের পর্যায়",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "মাধ্যমিক অগ্রগতিগুলি জীবনের অভ্যন্তরীণ পর্যায়, মানসিক পরিপক্কতা, পরিচয় বিকাশ এবং অগ্রাধিকারের পরিবর্তন দেখায়।",
    "Progressed Career Phase": "প্রগতিশীল কর্মজীবন পর্যায়",
    "Progressed Love Phase": "প্রগতি লাভ ফেজ",
    "Progressed Money Phase": "প্রগতিশীল অর্থ ফেজ",
    "Loading progressed planets...": "অগ্রসর গ্রহ লোড হচ্ছে...",
    "Progressed planets are not available.": "প্রগতিশীল গ্রহগুলি পাওয়া যায় না।",
    "Loading progressed aspects...": "অগ্রগতি দিকগুলি লোড হচ্ছে...",
    "No tight progressed-to-natal aspects found right now.": "এই মুহূর্তে কোন শক্ত অগ্রগতি থেকে জন্মগত দিক পাওয়া যায়নি।",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "এই পর্যায়টি প্রগতিশীল গ্রহ, অগ্রসরিত চাঁদের পর্যায় এবং শক্ত অগ্রগতি থেকে জন্মগত দিক থেকে বিচার করা উচিত।",
    "Vastu Analysis - Kundlistar": "বাস্তু বিশ্লেষণ - Kundlistar",
    "Failed to load selected chart.": "নির্বাচিত চার্ট লোড করতে ব্যর্থ হয়েছে৷",
    "Facing Direction": "অভিমুখী দিক",
    "Entrance Direction": "প্রবেশ পথ",
    "Kitchen Direction": "রান্নাঘরের দিকনির্দেশ",
    "Master Bedroom": "মাস্টার বেডরুম",
    "Children Bedroom": "শিশুদের বেডরুম",
    "Toilet Direction": "টয়লেটের দিকনির্দেশ",
    "Pooja Direction": "পূজার দিকনির্দেশনা",
    "Water Tank": "জলের ট্যাঙ্ক",
    "Underground Water": "ভূগর্ভস্থ জল",
    "Heavy Storage": "ভারী স্টোরেজ",
    "Living Room": "বসার ঘর",
    "Study Room": "স্টাডি রুম",
    "Vastu report generation failed.": "বাস্তু রিপোর্ট তৈরি ব্যর্থ হয়েছে।",
    "Please generate the Vastu report before downloading.": "ডাউনলোড করার আগে অনুগ্রহ করে বাস্তু রিপোর্ট তৈরি করুন।",
    "Failed to download Vastu report.": "বাস্তু রিপোর্ট ডাউনলোড করতে ব্যর্থ হয়েছে.",
    "Premium Feature": "প্রিমিয়াম বৈশিষ্ট্য",
    "Selected Chart": "নির্বাচিত চার্ট",
    "Basic + KP + BNN from chart": "চার্ট থেকে বেসিক + কেপি + বিএনএন",
    "Basic shown, KP + BNN locked": "বেসিক দেখানো হয়েছে, KP + BNN লক করা আছে",
    "Property Type": "সম্পত্তির ধরন",
    "Center Area": "কেন্দ্র এলাকা",
    "Generate Vastu Report": "বাস্তু রিপোর্ট তৈরি করুন",
    "Basic Vastu Analysis": "বেসিক বাস্তু বিশ্লেষণ",
    "KP Vastu Analysis": "কেপি বাস্তু বিশ্লেষণ",
    "BNN Vastu Analysis": "বিএনএন বাস্তু বিশ্লেষণ",
    "North East": "উত্তর পূর্ব",
    "South East": "দক্ষিণ পূর্ব",
    "South West": "দক্ষিণ পশ্চিম",
    "North West": "উত্তর পশ্চিম",
    "Red Coral": "লাল প্রবাল",
    "Yellow Sapphire": "হলুদ নীলকান্তমণি",
    "Blue Sapphire": "ব্লু স্যাফায়ার",
    "Cat's Eye": "ক্যাটস আই",
    "Additional Option": "অতিরিক্ত বিকল্প",
    "Lagna rule supports this gemstone option.": "Lagna নিয়ম এই রত্নপাথর বিকল্প সমর্থন করে.",
    "Moon sign rule supports this gemstone option.": "চাঁদ সাইন নিয়ম এই রত্নপাথর বিকল্প সমর্থন করে.",
    "Birth date rule supports this gemstone option.": "জন্ম তারিখ নিয়ম এই রত্ন পাথর বিকল্প সমর্থন করে.",
    "Birth weekday rule supports this gemstone option.": "জন্ম সপ্তাহের দিন নিয়ম এই রত্নপাথর বিকল্প সমর্থন করে.",
    "Current dasha rule supports this gemstone option.": "বর্তমান dasha নিয়ম এই রত্নপাথর বিকল্প সমর্থন করে.",
    "Age-band rule supports this gemstone option.": "বয়স-ব্যান্ড নিয়ম এই রত্নপাথর বিকল্প সমর্থন করে।",
    "Selected goal supports this gemstone option.": "নির্বাচিত লক্ষ্য এই রত্নপাথর বিকল্প সমর্থন করে.",
    "Profession rule supports this gemstone option.": "পেশার নিয়ম এই রত্নপাথরের বিকল্পকে সমর্থন করে।",
    "Name-initial rule supports this gemstone option.": "নাম-প্রাথমিক নিয়ম এই রত্নপাথরের বিকল্পকে সমর্থন করে।",
    "Moolank rule supports this gemstone option.": "মূলাঙ্ক নিয়ম এই রত্নপাথরের বিকল্পকে সমর্থন করে।",
    "Chart condition check was considered for this option.": "চার্ট শর্ত চেক এই বিকল্পের জন্য বিবেচনা করা হয়েছিল.",
    "Rule-based chart match supports this gemstone option.": "নিয়ম-ভিত্তিক চার্ট ম্যাচ এই রত্নপাথর বিকল্পকে সমর্থন করে।",
    "Expert kundli review is recommended before wearing this gemstone.": "এই রত্ন পাথর পরার আগে বিশেষজ্ঞ কুন্ডলি পর্যালোচনা করার পরামর্শ দেওয়া হয়।",
    "Ring finger": "অনামিকা",
    "Little finger": "কনিষ্ঠ আঙুল",
    "Index finger": "তর্জনী",
    "Middle finger": "মধ্যমা আঙুল",
    "Why recommended": "কেন সুপারিশ করা হয়",
    "Approx weight": "আনুমানিক ওজন",
    "Could not load chart.": "চার্ট লোড করা যায়নি।",
    "Gemstone Recommendations | Kundlistar": "রত্ন পাথরের সুপারিশ | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar এর নিয়ম-ভিত্তিক কুন্ডলি বিশ্লেষণ ইঞ্জিন থেকে বৈদিক রত্ন পাথরের সুপারিশগুলি অন্বেষণ করুন৷",
    "noindex,nofollow": "noindex, nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "রত্ন পাথরের সুপারিশ, বৈদিক রত্নপাথর, কুন্ডলি রত্নপাথর, Kundlistar",
    "Gemstone Recommendations": "রত্ন পাথর সুপারিশ",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "লগ্ন, চন্দ্র রাশি, দশা, DOB, পেশা এবং লক্ষ্যের উপর ভিত্তি করে বৈদিক রত্ন পাথর নির্দেশনার জন্য পৃথক Kundlistar মডিউল।",
    "Personalized Gemstone Recommendations are available for Premium users.": "ব্যক্তিগতকৃত রত্ন পাথর প্রস্তাবনা প্রিমিয়াম ব্যবহারকারীদের জন্য উপলব্ধ।",
    "Upgrade to Premium": "প্রিমিয়ামে আপগ্রেড করুন",
    "Login to Upgrade": "আপগ্রেড করতে লগইন করুন",
    "Select Goal": "লক্ষ্য নির্বাচন করুন",
    "Business, government job, teacher...": "ব্যবসা, সরকারি চাকরি, শিক্ষক...",
    "Weight kg": "ওজন কেজি",
    "वजन kg": "২ কেজি",
    "Optional ratti estimate": "ঐচ্ছিক রাট্টি অনুমান",
    "Click Calculate to apply these values.": "এই মানগুলি প্রয়োগ করতে গণনা ক্লিক করুন।",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi?",
    "Nadi Analysis": "নাড়ি বিশ্লেষণ",
    "KP Analysis": "কেপি বিশ্লেষণ",
    "Vedic Analysis": "বৈদিক বিশ্লেষণ",
    "BNN Analysis": "বিএনএন বিশ্লেষণ",
    "Jaimini Analysis": "জৈমিনি বিশ্লেষণ",
    "Western Astrology": "পাশ্চাত্য জ্যোতিষশাস্ত্র",
    "Panch Pakshi": "পঞ্চ পাকশী",
    "Tithi Pravesh": "তিথি প্রবেশ",
    "Lal Kitab": "লাল কিতাব",
    "Astro Logo": "অ্যাস্ট্রো লোগো",
    "Download failed": "ডাউনলোড ব্যর্থ হয়েছে৷",
    "Could not download PDF report.": "PDF রিপোর্ট ডাউনলোড করা যায়নি।",
    "Please login to download PDF reports.": "পিডিএফ রিপোর্ট ডাউনলোড করতে লগইন করুন.",
    "Failed to generate personalised report": "ব্যক্তিগতকৃত প্রতিবেদন তৈরি করতে ব্যর্থ হয়েছে৷",
    "Could not download personalised report.": "ব্যক্তিগতকৃত প্রতিবেদন ডাউনলোড করা যায়নি।",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--কুন্ডলিস্টার-নভবার-উচ্চতা, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(--কুন্ডলিস্টার-নভবার-উচ্চতা, 160px))",
    "width 0.2s ease": "প্রস্থ 0.2s সহজ",
    "Collapse sidebar": "সাইডবার সঙ্কুচিত করুন",
    "Expand sidebar": "সাইডবার প্রসারিত করুন",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-রুট",
    "Download PDF Report": "পিডিএফ রিপোর্ট ডাউনলোড করুন",
    "Login to download": "ডাউনলোড করতে লগইন করুন",
    "PDF Report": "পিডিএফ রিপোর্ট",
    "Download Personal Report": "ব্যক্তিগত প্রতিবেদন ডাউনলোড করুন",
    "Buy Premium to download": "ডাউনলোড করতে প্রিমিয়াম কিনুন",
    "Login to buy Premium": "প্রিমিয়াম কিনতে লগইন করুন",
    "Buy Premium": "প্রিমিয়াম কিনুন",
    "& .MuiTab-root": "& .MuiTab-মূল",
    "& .Mui-selected": "& .Mui-নির্বাচিত",
    "Unable to load Client Management data.": "ক্লায়েন্ট ম্যানেজমেন্ট ডেটা লোড করতে অক্ষম৷",
    "Unable to download PDF.": "PDF ডাউনলোড করতে অক্ষম।",
    "Free client limit reached": "বিনামূল্যে ক্লায়েন্ট সীমা পৌঁছেছে",
    "Welcome": "স্বাগতম",
    "Hello": "হ্যালো",
    "Your saved charts are shown below.": "আপনার সংরক্ষিত চার্ট নীচে দেখানো হয়েছে.",
    "All Features": "সমস্ত বৈশিষ্ট্য",
    "New Chart": "নতুন চার্ট",
    "Vedic Chart": "বৈদিক চার্ট",
    "Chakra": "চক্র",
    "Daily Panchang": "দৈনিক পঞ্চং",
    "Choghadiya": "চোগাদিয়া",
    "Daily Horoscope": "দৈনিক রাশিফল",
    "Gochar Alerts": "গোচর সতর্কতা",
    "Matching": "ম্যাচিং",
    "Ruling Planets": "শাসক গ্রহ",
    "Horary Chart": "হোরারি চার্ট",
    "Astro-Vastu": "অ্যাস্ট্রো-বাস্তু",
    "Vedic Numerology": "বৈদিক সংখ্যাতত্ত্ব",
    "My Charts": "আমার চার্ট",
    "Search by Name": "নাম দ্বারা অনুসন্ধান করুন",
    "Type": "টাইপ",
    "All": "সব",
    "Individual": "ব্যক্তি",
    "Horary": "হোরারি",
    "Clear": "পরিষ্কার",
    "Name": "নাম",
    "DOB": "ডিওবি",
    "Place": "স্থান",
    "Gender": "লিঙ্গ",
    "Created": "তৈরি হয়েছে",
    "Actions": "কর্ম",
    "Male": "পুরুষ",
    "Female": "মহিলা",
    "No matching charts found": "কোন মিল চার্ট পাওয়া যায়নি",
    "Create First Chart": "প্রথম চার্ট তৈরি করুন",
    "View Chart": "চার্ট দেখুন",
    "Copy Share Link": "শেয়ার লিংক কপি করুন",
    "Use premium credit: Download PDF Report": "প্রিমিয়াম ক্রেডিট ব্যবহার করুন: PDF রিপোর্ট ডাউনলোড করুন",
    "Download Personalised Report": "ব্যক্তিগতকৃত প্রতিবেদন ডাউনলোড করুন",
    "Premium: Download Personalised Report": "প্রিমিয়াম: ব্যক্তিগতকৃত প্রতিবেদন ডাউনলোড করুন",
    "Hide Chart": "চার্ট লুকান",
    "Personalised": "ব্যক্তিগতকৃত",
    "Generating your Personalised Report": "আপনার ব্যক্তিগতকৃত প্রতিবেদন তৈরি করা হচ্ছে",
    "Please do not leave this page till the report is generated. This can take a little while.": "প্রতিবেদন তৈরি না হওয়া পর্যন্ত দয়া করে এই পৃষ্ঠাটি ছেড়ে যাবেন না। এটি একটু সময় নিতে পারে.",
    "Please don't leave this page till the report is generated. This can take a little while.": "প্রতিবেদন তৈরি না হওয়া পর্যন্ত দয়া করে এই পৃষ্ঠাটি ছেড়ে যাবেন না। এটি একটু সময় নিতে পারে.",
    "Update": "আপডেট",
    "Complete your billing address. Required for generating invoice.": "আপনার বিলিং ঠিকানা সম্পূর্ণ করুন. চালান তৈরির জন্য প্রয়োজন।",
    "Report this report": "এই প্রতিবেদনটি জানান",
    "Reason": "কারণ",
    "Optional comment": "ঐচ্ছিক মন্তব্য",
    "Submit": "জমা দিন",
    "Incorrect info": "ভুল তথ্য",
    "Offensive": "আক্রমণাত্মক",
    "Harmful": "ক্ষতিকর",
    "This report has been sent for review.": "এই প্রতিবেদন পর্যালোচনার জন্য পাঠানো হয়েছে।",
    "Failed to submit report feedback": "রিপোর্ট প্রতিক্রিয়া জমা দিতে ব্যর্থ",
    "Failed to download PDF": "PDF ডাউনলোড করতে ব্যর্থ হয়েছে",
    "Failed to download personalised report": "ব্যক্তিগতকৃত প্রতিবেদন ডাউনলোড করতে ব্যর্থ হয়েছে৷",
    "Failed to load charts": "চার্ট লোড করতে ব্যর্থ হয়েছে৷",
    "Failed to hide chart": "চার্ট লুকাতে ব্যর্থ হয়েছে৷",
    "Failed to delete chart": "চার্ট মুছে ফেলতে ব্যর্থ হয়েছে",
    "Share link copied to clipboard!": "শেয়ার লিঙ্ক ক্লিপবোর্ডে অনুলিপি করা হয়েছে!",
    "Delete Chart": "চার্ট মুছুন",
    "Delete chart": "চার্ট মুছুন",
    "Error": "ত্রুটি",
    "OK": "ঠিক আছে",
    "Thanks": "ধন্যবাদ",
    "Report failed": "রিপোর্ট ব্যর্থ হয়েছে",
    "Could not submit report feedback.": "রিপোর্ট প্রতিক্রিয়া জমা দিতে পারেনি.",
    "Personalised report ready": "ব্যক্তিগতকৃত প্রতিবেদন প্রস্তুত",
    "Personalised report failed": "ব্যক্তিগতকৃত রিপোর্ট ব্যর্থ হয়েছে",
    "Could not generate personalised report.": "ব্যক্তিগতকৃত প্রতিবেদন তৈরি করা যায়নি।",
    "Could not generate personalised PDF report.": "ব্যক্তিগতকৃত PDF প্রতিবেদন তৈরি করা যায়নি।",
    "Monthly limit reached": "মাসিক সীমা পৌঁছেছে",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "আপনার মাসিক ব্যক্তিগতকৃত প্রতিবেদনের সীমা পৌঁছে গেছে। একটি অ্যাড-অনে সদস্যতা নিন: 20টি প্রতিবেদনের জন্য ₹299/মাস বা 40টি প্রতিবেদনের জন্য ₹499/মাস।",
    "Buy Add-on": "অ্যাড-অন কিনুন",
    "Manage": "পরিচালনা করুন",
    "Add-on active: Unlimited reports": "অ্যাড-অন সক্রিয়: সীমাহীন রিপোর্ট",
    "Add-on active: 40 reports/month": "অ্যাড-অন সক্রিয়: 40 রিপোর্ট/মাস",
    "Add-on active: 20 reports/month": "অ্যাড-অন সক্রিয়: 20 রিপোর্ট/মাস",
    "reports remaining this cycle": "এই চক্র অবশিষ্ট রিপোর্ট",
    "Add-on active": "অ্যাড-অন সক্রিয়",
    "Personalised reports remaining this month": "এই মাসে বাকি ব্যক্তিগতকৃত রিপোর্ট",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "প্রিমিয়াম 2/মাস অন্তর্ভুক্ত। অ্যাড-অন: 20টি রিপোর্ট/মাসের জন্য ₹299/মাস বা 40টি রিপোর্ট/মাসের জন্য ₹499/মাস।",
    "AI Disclaimer": "এআই দাবিত্যাগ",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "এই প্রতিবেদনটি AI এবং জ্যোতিষশাস্ত্রীয় ব্যাখ্যা ব্যবহার করে তৈরি করা হয়েছে। এটি শুধুমাত্র তথ্য এবং বিনোদনের উদ্দেশ্যে। এটিকে চিকিৎসা, আইনি বা আর্থিক পরামর্শ হিসেবে বিবেচনা করা উচিত নয়।",
    "A copy of this report has also been sent to your registered email address as a PDF.": "এই প্রতিবেদনের একটি অনুলিপি পিডিএফ হিসাবে আপনার নিবন্ধিত ইমেল ঠিকানাতেও পাঠানো হয়েছে।",
    "Report this AI-generated report?": "এই AI-উত্পন্ন রিপোর্ট রিপোর্ট?",
    "charts": "চার্ট",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "স্বাধীন নোট, তারিখ এবং সময় পরিকল্পনা। সংরক্ষণের জন্য লগইন প্রয়োজন; বিনামূল্যে ব্যবহারকারীরা সম্পূর্ণ পরিকল্পনাকারী অ্যাক্সেস পান।",
    "Independent notes, date and time planning.": "স্বাধীন নোট, তারিখ এবং সময় পরিকল্পনা।",
    "Add Plan": "পরিকল্পনা যোগ করুন",
    "Save Plan": "পরিকল্পনা সংরক্ষণ করুন",
    "Saved Plans": "সংরক্ষিত পরিকল্পনা",
    "Planner Entry": "পরিকল্পনাকারী এন্ট্রি",
    "Plan": "পরিকল্পনা",
    "Saving...": "সংরক্ষণ করা হচ্ছে...",
    "Refresh": "রিফ্রেশ",
    "No plans saved yet.": "এখনও কোনো পরিকল্পনা সংরক্ষিত.",
    "Planner layout is available. Login only when you want to save.": "প্ল্যানার লেআউট উপলব্ধ। আপনি যখন সংরক্ষণ করতে চান শুধুমাত্র লগইন করুন.",
    "No matching plans.": "কোন মিল পরিকল্পনা.",
    "Search Plans": "অনুসন্ধান পরিকল্পনা",
    "Search title, note, date or status": "শিরোনাম, নোট, তারিখ বা স্থিতি অনুসন্ধান করুন",
    "Login is required only when you want to save planner entries.": "আপনি যখন পরিকল্পনাকারী এন্ট্রি সংরক্ষণ করতে চান শুধুমাত্র তখনই লগইন প্রয়োজন৷",
    "Planner entry saved.": "পরিকল্পনাকারী এন্ট্রি সংরক্ষিত.",
    "Unable to load planner.": "প্ল্যানার লোড করতে অক্ষম৷",
    "Unable to save planner entry.": "পরিকল্পনাকারী এন্ট্রি সংরক্ষণ করতে অক্ষম.",
    "Could not load planner.": "প্ল্যানার লোড করা যায়নি।",
    "Could not save planner entry.": "পরিকল্পনাকারী এন্ট্রি সংরক্ষণ করা যায়নি.",
    "Login required to save": "সংরক্ষণ করতে লগইন প্রয়োজন",
    "You can explore Planner now. Login when you want to save entries.": "আপনি এখন পরিকল্পনাকারী অন্বেষণ করতে পারেন. আপনি যখন এন্ট্রি সংরক্ষণ করতে চান তখন লগইন করুন।",
    "Prev": "পূর্ববর্তী",
    "Next": "পরবর্তী",
    "Page": "পাতা",
    "of": "এর",
    "Child Birth Mahoorat": "সন্তান প্রসবের মহরত",
    "Child Birth Mahoorat | Kundlistar Premium": "সন্তান জন্মের মহরত | কুন্ডলিস্টার প্রিমিয়াম",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "পঞ্চং, চোঘাদিয়া এবং হোরা ভিত্তিক নির্দেশিকা সহ প্রিমিয়াম শিশু জন্মের মহুরত উইন্ডো।",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "পরিকল্পিত সন্তান-জন্মের সময় নির্দেশনার জন্য শুভ উপলব্ধ উইন্ডোগুলি অন্বেষণ করতে একটি তারিখ এবং স্থান নির্বাচন করুন৷",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "শিশু জন্মের মহূরত শুধুমাত্র আধ্যাত্মিক এবং জ্যোতিষশাস্ত্রীয় নির্দেশনার জন্য।",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "শিশু জন্মের মহুরত একটি প্রিমিয়াম বৈশিষ্ট্য। Panchang, Choghadiya এবং Hora চেকের মাধ্যমে শুভ নির্দেশিকা উইন্ডো আনলক করতে আপগ্রেড করুন।",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "শিশু জন্মের মহুরত একটি প্রিমিয়াম বৈশিষ্ট্য। Panchang, Choghadiya এবং Hora চেকের সাহায্যে নির্দেশিকা উইন্ডো আনলক করতে আপগ্রেড করুন।",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "তারিখ, স্থান, পঞ্চং, চোঘাদিয়া এবং হোরা অনুসারে প্রিমিয়াম নির্দেশিকা উইন্ডো।",
    "Premium feature": "প্রিমিয়াম বৈশিষ্ট্য",
    "Upgrade to Kundlistar Premium": "কুন্ডলিস্টার প্রিমিয়ামে আপগ্রেড করুন",
    "Previous": "আগের",
    "Today": "আজ",
    "Birth place / City": "জন্মস্থান/শহর",
    "Birth place / city": "জন্মস্থান/শহর",
    "Select country, then search city": "দেশ নির্বাচন করুন, তারপর শহর খুঁজুন",
    "Preferred start": "পছন্দের শুরু",
    "Preferred end": "পছন্দের শেষ",
    "Mother Moon sign (optional)": "মা চন্দ্র চিহ্ন (ঐচ্ছিক)",
    "Cancer": "কর্কট",
    "Load Kundli": "কুন্ডলি লোড করুন",
    "Find Premium Windows": "প্রিমিয়াম উইন্ডোজ খুঁজুন",
    "Date (DD/MM/YYYY)": "তারিখ (DD/MM/YYYY)",
    "Invalid Date": "অবৈধ তারিখ",
    "Date must be in DD/MM/YYYY format.": "তারিখ অবশ্যই DD/MM/YYYY ফর্ম্যাটে হতে হবে।",
    "Required": "প্রয়োজন",
    "Please select a city.": "একটি শহর নির্বাচন করুন.",
    "Kundli": "কুন্ডলি",
    "Unable to load kundli.": "কুন্ডলি লোড করতে অক্ষম।",
    "Unable to calculate Child Birth Mahoorat.": "সন্তানের জন্মের মহরত গণনা করতে অক্ষম।",
    "Kundli Preview": "কুন্ডলি প্রিভিউ",
    "Loaded for": "জন্য লোড",
    "Doshas & Yogas": "দোষ ও যোগাসন",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "লোড লাহিড়ী কুন্ডলি থেকে নিয়ম ভিত্তিক ইঙ্গিত. পর্যালোচনা এবং আধ্যাত্মিক নির্দেশনার জন্য এগুলি ব্যবহার করুন, চূড়ান্ত বিচার হিসাবে নয়।",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "লোড লাহিড়ী কুন্ডলি থেকে নিয়ম ভিত্তিক ইঙ্গিত. পর্যালোচনা এবং আধ্যাত্মিক নির্দেশিকা জন্য ব্যবহার করুন.",
    "Detected": "সনাক্ত করা হয়েছে",
    "Not detected": "সনাক্ত করা হয়নি",
    "Review": "পর্যালোচনা",
    "Dosha": "দোশা",
    "Yoga": "যোগব্যায়াম",
    "Full Yoga Scan": "সম্পূর্ণ যোগ স্ক্যান",
    "Checking yogas...": "যোগাস পরীক্ষা করা হচ্ছে...",
    "No major yogas were detected by the premium yoga scan.": "প্রিমিয়াম যোগব্যায়াম স্ক্যান দ্বারা কোন বড় যোগাস সনাক্ত করা যায়নি।",
    "No suitable premium windows found for the selected date and time range.": "নির্বাচিত তারিখ এবং সময় সীমার জন্য কোন উপযুক্ত প্রিমিয়াম উইন্ডো পাওয়া যায়নি।",
    "No suitable windows found": "কোনো উপযুক্ত জানালা পাওয়া যায়নি",
    "Try changing the time range or select previous/next date.": "সময়সীমা পরিবর্তন করার চেষ্টা করুন বা পূর্ববর্তী/পরবর্তী তারিখ নির্বাচন করুন।",
    "Try changing the date or time range.": "তারিখ বা সময় পরিসীমা পরিবর্তন করার চেষ্টা করুন.",
    "Try the Previous or Next date button to find a better option.": "একটি ভাল বিকল্প খুঁজে পেতে পূর্ববর্তী বা পরবর্তী তারিখ বোতাম চেষ্টা করুন.",
    "Use Previous or Next date to find a better option.": "একটি ভাল বিকল্প খুঁজে পেতে পূর্ববর্তী বা পরবর্তী তারিখ ব্যবহার করুন.",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "নির্বাচিত তারিখ এবং শহরের জন্য সেরা প্রিমিয়াম উইন্ডোগুলি গণনা করতে প্রিমিয়াম উইন্ডোজ খুঁজুন ক্লিক করুন৷",
    "Tap Find Premium Windows for the selected date and city.": "নির্বাচিত তারিখ এবং শহরের জন্য প্রিমিয়াম উইন্ডোজ খুঁজুন আলতো চাপুন।",
    "Good tithi": "শুভ তিথি",
    "Supportive nakshatra": "সহায়ক নক্ষত্র",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "নক্ষত্র সংবেদনশীল। পাদা এবং গন্ডাটা সাবধানে পরীক্ষা করুন।",
    "Supportive weekday": "সহায়ক সপ্তাহের দিন",
    "Good Choghadiya": "ভাল চোৰাদিয়া",
    "Weak Choghadiya": "দুর্বল চোগদিয়া",
    "Supportive Hora": "সাপোর্টিভ হোরা",
    "Baby Moon matches mother's Moon sign.": "শিশুর চাঁদ মায়ের চাঁদের চিহ্নের সাথে মিলে যায়।",
    "Hora": "হোরা",
    "slots": "স্লট",
    "min": "মিনিট",
    "Good": "ভাল",
    "Excellent": "চমৎকার",
    "Usable": "ব্যবহারযোগ্য",
    "Rejected": "প্রত্যাখ্যাত",
    "Sunday": "রবিবার",
    "Monday": "সোমবার",
    "Tuesday": "মঙ্গলবার",
    "Wednesday": "বুধবার",
    "Thursday": "বৃহস্পতিবার",
    "Friday": "শুক্রবার",
    "Saturday": "শনিবার",
    "Sun": "সূর্য",
    "Moon": "চন্দ্র",
    "Mars": "মঙ্গল",
    "Mercury": "বুধ",
    "Jupiter": "বৃহস্পতি",
    "Venus": "শুক্র",
    "Saturn": "শনি",
    "Rahu": "রাহু",
    "Ketu": "কেতু",
    "Chal": "চল",
    "Labh": "লভ",
    "Amrit": "অমৃত",
    "Shubh": "শুভ",
    "Udveg": "উদ্ভেগ",
    "Rog": "রোগ",
    "Kaal": "কাল",
    "Krishna Navami": "কৃষ্ণ নবমী",
    "Ashwini": "অশ্বিনী",
    "Bharani": "ভরণী",
    "Krittika": "কৃত্তিকা",
    "Rohini": "রোহিণী",
    "Mrigashira": "মৃগশিরা",
    "Ardra": "আর্দ্রা",
    "Punarvasu": "পুনর্বসু",
    "Pushya": "পুষ্যা",
    "Ashlesha": "অশ্লেষা",
    "Magha": "মঘা",
    "Jyeshtha": "জ্যেষ্ঠা",
    "Moola": "মূলা",
    "Mula": "মূলা",
    "Revati": "রেবতী",
    "Hasta": "হস্ত",
    "Chitra": "চিত্রা",
    "Swati": "স্বাতী",
    "Vishakha": "বিশাখা",
    "Anuradha": "অনুরাধা",
    "Shravana": "শ্রবণা",
    "Dhanishta": "ধনিষ্ঠা",
    "Shatabhisha": "শতভিষা",
    "Aries": "মেষ",
    "Taurus": "বৃষ",
    "Gemini": "মিথুন",
    "Leo": "সিংহ",
    "Virgo": "কন্যা",
    "Libra": "তুলা",
    "Scorpio": "বৃশ্চিক",
    "Sagittarius": "ধনু",
    "Capricorn": "মকর",
    "Aquarius": "কুম্ভ",
    "Pisces": "মীন",
    "Ascendant": "লগ্ন",
    "Asc": "লগ্ন",
    "Lagna": "লগ্ন",
    "Sign": "রাশি",
    "Signs": "রাশি",
    "House": "ভাব",
    "Houses": "ভাবসমূহ",
    "Lord": "অধিপতি",
    "House Lordships": "ভাব অধিপতি",
    "Sign Lord": "রাশির অধিপতি",
    "Star Lord": "নক্ষত্র অধিপতি",
    "Sub Lord": "উপ অধিপতি",
    "Sub-Sub Lord": "উপ-উপ অধিপতি",
    "Cusp Lord": "ভাবসন্ধির অধিপতি",
    "Nakshatra Nadi": "নক্ষত্র নাড়ি",
    "Nakshatra": "নক্ষত্র",
    "Pada": "পাদ",
    "Mrigashirsha": "মৃগশিরা"
  },
  "kn": {
    "Client Management": "ಗ್ರಾಹಕ ನಿರ್ವಹಣೆ",
    "Dashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    "Clients": "ಗ್ರಾಹಕರು",
    "Consultations": "ಸಮಾಲೋಚನೆಗಳು",
    "Notes": "ಟಿಪ್ಪಣಿಗಳು",
    "Follow-ups": "ಅನುಸರಣೆಗಳು",
    "Reports": "ವರದಿಗಳು",
    "Remedies": "ಪರಿಹಾರಗಳು",
    "Predictions": "ಭವಿಷ್ಯವಾಣಿಗಳು",
    "Planner": "ಯೋಜಕ",
    "Templates": "ಟೆಂಪ್ಲೇಟ್‌ಗಳು",
    "Analytics": "ಅನಾಲಿಟಿಕ್ಸ್",
    "Payments": "ಪಾವತಿಗಳು",
    "Settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings ನಲ್ಲಿ ಡೀಫಾಲ್ಟ್ ನಗರವನ್ನು ಉಳಿಸಬಹುದು. ಡೀಫಾಲ್ಟ್ ನಗರ ಆಯ್ಕೆ ಆಗುವವರೆಗೆ ನಗರ ಕ್ಷೇತ್ರಗಳು ಖಾಲಿ ಇರುತ್ತವೆ.",
    "is now your default city.": "ಈಗ ನಿಮ್ಮ ಡೀಫಾಲ್ಟ್ ನಗರವಾಗಿದೆ.",
    "Search your default city": "ನಿಮ್ಮ ಡೀಫಾಲ್ಟ್ ನಗರವನ್ನು ಹುಡುಕಿ",
    "This color is saved for the website theme and PDF report accent.": "ಈ ಬಣ್ಣ ವೆಬ್‌ಸೈಟ್ ಥೀಮ್ ಮತ್ತು PDF ವರದಿ accent ಗೆ ಉಳಿಯುತ್ತದೆ.",
    "Turn All off to include only the checked modules in the report.": "ವರದಿಯಲ್ಲಿ ಆಯ್ದ ಮಾಡ್ಯೂಲ್‌ಗಳನ್ನು ಮಾತ್ರ ಸೇರಿಸಲು All ಆಫ್ ಮಾಡಿ.",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All ಆನ್ ಇದ್ದರೆ PDF ಎಲ್ಲಾ ಮಾಡ್ಯೂಲ್‌ಗಳನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ. ಆಯ್ದವುಗಳನ್ನು ಮಾತ್ರ ಸೇರಿಸಲು ಅದನ್ನು ಆಫ್ ಮಾಡಿ.",
    "Uranus, Neptune and Pluto stay hidden by default.": "ಯುರೇನಸ್, ನೆಪ್ಚ್ಯೂನ್ ಮತ್ತು ಪ್ಲೂಟೋ ಡೀಫಾಲ್ಟ್ ಆಗಿ ಮರೆಮಾಡಲ್ಪಡುತ್ತವೆ.",
    "Show Uranus, Neptune and Pluto": "ಯುರೇನಸ್, ನೆಪ್ಚ್ಯೂನ್ ಮತ್ತು ಪ್ಲೂಟೋ ತೋರಿಸಿ",
    "When off, Nadi and KP also use the selected global ayanamsha.": "ಆಫ್ ಇದ್ದರೆ, ನಾಡಿ ಮತ್ತು KP ಆಯ್ದ ಜಾಗತಿಕ ಅಯನಾಂಶವನ್ನು ಬಳಸುತವೆ.",
    "Use KP for Nadi and KP": "ನಾಡಿ ಮತ್ತು KP ಗೆ KP ಬಳಸಿ",
    "Use KP ayanamsha for Nadi and KP": "ನಾಡಿ ಮತ್ತು KP ಗೆ KP ಅಯನಾಂಶ ಬಳಸಿ",
    "Night": "ನೈಟ್",
    "Dark": "ಡಾರ್ಕ್",
    "Light": "ಲೈಟ್",
    "Clear default city": "ಡೀಫಾಲ್ಟ್ ನಗರವನ್ನು ತೆರವುಗೊಳಿಸಿ",
    "Default City": "ಡೀಫಾಲ್ಟ್ ನಗರ",
    "Default city": "ಡೀಫಾಲ್ಟ್ ನಗರ",
    "Theme Color": "ಥೀಮ್ ಬಣ್ಣ",
    "Theme color": "ಥೀಮ್ ಬಣ್ಣ",
    "Include all modules": "ಎಲ್ಲಾ ಮಾಡ್ಯೂಲ್‌ಗಳನ್ನು ಸೇರಿಸಿ",
    "PDF Report Modules": "PDF ವರದಿ ಮಾಡ್ಯೂಲ್‌ಗಳು",
    "PDF report modules": "PDF ವರದಿ ಮಾಡ್ಯೂಲ್‌ಗಳು",
    "Show": "ತೋರಿಸಿ",
    "Hide": "ಮರೆಮಾಡಿ",
    "Outer Planets": "ಹೊರ ಗ್ರಹಗಳು",
    "Outer planets": "ಹೊರ ಗ್ರಹಗಳು",
    "Ayanamsha": "ಅಯನಾಂಶ",
    "Mean Node": "ಮೀನ್ ನೋಡ್",
    "True Node": "ಟ್ರೂ ನೋಡ್",
    "Rahu/Ketu Calculation": "ರಾಹು/ಕೇತು ಗಣನೆ",
    "Rahu/Ketu calculation": "ರಾಹು/ಕೇತು ಗಣನೆ",
    "East": "ಪೂರ್ವ ಭಾರತೀಯ",
    "South": "ದಕ್ಷಿಣ ಭಾರತೀಯ",
    "North": "ಉತ್ತರ ಭಾರತೀಯ",
    "Chart Style": "ಚಾರ್ಟ್ ಶೈಲಿ",
    "Chart style": "ಚಾರ್ಟ್ ಶೈಲಿ",
    "Language": "ಭಾಷೆ",
    "Records": "ದಾಖಲೆಗಳು",
    "Relations": "ಸಂಬಂಧಗಳು",
    "Relation": "ಸಂಬಂಧ",
    "Add Client": "ಕ್ಲೈಂಟ್ ಸೇರಿಸಿ",
    "Add Consultation": "ಸಮಾಲೋಚನೆ ಸೇರಿಸಿ",
    "Add Note": "ಟಿಪ್ಪಣಿ ಸೇರಿಸಿ",
    "Add Follow-up": "ಅನುಸರಣೆಯನ್ನು ಸೇರಿಸಿ",
    "Create Report": "ವರದಿಯನ್ನು ರಚಿಸಿ",
    "Assign Remedy": "ಪರಿಹಾರವನ್ನು ನಿಯೋಜಿಸಿ",
    "Add Prediction": "ಭವಿಷ್ಯವನ್ನು ಸೇರಿಸಿ",
    "Add Payment": "ಪಾವತಿಯನ್ನು ಸೇರಿಸಿ",
    "Assign Chart": "ಚಾರ್ಟ್ ನಿಯೋಜಿಸಿ",
    "Add Relation": "ಸಂಬಂಧವನ್ನು ಸೇರಿಸಿ",
    "CMS Action": "CMS ಕ್ರಿಯೆ",
    "Client": "ಗ್ರಾಹಕ",
    "Chart": "ಚಾರ್ಟ್",
    "Related Client": "ಸಂಬಂಧಿತ ಗ್ರಾಹಕ",
    "Full Name": "ಪೂರ್ಣ ಹೆಸರು",
    "Phone Number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "WhatsApp Number": "WhatsApp ಸಂಖ್ಯೆ",
    "Email": "ಇಮೇಲ್",
    "Birth Place": "ಹುಟ್ಟಿದ ಸ್ಥಳ",
    "Current City": "ಪ್ರಸ್ತುತ ನಗರ",
    "Main Topic": "ಮುಖ್ಯ ವಿಷಯ",
    "Status": "ಸ್ಥಿತಿ",
    "Source": "ಮೂಲ",
    "Tags": "ಟ್ಯಾಗ್‌ಗಳು",
    "Internal Note": "ಆಂತರಿಕ ಟಿಪ್ಪಣಿ",
    "Purpose": "ಉದ್ದೇಶ",
    "Relation Type": "ಸಂಬಂಧದ ಪ್ರಕಾರ",
    "Title": "ಶೀರ್ಷಿಕೆ",
    "Topic": "ವಿಷಯ",
    "Date": "ದಿನಾಂಕ",
    "Time": "ಸಮಯ",
    "Amount": "ಮೊತ್ತ",
    "Mode": "ಮೋಡ್",
    "Payment Status": "ಪಾವತಿ ಸ್ಥಿತಿ",
    "Note / Summary": "ಟಿಪ್ಪಣಿ / ಸಾರಾಂಶ",
    "Close": "ಮುಚ್ಚಿ",
    "Cancel": "ರದ್ದುಮಾಡು",
    "Save": "ಉಳಿಸಿ",
    "Saving": "ಉಳಿಸಲಾಗುತ್ತಿದೆ",
    "Save Changes": "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    "Edit Client": "ಕ್ಲೈಂಟ್ ಅನ್ನು ಸಂಪಾದಿಸಿ",
    "Client Chart": "ಕ್ಲೈಂಟ್ ಚಾರ್ಟ್",
    "Comma separated": "ಅಲ್ಪವಿರಾಮವನ್ನು ಬೇರ್ಪಡಿಸಲಾಗಿದೆ",
    "Search by name, phone, email, topic, or tag": "ಹೆಸರು, ಫೋನ್, ಇಮೇಲ್, ವಿಷಯ ಅಥವಾ ಟ್ಯಾಗ್ ಮೂಲಕ ಹುಡುಕಿ",
    "Search clients, phone, topic": "ಗ್ರಾಹಕರು, ಫೋನ್, ವಿಷಯವನ್ನು ಹುಡುಕಿ",
    "Search your saved charts by chart name": "ಚಾರ್ಟ್ ಹೆಸರಿನ ಮೂಲಕ ನಿಮ್ಮ ಉಳಿಸಿದ ಚಾರ್ಟ್‌ಗಳನ್ನು ಹುಡುಕಿ",
    "Linked Chart": "ಲಿಂಕ್ ಮಾಡಿದ ಚಾರ್ಟ್",
    "Select linked chart": "ಲಿಂಕ್ ಮಾಡಿದ ಚಾರ್ಟ್ ಆಯ್ಕೆಮಾಡಿ",
    "Link a chart to this client before adding records.": "ದಾಖಲೆಗಳನ್ನು ಸೇರಿಸುವ ಮೊದಲು ಈ ಕ್ಲೈಂಟ್‌ಗೆ ಚಾರ್ಟ್ ಅನ್ನು ಲಿಂಕ್ ಮಾಡಿ.",
    "Connect this client with another saved client profile": "ಈ ಕ್ಲೈಂಟ್ ಅನ್ನು ಮತ್ತೊಂದು ಉಳಿಸಿದ ಕ್ಲೈಂಟ್ ಪ್ರೊಫೈಲ್‌ನೊಂದಿಗೆ ಸಂಪರ್ಕಿಸಿ",
    "CMS for astrologer client work": "ಜ್ಯೋತಿಷಿ ಕ್ಲೈಂಟ್ ಕೆಲಸಕ್ಕಾಗಿ CMS",
    "Premium Pro unlocks Client Management": "ಪ್ರೀಮಿಯಂ ಪ್ರೊ ಕ್ಲೈಂಟ್ ಮ್ಯಾನೇಜ್‌ಮೆಂಟ್ ಅನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡುತ್ತದೆ",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ಕ್ಲೈಂಟ್ ಪ್ರೊಫೈಲ್‌ಗಳು, ಸಮಾಲೋಚನೆಗಳು, ಟಿಪ್ಪಣಿಗಳು, ಅನುಸರಣೆಗಳು, ವರದಿಗಳು, ಪರಿಹಾರಗಳು, ಮುನ್ನೋಟಗಳು, ವಿಶ್ಲೇಷಣೆಗಳು ಮತ್ತು ಪಾವತಿ ಟ್ರ್ಯಾಕಿಂಗ್ ಅನ್ನು ಒಂದೇ ಕಾರ್ಯಕ್ಷೇತ್ರದಲ್ಲಿ ನಿರ್ವಹಿಸಲು ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
    "Upgrade to Premium Pro": "ಪ್ರೀಮಿಯಂ ಪ್ರೊಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ",
    "CMS modules included": "CMS ಮಾಡ್ಯೂಲ್‌ಗಳನ್ನು ಒಳಗೊಂಡಿದೆ",
    "Please login to use Client Management. CMS data is stored per account.": "ಗ್ರಾಹಕ ನಿರ್ವಹಣೆಯನ್ನು ಬಳಸಲು ದಯವಿಟ್ಟು ಲಾಗಿನ್ ಮಾಡಿ. ಪ್ರತಿ ಖಾತೆಗೆ CMS ಡೇಟಾವನ್ನು ಸಂಗ್ರಹಿಸಲಾಗಿದೆ.",
    "Login": "ಲಾಗಿನ್ ಮಾಡಿ",
    "Loading live CMS data...": "ಲೈವ್ CMS ಡೇಟಾವನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Quick Actions": "ತ್ವರಿತ ಕ್ರಮಗಳು",
    "Client Records": "ಗ್ರಾಹಕ ದಾಖಲೆಗಳು",
    "Client Record": "ಗ್ರಾಹಕ ದಾಖಲೆ",
    "Client Profile": "ಕ್ಲೈಂಟ್ ಪ್ರೊಫೈಲ್",
    "Back to Clients": "ಗ್ರಾಹಕರಿಗೆ ಹಿಂತಿರುಗಿ",
    "View": "ವೀಕ್ಷಿಸಿ",
    "Edit": "ಸಂಪಾದಿಸು",
    "Delete": "ಅಳಿಸಿ",
    "Note": "ಗಮನಿಸಿ",
    "Archive": "ಆರ್ಕೈವ್",
    "Download PDF": "PDF ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "Delete this record?": "ಈ ದಾಖಲೆಯನ್ನು ಅಳಿಸುವುದೇ?",
    "Unable to edit this CMS record.": "ಈ CMS ದಾಖಲೆಯನ್ನು ಸಂಪಾದಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "Unable to update CMS record.": "CMS ದಾಖಲೆಯನ್ನು ನವೀಕರಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "Unable to delete CMS record.": "CMS ದಾಖಲೆಯನ್ನು ಅಳಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ.",
    "No contact added": "ಯಾವುದೇ ಸಂಪರ್ಕವನ್ನು ಸೇರಿಸಲಾಗಿಲ್ಲ",
    "No topic": "ಯಾವುದೇ ವಿಷಯವಿಲ್ಲ",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "ಇನ್ನೂ ಯಾವುದೇ ಗ್ರಾಹಕರು ಕಂಡುಬಂದಿಲ್ಲ. CMS ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡಲು ನಿಮ್ಮ ಮೊದಲ ನೈಜ ಕ್ಲೈಂಟ್ ಅನ್ನು ಸೇರಿಸಿ.",
    "Last Consultation": "ಕೊನೆಯ ಸಮಾಲೋಚನೆ",
    "Next Follow-up": "ಮುಂದಿನ ಅನುಸರಣೆ",
    "Date of Birth": "ಹುಟ್ಟಿದ ದಿನಾಂಕ",
    "Time of Birth": "ಹುಟ್ಟಿದ ಸಮಯ",
    "Client Details": "ಗ್ರಾಹಕರ ವಿವರಗಳು",
    "No connected profiles yet.": "ಇನ್ನೂ ಸಂಪರ್ಕಿತ ಪ್ರೊಫೈಲ್‌ಗಳಿಲ್ಲ.",
    "Select a client record to view details.": "ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಕ್ಲೈಂಟ್ ದಾಖಲೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "Record": "ರೆಕಾರ್ಡ್ ಮಾಡಿ",
    "Consultation Summary": "ಸಮಾಲೋಚನೆಯ ಸಾರಾಂಶ",
    "Client Note": "ಗ್ರಾಹಕ ಟಿಪ್ಪಣಿ",
    "Start a consultation record with summary, topic, mode and payment fields.": "ಸಾರಾಂಶ, ವಿಷಯ, ಮೋಡ್ ಮತ್ತು ಪಾವತಿ ಕ್ಷೇತ್ರಗಳೊಂದಿಗೆ ಸಮಾಲೋಚನೆಯ ದಾಖಲೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
    "Start a private note attached to a client profile.": "ಕ್ಲೈಂಟ್ ಪ್ರೊಫೈಲ್‌ಗೆ ಲಗತ್ತಿಸಲಾದ ಖಾಸಗಿ ಟಿಪ್ಪಣಿಯನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
    "Start a pending follow-up with due date and topic.": "ನಿಗದಿತ ದಿನಾಂಕ ಮತ್ತು ವಿಷಯದೊಂದಿಗೆ ಬಾಕಿ ಉಳಿದಿರುವ ಅನುಸರಣೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
    "Start a report record connected to the client timeline.": "ಕ್ಲೈಂಟ್ ಟೈಮ್‌ಲೈನ್‌ಗೆ ಸಂಪರ್ಕಗೊಂಡಿರುವ ವರದಿಯ ದಾಖಲೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
    "Start an active remedy record for client guidance.": "ಕ್ಲೈಂಟ್ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಸಕ್ರಿಯ ಪರಿಹಾರ ದಾಖಲೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
    "Start an open prediction record with notes and follow-up date.": "ಟಿಪ್ಪಣಿಗಳು ಮತ್ತು ಅನುಸರಣಾ ದಿನಾಂಕದೊಂದಿಗೆ ತೆರೆದ ಭವಿಷ್ಯ ದಾಖಲೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
    "Statuses": "ಸ್ಥಿತಿಗಳು",
    "Topics": "ವಿಷಯಗಳು",
    "Sources": "ಮೂಲಗಳು",
    "No records found for the current filters.": "ಪ್ರಸ್ತುತ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಯಾವುದೇ ದಾಖಲೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "Total Clients": "ಒಟ್ಟು ಗ್ರಾಹಕರು",
    "New Clients This Month": "ಈ ತಿಂಗಳು ಹೊಸ ಗ್ರಾಹಕರು",
    "Consultations This Month": "ಈ ತಿಂಗಳು ಸಮಾಲೋಚನೆಗಳು",
    "Today's Consultations": "ಇಂದಿನ ಸಮಾಲೋಚನೆಗಳು",
    "Consultations scheduled for today from real client records.": "ನೈಜ ಕ್ಲೈಂಟ್ ದಾಖಲೆಗಳಿಂದ ಇಂದು ಸಮಾಲೋಚನೆಗಳನ್ನು ನಿಗದಿಪಡಿಸಲಾಗಿದೆ.",
    "No consultations scheduled for today.": "ಇಂದು ಯಾವುದೇ ಸಮಾಲೋಚನೆಗಳನ್ನು ನಿಗದಿಪಡಿಸಲಾಗಿಲ್ಲ.",
    "Pending Follow-ups": "ಬಾಕಿ ಉಳಿದಿರುವ ಅನುಸರಣೆಗಳು",
    "Reports Created": "ವರದಿಗಳನ್ನು ರಚಿಸಲಾಗಿದೆ",
    "Active Remedies": "ಸಕ್ರಿಯ ಪರಿಹಾರಗಳು",
    "Open Predictions": "ಮುನ್ಸೂಚನೆಗಳನ್ನು ತೆರೆಯಿರಿ",
    "Pending Payments": "ಬಾಕಿ ಪಾವತಿಗಳು",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "ಕ್ಲೈಂಟ್ ಚಟುವಟಿಕೆ, ಇತ್ತೀಚಿನ ಕೆಲಸ, ಫಾಲೋ-ಅಪ್‌ಗಳು, ವರದಿಗಳು, ಮುನ್ನೋಟಗಳು, ಪರಿಹಾರಗಳು ಮತ್ತು ಬಾಕಿಯಿರುವ ಪಾವತಿಗಳನ್ನು ಒಂದೇ ಸ್ಥಳದಲ್ಲಿ ನೋಡಿ.",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "ಜನ್ಮ ವಿವರಗಳು, ವಿಷಯಗಳು, ಟ್ಯಾಗ್‌ಗಳು, ಸ್ಥಿತಿ ಮತ್ತು ಆರ್ಕೈವ್/ರೀಸ್ಟೋರ್ ಕ್ರಿಯೆಗಳೊಂದಿಗೆ ಜ್ಯೋತಿಷಿ ಕ್ಲೈಂಟ್ ದಾಖಲೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ.",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "ಅಧಿವೇಶನದ ವಿವರಗಳು, ಲಿಂಕ್ ಮಾಡಿದ ಚಾರ್ಟ್‌ಗಳು, ವಿಷಯಗಳು, ಅವಲೋಕನಗಳು, ಮುನ್ನೋಟಗಳು, ಪರಿಹಾರಗಳು ಮತ್ತು ಅನುಸರಣಾ ದಿನಾಂಕಗಳನ್ನು ಸಂಗ್ರಹಿಸಿ.",
    "Keep private consultation notes and chart observations attached to client profiles.": "ಕ್ಲೈಂಟ್ ಪ್ರೊಫೈಲ್‌ಗಳಿಗೆ ಲಗತ್ತಿಸಲಾದ ಖಾಸಗಿ ಸಮಾಲೋಚನೆ ಟಿಪ್ಪಣಿಗಳು ಮತ್ತು ಚಾರ್ಟ್ ವೀಕ್ಷಣೆಗಳನ್ನು ಇರಿಸಿಕೊಳ್ಳಿ.",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "ಪುಶ್, SMS, ಇಮೇಲ್ ಅಥವಾ WhatsApp ಎಚ್ಚರಿಕೆಗಳಿಲ್ಲದೆಯೇ ಕ್ಲೈಂಟ್ ಮ್ಯಾನೇಜ್‌ಮೆಂಟ್‌ನಲ್ಲಿ ಇಂದು ಮತ್ತು ಮುಂಬರುವ ಫಾಲೋ-ಅಪ್‌ಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.",
    "Create and organize client reports generated from saved charts and consultation context.": "ಉಳಿಸಿದ ಚಾರ್ಟ್‌ಗಳು ಮತ್ತು ಸಮಾಲೋಚನೆ ಸಂದರ್ಭದಿಂದ ರಚಿಸಲಾದ ಕ್ಲೈಂಟ್ ವರದಿಗಳನ್ನು ರಚಿಸಿ ಮತ್ತು ಸಂಘಟಿಸಿ.",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "ಪರಿಹಾರಗಳನ್ನು ನಿಯೋಜಿಸಿ, ಸಕ್ರಿಯ ಮಾರ್ಗದರ್ಶನವನ್ನು ಗುರುತಿಸಿ ಮತ್ತು ಕ್ಲೈಂಟ್ ಟೈಮ್‌ಲೈನ್‌ಗೆ ಸಂಪರ್ಕಿತವಾಗಿರುವ ಪರಿಹಾರ ಇತಿಹಾಸವನ್ನು ಇರಿಸಿಕೊಳ್ಳಿ.",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "ಪ್ರತಿ ಕ್ಲೈಂಟ್‌ಗಾಗಿ ತೆರೆದ ಮುನ್ನೋಟಗಳು, ದಿನಾಂಕಗಳು, ವಿಶ್ವಾಸಾರ್ಹ ಟಿಪ್ಪಣಿಗಳು ಮತ್ತು ಫಲಿತಾಂಶದ ನವೀಕರಣಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.",
    "Plan consultations, follow-ups and payment dates in one working view.": "ಒಂದು ಕೆಲಸದ ವೀಕ್ಷಣೆಯಲ್ಲಿ ಸಮಾಲೋಚನೆಗಳು, ಅನುಸರಣೆಗಳು ಮತ್ತು ಪಾವತಿ ದಿನಾಂಕಗಳನ್ನು ಯೋಜಿಸಿ.",
    "Prepare reusable consultation, report, remedy and prediction templates.": "ಮರುಬಳಕೆ ಮಾಡಬಹುದಾದ ಸಮಾಲೋಚನೆ, ವರದಿ, ಪರಿಹಾರ ಮತ್ತು ಭವಿಷ್ಯ ಟೆಂಪ್ಲೇಟ್‌ಗಳನ್ನು ತಯಾರಿಸಿ.",
    "Review client activity, consultation volume, reports created and pending work.": "ಕ್ಲೈಂಟ್ ಚಟುವಟಿಕೆ, ಸಮಾಲೋಚನೆಯ ಪ್ರಮಾಣ, ರಚಿಸಲಾದ ವರದಿಗಳು ಮತ್ತು ಬಾಕಿ ಉಳಿದಿರುವ ಕೆಲಸವನ್ನು ಪರಿಶೀಲಿಸಿ.",
    "Track consultation amounts and payment status without plan or pricing rules.": "ಯೋಜನೆ ಅಥವಾ ಬೆಲೆ ನಿಯಮಗಳಿಲ್ಲದೆ ಸಮಾಲೋಚನೆ ಮೊತ್ತ ಮತ್ತು ಪಾವತಿ ಸ್ಥಿತಿಯನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "ಕ್ಲೈಂಟ್ ಮೂಲಗಳು, ಸ್ಥಿತಿಗಳು, ವಿಷಯಗಳು, ಟ್ಯಾಗ್‌ಗಳು ಮತ್ತು ಆಂತರಿಕ CMS ಆದ್ಯತೆಗಳನ್ನು ಕಾನ್ಫಿಗರ್ ಮಾಡಿ.",
    "Showing saved records connected to client records.": "ಕ್ಲೈಂಟ್ ದಾಖಲೆಗಳಿಗೆ ಸಂಪರ್ಕಗೊಂಡಿರುವ ಉಳಿಸಿದ ದಾಖಲೆಗಳನ್ನು ತೋರಿಸಲಾಗುತ್ತಿದೆ.",
    "No Status": "ಸ್ಥಿತಿ ಇಲ್ಲ",
    "No Mode": "ಮೋಡ್ ಇಲ್ಲ",
    "No Payment Status": "ಪಾವತಿ ಸ್ಥಿತಿ ಇಲ್ಲ",
    "No Topic": "ವಿಷಯವಿಲ್ಲ",
    "No Source": "ಮೂಲವಿಲ್ಲ",
    "All Statuses": "ಎಲ್ಲಾ ಸ್ಥಿತಿಗಳು",
    "All Topics": "ಎಲ್ಲಾ ವಿಷಯಗಳು",
    "No clients found": "ಯಾವುದೇ ಗ್ರಾಹಕರು ಕಂಡುಬಂದಿಲ್ಲ",
    "Type to search clients": "ಕ್ಲೈಂಟ್‌ಗಳನ್ನು ಹುಡುಕಲು ಟೈಪ್ ಮಾಡಿ",
    "No charts found": "ಯಾವುದೇ ಚಾರ್ಟ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    "Type to search saved charts": "ಉಳಿಸಿದ ಚಾರ್ಟ್‌ಗಳನ್ನು ಹುಡುಕಲು ಟೈಪ್ ಮಾಡಿ",
    "Type to search related client": "ಸಂಬಂಧಿತ ಕ್ಲೈಂಟ್ ಅನ್ನು ಹುಡುಕಲು ಟೈಪ್ ಮಾಡಿ",
    "Open": "ತೆರೆಯಿರಿ",
    "Pending": "ಬಾಕಿಯಿದೆ",
    "Scheduled": "ನಿಗದಿಪಡಿಸಲಾಗಿದೆ",
    "Completed": "ಪೂರ್ಣಗೊಂಡಿದೆ",
    "Follow-up Pending": "ಅನುಸರಣೆ ಬಾಕಿಯಿದೆ",
    "Cancelled": "ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ",
    "Closed": "ಮುಚ್ಚಲಾಗಿದೆ",
    "No-show": "ನೋ-ಶೋ",
    "Not Applicable": "ಅನ್ವಯಿಸುವುದಿಲ್ಲ",
    "Paid": "ಪಾವತಿಸಲಾಗಿದೆ",
    "Partially Paid": "ಭಾಗಶಃ ಪಾವತಿಸಲಾಗಿದೆ",
    "Refunded": "ಮರುಪಾವತಿ ಮಾಡಲಾಗಿದೆ",
    "Phone": "ಫೋನ್",
    "WhatsApp Call": "WhatsApp ಕರೆ",
    "Video Call": "ವೀಡಿಯೊ ಕರೆ",
    "In-person": "ವ್ಯಕ್ತಿಗತವಾಗಿ",
    "Chat": "ಚಾಟ್ ಮಾಡಿ",
    "Other": "ಇತರೆ",
    "New": "ಹೊಸದು",
    "VIP": "ವಿಐಪಿ",
    "Inactive": "ನಿಷ್ಕ್ರಿಯ",
    "Consultation Completed": "ಸಮಾಲೋಚನೆ ಪೂರ್ಣಗೊಂಡಿದೆ",
    "WhatsApp": "WhatsApp",
    "Instagram": "Instagram",
    "YouTube": "YouTube",
    "Referral": "ರೆಫರಲ್",
    "Website": "ವೆಬ್‌ಸೈಟ್",
    "Walk-in": "ವಾಕ್-ಇನ್",
    "Repeat Client": "ಕ್ಲೈಂಟ್ ಅನ್ನು ಪುನರಾವರ್ತಿಸಿ",
    "Family Referral": "ಕುಟುಂಬ ರೆಫರಲ್",
    "Business": "ವ್ಯಾಪಾರ",
    "Finance": "ಹಣಕಾಸು",
    "Property": "ಆಸ್ತಿ",
    "Children": "ಮಕ್ಕಳು",
    "Foreign Settlement": "ವಿದೇಶಿ ವಸಾಹತು",
    "Legal": "ಕಾನೂನುಬದ್ಧ",
    "Remedy": "ಪರಿಹಾರ",
    "General": "ಸಾಮಾನ್ಯ",
    "Active": "ಸಕ್ರಿಯ",
    "Past": "ಹಿಂದಿನ",
    "Potential": "ಸಂಭಾವ್ಯ",
    "Archived": "ಆರ್ಕೈವ್ ಮಾಡಲಾಗಿದೆ",
    "Spouse": "ಸಂಗಾತಿ",
    "Husband": "ಗಂಡ",
    "Wife": "ಹೆಂಡತಿ",
    "Child": "ಮಗು",
    "Son": "ಮಗ",
    "Daughter": "ಮಗಳು",
    "Father": "ತಂದೆ",
    "Mother": "ತಾಯಿ",
    "Sibling": "ಒಡಹುಟ್ಟಿದವರು",
    "Brother": "ಸಹೋದರ",
    "Sister": "ಸಹೋದರಿ",
    "Marriage Prospect": "ಮದುವೆಯ ನಿರೀಕ್ಷೆ",
    "Fiance": "ನಿಶ್ಚಿತ ವರ",
    "Business Partner": "ವ್ಯಾಪಾರ ಪಾಲುದಾರ",
    "Friend": "ಸ್ನೇಹಿತ",
    "Relative": "ಸಂಬಂಧಿ",
    "Upgrade": "ನವೀಕರಿಸಿ",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "ನೀವು ಕೇವಲ 2 ಕ್ಲೈಂಟ್‌ಗಳನ್ನು ಮಾತ್ರ ಸೇರಿಸಬಹುದು. ಹೆಚ್ಚಿನ ಕ್ಲೈಂಟ್‌ಗಳಿಗಾಗಿ ಪ್ರೀಮಿಯಂಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
    "None": "ಯಾವುದೂ ಇಲ್ಲ",
    "Education": "ಶಿಕ್ಷಣ",
    "Awards": "ಪ್ರಶಸ್ತಿಗಳು",
    "Prize": "ಬಹುಮಾನ",
    "Career": "ವೃತ್ತಿ",
    "Love": "ಪ್ರೀತಿ",
    "Marriage": "ಮದುವೆ",
    "Dowry or Legacy": "ವರದಕ್ಷಿಣೆ ಅಥವಾ ಪರಂಪರೆ",
    "Divorce": "ವಿಚ್ಛೇದನ",
    "Abortion": "ಗರ್ಭಪಾತ",
    "Child Birth": "ಮಗುವಿನ ಜನನ",
    "Property/Vehicle Purchase": "ಆಸ್ತಿ/ವಾಹನ ಖರೀದಿ",
    "Property/Vehicle Sale": "ಆಸ್ತಿ/ವಾಹನ ಮಾರಾಟ",
    "Love and Caring": "ಪ್ರೀತಿ ಮತ್ತು ಕಾಳಜಿ",
    "Depression": "ಖಿನ್ನತೆ",
    "Aggression": "ಆಕ್ರಮಣಶೀಲತೆ",
    "Health": "ಆರೋಗ್ಯ",
    "Travel": "ಪ್ರಯಾಣ",
    "Homecoming": "ಗೃಹಪ್ರವೇಶ",
    "Litigation": "ವ್ಯಾಜ್ಯ",
    "Arrest": "ಬಂಧಿಸಿ",
    "Locked": "ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
    "Strong": "ಬಲಶಾಲಿ",
    "Weak": "ದುರ್ಬಲ",
    "Supportive": "ಪೋಷಕ",
    "Avoid": "ತಪ್ಪಿಸಿ",
    "Premium": "ಪ್ರೀಮಿಯಂ",
    " UTC": "UTC",
    "Unable to calculate Tithi Pravesh": "ತಿಥಿ ಪ್ರವೇಶವನ್ನು ಲೆಕ್ಕ ಹಾಕಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ",
    "IANA timezone": "IANA ಸಮಯವಲಯ",
    "TP Local": "ಟಿಪಿ ಸ್ಥಳೀಯ",
    "TP UTC": "ಟಿಪಿ ಯುಟಿಸಿ",
    "Next TP Local": "ಮುಂದಿನ ಟಿಪಿ ಸ್ಥಳೀಯ",
    "Models: KP + Vedic": "ಮಾದರಿಗಳು: ಕೆಪಿ + ವೈದಿಕ",
    "Overall Year Theme": "ಒಟ್ಟಾರೆ ವರ್ಷದ ಥೀಮ್",
    "Career & Job": "ವೃತ್ತಿ ಮತ್ತು ಉದ್ಯೋಗ",
    "Finance & Savings": "ಹಣಕಾಸು ಮತ್ತು ಉಳಿತಾಯ",
    "Relationship & Marriage": "ಸಂಬಂಧ ಮತ್ತು ಮದುವೆ",
    "Family Matters": "ಕುಟುಂಬದ ವಿಷಯಗಳು",
    "Property & Vehicle": "ಆಸ್ತಿ ಮತ್ತು ವಾಹನ",
    "Health & Wellness": "ಆರೋಗ್ಯ ಮತ್ತು ಸ್ವಾಸ್ಥ್ಯ",
    "Spiritual Growth": "ಆಧ್ಯಾತ್ಮಿಕ ಬೆಳವಣಿಗೆ",
    "Social Status & Recognition": "ಸಾಮಾಜಿಕ ಸ್ಥಿತಿ ಮತ್ತು ಗುರುತಿಸುವಿಕೆ",
    "Please select a saved chart first.": "ದಯವಿಟ್ಟು ಮೊದಲು ಉಳಿಸಿದ ಚಾರ್ಟ್ ಅನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "Unable to generate Tajika Varshphal": "ತಾಜಿಕಾ ವರ್ಷಫಾಲ್ ಅನ್ನು ಉತ್ಪಾದಿಸಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ",
    "Premium yearly module": "ಪ್ರೀಮಿಯಂ ವಾರ್ಷಿಕ ಮಾಡ್ಯೂಲ್",
    "Tajika Varshphal": "ತಾಜಿಕಾ ವರ್ಷಫಾಲ್",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "ವರ್ಷ ಲಗ್ನ, ಮುಂತಾ, ವರ್ಷಾ ಲಾರ್ಡ್, ಸಹಮ್ಸ್, ಮಾಸಿಕ ಮಾರ್ಗದರ್ಶನ, ಪರಿಹಾರಗಳು ಮತ್ತು ಈ ಉಳಿಸಿದ ಕುಂಡಲಿಯಿಂದ ವೈಯಕ್ತೀಕರಿಸಿದ ಪ್ರಾಯೋಗಿಕ ಜೀವನದ ಥೀಮ್‌ಗಳೊಂದಿಗೆ ಸೌರ ರಿಟರ್ನ್ ಆಧಾರಿತ ವಾರ್ಷಿಕ ಜಾತಕ.",
    "Saved chart": "ಉಳಿಸಿದ ಚಾರ್ಟ್",
    "Untitled Chart": "ಶೀರ್ಷಿಕೆರಹಿತ ಚಾರ್ಟ್",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "ನಿಮ್ಮ 4 ಉಚಿತ ಪ್ರೀಮಿಯಂ ಕ್ರೆಡಿಟ್‌ಗಳನ್ನು ಬಳಸಲಾಗುತ್ತದೆ. ಅನಿಯಮಿತ ಪ್ರೀಮಿಯಂ ಪ್ರವೇಶಕ್ಕಾಗಿ Kundlistar ಪ್ರೀಮಿಯಂಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "ನೀವು 4 ನಿಃಶುಲ್ಕ ಪ್ರೀಮಿಯಂ ಕ್ರೆಡಿಟ್ ಉಪಯೋಗವನ್ನು ಹೊಂದಿದೆ. ಅಸೀಮಿತ್ ಪ್ರಿಮಿಯಂ ಎಕ್ಸೆಸ್ ಗೆ Kundlistar ಪ್ರೀಮಿಯಂ ಲೆಂ.",
    "Core Year Markers": "ಕೋರ್ ವರ್ಷದ ಗುರುತುಗಳು",
    "Solar Return": "ಸೋಲಾರ್ ರಿಟರ್ನ್",
    "Varsha Lagna": "ವರ್ಷ ಲಗ್ನ",
    "Muntha Lord": "ಮುಂತಾ ಪ್ರಭು",
    "Varsha Lord": "ವರ್ಷಾ ಪ್ರಭು",
    "Varshesh Method": "ವರ್ಷೇಶ್ ವಿಧಾನ",
    "Yearly Summary": "ವಾರ್ಷಿಕ ಸಾರಾಂಶ",
    "Not available yet.": "ಇನ್ನೂ ಲಭ್ಯವಿಲ್ಲ.",
    "Varshesh Candidates": "ವರ್ಷೇಶ್ ಅಭ್ಯರ್ಥಿಗಳು",
    "Risk Areas": "ಅಪಾಯದ ಪ್ರದೇಶಗಳು",
    "Favourable Periods": "ಅನುಕೂಲಕರ ಅವಧಿಗಳು",
    "Challenging Periods": "ಸವಾಲಿನ ಅವಧಿಗಳು",
    "Remedies & Final Advice": "ಪರಿಹಾರಗಳು ಮತ್ತು ಅಂತಿಮ ಸಲಹೆ",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "ತಾಜಿಕಾ ವರ್ಷಫಲ್ ವಿವರಣಾತ್ಮಕ ವಾರ್ಷಿಕ ಮಾರ್ಗದರ್ಶನವನ್ನು ನೀಡುತ್ತದೆ. ಇದನ್ನು ವೈದ್ಯಕೀಯ, ಕಾನೂನು, ಹಣಕಾಸು, ಅಥವಾ ಕೆಲವು ಭವಿಷ್ಯ ಸಲಹೆ ಎಂದು ಪರಿಗಣಿಸಬಾರದು.",
    "Griha Pravesh": "ಗೃಹ ಪ್ರವೇಶ",
    "Purva Phalguni": "ಪೂರ್ವ ಫಲ್ಗುಣಿ",
    "Uttara Phalguni": "ಉತ್ತರಾ ಫಲ್ಗುಣಿ",
    "Purva Ashadha": "ಪೂರ್ವ ಆಷಾಢ",
    "Uttara Ashadha": "ಉತ್ತರ ಆಷಾಢ",
    "Purva Bhadrapada": "ಪೂರ್ವ ಭಾದ್ರಪದ",
    "Uttara Bhadrapada": "ಉತ್ತರ ಭಾದ್ರಪದ",
    "Param Mitra": "ಪರಮ ಮಿತ್ರ",
    "Kundli birthplace": "ಕುಂಡ್ಲಿ ಜನ್ಮಸ್ಥಳ",
    "Selected city": "ಆಯ್ದ ನಗರ",
    "Muhurat - Kundlistar": "ಮುಹೂರ್ತ - Kundlistar",
    "Please select a city first.": "ದಯವಿಟ್ಟು ಮೊದಲು ನಗರವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "Unable to calculate Muhurat.": "ಮುಹೂರ್ತವನ್ನು ಲೆಕ್ಕ ಹಾಕಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "Unable to calculate personalized Muhurat.": "ವೈಯಕ್ತೀಕರಿಸಿದ ಮುಹೂರ್ತವನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ.",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "ಪಂಚಾಂಗ, ಚೋಘಡಿಯಾ, ಹೋರಾ, ತಾರಾಬಲ ಮತ್ತು ಚಂದ್ರಬಲವನ್ನು ಬಳಸಿಕೊಂಡು ಸಾಮಾನ್ಯ ಮತ್ತು ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ಮುಹೂರ್ತವನ್ನು ಹುಡುಕಿ.",
    "Muhurat Finder": "ಮುಹೂರ್ತ ಶೋಧಕ",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "ಪಂಚಂಗ್, ಚೋಘಡಿಯಾ ಮತ್ತು ಪ್ರೀಮಿಯಂ ವೈಯಕ್ತಿಕ ಜನ್ಮ ಅಂಶಗಳನ್ನು ಬಳಸಿಕೊಂಡು ಉಪಯುಕ್ತ ಸಮಯ ವಿಂಡೋಗಳನ್ನು ಹುಡುಕಿ.",
    "Search city...": "ನಗರವನ್ನು ಹುಡುಕಿ...",
    "Using selected Kundli": "ಆಯ್ದ ಕುಂಡ್ಲಿಯನ್ನು ಬಳಸುವುದು",
    "Find Free": "ಉಚಿತ ಹುಡುಕಿ",
    "Free General Muhurat": "ಉಚಿತ ಸಾಮಾನ್ಯ ಮುಹೂರ್ತ",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "ಮುಂದಿನ 7 ದಿನಗಳವರೆಗೆ ಟಾಪ್ 3 ಸ್ಲಾಟ್‌ಗಳು. ರಾಹುಕಾಲ, ಯಮಗಂಡ ಮತ್ತು ಗುಳಿಕ ನಿವಾರಣೆಯಾಗುತ್ತದೆ.",
    "Today's Muhurat": "ಇವತ್ತು ಮುಹೂರ್ತ",
    "Daily Muhurat by Kundlistar": "Kundlistar ಅವರಿಂದ ದೈನಂದಿನ ಮುಹೂರ್ತ",
    "Shared via Kundlistar": "Kundlistar ಮೂಲಕ ಹಂಚಿಕೊಳ್ಳಲಾಗಿದೆ",
    "Kundlistar Muhurat": "Kundlistar ಮುಹೂರ್ತ",
    "Share Image": "ಚಿತ್ರವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
    "Share Text": "ಪಠ್ಯವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
    "Copy Text": "ಪಠ್ಯವನ್ನು ನಕಲಿಸಿ",
    "Click Find Free to use the selected Kundli birthplace.": "ಆಯ್ಕೆಮಾಡಿದ ಕುಂಡ್ಲಿ ಜನ್ಮಸ್ಥಳವನ್ನು ಬಳಸಲು ಉಚಿತ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    "Select a city and click Find Free.": "ನಗರವನ್ನು ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ಉಚಿತವನ್ನು ಹುಡುಕಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    "Premium Personalized Muhurat": "ಪ್ರೀಮಿಯಂ ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ಮುಹೂರ್ತ",
    "Loading Kundli details...": "ಕುಂಡಲಿ ವಿವರಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Birth Nakshatra": "ಜನ್ಮ ನಕ್ಷತ್ರ",
    "Birth Moon Rashi": "ಜನ್ಮ ಚಂದ್ರ ರಾಶಿ",
    "Include night slots": "ರಾತ್ರಿ ಸ್ಲಾಟ್‌ಗಳನ್ನು ಸೇರಿಸಿ",
    "Find Premium": "ಪ್ರೀಮಿಯಂ ಅನ್ನು ಹುಡುಕಿ",
    "Your grounding and foundation energy appears strong in this chart.": "ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ನಿಮ್ಮ ಗ್ರೌಂಡಿಂಗ್ ಮತ್ತು ಫೌಂಡೇಶನ್ ಶಕ್ತಿಯು ಬಲವಾಗಿ ಕಾಣುತ್ತದೆ.",
    "Your grounding energy appears generally balanced in this chart.": "ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ನಿಮ್ಮ ಗ್ರೌಂಡಿಂಗ್ ಶಕ್ತಿಯು ಸಾಮಾನ್ಯವಾಗಿ ಸಮತೋಲಿತವಾಗಿ ಕಂಡುಬರುತ್ತದೆ.",
    "Reflection on routine, discipline, and inner stability may be useful.": "ದಿನಚರಿ, ಶಿಸ್ತು ಮತ್ತು ಆಂತರಿಕ ಸ್ಥಿರತೆಯ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "Your creative and emotional flow energy appears strong in this chart.": "ನಿಮ್ಮ ಸೃಜನಾತ್ಮಕ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಹರಿವಿನ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಬಲವಾಗಿ ಕಾಣುತ್ತದೆ.",
    "Your creative energy appears balanced in this chart.": "ನಿಮ್ಮ ಸೃಜನಶೀಲ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಸಮತೋಲಿತವಾಗಿ ಗೋಚರಿಸುತ್ತದೆ.",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "ಸೃಜನಶೀಲತೆ, ಭಾವನಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿ ಮತ್ತು ಆಂತರಿಕ ಹರಿವಿನ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "Your confidence and willpower energy appears strong in this chart.": "ನಿಮ್ಮ ಆತ್ಮವಿಶ್ವಾಸ ಮತ್ತು ಇಚ್ಛಾಶಕ್ತಿಯ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಬಲವಾಗಿ ಕಂಡುಬರುತ್ತದೆ.",
    "Your action-taking energy appears balanced in this chart.": "ನಿಮ್ಮ ಕ್ರಿಯೆಯನ್ನು ತೆಗೆದುಕೊಳ್ಳುವ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಸಮತೋಲಿತವಾಗಿದೆ.",
    "Reflection on confidence, discipline, and decision power may be useful.": "ಆತ್ಮವಿಶ್ವಾಸ, ಶಿಸ್ತು ಮತ್ತು ನಿರ್ಧಾರದ ಶಕ್ತಿಯ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "Your connection and compassion energy appears strong in this chart.": "ನಿಮ್ಮ ಸಂಪರ್ಕ ಮತ್ತು ಸಹಾನುಭೂತಿಯ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಬಲವಾಗಿ ಗೋಚರಿಸುತ್ತದೆ.",
    "Your emotional connection energy appears balanced in this chart.": "ನಿಮ್ಮ ಭಾವನಾತ್ಮಕ ಸಂಪರ್ಕದ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಸಮತೋಲಿತವಾಗಿದೆ.",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "ಸಾಮರಸ್ಯ, ಕ್ಷಮೆ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಸಮತೋಲನದ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "Your communication and expression energy appears strong in this chart.": "ನಿಮ್ಮ ಸಂವಹನ ಮತ್ತು ಅಭಿವ್ಯಕ್ತಿ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಪ್ರಬಲವಾಗಿದೆ.",
    "Your expression energy appears balanced in this chart.": "ನಿಮ್ಮ ಅಭಿವ್ಯಕ್ತಿ ಶಕ್ತಿಯು ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಸಮತೋಲಿತವಾಗಿ ಗೋಚರಿಸುತ್ತದೆ.",
    "Reflection on clear communication and self-expression may be useful.": "ಸ್ಪಷ್ಟ ಸಂವಹನ ಮತ್ತು ಸ್ವಯಂ ಅಭಿವ್ಯಕ್ತಿಯ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "Your intuition and inner clarity appears strong in this chart.": "ನಿಮ್ಮ ಅಂತಃಪ್ರಜ್ಞೆ ಮತ್ತು ಆಂತರಿಕ ಸ್ಪಷ್ಟತೆ ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ಬಲವಾಗಿ ಕಾಣುತ್ತದೆ.",
    "Your intuitive clarity appears balanced in this chart.": "ಈ ಚಾರ್ಟ್‌ನಲ್ಲಿ ನಿಮ್ಮ ಅರ್ಥಗರ್ಭಿತ ಸ್ಪಷ್ಟತೆ ಸಮತೋಲಿತವಾಗಿ ಗೋಚರಿಸುತ್ತದೆ.",
    "Reflection on focus, intuition, and inner guidance may be useful.": "ಗಮನ, ಅಂತಃಪ್ರಜ್ಞೆ ಮತ್ತು ಆಂತರಿಕ ಮಾರ್ಗದರ್ಶನದ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "A strong Fire element supports action, courage, and leadership energy.": "ಬಲವಾದ ಬೆಂಕಿಯ ಅಂಶವು ಕ್ರಿಯೆ, ಧೈರ್ಯ ಮತ್ತು ನಾಯಕತ್ವದ ಶಕ್ತಿಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "ಬೆಂಕಿಯು ಸಮತೋಲಿತವಾಗಿ ಕಾಣುತ್ತದೆ, ಕ್ರಿಯೆ ಮತ್ತು ತಾಳ್ಮೆಯ ನಡುವೆ ಸ್ಥಿರವಾದ ಲಯವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Reflection on confidence and action-taking may be useful.": "ಆತ್ಮವಿಶ್ವಾಸ ಮತ್ತು ಕ್ರಿಯೆ-ತೆಗೆದುಕೊಳ್ಳುವಿಕೆಯ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "A strong Earth element supports practicality, patience, and stability.": "ಬಲವಾದ ಭೂಮಿಯ ಅಂಶವು ಪ್ರಾಯೋಗಿಕತೆ, ತಾಳ್ಮೆ ಮತ್ತು ಸ್ಥಿರತೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Earth appears balanced, supporting practical thinking with flexibility.": "ಭೂಮಿಯು ಸಮತೋಲಿತವಾಗಿ ಕಾಣುತ್ತದೆ, ನಮ್ಯತೆಯೊಂದಿಗೆ ಪ್ರಾಯೋಗಿಕ ಚಿಂತನೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Reflection on grounding, consistency, and planning may be useful.": "ಗ್ರೌಂಡಿಂಗ್, ಸ್ಥಿರತೆ ಮತ್ತು ಯೋಜನೆಗಳ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "A strong Air element supports ideas, communication, and adaptability.": "ಬಲವಾದ ಗಾಳಿಯ ಅಂಶವು ಕಲ್ಪನೆಗಳು, ಸಂವಹನ ಮತ್ತು ಹೊಂದಾಣಿಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Air appears balanced, supporting harmony between thinking and action.": "ಗಾಳಿಯು ಸಮತೋಲಿತವಾಗಿ ಕಾಣುತ್ತದೆ, ಆಲೋಚನೆ ಮತ್ತು ಕ್ರಿಯೆಯ ನಡುವೆ ಸಾಮರಸ್ಯವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Reflection on communication and flexibility may be useful.": "ಸಂವಹನ ಮತ್ತು ನಮ್ಯತೆಯ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "ಬಲವಾದ ನೀರಿನ ಅಂಶವು ಅಂತಃಪ್ರಜ್ಞೆ, ಸೂಕ್ಷ್ಮತೆ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಆಳವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Water appears balanced, supporting harmony between emotions and logic.": "ನೀರು ಸಮತೋಲಿತವಾಗಿ ಕಾಣುತ್ತದೆ, ಭಾವನೆಗಳು ಮತ್ತು ತರ್ಕದ ನಡುವೆ ಸಾಮರಸ್ಯವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Reflection on emotional expression and inner connection may be useful.": "ಭಾವನಾತ್ಮಕ ಅಭಿವ್ಯಕ್ತಿ ಮತ್ತು ಆಂತರಿಕ ಸಂಪರ್ಕದ ಪ್ರತಿಬಿಂಬವು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "A strong Ether element supports spiritual awareness and broader vision.": "ಬಲವಾದ ಈಥರ್ ಅಂಶವು ಆಧ್ಯಾತ್ಮಿಕ ಅರಿವು ಮತ್ತು ವಿಶಾಲ ದೃಷ್ಟಿಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ಈಥರ್ ಸಮತೋಲಿತವಾಗಿ ಕಾಣುತ್ತದೆ, ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ಪ್ರಾಯೋಗಿಕ ವಿಧಾನದ ನಡುವೆ ಸಾಮರಸ್ಯವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Reflection, silence, and spiritual discipline may be useful.": "ಪ್ರತಿಬಿಂಬ, ಮೌನ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಶಿಸ್ತು ಉಪಯುಕ್ತವಾಗಬಹುದು.",
    "For inner confidence, clarity, and soul strength.": "ಆಂತರಿಕ ಆತ್ಮವಿಶ್ವಾಸ, ಸ್ಪಷ್ಟತೆ ಮತ್ತು ಆತ್ಮ ಶಕ್ತಿಗಾಗಿ.",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "ಈ ಇಷ್ಟ ದೇವತಾ ಸೂಚನೆಯು ಜನ್ಮ ಕುಂಡಲಿಯಿಂದ ಗ್ರಹಗಳ ಬಲ, ಲಗ್ನ ಅಧಿಪತಿ, ಚಂದ್ರನ ರಾಶಿಯ ಅಧಿಪತಿ ಮತ್ತು ಆತ್ಮಕಾರಕವನ್ನು ಆಧರಿಸಿದೆ.",
    "For calmness, emotional balance, and softness.": "ಶಾಂತತೆ, ಭಾವನಾತ್ಮಕ ಸಮತೋಲನ ಮತ್ತು ಮೃದುತ್ವಕ್ಕಾಗಿ.",
    "For courage, protection, and discipline.": "ಧೈರ್ಯ, ರಕ್ಷಣೆ ಮತ್ತು ಶಿಸ್ತುಗಾಗಿ.",
    "For intellect, speech, learning, and obstacle removal.": "ಬುದ್ಧಿಶಕ್ತಿ, ಮಾತು, ಕಲಿಕೆ ಮತ್ತು ಅಡೆತಡೆ ನಿವಾರಣೆಗೆ.",
    "For knowledge, guidance, dharma, and blessings.": "ಜ್ಞಾನ, ಮಾರ್ಗದರ್ಶನ, ಧರ್ಮ ಮತ್ತು ಆಶೀರ್ವಾದಕ್ಕಾಗಿ.",
    "Mahalakshmi Ji": "ಮಹಾಲಕ್ಷ್ಮಿ ಜಿ",
    "For harmony, beauty, comfort, and prosperity.": "ಸಾಮರಸ್ಯ, ಸೌಂದರ್ಯ, ಸೌಕರ್ಯ ಮತ್ತು ಸಮೃದ್ಧಿಗಾಗಿ.",
    "For karma, patience, discipline, and protection.": "ಕರ್ಮ, ತಾಳ್ಮೆ, ಶಿಸ್ತು ಮತ್ತು ರಕ್ಷಣೆಗಾಗಿ.",
    "For protection from confusion, fear, and illusion.": "ಗೊಂದಲ, ಭಯ ಮತ್ತು ಭ್ರಮೆಯಿಂದ ರಕ್ಷಣೆಗಾಗಿ.",
    "Lord Ganesha": "ಭಗವಾನ್ ಗಣೇಶ",
    "For spiritual clarity, detachment, and obstacle removal.": "ಆಧ್ಯಾತ್ಮಿಕ ಸ್ಪಷ್ಟತೆ, ಬೇರ್ಪಡುವಿಕೆ ಮತ್ತು ಅಡಚಣೆ ನಿವಾರಣೆಗಾಗಿ.",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "ಚಕ್ರ ಒಳನೋಟಕ್ಕಾಗಿ ಚಾರ್ಟ್ ಡೇಟಾ ಅಗತ್ಯವಿದೆ.",
    "Unable to load Chakra insight.": "ಚಕ್ರ ಒಳನೋಟವನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "ಯಹ ಕೇವಲ ಜನ್ಮ ಕುಂಡಲಿ ಆಧಾರಿತ ಆಧ್ಯಾತ್ಮಿಕ ಶಕ್ತಿಯ ಒಳನೋಟ ಮತ್ತು ಆತ್ಮಾವಲೋಕನವನ್ನು ಹೊಂದಿದೆ. ಇಹ ವೃತ್ತಿಪರ ಸಲಹೆ ಇಲ್ಲ.",
    "Spiritual energy insights from Kundli": "ಕುಂಡ್ಲಿಯಿಂದ ಆಧ್ಯಾತ್ಮಿಕ ಶಕ್ತಿಯ ಒಳನೋಟಗಳು",
    "Calculated from your individual birth chart": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಜನ್ಮ ಚಾರ್ಟ್ನಿಂದ ಲೆಕ್ಕಹಾಕಲಾಗಿದೆ",
    "Chakra Balance": "ಚಕ್ರ ಸಮತೋಲನ",
    "Panch Tatva Balance": "ಪಂಚ ತತ್ವ ಸಮತೋಲನ",
    "Ishta Devata": "ಇಷ್ಟ ದೇವತಾ",
    "Signal planet": "ಸಿಗ್ನಲ್ ಗ್ರಹ",
    "Very Good": "ತುಂಬಾ ಚೆನ್ನಾಗಿದೆ",
    "Very Bad": "ತುಂಬಾ ಕೆಟ್ಟದು",
    "Panch Pakshi Calculator - Kundlistar": "ಪಂಚ ಪಕ್ಷಿ ಕ್ಯಾಲ್ಕುಲೇಟರ್ - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "ಚಾರ್ಟ್‌ನಿಂದ ಪಂಚ ಪಕ್ಷಿಯನ್ನು ಪೂರ್ವಭರ್ತಿ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ನೀವು ಇನ್ನೂ ಹಸ್ತಚಾಲಿತವಾಗಿ ಲೆಕ್ಕ ಹಾಕಬಹುದು.",
    "Could not load sunrise and sunset from Panchang for this chart location.": "ಈ ಚಾರ್ಟ್ ಸ್ಥಾನಕ್ಕಾಗಿ ಪಂಚಾಂಗದಿಂದ ಸೂರ್ಯೋದಯ ಮತ್ತು ಸೂರ್ಯಾಸ್ತವನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "ಪಂಚಾಂಗದಿಂದ ಸೂರ್ಯೋದಯ, ಸೂರ್ಯಾಸ್ತ ಮತ್ತು ಮುಂದಿನ ಸೂರ್ಯೋದಯವನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ.",
    "Panch Pakshi calculation failed.": "ಪಂಚ ಪಕ್ಷಿ ಲೆಕ್ಕಾಚಾರ ವಿಫಲವಾಗಿದೆ.",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "ಪಂಚ ಪಕ್ಷಿ ಪಕ್ಷಿ, ಚಟುವಟಿಕೆ, ಯಮ, ಅಪಹಾರ ಅವಧಿ, ಸಂಬಂಧ, ಅಂಕ ಮತ್ತು ಫಲಿತಾಂಶವನ್ನು ಲೆಕ್ಕ ಹಾಕಿ.",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "ನಿಮ್ಮ ಉಚಿತ ಪ್ರೀಮಿಯಂ ಕ್ರೆಡಿಟ್‌ಗಳು ಮುಗಿದಿವೆ. ಮುಂದುವರಿಯಲು Premium ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
    "This is a premium feature. You can use 1 free premium credit to continue.": "ಇದು ಪ್ರೀಮಿಯಂ ವೈಶಿಷ್ಟ್ಯವಾಗಿದೆ. ಮುಂದುವರಿಸಲು ನೀವು 1 ಉಚಿತ ಪ್ರೀಮಿಯಂ ಕ್ರೆಡಿಟ್ ಅನ್ನು ಬಳಸಬಹುದು.",
    "Selected Date": "ಆಯ್ಕೆಮಾಡಿದ ದಿನಾಂಕ",
    "repeat(3, 1fr)": "ಪುನರಾವರ್ತಿಸಿ (3, 1fr)",
    "Birth Paksha": "ಜನ್ಮ ಪಕ್ಷ",
    "Current Paksha": "ಪ್ರಸ್ತುತ ಪಕ್ಷ",
    "repeat(4, 1fr)": "ಪುನರಾವರ್ತಿಸಿ (4, 1fr)",
    "Target Date Time": "ಗುರಿ ದಿನಾಂಕ ಸಮಯ",
    "Next Sunrise": "ಮುಂದಿನ ಸೂರ್ಯೋದಯ",
    "Calculate Panch Pakshi": "ಪಂಚ ಪಕ್ಷಿಯನ್ನು ಲೆಕ್ಕ ಹಾಕಿ",
    "repeat(2, 1fr)": "ಪುನರಾವರ್ತಿಸಿ (2, 1fr)",
    "repeat(6, 1fr)": "ಪುನರಾವರ್ತಿಸಿ (6, 1fr)",
    "Birth Pakshi": "ಜನ್ಮ ಪಕ್ಷಿ",
    "Current Period": "ಪ್ರಸ್ತುತ ಅವಧಿ",
    "Current Yamam": "ಪ್ರಸ್ತುತ ಯಮಮ್",
    "Main Activity": "ಮುಖ್ಯ ಚಟುವಟಿಕೆ",
    "Natal Western Chart": "ನಟಾಲ್ ವೆಸ್ಟರ್ನ್ ಚಾರ್ಟ್",
    "Life Phase Progression": "ಜೀವನದ ಹಂತದ ಪ್ರಗತಿ",
    "Self-focus, identity change, body awareness and personal reset.": "ಸ್ವಯಂ-ಕೇಂದ್ರಿತ, ಗುರುತಿನ ಬದಲಾವಣೆ, ದೇಹದ ಅರಿವು ಮತ್ತು ವೈಯಕ್ತಿಕ ಮರುಹೊಂದಿಸುವಿಕೆ.",
    "Money, values, family, speech and security become emotionally important.": "ಹಣ, ಮೌಲ್ಯಗಳು, ಕುಟುಂಬ, ಮಾತು ಮತ್ತು ಭದ್ರತೆ ಭಾವನಾತ್ಮಕವಾಗಿ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Communication, learning, siblings, writing and short travel become important.": "ಸಂವಹನ, ಕಲಿಕೆ, ಒಡಹುಟ್ಟಿದವರು, ಬರವಣಿಗೆ ಮತ್ತು ಸಣ್ಣ ಪ್ರಯಾಣ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Home, mother, property, family and emotional roots become important.": "ಮನೆ, ತಾಯಿ, ಆಸ್ತಿ, ಕುಟುಂಬ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಬೇರುಗಳು ಮುಖ್ಯವಾಗುತ್ತವೆ.",
    "Creativity, romance, children, hobbies and self-expression become important.": "ಸೃಜನಶೀಲತೆ, ಪ್ರಣಯ, ಮಕ್ಕಳು, ಹವ್ಯಾಸಗಳು ಮತ್ತು ಸ್ವಯಂ ಅಭಿವ್ಯಕ್ತಿ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Work routine, health habits, service and discipline become important.": "ಕೆಲಸದ ದಿನಚರಿ, ಆರೋಗ್ಯ ಪದ್ಧತಿ, ಸೇವೆ ಮತ್ತು ಶಿಸ್ತು ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Relationship, marriage, partnership and public dealing become important.": "ಸಂಬಂಧ, ಮದುವೆ, ಪಾಲುದಾರಿಕೆ ಮತ್ತು ಸಾರ್ವಜನಿಕ ವ್ಯವಹಾರಗಳು ಮುಖ್ಯವಾಗುತ್ತವೆ.",
    "Deep emotional change, intimacy, shared money and transformation become important.": "ಆಳವಾದ ಭಾವನಾತ್ಮಕ ಬದಲಾವಣೆ, ಅನ್ಯೋನ್ಯತೆ, ಹಂಚಿಕೆಯ ಹಣ ಮತ್ತು ರೂಪಾಂತರವು ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Learning, travel, teaching, belief and higher wisdom become important.": "ಕಲಿಕೆ, ಪ್ರಯಾಣ, ಬೋಧನೆ, ನಂಬಿಕೆ ಮತ್ತು ಉನ್ನತ ಬುದ್ಧಿವಂತಿಕೆ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Career, status, public image and responsibility become emotionally important.": "ವೃತ್ತಿ, ಸ್ಥಾನಮಾನ, ಸಾರ್ವಜನಿಕ ಚಿತ್ರಣ ಮತ್ತು ಜವಾಬ್ದಾರಿ ಭಾವನಾತ್ಮಕವಾಗಿ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Income, friends, networking, community and ambitions become important.": "ಆದಾಯ, ಸ್ನೇಹಿತರು, ನೆಟ್‌ವರ್ಕಿಂಗ್, ಸಮುದಾಯ ಮತ್ತು ಮಹತ್ವಾಕಾಂಕ್ಷೆಗಳು ಮುಖ್ಯವಾಗುತ್ತವೆ.",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "ವಿಶ್ರಾಂತಿ, ಪ್ರತ್ಯೇಕತೆ, ಆಧ್ಯಾತ್ಮಿಕತೆ, ವಿದೇಶಿ ಸಂಪರ್ಕ ಮತ್ತು ಆಂತರಿಕ ಚಿಕಿತ್ಸೆ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Identity development and self-expression are central.": "ಗುರುತಿನ ಅಭಿವೃದ್ಧಿ ಮತ್ತು ಸ್ವಯಂ ಅಭಿವ್ಯಕ್ತಿ ಕೇಂದ್ರವಾಗಿದೆ.",
    "Values, money and self-worth become central.": "ಮೌಲ್ಯಗಳು, ಹಣ ಮತ್ತು ಸ್ವ-ಮೌಲ್ಯಗಳು ಕೇಂದ್ರವಾಗುತ್ತವೆ.",
    "Communication, learning and skills become central.": "ಸಂವಹನ, ಕಲಿಕೆ ಮತ್ತು ಕೌಶಲ್ಯಗಳು ಕೇಂದ್ರವಾಗುತ್ತವೆ.",
    "Home, roots and emotional foundation become central.": "ಮನೆ, ಬೇರುಗಳು ಮತ್ತು ಭಾವನಾತ್ಮಕ ಅಡಿಪಾಯಗಳು ಕೇಂದ್ರವಾಗುತ್ತವೆ.",
    "Creativity, love and self-expression become central.": "ಸೃಜನಶೀಲತೆ, ಪ್ರೀತಿ ಮತ್ತು ಸ್ವಯಂ ಅಭಿವ್ಯಕ್ತಿ ಕೇಂದ್ರವಾಗುತ್ತದೆ.",
    "Work, discipline and health routines become central.": "ಕೆಲಸ, ಶಿಸ್ತು ಮತ್ತು ಆರೋಗ್ಯ ದಿನಚರಿಗಳು ಕೇಂದ್ರವಾಗುತ್ತವೆ.",
    "Partnerships and relationship identity become central.": "ಪಾಲುದಾರಿಕೆಗಳು ಮತ್ತು ಸಂಬಂಧದ ಗುರುತು ಕೇಂದ್ರವಾಗುತ್ತದೆ.",
    "Transformation, deep healing and shared resources become central.": "ರೂಪಾಂತರ, ಆಳವಾದ ಚಿಕಿತ್ಸೆ ಮತ್ತು ಹಂಚಿಕೆಯ ಸಂಪನ್ಮೂಲಗಳು ಕೇಂದ್ರವಾಗುತ್ತವೆ.",
    "Wisdom, travel, belief and higher learning become central.": "ಬುದ್ಧಿವಂತಿಕೆ, ಪ್ರಯಾಣ, ನಂಬಿಕೆ ಮತ್ತು ಉನ್ನತ ಕಲಿಕೆ ಕೇಂದ್ರವಾಗುತ್ತದೆ.",
    "Career, authority and public role become central.": "ವೃತ್ತಿ, ಅಧಿಕಾರ ಮತ್ತು ಸಾರ್ವಜನಿಕ ಪಾತ್ರವು ಕೇಂದ್ರವಾಗುತ್ತದೆ.",
    "Community, income, goals and networks become central.": "ಸಮುದಾಯ, ಆದಾಯ, ಗುರಿಗಳು ಮತ್ತು ನೆಟ್‌ವರ್ಕ್‌ಗಳು ಕೇಂದ್ರವಾಗುತ್ತವೆ.",
    "Spirituality, closure, retreat and inner development become central.": "ಆಧ್ಯಾತ್ಮಿಕತೆ, ಮುಚ್ಚುವಿಕೆ, ಹಿಮ್ಮೆಟ್ಟುವಿಕೆ ಮತ್ತು ಆಂತರಿಕ ಅಭಿವೃದ್ಧಿ ಕೇಂದ್ರವಾಗುತ್ತದೆ.",
    "This house becomes emotionally important.": "ಈ ಮನೆ ಭಾವನಾತ್ಮಕವಾಗಿ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "This house becomes central for identity development.": "ಈ ಮನೆ ಗುರುತಿನ ಅಭಿವೃದ್ಧಿಗೆ ಕೇಂದ್ರವಾಗುತ್ತದೆ.",
    "Thinking, communication, learning and decisions are developing through this house.": "ಈ ಮನೆಯ ಮೂಲಕ ಚಿಂತನೆ, ಸಂವಹನ, ಕಲಿಕೆ ಮತ್ತು ನಿರ್ಧಾರಗಳು ಅಭಿವೃದ್ಧಿಗೊಳ್ಳುತ್ತಿವೆ.",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "ಈ ಮನೆಯ ಮೂಲಕ ಪ್ರೀತಿ, ಸೌಕರ್ಯ, ಮೌಲ್ಯಗಳು, ಸೌಂದರ್ಯ ಮತ್ತು ಹಣದ ಆದ್ಯತೆಗಳು ಬೆಳೆಯುತ್ತಿವೆ.",
    "Action style, courage, ambition and drive are developing through this house.": "ಈ ಮನೆಯ ಮೂಲಕ ಆಕ್ಷನ್ ಶೈಲಿ, ಧೈರ್ಯ, ಮಹತ್ವಾಕಾಂಕ್ಷೆ ಮತ್ತು ಡ್ರೈವ್ ಅಭಿವೃದ್ಧಿಗೊಳ್ಳುತ್ತಿದೆ.",
    "Growth, faith, learning and expansion themes develop through this house.": "ಬೆಳವಣಿಗೆ, ನಂಬಿಕೆ, ಕಲಿಕೆ ಮತ್ತು ವಿಸ್ತರಣೆ ವಿಷಯಗಳು ಈ ಮನೆಯ ಮೂಲಕ ಅಭಿವೃದ್ಧಿಗೊಳ್ಳುತ್ತವೆ.",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "ಪ್ರಬುದ್ಧತೆ, ಜವಾಬ್ದಾರಿ, ಶಿಸ್ತು ಮತ್ತು ದೀರ್ಘಾವಧಿಯ ರಚನೆಯು ಈ ಮನೆಯ ಮೂಲಕ ಅಭಿವೃದ್ಧಿಗೊಳ್ಳುತ್ತದೆ.",
    "This progressed planet shows an inner life phase through this house.": "ಈ ಪ್ರಗತಿ ಹೊಂದಿದ ಗ್ರಹವು ಈ ಮನೆಯ ಮೂಲಕ ಆಂತರಿಕ ಜೀವನದ ಹಂತವನ್ನು ತೋರಿಸುತ್ತದೆ.",
    "New Moon Phase": "ಅಮಾವಾಸ್ಯೆಯ ಹಂತ",
    "New beginning, identity reset and fresh internal cycle.": "ಹೊಸ ಆರಂಭ, ಗುರುತಿನ ಮರುಹೊಂದಿಕೆ ಮತ್ತು ತಾಜಾ ಆಂತರಿಕ ಚಕ್ರ.",
    "Crescent Phase": "ಕ್ರೆಸೆಂಟ್ ಹಂತ",
    "Growth, effort, learning and building confidence.": "ಬೆಳವಣಿಗೆ, ಪ್ರಯತ್ನ, ಕಲಿಕೆ ಮತ್ತು ಆತ್ಮವಿಶ್ವಾಸವನ್ನು ಬೆಳೆಸುವುದು.",
    "First Quarter Phase": "ಮೊದಲ ತ್ರೈಮಾಸಿಕ ಹಂತ",
    "Action, decision-making, pressure and development.": "ಕ್ರಿಯೆ, ನಿರ್ಧಾರ ತೆಗೆದುಕೊಳ್ಳುವಿಕೆ, ಒತ್ತಡ ಮತ್ತು ಅಭಿವೃದ್ಧಿ.",
    "Gibbous Phase": "ಗಿಬ್ಬಸ್ ಹಂತ",
    "Refinement, improvement, preparation and skill-building.": "ಪರಿಷ್ಕರಣೆ, ಸುಧಾರಣೆ, ತಯಾರಿ ಮತ್ತು ಕೌಶಲ್ಯ-ನಿರ್ಮಾಣ.",
    "Full Moon Phase": "ಹುಣ್ಣಿಮೆಯ ಹಂತ",
    "Visibility, relationship awareness, emotional clarity and results.": "ಗೋಚರತೆ, ಸಂಬಂಧದ ಅರಿವು, ಭಾವನಾತ್ಮಕ ಸ್ಪಷ್ಟತೆ ಮತ್ತು ಫಲಿತಾಂಶಗಳು.",
    "Disseminating Phase": "ಪ್ರಸರಣ ಹಂತ",
    "Sharing, teaching, communication and distributing experience.": "ಹಂಚಿಕೆ, ಬೋಧನೆ, ಸಂವಹನ ಮತ್ತು ಅನುಭವವನ್ನು ವಿತರಿಸುವುದು.",
    "Last Quarter Phase": "ಕೊನೆಯ ತ್ರೈಮಾಸಿಕ ಹಂತ",
    "Reorientation, correction, release and mature decision-making.": "ಮರುನಿರ್ದೇಶನ, ತಿದ್ದುಪಡಿ, ಬಿಡುಗಡೆ ಮತ್ತು ಪ್ರಬುದ್ಧ ನಿರ್ಧಾರ ತೆಗೆದುಕೊಳ್ಳುವಿಕೆ.",
    "Balsamic Phase": "ಬಾಲ್ಸಾಮಿಕ್ ಹಂತ",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "ಮುಚ್ಚುವಿಕೆ, ಆಧ್ಯಾತ್ಮಿಕ ಪ್ರತಿಬಿಂಬ, ವಿಶ್ರಾಂತಿ ಮತ್ತು ಹೊಸ ಚಕ್ರಕ್ಕೆ ತಯಾರಿ.",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "ಪ್ರಮುಖ ಭಾವನಾತ್ಮಕ ಮತ್ತು ಗುರುತಿನ ಹಂತವು ಪ್ರಾರಂಭವಾಗುತ್ತದೆ. ವ್ಯಕ್ತಿಯು ಹೊಸ ಅಧ್ಯಾಯಕ್ಕೆ ಸಿದ್ಧನಾಗಬಹುದು.",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "ಭಾವನಾತ್ಮಕ ಮರುಹೊಂದಿಸುವ ಅವಧಿ. ಕುಟುಂಬ, ಸೌಕರ್ಯ, ಆಂತರಿಕ ಶಾಂತಿ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಅಗತ್ಯಗಳು ಮುಖ್ಯವಾಗುತ್ತವೆ.",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "ಪ್ರೀತಿ, ಸಂಬಂಧ, ಸೌಕರ್ಯ, ಸೌಂದರ್ಯ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಬಂಧ ಮುಖ್ಯವಾಗುತ್ತದೆ.",
    "Emotional needs and relationship expectations may need adjustment.": "ಭಾವನಾತ್ಮಕ ಅಗತ್ಯಗಳು ಮತ್ತು ಸಂಬಂಧದ ನಿರೀಕ್ಷೆಗಳಿಗೆ ಹೊಂದಾಣಿಕೆ ಅಗತ್ಯವಿರಬಹುದು.",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "ಶಕ್ತಿ, ಉತ್ಸಾಹ, ಅಸಹನೆ ಮತ್ತು ಕ್ರಿಯೆ ಹೆಚ್ಚಾಗುತ್ತದೆ. ಭಾವನಾತ್ಮಕ ಪ್ರತಿಕ್ರಿಯೆಗಳು ತ್ವರಿತವಾಗಬಹುದು.",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "ಭಾವನಾತ್ಮಕ ಚಡಪಡಿಕೆ, ಕೋಪ, ಸಂಘರ್ಷ ಅಥವಾ ತುರ್ತು ಕ್ರಮಗಳು ಹೆಚ್ಚಾಗಬಹುದು.",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "ಗಂಭೀರ ಭಾವನಾತ್ಮಕ ಹಂತ. ಜವಾಬ್ದಾರಿ, ಪ್ರಬುದ್ಧತೆ, ಕುಟುಂಬದ ಒತ್ತಡ ಅಥವಾ ಆಂತರಿಕ ಶಿಸ್ತು ಹೆಚ್ಚಾಗಬಹುದು.",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "ಭಾವನಾತ್ಮಕ ಭಾರ ಅಥವಾ ಜವಾಬ್ದಾರಿಯನ್ನು ಅನುಭವಿಸಬಹುದು. ತಾಳ್ಮೆ ಮತ್ತು ಪ್ರಬುದ್ಧತೆ ಅಗತ್ಯವಿದೆ.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "ಬೆಂಬಲ ಭಾವನಾತ್ಮಕ ಬೆಳವಣಿಗೆ, ಆಶಾವಾದ, ಪ್ರಯಾಣ, ಕಲಿಕೆ ಮತ್ತು ಆಶೀರ್ವಾದಗಳು ಹೆಚ್ಚಾಗಬಹುದು.",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "ಬೆಳವಣಿಗೆ-ಆಧಾರಿತ ಭಾವನಾತ್ಮಕ ಹಂತ. ಕಲಿಕೆ, ವಿಸ್ತರಣೆ, ಬೆಂಬಲ ಮತ್ತು ಸಕಾರಾತ್ಮಕ ನಿರ್ಧಾರಗಳಿಗೆ ಒಳ್ಳೆಯದು.",
    "Identity, love, beauty, money values and creative expression become highlighted.": "ಗುರುತು, ಪ್ರೀತಿ, ಸೌಂದರ್ಯ, ಹಣದ ಮೌಲ್ಯಗಳು ಮತ್ತು ಸೃಜನಶೀಲ ಅಭಿವ್ಯಕ್ತಿ ಹೈಲೈಟ್ ಆಗುತ್ತವೆ.",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "ಆತ್ಮವಿಶ್ವಾಸ, ಧೈರ್ಯ, ಮಹತ್ವಾಕಾಂಕ್ಷೆ ಮತ್ತು ಕಾರ್ಯವು ಹೆಚ್ಚಾಗುತ್ತದೆ. ಹೊಸ ಸಕ್ರಿಯ ಹಂತವನ್ನು ಪ್ರಾರಂಭಿಸಲು ಒಳ್ಳೆಯದು.",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "ಪ್ರಬುದ್ಧತೆಯ ಪರೀಕ್ಷೆ. ಜವಾಬ್ದಾರಿ, ವಿಳಂಬ, ಒತ್ತಡ ಅಥವಾ ವೃತ್ತಿ ಪುನರ್ರಚನೆ ಸಂಭವಿಸಬಹುದು.",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "ಬೆಳವಣಿಗೆ, ಆತ್ಮವಿಶ್ವಾಸ, ಬುದ್ಧಿವಂತಿಕೆ, ಗುರುತಿಸುವಿಕೆ ಮತ್ತು ಅವಕಾಶವನ್ನು ಹೆಚ್ಚಿಸಬಹುದು.",
    "Mental clarity, communication, study, writing and business decisions become important.": "ಮಾನಸಿಕ ಸ್ಪಷ್ಟತೆ, ಸಂವಹನ, ಅಧ್ಯಯನ, ಬರವಣಿಗೆ ಮತ್ತು ವ್ಯವಹಾರ ನಿರ್ಧಾರಗಳು ಮುಖ್ಯವಾಗುತ್ತವೆ.",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "ಹೊಸ ಮಾನಸಿಕ ಚಕ್ರ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ. ಕಲಿಕೆ, ಸಂವಹನ, ಬರವಣಿಗೆ ಮತ್ತು ಕೌಶಲ್ಯ ಅಭಿವೃದ್ಧಿಗೆ ಒಳ್ಳೆಯದು.",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "ಪ್ರೀತಿ, ಸೌಂದರ್ಯ, ಸೌಕರ್ಯ, ಸಾಮಾಜಿಕ ಜೀವನ ಮತ್ತು ಮೌಲ್ಯಗಳು ಗುರುತಿನೊಂದಿಗೆ ಬಲವಾಗಿ ಸಂಪರ್ಕ ಹೊಂದಿವೆ.",
    "Action, confidence, ambition and personal drive become stronger.": "ಕ್ರಿಯೆ, ವಿಶ್ವಾಸ, ಮಹತ್ವಾಕಾಂಕ್ಷೆ ಮತ್ತು ವೈಯಕ್ತಿಕ ಡ್ರೈವ್ ಬಲಗೊಳ್ಳುತ್ತದೆ.",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "ಪ್ರಗತಿಶೀಲ ಬುಧವು ಕಲಿಕೆ, ಸಂವಹನ, ವ್ಯಾಪಾರ, ಬರವಣಿಗೆ, ಮಾರ್ಕೆಟಿಂಗ್, ಕೋಡಿಂಗ್ ಅಥವಾ ವಿಶ್ಲೇಷಣಾತ್ಮಕ ಕೆಲಸವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "ಪ್ರಗತಿಶೀಲ ಮಂಗಳವು ಕ್ರಿಯೆ, ಧೈರ್ಯ, ಸ್ಪರ್ಧೆ, ತಾಂತ್ರಿಕ ಕೆಲಸ ಮತ್ತು ಸಕ್ರಿಯ ವೃತ್ತಿ ನಿರ್ಧಾರಗಳನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "ಪ್ರಗತಿ ಹೊಂದಿದ ಶುಕ್ರವು ಆರ್ಥಿಕ ಮೌಲ್ಯಗಳು, ಸೌಕರ್ಯ, ಲಾಭಗಳು, ಐಷಾರಾಮಿ, ಕಲೆ ಅಥವಾ ಸಂಬಂಧ ಆಧಾರಿತ ಆದಾಯದ ವಿಷಯಗಳನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "ಪ್ರಗತಿ ಹೊಂದಿದ ಗುರುವು ಬೆಳವಣಿಗೆ-ಆಧಾರಿತ ಆರ್ಥಿಕ ಚಿಂತನೆ ಮತ್ತು ಸಂಪನ್ಮೂಲಗಳ ವಿಸ್ತರಣೆಯನ್ನು ತೋರಿಸಬಹುದು.",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "ವೃತ್ತಿಜೀವನದ ಹಂತವನ್ನು ಪ್ರಗತಿಯಲ್ಲಿರುವ ಸೂರ್ಯ, ಚಂದ್ರ, ಬುಧ, ಮಂಗಳ ಮತ್ತು ಜನ್ಮ ಸೂರ್ಯ, ಶನಿ ಮತ್ತು ಮಧ್ಯ ಸ್ವರ್ಗದ ಅಂಶಗಳಿಂದ ನಿರ್ಣಯಿಸಬೇಕು.",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "ಪ್ರೇಮ ಹಂತವನ್ನು ಪ್ರಗತಿಯಲ್ಲಿರುವ ಚಂದ್ರ, ಶುಕ್ರ, ಮಂಗಳ ಮತ್ತು ಜನ್ಮ ಚಂದ್ರ, ಶುಕ್ರ, ಮಂಗಳ ಮತ್ತು 7 ನೇ ಮನೆಯ ಅಂಶಗಳಿಂದ ನಿರ್ಣಯಿಸಬೇಕು.",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "ಪ್ರಗತಿ ಹೊಂದಿದ ಚಂದ್ರ, ಶುಕ್ರ, ಗುರು ಮತ್ತು ಜನ್ಮ 2, 8 ಮತ್ತು 11 ನೇ ಮನೆ ಸಂಪರ್ಕಗಳಿಂದ ಹಣದ ಹಂತವನ್ನು ನಿರ್ಣಯಿಸಬೇಕು.",
    "Western Astrology - Kundlistar": "ಪಾಶ್ಚಾತ್ಯ ಜ್ಯೋತಿಷ್ಯ - Kundlistar",
    "No chart data available for preview": "ಪೂರ್ವವೀಕ್ಷಣೆಗಾಗಿ ಯಾವುದೇ ಚಾರ್ಟ್ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
    "Failed to load chart": "ಚಾರ್ಟ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "Chart not found": "ಚಾರ್ಟ್ ಕಂಡುಬಂದಿಲ್ಲ",
    "Western Astrology Module | Kundlistar": "ಪಾಶ್ಚಾತ್ಯ ಜ್ಯೋತಿಷ್ಯ ಮಾಡ್ಯೂಲ್ | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "ನೇಟಲ್ ಚಾರ್ಟ್ ಸ್ಥಾನಗಳು, ಪ್ಲ್ಯಾಸಿಡಸ್ ಹೌಸ್ ಕಸ್ಪ್ಸ್, ಬಾಹ್ಯ ಗ್ರಹಗಳು ಮತ್ತು ಪ್ರೀಮಿಯಂ ಟ್ರಾನ್ಸಿಟ್‌ಗಳು, ಸೋಲಾರ್ ರಿಟರ್ನ್ ಮತ್ತು ಸಿನಾಸ್ಟ್ರಿ ವೈಶಿಷ್ಟ್ಯಗಳೊಂದಿಗೆ Kundlistar ಒಳಗೆ ಪಾಶ್ಚಾತ್ಯ ಜ್ಯೋತಿಷ್ಯವನ್ನು ಅನ್ವೇಷಿಸಿ.",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "ಪಾಶ್ಚಾತ್ಯ ಜ್ಯೋತಿಷ್ಯ, ಜನ್ಮಜಾತ ಚಾರ್ಟ್, ಟ್ರಾನ್ಸಿಟ್ಸ್, ಸೌರ ರಿಟರ್ನ್, ಸಿನಾಸ್ಟ್ರಿ, Kundlistar",
    "New section": "ಹೊಸ ವಿಭಾಗ",
    "Premium active": "ಪ್ರೀಮಿಯಂ ಸಕ್ರಿಯವಾಗಿದೆ",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "ಮನೆ ವ್ಯವಸ್ಥೆ",
    "Placidus cusps": "ಪ್ಲಾಸಿಡಸ್ ಕಸ್ಪ್ಸ್",
    "Part of Fortune": "ಫಾರ್ಚೂನ್ ಭಾಗ",
    "Natal Western Aspects": "ನಟಾಲ್ ವೆಸ್ಟರ್ನ್ ಆಸ್ಪೆಕ್ಟ್ಸ್",
    "No major Western aspects found within the configured orbs.": "ಕಾನ್ಫಿಗರ್ ಮಾಡಿದ ಆರ್ಬ್ಸ್‌ನಲ್ಲಿ ಯಾವುದೇ ಪ್ರಮುಖ ಪಾಶ್ಚಾತ್ಯ ಅಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "Western natal astrology wheel": "ಪಾಶ್ಚಾತ್ಯ ಜನ್ಮ ಜ್ಯೋತಿಷ್ಯ ಚಕ್ರ",
    "Western Transits": "ಪಶ್ಚಿಮ ಸಾರಿಗೆಗಳು",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "ಲೋಡ್ ಮಾಡಲಾದ ಚಾರ್ಟ್ ಜನ್ಮಸ್ಥಳವನ್ನು ಬಳಸಿಕೊಂಡು ಪ್ರಸ್ತುತ ಸಾಗಣೆಯಿಂದ ಪ್ರಸವದ ಲೆಕ್ಕಾಚಾರಗಳು.",
    "Natal points available": "ನಟಾಲ್ ಪಾಯಿಂಟ್‌ಗಳು ಲಭ್ಯವಿದೆ",
    "Transit planets loaded": "ಸಾರಿಗೆ ಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
    "Loading current transit positions...": "ಪ್ರಸ್ತುತ ಸಾರಿಗೆ ಸ್ಥಾನಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Aspect method": "ಆಸ್ಪೆಕ್ಟ್ ವಿಧಾನ",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "ಪಾಶ್ಚಾತ್ಯ ಗೋಳಗಳೊಂದಿಗೆ ಸಂಯೋಗ, ಸೆಕ್ಸ್ಟೈಲ್, ಚದರ, ತ್ರಿಕೋನ ಮತ್ತು ವಿರೋಧ",
    "Primary focus": "ಪ್ರಾಥಮಿಕ ಗಮನ",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "ಜನನ ಸೂರ್ಯ, ಚಂದ್ರ, ಆರೋಹಣ, ಶುಕ್ರ, ಮಂಗಳ, ಗುರು, ಶನಿ ಮತ್ತು ಹೊರಗಿನ ಗ್ರಹಗಳಿಗೆ ಸಾರಿಗೆ ಸಂಪರ್ಕಗಳು",
    "Natal inner wheel": "ನಟಾಲ್ ಒಳ ಚಕ್ರ",
    "Transit outer wheel": "ಟ್ರಾನ್ಸಿಟ್ ಹೊರಗಿನ ಚಕ್ರ",
    "Current Transit Positions": "ಪ್ರಸ್ತುತ ಸಾರಿಗೆ ಸ್ಥಾನಗಳು",
    "Transit positions are not available.": "ಸಾರಿಗೆ ಸ್ಥಾನಗಳು ಲಭ್ಯವಿಲ್ಲ.",
    "Current Transit Aspects to Natal Chart": "ನಟಾಲ್ ಚಾರ್ಟ್‌ಗೆ ಪ್ರಸ್ತುತ ಸಾರಿಗೆ ಅಂಶಗಳು",
    "Loading transit aspects...": "ಸಾರಿಗೆ ಅಂಶಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "No major transit aspects found within the configured orbs.": "ಕಾನ್ಫಿಗರ್ ಮಾಡಿದ ಆರ್ಬ್ಸ್‌ನಲ್ಲಿ ಯಾವುದೇ ಪ್ರಮುಖ ಸಾರಿಗೆ ಅಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "ಪ್ರಸವ ಸೂರ್ಯನಿಂದ ವಾರ್ಷಿಕ ಪಾಶ್ಚಾತ್ಯ ರಿಟರ್ನ್ ಉಲ್ಲೇಖ, ಜನ್ಮಜಾತ ಅಂಶದ ಸಂದರ್ಭವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Solar return date": "ಸೌರ ವಾಪಸಾತಿ ದಿನಾಂಕ",
    "Calculation time": "ಲೆಕ್ಕಾಚಾರದ ಸಮಯ",
    "Birth date not available": "ಜನ್ಮ ದಿನಾಂಕ ಲಭ್ಯವಿಲ್ಲ",
    "Natal Sun": "ನಟಾಲ್ ಸನ್",
    "Natal Sun house": "ನಟಾಲ್ ಸನ್ ಹೌಸ್",
    "Return planets loaded": "ಹಿಂತಿರುಗಿದ ಗ್ರಹಗಳು ಲೋಡ್ ಆಗಿವೆ",
    "Loading solar return chart...": "ಸೌರ ರಿಟರ್ನ್ ಚಾರ್ಟ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Annual focus": "ವಾರ್ಷಿಕ ಗಮನ",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "ಸೌರ ಥೀಮ್‌ಗಳನ್ನು ಜನ್ಮ ಸೂರ್ಯ, ರಿಟರ್ನ್ ಅಸೆಂಡೆಂಟ್ ಮತ್ತು ವಾರ್ಷಿಕ ರಿಟರ್ನ್ ಚಾರ್ಟ್‌ನಿಂದ ಓದಲಾಗುತ್ತದೆ.",
    "Solar Return Planet Positions": "ಸೌರ ರಿಟರ್ನ್ ಪ್ಲಾನೆಟ್ ಸ್ಥಾನಗಳು",
    "Loading solar return planets...": "ಸೌರ ವಾಪಸಾತಿ ಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Solar return positions are not available.": "ಸೌರ ರಿಟರ್ನ್ ಸ್ಥಾನಗಳು ಲಭ್ಯವಿಲ್ಲ.",
    "Solar Return House Cusps": "ಸೋಲಾರ್ ರಿಟರ್ನ್ ಹೌಸ್ ಕಸ್ಪ್ಸ್",
    "Loading solar return cusps...": "ಸೋಲಾರ್ ರಿಟರ್ನ್ ಕಸ್ಪ್‌ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Solar return house cusps are not available.": "ಸೋಲಾರ್ ರಿಟರ್ನ್ ಹೌಸ್ ಕಸ್ಪ್‌ಗಳು ಲಭ್ಯವಿಲ್ಲ.",
    "Solar Return Aspects to Natal Chart": "ನಟಾಲ್ ಚಾರ್ಟ್‌ಗೆ ಸೌರ ರಿಟರ್ನ್ ಅಂಶಗಳು",
    "Loading solar return aspects...": "ಸೋಲಾರ್ ರಿಟರ್ನ್ ಅಂಶಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "No major solar return aspects found within the configured orbs.": "ಕಾನ್ಫಿಗರ್ ಮಾಡಿದ ಆರ್ಬ್ಸ್‌ನಲ್ಲಿ ಯಾವುದೇ ಪ್ರಮುಖ ಸೌರ ರಿಟರ್ನ್ ಅಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "Natal Sun Aspects for Solar Return Focus": "ಸೋಲಾರ್ ರಿಟರ್ನ್ ಫೋಕಸ್‌ಗಾಗಿ ನಟಾಲ್ ಸನ್ ಆಸ್ಪೆಕ್ಟ್ಸ್",
    "No major natal Sun aspects found within the configured orbs.": "ಕಾನ್ಫಿಗರ್ ಮಾಡಲಾದ ಮಂಡಲಗಳಲ್ಲಿ ಯಾವುದೇ ಪ್ರಮುಖ ಜನ್ಮಜಾತ ಸೂರ್ಯನ ಅಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "ಗ್ರಹದಿಂದ ಗ್ರಹದ ಅಂಶಗಳು, ಕೋನ ಸಂಪರ್ಕಗಳು ಮತ್ತು ಮನೆಯ ಮೇಲ್ಪದರಗಳನ್ನು ಬಳಸಿಕೊಂಡು ಸಂಬಂಧದ ಓವರ್‌ಲೇ ಫ್ರೇಮ್‌ವರ್ಕ್.",
    "Loaded first chart": "ಮೊದಲ ಚಾರ್ಟ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
    "Second chart": "ಎರಡನೇ ಚಾರ್ಟ್",
    "Select or load partner chart to calculate full synastry overlay": "ಪೂರ್ಣ ಸಿನಾಸ್ಟ್ರಿ ಓವರ್‌ಲೇ ಅನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡಲು ಪಾಲುದಾರ ಚಾರ್ಟ್ ಅನ್ನು ಆಯ್ಕೆಮಾಡಿ ಅಥವಾ ಲೋಡ್ ಮಾಡಿ",
    "Major inter-chart aspects with tight orb priority": "ಬಿಗಿಯಾದ ಮಂಡಲದ ಆದ್ಯತೆಯೊಂದಿಗೆ ಪ್ರಮುಖ ಅಂತರ-ಚಾರ್ಟ್ ಅಂಶಗಳು",
    "House overlay method": "ಹೌಸ್ ಓವರ್ಲೇ ವಿಧಾನ",
    "Partner planets are placed into the first chart houses after second chart is selected": "ಎರಡನೇ ಚಾರ್ಟ್ ಅನ್ನು ಆಯ್ಕೆ ಮಾಡಿದ ನಂತರ ಪಾಲುದಾರ ಗ್ರಹಗಳನ್ನು ಮೊದಲ ಚಾರ್ಟ್ ಮನೆಗಳಲ್ಲಿ ಇರಿಸಲಾಗುತ್ತದೆ",
    "Relationship Pattern Aspects from Loaded Chart": "ಲೋಡ್ ಮಾಡಿದ ಚಾರ್ಟ್‌ನಿಂದ ಸಂಬಂಧದ ಮಾದರಿಯ ಅಂಶಗಳು",
    "No major relationship-focused natal aspects found within the configured orbs.": "ಕಾನ್ಫಿಗರ್ ಮಾಡಲಾದ ಮಂಡಲಗಳಲ್ಲಿ ಯಾವುದೇ ಪ್ರಮುಖ ಸಂಬಂಧ-ಕೇಂದ್ರಿತ ಜನ್ಮಜಾತ ಅಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "Understand your current inner life phase through Western Secondary Progressions.": "ವೆಸ್ಟರ್ನ್ ಸೆಕೆಂಡರಿ ಪ್ರಗತಿಗಳ ಮೂಲಕ ನಿಮ್ಮ ಪ್ರಸ್ತುತ ಆಂತರಿಕ ಜೀವನದ ಹಂತವನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಿ.",
    "Secondary Progression": "ದ್ವಿತೀಯ ಪ್ರಗತಿ",
    "1 day after birth = 1 year of life": "ಜನನದ ನಂತರ 1 ದಿನ = ಜೀವನದ 1 ವರ್ಷ",
    "Current age used": "ಪ್ರಸ್ತುತ ವಯಸ್ಸು ಬಳಸಲಾಗಿದೆ",
    "Progressed date": "ಮುಂದುವರಿದ ದಿನಾಂಕ",
    "Progressed Moon": "ಪ್ರಗತಿ ಹೊಂದಿದ ಚಂದ್ರ",
    "Loading progressed Moon...": "ಲೋಡ್ ಆಗುತ್ತಿದೆ ಚಂದ್ರ...",
    "Progressed Moon phase": "ಪ್ರಗತಿಯ ಚಂದ್ರನ ಹಂತ",
    "Loading Moon phase...": "ಚಂದ್ರನ ಹಂತವನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Current Life Phase": "ಪ್ರಸ್ತುತ ಜೀವನದ ಹಂತ",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "ದ್ವಿತೀಯಕ ಪ್ರಗತಿಗಳು ಜೀವನದ ಆಂತರಿಕ ಹಂತ, ಭಾವನಾತ್ಮಕ ಪರಿಪಕ್ವತೆ, ಗುರುತಿನ ಅಭಿವೃದ್ಧಿ ಮತ್ತು ಬದಲಾಗುತ್ತಿರುವ ಆದ್ಯತೆಗಳನ್ನು ತೋರಿಸುತ್ತವೆ.",
    "Progressed Career Phase": "ಪ್ರಗತಿಯ ವೃತ್ತಿಜೀವನದ ಹಂತ",
    "Progressed Love Phase": "ಮುಂದುವರಿದ ಪ್ರೀತಿಯ ಹಂತ",
    "Progressed Money Phase": "ಸುಧಾರಿತ ಹಣದ ಹಂತ",
    "Loading progressed planets...": "ಪ್ರಗತಿಯಲ್ಲಿರುವ ಗ್ರಹಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "Progressed planets are not available.": "ಪ್ರಗತಿ ಹೊಂದಿದ ಗ್ರಹಗಳು ಲಭ್ಯವಿಲ್ಲ.",
    "Loading progressed aspects...": "ಮುಂದುವರಿದ ಅಂಶಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    "No tight progressed-to-natal aspects found right now.": "ಯಾವುದೇ ಬಿಗಿಯಾದ ಪ್ರಗತಿಯಿಂದ ಪ್ರಸವಪೂರ್ವ ಅಂಶಗಳು ಇದೀಗ ಕಂಡುಬಂದಿಲ್ಲ.",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "ಈ ಹಂತವನ್ನು ಪ್ರಗತಿ ಹೊಂದಿದ ಗ್ರಹಗಳು, ಪ್ರಗತಿಯ ಚಂದ್ರನ ಹಂತ ಮತ್ತು ಬಿಗಿಯಾದ ಪ್ರಗತಿಯಿಂದ ಜನನದ ಅಂಶಗಳಿಂದ ನಿರ್ಣಯಿಸಬೇಕು.",
    "Vastu Analysis - Kundlistar": "ವಾಸ್ತು ವಿಶ್ಲೇಷಣೆ - Kundlistar",
    "Failed to load selected chart.": "ಆಯ್ಕೆಮಾಡಿದ ಚಾರ್ಟ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
    "Facing Direction": "ದಿಕ್ಕು ಎದುರಿಸುತ್ತಿದೆ",
    "Entrance Direction": "ಪ್ರವೇಶ ನಿರ್ದೇಶನ",
    "Kitchen Direction": "ಅಡಿಗೆ ನಿರ್ದೇಶನ",
    "Master Bedroom": "ಮಾಸ್ಟರ್ ಬೆಡ್‌ರೂಮ್",
    "Children Bedroom": "ಮಕ್ಕಳ ಮಲಗುವ ಕೋಣೆ",
    "Toilet Direction": "ಟಾಯ್ಲೆಟ್ ನಿರ್ದೇಶನ",
    "Pooja Direction": "ಪೂಜಾ ನಿರ್ದೇಶನ",
    "Water Tank": "ನೀರಿನ ಟ್ಯಾಂಕ್",
    "Underground Water": "ಭೂಗತ ನೀರು",
    "Heavy Storage": "ಭಾರೀ ಸಂಗ್ರಹಣೆ",
    "Living Room": "ಲಿವಿಂಗ್ ರೂಮ್",
    "Study Room": "ಅಧ್ಯಯನ ಕೊಠಡಿ",
    "Vastu report generation failed.": "ವಾಸ್ತು ವರದಿ ರಚನೆ ವಿಫಲವಾಗಿದೆ.",
    "Please generate the Vastu report before downloading.": "ಡೌನ್‌ಲೋಡ್ ಮಾಡುವ ಮೊದಲು ದಯವಿಟ್ಟು ವಾಸ್ತು ವರದಿಯನ್ನು ರಚಿಸಿ.",
    "Failed to download Vastu report.": "ವಾಸ್ತು ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ.",
    "Premium Feature": "ಪ್ರೀಮಿಯಂ ವೈಶಿಷ್ಟ್ಯ",
    "Selected Chart": "ಆಯ್ದ ಚಾರ್ಟ್",
    "Basic + KP + BNN from chart": "ಚಾರ್ಟ್‌ನಿಂದ ಬೇಸಿಕ್ + ಕೆಪಿ + ಬಿಎನ್‌ಎನ್",
    "Basic shown, KP + BNN locked": "ಮೂಲಭೂತವಾಗಿ ತೋರಿಸಲಾಗಿದೆ, KP + BNN ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
    "Property Type": "ಆಸ್ತಿ ಪ್ರಕಾರ",
    "Center Area": "ಕೇಂದ್ರ ಪ್ರದೇಶ",
    "Generate Vastu Report": "ವಾಸ್ತು ವರದಿಯನ್ನು ರಚಿಸಿ",
    "Basic Vastu Analysis": "ಮೂಲ ವಾಸ್ತು ವಿಶ್ಲೇಷಣೆ",
    "KP Vastu Analysis": "ಕೆಪಿ ವಾಸ್ತು ವಿಶ್ಲೇಷಣೆ",
    "BNN Vastu Analysis": "BNN ವಾಸ್ತು ವಿಶ್ಲೇಷಣೆ",
    "North East": "ಈಶಾನ್ಯ",
    "South East": "ಆಗ್ನೇಯ",
    "South West": "ನೈಋತ್ಯ",
    "North West": "ವಾಯುವ್ಯ",
    "Red Coral": "ಕೆಂಪು ಹವಳ",
    "Yellow Sapphire": "ಹಳದಿ ನೀಲಮಣಿ",
    "Blue Sapphire": "ನೀಲಿ ನೀಲಮಣಿ",
    "Cat's Eye": "ಬೆಕ್ಕಿನ ಕಣ್ಣು",
    "Additional Option": "ಹೆಚ್ಚುವರಿ ಆಯ್ಕೆ",
    "Lagna rule supports this gemstone option.": "ಲಗ್ನ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Moon sign rule supports this gemstone option.": "ಚಂದ್ರನ ಚಿಹ್ನೆ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Birth date rule supports this gemstone option.": "ಜನ್ಮ ದಿನಾಂಕ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Birth weekday rule supports this gemstone option.": "ಜನ್ಮ ವಾರದ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Current dasha rule supports this gemstone option.": "ಪ್ರಸ್ತುತ ದಶಾ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Age-band rule supports this gemstone option.": "ವಯಸ್ಸು-ಬ್ಯಾಂಡ್ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Selected goal supports this gemstone option.": "ಆಯ್ದ ಗುರಿಯು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Profession rule supports this gemstone option.": "ವೃತ್ತಿ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Name-initial rule supports this gemstone option.": "ಹೆಸರು-ಆರಂಭಿಕ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Moolank rule supports this gemstone option.": "ಮೂಲಂಕ್ ನಿಯಮವು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Chart condition check was considered for this option.": "ಈ ಆಯ್ಕೆಗಾಗಿ ಚಾರ್ಟ್ ಸ್ಥಿತಿಯ ಪರಿಶೀಲನೆಯನ್ನು ಪರಿಗಣಿಸಲಾಗಿದೆ.",
    "Rule-based chart match supports this gemstone option.": "ನಿಯಮ-ಆಧಾರಿತ ಚಾರ್ಟ್ ಹೊಂದಾಣಿಕೆಯು ಈ ರತ್ನದ ಆಯ್ಕೆಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
    "Expert kundli review is recommended before wearing this gemstone.": "ಈ ರತ್ನವನ್ನು ಧರಿಸುವ ಮೊದಲು ಪರಿಣಿತ ಕುಂಡಲಿ ವಿಮರ್ಶೆಯನ್ನು ಶಿಫಾರಸು ಮಾಡಲಾಗಿದೆ.",
    "Ring finger": "ಉಂಗುರ ಬೆರಳು",
    "Little finger": "ಕಿರುಬೆರಳು",
    "Index finger": "ತೋರು ಬೆರಳು",
    "Middle finger": "ಮಧ್ಯದ ಬೆರಳು",
    "Why recommended": "ಏಕೆ ಶಿಫಾರಸು ಮಾಡಲಾಗಿದೆ",
    "Approx weight": "ಅಂದಾಜು ತೂಕ",
    "Could not load chart.": "ಚಾರ್ಟ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Gemstone Recommendations | Kundlistar": "ರತ್ನದ ಶಿಫಾರಸ್ಸುಗಳು | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar ನ ನಿಯಮ-ಆಧಾರಿತ ಕುಂಡಲಿ ವಿಶ್ಲೇಷಣಾ ಎಂಜಿನ್‌ನಿಂದ ವೈದಿಕ ರತ್ನದ ಶಿಫಾರಸ್ಸುಗಳನ್ನು ಅನ್ವೇಷಿಸಿ.",
    "noindex,nofollow": "noindex,nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "ರತ್ನದ ಶಿಫಾರಸ್ಸು, ವೈದಿಕ ರತ್ನದ ಕಲ್ಲುಗಳು, ಕುಂಡಲಿ ರತ್ನ, Kundlistar",
    "Gemstone Recommendations": "ರತ್ನದ ಶಿಫಾರಸುಗಳು",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "ಲಗ್ನ, ಚಂದ್ರ ರಾಶಿ, ದಶಾ, DOB, ವೃತ್ತಿ ಮತ್ತು ಗುರಿಗಳ ಆಧಾರದ ಮೇಲೆ ವೈದಿಕ ರತ್ನದ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಪ್ರತ್ಯೇಕ Kundlistar ಮಾಡ್ಯೂಲ್.",
    "Personalized Gemstone Recommendations are available for Premium users.": "ಪ್ರೀಮಿಯಂ ಬಳಕೆದಾರರಿಗೆ ವೈಯಕ್ತೀಕರಿಸಿದ ರತ್ನದ ಶಿಫಾರಸ್ಸುಗಳು ಲಭ್ಯವಿದೆ.",
    "Upgrade to Premium": "ಪ್ರೀಮಿಯಂಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ",
    "Login to Upgrade": "ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಲು ಲಾಗಿನ್ ಮಾಡಿ",
    "Select Goal": "ಗುರಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "Business, government job, teacher...": "ವ್ಯಾಪಾರ, ಸರ್ಕಾರಿ ಕೆಲಸ, ಶಿಕ್ಷಕ...",
    "Weight kg": "ತೂಕ ಕೆಜಿ",
    "वजन kg": "ವಜನ್ ಕೆಜಿ",
    "Optional ratti estimate": "ಐಚ್ಛಿಕ ರಟ್ಟಿ ಅಂದಾಜು",
    "Click Calculate to apply these values.": "ಈ ಮೌಲ್ಯಗಳನ್ನು ಅನ್ವಯಿಸಲು ಲೆಕ್ಕಾಚಾರ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi ?",
    "Nadi Analysis": "ನಾಡಿ ವಿಶ್ಲೇಷಣೆ",
    "KP Analysis": "ಕೆಪಿ ವಿಶ್ಲೇಷಣೆ",
    "Vedic Analysis": "ವೈದಿಕ ವಿಶ್ಲೇಷಣೆ",
    "BNN Analysis": "BNN ವಿಶ್ಲೇಷಣೆ",
    "Jaimini Analysis": "ಜೈಮಿನಿ ವಿಶ್ಲೇಷಣೆ",
    "Western Astrology": "ಪಾಶ್ಚಾತ್ಯ ಜ್ಯೋತಿಷ್ಯ",
    "Panch Pakshi": "ಪಂಚ ಪಕ್ಷಿ",
    "Tithi Pravesh": "ತಿಥಿ ಪ್ರವೇಶ",
    "Lal Kitab": "ಲಾಲ್ ಕಿತಾಬ್",
    "Astro Logo": "ಆಸ್ಟ್ರೋ ಲೋಗೋ",
    "Download failed": "ಡೌನ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ",
    "Could not download PDF report.": "PDF ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Please login to download PDF reports.": "PDF ವರದಿಗಳನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ದಯವಿಟ್ಟು ಲಾಗಿನ್ ಮಾಡಿ.",
    "Failed to generate personalised report": "ವೈಯಕ್ತೀಕರಿಸಿದ ವರದಿಯನ್ನು ರಚಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "Could not download personalised report.": "ವೈಯಕ್ತೀಕರಿಸಿದ ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--ಕುಂಡ್ಲಿಸ್ಟಾರ್-ನವ್ಬಾರ್-ಎತ್ತರ, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(--ಕುಂಡ್ಲಿಸ್ಟಾರ್-ನವ್ಬಾರ್-ಎತ್ತರ, 160px))",
    "width 0.2s ease": "ಅಗಲ 0.2 ಸೆ ಸುಲಭ",
    "Collapse sidebar": "ಸೈಡ್‌ಬಾರ್ ಅನ್ನು ಸಂಕುಚಿಸಿ",
    "Expand sidebar": "ಸೈಡ್‌ಬಾರ್ ಅನ್ನು ವಿಸ್ತರಿಸಿ",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-root",
    "Download PDF Report": "PDF ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "Login to download": "ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಲಾಗಿನ್ ಮಾಡಿ",
    "PDF Report": "PDF ವರದಿ",
    "Download Personal Report": "ವೈಯಕ್ತಿಕ ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "Buy Premium to download": "ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಪ್ರೀಮಿಯಂ ಅನ್ನು ಖರೀದಿಸಿ",
    "Login to buy Premium": "ಪ್ರೀಮಿಯಂ ಖರೀದಿಸಲು ಲಾಗಿನ್ ಮಾಡಿ",
    "Buy Premium": "ಪ್ರೀಮಿಯಂ ಖರೀದಿಸಿ",
    "& .MuiTab-root": "& .MuiTab-ರೂಟ್",
    "& .Mui-selected": "& .ಮುಯಿ-ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ",
    "Unable to load Client Management data.": "ಕ್ಲೈಂಟ್ ಮ್ಯಾನೇಜ್ಮೆಂಟ್ ಡೇಟಾವನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ.",
    "Unable to download PDF.": "PDF ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "Free client limit reached": "ಉಚಿತ ಕ್ಲೈಂಟ್ ಮಿತಿಯನ್ನು ತಲುಪಿದೆ",
    "Welcome": "ಸ್ವಾಗತ",
    "Hello": "ನಮಸ್ಕಾರ",
    "Your saved charts are shown below.": "ನಿಮ್ಮ ಉಳಿಸಿದ ಚಾರ್ಟ್‌ಗಳನ್ನು ಕೆಳಗೆ ತೋರಿಸಲಾಗಿದೆ.",
    "All Features": "ಎಲ್ಲಾ ವೈಶಿಷ್ಟ್ಯಗಳು",
    "New Chart": "ಹೊಸ ಚಾರ್ಟ್",
    "Vedic Chart": "ವೇದ ಚಾರ್ಟ್",
    "Chakra": "ಚಕ್ರ",
    "Daily Panchang": "ದೈನಂದಿನ ಪಂಚಾಂಗ",
    "Choghadiya": "ಚೋಘಡಿಯಾ",
    "Daily Horoscope": "ದೈನಂದಿನ ಜಾತಕ",
    "Gochar Alerts": "ಗೋಚಾರ್ ಎಚ್ಚರಿಕೆಗಳು",
    "Matching": "ಹೊಂದಾಣಿಕೆ",
    "Ruling Planets": "ಆಡಳಿತ ಗ್ರಹಗಳು",
    "Horary Chart": "ಹೋರಾರಿ ಚಾರ್ಟ್",
    "Astro-Vastu": "ಆಸ್ಟ್ರೋ-ವಾಸ್ತು",
    "Vedic Numerology": "ವೈದಿಕ ಸಂಖ್ಯಾಶಾಸ್ತ್ರ",
    "My Charts": "ನನ್ನ ಚಾರ್ಟ್‌ಗಳು",
    "Search by Name": "ಹೆಸರಿನ ಮೂಲಕ ಹುಡುಕಿ",
    "Type": "ಟೈಪ್ ಮಾಡಿ",
    "All": "ಎಲ್ಲಾ",
    "Individual": "ವೈಯಕ್ತಿಕ",
    "Horary": "ಹಾರ್ರಿ",
    "Clear": "ತೆರವುಗೊಳಿಸಿ",
    "Name": "ಹೆಸರು",
    "DOB": "DOB",
    "Place": "ಸ್ಥಳ",
    "Gender": "ಲಿಂಗ",
    "Created": "ರಚಿಸಲಾಗಿದೆ",
    "Actions": "ಕ್ರಿಯೆಗಳು",
    "Male": "ಪುರುಷ",
    "Female": "ಹೆಣ್ಣು",
    "No matching charts found": "ಯಾವುದೇ ಹೊಂದಾಣಿಕೆಯ ಚಾರ್ಟ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    "Create First Chart": "ಮೊದಲ ಚಾರ್ಟ್ ರಚಿಸಿ",
    "View Chart": "ಚಾರ್ಟ್ ವೀಕ್ಷಿಸಿ",
    "Copy Share Link": "ಹಂಚಿಕೆ ಲಿಂಕ್ ಅನ್ನು ನಕಲಿಸಿ",
    "Use premium credit: Download PDF Report": "ಪ್ರೀಮಿಯಂ ಕ್ರೆಡಿಟ್ ಬಳಸಿ: PDF ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "Download Personalised Report": "ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "Premium: Download Personalised Report": "ಪ್ರೀಮಿಯಂ: ವೈಯಕ್ತೀಕರಿಸಿದ ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "Hide Chart": "ಚಾರ್ಟ್ ಮರೆಮಾಡಿ",
    "Personalised": "ವೈಯಕ್ತೀಕರಿಸಲಾಗಿದೆ",
    "Generating your Personalised Report": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ವರದಿಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ",
    "Please do not leave this page till the report is generated. This can take a little while.": "ವರದಿಯನ್ನು ರಚಿಸುವವರೆಗೆ ದಯವಿಟ್ಟು ಈ ಪುಟವನ್ನು ಬಿಡಬೇಡಿ. ಇದು ಸ್ವಲ್ಪ ಸಮಯ ತೆಗೆದುಕೊಳ್ಳಬಹುದು.",
    "Please don't leave this page till the report is generated. This can take a little while.": "ವರದಿಯನ್ನು ರಚಿಸುವವರೆಗೆ ದಯವಿಟ್ಟು ಈ ಪುಟವನ್ನು ಬಿಡಬೇಡಿ. ಇದು ಸ್ವಲ್ಪ ಸಮಯ ತೆಗೆದುಕೊಳ್ಳಬಹುದು.",
    "Update": "ನವೀಕರಿಸಿ",
    "Complete your billing address. Required for generating invoice.": "ನಿಮ್ಮ ಬಿಲ್ಲಿಂಗ್ ವಿಳಾಸವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ. ಸರಕುಪಟ್ಟಿ ರಚಿಸಲು ಅಗತ್ಯವಿದೆ.",
    "Report this report": "ಈ ವರದಿಯನ್ನು ವರದಿ ಮಾಡಿ",
    "Reason": "ಕಾರಣ",
    "Optional comment": "ಐಚ್ಛಿಕ ಕಾಮೆಂಟ್",
    "Submit": "ಸಲ್ಲಿಸಿ",
    "Incorrect info": "ತಪ್ಪು ಮಾಹಿತಿ",
    "Offensive": "ಆಕ್ರಮಣಕಾರಿ",
    "Harmful": "ಹಾನಿಕಾರಕ",
    "This report has been sent for review.": "ಈ ವರದಿಯನ್ನು ಪರಿಶೀಲನೆಗೆ ಕಳುಹಿಸಲಾಗಿದೆ.",
    "Failed to submit report feedback": "ವರದಿಯ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಸಲ್ಲಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "Failed to download PDF": "PDF ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "Failed to download personalised report": "ವೈಯಕ್ತೀಕರಿಸಿದ ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "Failed to load charts": "ಚಾರ್ಟ್‌ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "Failed to hide chart": "ಚಾರ್ಟ್ ಅನ್ನು ಮರೆಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "Failed to delete chart": "ಚಾರ್ಟ್ ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "Share link copied to clipboard!": "ಹಂಚಿಕೆ ಲಿಂಕ್ ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ!",
    "Delete Chart": "ಚಾರ್ಟ್ ಅಳಿಸಿ",
    "Delete chart": "ಚಾರ್ಟ್ ಅಳಿಸಿ",
    "Error": "ದೋಷ",
    "OK": "ಸರಿ",
    "Thanks": "ಧನ್ಯವಾದಗಳು",
    "Report failed": "ವರದಿ ವಿಫಲವಾಗಿದೆ",
    "Could not submit report feedback.": "ವರದಿಯ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಸಲ್ಲಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Personalised report ready": "ವೈಯಕ್ತೀಕರಿಸಿದ ವರದಿ ಸಿದ್ಧವಾಗಿದೆ",
    "Personalised report failed": "ವೈಯಕ್ತೀಕರಿಸಿದ ವರದಿ ವಿಫಲವಾಗಿದೆ",
    "Could not generate personalised report.": "ವೈಯಕ್ತೀಕರಿಸಿದ ವರದಿಯನ್ನು ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Could not generate personalised PDF report.": "ವೈಯಕ್ತೀಕರಿಸಿದ PDF ವರದಿಯನ್ನು ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Monthly limit reached": "ಮಾಸಿಕ ಮಿತಿಯನ್ನು ತಲುಪಿದೆ",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "ನಿಮ್ಮ ಮಾಸಿಕ ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ವರದಿ ಮಿತಿಯನ್ನು ತಲುಪಿದೆ. ಆಡ್-ಆನ್‌ಗೆ ಚಂದಾದಾರರಾಗಿ: 20 ವರದಿಗಳಿಗೆ ₹299/ತಿಂಗಳು ಅಥವಾ 40 ವರದಿಗಳಿಗೆ ₹499/ತಿಂಗಳು.",
    "Buy Add-on": "ಆಡ್-ಆನ್ ಅನ್ನು ಖರೀದಿಸಿ",
    "Manage": "ನಿರ್ವಹಿಸಿ",
    "Add-on active: Unlimited reports": "ಆಡ್-ಆನ್ ಸಕ್ರಿಯ: ಅನಿಯಮಿತ ವರದಿಗಳು",
    "Add-on active: 40 reports/month": "ಆಡ್-ಆನ್ ಸಕ್ರಿಯ: 40 ವರದಿಗಳು/ತಿಂಗಳು",
    "Add-on active: 20 reports/month": "ಆಡ್-ಆನ್ ಸಕ್ರಿಯ: 20 ವರದಿಗಳು/ತಿಂಗಳು",
    "reports remaining this cycle": "ಈ ಚಕ್ರದಲ್ಲಿ ಉಳಿದಿರುವ ವರದಿಗಳು",
    "Add-on active": "ಆಡ್-ಆನ್ ಸಕ್ರಿಯವಾಗಿದೆ",
    "Personalised reports remaining this month": "ಈ ತಿಂಗಳು ಉಳಿದಿರುವ ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ವರದಿಗಳು",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "ಪ್ರೀಮಿಯಂ 2/ತಿಂಗಳನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ. ಆಡ್-ಆನ್‌ಗಳು: 20 ವರದಿಗಳಿಗೆ/ತಿಂಗಳಿಗೆ ₹299/ತಿಂಗಳು ಅಥವಾ 40 ವರದಿಗಳಿಗೆ/ತಿಂಗಳಿಗೆ ₹499/ತಿಂಗಳು.",
    "AI Disclaimer": "AI ಹಕ್ಕು ನಿರಾಕರಣೆ",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "AI ಮತ್ತು ಜ್ಯೋತಿಷ್ಯ ವ್ಯಾಖ್ಯಾನಗಳನ್ನು ಬಳಸಿಕೊಂಡು ಈ ವರದಿಯನ್ನು ರಚಿಸಲಾಗಿದೆ. ಇದು ಮಾಹಿತಿ ಮತ್ತು ಮನರಂಜನಾ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಮಾತ್ರ. ಇದನ್ನು ವೈದ್ಯಕೀಯ, ಕಾನೂನು ಅಥವಾ ಆರ್ಥಿಕ ಸಲಹೆ ಎಂದು ಪರಿಗಣಿಸಬಾರದು.",
    "A copy of this report has also been sent to your registered email address as a PDF.": "ಈ ವರದಿಯ ನಕಲನ್ನು ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್ ವಿಳಾಸಕ್ಕೆ PDF ಆಗಿ ಕಳುಹಿಸಲಾಗಿದೆ.",
    "Report this AI-generated report?": "ಈ AI-ರಚಿಸಿದ ವರದಿಯನ್ನು ವರದಿ ಮಾಡುವುದೇ?",
    "charts": "ಚಾರ್ಟ್‌ಗಳು",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "ಸ್ವತಂತ್ರ ಟಿಪ್ಪಣಿಗಳು, ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಯೋಜನೆ. ಉಳಿಸಲು ಲಾಗಿನ್ ಅಗತ್ಯವಿದೆ; ಉಚಿತ ಬಳಕೆದಾರರು ಪೂರ್ಣ ಯೋಜಕ ಪ್ರವೇಶವನ್ನು ಪಡೆಯುತ್ತಾರೆ.",
    "Independent notes, date and time planning.": "ಸ್ವತಂತ್ರ ಟಿಪ್ಪಣಿಗಳು, ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಯೋಜನೆ.",
    "Add Plan": "ಯೋಜನೆಯನ್ನು ಸೇರಿಸಿ",
    "Save Plan": "ಯೋಜನೆಯನ್ನು ಉಳಿಸಿ",
    "Saved Plans": "ಉಳಿಸಿದ ಯೋಜನೆಗಳು",
    "Planner Entry": "ಯೋಜಕ ಪ್ರವೇಶ",
    "Plan": "ಯೋಜನೆ",
    "Saving...": "ಉಳಿಸಲಾಗುತ್ತಿದೆ...",
    "Refresh": "ರಿಫ್ರೆಶ್ ಮಾಡಿ",
    "No plans saved yet.": "ಇನ್ನೂ ಯಾವುದೇ ಯೋಜನೆಗಳನ್ನು ಉಳಿಸಲಾಗಿಲ್ಲ.",
    "Planner layout is available. Login only when you want to save.": "ಪ್ಲಾನರ್ ಲೇಔಟ್ ಲಭ್ಯವಿದೆ. ನೀವು ಉಳಿಸಲು ಬಯಸಿದಾಗ ಮಾತ್ರ ಲಾಗಿನ್ ಮಾಡಿ.",
    "No matching plans.": "ಯಾವುದೇ ಹೊಂದಾಣಿಕೆಯ ಯೋಜನೆಗಳಿಲ್ಲ.",
    "Search Plans": "ಹುಡುಕಾಟ ಯೋಜನೆಗಳು",
    "Search title, note, date or status": "ಶೀರ್ಷಿಕೆ, ಟಿಪ್ಪಣಿ, ದಿನಾಂಕ ಅಥವಾ ಸ್ಥಿತಿಯನ್ನು ಹುಡುಕಿ",
    "Login is required only when you want to save planner entries.": "ನೀವು ಪ್ಲಾನರ್ ನಮೂದುಗಳನ್ನು ಉಳಿಸಲು ಬಯಸಿದಾಗ ಮಾತ್ರ ಲಾಗಿನ್ ಅಗತ್ಯವಿದೆ.",
    "Planner entry saved.": "ಪ್ಲಾನರ್ ಪ್ರವೇಶವನ್ನು ಉಳಿಸಲಾಗಿದೆ.",
    "Unable to load planner.": "ಪ್ಲಾನರ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "Unable to save planner entry.": "ಯೋಜಕ ಪ್ರವೇಶವನ್ನು ಉಳಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Could not load planner.": "ಪ್ಲಾನರ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Could not save planner entry.": "ಪ್ಲಾನರ್ ಪ್ರವೇಶವನ್ನು ಉಳಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "Login required to save": "ಉಳಿಸಲು ಲಾಗಿನ್ ಅಗತ್ಯವಿದೆ",
    "You can explore Planner now. Login when you want to save entries.": "ನೀವು ಈಗ ಪ್ಲಾನರ್ ಅನ್ನು ಅನ್ವೇಷಿಸಬಹುದು. ನೀವು ನಮೂದುಗಳನ್ನು ಉಳಿಸಲು ಬಯಸಿದಾಗ ಲಾಗಿನ್ ಮಾಡಿ.",
    "Prev": "ಹಿಂದಿನ",
    "Next": "ಮುಂದೆ",
    "Page": "ಪುಟ",
    "of": "ನ",
    "Child Birth Mahoorat": "ಮಗುವಿನ ಜನನ ಮಹೂರತ್",
    "Child Birth Mahoorat | Kundlistar Premium": "ಮಗುವಿನ ಜನನ ಮಹೂರತ್ | ಕುಂಡ್ಲಿಸ್ಟಾರ್ ಪ್ರೀಮಿಯಂ",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "ಪಂಚಾಂಗ್, ಚೋಘಡಿಯಾ ಮತ್ತು ಹೋರಾ ಆಧಾರಿತ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ಪ್ರೀಮಿಯಂ ಚೈಲ್ಡ್ ಬರ್ತ್ ಮಹೋರತ್ ಕಿಟಕಿಗಳು.",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "ಯೋಜಿತ ಮಗುವಿನ ಜನನದ ಸಮಯದ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಮಂಗಳಕರವಾದ ಲಭ್ಯವಿರುವ ಕಿಟಕಿಗಳನ್ನು ಅನ್ವೇಷಿಸಲು ದಿನಾಂಕ ಮತ್ತು ಸ್ಥಳವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "ಮಗುವಿನ ಜನನ ಮಹೋರತ್ ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ಜ್ಯೋತಿಷ್ಯ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಮಾತ್ರ.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "ಮಗುವಿನ ಜನನ ಮಹೋರತ್ ಪ್ರೀಮಿಯಂ ವೈಶಿಷ್ಟ್ಯವಾಗಿದೆ. ಪಂಚಾಂಗ್, ಚೋಘಡಿಯಾ ಮತ್ತು ಹೋರಾ ಚೆಕ್‌ಗಳೊಂದಿಗೆ ಮಂಗಳಕರ ಮಾರ್ಗದರ್ಶನ ವಿಂಡೋಗಳನ್ನು ಅನ್‌ಲಾಕ್ ಮಾಡಲು ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "ದಿನಾಂಕ, ಸ್ಥಳ, ಪಂಚಾಂಗ್, ಚೋಘಡಿಯಾ ಮತ್ತು ಹೋರಾ ಮೂಲಕ ಪ್ರೀಮಿಯಂ ಮಾರ್ಗದರ್ಶಿ ವಿಂಡೋಗಳು.",
    "Premium feature": "ಪ್ರೀಮಿಯಂ ವೈಶಿಷ್ಟ್ಯ",
    "Upgrade to Kundlistar Premium": "ಕುಂಡ್ಲಿಸ್ಟಾರ್ ಪ್ರೀಮಿಯಂಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ",
    "Previous": "ಹಿಂದಿನ",
    "Today": "ಇಂದು",
    "Birth place / City": "ಹುಟ್ಟಿದ ಸ್ಥಳ / ನಗರ",
    "Birth place / city": "ಹುಟ್ಟಿದ ಸ್ಥಳ / ನಗರ",
    "Select country, then search city": "ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ, ನಂತರ ನಗರವನ್ನು ಹುಡುಕಿ",
    "Preferred start": "ಆದ್ಯತೆಯ ಪ್ರಾರಂಭ",
    "Preferred end": "ಆದ್ಯತೆಯ ಅಂತ್ಯ",
    "Mother Moon sign (optional)": "ತಾಯಿ ಚಂದ್ರನ ಚಿಹ್ನೆ (ಐಚ್ಛಿಕ)",
    "Cancer": "ಕ್ಯಾನ್ಸರ್",
    "Load Kundli": "ಲೋಡ್ ಕುಂಡ್ಲಿ",
    "Find Premium Windows": "ಪ್ರೀಮಿಯಂ ವಿಂಡೋಸ್ ಅನ್ನು ಹುಡುಕಿ",
    "Date (DD/MM/YYYY)": "ದಿನಾಂಕ (DD/MM/YYYY)",
    "Invalid Date": "ಅಮಾನ್ಯ ದಿನಾಂಕ",
    "Date must be in DD/MM/YYYY format.": "ದಿನಾಂಕ DD/MM/YYYY ಫಾರ್ಮ್ಯಾಟ್‌ನಲ್ಲಿರಬೇಕು.",
    "Required": "ಅಗತ್ಯವಿದೆ",
    "Please select a city.": "ದಯವಿಟ್ಟು ನಗರವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "Kundli": "ಕುಂಡ್ಲಿ",
    "Unable to load kundli.": "ಕುಂಡಲಿಯನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ.",
    "Unable to calculate Child Birth Mahoorat.": "ಮಗುವಿನ ಜನನ ಮಹೋರತ್ ಅನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ.",
    "Kundli Preview": "ಕುಂಡಲಿ ಮುನ್ನೋಟ",
    "Loaded for": "ಗಾಗಿ ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
    "Doshas & Yogas": "ದೋಷಗಳು ಮತ್ತು ಯೋಗಗಳು",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "ಲೋಡ್ ಮಾಡಲಾದ ಲಾಹಿರಿ ಕುಂಡಲಿಯಿಂದ ನಿಯಮ-ಆಧಾರಿತ ಸೂಚನೆಗಳು. ವಿಮರ್ಶೆ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಅವುಗಳನ್ನು ಬಳಸಿ, ಅಂತಿಮ ತೀರ್ಪಿನಂತೆ ಅಲ್ಲ.",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "ಲೋಡ್ ಮಾಡಲಾದ ಲಾಹಿರಿ ಕುಂಡಲಿಯಿಂದ ನಿಯಮ-ಆಧಾರಿತ ಸೂಚನೆಗಳು. ವಿಮರ್ಶೆ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ಬಳಸಿ.",
    "Detected": "ಪತ್ತೆ ಮಾಡಲಾಗಿದೆ",
    "Not detected": "ಪತ್ತೆಯಾಗಿಲ್ಲ",
    "Review": "ವಿಮರ್ಶೆ",
    "Dosha": "ದೋಷ",
    "Yoga": "ಯೋಗ",
    "Full Yoga Scan": "ಪೂರ್ಣ ಯೋಗ ಸ್ಕ್ಯಾನ್",
    "Checking yogas...": "ಯೋಗಗಳನ್ನು ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...",
    "No major yogas were detected by the premium yoga scan.": "ಪ್ರೀಮಿಯಂ ಯೋಗ ಸ್ಕ್ಯಾನ್‌ನಿಂದ ಯಾವುದೇ ಪ್ರಮುಖ ಯೋಗಗಳು ಪತ್ತೆಯಾಗಿಲ್ಲ.",
    "No suitable premium windows found for the selected date and time range.": "ಆಯ್ಕೆಮಾಡಿದ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಶ್ರೇಣಿಗೆ ಸೂಕ್ತವಾದ ಪ್ರೀಮಿಯಂ ವಿಂಡೋಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    "No suitable windows found": "ಸೂಕ್ತವಾದ ಕಿಟಕಿಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    "Try changing the time range or select previous/next date.": "ಸಮಯ ಶ್ರೇಣಿಯನ್ನು ಬದಲಾಯಿಸಲು ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಹಿಂದಿನ/ಮುಂದಿನ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "Try changing the date or time range.": "ದಿನಾಂಕ ಅಥವಾ ಸಮಯದ ಶ್ರೇಣಿಯನ್ನು ಬದಲಾಯಿಸಲು ಪ್ರಯತ್ನಿಸಿ.",
    "Try the Previous or Next date button to find a better option.": "ಉತ್ತಮ ಆಯ್ಕೆಯನ್ನು ಹುಡುಕಲು ಹಿಂದಿನ ಅಥವಾ ಮುಂದಿನ ದಿನಾಂಕ ಬಟನ್ ಅನ್ನು ಪ್ರಯತ್ನಿಸಿ.",
    "Use Previous or Next date to find a better option.": "ಉತ್ತಮ ಆಯ್ಕೆಯನ್ನು ಹುಡುಕಲು ಹಿಂದಿನ ಅಥವಾ ಮುಂದಿನ ದಿನಾಂಕವನ್ನು ಬಳಸಿ.",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "ಆಯ್ಕೆಮಾಡಿದ ದಿನಾಂಕ ಮತ್ತು ನಗರಕ್ಕಾಗಿ ಅತ್ಯುತ್ತಮ ಪ್ರೀಮಿಯಂ ವಿಂಡೋಗಳನ್ನು ಲೆಕ್ಕಾಚಾರ ಮಾಡಲು ಪ್ರೀಮಿಯಂ ವಿಂಡೋಸ್ ಅನ್ನು ಹುಡುಕಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    "Tap Find Premium Windows for the selected date and city.": "ಆಯ್ಕೆಮಾಡಿದ ದಿನಾಂಕ ಮತ್ತು ನಗರಕ್ಕಾಗಿ ಪ್ರೀಮಿಯಂ ವಿಂಡೋಸ್ ಅನ್ನು ಹುಡುಕಿ ಟ್ಯಾಪ್ ಮಾಡಿ.",
    "Good tithi": "ಒಳ್ಳೆಯ ತಿಥಿ",
    "Supportive nakshatra": "ಪೋಷಕ ನಕ್ಷತ್ರ",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "ನಕ್ಷತ್ರವು ಸೂಕ್ಷ್ಮವಾಗಿರುತ್ತದೆ. ಪದ ಮತ್ತು ಗಂಡಾಂತವನ್ನು ಎಚ್ಚರಿಕೆಯಿಂದ ಪರಿಶೀಲಿಸಿ.",
    "Supportive weekday": "ಬೆಂಬಲ ವಾರದ ದಿನ",
    "Good Choghadiya": "ಒಳ್ಳೆಯ ಚೋಗಾಡಿಯಾ",
    "Weak Choghadiya": "ದುರ್ಬಲ ಚೋಘಡಿಯಾ",
    "Supportive Hora": "ಪೋಷಕ ಹೋರಾ",
    "Baby Moon matches mother's Moon sign.": "ಬೇಬಿ ಮೂನ್ ತಾಯಿಯ ಚಂದ್ರನ ಚಿಹ್ನೆಗೆ ಹೊಂದಿಕೆಯಾಗುತ್ತದೆ.",
    "Hora": "ಹೊರಾ",
    "slots": "ಸ್ಲಾಟ್‌ಗಳು",
    "min": "ನಿಮಿ",
    "Good": "ಒಳ್ಳೆಯದು",
    "Excellent": "ಅತ್ಯುತ್ತಮ",
    "Usable": "ಬಳಸಬಹುದಾದ",
    "Rejected": "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
    "Sunday": "ಭಾನುವಾರ",
    "Monday": "ಸೋಮವಾರ",
    "Tuesday": "ಮಂಗಳವಾರ",
    "Wednesday": "ಬುಧವಾರ",
    "Thursday": "ಗುರುವಾರ",
    "Friday": "ಶುಕ್ರವಾರ",
    "Saturday": "ಶನಿವಾರ",
    "Sun": "ಸೂರ್ಯ",
    "Moon": "ಚಂದ್ರ",
    "Mars": "ಮಂಗಳ",
    "Mercury": "ಮರ್ಕ್ಯುರಿ",
    "Jupiter": "ಗುರು",
    "Venus": "ಶುಕ್ರ",
    "Saturn": "ಶನಿಗ್ರಹ",
    "Rahu": "ರಾಹು",
    "Ketu": "ಕೇತು",
    "Chal": "ಚಾಲ್",
    "Labh": "ಲ್ಯಾಬ್",
    "Amrit": "ಅಮೃತ್",
    "Shubh": "ಶುಭ್",
    "Udveg": "ಉದ್ವೇಗ್",
    "Rog": "ರೋಗ್",
    "Kaal": "ಕಾಲ",
    "Krishna Navami": "ಕೃಷ್ಣ ನವಮಿ",
    "Ashwini": "ಅಶ್ವಿನಿ",
    "Bharani": "ಭರಣಿ",
    "Krittika": "ಕೃತ್ತಿಕಾ",
    "Rohini": "ರೋಹಿಣಿ",
    "Mrigashira": "ಮೃಗಶಿರ",
    "Ardra": "ಆರ್ದ್ರಾ",
    "Punarvasu": "ಪುನರ್ವಸು",
    "Pushya": "ಪುಷ್ಯ",
    "Ashlesha": "ಆಶ್ಲೇಷಾ",
    "Magha": "ಮಾಘ",
    "Jyeshtha": "ಜ್ಯೇಷ್ಠಾ",
    "Moola": "ಮೂಲಾ",
    "Mula": "ಮುಲಾ",
    "Revati": "ರೇವತಿ"
  },
  "ml": {
    "Client Management": "ക്ലയൻ്റ് മാനേജ്മെൻ്റ്",
    "Dashboard": "ഡാഷ്ബോർഡ്",
    "Clients": "ഉപഭോക്താക്കൾ",
    "Consultations": "കൂടിയാലോചനകൾ",
    "Notes": "കുറിപ്പുകൾ",
    "Follow-ups": "ഫോളോ-അപ്പുകൾ",
    "Reports": "റിപ്പോർട്ടുകൾ",
    "Remedies": "പ്രതിവിധികൾ",
    "Predictions": "പ്രവചനങ്ങൾ",
    "Planner": "പ്ലാനർ",
    "Templates": "ടെംപ്ലേറ്റുകൾ",
    "Analytics": "അനലിറ്റിക്സ്",
    "Payments": "പേയ്മെൻ്റുകൾ",
    "Settings": "ക്രമീകരണങ്ങൾ",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings-ൽ ഡിഫോൾട്ട് നഗരം സംരക്ഷിക്കാം. തിരഞ്ഞെടുക്കുന്നതുവരെ നഗര ഫീൽഡുകൾ ശൂന്യമായിരിക്കും.",
    "is now your default city.": "ഇപ്പോൾ നിങ്ങളുടെ ഡിഫോൾട്ട് നഗരമാണ്.",
    "Search your default city": "നിങ്ങളുടെ ഡിഫോൾട്ട് നഗരം തിരയുക",
    "This color is saved for the website theme and PDF report accent.": "ഈ നിറം വെബ്‌സൈറ്റ് തീമിനും PDF റിപ്പോർട്ട് accent-നും സംരക്ഷിക്കും.",
    "Turn All off to include only the checked modules in the report.": "റിപ്പോർട്ടിൽ തിരഞ്ഞെടുത്ത മോഡ്യൂളുകൾ മാത്രം ഉൾപ്പെടുത്താൻ All ഓഫ് ചെയ്യുക.",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All ഓൺ ആണെങ്കിൽ PDF എല്ലാ മോഡ്യൂളുകളും ഉൾപ്പെടും. തിരഞ്ഞെടുത്തവ മാത്രം ഉൾപ്പെടുത്താൻ ഓഫ് ചെയ്യുക.",
    "Uranus, Neptune and Pluto stay hidden by default.": "യുറാനസ്, നെപ്റ്റ്യൂൺ, പ്ലൂട്ടോ ഡിഫോൾട്ടായി മറഞ്ഞിരിക്കും.",
    "Show Uranus, Neptune and Pluto": "യുറാനസ്, നെപ്റ്റ്യൂൺ, പ്ലൂട്ടോ കാണിക്കുക",
    "When off, Nadi and KP also use the selected global ayanamsha.": "ഓഫ് ആണെങ്കിൽ നാടി, KP എന്നിവയും തിരഞ്ഞെടുത്ത ഗ്ലോബൽ അയനാംശം ഉപയോഗിക്കും.",
    "Use KP for Nadi and KP": "നാടി, KP എന്നിവയ്ക്ക് KP ഉപയോഗിക്കുക",
    "Use KP ayanamsha for Nadi and KP": "നാടി, KP എന്നിവയ്ക്ക് KP അയനാംശം ഉപയോഗിക്കുക",
    "Night": "നൈറ്റ്",
    "Dark": "ഡാർക്ക്",
    "Light": "ലൈറ്റ്",
    "Clear default city": "ഡിഫോൾട്ട് നഗരം നീക്കംചെയ്യുക",
    "Default City": "ഡിഫോൾട്ട് നഗരം",
    "Default city": "ഡിഫോൾട്ട് നഗരം",
    "Theme Color": "തീം നിറം",
    "Theme color": "തീം നിറം",
    "Include all modules": "എല്ലാ മോഡ്യൂളുകളും ഉൾപ്പെടുത്തുക",
    "PDF Report Modules": "PDF റിപ്പോർട്ട് മോഡ്യൂളുകൾ",
    "PDF report modules": "PDF റിപ്പോർട്ട് മോഡ്യൂളുകൾ",
    "Show": "കാണിക്കുക",
    "Hide": "മറയ്ക്കുക",
    "Outer Planets": "ബാഹ്യ ഗ്രഹങ്ങൾ",
    "Outer planets": "ബാഹ്യ ഗ്രഹങ്ങൾ",
    "Ayanamsha": "അയനാംശം",
    "Mean Node": "മീൻ നോഡ്",
    "True Node": "ട്രൂ നോഡ്",
    "Rahu/Ketu Calculation": "രാഹു/കേതു കണക്കുകൂട്ടൽ",
    "Rahu/Ketu calculation": "രാഹു/കേതു കണക്കുകൂട്ടൽ",
    "East": "കിഴക്കൻ ഇന്ത്യൻ",
    "South": "തെക്കേ ഇന്ത്യൻ",
    "North": "വടക്കേ ഇന്ത്യൻ",
    "Chart Style": "ചാർട്ട് ശൈലി",
    "Chart style": "ചാർട്ട് ശൈലി",
    "Language": "ഭാഷ",
    "Records": "റെക്കോർഡുകൾ",
    "Relations": "ബന്ധങ്ങൾ",
    "Relation": "ബന്ധം",
    "Add Client": "ക്ലയൻ്റ് ചേർക്കുക",
    "Add Consultation": "കൺസൾട്ടേഷൻ ചേർക്കുക",
    "Add Note": "കുറിപ്പ് ചേർക്കുക",
    "Add Follow-up": "ഫോളോ-അപ്പ് ചേർക്കുക",
    "Create Report": "റിപ്പോർട്ട് സൃഷ്ടിക്കുക",
    "Assign Remedy": "പ്രതിവിധി അസൈൻ ചെയ്യുക",
    "Add Prediction": "പ്രവചനം ചേർക്കുക",
    "Add Payment": "പേയ്മെൻ്റ് ചേർക്കുക",
    "Assign Chart": "ചാർട്ട് അസൈൻ ചെയ്യുക",
    "Add Relation": "ബന്ധം ചേർക്കുക",
    "CMS Action": "CMS പ്രവർത്തനം",
    "Client": "ക്ലയൻ്റ്",
    "Chart": "ചാർട്ട്",
    "Related Client": "ബന്ധപ്പെട്ട ക്ലയൻ്റ്",
    "Full Name": "മുഴുവൻ പേര്",
    "Phone Number": "ഫോൺ നമ്പർ",
    "WhatsApp Number": "വാട്ട്‌സ്ആപ്പ് നമ്പർ",
    "Email": "ഇമെയിൽ",
    "Birth Place": "ജന്മസ്ഥലം",
    "Current City": "നിലവിലെ നഗരം",
    "Main Topic": "പ്രധാന വിഷയം",
    "Status": "നില",
    "Source": "ഉറവിടം",
    "Tags": "ടാഗുകൾ",
    "Internal Note": "ആന്തരിക കുറിപ്പ്",
    "Purpose": "ഉദ്ദേശ്യം",
    "Relation Type": "ബന്ധ തരം",
    "Title": "തലക്കെട്ട്",
    "Topic": "വിഷയം",
    "Date": "തീയതി",
    "Time": "സമയം",
    "Amount": "തുക",
    "Mode": "മോഡ്",
    "Payment Status": "പേയ്മെൻ്റ് നില",
    "Note / Summary": "കുറിപ്പ് / സംഗ്രഹം",
    "Close": "അടയ്ക്കുക",
    "Cancel": "റദ്ദാക്കുക",
    "Save": "സംരക്ഷിക്കുക",
    "Saving": "സംരക്ഷിക്കുന്നു",
    "Save Changes": "മാറ്റങ്ങൾ സംരക്ഷിക്കുക",
    "Edit Client": "ക്ലയൻ്റ് എഡിറ്റ് ചെയ്യുക",
    "Client Chart": "ക്ലയൻ്റ് ചാർട്ട്",
    "Comma separated": "കോമ വേർതിരിച്ചു",
    "Search by name, phone, email, topic, or tag": "പേര്, ഫോൺ, ഇമെയിൽ, വിഷയം അല്ലെങ്കിൽ ടാഗ് എന്നിവ പ്രകാരം തിരയുക",
    "Search clients, phone, topic": "ക്ലയൻ്റുകൾ, ഫോൺ, വിഷയം എന്നിവ തിരയുക",
    "Search your saved charts by chart name": "ചാർട്ട് നാമം ഉപയോഗിച്ച് നിങ്ങളുടെ സംരക്ഷിച്ച ചാർട്ടുകൾ തിരയുക",
    "Linked Chart": "ലിങ്ക് ചെയ്‌ത ചാർട്ട്",
    "Select linked chart": "ലിങ്ക് ചെയ്‌ത ചാർട്ട് തിരഞ്ഞെടുക്കുക",
    "Link a chart to this client before adding records.": "റെക്കോർഡുകൾ ചേർക്കുന്നതിന് മുമ്പ് ഈ ക്ലയൻ്റുമായി ഒരു ചാർട്ട് ലിങ്ക് ചെയ്യുക.",
    "Connect this client with another saved client profile": "സംരക്ഷിച്ച മറ്റൊരു ക്ലയൻ്റ് പ്രൊഫൈലുമായി ഈ ക്ലയൻ്റിനെ ബന്ധിപ്പിക്കുക",
    "CMS for astrologer client work": "ജ്യോതിഷിയുടെ ക്ലയൻ്റ് വർക്കിനുള്ള സി.എം.എസ്",
    "Premium Pro unlocks Client Management": "പ്രീമിയം പ്രോ ക്ലയൻ്റ് മാനേജ്‌മെൻ്റ് അൺലോക്ക് ചെയ്യുന്നു",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ഒരു വർക്ക്‌സ്‌പെയ്‌സിൽ ക്ലയൻ്റ് പ്രൊഫൈലുകൾ, കൺസൾട്ടേഷനുകൾ, കുറിപ്പുകൾ, ഫോളോ-അപ്പുകൾ, റിപ്പോർട്ടുകൾ, പരിഹാരങ്ങൾ, പ്രവചനങ്ങൾ, അനലിറ്റിക്‌സ്, പേയ്‌മെൻ്റ് ട്രാക്കിംഗ് എന്നിവ മാനേജ് ചെയ്യാൻ അപ്‌ഗ്രേഡ് ചെയ്യുക.",
    "Upgrade to Premium Pro": "പ്രീമിയം പ്രോയിലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക",
    "CMS modules included": "CMS മൊഡ്യൂളുകൾ ഉൾപ്പെടുത്തിയിട്ടുണ്ട്",
    "Please login to use Client Management. CMS data is stored per account.": "ക്ലയൻ്റ് മാനേജ്‌മെൻ്റ് ഉപയോഗിക്കുന്നതിന് ദയവായി ലോഗിൻ ചെയ്യുക. ഓരോ അക്കൗണ്ടിലും CMS ഡാറ്റ സംഭരിച്ചിരിക്കുന്നു.",
    "Login": "ലോഗിൻ ചെയ്യുക",
    "Loading live CMS data...": "തത്സമയ CMS ഡാറ്റ ലോഡുചെയ്യുന്നു...",
    "Quick Actions": "ദ്രുത പ്രവർത്തനങ്ങൾ",
    "Client Records": "ക്ലയൻ്റ് റെക്കോർഡുകൾ",
    "Client Record": "ക്ലയൻ്റ് റെക്കോർഡ്",
    "Client Profile": "ക്ലയൻ്റ് പ്രൊഫൈൽ",
    "Back to Clients": "ക്ലയൻ്റുകളിലേക്ക് മടങ്ങുക",
    "View": "കാണുക",
    "Edit": "എഡിറ്റ് ചെയ്യുക",
    "Delete": "ഇല്ലാതാക്കുക",
    "Note": "കുറിപ്പ്",
    "Archive": "ആർക്കൈവ്",
    "Download PDF": "PDF ഡൗൺലോഡ് ചെയ്യുക",
    "Delete this record?": "ഈ റെക്കോർഡ് ഇല്ലാതാക്കണോ?",
    "Unable to edit this CMS record.": "ഈ CMS റെക്കോർഡ് എഡിറ്റ് ചെയ്യാനായില്ല.",
    "Unable to update CMS record.": "CMS റെക്കോർഡ് അപ്ഡേറ്റ് ചെയ്യാനായില്ല.",
    "Unable to delete CMS record.": "CMS റെക്കോർഡ് ഇല്ലാതാക്കാൻ കഴിയുന്നില്ല.",
    "No contact added": "കോൺടാക്‌റ്റൊന്നും ചേർത്തിട്ടില്ല",
    "No topic": "വിഷയമില്ല",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "ഇതുവരെ ക്ലയൻ്റുകളൊന്നും കണ്ടെത്തിയില്ല. CMS ഡാഷ്‌ബോർഡ് പൂരിപ്പിക്കുന്നത് ആരംഭിക്കാൻ നിങ്ങളുടെ ആദ്യത്തെ യഥാർത്ഥ ക്ലയൻ്റ് ചേർക്കുക.",
    "Last Consultation": "അവസാന കൂടിയാലോചന",
    "Next Follow-up": "അടുത്ത ഫോളോ-അപ്പ്",
    "Date of Birth": "ജനനത്തീയതി",
    "Time of Birth": "ജനന സമയം",
    "Client Details": "ക്ലയൻ്റ് വിശദാംശങ്ങൾ",
    "No connected profiles yet.": "ഇതുവരെ ബന്ധിപ്പിച്ച പ്രൊഫൈലുകളൊന്നുമില്ല.",
    "Select a client record to view details.": "വിശദാംശങ്ങൾ കാണുന്നതിന് ഒരു ക്ലയൻ്റ് റെക്കോർഡ് തിരഞ്ഞെടുക്കുക.",
    "Record": "രേഖപ്പെടുത്തുക",
    "Consultation Summary": "കൺസൾട്ടേഷൻ സംഗ്രഹം",
    "Client Note": "ക്ലയൻ്റ് കുറിപ്പ്",
    "Start a consultation record with summary, topic, mode and payment fields.": "സംഗ്രഹം, വിഷയം, മോഡ്, പേയ്‌മെൻ്റ് ഫീൽഡുകൾ എന്നിവ ഉപയോഗിച്ച് ഒരു കൺസൾട്ടേഷൻ റെക്കോർഡ് ആരംഭിക്കുക.",
    "Start a private note attached to a client profile.": "ഒരു ക്ലയൻ്റ് പ്രൊഫൈലിൽ അറ്റാച്ച് ചെയ്‌തിരിക്കുന്ന ഒരു സ്വകാര്യ കുറിപ്പ് ആരംഭിക്കുക.",
    "Start a pending follow-up with due date and topic.": "നിശ്ചിത തീയതിയും വിഷയവും സഹിതം തീർച്ചപ്പെടുത്താത്ത ഫോളോ-അപ്പ് ആരംഭിക്കുക.",
    "Start a report record connected to the client timeline.": "ക്ലയൻ്റ് ടൈംലൈനുമായി ബന്ധിപ്പിച്ച ഒരു റിപ്പോർട്ട് റെക്കോർഡ് ആരംഭിക്കുക.",
    "Start an active remedy record for client guidance.": "ക്ലയൻ്റ് മാർഗ്ഗനിർദ്ദേശത്തിനായി ഒരു സജീവ പ്രതിവിധി റെക്കോർഡ് ആരംഭിക്കുക.",
    "Start an open prediction record with notes and follow-up date.": "കുറിപ്പുകളും ഫോളോ-അപ്പ് തീയതിയും ഉപയോഗിച്ച് ഒരു തുറന്ന പ്രവചന റെക്കോർഡ് ആരംഭിക്കുക.",
    "Statuses": "നിലകൾ",
    "Topics": "വിഷയങ്ങൾ",
    "Sources": "ഉറവിടങ്ങൾ",
    "No records found for the current filters.": "നിലവിലെ ഫിൽട്ടറുകൾക്കായി രേഖകളൊന്നും കണ്ടെത്തിയില്ല.",
    "Total Clients": "മൊത്തം ക്ലയൻ്റുകൾ",
    "New Clients This Month": "ഈ മാസം പുതിയ ഉപഭോക്താക്കൾ",
    "Consultations This Month": "ഈ മാസം കൂടിയാലോചനകൾ",
    "Today's Consultations": "ഇന്നത്തെ കൂടിയാലോചനകൾ",
    "Consultations scheduled for today from real client records.": "യഥാർത്ഥ ക്ലയൻ്റ് രേഖകളിൽ നിന്നുള്ള കൺസൾട്ടേഷനുകൾ ഇന്ന് ഷെഡ്യൂൾ ചെയ്തിട്ടുണ്ട്.",
    "No consultations scheduled for today.": "ഇന്ന് കൂടിയാലോചനകളൊന്നും ഷെഡ്യൂൾ ചെയ്തിട്ടില്ല.",
    "Pending Follow-ups": "ശേഷിക്കുന്ന തുടർനടപടികൾ",
    "Reports Created": "റിപ്പോർട്ടുകൾ സൃഷ്ടിച്ചു",
    "Active Remedies": "സജീവമായ പരിഹാരങ്ങൾ",
    "Open Predictions": "പ്രവചനങ്ങൾ തുറക്കുക",
    "Pending Payments": "തീർപ്പാക്കാത്ത പേയ്‌മെൻ്റുകൾ",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "ക്ലയൻ്റ് ആക്‌റ്റിവിറ്റി, സമീപകാല ജോലികൾ, ഫോളോ-അപ്പുകൾ, റിപ്പോർട്ടുകൾ, പ്രവചനങ്ങൾ, പരിഹാരങ്ങൾ, തീർപ്പാക്കാത്ത പേയ്‌മെൻ്റുകൾ എന്നിവ ഒരിടത്ത് കാണുക.",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "ജനന വിശദാംശങ്ങൾ, വിഷയങ്ങൾ, ടാഗുകൾ, സ്റ്റാറ്റസ്, ആർക്കൈവ്/പുനഃസ്ഥാപിക്കൽ പ്രവർത്തനങ്ങൾ എന്നിവ ഉപയോഗിച്ച് ജ്യോതിഷി ക്ലയൻ്റ് റെക്കോർഡുകൾ കൈകാര്യം ചെയ്യുക.",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "സെഷൻ വിശദാംശങ്ങൾ, ലിങ്ക് ചെയ്‌ത ചാർട്ടുകൾ, വിഷയങ്ങൾ, നിരീക്ഷണങ്ങൾ, പ്രവചനങ്ങൾ, പരിഹാരങ്ങൾ, തുടർന്നുള്ള തീയതികൾ എന്നിവ സംഭരിക്കുക.",
    "Keep private consultation notes and chart observations attached to client profiles.": "ക്ലയൻ്റ് പ്രൊഫൈലുകളിൽ സ്വകാര്യ കൺസൾട്ടേഷൻ കുറിപ്പുകളും ചാർട്ട് നിരീക്ഷണങ്ങളും അറ്റാച്ചുചെയ്യുക.",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "പുഷ്, SMS, ഇമെയിൽ അല്ലെങ്കിൽ WhatsApp അലേർട്ടുകൾ ഇല്ലാതെ ക്ലയൻ്റ് മാനേജ്‌മെൻ്റിനുള്ളിലെ ഇന്നത്തെയും വരാനിരിക്കുന്ന ഫോളോ-അപ്പുകളും ട്രാക്ക് ചെയ്യുക.",
    "Create and organize client reports generated from saved charts and consultation context.": "സംരക്ഷിച്ച ചാർട്ടുകളിൽ നിന്നും കൺസൾട്ടേഷൻ സന്ദർഭത്തിൽ നിന്നും സൃഷ്ടിച്ച ക്ലയൻ്റ് റിപ്പോർട്ടുകൾ സൃഷ്‌ടിക്കുകയും ഓർഗനൈസ് ചെയ്യുകയും ചെയ്യുക.",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "പ്രതിവിധികൾ അസൈൻ ചെയ്യുക, സജീവമായ മാർഗ്ഗനിർദ്ദേശം അടയാളപ്പെടുത്തുക, ക്ലയൻ്റ് ടൈംലൈനുമായി ബന്ധിപ്പിച്ചിട്ടുള്ള പ്രതിവിധി ചരിത്രം സൂക്ഷിക്കുക.",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "ഓരോ ക്ലയൻ്റിനുമുള്ള തുറന്ന പ്രവചനങ്ങൾ, തീയതികൾ, ആത്മവിശ്വാസ കുറിപ്പുകൾ, ഫല അപ്‌ഡേറ്റുകൾ എന്നിവ ട്രാക്കുചെയ്യുക.",
    "Plan consultations, follow-ups and payment dates in one working view.": "കൺസൾട്ടേഷനുകളും ഫോളോ-അപ്പുകളും പേയ്‌മെൻ്റ് തീയതികളും ഒരു വർക്കിംഗ് വ്യൂവിൽ പ്ലാൻ ചെയ്യുക.",
    "Prepare reusable consultation, report, remedy and prediction templates.": "പുനരുപയോഗിക്കാവുന്ന കൺസൾട്ടേഷൻ, റിപ്പോർട്ട്, പ്രതിവിധി, പ്രവചന ടെംപ്ലേറ്റുകൾ എന്നിവ തയ്യാറാക്കുക.",
    "Review client activity, consultation volume, reports created and pending work.": "ക്ലയൻ്റ് ആക്‌റ്റിവിറ്റി, കൺസൾട്ടേഷൻ വോളിയം, സൃഷ്‌ടിച്ച റിപ്പോർട്ടുകൾ, തീർപ്പാക്കാത്ത ജോലി എന്നിവ അവലോകനം ചെയ്യുക.",
    "Track consultation amounts and payment status without plan or pricing rules.": "പ്ലാൻ അല്ലെങ്കിൽ വിലനിർണ്ണയ നിയമങ്ങൾ ഇല്ലാതെ കൺസൾട്ടേഷൻ തുകയും പേയ്മെൻ്റ് നിലയും ട്രാക്ക് ചെയ്യുക.",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "ക്ലയൻ്റ് ഉറവിടങ്ങൾ, സ്റ്റാറ്റസുകൾ, വിഷയങ്ങൾ, ടാഗുകൾ, ആന്തരിക CMS മുൻഗണനകൾ എന്നിവ കോൺഫിഗർ ചെയ്യുക.",
    "Showing saved records connected to client records.": "ക്ലയൻ്റ് റെക്കോർഡുകളുമായി ബന്ധിപ്പിച്ച സംരക്ഷിച്ച റെക്കോർഡുകൾ കാണിക്കുന്നു.",
    "No Status": "സ്റ്റാറ്റസ് ഇല്ല",
    "No Mode": "മോഡ് ഇല്ല",
    "No Payment Status": "പേയ്‌മെൻ്റ് നില ഇല്ല",
    "No Topic": "വിഷയമില്ല",
    "No Source": "ഉറവിടമില്ല",
    "All Statuses": "എല്ലാ നിലകളും",
    "All Topics": "എല്ലാ വിഷയങ്ങളും",
    "No clients found": "ക്ലയൻ്റുകളൊന്നും കണ്ടെത്തിയില്ല",
    "Type to search clients": "ക്ലയൻ്റുകളെ തിരയാൻ ടൈപ്പ് ചെയ്യുക",
    "No charts found": "ചാർട്ടുകളൊന്നും കണ്ടെത്തിയില്ല",
    "Type to search saved charts": "സംരക്ഷിച്ച ചാർട്ടുകൾ തിരയാൻ ടൈപ്പ് ചെയ്യുക",
    "Type to search related client": "ബന്ധപ്പെട്ട ക്ലയൻ്റ് തിരയാൻ ടൈപ്പ് ചെയ്യുക",
    "Open": "തുറക്കുക",
    "Pending": "തീർപ്പാക്കാത്തത്",
    "Scheduled": "ഷെഡ്യൂൾ ചെയ്തു",
    "Completed": "പൂർത്തിയാക്കി",
    "Follow-up Pending": "തുടർനടപടികൾ തീർച്ചപ്പെടുത്തിയിട്ടില്ല",
    "Cancelled": "റദ്ദാക്കി",
    "Closed": "അടച്ചു",
    "No-show": "നോ-ഷോ",
    "Not Applicable": "ബാധകമല്ല",
    "Paid": "പണം നൽകി",
    "Partially Paid": "ഭാഗികമായി പണം നൽകി",
    "Refunded": "റീഫണ്ട് ചെയ്തു",
    "Phone": "ഫോൺ",
    "WhatsApp Call": "വാട്ട്‌സ്ആപ്പ് കോൾ",
    "Video Call": "വീഡിയോ കോൾ",
    "In-person": "വ്യക്തിപരമായി",
    "Chat": "ചാറ്റ്",
    "Other": "മറ്റുള്ളവ",
    "New": "പുതിയത്",
    "VIP": "വിഐപി",
    "Inactive": "നിഷ്ക്രിയം",
    "Consultation Completed": "കൺസൾട്ടേഷൻ പൂർത്തിയായി",
    "WhatsApp": "WhatsApp",
    "Instagram": "ഇൻസ്റ്റാഗ്രാം",
    "YouTube": "YouTube",
    "Referral": "റഫറൽ",
    "Website": "വെബ്സൈറ്റ്",
    "Walk-in": "വാക്ക്-ഇൻ",
    "Repeat Client": "ക്ലയൻ്റ് ആവർത്തിക്കുക",
    "Family Referral": "കുടുംബ റഫറൽ",
    "Business": "ബിസിനസ്സ്",
    "Finance": "ധനകാര്യം",
    "Property": "സ്വത്ത്",
    "Children": "കുട്ടികൾ",
    "Foreign Settlement": "വിദേശ സെറ്റിൽമെൻ്റ്",
    "Legal": "നിയമപരമായ",
    "Remedy": "പ്രതിവിധി",
    "General": "ജനറൽ",
    "Active": "സജീവമാണ്",
    "Past": "കഴിഞ്ഞത്",
    "Potential": "സാധ്യത",
    "Archived": "ആർക്കൈവ് ചെയ്തു",
    "Spouse": "ഇണ",
    "Husband": "ഭർത്താവ്",
    "Wife": "ഭാര്യ",
    "Child": "കുട്ടി",
    "Son": "മകൻ",
    "Daughter": "മകൾ",
    "Father": "അച്ഛൻ",
    "Mother": "അമ്മ",
    "Sibling": "സഹോദരൻ",
    "Brother": "സഹോദരൻ",
    "Sister": "സഹോദരി",
    "Marriage Prospect": "വിവാഹ സാധ്യത",
    "Fiance": "പ്രതിശ്രുതവധു",
    "Business Partner": "ബിസിനസ് പങ്കാളി",
    "Friend": "സുഹൃത്ത്",
    "Relative": "ബന്ധു",
    "Upgrade": "നവീകരിക്കുക",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "നിങ്ങൾക്ക് 2 ക്ലയൻ്റുകളെ മാത്രമേ ചേർക്കാൻ കഴിയൂ. കൂടുതൽ ഉപഭോക്താക്കൾക്കായി Premium-ലേക്ക് അപ്ഗ്രേഡ് ചെയ്യുക.",
    "None": "ഒന്നുമില്ല",
    "Education": "വിദ്യാഭ്യാസം",
    "Awards": "അവാർഡുകൾ",
    "Prize": "സമ്മാനം",
    "Career": "കരിയർ",
    "Love": "സ്നേഹം",
    "Marriage": "വിവാഹം",
    "Dowry or Legacy": "സ്ത്രീധനം അല്ലെങ്കിൽ പാരമ്പര്യം",
    "Divorce": "വിവാഹമോചനം",
    "Abortion": "ഗർഭച്ഛിദ്രം",
    "Child Birth": "കുട്ടിയുടെ ജനനം",
    "Property/Vehicle Purchase": "വസ്തു/വാഹനം വാങ്ങൽ",
    "Property/Vehicle Sale": "വസ്തു/വാഹന വിൽപ്പന",
    "Love and Caring": "സ്നേഹവും കരുതലും",
    "Depression": "വിഷാദം",
    "Aggression": "ആക്രമണോത്സുകത",
    "Health": "ആരോഗ്യം",
    "Travel": "യാത്ര",
    "Homecoming": "ഗൃഹപ്രവേശം",
    "Litigation": "വ്യവഹാരം",
    "Arrest": "അറസ്റ്റ് ചെയ്യുക",
    "Locked": "പൂട്ടി",
    "Strong": "ശക്തമായ",
    "Weak": "ദുർബലമായ",
    "Supportive": "പിന്തുണയ്ക്കുന്ന",
    "Avoid": "ഒഴിവാക്കുക",
    "Premium": "പ്രീമിയം",
    " UTC": "യുടിസി",
    "Unable to calculate Tithi Pravesh": "തിഥി പ്രവേശനം കണക്കാക്കാൻ കഴിയുന്നില്ല",
    "IANA timezone": "IANA സമയമേഖല",
    "TP Local": "ടിപി ലോക്കൽ",
    "TP UTC": "ടിപി യുടിസി",
    "Next TP Local": "അടുത്ത TP ലോക്കൽ",
    "Models: KP + Vedic": "മോഡലുകൾ: കെപി + വേദിക്",
    "Overall Year Theme": "മൊത്തത്തിലുള്ള വർഷം തീം",
    "Career & Job": "കരിയർ & ജോലി",
    "Finance & Savings": "ഫിനാൻസ് & സേവിംഗ്സ്",
    "Relationship & Marriage": "ബന്ധവും വിവാഹവും",
    "Family Matters": "കുടുംബകാര്യങ്ങൾ",
    "Property & Vehicle": "വസ്തുവും വാഹനവും",
    "Health & Wellness": "ആരോഗ്യവും ആരോഗ്യവും",
    "Spiritual Growth": "ആത്മീയ വളർച്ച",
    "Social Status & Recognition": "സാമൂഹിക നിലയും അംഗീകാരവും",
    "Please select a saved chart first.": "ദയവായി ആദ്യം സംരക്ഷിച്ച ഒരു ചാർട്ട് തിരഞ്ഞെടുക്കുക.",
    "Unable to generate Tajika Varshphal": "താജിക വർഷ്‌ഫലിനെ സൃഷ്‌ടിക്കാനായില്ല",
    "Premium yearly module": "പ്രീമിയം വാർഷിക മൊഡ്യൂൾ",
    "Tajika Varshphal": "താജിക വർഷ്ഫാൽ",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "ഈ സംരക്ഷിച്ച കുണ്ഡലിയിൽ നിന്ന് വ്യക്തിഗതമാക്കിയ വർഷ ലഗ്നം, മുൻത, വർഷ കർത്താവ്, സഹംസ്, പ്രതിമാസ മാർഗ്ഗനിർദ്ദേശം, പരിഹാരങ്ങൾ, പ്രായോഗിക ജീവിത തീമുകൾ എന്നിവയോടുകൂടിയ സൗര റിട്ടേൺ അടിസ്ഥാനമാക്കിയുള്ള വാർഷിക ജാതകം.",
    "Saved chart": "സംരക്ഷിച്ച ചാർട്ട്",
    "Untitled Chart": "ശീർഷകമില്ലാത്ത ചാർട്ട്",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "നിങ്ങളുടെ 4 സൗജന്യ പ്രീമിയം ക്രെഡിറ്റുകൾ ഉപയോഗിക്കുന്നു. അൺലിമിറ്റഡ് പ്രീമിയം ആക്‌സസിന് Kundlistar പ്രീമിയത്തിലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക.",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "നിങ്ങൾ 4 നിശൽക് പ്രീമിയം ക്രെഡിറ്റ് ഉപയോഗം ഉണ്ട്. അസീമിത് പ്രീമിയം എക്സസ് Kundlistar പ്രീമിയം ലെം.",
    "Core Year Markers": "കോർ ഇയർ മാർക്കറുകൾ",
    "Solar Return": "സോളാർ റിട്ടേൺ",
    "Varsha Lagna": "വർഷ ലഗ്നം",
    "Muntha Lord": "മുന്ത പ്രഭു",
    "Varsha Lord": "വർഷ പ്രഭു",
    "Varshesh Method": "വർഷേഷ് രീതി",
    "Yearly Summary": "വാർഷിക സംഗ്രഹം",
    "Not available yet.": "ഇതുവരെ ലഭ്യമല്ല.",
    "Varshesh Candidates": "വർഷേഷ് സ്ഥാനാർത്ഥികൾ",
    "Risk Areas": "റിസ്ക് ഏരിയകൾ",
    "Favourable Periods": "അനുകൂലമായ കാലഘട്ടങ്ങൾ",
    "Challenging Periods": "വെല്ലുവിളി നിറഞ്ഞ കാലഘട്ടങ്ങൾ",
    "Remedies & Final Advice": "പരിഹാരങ്ങളും അന്തിമ ഉപദേശവും",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "താജിക വർഷ്‌ഫല് പ്രതിവർഷം വ്യാഖ്യാന മാർഗ്ഗനിർദ്ദേശം നൽകുന്നു. ഇത് മെഡിക്കൽ, നിയമ, സാമ്പത്തിക അല്ലെങ്കിൽ ചില പ്രവചന ഉപദേശമായി കണക്കാക്കരുത്.",
    "Griha Pravesh": "ഗൃഹപ്രവേശം",
    "Purva Phalguni": "പൂർവ ഫാൽഗുനി",
    "Uttara Phalguni": "ഉത്തര ഫാൽഗുനി",
    "Purva Ashadha": "പൂർവാഷാഢം",
    "Uttara Ashadha": "ഉത്തര ആഷാഢം",
    "Purva Bhadrapada": "പൂർവ ഭാദ്രപദ",
    "Uttara Bhadrapada": "ഉത്തര ഭാദ്രപദ",
    "Param Mitra": "പരം മിത്ര",
    "Kundli birthplace": "കുണ്ഡലി ജന്മസ്ഥലം",
    "Selected city": "തിരഞ്ഞെടുത്ത നഗരം",
    "Muhurat - Kundlistar": "മുഹൂർത്തം - Kundlistar",
    "Please select a city first.": "ആദ്യം ഒരു നഗരം തിരഞ്ഞെടുക്കുക.",
    "Unable to calculate Muhurat.": "മുഹൂർത്തം കണക്കാക്കാൻ കഴിയുന്നില്ല.",
    "Unable to calculate personalized Muhurat.": "വ്യക്തിഗതമാക്കിയ മുഹൂർത്തം കണക്കാക്കാൻ കഴിയുന്നില്ല.",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "പഞ്ചാങ്, ചോഗാഡിയ, ഹോറ, താരബല, ചന്ദ്രബാല എന്നിവ ഉപയോഗിച്ച് പൊതുവായതും വ്യക്തിപരവുമായ മുഹൂർത്തം കണ്ടെത്തുക.",
    "Muhurat Finder": "മുഹൂർത്ത ഫൈൻഡർ",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "പഞ്ചാങ്, ചോഗാഡിയ, പ്രീമിയം വ്യക്തിഗത ജനന ഘടകങ്ങൾ എന്നിവ ഉപയോഗിച്ച് ഉപയോഗപ്രദമായ സമയ വിൻഡോകൾ കണ്ടെത്തുക.",
    "Search city...": "നഗരം തിരയുക...",
    "Using selected Kundli": "തിരഞ്ഞെടുത്ത കുണ്ഡലി ഉപയോഗിക്കുന്നു",
    "Find Free": "സൗജന്യമായി കണ്ടെത്തുക",
    "Free General Muhurat": "സൗജന്യ ജനറൽ മുഹൂർത്തം",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "അടുത്ത 7 ദിവസത്തേക്കുള്ള മികച്ച 3 സ്ലോട്ടുകൾ. രാഹുകാലം, യമഗണ്ഡം, ഗുളികകൾ എന്നിവ അകന്നു.",
    "Today's Muhurat": "ഇന്നത്തെ മുഹൂർത്തം",
    "Daily Muhurat by Kundlistar": "Kundlistar പ്രതിദിന മുഹൂർത്തം",
    "Shared via Kundlistar": "Kundlistar വഴി പങ്കിട്ടു",
    "Kundlistar Muhurat": "Kundlistar മുഹൂർത്തം",
    "Share Image": "ചിത്രം പങ്കിടുക",
    "Share Text": "വാചകം പങ്കിടുക",
    "Copy Text": "വാചകം പകർത്തുക",
    "Click Find Free to use the selected Kundli birthplace.": "തിരഞ്ഞെടുത്ത കുണ്ഡലി ജന്മസ്ഥലം ഉപയോഗിക്കുന്നതിന് സൗജന്യമായി കണ്ടെത്തുക ക്ലിക്ക് ചെയ്യുക.",
    "Select a city and click Find Free.": "ഒരു നഗരം തിരഞ്ഞെടുത്ത് സൗജന്യമായി കണ്ടെത്തുക ക്ലിക്കുചെയ്യുക.",
    "Premium Personalized Muhurat": "പ്രീമിയം വ്യക്തിഗതമാക്കിയ മുഹൂർത്തം",
    "Loading Kundli details...": "കുണ്ഡലി വിശദാംശങ്ങൾ ലോഡുചെയ്യുന്നു...",
    "Birth Nakshatra": "ജന്മനക്ഷത്രം",
    "Birth Moon Rashi": "ജന്മ ചന്ദ്രൻ രാശി",
    "Include night slots": "രാത്രി സ്ലോട്ടുകൾ ഉൾപ്പെടുത്തുക",
    "Find Premium": "പ്രീമിയം കണ്ടെത്തുക",
    "Your grounding and foundation energy appears strong in this chart.": "ഈ ചാർട്ടിൽ നിങ്ങളുടെ ഗ്രൗണ്ടിംഗും അടിസ്ഥാന ഊർജവും ശക്തമായി കാണപ്പെടുന്നു.",
    "Your grounding energy appears generally balanced in this chart.": "ഈ ചാർട്ടിൽ നിങ്ങളുടെ ഗ്രൗണ്ടിംഗ് എനർജി പൊതുവെ സന്തുലിതമായി കാണപ്പെടുന്നു.",
    "Reflection on routine, discipline, and inner stability may be useful.": "ദിനചര്യ, അച്ചടക്കം, ആന്തരിക സ്ഥിരത എന്നിവയെക്കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "Your creative and emotional flow energy appears strong in this chart.": "നിങ്ങളുടെ ക്രിയാത്മകവും വൈകാരികവുമായ ഒഴുക്ക് ഊർജ്ജം ഈ ചാർട്ടിൽ ശക്തമായി കാണപ്പെടുന്നു.",
    "Your creative energy appears balanced in this chart.": "നിങ്ങളുടെ സർഗ്ഗാത്മക ഊർജ്ജം ഈ ചാർട്ടിൽ സമതുലിതമായി കാണപ്പെടുന്നു.",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "സർഗ്ഗാത്മകത, വൈകാരിക പ്രകടനങ്ങൾ, ആന്തരിക പ്രവാഹം എന്നിവയെക്കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "Your confidence and willpower energy appears strong in this chart.": "നിങ്ങളുടെ ആത്മവിശ്വാസവും ഇച്ഛാശക്തിയും ഈ ചാർട്ടിൽ ശക്തമായി കാണപ്പെടുന്നു.",
    "Your action-taking energy appears balanced in this chart.": "നിങ്ങളുടെ പ്രവർത്തനക്ഷമമായ ഊർജ്ജം ഈ ചാർട്ടിൽ സന്തുലിതമായി കാണപ്പെടുന്നു.",
    "Reflection on confidence, discipline, and decision power may be useful.": "ആത്മവിശ്വാസം, അച്ചടക്കം, തീരുമാനശക്തി എന്നിവയെക്കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "Your connection and compassion energy appears strong in this chart.": "ഈ ചാർട്ടിൽ നിങ്ങളുടെ കണക്ഷനും അനുകമ്പയും ശക്തമായി കാണപ്പെടുന്നു.",
    "Your emotional connection energy appears balanced in this chart.": "നിങ്ങളുടെ വൈകാരിക കണക്ഷൻ ഊർജ്ജം ഈ ചാർട്ടിൽ സമതുലിതമായി കാണപ്പെടുന്നു.",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "ഐക്യം, ക്ഷമ, വൈകാരിക സന്തുലിതാവസ്ഥ എന്നിവയെക്കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "Your communication and expression energy appears strong in this chart.": "നിങ്ങളുടെ ആശയവിനിമയവും ഊർജവും ഈ ചാർട്ടിൽ ശക്തമായി കാണപ്പെടുന്നു.",
    "Your expression energy appears balanced in this chart.": "ഈ ചാർട്ടിൽ നിങ്ങളുടെ എക്സ്പ്രഷൻ എനർജി സന്തുലിതമായി കാണപ്പെടുന്നു.",
    "Reflection on clear communication and self-expression may be useful.": "വ്യക്തമായ ആശയവിനിമയത്തെയും സ്വയം പ്രകടിപ്പിക്കുന്നതിനെയും കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "Your intuition and inner clarity appears strong in this chart.": "നിങ്ങളുടെ അവബോധവും ആന്തരിക വ്യക്തതയും ഈ ചാർട്ടിൽ ശക്തമായി കാണപ്പെടുന്നു.",
    "Your intuitive clarity appears balanced in this chart.": "നിങ്ങളുടെ അവബോധജന്യമായ വ്യക്തത ഈ ചാർട്ടിൽ സമതുലിതമായി കാണപ്പെടുന്നു.",
    "Reflection on focus, intuition, and inner guidance may be useful.": "ഫോക്കസ്, അവബോധം, ആന്തരിക മാർഗനിർദേശം എന്നിവയെക്കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "A strong Fire element supports action, courage, and leadership energy.": "ശക്തമായ അഗ്നി ഘടകം പ്രവർത്തനം, ധൈര്യം, നേതൃത്വ ഊർജ്ജം എന്നിവയെ പിന്തുണയ്ക്കുന്നു.",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "തീ സന്തുലിതമായി കാണപ്പെടുന്നു, പ്രവർത്തനത്തിനും ക്ഷമയ്ക്കും ഇടയിലുള്ള സ്ഥിരമായ താളത്തെ പിന്തുണയ്ക്കുന്നു.",
    "Reflection on confidence and action-taking may be useful.": "ആത്മവിശ്വാസത്തെയും പ്രവർത്തനങ്ങളെയും കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "A strong Earth element supports practicality, patience, and stability.": "ശക്തമായ ഭൂമി മൂലകം പ്രായോഗികത, ക്ഷമ, സ്ഥിരത എന്നിവയെ പിന്തുണയ്ക്കുന്നു.",
    "Earth appears balanced, supporting practical thinking with flexibility.": "ഭൂമി സന്തുലിതമായി കാണപ്പെടുന്നു, പ്രായോഗിക ചിന്തയെ വഴക്കത്തോടെ പിന്തുണയ്ക്കുന്നു.",
    "Reflection on grounding, consistency, and planning may be useful.": "അടിസ്ഥാനം, സ്ഥിരത, ആസൂത്രണം എന്നിവയെക്കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "A strong Air element supports ideas, communication, and adaptability.": "ശക്തമായ എയർ ഘടകം ആശയങ്ങൾ, ആശയവിനിമയം, പൊരുത്തപ്പെടുത്തൽ എന്നിവയെ പിന്തുണയ്ക്കുന്നു.",
    "Air appears balanced, supporting harmony between thinking and action.": "വായു സന്തുലിതമായി കാണപ്പെടുന്നു, ചിന്തയും പ്രവർത്തനവും തമ്മിലുള്ള ഐക്യത്തെ പിന്തുണയ്ക്കുന്നു.",
    "Reflection on communication and flexibility may be useful.": "ആശയവിനിമയത്തെയും വഴക്കത്തെയും കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "ശക്തമായ ജല ഘടകം അവബോധം, സംവേദനക്ഷമത, വൈകാരിക ആഴം എന്നിവയെ പിന്തുണയ്ക്കുന്നു.",
    "Water appears balanced, supporting harmony between emotions and logic.": "ജലം സന്തുലിതമായി കാണപ്പെടുന്നു, വികാരങ്ങളും യുക്തിയും തമ്മിലുള്ള യോജിപ്പിനെ പിന്തുണയ്ക്കുന്നു.",
    "Reflection on emotional expression and inner connection may be useful.": "വൈകാരിക പ്രകടനത്തെയും ആന്തരിക ബന്ധത്തെയും കുറിച്ചുള്ള പ്രതിഫലനം ഉപയോഗപ്രദമാകും.",
    "A strong Ether element supports spiritual awareness and broader vision.": "ശക്തമായ ഈതർ ഘടകം ആത്മീയ അവബോധത്തെയും വിശാലമായ കാഴ്ചപ്പാടിനെയും പിന്തുണയ്ക്കുന്നു.",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ഈഥർ സമതുലിതമായി കാണപ്പെടുന്നു, ആത്മീയവും പ്രായോഗികവുമായ സമീപനം തമ്മിലുള്ള ഐക്യത്തെ പിന്തുണയ്ക്കുന്നു.",
    "Reflection, silence, and spiritual discipline may be useful.": "പ്രതിഫലനം, നിശബ്ദത, ആത്മീയ ശിക്ഷണം എന്നിവ ഉപയോഗപ്രദമാകും.",
    "For inner confidence, clarity, and soul strength.": "ആന്തരിക ആത്മവിശ്വാസത്തിനും വ്യക്തതയ്ക്കും ആത്മാവിൻ്റെ ശക്തിക്കും.",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "ഗ്രഹബലം, ലഗ്നാധിപൻ, ചന്ദ്രൻ രാശി, ആത്മകാരകൻ എന്നിവയെ അടിസ്ഥാനമാക്കിയാണ് ഈ ഇഷ്ടദേവതാ സൂചന.",
    "For calmness, emotional balance, and softness.": "ശാന്തത, വൈകാരിക ബാലൻസ്, മൃദുത്വം എന്നിവയ്ക്കായി.",
    "For courage, protection, and discipline.": "ധൈര്യത്തിനും സംരക്ഷണത്തിനും അച്ചടക്കത്തിനും.",
    "For intellect, speech, learning, and obstacle removal.": "ബുദ്ധി, സംസാരം, പഠനം, തടസ്സം നീക്കൽ എന്നിവയ്ക്കായി.",
    "For knowledge, guidance, dharma, and blessings.": "അറിവിനും മാർഗദർശനത്തിനും ധർമ്മത്തിനും അനുഗ്രഹത്തിനും.",
    "Mahalakshmi Ji": "മഹാലക്ഷ്മി ജി",
    "For harmony, beauty, comfort, and prosperity.": "ഐക്യം, സൗന്ദര്യം, സുഖം, സമൃദ്ധി എന്നിവയ്ക്കായി.",
    "For karma, patience, discipline, and protection.": "കർമ്മം, ക്ഷമ, അച്ചടക്കം, സംരക്ഷണം എന്നിവയ്ക്കായി.",
    "For protection from confusion, fear, and illusion.": "ആശയക്കുഴപ്പം, ഭയം, മിഥ്യാബോധം എന്നിവയിൽ നിന്നുള്ള സംരക്ഷണത്തിനായി.",
    "Lord Ganesha": "ഗണപതി ഭഗവാൻ",
    "For spiritual clarity, detachment, and obstacle removal.": "ആത്മീയ വ്യക്തത, വേർപിരിയൽ, തടസ്സം നീക്കൽ എന്നിവയ്ക്കായി.",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "ചക്ര ഇൻസൈറ്റിന് ചാർട്ട് ഡാറ്റ ആവശ്യമാണ്.",
    "Unable to load Chakra insight.": "ചക്ര ഉൾക്കാഴ്ച ലോഡ് ചെയ്യാനായില്ല.",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "വെറും ജന്മ കുണ്ഡലി ആധാരിത ആത്മീയ ഊർജ്ജ ഉൾക്കാഴ്ചയും സ്വയം പ്രതിഫലനവും ഉണ്ട്. യോ പ്രൊഫഷണൽ ഉപദേശം ഇല്ല.",
    "Spiritual energy insights from Kundli": "കുണ്ഡലിയിൽ നിന്നുള്ള ആത്മീയ ഊർജ്ജ ഉൾക്കാഴ്ചകൾ",
    "Calculated from your individual birth chart": "നിങ്ങളുടെ വ്യക്തിഗത ജനന ചാർട്ടിൽ നിന്ന് കണക്കാക്കിയത്",
    "Chakra Balance": "ചക്ര ബാലൻസ്",
    "Panch Tatva Balance": "പഞ്ച തത്വ ബാലൻസ്",
    "Ishta Devata": "ഇഷ്ട ദേവതാ",
    "Signal planet": "സിഗ്നൽ ഗ്രഹം",
    "Very Good": "വളരെ നല്ലത്",
    "Very Bad": "വളരെ മോശം",
    "Panch Pakshi Calculator - Kundlistar": "പഞ്ച് പക്ഷി കാൽക്കുലേറ്റർ - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "ചാർട്ടിൽ നിന്ന് പഞ്ച് പക്ഷി മുൻകൂട്ടി പൂരിപ്പിക്കാൻ കഴിഞ്ഞില്ല. നിങ്ങൾക്ക് ഇപ്പോഴും സ്വമേധയാ കണക്കാക്കാം.",
    "Could not load sunrise and sunset from Panchang for this chart location.": "ഈ ചാർട്ട് ലൊക്കേഷനായി പഞ്ചാങ്ങിൽ നിന്ന് സൂര്യോദയവും അസ്തമയവും ലോഡ് ചെയ്യാനായില്ല.",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "പഞ്ചാങ്ങിൽ നിന്ന് സൂര്യോദയം, സൂര്യാസ്തമയം, അടുത്ത സൂര്യോദയം എന്നിവ ലോഡ് ചെയ്യാനാവുന്നില്ല.",
    "Panch Pakshi calculation failed.": "പഞ്ചപക്ഷി കണക്കുകൂട്ടൽ പരാജയപ്പെട്ടു.",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "പഞ്ച് പക്ഷി പക്ഷി, പ്രവർത്തനം, യമം, അപഹാര കാലഘട്ടം, ബന്ധം, സ്കോർ, ഫലം എന്നിവ കണക്കാക്കുക.",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "നിങ്ങളുടെ സൗജന്യ പ്രീമിയം ക്രെഡിറ്റുകൾ പൂർത്തിയായി. തുടരാൻ Premium-ലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക.",
    "This is a premium feature. You can use 1 free premium credit to continue.": "ഇതൊരു പ്രീമിയം ഫീച്ചറാണ്. തുടരാൻ നിങ്ങൾക്ക് 1 സൗജന്യ പ്രീമിയം ക്രെഡിറ്റ് ഉപയോഗിക്കാം.",
    "Selected Date": "തിരഞ്ഞെടുത്ത തീയതി",
    "repeat(3, 1fr)": "ആവർത്തിക്കുക (3, 1fr)",
    "Birth Paksha": "ജന്മ പക്ഷ",
    "Current Paksha": "നിലവിലെ പക്ഷ",
    "repeat(4, 1fr)": "ആവർത്തിക്കുക (4, 1fr)",
    "Target Date Time": "ടാർഗെറ്റ് തീയതി സമയം",
    "Next Sunrise": "അടുത്ത സൂര്യോദയം",
    "Calculate Panch Pakshi": "പഞ്ച് പക്ഷി കണക്കാക്കുക",
    "repeat(2, 1fr)": "ആവർത്തിക്കുക (2, 1fr)",
    "repeat(6, 1fr)": "ആവർത്തിക്കുക (6, 1fr)",
    "Birth Pakshi": "ജനന പക്ഷി",
    "Current Period": "നിലവിലെ കാലയളവ്",
    "Current Yamam": "ഇപ്പോഴത്തെ യമം",
    "Main Activity": "പ്രധാന പ്രവർത്തനം",
    "Natal Western Chart": "നേറ്റൽ വെസ്റ്റേൺ ചാർട്ട്",
    "Life Phase Progression": "ജീവിത ഘട്ട പുരോഗതി",
    "Self-focus, identity change, body awareness and personal reset.": "സ്വയം ഫോക്കസ്, ഐഡൻ്റിറ്റി മാറ്റം, ശരീര അവബോധം, വ്യക്തിഗത പുനഃസജ്ജീകരണം.",
    "Money, values, family, speech and security become emotionally important.": "പണം, മൂല്യങ്ങൾ, കുടുംബം, സംസാരം, സുരക്ഷ എന്നിവ വൈകാരികമായി പ്രധാനമാണ്.",
    "Communication, learning, siblings, writing and short travel become important.": "ആശയവിനിമയം, പഠനം, സഹോദരങ്ങൾ, എഴുത്ത്, ചെറു യാത്രകൾ എന്നിവ പ്രധാനമാകുന്നു.",
    "Home, mother, property, family and emotional roots become important.": "വീട്, അമ്മ, സ്വത്ത്, കുടുംബം, വൈകാരിക വേരുകൾ എന്നിവ പ്രധാനമാണ്.",
    "Creativity, romance, children, hobbies and self-expression become important.": "സർഗ്ഗാത്മകത, പ്രണയം, കുട്ടികൾ, ഹോബികൾ, സ്വയം പ്രകടിപ്പിക്കൽ എന്നിവ പ്രധാനമാണ്.",
    "Work routine, health habits, service and discipline become important.": "ജോലിയുടെ പതിവ്, ആരോഗ്യ ശീലങ്ങൾ, സേവനം, അച്ചടക്കം എന്നിവ പ്രധാനമാണ്.",
    "Relationship, marriage, partnership and public dealing become important.": "ബന്ധം, വിവാഹം, പങ്കാളിത്തം, പൊതു ഇടപാടുകൾ എന്നിവ പ്രധാനമാണ്.",
    "Deep emotional change, intimacy, shared money and transformation become important.": "ആഴത്തിലുള്ള വൈകാരിക മാറ്റം, അടുപ്പം, പങ്കിട്ട പണം, പരിവർത്തനം എന്നിവ പ്രധാനമാണ്.",
    "Learning, travel, teaching, belief and higher wisdom become important.": "പഠനം, യാത്ര, പഠിപ്പിക്കൽ, വിശ്വാസം, ഉയർന്ന ജ്ഞാനം എന്നിവ പ്രധാനമാണ്.",
    "Career, status, public image and responsibility become emotionally important.": "കരിയർ, പദവി, പൊതു പ്രതിച്ഛായ, ഉത്തരവാദിത്തം എന്നിവ വൈകാരികമായി പ്രാധാന്യമർഹിക്കുന്നു.",
    "Income, friends, networking, community and ambitions become important.": "വരുമാനം, സുഹൃത്തുക്കൾ, നെറ്റ്‌വർക്കിംഗ്, സമൂഹം, അഭിലാഷങ്ങൾ എന്നിവ പ്രധാനമാണ്.",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "വിശ്രമം, ഒറ്റപ്പെടൽ, ആത്മീയത, വിദേശ ബന്ധം, ആന്തരിക സൗഖ്യം എന്നിവ പ്രധാനമാണ്.",
    "Identity development and self-expression are central.": "ഐഡൻ്റിറ്റി ഡെവലപ്‌മെൻ്റും സ്വയം പ്രകടിപ്പിക്കലും കേന്ദ്രമാണ്.",
    "Values, money and self-worth become central.": "മൂല്യങ്ങളും പണവും ആത്മാഭിമാനവും കേന്ദ്രമാകുന്നു.",
    "Communication, learning and skills become central.": "ആശയവിനിമയം, പഠനം, കഴിവുകൾ എന്നിവ കേന്ദ്രീകരിക്കുന്നു.",
    "Home, roots and emotional foundation become central.": "വീടും വേരുകളും വൈകാരിക അടിത്തറയും കേന്ദ്രമാകും.",
    "Creativity, love and self-expression become central.": "സർഗ്ഗാത്മകത, സ്നേഹം, സ്വയം പ്രകടിപ്പിക്കൽ എന്നിവ കേന്ദ്രീകരിക്കുന്നു.",
    "Work, discipline and health routines become central.": "ജോലി, അച്ചടക്കം, ആരോഗ്യ ദിനചര്യകൾ എന്നിവ കേന്ദ്രീകൃതമാകുന്നു.",
    "Partnerships and relationship identity become central.": "പങ്കാളിത്തങ്ങളും ബന്ധങ്ങളുടെ ഐഡൻ്റിറ്റിയും കേന്ദ്രമായി മാറുന്നു.",
    "Transformation, deep healing and shared resources become central.": "പരിവർത്തനം, ആഴത്തിലുള്ള രോഗശാന്തി, പങ്കിടൽ വിഭവങ്ങൾ എന്നിവ കേന്ദ്രമായി മാറുന്നു.",
    "Wisdom, travel, belief and higher learning become central.": "ജ്ഞാനം, യാത്ര, വിശ്വാസം, ഉന്നത പഠനം എന്നിവ കേന്ദ്രമായി മാറുന്നു.",
    "Career, authority and public role become central.": "കരിയർ, അധികാരം, പൊതു പങ്ക് എന്നിവ കേന്ദ്രമായി മാറുന്നു.",
    "Community, income, goals and networks become central.": "സമൂഹവും വരുമാനവും ലക്ഷ്യങ്ങളും ശൃംഖലകളും കേന്ദ്രമായി മാറുന്നു.",
    "Spirituality, closure, retreat and inner development become central.": "ആത്മീയത, അടച്ചുപൂട്ടൽ, പിൻവാങ്ങൽ, ആന്തരിക വികസനം എന്നിവ കേന്ദ്രമായി മാറുന്നു.",
    "This house becomes emotionally important.": "ഈ വീട് വൈകാരികമായി പ്രാധാന്യമർഹിക്കുന്നു.",
    "This house becomes central for identity development.": "ഈ വീട് ഐഡൻ്റിറ്റി വികസനത്തിൻ്റെ കേന്ദ്രമായി മാറുന്നു.",
    "Thinking, communication, learning and decisions are developing through this house.": "ചിന്തയും ആശയവിനിമയവും പഠനവും തീരുമാനങ്ങളും ഈ വീടിലൂടെ വികസിക്കുന്നു.",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "സ്നേഹം, സുഖം, മൂല്യങ്ങൾ, സൗന്ദര്യം, പണ മുൻഗണനകൾ എന്നിവ ഈ വീടിലൂടെ വികസിക്കുന്നു.",
    "Action style, courage, ambition and drive are developing through this house.": "ആക്ഷൻ ശൈലി, ധൈര്യം, അഭിലാഷം, ഡ്രൈവ് എന്നിവ ഈ വീടിലൂടെ വികസിക്കുന്നു.",
    "Growth, faith, learning and expansion themes develop through this house.": "വളർച്ച, വിശ്വാസം, പഠനം, വിപുലീകരണ തീമുകൾ എന്നിവ ഈ ഭവനത്തിലൂടെ വികസിക്കുന്നു.",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "പക്വത, ഉത്തരവാദിത്തം, അച്ചടക്കം, ദീർഘകാല ഘടന എന്നിവ ഈ ഭവനത്തിലൂടെ വികസിക്കുന്നു.",
    "This progressed planet shows an inner life phase through this house.": "ഈ പുരോഗമിച്ച ഗ്രഹം ഈ വീടിലൂടെ ഒരു ആന്തരിക ജീവിത ഘട്ടം കാണിക്കുന്നു.",
    "New Moon Phase": "ന്യൂ മൂൺ ഘട്ടം",
    "New beginning, identity reset and fresh internal cycle.": "പുതിയ തുടക്കം, ഐഡൻ്റിറ്റി റീസെറ്റ്, പുതിയ ആന്തരിക സൈക്കിൾ.",
    "Crescent Phase": "ക്രസൻ്റ് ഘട്ടം",
    "Growth, effort, learning and building confidence.": "വളർച്ച, പരിശ്രമം, പഠനം, ആത്മവിശ്വാസം വളർത്തൽ.",
    "First Quarter Phase": "ആദ്യ പാദ ഘട്ടം",
    "Action, decision-making, pressure and development.": "പ്രവർത്തനം, തീരുമാനമെടുക്കൽ, സമ്മർദ്ദം, വികസനം.",
    "Gibbous Phase": "ഗിബ്ബസ് ഘട്ടം",
    "Refinement, improvement, preparation and skill-building.": "ശുദ്ധീകരണം, മെച്ചപ്പെടുത്തൽ, തയ്യാറെടുപ്പ്, നൈപുണ്യ വികസനം.",
    "Full Moon Phase": "പൂർണ്ണ ചന്ദ്ര ഘട്ടം",
    "Visibility, relationship awareness, emotional clarity and results.": "ദൃശ്യപരത, ബന്ധ അവബോധം, വൈകാരിക വ്യക്തതയും ഫലങ്ങളും.",
    "Disseminating Phase": "പ്രചരിപ്പിക്കുന്ന ഘട്ടം",
    "Sharing, teaching, communication and distributing experience.": "അനുഭവം പങ്കിടൽ, പഠിപ്പിക്കൽ, ആശയവിനിമയം, വിതരണം.",
    "Last Quarter Phase": "അവസാന ക്വാർട്ടർ ഘട്ടം",
    "Reorientation, correction, release and mature decision-making.": "പുനഃക്രമീകരിക്കൽ, തിരുത്തൽ, റിലീസ്, പക്വതയുള്ള തീരുമാനമെടുക്കൽ.",
    "Balsamic Phase": "ബാൽസാമിക് ഘട്ടം",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "അടച്ചുപൂട്ടൽ, ആത്മീയ പ്രതിഫലനം, വിശ്രമം, ഒരു പുതിയ ചക്രത്തിനായുള്ള തയ്യാറെടുപ്പ്.",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "ഒരു പ്രധാന വൈകാരികവും വ്യക്തിത്വവുമായ ഘട്ടം ആരംഭിക്കുന്നു. ഒരു വ്യക്തി ഒരു പുതിയ അധ്യായത്തിന് തയ്യാറാണെന്ന് തോന്നിയേക്കാം.",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "വൈകാരിക പുനഃസജ്ജീകരണ കാലയളവ്. കുടുംബം, ആശ്വാസം, ആന്തരിക സമാധാനം, വൈകാരിക ആവശ്യങ്ങൾ എന്നിവ പ്രധാനമാണ്.",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "സ്നേഹം, ബന്ധം, സുഖം, സൗന്ദര്യം, വൈകാരിക ബന്ധം എന്നിവ പ്രധാനമാണ്.",
    "Emotional needs and relationship expectations may need adjustment.": "വൈകാരിക ആവശ്യങ്ങൾക്കും ബന്ധങ്ങളുടെ പ്രതീക്ഷകൾക്കും ക്രമീകരണം ആവശ്യമായി വന്നേക്കാം.",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "ഊർജ്ജം, അഭിനിവേശം, അക്ഷമ, പ്രവൃത്തി എന്നിവ വർദ്ധിക്കുന്നു. വൈകാരിക പ്രതികരണങ്ങൾ വേഗത്തിലായേക്കാം.",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "വൈകാരിക അസ്വസ്ഥത, കോപം, സംഘർഷം അല്ലെങ്കിൽ അടിയന്തിര പ്രവർത്തനം എന്നിവ വർദ്ധിക്കും.",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "ഗുരുതരമായ വൈകാരിക ഘട്ടം. ഉത്തരവാദിത്തം, പക്വത, കുടുംബ സമ്മർദ്ദം അല്ലെങ്കിൽ ആന്തരിക അച്ചടക്കം എന്നിവ വർദ്ധിച്ചേക്കാം.",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "വൈകാരിക ഭാരമോ ഉത്തരവാദിത്തമോ അനുഭവപ്പെട്ടേക്കാം. ക്ഷമയും പക്വതയും ആവശ്യമാണ്.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "പിന്തുണയുള്ള വൈകാരിക വളർച്ച, ശുഭാപ്തിവിശ്വാസം, യാത്ര, പഠനം, അനുഗ്രഹങ്ങൾ എന്നിവ വർദ്ധിക്കും.",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "വളർച്ചയെ അടിസ്ഥാനമാക്കിയുള്ള വൈകാരിക ഘട്ടം. പഠനത്തിനും വിപുലീകരണത്തിനും പിന്തുണക്കും നല്ല തീരുമാനങ്ങൾക്കും നല്ലതാണ്.",
    "Identity, love, beauty, money values and creative expression become highlighted.": "വ്യക്തിത്വം, സ്നേഹം, സൗന്ദര്യം, പണമൂല്യങ്ങൾ, സൃഷ്ടിപരമായ ആവിഷ്കാരം എന്നിവ ഹൈലൈറ്റ് ചെയ്യപ്പെടുന്നു.",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "ആത്മവിശ്വാസം, ധൈര്യം, അഭിലാഷം, പ്രവൃത്തി എന്നിവ വർദ്ധിക്കുന്നു. ഒരു പുതിയ സജീവ ഘട്ടം ആരംഭിക്കുന്നതിന് നല്ലതാണ്.",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "ഒരു മെച്യൂരിറ്റി ടെസ്റ്റ്. ഉത്തരവാദിത്തം, കാലതാമസം, സമ്മർദ്ദം അല്ലെങ്കിൽ കരിയർ പുനർനിർമ്മാണം എന്നിവ സംഭവിക്കാം.",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "വളർച്ച, ആത്മവിശ്വാസം, ജ്ഞാനം, അംഗീകാരം, അവസരം എന്നിവ വർദ്ധിക്കും.",
    "Mental clarity, communication, study, writing and business decisions become important.": "മാനസിക വ്യക്തത, ആശയവിനിമയം, പഠനം, എഴുത്ത്, ബിസിനസ്സ് തീരുമാനങ്ങൾ എന്നിവ പ്രധാനമാണ്.",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "ഒരു പുതിയ മാനസിക ചക്രം ആരംഭിക്കുന്നു. പഠനം, ആശയവിനിമയം, എഴുത്ത്, നൈപുണ്യ വികസനം എന്നിവയ്ക്ക് നല്ലതാണ്.",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "സ്നേഹം, സൗന്ദര്യം, സുഖം, സാമൂഹിക ജീവിതം, മൂല്യങ്ങൾ എന്നിവ സ്വത്വവുമായി ശക്തമായി ബന്ധപ്പെട്ടിരിക്കുന്നു.",
    "Action, confidence, ambition and personal drive become stronger.": "പ്രവർത്തനം, ആത്മവിശ്വാസം, അഭിലാഷം, വ്യക്തിഗത ഡ്രൈവ് എന്നിവ ശക്തമാകുന്നു.",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "പുരോഗമിച്ച ബുധൻ പഠനം, ആശയവിനിമയം, ബിസിനസ്സ്, എഴുത്ത്, മാർക്കറ്റിംഗ്, കോഡിംഗ് അല്ലെങ്കിൽ വിശകലന പ്രവർത്തനങ്ങൾ എന്നിവയെ പിന്തുണയ്ക്കുന്നു.",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "പുരോഗമിച്ച ചൊവ്വ പ്രവർത്തനം, ധൈര്യം, മത്സരം, സാങ്കേതിക ജോലി, സജീവമായ കരിയർ തീരുമാനങ്ങൾ എന്നിവയെ പിന്തുണയ്ക്കുന്നു.",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "പുരോഗമിച്ച ശുക്രൻ സാമ്പത്തിക മൂല്യങ്ങൾ, സുഖം, നേട്ടങ്ങൾ, ആഡംബരം, കല അല്ലെങ്കിൽ ബന്ധങ്ങളെ അടിസ്ഥാനമാക്കിയുള്ള വരുമാന തീമുകൾ എന്നിവ പിന്തുണയ്ക്കുന്നു.",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "പുരോഗമിച്ച വ്യാഴത്തിന് വളർച്ചയെ അടിസ്ഥാനമാക്കിയുള്ള സാമ്പത്തിക ചിന്തയും വിഭവങ്ങളുടെ വിപുലീകരണവും കാണിക്കാൻ കഴിയും.",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "പുരോഗമിച്ച സൂര്യൻ, ചന്ദ്രൻ, ബുധൻ, ചൊവ്വ എന്നിവയിൽ നിന്നും ജന്മസൂര്യൻ, ശനി, മദ്ധ്യാകാശം എന്നീ ഭാവങ്ങളിൽ നിന്നും കരിയർ ഘട്ടം വിലയിരുത്തണം.",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "പുരോഗമിച്ച ചന്ദ്രൻ, ശുക്രൻ, ചൊവ്വ എന്നിവയിൽ നിന്നും ജനന ചന്ദ്രൻ, ശുക്രൻ, ചൊവ്വ, ഏഴാം ഭാവം എന്നിവയിലേക്കുള്ള ഭാവങ്ങളും ലവ് ഘട്ടം വിലയിരുത്തണം.",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "പുരോഗമിച്ച ചന്ദ്രൻ, ശുക്രൻ, വ്യാഴം, ജനന 2, 8, 11 എന്നീ ഗൃഹ ബന്ധങ്ങളിൽ നിന്നാണ് പണത്തിൻ്റെ ഘട്ടം വിലയിരുത്തേണ്ടത്.",
    "Western Astrology - Kundlistar": "പാശ്ചാത്യ ജ്യോതിഷം - Kundlistar",
    "No chart data available for preview": "പ്രിവ്യൂവിന് ചാർട്ട് ഡാറ്റയൊന്നും ലഭ്യമല്ല",
    "Failed to load chart": "ചാർട്ട് ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    "Chart not found": "ചാർട്ട് കണ്ടെത്തിയില്ല",
    "Western Astrology Module | Kundlistar": "പാശ്ചാത്യ ജ്യോതിഷ ഘടകം | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "നേറ്റൽ ചാർട്ട് പൊസിഷനുകൾ, പ്ലാസിഡസ് ഹൗസ് കപ്‌സ്, ബാഹ്യ ഗ്രഹങ്ങൾ, പ്രീമിയം ട്രാൻസിറ്റുകൾ, സോളാർ റിട്ടേൺ, സിനാസ്ട്രി സവിശേഷതകൾ എന്നിവ ഉപയോഗിച്ച് Kundlistar ഉള്ളിൽ പാശ്ചാത്യ ജ്യോതിഷം പര്യവേക്ഷണം ചെയ്യുക.",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "പാശ്ചാത്യ ജ്യോതിഷം, നേറ്റൽ ചാർട്ട്, ട്രാൻസിറ്റുകൾ, സോളാർ റിട്ടേൺ, സിനാസ്ട്രി, Kundlistar",
    "New section": "പുതിയ വിഭാഗം",
    "Premium active": "പ്രീമിയം സജീവമാണ്",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "ഹൗസ് സിസ്റ്റം",
    "Placidus cusps": "പ്ലാസിഡസ് കസ്പ്സ്",
    "Part of Fortune": "ഫോർച്യൂണിൻ്റെ ഭാഗം",
    "Natal Western Aspects": "നേറ്റൽ പാശ്ചാത്യ വശങ്ങൾ",
    "No major Western aspects found within the configured orbs.": "ക്രമീകരിച്ച ഓർബുകളിൽ പ്രധാന പാശ്ചാത്യ വശങ്ങളൊന്നും കണ്ടെത്തിയില്ല.",
    "Western natal astrology wheel": "പാശ്ചാത്യ ജന്മ ജ്യോതിഷ ചക്രം",
    "Western Transits": "പടിഞ്ഞാറൻ ഗതാഗതം",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "ലോഡ് ചെയ്ത ചാർട്ട് ജന്മസ്ഥലം ഉപയോഗിച്ചുള്ള നിലവിലെ ട്രാൻസിറ്റ്-ടു-നാറ്റൽ കണക്കുകൂട്ടലുകൾ.",
    "Natal points available": "നേറ്റൽ പോയിൻ്റുകൾ ലഭ്യമാണ്",
    "Transit planets loaded": "ട്രാൻസിറ്റ് ഗ്രഹങ്ങൾ ലോഡ് ചെയ്തു",
    "Loading current transit positions...": "നിലവിലെ ട്രാൻസിറ്റ് സ്ഥാനങ്ങൾ ലോഡ് ചെയ്യുന്നു...",
    "Aspect method": "വീക്ഷണ രീതി",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "വെസ്റ്റേൺ ഓർബുകളുമായുള്ള സംയോജനം, സെക്‌സ്റ്റൈൽ, ചതുരം, ത്രികോണം, എതിർപ്പ്",
    "Primary focus": "പ്രാഥമിക ഫോക്കസ്",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "ജന്മനായുള്ള സൂര്യൻ, ചന്ദ്രൻ, ആരോഹണം, ശുക്രൻ, ചൊവ്വ, വ്യാഴം, ശനി, ബാഹ്യഗ്രഹങ്ങൾ എന്നിവയിലേക്കുള്ള സംക്രമണ ബന്ധങ്ങൾ",
    "Natal inner wheel": "നേറ്റൽ ആന്തരിക ചക്രം",
    "Transit outer wheel": "ട്രാൻസിറ്റ് പുറം ചക്രം",
    "Current Transit Positions": "നിലവിലെ ട്രാൻസിറ്റ് സ്ഥാനങ്ങൾ",
    "Transit positions are not available.": "ട്രാൻസിറ്റ് സ്ഥാനങ്ങൾ ലഭ്യമല്ല.",
    "Current Transit Aspects to Natal Chart": "നേറ്റൽ ചാർട്ടിലേക്കുള്ള നിലവിലെ ട്രാൻസിറ്റ് വശങ്ങൾ",
    "Loading transit aspects...": "ട്രാൻസിറ്റ് വശങ്ങൾ ലോഡ് ചെയ്യുന്നു...",
    "No major transit aspects found within the configured orbs.": "ക്രമീകരിച്ച ഓർബുകളിൽ പ്രധാന ട്രാൻസിറ്റ് വശങ്ങളൊന്നും കണ്ടെത്തിയില്ല.",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "നേറ്റൽ സൂര്യനിൽ നിന്നുള്ള വാർഷിക പാശ്ചാത്യ റിട്ടേൺ റഫറൻസ്, നേറ്റൽ വശ സന്ദർഭത്തെ പിന്തുണയ്ക്കുന്നു.",
    "Solar return date": "സോളാർ റിട്ടേൺ തീയതി",
    "Calculation time": "കണക്കുകൂട്ടൽ സമയം",
    "Birth date not available": "ജനനത്തീയതി ലഭ്യമല്ല",
    "Natal Sun": "നേറ്റൽ സൺ",
    "Natal Sun house": "നടാൽ സൺ ഹൗസ്",
    "Return planets loaded": "തിരികെ ഗ്രഹങ്ങൾ ലോഡ് ചെയ്തു",
    "Loading solar return chart...": "സോളാർ റിട്ടേൺ ചാർട്ട് ലോഡ് ചെയ്യുന്നു...",
    "Annual focus": "വാർഷിക ശ്രദ്ധ",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "സോളാർ തീമുകൾ ജനിച്ച സൂര്യൻ, റിട്ടേൺ അസെൻഡൻ്റ്, വാർഷിക റിട്ടേൺ ചാർട്ട് എന്നിവയിൽ നിന്ന് വായിക്കുന്നു.",
    "Solar Return Planet Positions": "സോളാർ റിട്ടേൺ പ്ലാനറ്റ് സ്ഥാനങ്ങൾ",
    "Loading solar return planets...": "സോളാർ റിട്ടേൺ പ്ലാനറ്റുകൾ ലോഡ് ചെയ്യുന്നു...",
    "Solar return positions are not available.": "സോളാർ റിട്ടേൺ സ്ഥാനങ്ങൾ ലഭ്യമല്ല.",
    "Solar Return House Cusps": "സോളാർ റിട്ടേൺ ഹൗസ് കസ്പ്സ്",
    "Loading solar return cusps...": "സോളാർ റിട്ടേൺ കപ്പുകൾ ലോഡുചെയ്യുന്നു...",
    "Solar return house cusps are not available.": "സോളാർ റിട്ടേൺ ഹൗസ് കസപ്പുകൾ ലഭ്യമല്ല.",
    "Solar Return Aspects to Natal Chart": "നേറ്റൽ ചാർട്ടിലേക്കുള്ള സോളാർ റിട്ടേൺ വശങ്ങൾ",
    "Loading solar return aspects...": "സോളാർ റിട്ടേൺ വശങ്ങൾ ലോഡ് ചെയ്യുന്നു...",
    "No major solar return aspects found within the configured orbs.": "കോൺഫിഗർ ചെയ്‌ത ഓർബുകളിൽ പ്രധാന സോളാർ റിട്ടേൺ വശങ്ങളൊന്നും കണ്ടെത്തിയില്ല.",
    "Natal Sun Aspects for Solar Return Focus": "സോളാർ റിട്ടേൺ ഫോക്കസിനായുള്ള നേറ്റൽ സൺ വശങ്ങൾ",
    "No major natal Sun aspects found within the configured orbs.": "കോൺഫിഗർ ചെയ്‌ത ഭ്രമണപഥങ്ങളിൽ സൂര്യൻ്റെ പ്രധാന ഭാവങ്ങളൊന്നും കണ്ടെത്തിയില്ല.",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "പ്ലാനറ്റ്-ടു-പ്ലാനറ്റ് വശങ്ങൾ, ആംഗിൾ കോൺടാക്റ്റുകൾ, ഹൗസ് ഓവർലേകൾ എന്നിവ ഉപയോഗിച്ച് റിലേഷൻഷിപ്പ് ഓവർലേ ഫ്രെയിംവർക്ക്.",
    "Loaded first chart": "ആദ്യ ചാർട്ട് ലോഡ് ചെയ്തു",
    "Second chart": "രണ്ടാമത്തെ ചാർട്ട്",
    "Select or load partner chart to calculate full synastry overlay": "സമ്പൂർണ്ണ സിനാസ്ട്രി ഓവർലേ കണക്കാക്കാൻ പങ്കാളി ചാർട്ട് തിരഞ്ഞെടുക്കുക അല്ലെങ്കിൽ ലോഡ് ചെയ്യുക",
    "Major inter-chart aspects with tight orb priority": "ഇറുകിയ ഓർബ് മുൻഗണനയുള്ള പ്രധാന ഇൻ്റർ-ചാർട്ട് വശങ്ങൾ",
    "House overlay method": "ഹൗസ് ഓവർലേ രീതി",
    "Partner planets are placed into the first chart houses after second chart is selected": "രണ്ടാമത്തെ ചാർട്ട് തിരഞ്ഞെടുത്തതിന് ശേഷം പങ്കാളി ഗ്രഹങ്ങളെ ആദ്യ ചാർട്ട് ഹൗസുകളിൽ സ്ഥാപിക്കും",
    "Relationship Pattern Aspects from Loaded Chart": "ലോഡ് ചെയ്ത ചാർട്ടിൽ നിന്നുള്ള ബന്ധത്തിൻ്റെ പാറ്റേൺ വശങ്ങൾ",
    "No major relationship-focused natal aspects found within the configured orbs.": "കോൺഫിഗർ ചെയ്‌ത ഓർബുകളിൽ പ്രധാന ബന്ധങ്ങളെ കേന്ദ്രീകരിച്ചുള്ള നേറ്റൽ വശങ്ങളൊന്നും കണ്ടെത്തിയില്ല.",
    "Understand your current inner life phase through Western Secondary Progressions.": "പാശ്ചാത്യ ദ്വിതീയ പുരോഗതിയിലൂടെ നിങ്ങളുടെ നിലവിലെ ആന്തരിക ജീവിത ഘട്ടം മനസ്സിലാക്കുക.",
    "Secondary Progression": "ദ്വിതീയ പുരോഗതി",
    "1 day after birth = 1 year of life": "ജനിച്ച് 1 ദിവസം = ജീവിതത്തിൻ്റെ 1 വർഷം",
    "Current age used": "ഉപയോഗിക്കുന്ന നിലവിലെ പ്രായം",
    "Progressed date": "പുരോഗമിച്ച തീയതി",
    "Progressed Moon": "പുരോഗമിച്ച ചന്ദ്രൻ",
    "Loading progressed Moon...": "ലോഡിംഗ് പുരോഗമിച്ച ചന്ദ്രൻ...",
    "Progressed Moon phase": "പുരോഗമിച്ച ചന്ദ്ര ഘട്ടം",
    "Loading Moon phase...": "ചന്ദ്രൻ്റെ ഘട്ടം ലോഡ് ചെയ്യുന്നു...",
    "Current Life Phase": "നിലവിലെ ജീവിത ഘട്ടം",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "ദ്വിതീയ പുരോഗതികൾ ജീവിതത്തിൻ്റെ ആന്തരിക ഘട്ടം, വൈകാരിക പക്വത, സ്വത്വ വികസനം, മുൻഗണനകൾ മാറൽ എന്നിവ കാണിക്കുന്നു.",
    "Progressed Career Phase": "പുരോഗമിച്ച കരിയർ ഘട്ടം",
    "Progressed Love Phase": "പുരോഗമിച്ച പ്രണയ ഘട്ടം",
    "Progressed Money Phase": "പുരോഗമിച്ച പണത്തിൻ്റെ ഘട്ടം",
    "Loading progressed planets...": "പുരോഗമിച്ച ഗ്രഹങ്ങൾ ലോഡ് ചെയ്യുന്നു...",
    "Progressed planets are not available.": "പുരോഗമിച്ച ഗ്രഹങ്ങൾ ലഭ്യമല്ല.",
    "Loading progressed aspects...": "പുരോഗമിച്ച വശങ്ങൾ ലോഡുചെയ്യുന്നു...",
    "No tight progressed-to-natal aspects found right now.": "ഇറുകിയ പുരോഗതി-പ്രജനന വശങ്ങൾ ഒന്നും ഇപ്പോൾ കണ്ടെത്തിയില്ല.",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "പുരോഗമിച്ച ഗ്രഹങ്ങൾ, പുരോഗമിച്ച ചന്ദ്രൻ്റെ ഘട്ടം, കഠിനമായ പുരോഗമന-ജനന വശങ്ങൾ എന്നിവയിൽ നിന്നാണ് ഈ ഘട്ടം വിലയിരുത്തേണ്ടത്.",
    "Vastu Analysis - Kundlistar": "വാസ്തു വിശകലനം - Kundlistar",
    "Failed to load selected chart.": "തിരഞ്ഞെടുത്ത ചാർട്ട് ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു.",
    "Facing Direction": "അഭിമുഖീകരിക്കുന്ന ദിശ",
    "Entrance Direction": "പ്രവേശന ദിശ",
    "Kitchen Direction": "അടുക്കള ദിശ",
    "Master Bedroom": "മാസ്റ്റർ ബെഡ്റൂം",
    "Children Bedroom": "കുട്ടികളുടെ കിടപ്പുമുറി",
    "Toilet Direction": "ടോയ്‌ലറ്റ് ദിശ",
    "Pooja Direction": "പൂജ സംവിധാനം",
    "Water Tank": "വാട്ടർ ടാങ്ക്",
    "Underground Water": "ഭൂഗർഭ ജലം",
    "Heavy Storage": "കനത്ത സംഭരണം",
    "Living Room": "ലിവിംഗ് റൂം",
    "Study Room": "പഠനമുറി",
    "Vastu report generation failed.": "വാസ്തു റിപ്പോർട്ട് തയ്യാറാക്കുന്നതിൽ പരാജയപ്പെട്ടു.",
    "Please generate the Vastu report before downloading.": "ഡൗൺലോഡ് ചെയ്യുന്നതിന് മുമ്പ് ദയവായി വാസ്തു റിപ്പോർട്ട് സൃഷ്ടിക്കുക.",
    "Failed to download Vastu report.": "വാസ്തു റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യാനായില്ല.",
    "Premium Feature": "പ്രീമിയം ഫീച്ചർ",
    "Selected Chart": "തിരഞ്ഞെടുത്ത ചാർട്ട്",
    "Basic + KP + BNN from chart": "ചാർട്ടിൽ നിന്ന് അടിസ്ഥാന + KP + BNN",
    "Basic shown, KP + BNN locked": "അടിസ്ഥാന കാണിച്ചിരിക്കുന്നത്, KP + BNN ലോക്ക് ചെയ്തു",
    "Property Type": "പ്രോപ്പർട്ടി തരം",
    "Center Area": "സെൻ്റർ ഏരിയ",
    "Generate Vastu Report": "വാസ്തു റിപ്പോർട്ട് തയ്യാറാക്കുക",
    "Basic Vastu Analysis": "അടിസ്ഥാന വാസ്തു വിശകലനം",
    "KP Vastu Analysis": "കെപി വാസ്തു വിശകലനം",
    "BNN Vastu Analysis": "ബിഎൻഎൻ വാസ്തു വിശകലനം",
    "North East": "നോർത്ത് ഈസ്റ്റ്",
    "South East": "തെക്ക് കിഴക്ക്",
    "South West": "തെക്ക് പടിഞ്ഞാറ്",
    "North West": "വടക്ക് പടിഞ്ഞാറ്",
    "Red Coral": "ചുവന്ന പവിഴം",
    "Yellow Sapphire": "മഞ്ഞ നീലക്കല്ല്",
    "Blue Sapphire": "നീല നീലക്കല്ലു",
    "Cat's Eye": "പൂച്ചയുടെ കണ്ണ്",
    "Additional Option": "അധിക ഓപ്ഷൻ",
    "Lagna rule supports this gemstone option.": "ലഗ്ന നിയമം ഈ രത്ന ഓപ്ഷൻ പിന്തുണയ്ക്കുന്നു.",
    "Moon sign rule supports this gemstone option.": "ചന്ദ്ര ചിഹ്ന നിയമം ഈ രത്നക്കല്ല് ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Birth date rule supports this gemstone option.": "ജനനത്തീയതി നിയമം ഈ രത്നകല്ല് ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Birth weekday rule supports this gemstone option.": "ജനന പ്രവൃത്തിദിന നിയമം ഈ രത്നക്കല്ല് ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Current dasha rule supports this gemstone option.": "നിലവിലെ dasha റൂൾ ഈ രത്ന ഓപ്ഷൻ പിന്തുണയ്ക്കുന്നു.",
    "Age-band rule supports this gemstone option.": "പ്രായ-ബാൻഡ് റൂൾ ഈ രത്ന ഓപ്ഷൻ പിന്തുണയ്ക്കുന്നു.",
    "Selected goal supports this gemstone option.": "തിരഞ്ഞെടുത്ത ലക്ഷ്യം ഈ രത്നക്കല്ല് ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Profession rule supports this gemstone option.": "തൊഴിൽ നിയമം ഈ രത്ന ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Name-initial rule supports this gemstone option.": "നെയിം-ഇനിഷ്യൽ റൂൾ ഈ ജെംസ്റ്റോൺ ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Moolank rule supports this gemstone option.": "മൂലങ്ക് നിയമം ഈ രത്ന ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Chart condition check was considered for this option.": "ഈ ഓപ്ഷനായി ചാർട്ട് കണ്ടീഷൻ ചെക്ക് പരിഗണിച്ചു.",
    "Rule-based chart match supports this gemstone option.": "റൂൾ അധിഷ്ഠിത ചാർട്ട് പൊരുത്തം ഈ രത്ന ഓപ്ഷനെ പിന്തുണയ്ക്കുന്നു.",
    "Expert kundli review is recommended before wearing this gemstone.": "ഈ രത്നക്കല്ല് ധരിക്കുന്നതിന് മുമ്പ് വിദഗ്ധ കുണ്ഡലി അവലോകനം ശുപാർശ ചെയ്യുന്നു.",
    "Ring finger": "മോതിര വിരൽ",
    "Little finger": "ചെറിയ വിരൽ",
    "Index finger": "ചൂണ്ടുവിരൽ",
    "Middle finger": "നടുവിരൽ",
    "Why recommended": "എന്തുകൊണ്ട് ശുപാർശ ചെയ്തു",
    "Approx weight": "ഏകദേശം ഭാരം",
    "Could not load chart.": "ചാർട്ട് ലോഡ് ചെയ്യാനായില്ല.",
    "Gemstone Recommendations | Kundlistar": "രത്നനിർദ്ദേശങ്ങൾ | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar-ൻ്റെ റൂൾ അടിസ്ഥാനമാക്കിയുള്ള കുണ്ഡലി വിശകലന എഞ്ചിനിൽ നിന്ന് വേദ രത്ന ശുപാർശകൾ പര്യവേക്ഷണം ചെയ്യുക.",
    "noindex,nofollow": "noindex,nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "രത്ന ശുപാർശ, വേദ രത്നക്കല്ലുകൾ, കുണ്ഡലി രത്നം, Kundlistar",
    "Gemstone Recommendations": "രത്ന ശുപാർശകൾ",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "ലഗ്നം, ചന്ദ്ര രാശി, ദശ, DOB, തൊഴിൽ, ലക്ഷ്യങ്ങൾ എന്നിവയെ അടിസ്ഥാനമാക്കിയുള്ള വേദ രത്ന മാർഗ്ഗനിർദ്ദേശത്തിനായി Kundlistar മൊഡ്യൂൾ വേർതിരിക്കുക.",
    "Personalized Gemstone Recommendations are available for Premium users.": "പ്രീമിയം ഉപയോക്താക്കൾക്ക് വ്യക്തിഗതമാക്കിയ ജെംസ്റ്റോൺ ശുപാർശകൾ ലഭ്യമാണ്.",
    "Upgrade to Premium": "Premium-ലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക",
    "Login to Upgrade": "നവീകരിക്കാൻ ലോഗിൻ ചെയ്യുക",
    "Select Goal": "ലക്ഷ്യം തിരഞ്ഞെടുക്കുക",
    "Business, government job, teacher...": "ബിസിനസ്സ്, സർക്കാർ ജോലി, അധ്യാപകൻ...",
    "Weight kg": "ഭാരം കിലോ",
    "वजन kg": "വജൻ കിലോ",
    "Optional ratti estimate": "ഓപ്ഷണൽ റാട്ടി എസ്റ്റിമേറ്റ്",
    "Click Calculate to apply these values.": "ഈ മൂല്യങ്ങൾ പ്രയോഗിക്കാൻ കണക്കുകൂട്ടുക ക്ലിക്ക് ചെയ്യുക.",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi ?",
    "Nadi Analysis": "നാഡി വിശകലനം",
    "KP Analysis": "കെപി വിശകലനം",
    "Vedic Analysis": "വേദ വിശകലനം",
    "BNN Analysis": "ബിഎൻഎൻ വിശകലനം",
    "Jaimini Analysis": "ജൈമിനി വിശകലനം",
    "Western Astrology": "പാശ്ചാത്യ ജ്യോതിഷം",
    "Panch Pakshi": "പഞ്ച് പക്ഷി",
    "Tithi Pravesh": "തിഥി പ്രവേശനം",
    "Lal Kitab": "ലാൽ കിതാബ്",
    "Astro Logo": "ആസ്ട്രോ ലോഗോ",
    "Download failed": "ഡൗൺലോഡ് പരാജയപ്പെട്ടു",
    "Could not download PDF report.": "PDF റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യാനായില്ല.",
    "Please login to download PDF reports.": "PDF റിപ്പോർട്ടുകൾ ഡൗൺലോഡ് ചെയ്യാൻ ദയവായി ലോഗിൻ ചെയ്യുക.",
    "Failed to generate personalised report": "വ്യക്തിപരമാക്കിയ റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നതിൽ പരാജയപ്പെട്ടു",
    "Could not download personalised report.": "വ്യക്തിഗത റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യാനായില്ല.",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--kundlistar-navbar-height, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(--kundlistar-navbar-height, 160px))",
    "width 0.2s ease": "വീതി 0.2സെ അനായാസം",
    "Collapse sidebar": "സൈഡ്‌ബാർ ചുരുക്കുക",
    "Expand sidebar": "സൈഡ്‌ബാർ വികസിപ്പിക്കുക",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-root",
    "Download PDF Report": "PDF റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യുക",
    "Login to download": "ഡൗൺലോഡ് ചെയ്യാൻ ലോഗിൻ ചെയ്യുക",
    "PDF Report": "PDF റിപ്പോർട്ട്",
    "Download Personal Report": "വ്യക്തിഗത റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യുക",
    "Buy Premium to download": "ഡൗൺലോഡ് ചെയ്യാൻ പ്രീമിയം വാങ്ങുക",
    "Login to buy Premium": "പ്രീമിയം വാങ്ങാൻ ലോഗിൻ ചെയ്യുക",
    "Buy Premium": "പ്രീമിയം വാങ്ങുക",
    "& .MuiTab-root": "& .MuiTab-root",
    "& .Mui-selected": "& .മുയി-തിരഞ്ഞെടുത്തത്",
    "Unable to load Client Management data.": "ക്ലയൻ്റ് മാനേജ്‌മെൻ്റ് ഡാറ്റ ലോഡുചെയ്യാനായില്ല.",
    "Unable to download PDF.": "PDF ഡൗൺലോഡ് ചെയ്യാനായില്ല.",
    "Free client limit reached": "സൗജന്യ ക്ലയൻ്റ് പരിധി എത്തി",
    "Welcome": "സ്വാഗതം",
    "Hello": "ഹലോ",
    "Your saved charts are shown below.": "നിങ്ങളുടെ സംരക്ഷിച്ച ചാർട്ടുകൾ ചുവടെ കാണിച്ചിരിക്കുന്നു.",
    "All Features": "എല്ലാ സവിശേഷതകളും",
    "New Chart": "പുതിയ ചാർട്ട്",
    "Vedic Chart": "വേദ ചാർട്ട്",
    "Chakra": "ചക്രം",
    "Daily Panchang": "പ്രതിദിന പഞ്ചാങ്",
    "Choghadiya": "ചോഗാഡിയ",
    "Daily Horoscope": "പ്രതിദിന ജാതകം",
    "Gochar Alerts": "ഗോച്ചർ അലേർട്ടുകൾ",
    "Matching": "പൊരുത്തപ്പെടുന്നു",
    "Ruling Planets": "ഭരിക്കുന്ന ഗ്രഹങ്ങൾ",
    "Horary Chart": "ഹോററി ചാർട്ട്",
    "Astro-Vastu": "ആസ്ട്രോ-വാസ്തു",
    "Vedic Numerology": "വേദ സംഖ്യാശാസ്ത്രം",
    "My Charts": "എൻ്റെ ചാർട്ടുകൾ",
    "Search by Name": "പേര് പ്രകാരം തിരയുക",
    "Type": "ടൈപ്പ് ചെയ്യുക",
    "All": "എല്ലാം",
    "Individual": "വ്യക്തിഗത",
    "Horary": "ഹൊററി",
    "Clear": "ക്ലിയർ",
    "Name": "പേര്",
    "DOB": "DOB",
    "Place": "സ്ഥലം",
    "Gender": "ലിംഗഭേദം",
    "Created": "സൃഷ്ടിച്ചത്",
    "Actions": "പ്രവർത്തനങ്ങൾ",
    "Male": "പുരുഷൻ",
    "Female": "സ്ത്രീ",
    "No matching charts found": "പൊരുത്തപ്പെടുന്ന ചാർട്ടുകളൊന്നും കണ്ടെത്തിയില്ല",
    "Create First Chart": "ആദ്യ ചാർട്ട് സൃഷ്ടിക്കുക",
    "View Chart": "ചാർട്ട് കാണുക",
    "Copy Share Link": "പങ്കിടൽ ലിങ്ക് പകർത്തുക",
    "Use premium credit: Download PDF Report": "പ്രീമിയം ക്രെഡിറ്റ് ഉപയോഗിക്കുക: PDF റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യുക",
    "Download Personalised Report": "വ്യക്തിപരമാക്കിയ റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യുക",
    "Premium: Download Personalised Report": "പ്രീമിയം: വ്യക്തിപരമാക്കിയ റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യുക",
    "Hide Chart": "ചാർട്ട് മറയ്ക്കുക",
    "Personalised": "വ്യക്തിപരമാക്കിയത്",
    "Generating your Personalised Report": "നിങ്ങളുടെ വ്യക്തിപരമാക്കിയ റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നു",
    "Please do not leave this page till the report is generated. This can take a little while.": "റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നത് വരെ ദയവായി ഈ പേജ് വിടരുത്. ഇതിന് കുറച്ച് സമയമെടുത്തേക്കാം.",
    "Please don't leave this page till the report is generated. This can take a little while.": "റിപ്പോർട്ട് സൃഷ്ടിക്കുന്നത് വരെ ദയവായി ഈ പേജ് വിടരുത്. ഇതിന് കുറച്ച് സമയമെടുത്തേക്കാം.",
    "Update": "അപ്ഡേറ്റ്",
    "Complete your billing address. Required for generating invoice.": "നിങ്ങളുടെ ബില്ലിംഗ് വിലാസം പൂർത്തിയാക്കുക. ഇൻവോയ്‌സ് സൃഷ്‌ടിക്കുന്നതിന് ആവശ്യമാണ്.",
    "Report this report": "ഈ റിപ്പോർട്ട് റിപ്പോർട്ട് ചെയ്യുക",
    "Reason": "കാരണം",
    "Optional comment": "ഓപ്ഷണൽ അഭിപ്രായം",
    "Submit": "സമർപ്പിക്കുക",
    "Incorrect info": "തെറ്റായ വിവരം",
    "Offensive": "കുറ്റകരമായ",
    "Harmful": "ഹാനികരമായ",
    "This report has been sent for review.": "ഈ റിപ്പോർട്ട് അവലോകനത്തിനായി അയച്ചിട്ടുണ്ട്.",
    "Failed to submit report feedback": "റിപ്പോർട്ട് ഫീഡ്‌ബാക്ക് സമർപ്പിക്കുന്നതിൽ പരാജയപ്പെട്ടു",
    "Failed to download PDF": "PDF ഡൗൺലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    "Failed to download personalised report": "വ്യക്തിപരമാക്കിയ റിപ്പോർട്ട് ഡൗൺലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    "Failed to load charts": "ചാർട്ടുകൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു",
    "Failed to hide chart": "ചാർട്ട് മറയ്ക്കുന്നതിൽ പരാജയപ്പെട്ടു",
    "Failed to delete chart": "ചാർട്ട് ഇല്ലാതാക്കുന്നതിൽ പരാജയപ്പെട്ടു",
    "Share link copied to clipboard!": "ലിങ്ക് പങ്കിടുക ക്ലിപ്പ്ബോർഡിലേക്ക് പകർത്തി!",
    "Delete Chart": "ചാർട്ട് ഇല്ലാതാക്കുക",
    "Delete chart": "ചാർട്ട് ഇല്ലാതാക്കുക",
    "Error": "പിശക്",
    "OK": "ശരി",
    "Thanks": "നന്ദി",
    "Report failed": "റിപ്പോർട്ട് പരാജയപ്പെട്ടു",
    "Could not submit report feedback.": "റിപ്പോർട്ട് ഫീഡ്ബാക്ക് സമർപ്പിക്കാൻ കഴിഞ്ഞില്ല.",
    "Personalised report ready": "വ്യക്തിഗത റിപ്പോർട്ട് തയ്യാറാണ്",
    "Personalised report failed": "വ്യക്തിപരമാക്കിയ റിപ്പോർട്ട് പരാജയപ്പെട്ടു",
    "Could not generate personalised report.": "വ്യക്തിഗത റിപ്പോർട്ട് സൃഷ്ടിക്കാൻ കഴിഞ്ഞില്ല.",
    "Could not generate personalised PDF report.": "വ്യക്തിഗതമാക്കിയ PDF റിപ്പോർട്ട് സൃഷ്ടിക്കാൻ കഴിഞ്ഞില്ല.",
    "Monthly limit reached": "പ്രതിമാസ പരിധി എത്തി",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "നിങ്ങളുടെ പ്രതിമാസ വ്യക്തിഗത റിപ്പോർട്ട് പരിധി എത്തി. ഒരു ആഡ്-ഓണിലേക്ക് സബ്‌സ്‌ക്രൈബ് ചെയ്യുക: 20 റിപ്പോർട്ടുകൾക്ക് പ്രതിമാസം ₹299 അല്ലെങ്കിൽ 40 റിപ്പോർട്ടുകൾക്ക് പ്രതിമാസം ₹499.",
    "Buy Add-on": "ആഡ്-ഓൺ വാങ്ങുക",
    "Manage": "കൈകാര്യം ചെയ്യുക",
    "Add-on active: Unlimited reports": "ആഡ്-ഓൺ സജീവം: അൺലിമിറ്റഡ് റിപ്പോർട്ടുകൾ",
    "Add-on active: 40 reports/month": "ആഡ്-ഓൺ സജീവം: 40 റിപ്പോർട്ടുകൾ/മാസം",
    "Add-on active: 20 reports/month": "ആഡ്-ഓൺ സജീവം: 20 റിപ്പോർട്ടുകൾ/മാസം",
    "reports remaining this cycle": "ഈ ചക്രം ശേഷിക്കുന്ന റിപ്പോർട്ടുകൾ",
    "Add-on active": "ആഡ്-ഓൺ സജീവമാണ്",
    "Personalised reports remaining this month": "ഈ മാസം ശേഷിക്കുന്ന വ്യക്തിപരമാക്കിയ റിപ്പോർട്ടുകൾ",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "പ്രീമിയത്തിൽ 2/മാസം ഉൾപ്പെടുന്നു. ആഡ്-ഓണുകൾ: പ്രതിമാസം 20 റിപ്പോർട്ടുകൾക്ക് ₹299/മാസം അല്ലെങ്കിൽ 40 റിപ്പോർട്ടുകൾക്ക് പ്രതിമാസം ₹499.",
    "AI Disclaimer": "AI നിരാകരണം",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "AI-യും ജ്യോതിഷ വ്യാഖ്യാനങ്ങളും ഉപയോഗിച്ചാണ് ഈ റിപ്പോർട്ട് തയ്യാറാക്കിയിരിക്കുന്നത്. ഇത് വിവരദായക, വിനോദ ആവശ്യങ്ങൾക്ക് മാത്രമുള്ളതാണ്. ഇത് മെഡിക്കൽ, നിയമ, അല്ലെങ്കിൽ സാമ്പത്തിക ഉപദേശമായി കണക്കാക്കരുത്.",
    "A copy of this report has also been sent to your registered email address as a PDF.": "ഈ റിപ്പോർട്ടിൻ്റെ ഒരു പകർപ്പ് നിങ്ങളുടെ രജിസ്റ്റർ ചെയ്ത ഇമെയിൽ വിലാസത്തിലേക്ക് PDF ആയി അയച്ചിട്ടുണ്ട്.",
    "Report this AI-generated report?": "AI സൃഷ്ടിച്ച ഈ റിപ്പോർട്ട് റിപ്പോർട്ടുചെയ്യണോ?",
    "charts": "ചാർട്ടുകൾ",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "സ്വതന്ത്ര കുറിപ്പുകൾ, തീയതിയും സമയവും ആസൂത്രണം ചെയ്യുക. സംരക്ഷിക്കുന്നതിന് ലോഗിൻ ആവശ്യമാണ്; സൗജന്യ ഉപയോക്താക്കൾക്ക് പൂർണ്ണ പ്ലാനർ ആക്സസ് ലഭിക്കും.",
    "Independent notes, date and time planning.": "സ്വതന്ത്ര കുറിപ്പുകൾ, തീയതിയും സമയവും ആസൂത്രണം ചെയ്യുക.",
    "Add Plan": "പ്ലാൻ ചേർക്കുക",
    "Save Plan": "പദ്ധതി സംരക്ഷിക്കുക",
    "Saved Plans": "സംരക്ഷിച്ച പ്ലാനുകൾ",
    "Planner Entry": "പ്ലാനർ എൻട്രി",
    "Plan": "പ്ലാൻ ചെയ്യുക",
    "Saving...": "സംരക്ഷിക്കുന്നു...",
    "Refresh": "പുതുക്കുക",
    "No plans saved yet.": "ഇതുവരെ പ്ലാനുകളൊന്നും സംരക്ഷിച്ചിട്ടില്ല.",
    "Planner layout is available. Login only when you want to save.": "പ്ലാനർ ലേഔട്ട് ലഭ്യമാണ്. നിങ്ങൾക്ക് സംരക്ഷിക്കാൻ താൽപ്പര്യമുള്ളപ്പോൾ മാത്രം ലോഗിൻ ചെയ്യുക.",
    "No matching plans.": "പൊരുത്തപ്പെടുന്ന പ്ലാനുകളൊന്നുമില്ല.",
    "Search Plans": "തിരയൽ പ്ലാനുകൾ",
    "Search title, note, date or status": "ശീർഷകം, കുറിപ്പ്, തീയതി അല്ലെങ്കിൽ നില എന്നിവ തിരയുക",
    "Login is required only when you want to save planner entries.": "പ്ലാനർ എൻട്രികൾ സംരക്ഷിക്കാൻ താൽപ്പര്യപ്പെടുമ്പോൾ മാത്രം ലോഗിൻ ചെയ്യേണ്ടതുണ്ട്.",
    "Planner entry saved.": "പ്ലാനർ എൻട്രി സംരക്ഷിച്ചു.",
    "Unable to load planner.": "പ്ലാനർ ലോഡുചെയ്യാനായില്ല.",
    "Unable to save planner entry.": "പ്ലാനർ എൻട്രി സംരക്ഷിക്കാനായില്ല.",
    "Could not load planner.": "പ്ലാനർ ലോഡ് ചെയ്യാനായില്ല.",
    "Could not save planner entry.": "പ്ലാനർ എൻട്രി സംരക്ഷിക്കാൻ കഴിഞ്ഞില്ല.",
    "Login required to save": "സംരക്ഷിക്കാൻ ലോഗിൻ ചെയ്യേണ്ടതുണ്ട്",
    "You can explore Planner now. Login when you want to save entries.": "നിങ്ങൾക്ക് ഇപ്പോൾ പ്ലാനർ പര്യവേക്ഷണം ചെയ്യാം. നിങ്ങൾക്ക് എൻട്രികൾ സംരക്ഷിക്കാൻ താൽപ്പര്യപ്പെടുമ്പോൾ ലോഗിൻ ചെയ്യുക.",
    "Prev": "മുൻ",
    "Next": "അടുത്തത്",
    "Page": "പേജ്",
    "of": "ൻ്റെ",
    "Child Birth Mahoorat": "ശിശു ജനനം മഹൂറത്ത്",
    "Child Birth Mahoorat | Kundlistar Premium": "ശിശു ജനനം മഹൂരത് | കുണ്ട്ലിസ്‌റ്റാർ പ്രീമിയം",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "പഞ്ചാങ്, ചോഗാഡിയ, ഹോറ എന്നിവ അടിസ്ഥാനമാക്കിയുള്ള മാർഗനിർദേശങ്ങളുള്ള പ്രീമിയം ചൈൽഡ് ബർത്ത് മഹൂറത്ത് വിൻഡോകൾ.",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "ആസൂത്രിത ശിശുജനന സമയ മാർഗ്ഗനിർദ്ദേശത്തിനായി ലഭ്യമായ ജാലകങ്ങൾ പര്യവേക്ഷണം ചെയ്യാൻ ഒരു തീയതിയും സ്ഥലവും തിരഞ്ഞെടുക്കുക.",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "ശിശു ജനന മഹോരത്ത് ആത്മീയവും ജ്യോതിഷവുമായ മാർഗ്ഗനിർദ്ദേശത്തിന് മാത്രമുള്ളതാണ്.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "ശിശു ജനന മഹോരത് ഒരു പ്രീമിയം സവിശേഷതയാണ്. പഞ്ചാങ്, ചോഗാഡിയ, ഹോറ ചെക്കുകൾ ഉപയോഗിച്ച് ശുഭകരമായ മാർഗ്ഗനിർദ്ദേശ വിൻഡോകൾ അൺലോക്ക് ചെയ്യാൻ അപ്‌ഗ്രേഡ് ചെയ്യുക.",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "ശിശു ജനന മഹോരത് ഒരു പ്രീമിയം സവിശേഷതയാണ്. പഞ്ചാങ്, ചോഗാഡിയ, ഹോറ ചെക്കുകൾ ഉപയോഗിച്ച് ഗൈഡൻസ് വിൻഡോകൾ അൺലോക്ക് ചെയ്യാൻ അപ്‌ഗ്രേഡ് ചെയ്യുക.",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "തീയതി, സ്ഥലം, പഞ്ചാങ്, ചോഗാഡിയ, ഹോറ എന്നിവ പ്രകാരം പ്രീമിയം ഗൈഡൻസ് വിൻഡോകൾ.",
    "Premium feature": "പ്രീമിയം ഫീച്ചർ",
    "Upgrade to Kundlistar Premium": "Kundlistar Premium-ലേക്ക് അപ്ഗ്രേഡ് ചെയ്യുക",
    "Previous": "മുമ്പത്തെ",
    "Today": "ഇന്ന്",
    "Birth place / City": "ജനന സ്ഥലം / നഗരം",
    "Birth place / city": "ജനന സ്ഥലം / നഗരം",
    "Select country, then search city": "രാജ്യം തിരഞ്ഞെടുക്കുക, തുടർന്ന് നഗരം തിരയുക",
    "Preferred start": "തിരഞ്ഞെടുത്ത തുടക്കം",
    "Preferred end": "തിരഞ്ഞെടുത്ത അവസാനം",
    "Mother Moon sign (optional)": "മാതൃ ചന്ദ്ര ചിഹ്നം (ഓപ്ഷണൽ)",
    "Cancer": "കാൻസർ",
    "Load Kundli": "കുണ്ഡലി ലോഡ് ചെയ്യുക",
    "Find Premium Windows": "പ്രീമിയം വിൻഡോസ് കണ്ടെത്തുക",
    "Date (DD/MM/YYYY)": "തീയതി (DD/MM/YYYY)",
    "Invalid Date": "അസാധുവായ തീയതി",
    "Date must be in DD/MM/YYYY format.": "തീയതി DD/MM/YYYY ഫോർമാറ്റിൽ ആയിരിക്കണം.",
    "Required": "ആവശ്യമാണ്",
    "Please select a city.": "ദയവായി ഒരു നഗരം തിരഞ്ഞെടുക്കുക.",
    "Kundli": "കുണ്ഡലി",
    "Unable to load kundli.": "കുണ്ഡലി ലോഡുചെയ്യാനായില്ല.",
    "Unable to calculate Child Birth Mahoorat.": "കുട്ടിയുടെ ജനനം മഹൂറത്ത് കണക്കാക്കാൻ കഴിയുന്നില്ല.",
    "Kundli Preview": "കുണ്ഡലി പ്രിവ്യൂ",
    "Loaded for": "ഇതിനായി ലോഡ് ചെയ്തു",
    "Doshas & Yogas": "ദോഷങ്ങളും യോഗകളും",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "ലോഡ് ചെയ്ത ലാഹിരി കുണ്ഡലിയിൽ നിന്നുള്ള നിയമാധിഷ്ഠിത സൂചനകൾ. അവലോകനത്തിനും ആത്മീയ മാർഗനിർദേശത്തിനും അവ ഉപയോഗിക്കുക, അന്തിമ വിധി എന്ന നിലയിലല്ല.",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "ലോഡ് ചെയ്ത ലാഹിരി കുണ്ഡലിയിൽ നിന്നുള്ള നിയമാധിഷ്ഠിത സൂചനകൾ. അവലോകനത്തിനും ആത്മീയ മാർഗനിർദേശത്തിനും ഉപയോഗിക്കുക.",
    "Detected": "കണ്ടെത്തി",
    "Not detected": "കണ്ടെത്തിയില്ല",
    "Review": "അവലോകനം",
    "Dosha": "ദോശ",
    "Yoga": "യോഗ",
    "Full Yoga Scan": "പൂർണ്ണ യോഗ സ്കാൻ",
    "Checking yogas...": "യോഗകൾ പരിശോധിക്കുന്നു...",
    "No major yogas were detected by the premium yoga scan.": "പ്രീമിയം യോഗ സ്‌കാൻ വഴി വലിയ യോഗകളൊന്നും കണ്ടെത്തിയില്ല.",
    "No suitable premium windows found for the selected date and time range.": "തിരഞ്ഞെടുത്ത തീയതിക്കും സമയ പരിധിക്കും അനുയോജ്യമായ പ്രീമിയം വിൻഡോകളൊന്നും കണ്ടെത്തിയില്ല.",
    "No suitable windows found": "അനുയോജ്യമായ വിൻഡോകളൊന്നും കണ്ടെത്തിയില്ല",
    "Try changing the time range or select previous/next date.": "സമയപരിധി മാറ്റാൻ ശ്രമിക്കുക അല്ലെങ്കിൽ മുമ്പത്തെ/അടുത്ത തീയതി തിരഞ്ഞെടുക്കുക.",
    "Try changing the date or time range.": "തീയതിയോ സമയ പരിധിയോ മാറ്റാൻ ശ്രമിക്കുക.",
    "Try the Previous or Next date button to find a better option.": "മികച്ച ഓപ്ഷൻ കണ്ടെത്താൻ മുമ്പത്തെ അല്ലെങ്കിൽ അടുത്ത തീയതി ബട്ടൺ പരീക്ഷിക്കുക.",
    "Use Previous or Next date to find a better option.": "മികച്ച ഓപ്ഷൻ കണ്ടെത്താൻ മുമ്പത്തെ അല്ലെങ്കിൽ അടുത്ത തീയതി ഉപയോഗിക്കുക.",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "തിരഞ്ഞെടുത്ത തീയതിക്കും നഗരത്തിനുമുള്ള മികച്ച പ്രീമിയം വിൻഡോകൾ കണക്കാക്കാൻ പ്രീമിയം വിൻഡോകൾ കണ്ടെത്തുക ക്ലിക്കുചെയ്യുക.",
    "Tap Find Premium Windows for the selected date and city.": "തിരഞ്ഞെടുത്ത തീയതിക്കും നഗരത്തിനുമായി പ്രീമിയം വിൻഡോകൾ കണ്ടെത്തുക ടാപ്പ് ചെയ്യുക.",
    "Good tithi": "നല്ല തിഥി",
    "Supportive nakshatra": "പിന്തുണയ്ക്കുന്ന നക്ഷത്രം",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "നക്ഷത്രം സെൻസിറ്റീവ് ആണ്. പാഡയും ഗണ്ഡാന്തവും ശ്രദ്ധാപൂർവ്വം പരിശോധിക്കുക.",
    "Supportive weekday": "പിന്തുണയുള്ള പ്രവൃത്തിദിനം",
    "Good Choghadiya": "കൊള്ളാം ചോഗാഡിയ",
    "Weak Choghadiya": "ദുർബ്ബലമായ ചോഘാഡിയ",
    "Supportive Hora": "പിന്തുണയ്ക്കുന്ന ഹോറ",
    "Baby Moon matches mother's Moon sign.": "ബേബി മൂൺ അമ്മയുടെ ചന്ദ്ര രാശിയുമായി പൊരുത്തപ്പെടുന്നു.",
    "Hora": "ഹോരാ",
    "slots": "സ്ലോട്ടുകൾ",
    "min": "മിനിറ്റ്",
    "Good": "നല്ലത്",
    "Excellent": "മികച്ചത്",
    "Usable": "ഉപയോഗിക്കാവുന്നത്",
    "Rejected": "നിരസിച്ചു",
    "Sunday": "ഞായറാഴ്ച",
    "Monday": "തിങ്കളാഴ്ച",
    "Tuesday": "ചൊവ്വാഴ്ച",
    "Wednesday": "ബുധനാഴ്ച",
    "Thursday": "വ്യാഴാഴ്ച",
    "Friday": "വെള്ളിയാഴ്ച",
    "Saturday": "ശനിയാഴ്ച",
    "Sun": "സൂര്യൻ",
    "Moon": "ചന്ദ്രൻ",
    "Mars": "ചൊവ്വ",
    "Mercury": "ബുധൻ",
    "Jupiter": "വ്യാഴം",
    "Venus": "ശുക്രൻ",
    "Saturn": "ശനി",
    "Rahu": "രാഹു",
    "Ketu": "കേതു",
    "Chal": "ചാൽ",
    "Labh": "ലാബ്",
    "Amrit": "അമൃത്",
    "Shubh": "ശുഭ്",
    "Udveg": "ഉദ്വേഗ്",
    "Rog": "റോഗ്",
    "Kaal": "കാല്",
    "Krishna Navami": "കൃഷ്ണ നവമി",
    "Ashwini": "അശ്വിനി",
    "Bharani": "ഭരണി",
    "Krittika": "കൃതിക",
    "Rohini": "രോഹിണി",
    "Mrigashira": "മൃഗശിര",
    "Ardra": "ആർദ്ര",
    "Punarvasu": "പുനർവാസു",
    "Pushya": "പുഷ്യ",
    "Ashlesha": "ആശ്ലേഷ",
    "Magha": "മാഘ",
    "Jyeshtha": "ജ്യേഷ്ഠ",
    "Moola": "മൂല",
    "Mula": "മുള",
    "Revati": "രേവതി"
  },
  "pa": {
    "Client Management": "ਕਲਾਇੰਟ ਪ੍ਰਬੰਧਨ",
    "Dashboard": "ਡੈਸ਼ਬੋਰਡ",
    "Clients": "ਗਾਹਕ",
    "Consultations": "ਸਲਾਹ-ਮਸ਼ਵਰੇ",
    "Notes": "ਨੋਟਸ",
    "Follow-ups": "ਫਾਲੋ-ਅੱਪ",
    "Reports": "ਰਿਪੋਰਟਾਂ",
    "Remedies": "ਉਪਾਅ",
    "Predictions": "ਭਵਿੱਖਬਾਣੀਆਂ",
    "Planner": "ਯੋਜਨਾਕਾਰ",
    "Templates": "ਟੈਂਪਲੇਟਸ",
    "Analytics": "ਵਿਸ਼ਲੇਸ਼ਣ",
    "Payments": "ਭੁਗਤਾਨ",
    "Settings": "ਸੈਟਿੰਗਾਂ",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings ਵਿੱਚ ਡਿਫਾਲਟ ਸ਼ਹਿਰ ਸੇਵ ਕਰ ਸਕਦੇ ਹੋ। ਚੁਣਨ ਤੱਕ ਸ਼ਹਿਰ ਵਾਲੇ ਫੀਲਡ ਖਾਲੀ ਰਹਿਣਗੇ।",
    "is now your default city.": "ਹੁਣ ਤੁਹਾਡਾ ਡਿਫਾਲਟ ਸ਼ਹਿਰ ਹੈ।",
    "Search your default city": "ਆਪਣਾ ਡਿਫਾਲਟ ਸ਼ਹਿਰ ਖੋਜੋ",
    "This color is saved for the website theme and PDF report accent.": "ਇਹ ਰੰਗ ਵੈੱਬਸਾਈਟ ਥੀਮ ਅਤੇ PDF ਰਿਪੋਰਟ accent ਲਈ ਸੇਵ ਹੁੰਦਾ ਹੈ।",
    "Turn All off to include only the checked modules in the report.": "ਰਿਪੋਰਟ ਵਿੱਚ ਸਿਰਫ਼ ਚੁਣੇ ਮੋਡੀਊਲ ਸ਼ਾਮਲ ਕਰਨ ਲਈ All ਬੰਦ ਕਰੋ।",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All ਚਾਲੂ ਹੋਣ ਤੇ PDF ਵਿੱਚ ਸਾਰੇ ਮੋਡੀਊਲ ਆਉਂਦੇ ਹਨ। ਸਿਰਫ਼ ਚੁਣੇ ਮੋਡੀਊਲ ਲਈ ਇਸਨੂੰ ਬੰਦ ਕਰੋ।",
    "Uranus, Neptune and Pluto stay hidden by default.": "ਯੂਰੇਨਸ, ਨੇਪਚੂਨ ਅਤੇ ਪਲੂਟੋ ਡਿਫਾਲਟ ਤੌਰ ਤੇ ਲੁਕੇ ਰਹਿੰਦੇ ਹਨ।",
    "Show Uranus, Neptune and Pluto": "ਯੂਰੇਨਸ, ਨੇਪਚੂਨ ਅਤੇ ਪਲੂਟੋ ਦਿਖਾਓ",
    "When off, Nadi and KP also use the selected global ayanamsha.": "ਆਫ਼ ਹੋਣ ਤੇ ਨਾਡੀ ਅਤੇ KP ਵੀ ਚੁਣਿਆ ਗਿਆ ਗਲੋਬਲ ਅਯਨਾਮਸ਼ਾ ਵਰਤਦੇ ਹਨ।",
    "Use KP for Nadi and KP": "ਨਾਡੀ ਅਤੇ KP ਲਈ KP ਵਰਤੋ",
    "Use KP ayanamsha for Nadi and KP": "ਨਾਡੀ ਅਤੇ KP ਲਈ KP ਅਯਨਾਮਸ਼ਾ ਵਰਤੋ",
    "Night": "ਨਾਈਟ",
    "Dark": "ਡਾਰਕ",
    "Light": "ਲਾਈਟ",
    "Clear default city": "ਡਿਫਾਲਟ ਸ਼ਹਿਰ ਹਟਾਓ",
    "Default City": "ਡਿਫਾਲਟ ਸ਼ਹਿਰ",
    "Default city": "ਡਿਫਾਲਟ ਸ਼ਹਿਰ",
    "Theme Color": "ਥੀਮ ਰੰਗ",
    "Theme color": "ਥੀਮ ਰੰਗ",
    "Include all modules": "ਸਾਰੇ ਮੋਡੀਊਲ ਸ਼ਾਮਲ ਕਰੋ",
    "PDF Report Modules": "PDF ਰਿਪੋਰਟ ਮੋਡੀਊਲ",
    "PDF report modules": "PDF ਰਿਪੋਰਟ ਮੋਡੀਊਲ",
    "Show": "ਦਿਖਾਓ",
    "Hide": "ਲੁਕਾਓ",
    "Outer Planets": "ਬਾਹਰੀ ਗ੍ਰਹਿ",
    "Outer planets": "ਬਾਹਰੀ ਗ੍ਰਹਿ",
    "Ayanamsha": "ਅਯਨਾਮਸ਼ਾ",
    "Mean Node": "ਮੀਨ ਨੋਡ",
    "True Node": "ਟ੍ਰੂ ਨੋਡ",
    "Rahu/Ketu Calculation": "ਰਾਹੂ/ਕੇਤੂ ਗਣਨਾ",
    "Rahu/Ketu calculation": "ਰਾਹੂ/ਕੇਤੂ ਗਣਨਾ",
    "East": "ਪੂਰਬੀ ਭਾਰਤੀ",
    "South": "ਦੱਖਣੀ ਭਾਰਤੀ",
    "North": "ਉੱਤਰੀ ਭਾਰਤੀ",
    "Chart Style": "ਚਾਰਟ ਸ਼ੈਲੀ",
    "Chart style": "ਚਾਰਟ ਸ਼ੈਲੀ",
    "Language": "ਭਾਸ਼ਾ",
    "Records": "ਰਿਕਾਰਡਸ",
    "Relations": "ਰਿਸ਼ਤੇ",
    "Relation": "ਸਬੰਧ",
    "Add Client": "ਕਲਾਇੰਟ ਸ਼ਾਮਲ ਕਰੋ",
    "Add Consultation": "ਸਲਾਹ ਸ਼ਾਮਲ ਕਰੋ",
    "Add Note": "ਨੋਟ ਸ਼ਾਮਲ ਕਰੋ",
    "Add Follow-up": "ਫਾਲੋ-ਅੱਪ ਸ਼ਾਮਲ ਕਰੋ",
    "Create Report": "ਰਿਪੋਰਟ ਬਣਾਓ",
    "Assign Remedy": "ਉਪਾਅ ਨਿਰਧਾਰਤ ਕਰੋ",
    "Add Prediction": "ਭਵਿੱਖਬਾਣੀ ਸ਼ਾਮਲ ਕਰੋ",
    "Add Payment": "ਭੁਗਤਾਨ ਸ਼ਾਮਲ ਕਰੋ",
    "Assign Chart": "ਚਾਰਟ ਨਿਰਧਾਰਤ ਕਰੋ",
    "Add Relation": "ਸਬੰਧ ਜੋੜੋ",
    "CMS Action": "CMS ਐਕਸ਼ਨ",
    "Client": "ਕਲਾਇੰਟ",
    "Chart": "ਚਾਰਟ",
    "Related Client": "ਸੰਬੰਧਿਤ ਕਲਾਇੰਟ",
    "Full Name": "ਪੂਰਾ ਨਾਮ",
    "Phone Number": "ਫ਼ੋਨ ਨੰਬਰ",
    "WhatsApp Number": "ਵਟਸਐਪ ਨੰਬਰ",
    "Email": "ਈਮੇਲ",
    "Birth Place": "ਜਨਮ ਸਥਾਨ",
    "Current City": "ਮੌਜੂਦਾ ਸ਼ਹਿਰ",
    "Main Topic": "ਮੁੱਖ ਵਿਸ਼ਾ",
    "Status": "ਸਥਿਤੀ",
    "Source": "ਸਰੋਤ",
    "Tags": "ਟੈਗਸ",
    "Internal Note": "ਅੰਦਰੂਨੀ ਨੋਟ",
    "Purpose": "ਮਕਸਦ",
    "Relation Type": "ਸਬੰਧ ਦੀ ਕਿਸਮ",
    "Title": "ਸਿਰਲੇਖ",
    "Topic": "ਵਿਸ਼ਾ",
    "Date": "ਮਿਤੀ",
    "Time": "ਸਮਾਂ",
    "Amount": "ਰਕਮ",
    "Mode": "ਮੋਡ",
    "Payment Status": "ਭੁਗਤਾਨ ਸਥਿਤੀ",
    "Note / Summary": "ਨੋਟ / ਸੰਖੇਪ",
    "Close": "ਬੰਦ ਕਰੋ",
    "Cancel": "ਰੱਦ ਕਰੋ",
    "Save": "ਸੇਵ ਕਰੋ",
    "Saving": "ਸੰਭਾਲ ਰਿਹਾ ਹੈ",
    "Save Changes": "ਤਬਦੀਲੀਆਂ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    "Edit Client": "ਕਲਾਇੰਟ ਦਾ ਸੰਪਾਦਨ ਕਰੋ",
    "Client Chart": "ਕਲਾਇੰਟ ਚਾਰਟ",
    "Comma separated": "ਕੌਮਾ ਵੱਖ ਕੀਤਾ",
    "Search by name, phone, email, topic, or tag": "ਨਾਮ, ਫ਼ੋਨ, ਈਮੇਲ, ਵਿਸ਼ਾ, ਜਾਂ ਟੈਗ ਦੁਆਰਾ ਖੋਜ ਕਰੋ",
    "Search clients, phone, topic": "ਗਾਹਕ, ਫ਼ੋਨ, ਵਿਸ਼ਾ ਖੋਜੋ",
    "Search your saved charts by chart name": "ਚਾਰਟ ਨਾਮ ਦੁਆਰਾ ਆਪਣੇ ਸੁਰੱਖਿਅਤ ਕੀਤੇ ਚਾਰਟਾਂ ਦੀ ਖੋਜ ਕਰੋ",
    "Linked Chart": "ਲਿੰਕਡ ਚਾਰਟ",
    "Select linked chart": "ਲਿੰਕ ਕੀਤਾ ਚਾਰਟ ਚੁਣੋ",
    "Link a chart to this client before adding records.": "ਰਿਕਾਰਡ ਜੋੜਨ ਤੋਂ ਪਹਿਲਾਂ ਇਸ ਕਲਾਇੰਟ ਨਾਲ ਇੱਕ ਚਾਰਟ ਲਿੰਕ ਕਰੋ।",
    "Connect this client with another saved client profile": "ਇਸ ਕਲਾਇੰਟ ਨੂੰ ਕਿਸੇ ਹੋਰ ਸੁਰੱਖਿਅਤ ਕੀਤੇ ਕਲਾਇੰਟ ਪ੍ਰੋਫਾਈਲ ਨਾਲ ਕਨੈਕਟ ਕਰੋ",
    "CMS for astrologer client work": "ਜੋਤਸ਼ੀ ਕਲਾਇੰਟ ਦੇ ਕੰਮ ਲਈ ਸੀ.ਐੱਮ.ਐੱਸ",
    "Premium Pro unlocks Client Management": "ਪ੍ਰੀਮੀਅਮ ਪ੍ਰੋ ਕਲਾਇੰਟ ਪ੍ਰਬੰਧਨ ਨੂੰ ਅਨਲੌਕ ਕਰਦਾ ਹੈ",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ਇੱਕ ਵਰਕਸਪੇਸ ਵਿੱਚ ਕਲਾਇੰਟ ਪ੍ਰੋਫਾਈਲਾਂ, ਸਲਾਹ-ਮਸ਼ਵਰੇ, ਨੋਟਸ, ਫਾਲੋ-ਅੱਪ, ਰਿਪੋਰਟਾਂ, ਉਪਚਾਰਾਂ, ਪੂਰਵ-ਅਨੁਮਾਨਾਂ, ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਭੁਗਤਾਨ ਟਰੈਕਿੰਗ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰਨ ਲਈ ਅੱਪਗਰੇਡ ਕਰੋ।",
    "Upgrade to Premium Pro": "ਪ੍ਰੀਮੀਅਮ ਪ੍ਰੋ 'ਤੇ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
    "CMS modules included": "CMS ਮੋਡੀਊਲ ਸ਼ਾਮਲ ਹਨ",
    "Please login to use Client Management. CMS data is stored per account.": "ਕਿਰਪਾ ਕਰਕੇ ਕਲਾਇੰਟ ਪ੍ਰਬੰਧਨ ਦੀ ਵਰਤੋਂ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ। CMS ਡੇਟਾ ਪ੍ਰਤੀ ਖਾਤਾ ਸਟੋਰ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
    "Login": "ਲੌਗਇਨ ਕਰੋ",
    "Loading live CMS data...": "ਲਾਈਵ CMS ਡਾਟਾ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Quick Actions": "ਤੇਜ਼ ਕਾਰਵਾਈਆਂ",
    "Client Records": "ਕਲਾਇੰਟ ਰਿਕਾਰਡ",
    "Client Record": "ਕਲਾਇੰਟ ਰਿਕਾਰਡ",
    "Client Profile": "ਕਲਾਇੰਟ ਪ੍ਰੋਫਾਈਲ",
    "Back to Clients": "ਗਾਹਕਾਂ 'ਤੇ ਵਾਪਸ ਜਾਓ",
    "View": "ਦੇਖੋ",
    "Edit": "ਸੰਪਾਦਿਤ ਕਰੋ",
    "Delete": "ਮਿਟਾਓ",
    "Note": "ਨੋਟ ਕਰੋ",
    "Archive": "ਪੁਰਾਲੇਖ",
    "Download PDF": "PDF ਡਾਊਨਲੋਡ ਕਰੋ",
    "Delete this record?": "ਕੀ ਇਸ ਰਿਕਾਰਡ ਨੂੰ ਮਿਟਾਉਣਾ ਹੈ?",
    "Unable to edit this CMS record.": "ਇਸ CMS ਰਿਕਾਰਡ ਨੂੰ ਸੰਪਾਦਿਤ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Unable to update CMS record.": "CMS ਰਿਕਾਰਡ ਅੱਪਡੇਟ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Unable to delete CMS record.": "CMS ਰਿਕਾਰਡ ਨੂੰ ਮਿਟਾਉਣ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "No contact added": "ਕੋਈ ਸੰਪਰਕ ਸ਼ਾਮਲ ਨਹੀਂ ਕੀਤਾ ਗਿਆ",
    "No topic": "ਕੋਈ ਵਿਸ਼ਾ ਨਹੀਂ",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "ਅਜੇ ਤੱਕ ਕੋਈ ਗਾਹਕ ਨਹੀਂ ਮਿਲਿਆ। CMS ਡੈਸ਼ਬੋਰਡ ਨੂੰ ਭਰਨਾ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਆਪਣਾ ਪਹਿਲਾ ਅਸਲੀ ਕਲਾਇੰਟ ਸ਼ਾਮਲ ਕਰੋ।",
    "Last Consultation": "ਆਖਰੀ ਸਲਾਹ",
    "Next Follow-up": "ਅਗਲਾ ਫਾਲੋ-ਅੱਪ",
    "Date of Birth": "ਜਨਮ ਮਿਤੀ",
    "Time of Birth": "ਜਨਮ ਦਾ ਸਮਾਂ",
    "Client Details": "ਕਲਾਇੰਟ ਵੇਰਵੇ",
    "No connected profiles yet.": "ਅਜੇ ਤੱਕ ਕੋਈ ਕਨੈਕਟ ਕੀਤੇ ਪ੍ਰੋਫਾਈਲ ਨਹੀਂ ਹਨ।",
    "Select a client record to view details.": "ਵੇਰਵੇ ਦੇਖਣ ਲਈ ਇੱਕ ਕਲਾਇੰਟ ਰਿਕਾਰਡ ਚੁਣੋ।",
    "Record": "ਰਿਕਾਰਡ",
    "Consultation Summary": "ਸਲਾਹ ਸੰਖੇਪ",
    "Client Note": "ਕਲਾਇੰਟ ਨੋਟ",
    "Start a consultation record with summary, topic, mode and payment fields.": "ਸੰਖੇਪ, ਵਿਸ਼ਾ, ਮੋਡ ਅਤੇ ਭੁਗਤਾਨ ਖੇਤਰਾਂ ਦੇ ਨਾਲ ਇੱਕ ਸਲਾਹ-ਮਸ਼ਵਰੇ ਦਾ ਰਿਕਾਰਡ ਸ਼ੁਰੂ ਕਰੋ।",
    "Start a private note attached to a client profile.": "ਇੱਕ ਕਲਾਇੰਟ ਪ੍ਰੋਫਾਈਲ ਨਾਲ ਜੁੜਿਆ ਇੱਕ ਨਿੱਜੀ ਨੋਟ ਸ਼ੁਰੂ ਕਰੋ।",
    "Start a pending follow-up with due date and topic.": "ਨਿਯਤ ਮਿਤੀ ਅਤੇ ਵਿਸ਼ੇ ਦੇ ਨਾਲ ਇੱਕ ਬਕਾਇਆ ਫਾਲੋ-ਅਪ ਸ਼ੁਰੂ ਕਰੋ।",
    "Start a report record connected to the client timeline.": "ਕਲਾਇੰਟ ਟਾਈਮਲਾਈਨ ਨਾਲ ਜੁੜਿਆ ਇੱਕ ਰਿਪੋਰਟ ਰਿਕਾਰਡ ਸ਼ੁਰੂ ਕਰੋ।",
    "Start an active remedy record for client guidance.": "ਗਾਹਕ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਇੱਕ ਸਰਗਰਮ ਉਪਚਾਰ ਰਿਕਾਰਡ ਸ਼ੁਰੂ ਕਰੋ।",
    "Start an open prediction record with notes and follow-up date.": "ਨੋਟਸ ਅਤੇ ਫਾਲੋ-ਅੱਪ ਮਿਤੀ ਦੇ ਨਾਲ ਇੱਕ ਖੁੱਲਾ ਭਵਿੱਖਬਾਣੀ ਰਿਕਾਰਡ ਸ਼ੁਰੂ ਕਰੋ।",
    "Statuses": "ਸਥਿਤੀਆਂ",
    "Topics": "ਵਿਸ਼ੇ",
    "Sources": "ਸਰੋਤ",
    "No records found for the current filters.": "ਮੌਜੂਦਾ ਫਿਲਟਰਾਂ ਲਈ ਕੋਈ ਰਿਕਾਰਡ ਨਹੀਂ ਮਿਲਿਆ।",
    "Total Clients": "ਕੁੱਲ ਗਾਹਕ",
    "New Clients This Month": "ਇਸ ਮਹੀਨੇ ਨਵੇਂ ਗਾਹਕ",
    "Consultations This Month": "ਇਸ ਮਹੀਨੇ ਸਲਾਹ-ਮਸ਼ਵਰੇ",
    "Today's Consultations": "ਅੱਜ ਦੇ ਸਲਾਹ-ਮਸ਼ਵਰੇ",
    "Consultations scheduled for today from real client records.": "ਅਸਲ ਕਲਾਇੰਟ ਰਿਕਾਰਡਾਂ ਤੋਂ ਅੱਜ ਲਈ ਤਹਿ ਕੀਤੇ ਗਏ ਸਲਾਹ-ਮਸ਼ਵਰੇ।",
    "No consultations scheduled for today.": "ਅੱਜ ਲਈ ਕੋਈ ਸਲਾਹ-ਮਸ਼ਵਰੇ ਨਿਰਧਾਰਤ ਨਹੀਂ ਕੀਤੇ ਗਏ ਹਨ।",
    "Pending Follow-ups": "ਬਕਾਇਆ ਫਾਲੋ-ਅੱਪ",
    "Reports Created": "ਰਿਪੋਰਟਾਂ ਬਣਾਈਆਂ ਗਈਆਂ",
    "Active Remedies": "ਕਿਰਿਆਸ਼ੀਲ ਉਪਚਾਰ",
    "Open Predictions": "ਪੂਰਵ ਅਨੁਮਾਨਾਂ ਨੂੰ ਖੋਲ੍ਹੋ",
    "Pending Payments": "ਬਕਾਇਆ ਭੁਗਤਾਨ",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "ਗਾਹਕ ਦੀ ਗਤੀਵਿਧੀ, ਹਾਲੀਆ ਕੰਮ, ਫਾਲੋ-ਅਪਸ, ਰਿਪੋਰਟਾਂ, ਪੂਰਵ-ਅਨੁਮਾਨਾਂ, ਉਪਚਾਰਾਂ ਅਤੇ ਬਕਾਇਆ ਭੁਗਤਾਨਾਂ ਨੂੰ ਇੱਕ ਥਾਂ 'ਤੇ ਦੇਖੋ।",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "ਜਨਮ ਵੇਰਵਿਆਂ, ਵਿਸ਼ਿਆਂ, ਟੈਗਸ, ਸਥਿਤੀ ਅਤੇ ਆਰਕਾਈਵ/ਰੀਸਟੋਰ ਕਾਰਵਾਈਆਂ ਦੇ ਨਾਲ ਜੋਤਸ਼ੀ ਕਲਾਇੰਟ ਰਿਕਾਰਡਾਂ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰੋ।",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "ਸੈਸ਼ਨ ਦੇ ਵੇਰਵੇ, ਲਿੰਕ ਕੀਤੇ ਚਾਰਟ, ਵਿਸ਼ੇ, ਨਿਰੀਖਣ, ਪੂਰਵ-ਅਨੁਮਾਨ, ਉਪਚਾਰ ਅਤੇ ਫਾਲੋ-ਅੱਪ ਤਾਰੀਖਾਂ ਨੂੰ ਸਟੋਰ ਕਰੋ।",
    "Keep private consultation notes and chart observations attached to client profiles.": "ਨਿਜੀ ਸਲਾਹ-ਮਸ਼ਵਰੇ ਨੋਟਸ ਅਤੇ ਚਾਰਟ ਨਿਰੀਖਣਾਂ ਨੂੰ ਕਲਾਇੰਟ ਪ੍ਰੋਫਾਈਲਾਂ ਨਾਲ ਜੋੜ ਕੇ ਰੱਖੋ।",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "ਪੁਸ਼, SMS, ਈਮੇਲ ਜਾਂ WhatsApp ਚੇਤਾਵਨੀਆਂ ਤੋਂ ਬਿਨਾਂ ਕਲਾਇੰਟ ਪ੍ਰਬੰਧਨ ਦੇ ਅੰਦਰ ਅੱਜ ਅਤੇ ਆਉਣ ਵਾਲੇ ਫਾਲੋ-ਅਪਸ ਨੂੰ ਟ੍ਰੈਕ ਕਰੋ।",
    "Create and organize client reports generated from saved charts and consultation context.": "ਸੁਰੱਖਿਅਤ ਕੀਤੇ ਚਾਰਟਾਂ ਅਤੇ ਸਲਾਹ-ਮਸ਼ਵਰੇ ਦੇ ਸੰਦਰਭ ਤੋਂ ਤਿਆਰ ਕੀਤੀਆਂ ਕਲਾਇੰਟ ਰਿਪੋਰਟਾਂ ਬਣਾਓ ਅਤੇ ਵਿਵਸਥਿਤ ਕਰੋ।",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "ਉਪਚਾਰ ਨਿਰਧਾਰਤ ਕਰੋ, ਸਰਗਰਮ ਮਾਰਗਦਰਸ਼ਨ ਦੀ ਨਿਸ਼ਾਨਦੇਹੀ ਕਰੋ ਅਤੇ ਉਪਚਾਰ ਇਤਿਹਾਸ ਨੂੰ ਕਲਾਇੰਟ ਟਾਈਮਲਾਈਨ ਨਾਲ ਜੁੜਿਆ ਰੱਖੋ।",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "ਹਰੇਕ ਕਲਾਇੰਟ ਲਈ ਓਪਨ ਪੂਰਵ-ਅਨੁਮਾਨਾਂ, ਤਾਰੀਖਾਂ, ਭਰੋਸੇ ਦੇ ਨੋਟਸ ਅਤੇ ਨਤੀਜਿਆਂ ਦੇ ਅਪਡੇਟਸ ਨੂੰ ਟ੍ਰੈਕ ਕਰੋ।",
    "Plan consultations, follow-ups and payment dates in one working view.": "ਇੱਕ ਕਾਰਜਸ਼ੀਲ ਦ੍ਰਿਸ਼ ਵਿੱਚ ਯੋਜਨਾ ਸਲਾਹ-ਮਸ਼ਵਰੇ, ਫਾਲੋ-ਅੱਪ ਅਤੇ ਭੁਗਤਾਨ ਮਿਤੀਆਂ।",
    "Prepare reusable consultation, report, remedy and prediction templates.": "ਮੁੜ ਵਰਤੋਂ ਯੋਗ ਸਲਾਹ-ਮਸ਼ਵਰੇ, ਰਿਪੋਰਟ, ਉਪਚਾਰ ਅਤੇ ਭਵਿੱਖਬਾਣੀ ਟੈਂਪਲੇਟ ਤਿਆਰ ਕਰੋ।",
    "Review client activity, consultation volume, reports created and pending work.": "ਗਾਹਕ ਦੀ ਗਤੀਵਿਧੀ, ਸਲਾਹ-ਮਸ਼ਵਰੇ ਦੀ ਮਾਤਰਾ, ਬਣਾਈਆਂ ਗਈਆਂ ਰਿਪੋਰਟਾਂ ਅਤੇ ਲੰਬਿਤ ਕੰਮ ਦੀ ਸਮੀਖਿਆ ਕਰੋ।",
    "Track consultation amounts and payment status without plan or pricing rules.": "ਯੋਜਨਾ ਜਾਂ ਕੀਮਤ ਨਿਯਮਾਂ ਦੇ ਬਿਨਾਂ ਸਲਾਹ-ਮਸ਼ਵਰੇ ਦੀ ਮਾਤਰਾ ਅਤੇ ਭੁਗਤਾਨ ਸਥਿਤੀ ਨੂੰ ਟ੍ਰੈਕ ਕਰੋ।",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "ਕਲਾਇੰਟ ਸਰੋਤਾਂ, ਸਥਿਤੀਆਂ, ਵਿਸ਼ੇ, ਟੈਗਸ ਅਤੇ ਅੰਦਰੂਨੀ CMS ਤਰਜੀਹਾਂ ਨੂੰ ਕੌਂਫਿਗਰ ਕਰੋ।",
    "Showing saved records connected to client records.": "ਕਲਾਇੰਟ ਰਿਕਾਰਡਾਂ ਨਾਲ ਜੁੜੇ ਸੁਰੱਖਿਅਤ ਰਿਕਾਰਡ ਦਿਖਾ ਰਿਹਾ ਹੈ।",
    "No Status": "ਕੋਈ ਸਥਿਤੀ ਨਹੀਂ",
    "No Mode": "ਕੋਈ ਮੋਡ ਨਹੀਂ",
    "No Payment Status": "ਕੋਈ ਭੁਗਤਾਨ ਸਥਿਤੀ ਨਹੀਂ",
    "No Topic": "ਕੋਈ ਵਿਸ਼ਾ ਨਹੀਂ",
    "No Source": "ਕੋਈ ਸਰੋਤ ਨਹੀਂ",
    "All Statuses": "ਸਾਰੀਆਂ ਸਥਿਤੀਆਂ",
    "All Topics": "ਸਾਰੇ ਵਿਸ਼ੇ",
    "No clients found": "ਕੋਈ ਗਾਹਕ ਨਹੀਂ ਮਿਲਿਆ",
    "Type to search clients": "ਕਲਾਇੰਟਸ ਨੂੰ ਖੋਜਣ ਲਈ ਟਾਈਪ ਕਰੋ",
    "No charts found": "ਕੋਈ ਚਾਰਟ ਨਹੀਂ ਮਿਲੇ",
    "Type to search saved charts": "ਸੁਰੱਖਿਅਤ ਕੀਤੇ ਚਾਰਟ ਖੋਜਣ ਲਈ ਟਾਈਪ ਕਰੋ",
    "Type to search related client": "ਸੰਬੰਧਿਤ ਕਲਾਇੰਟ ਨੂੰ ਖੋਜਣ ਲਈ ਟਾਈਪ ਕਰੋ",
    "Open": "ਖੋਲ੍ਹੋ",
    "Pending": "ਬਕਾਇਆ",
    "Scheduled": "ਤਹਿ ਕੀਤਾ",
    "Completed": "ਪੂਰਾ ਹੋਇਆ",
    "Follow-up Pending": "ਫਾਲੋ-ਅੱਪ ਬਕਾਇਆ",
    "Cancelled": "ਰੱਦ ਕਰ ਦਿੱਤਾ",
    "Closed": "ਬੰਦ",
    "No-show": "ਨਾਹ-ਵੇਖਾ",
    "Not Applicable": "ਲਾਗੂ ਨਹੀਂ ਹੈ",
    "Paid": "ਭੁਗਤਾਨ ਕੀਤਾ",
    "Partially Paid": "ਅੰਸ਼ਕ ਤੌਰ 'ਤੇ ਭੁਗਤਾਨ ਕੀਤਾ ਗਿਆ",
    "Refunded": "ਰਿਫੰਡ ਕੀਤਾ ਗਿਆ",
    "Phone": "ਫ਼ੋਨ",
    "WhatsApp Call": "ਵਟਸਐਪ ਕਾਲ",
    "Video Call": "ਵੀਡੀਓ ਕਾਲ",
    "In-person": "ਵਿਅਕਤੀਗਤ ਤੌਰ 'ਤੇ",
    "Chat": "ਚੈਟ",
    "Other": "ਹੋਰ",
    "New": "ਨਵਾਂ",
    "VIP": "ਵੀ.ਆਈ.ਪੀ",
    "Inactive": "ਅਕਿਰਿਆਸ਼ੀਲ",
    "Consultation Completed": "ਸਲਾਹ-ਮਸ਼ਵਰਾ ਪੂਰਾ ਹੋਇਆ",
    "WhatsApp": "ਵਟਸਐਪ",
    "Instagram": "Instagram",
    "YouTube": "YouTube",
    "Referral": "ਰੈਫਰਲ",
    "Website": "ਵੈੱਬਸਾਈਟ",
    "Walk-in": "ਵਾਕ-ਇਨ",
    "Repeat Client": "ਗਾਹਕ ਨੂੰ ਦੁਹਰਾਓ",
    "Family Referral": "ਪਰਿਵਾਰਕ ਰੈਫਰਲ",
    "Business": "ਵਪਾਰ",
    "Finance": "ਵਿੱਤ",
    "Property": "ਜਾਇਦਾਦ",
    "Children": "ਬੱਚੇ",
    "Foreign Settlement": "ਵਿਦੇਸ਼ੀ ਬੰਦੋਬਸਤ",
    "Legal": "ਕਾਨੂੰਨੀ",
    "Remedy": "ਉਪਾਅ",
    "General": "ਜਨਰਲ",
    "Active": "ਕਿਰਿਆਸ਼ੀਲ",
    "Past": "ਅਤੀਤ",
    "Potential": "ਸੰਭਾਵੀ",
    "Archived": "ਪੁਰਾਲੇਖ",
    "Spouse": "ਜੀਵਨ ਸਾਥੀ",
    "Husband": "ਪਤੀ",
    "Wife": "ਪਤਨੀ",
    "Child": "ਬੱਚਾ",
    "Son": "ਪੁੱਤਰ",
    "Daughter": "ਧੀ",
    "Father": "ਪਿਤਾ",
    "Mother": "ਮਾਂ",
    "Sibling": "ਭੈਣ-ਭਰਾ",
    "Brother": "ਭਾਈ",
    "Sister": "ਭੈਣ",
    "Marriage Prospect": "ਵਿਆਹ ਦੀ ਸੰਭਾਵਨਾ",
    "Fiance": "ਮੰਗੇਤਰ",
    "Business Partner": "ਵਪਾਰਕ ਸਾਥੀ",
    "Friend": "ਦੋਸਤ",
    "Relative": "ਰਿਸ਼ਤੇਦਾਰ",
    "Upgrade": "ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "ਤੁਸੀਂ ਸਿਰਫ਼ 2 ਗਾਹਕਾਂ ਨੂੰ ਜੋੜ ਸਕਦੇ ਹੋ। ਹੋਰ ਗਾਹਕਾਂ ਲਈ ਪ੍ਰੀਮੀਅਮ ਵਿੱਚ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
    "None": "ਕੋਈ ਨਹੀਂ",
    "Education": "ਸਿੱਖਿਆ",
    "Awards": "ਅਵਾਰਡ",
    "Prize": "ਇਨਾਮ",
    "Career": "ਕੈਰੀਅਰ",
    "Love": "ਪਿਆਰ",
    "Marriage": "ਵਿਆਹ",
    "Dowry or Legacy": "ਦਾਜ ਜਾਂ ਵਿਰਾਸਤ",
    "Divorce": "ਤਲਾਕ",
    "Abortion": "ਗਰਭਪਾਤ",
    "Child Birth": "ਬੱਚੇ ਦਾ ਜਨਮ",
    "Property/Vehicle Purchase": "ਜਾਇਦਾਦ/ਵਾਹਨ ਦੀ ਖਰੀਦਦਾਰੀ",
    "Property/Vehicle Sale": "ਜਾਇਦਾਦ/ਵਾਹਨ ਦੀ ਵਿਕਰੀ",
    "Love and Caring": "ਪਿਆਰ ਅਤੇ ਦੇਖਭਾਲ",
    "Depression": "ਉਦਾਸੀ",
    "Aggression": "ਹਮਲਾਵਰਤਾ",
    "Health": "ਸਿਹਤ",
    "Travel": "ਯਾਤਰਾ",
    "Homecoming": "ਘਰ ਵਾਪਸੀ",
    "Litigation": "ਮੁਕੱਦਮੇਬਾਜ਼ੀ",
    "Arrest": "ਗ੍ਰਿਫਤਾਰ",
    "Locked": "ਤਾਲਾਬੰਦ",
    "Strong": "ਮਜ਼ਬੂਤ",
    "Weak": "ਕਮਜ਼ੋਰ",
    "Supportive": "ਸਹਾਇਕ",
    "Avoid": "ਬਚੋ",
    "Premium": "ਪ੍ਰੀਮੀਅਮ",
    " UTC": "UTC",
    "Unable to calculate Tithi Pravesh": "ਤਿਥੀ ਪ੍ਰਵੇਸ਼ ਦੀ ਗਣਨਾ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
    "IANA timezone": "IANA ਸਮਾਂ ਖੇਤਰ",
    "TP Local": "TP ਸਥਾਨਕ",
    "TP UTC": "TP UTC",
    "Next TP Local": "ਅਗਲਾ TP ਸਥਾਨਕ",
    "Models: KP + Vedic": "ਮਾਡਲ: ਕੇਪੀ + ਵੈਦਿਕ",
    "Overall Year Theme": "ਕੁੱਲ ਮਿਲਾ ਕੇ ਸਾਲ ਦੀ ਥੀਮ",
    "Career & Job": "ਕਰੀਅਰ ਅਤੇ ਨੌਕਰੀ",
    "Finance & Savings": "ਵਿੱਤ ਅਤੇ ਬਚਤ",
    "Relationship & Marriage": "ਰਿਸ਼ਤਾ ਅਤੇ ਵਿਆਹ",
    "Family Matters": "ਪਰਿਵਾਰਕ ਮਾਮਲੇ",
    "Property & Vehicle": "ਜਾਇਦਾਦ ਅਤੇ ਵਾਹਨ",
    "Health & Wellness": "ਸਿਹਤ ਅਤੇ ਤੰਦਰੁਸਤੀ",
    "Spiritual Growth": "ਆਤਮਿਕ ਵਿਕਾਸ",
    "Social Status & Recognition": "ਸਮਾਜਿਕ ਸਥਿਤੀ ਅਤੇ ਮਾਨਤਾ",
    "Please select a saved chart first.": "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਇੱਕ ਸੁਰੱਖਿਅਤ ਕੀਤਾ ਚਾਰਟ ਚੁਣੋ।",
    "Unable to generate Tajika Varshphal": "ਤਾਜਿਕਾ ਵਰਸ਼ਫਾਲ ਬਣਾਉਣ ਵਿੱਚ ਅਸਮਰੱਥ",
    "Premium yearly module": "ਪ੍ਰੀਮੀਅਮ ਸਾਲਾਨਾ ਮੋਡੀਊਲ",
    "Tajika Varshphal": "ਤਾਜਿਕਾ ਵਰਸ਼ਫਲ",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "ਸੂਰਜੀ ਰਿਟਰਨ ਆਧਾਰਿਤ ਸਲਾਨਾ ਕੁੰਡਲੀ, ਵਰਸ਼ਾ ਲਗਨਾ, ਮੁੰਠਾ, ਵਰਸ਼ ਪ੍ਰਭੂ, ਸਹਮਸ, ਮਾਸਿਕ ਮਾਰਗਦਰਸ਼ਨ, ਉਪਚਾਰ, ਅਤੇ ਵਿਹਾਰਕ ਜੀਵਨ ਥੀਮਾਂ ਦੇ ਨਾਲ ਇਸ ਸੁਰੱਖਿਅਤ ਕੀਤੀ ਕੁੰਡਲੀ ਤੋਂ ਵਿਅਕਤੀਗਤ ਬਣਾਈ ਗਈ ਹੈ।",
    "Saved chart": "ਰੱਖਿਅਤ ਕੀਤਾ ਚਾਰਟ",
    "Untitled Chart": "ਬਿਨਾਂ ਸਿਰਲੇਖ ਵਾਲਾ ਚਾਰਟ",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "ਤੁਹਾਡੇ 4 ਮੁਫ਼ਤ ਪ੍ਰੀਮੀਅਮ ਕ੍ਰੈਡਿਟ ਵਰਤੇ ਜਾਂਦੇ ਹਨ। ਅਸੀਮਤ ਪ੍ਰੀਮੀਅਮ ਪਹੁੰਚ ਲਈ Kundlistar ਪ੍ਰੀਮੀਅਮ ਵਿੱਚ ਅੱਪਗਰੇਡ ਕਰੋ।",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "ਤੁਹਾਡਾ 4 ਮੁਫਤ ਪ੍ਰੀਮੀਅਮ ਕ੍ਰੈਡਿਟ ਵਰਤੋ। ਅਸਮਿਤ ਪ੍ਰੀਮੀਅਮ ਐਕਸੈਸ ਲਈ __KDL_MASK__0__ ਪ੍ਰੀਮੀਅਮ ਲੈਨ।",
    "Core Year Markers": "ਕੋਰ ਸਾਲ ਮਾਰਕਰ",
    "Solar Return": "ਸੂਰਜੀ ਵਾਪਸੀ",
    "Varsha Lagna": "ਵਰਸ਼ਾ ਲਗਨਾ",
    "Muntha Lord": "ਮੁੰਠਾ ਪ੍ਰਭੂ",
    "Varsha Lord": "ਵਰਸਾ ਪ੍ਰਭੂ",
    "Varshesh Method": "ਵਰਸ਼ੇਸ਼ ਵਿਧੀ",
    "Yearly Summary": "ਸਾਲਾਨਾ ਸੰਖੇਪ",
    "Not available yet.": "ਅਜੇ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।",
    "Varshesh Candidates": "ਵਾਰੇਸ਼ ਉਮੀਦਵਾਰ",
    "Risk Areas": "ਜੋਖਮ ਵਾਲੇ ਖੇਤਰ",
    "Favourable Periods": "ਅਨੁਕੂਲ ਮਿਆਦ",
    "Challenging Periods": "ਚੁਣੌਤੀਪੂਰਨ ਦੌਰ",
    "Remedies & Final Advice": "ਉਪਚਾਰ ਅਤੇ ਅੰਤਮ ਸਲਾਹ",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "ਤਾਜਿਕਾ ਵਰਸ਼ਫਾਲ ਵਿਆਖਿਆਤਮਕ ਸਾਲਾਨਾ ਮਾਰਗਦਰਸ਼ਨ ਦਿੰਦੀ ਹੈ। ਇਸ ਨੂੰ ਡਾਕਟਰੀ, ਕਾਨੂੰਨੀ, ਵਿੱਤੀ, ਜਾਂ ਕੁਝ ਪੂਰਵ-ਅਨੁਮਾਨ ਸਲਾਹ ਵਜੋਂ ਨਹੀਂ ਮੰਨਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "Griha Pravesh": "ਗ੍ਰਹਿ ਪ੍ਰਵੇਸ਼",
    "Purva Phalguni": "ਪੂਰਵਾ ਫਾਲਗੁਨੀ",
    "Uttara Phalguni": "ਉੱਤਰਾ ਫਾਲਗੁਨੀ",
    "Purva Ashadha": "ਪੂਰਵ ਅਸਾਧ",
    "Uttara Ashadha": "ਉੱਤਰਾ ਅਸਾਧ",
    "Purva Bhadrapada": "ਪੂਰਵਾ ਭਾਦਰਪਦ",
    "Uttara Bhadrapada": "ਉੱਤਰਾ ਭਾਦਰਪਦ",
    "Param Mitra": "ਪਰਮ ਮਿੱਤਰ",
    "Kundli birthplace": "ਕੁੰਡਲੀ ਜਨਮ ਸਥਾਨ",
    "Selected city": "ਚੁਣਿਆ ਗਿਆ ਸ਼ਹਿਰ",
    "Muhurat - Kundlistar": "ਮੁਹੂਰਤ - Kundlistar",
    "Please select a city first.": "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਇੱਕ ਸ਼ਹਿਰ ਚੁਣੋ।",
    "Unable to calculate Muhurat.": "ਮੁਹੂਰਤ ਦੀ ਗਣਨਾ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Unable to calculate personalized Muhurat.": "ਵਿਅਕਤੀਗਤ ਬਣਾਏ ਮੁਹੂਰਤ ਦੀ ਗਣਨਾ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "ਪੰਚਾਂਗ, ਚੋਘੜੀਆ, ਹੋਰਾ, ਤਰਾਬਲਾ ਅਤੇ ਚੰਦਰਬਾਲਾ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਆਮ ਅਤੇ ਵਿਅਕਤੀਗਤ ਮੁਹੂਰਤ ਲੱਭੋ।",
    "Muhurat Finder": "ਮੁਹੂਰਤ ਖੋਜਕ",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "ਪੰਚਾਂਗ, ਚੋਘੜੀਆ ਅਤੇ ਪ੍ਰੀਮੀਅਮ ਨਿੱਜੀ ਜਨਮ ਕਾਰਕਾਂ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹੋਏ ਉਪਯੋਗੀ ਸਮਾਂ ਵਿੰਡੋਜ਼ ਲੱਭੋ।",
    "Search city...": "ਸ਼ਹਿਰ ਖੋਜੋ...",
    "Using selected Kundli": "ਚੁਣੀ ਕੁੰਡਲੀ ਦੀ ਵਰਤੋਂ ਕਰਨਾ",
    "Find Free": "ਮੁਫ਼ਤ ਲੱਭੋ",
    "Free General Muhurat": "ਮੁਫਤ ਜਨਰਲ ਮੁਹੂਰਤ",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "ਅਗਲੇ 7 ਦਿਨਾਂ ਲਈ ਚੋਟੀ ਦੇ 3 ਸਲਾਟ। ਰਾਹੂ ਕਾਲ, ਯਮਗੰਡਾ ਅਤੇ ਗੁਲਿਕਾ ਨੂੰ ਹਟਾ ਦਿੱਤਾ ਜਾਂਦਾ ਹੈ।",
    "Today's Muhurat": "ਅੱਜ ਦਾ ਮੁਹੂਰਤ",
    "Daily Muhurat by Kundlistar": "Kundlistar ਦੁਆਰਾ ਰੋਜ਼ਾਨਾ ਮੁਹੂਰਤ",
    "Shared via Kundlistar": "Kundlistar ਦੁਆਰਾ ਸਾਂਝਾ ਕੀਤਾ ਗਿਆ",
    "Kundlistar Muhurat": "Kundlistar ਮੁਹੂਰਤ",
    "Share Image": "ਚਿੱਤਰ ਸਾਂਝਾ ਕਰੋ",
    "Share Text": "ਟੈਕਸਟ ਸਾਂਝਾ ਕਰੋ",
    "Copy Text": "ਟੈਕਸਟ ਕਾਪੀ ਕਰੋ",
    "Click Find Free to use the selected Kundli birthplace.": "ਚੁਣੇ ਗਏ ਕੁੰਡਲੀ ਜਨਮ ਸਥਾਨ ਦੀ ਵਰਤੋਂ ਕਰਨ ਲਈ ਮੁਫ਼ਤ ਲੱਭੋ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    "Select a city and click Find Free.": "ਇੱਕ ਸ਼ਹਿਰ ਚੁਣੋ ਅਤੇ ਮੁਫ਼ਤ ਲੱਭੋ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    "Premium Personalized Muhurat": "ਪ੍ਰੀਮੀਅਮ ਵਿਅਕਤੀਗਤ ਮੁਹੂਰਤ",
    "Loading Kundli details...": "ਕੁੰਡਲੀ ਵੇਰਵੇ ਲੋਡ ਕੀਤੇ ਜਾ ਰਹੇ ਹਨ...",
    "Birth Nakshatra": "ਜਨਮ ਨਕਸ਼ਤਰ",
    "Birth Moon Rashi": "ਜਨਮ ਚੰਦਰਮਾ ਰਾਸ਼ੀ",
    "Include night slots": "ਰਾਤ ਦੇ ਸਲਾਟ ਸ਼ਾਮਲ ਕਰੋ",
    "Find Premium": "ਪ੍ਰੀਮੀਅਮ ਲੱਭੋ",
    "Your grounding and foundation energy appears strong in this chart.": "ਤੁਹਾਡੀ ਗਰਾਉਂਡਿੰਗ ਅਤੇ ਫਾਊਂਡੇਸ਼ਨ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਮਜ਼ਬੂਤ ​​ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Your grounding energy appears generally balanced in this chart.": "ਤੁਹਾਡੀ ਗਰਾਊਂਡਿੰਗ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਆਮ ਤੌਰ 'ਤੇ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Reflection on routine, discipline, and inner stability may be useful.": "ਰੁਟੀਨ, ਅਨੁਸ਼ਾਸਨ, ਅਤੇ ਅੰਦਰੂਨੀ ਸਥਿਰਤਾ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ.",
    "Your creative and emotional flow energy appears strong in this chart.": "ਤੁਹਾਡੀ ਰਚਨਾਤਮਕ ਅਤੇ ਭਾਵਨਾਤਮਕ ਪ੍ਰਵਾਹ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਮਜ਼ਬੂਤ ​​ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Your creative energy appears balanced in this chart.": "ਤੁਹਾਡੀ ਰਚਨਾਤਮਕ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "ਰਚਨਾਤਮਕਤਾ, ਭਾਵਨਾਤਮਕ ਪ੍ਰਗਟਾਵੇ, ਅਤੇ ਅੰਦਰੂਨੀ ਪ੍ਰਵਾਹ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "Your confidence and willpower energy appears strong in this chart.": "ਤੁਹਾਡਾ ਵਿਸ਼ਵਾਸ ਅਤੇ ਇੱਛਾ ਸ਼ਕਤੀ ਇਸ ਚਾਰਟ ਵਿੱਚ ਮਜ਼ਬੂਤ ​​ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Your action-taking energy appears balanced in this chart.": "ਤੁਹਾਡੀ ਕਾਰਵਾਈ ਕਰਨ ਵਾਲੀ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Reflection on confidence, discipline, and decision power may be useful.": "ਆਤਮ-ਵਿਸ਼ਵਾਸ, ਅਨੁਸ਼ਾਸਨ ਅਤੇ ਫੈਸਲੇ ਦੀ ਸ਼ਕਤੀ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "Your connection and compassion energy appears strong in this chart.": "ਇਸ ਚਾਰਟ ਵਿੱਚ ਤੁਹਾਡਾ ਕਨੈਕਸ਼ਨ ਅਤੇ ਹਮਦਰਦੀ ਊਰਜਾ ਮਜ਼ਬੂਤ ​​ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Your emotional connection energy appears balanced in this chart.": "ਤੁਹਾਡੀ ਭਾਵਨਾਤਮਕ ਕਨੈਕਸ਼ਨ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "ਇਕਸੁਰਤਾ, ਮਾਫ਼ੀ, ਅਤੇ ਭਾਵਨਾਤਮਕ ਸੰਤੁਲਨ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ.",
    "Your communication and expression energy appears strong in this chart.": "ਤੁਹਾਡੀ ਸੰਚਾਰ ਅਤੇ ਪ੍ਰਗਟਾਵੇ ਦੀ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਮਜ਼ਬੂਤ ​​ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Your expression energy appears balanced in this chart.": "ਤੁਹਾਡੀ ਸਮੀਕਰਨ ਊਰਜਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Reflection on clear communication and self-expression may be useful.": "ਸਪਸ਼ਟ ਸੰਚਾਰ ਅਤੇ ਸਵੈ-ਪ੍ਰਗਟਾਵੇ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "Your intuition and inner clarity appears strong in this chart.": "ਤੁਹਾਡੀ ਸੂਝ ਅਤੇ ਅੰਦਰੂਨੀ ਸਪਸ਼ਟਤਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਮਜ਼ਬੂਤ ​​ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Your intuitive clarity appears balanced in this chart.": "ਤੁਹਾਡੀ ਅਨੁਭਵੀ ਸਪੱਸ਼ਟਤਾ ਇਸ ਚਾਰਟ ਵਿੱਚ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।",
    "Reflection on focus, intuition, and inner guidance may be useful.": "ਫੋਕਸ, ਅਨੁਭਵ ਅਤੇ ਅੰਦਰੂਨੀ ਮਾਰਗਦਰਸ਼ਨ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "A strong Fire element supports action, courage, and leadership energy.": "ਇੱਕ ਮਜ਼ਬੂਤ ​​ਫਾਇਰ ਤੱਤ ਕਾਰਵਾਈ, ਹਿੰਮਤ ਅਤੇ ਲੀਡਰਸ਼ਿਪ ਊਰਜਾ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "ਅੱਗ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ, ਕਾਰਵਾਈ ਅਤੇ ਧੀਰਜ ਦੇ ਵਿਚਕਾਰ ਇੱਕ ਸਥਿਰ ਤਾਲ ਦਾ ਸਮਰਥਨ ਕਰਦੀ ਹੈ।",
    "Reflection on confidence and action-taking may be useful.": "ਆਤਮ-ਵਿਸ਼ਵਾਸ ਅਤੇ ਕਾਰਵਾਈ ਕਰਨ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "A strong Earth element supports practicality, patience, and stability.": "ਇੱਕ ਮਜ਼ਬੂਤ ​​ਧਰਤੀ ਦਾ ਤੱਤ ਵਿਹਾਰਕਤਾ, ਧੀਰਜ ਅਤੇ ਸਥਿਰਤਾ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Earth appears balanced, supporting practical thinking with flexibility.": "ਧਰਤੀ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ, ਲਚਕਤਾ ਦੇ ਨਾਲ ਵਿਹਾਰਕ ਸੋਚ ਦਾ ਸਮਰਥਨ ਕਰਦੀ ਹੈ।",
    "Reflection on grounding, consistency, and planning may be useful.": "ਗਰਾਉਂਡਿੰਗ, ਇਕਸਾਰਤਾ ਅਤੇ ਯੋਜਨਾਬੰਦੀ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "A strong Air element supports ideas, communication, and adaptability.": "ਇੱਕ ਮਜ਼ਬੂਤ ​​ਹਵਾ ਤੱਤ ਵਿਚਾਰਾਂ, ਸੰਚਾਰ ਅਤੇ ਅਨੁਕੂਲਤਾ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Air appears balanced, supporting harmony between thinking and action.": "ਹਵਾ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ, ਸੋਚ ਅਤੇ ਕਿਰਿਆ ਵਿਚਕਾਰ ਇਕਸੁਰਤਾ ਦਾ ਸਮਰਥਨ ਕਰਦੀ ਹੈ।",
    "Reflection on communication and flexibility may be useful.": "ਸੰਚਾਰ ਅਤੇ ਲਚਕਤਾ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ.",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "ਪਾਣੀ ਦਾ ਇੱਕ ਮਜ਼ਬੂਤ ​​ਤੱਤ ਅਨੁਭਵ, ਸੰਵੇਦਨਸ਼ੀਲਤਾ ਅਤੇ ਭਾਵਨਾਤਮਕ ਡੂੰਘਾਈ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Water appears balanced, supporting harmony between emotions and logic.": "ਪਾਣੀ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦਾ ਹੈ, ਭਾਵਨਾਵਾਂ ਅਤੇ ਤਰਕ ਵਿਚਕਾਰ ਇਕਸੁਰਤਾ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Reflection on emotional expression and inner connection may be useful.": "ਭਾਵਨਾਤਮਕ ਪ੍ਰਗਟਾਵੇ ਅਤੇ ਅੰਦਰੂਨੀ ਸਬੰਧਾਂ 'ਤੇ ਪ੍ਰਤੀਬਿੰਬ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "A strong Ether element supports spiritual awareness and broader vision.": "ਇੱਕ ਮਜ਼ਬੂਤ ​​ਈਥਰ ਤੱਤ ਅਧਿਆਤਮਿਕ ਜਾਗਰੂਕਤਾ ਅਤੇ ਵਿਆਪਕ ਦ੍ਰਿਸ਼ਟੀ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ਈਥਰ ਸੰਤੁਲਿਤ ਦਿਖਾਈ ਦਿੰਦਾ ਹੈ, ਅਧਿਆਤਮਿਕ ਅਤੇ ਵਿਹਾਰਕ ਪਹੁੰਚ ਵਿਚਕਾਰ ਇਕਸੁਰਤਾ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Reflection, silence, and spiritual discipline may be useful.": "ਪ੍ਰਤੀਬਿੰਬ, ਚੁੱਪ ਅਤੇ ਅਧਿਆਤਮਿਕ ਅਨੁਸ਼ਾਸਨ ਲਾਭਦਾਇਕ ਹੋ ਸਕਦਾ ਹੈ।",
    "For inner confidence, clarity, and soul strength.": "ਅੰਦਰੂਨੀ ਵਿਸ਼ਵਾਸ, ਸਪਸ਼ਟਤਾ ਅਤੇ ਆਤਮਾ ਦੀ ਤਾਕਤ ਲਈ।",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "ਇਹ ਇਸ਼ਟ ਦੇਵਤਾ ਸੰਕੇਤ ਜਨਮ ਚਾਰਟ ਤੋਂ ਗ੍ਰਹਿ ਸ਼ਕਤੀ, ਲਗਨ ਪ੍ਰਭੂ, ਚੰਦਰਮਾ ਚਿੰਨ੍ਹ ਦੇ ਸੁਆਮੀ ਅਤੇ ਆਤਮਕਾਰਕ 'ਤੇ ਅਧਾਰਤ ਹੈ।",
    "For calmness, emotional balance, and softness.": "ਸ਼ਾਂਤਤਾ, ਭਾਵਨਾਤਮਕ ਸੰਤੁਲਨ ਅਤੇ ਕੋਮਲਤਾ ਲਈ।",
    "For courage, protection, and discipline.": "ਹਿੰਮਤ, ਸੁਰੱਖਿਆ ਅਤੇ ਅਨੁਸ਼ਾਸਨ ਲਈ।",
    "For intellect, speech, learning, and obstacle removal.": "ਬੁੱਧੀ, ਬੋਲਣ, ਸਿੱਖਣ ਅਤੇ ਰੁਕਾਵਟਾਂ ਨੂੰ ਦੂਰ ਕਰਨ ਲਈ।",
    "For knowledge, guidance, dharma, and blessings.": "ਗਿਆਨ, ਮਾਰਗਦਰਸ਼ਨ, ਧਰਮ ਅਤੇ ਅਸੀਸਾਂ ਲਈ।",
    "Mahalakshmi Ji": "ਮਹਾਲਕਸ਼ਮੀ ਜੀ",
    "For harmony, beauty, comfort, and prosperity.": "ਸਦਭਾਵਨਾ, ਸੁੰਦਰਤਾ, ਆਰਾਮ ਅਤੇ ਖੁਸ਼ਹਾਲੀ ਲਈ.",
    "For karma, patience, discipline, and protection.": "ਕਰਮ, ਧੀਰਜ, ਅਨੁਸ਼ਾਸਨ ਅਤੇ ਸੁਰੱਖਿਆ ਲਈ।",
    "For protection from confusion, fear, and illusion.": "ਉਲਝਣ, ਡਰ ਅਤੇ ਭਰਮ ਤੋਂ ਸੁਰੱਖਿਆ ਲਈ।",
    "Lord Ganesha": "ਭਗਵਾਨ ਗਣੇਸ਼",
    "For spiritual clarity, detachment, and obstacle removal.": "ਅਧਿਆਤਮਿਕ ਸਪਸ਼ਟਤਾ, ਨਿਰਲੇਪਤਾ ਅਤੇ ਰੁਕਾਵਟਾਂ ਨੂੰ ਹਟਾਉਣ ਲਈ।",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "ਚੱਕਰ ਦੀ ਸੂਝ ਲਈ ਚਾਰਟ ਡੇਟਾ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ।",
    "Unable to load Chakra insight.": "ਚੱਕਰ ਇਨਸਾਈਟ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "ਇਹ ਕੇਵਲ ਜਨਮ ਕੁੰਡਲੀ ਆਧਾਰਿਤ ਅਧਿਆਤਮਿਕ ਊਰਜਾ ਸੂਝ ਅਤੇ ਸਵੈ-ਪ੍ਰਤੀਬਿੰਬ ਹੈ। ਇਹ ਪੇਸ਼ੇਵਰ ਸਲਾਹ ਨਹੀਂ ਹੈ।",
    "Spiritual energy insights from Kundli": "ਕੁੰਡਲੀ ਤੋਂ ਅਧਿਆਤਮਿਕ ਊਰਜਾ ਦੀ ਸੂਝ",
    "Calculated from your individual birth chart": "ਤੁਹਾਡੇ ਵਿਅਕਤੀਗਤ ਜਨਮ ਚਾਰਟ ਤੋਂ ਗਿਣਿਆ ਜਾਂਦਾ ਹੈ",
    "Chakra Balance": "ਚੱਕਰ ਸੰਤੁਲਨ",
    "Panch Tatva Balance": "ਪੰਚ ਤੱਤ ਸੰਤੁਲਨ",
    "Ishta Devata": "ਇਸ਼ਟ ਦੇਵਤਾ",
    "Signal planet": "ਸੰਕੇਤ ਗ੍ਰਹਿ",
    "Very Good": "ਬਹੁਤ ਅੱਛਾ",
    "Very Bad": "ਬਹੁਤ ਬੁਰਾ",
    "Panch Pakshi Calculator - Kundlistar": "ਪੰਚ ਪੱਖੀ ਕੈਲਕੂਲੇਟਰ - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "ਚਾਰਟ ਤੋਂ ਪੰਚ ਪਕਸ਼ੀ ਨੂੰ ਪ੍ਰੀਫਿਲ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ। ਤੁਸੀਂ ਅਜੇ ਵੀ ਹੱਥੀਂ ਗਣਨਾ ਕਰ ਸਕਦੇ ਹੋ।",
    "Could not load sunrise and sunset from Panchang for this chart location.": "ਇਸ ਚਾਰਟ ਟਿਕਾਣੇ ਲਈ ਪੰਚਾਂਗ ਤੋਂ ਸੂਰਜ ਚੜ੍ਹਨ ਅਤੇ ਸੂਰਜ ਡੁੱਬਣ ਨੂੰ ਲੋਡ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "ਪੰਚਾਂਗ ਤੋਂ ਸੂਰਜ ਚੜ੍ਹਨ, ਸੂਰਜ ਡੁੱਬਣ ਅਤੇ ਅਗਲੇ ਸੂਰਜ ਚੜ੍ਹਨ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Panch Pakshi calculation failed.": "ਪੰਚ ਪੱਖੀ ਦੀ ਗਣਨਾ ਅਸਫਲ ਰਹੀ।",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "ਪੰਚ ਪੰਛੀ, ਗਤੀਵਿਧੀ, ਯਮਮ, ਅਪਹਾਰਾ ਮਿਆਦ, ਸਬੰਧ, ਸਕੋਰ ਅਤੇ ਨਤੀਜੇ ਦੀ ਗਣਨਾ ਕਰੋ।",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "ਤੁਹਾਡੇ ਮੁਫਤ ਪ੍ਰੀਮੀਅਮ ਕ੍ਰੈਡਿਟ ਖਤਮ ਹੋ ਗਏ ਹਨ। ਜਾਰੀ ਰੱਖਣ ਲਈ ਪ੍ਰੀਮੀਅਮ 'ਤੇ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
    "This is a premium feature. You can use 1 free premium credit to continue.": "ਇਹ ਇੱਕ ਪ੍ਰੀਮੀਅਮ ਵਿਸ਼ੇਸ਼ਤਾ ਹੈ। ਤੁਸੀਂ ਜਾਰੀ ਰੱਖਣ ਲਈ 1 ਮੁਫ਼ਤ ਪ੍ਰੀਮੀਅਮ ਕ੍ਰੈਡਿਟ ਦੀ ਵਰਤੋਂ ਕਰ ਸਕਦੇ ਹੋ।",
    "Selected Date": "ਚੁਣੀ ਗਈ ਮਿਤੀ",
    "repeat(3, 1fr)": "ਦੁਹਰਾਓ(3, 1fr)",
    "Birth Paksha": "ਜਨਮ ਪੱਖ",
    "Current Paksha": "ਮੌਜੂਦਾ ਪਾਕਸ਼",
    "repeat(4, 1fr)": "ਦੁਹਰਾਓ (4, 1fr)",
    "Target Date Time": "ਟੀਚਾ ਮਿਤੀ ਸਮਾਂ",
    "Next Sunrise": "ਅਗਲਾ ਸੂਰਜ ਚੜ੍ਹਨਾ",
    "Calculate Panch Pakshi": "ਪੰਚ ਪੱਖ ਦੀ ਗਣਨਾ ਕਰੋ",
    "repeat(2, 1fr)": "ਦੁਹਰਾਓ (2, 1fr)",
    "repeat(6, 1fr)": "ਦੁਹਰਾਓ (6, 1fr)",
    "Birth Pakshi": "ਜਨਮ ਪਾਖੀ",
    "Current Period": "ਵਰਤਮਾਨ ਮਿਆਦ",
    "Current Yamam": "ਵਰਤਮਾਨ ਯਮਮ",
    "Main Activity": "ਮੁੱਖ ਗਤੀਵਿਧੀ",
    "Natal Western Chart": "ਨੇਟਲ ਪੱਛਮੀ ਚਾਰਟ",
    "Life Phase Progression": "ਜੀਵਨ ਪੜਾਅ ਤਰੱਕੀ",
    "Self-focus, identity change, body awareness and personal reset.": "ਸਵੈ-ਫੋਕਸ, ਪਛਾਣ ਤਬਦੀਲੀ, ਸਰੀਰ ਦੀ ਜਾਗਰੂਕਤਾ ਅਤੇ ਨਿੱਜੀ ਰੀਸੈਟ.",
    "Money, values, family, speech and security become emotionally important.": "ਪੈਸਾ, ਮੁੱਲ, ਪਰਿਵਾਰ, ਬੋਲੀ ਅਤੇ ਸੁਰੱਖਿਆ ਭਾਵਨਾਤਮਕ ਤੌਰ 'ਤੇ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Communication, learning, siblings, writing and short travel become important.": "ਸੰਚਾਰ, ਸਿੱਖਣ, ਭੈਣ-ਭਰਾ, ਲੇਖਣੀ ਅਤੇ ਛੋਟੀ ਯਾਤਰਾ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੀ ਹੈ।",
    "Home, mother, property, family and emotional roots become important.": "ਘਰ, ਮਾਂ, ਜਾਇਦਾਦ, ਪਰਿਵਾਰ ਅਤੇ ਭਾਵਨਾਤਮਕ ਜੜ੍ਹਾਂ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੀਆਂ ਹਨ।",
    "Creativity, romance, children, hobbies and self-expression become important.": "ਰਚਨਾਤਮਕਤਾ, ਰੋਮਾਂਸ, ਬੱਚੇ, ਸ਼ੌਕ ਅਤੇ ਸਵੈ-ਪ੍ਰਗਟਾਵੇ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Work routine, health habits, service and discipline become important.": "ਕੰਮ ਦੀ ਰੁਟੀਨ, ਸਿਹਤ ਦੀਆਂ ਆਦਤਾਂ, ਸੇਵਾ ਅਤੇ ਅਨੁਸ਼ਾਸਨ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Relationship, marriage, partnership and public dealing become important.": "ਰਿਸ਼ਤਾ, ਵਿਆਹ, ਭਾਈਵਾਲੀ ਅਤੇ ਪਬਲਿਕ ਡੀਲਿੰਗ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Deep emotional change, intimacy, shared money and transformation become important.": "ਡੂੰਘੀ ਭਾਵਨਾਤਮਕ ਤਬਦੀਲੀ, ਨੇੜਤਾ, ਸਾਂਝਾ ਪੈਸਾ ਅਤੇ ਪਰਿਵਰਤਨ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Learning, travel, teaching, belief and higher wisdom become important.": "ਸਿੱਖਣ, ਯਾਤਰਾ, ਉਪਦੇਸ਼, ਵਿਸ਼ਵਾਸ ਅਤੇ ਉੱਚ ਬੁੱਧੀ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੀ ਹੈ।",
    "Career, status, public image and responsibility become emotionally important.": "ਕਰੀਅਰ, ਰੁਤਬਾ, ਜਨਤਕ ਅਕਸ ਅਤੇ ਜ਼ਿੰਮੇਵਾਰੀ ਭਾਵਨਾਤਮਕ ਤੌਰ 'ਤੇ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Income, friends, networking, community and ambitions become important.": "ਆਮਦਨ, ਦੋਸਤ, ਨੈੱਟਵਰਕਿੰਗ, ਭਾਈਚਾਰਾ ਅਤੇ ਅਭਿਲਾਸ਼ਾਵਾਂ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੀਆਂ ਹਨ।",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "ਆਰਾਮ, ਅਲੱਗ-ਥਲੱਗਤਾ, ਅਧਿਆਤਮਿਕਤਾ, ਵਿਦੇਸ਼ੀ ਸੰਪਰਕ ਅਤੇ ਅੰਦਰੂਨੀ ਇਲਾਜ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Identity development and self-expression are central.": "ਪਛਾਣ ਵਿਕਾਸ ਅਤੇ ਸਵੈ-ਪ੍ਰਗਟਾਵੇ ਕੇਂਦਰੀ ਹਨ।",
    "Values, money and self-worth become central.": "ਮੁੱਲ, ਪੈਸਾ ਅਤੇ ਸਵੈ-ਮੁੱਲ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Communication, learning and skills become central.": "ਸੰਚਾਰ, ਸਿੱਖਣ ਅਤੇ ਹੁਨਰ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Home, roots and emotional foundation become central.": "ਘਰ, ਜੜ੍ਹਾਂ ਅਤੇ ਭਾਵਨਾਤਮਕ ਬੁਨਿਆਦ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Creativity, love and self-expression become central.": "ਰਚਨਾਤਮਕਤਾ, ਪਿਆਰ ਅਤੇ ਸਵੈ-ਪ੍ਰਗਟਾਵੇ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Work, discipline and health routines become central.": "ਕੰਮ, ਅਨੁਸ਼ਾਸਨ ਅਤੇ ਸਿਹਤ ਰੁਟੀਨ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Partnerships and relationship identity become central.": "ਭਾਈਵਾਲੀ ਅਤੇ ਰਿਸ਼ਤੇ ਦੀ ਪਛਾਣ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੀ ਹੈ।",
    "Transformation, deep healing and shared resources become central.": "ਪਰਿਵਰਤਨ, ਡੂੰਘੀ ਇਲਾਜ ਅਤੇ ਸਾਂਝੇ ਸਰੋਤ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Wisdom, travel, belief and higher learning become central.": "ਸਿਆਣਪ, ਯਾਤਰਾ, ਵਿਸ਼ਵਾਸ ਅਤੇ ਉੱਚ ਸਿੱਖਿਆ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Career, authority and public role become central.": "ਕਰੀਅਰ, ਅਥਾਰਟੀ ਅਤੇ ਜਨਤਕ ਭੂਮਿਕਾ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੀ ਹੈ।",
    "Community, income, goals and networks become central.": "ਭਾਈਚਾਰਾ, ਆਮਦਨ, ਟੀਚੇ ਅਤੇ ਨੈੱਟਵਰਕ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Spirituality, closure, retreat and inner development become central.": "ਅਧਿਆਤਮਿਕਤਾ, ਬੰਦਸ਼, ਪਿੱਛੇ ਹਟਣਾ ਅਤੇ ਅੰਦਰੂਨੀ ਵਿਕਾਸ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦਾ ਹੈ।",
    "This house becomes emotionally important.": "ਇਹ ਘਰ ਭਾਵਨਾਤਮਕ ਤੌਰ 'ਤੇ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦਾ ਹੈ।",
    "This house becomes central for identity development.": "ਇਹ ਘਰ ਪਛਾਣ ਦੇ ਵਿਕਾਸ ਲਈ ਕੇਂਦਰੀ ਬਣ ਜਾਂਦਾ ਹੈ।",
    "Thinking, communication, learning and decisions are developing through this house.": "ਇਸ ਘਰ ਰਾਹੀਂ ਸੋਚ, ਸੰਚਾਰ, ਸਿੱਖਣ ਅਤੇ ਫੈਸਲੇ ਵਿਕਸਿਤ ਹੋ ਰਹੇ ਹਨ।",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "ਇਸ ਘਰ ਰਾਹੀਂ ਪਿਆਰ, ਆਰਾਮ, ਕਦਰਾਂ-ਕੀਮਤਾਂ, ਸੁੰਦਰਤਾ ਅਤੇ ਪੈਸੇ ਦੀਆਂ ਤਰਜੀਹਾਂ ਵਿਕਸਿਤ ਹੋ ਰਹੀਆਂ ਹਨ।",
    "Action style, courage, ambition and drive are developing through this house.": "ਇਸ ਘਰ ਰਾਹੀਂ ਐਕਸ਼ਨ ਸ਼ੈਲੀ, ਹਿੰਮਤ, ਅਭਿਲਾਸ਼ਾ ਅਤੇ ਡਰਾਈਵ ਦਾ ਵਿਕਾਸ ਹੋ ਰਿਹਾ ਹੈ।",
    "Growth, faith, learning and expansion themes develop through this house.": "ਇਸ ਘਰ ਰਾਹੀਂ ਵਿਕਾਸ, ਵਿਸ਼ਵਾਸ, ਸਿੱਖਣ ਅਤੇ ਵਿਸਤਾਰ ਦੇ ਵਿਸ਼ੇ ਵਿਕਸਿਤ ਹੁੰਦੇ ਹਨ।",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "ਇਸ ਘਰ ਰਾਹੀਂ ਪਰਿਪੱਕਤਾ, ਜ਼ਿੰਮੇਵਾਰੀ, ਅਨੁਸ਼ਾਸਨ ਅਤੇ ਲੰਮੇ ਸਮੇਂ ਦੀ ਬਣਤਰ ਦਾ ਵਿਕਾਸ ਹੁੰਦਾ ਹੈ।",
    "This progressed planet shows an inner life phase through this house.": "ਇਹ ਪ੍ਰਗਤੀਸ਼ੀਲ ਗ੍ਰਹਿ ਇਸ ਘਰ ਦੁਆਰਾ ਇੱਕ ਅੰਦਰੂਨੀ ਜੀਵਨ ਪੜਾਅ ਦਰਸਾਉਂਦਾ ਹੈ।",
    "New Moon Phase": "ਨਿਊ ਮੂਨ ਪੜਾਅ",
    "New beginning, identity reset and fresh internal cycle.": "ਨਵੀਂ ਸ਼ੁਰੂਆਤ, ਪਛਾਣ ਰੀਸੈਟ ਅਤੇ ਤਾਜ਼ਾ ਅੰਦਰੂਨੀ ਚੱਕਰ।",
    "Crescent Phase": "ਕ੍ਰੇਸੈਂਟ ਪੜਾਅ",
    "Growth, effort, learning and building confidence.": "ਵਿਕਾਸ, ਕੋਸ਼ਿਸ਼, ਸਿੱਖਣ ਅਤੇ ਆਤਮ ਵਿਸ਼ਵਾਸ ਪੈਦਾ ਕਰਨਾ।",
    "First Quarter Phase": "ਪਹਿਲਾ ਤਿਮਾਹੀ ਪੜਾਅ",
    "Action, decision-making, pressure and development.": "ਕਾਰਵਾਈ, ਫੈਸਲੇ ਲੈਣ, ਦਬਾਅ ਅਤੇ ਵਿਕਾਸ.",
    "Gibbous Phase": "ਗਿੱਬਸ ਪੜਾਅ",
    "Refinement, improvement, preparation and skill-building.": "ਸੁਧਾਰ, ਸੁਧਾਰ, ਤਿਆਰੀ ਅਤੇ ਹੁਨਰ-ਨਿਰਮਾਣ।",
    "Full Moon Phase": "ਪੂਰਾ ਚੰਦਰਮਾ ਪੜਾਅ",
    "Visibility, relationship awareness, emotional clarity and results.": "ਦਿੱਖ, ਰਿਸ਼ਤੇ ਦੀ ਜਾਗਰੂਕਤਾ, ਭਾਵਨਾਤਮਕ ਸਪੱਸ਼ਟਤਾ ਅਤੇ ਨਤੀਜੇ।",
    "Disseminating Phase": "ਪ੍ਰਸਾਰਣ ਪੜਾਅ",
    "Sharing, teaching, communication and distributing experience.": "ਸਾਂਝਾ ਕਰਨਾ, ਸਿਖਾਉਣਾ, ਸੰਚਾਰ ਕਰਨਾ ਅਤੇ ਤਜ਼ਰਬਾ ਵੰਡਣਾ।",
    "Last Quarter Phase": "ਆਖਰੀ ਤਿਮਾਹੀ ਪੜਾਅ",
    "Reorientation, correction, release and mature decision-making.": "ਪੁਨਰ-ਨਿਰਧਾਰਨ, ਸੁਧਾਰ, ਰੀਲੀਜ਼ ਅਤੇ ਪਰਿਪੱਕ ਫੈਸਲਾ ਲੈਣਾ।",
    "Balsamic Phase": "ਬਾਲਸਾਮਿਕ ਪੜਾਅ",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "ਬੰਦ, ਅਧਿਆਤਮਿਕ ਪ੍ਰਤੀਬਿੰਬ, ਆਰਾਮ ਅਤੇ ਇੱਕ ਨਵੇਂ ਚੱਕਰ ਲਈ ਤਿਆਰੀ।",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "ਇੱਕ ਪ੍ਰਮੁੱਖ ਭਾਵਨਾਤਮਕ ਅਤੇ ਪਛਾਣ ਪੜਾਅ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ. ਵਿਅਕਤੀ ਇੱਕ ਨਵੇਂ ਅਧਿਆਏ ਲਈ ਤਿਆਰ ਮਹਿਸੂਸ ਕਰ ਸਕਦਾ ਹੈ।",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "ਭਾਵਨਾਤਮਕ ਰੀਸੈਟ ਦੀ ਮਿਆਦ. ਪਰਿਵਾਰ, ਆਰਾਮ, ਅੰਦਰੂਨੀ ਸ਼ਾਂਤੀ ਅਤੇ ਭਾਵਨਾਤਮਕ ਲੋੜਾਂ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੀਆਂ ਹਨ।",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "ਪਿਆਰ, ਰਿਸ਼ਤਾ, ਆਰਾਮ, ਸੁੰਦਰਤਾ ਅਤੇ ਭਾਵਨਾਤਮਕ ਬੰਧਨ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "Emotional needs and relationship expectations may need adjustment.": "ਭਾਵਨਾਤਮਕ ਲੋੜਾਂ ਅਤੇ ਰਿਸ਼ਤੇ ਦੀਆਂ ਉਮੀਦਾਂ ਨੂੰ ਸਮਾਯੋਜਨ ਦੀ ਲੋੜ ਹੋ ਸਕਦੀ ਹੈ।",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "ਊਰਜਾ, ਜੋਸ਼, ਬੇਸਬਰੀ ਅਤੇ ਕਿਰਿਆ ਵਧਦੀ ਹੈ। ਭਾਵਨਾਤਮਕ ਪ੍ਰਤੀਕ੍ਰਿਆਵਾਂ ਤੇਜ਼ ਹੋ ਸਕਦੀਆਂ ਹਨ।",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "ਭਾਵਨਾਤਮਕ ਬੇਚੈਨੀ, ਗੁੱਸਾ, ਝਗੜਾ ਜਾਂ ਜ਼ਰੂਰੀ ਕਾਰਵਾਈ ਵਧ ਸਕਦੀ ਹੈ।",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "ਇੱਕ ਗੰਭੀਰ ਭਾਵਨਾਤਮਕ ਪੜਾਅ. ਜ਼ਿੰਮੇਵਾਰੀ, ਪਰਿਪੱਕਤਾ, ਪਰਿਵਾਰਕ ਦਬਾਅ ਜਾਂ ਅੰਦਰੂਨੀ ਅਨੁਸ਼ਾਸਨ ਵਧ ਸਕਦਾ ਹੈ।",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "ਭਾਵਨਾਤਮਕ ਭਾਰ ਜਾਂ ਜ਼ਿੰਮੇਵਾਰੀ ਮਹਿਸੂਸ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ। ਧੀਰਜ ਅਤੇ ਪਰਿਪੱਕਤਾ ਦੀ ਲੋੜ ਹੈ.",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "ਸਹਾਇਕ ਭਾਵਨਾਤਮਕ ਵਿਕਾਸ, ਆਸ਼ਾਵਾਦ, ਯਾਤਰਾ, ਸਿੱਖਣ ਅਤੇ ਅਸੀਸਾਂ ਵਿੱਚ ਵਾਧਾ ਹੋ ਸਕਦਾ ਹੈ।",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "ਇੱਕ ਵਿਕਾਸ-ਮੁਖੀ ਭਾਵਨਾਤਮਕ ਪੜਾਅ. ਸਿੱਖਣ, ਵਿਸਥਾਰ, ਸਮਰਥਨ ਅਤੇ ਸਕਾਰਾਤਮਕ ਫੈਸਲਿਆਂ ਲਈ ਵਧੀਆ।",
    "Identity, love, beauty, money values and creative expression become highlighted.": "ਪਛਾਣ, ਪਿਆਰ, ਸੁੰਦਰਤਾ, ਪੈਸੇ ਦੀਆਂ ਕਦਰਾਂ-ਕੀਮਤਾਂ ਅਤੇ ਰਚਨਾਤਮਕ ਪ੍ਰਗਟਾਵਾ ਉਜਾਗਰ ਹੋ ਜਾਂਦੇ ਹਨ।",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "ਆਤਮ-ਵਿਸ਼ਵਾਸ, ਹਿੰਮਤ, ਅਭਿਲਾਸ਼ਾ ਅਤੇ ਕਾਰਜ ਵਿਚ ਵਾਧਾ ਹੁੰਦਾ ਹੈ। ਇੱਕ ਨਵਾਂ ਸਰਗਰਮ ਪੜਾਅ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਵਧੀਆ।",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "ਇੱਕ ਪਰਿਪੱਕਤਾ ਟੈਸਟ. ਜ਼ਿੰਮੇਵਾਰੀ, ਦੇਰੀ, ਦਬਾਅ ਜਾਂ ਕਰੀਅਰ ਦਾ ਪੁਨਰਗਠਨ ਹੋ ਸਕਦਾ ਹੈ।",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "ਵਿਕਾਸ, ਆਤਮ-ਵਿਸ਼ਵਾਸ, ਸਿਆਣਪ, ਮਾਨਤਾ ਅਤੇ ਮੌਕੇ ਵਧ ਸਕਦੇ ਹਨ।",
    "Mental clarity, communication, study, writing and business decisions become important.": "ਮਾਨਸਿਕ ਸਪਸ਼ਟਤਾ, ਸੰਚਾਰ, ਅਧਿਐਨ, ਲਿਖਤ ਅਤੇ ਕਾਰੋਬਾਰੀ ਫੈਸਲੇ ਮਹੱਤਵਪੂਰਨ ਬਣ ਜਾਂਦੇ ਹਨ।",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "ਇੱਕ ਨਵਾਂ ਮਾਨਸਿਕ ਚੱਕਰ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ। ਸਿੱਖਣ, ਸੰਚਾਰ, ਲਿਖਣ ਅਤੇ ਹੁਨਰ ਵਿਕਾਸ ਲਈ ਵਧੀਆ।",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "ਪਿਆਰ, ਸੁੰਦਰਤਾ, ਆਰਾਮ, ਸਮਾਜਿਕ ਜੀਵਨ ਅਤੇ ਕਦਰਾਂ-ਕੀਮਤਾਂ ਪਛਾਣ ਨਾਲ ਮਜ਼ਬੂਤੀ ਨਾਲ ਜੁੜੀਆਂ ਹੋਈਆਂ ਹਨ।",
    "Action, confidence, ambition and personal drive become stronger.": "ਐਕਸ਼ਨ, ਆਤਮ-ਵਿਸ਼ਵਾਸ, ਅਭਿਲਾਸ਼ਾ ਅਤੇ ਨਿੱਜੀ ਡਰਾਈਵ ਮਜ਼ਬੂਤ ​​ਹੋ ਜਾਂਦੀ ਹੈ।",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "ਪ੍ਰਗਤੀਸ਼ੀਲ ਮਰਕਰੀ ਸਿੱਖਣ, ਸੰਚਾਰ, ਕਾਰੋਬਾਰ, ਲਿਖਣ, ਮਾਰਕੀਟਿੰਗ, ਕੋਡਿੰਗ ਜਾਂ ਵਿਸ਼ਲੇਸ਼ਣਾਤਮਕ ਕੰਮ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "ਪ੍ਰਗਤੀਸ਼ੀਲ ਮੰਗਲ ਕਾਰਵਾਈ, ਹਿੰਮਤ, ਮੁਕਾਬਲੇ, ਤਕਨੀਕੀ ਕੰਮ ਅਤੇ ਸਰਗਰਮ ਕਰੀਅਰ ਦੇ ਫੈਸਲਿਆਂ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "ਤਰੱਕੀਸ਼ੁਦਾ ਵੀਨਸ ਵਿੱਤੀ ਮੁੱਲਾਂ, ਆਰਾਮ, ਲਾਭ, ਲਗਜ਼ਰੀ, ਕਲਾ ਜਾਂ ਸਬੰਧ-ਅਧਾਰਤ ਆਮਦਨੀ ਥੀਮਾਂ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "ਪ੍ਰਗਤੀਸ਼ੀਲ ਜੁਪੀਟਰ ਵਿਕਾਸ-ਮੁਖੀ ਵਿੱਤੀ ਸੋਚ ਅਤੇ ਸਰੋਤਾਂ ਦੇ ਵਿਸਥਾਰ ਨੂੰ ਦਿਖਾ ਸਕਦਾ ਹੈ।",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "ਕਰੀਅਰ ਦੇ ਪੜਾਅ ਨੂੰ ਸੂਰਜ, ਚੰਦਰਮਾ, ਬੁਧ, ਮੰਗਲ ਅਤੇ ਜਨਮ ਦੇ ਸੂਰਜ, ਸ਼ਨੀ ਅਤੇ ਮਿਧੇਵਨ ਦੇ ਪਹਿਲੂਆਂ ਤੋਂ ਨਿਰਣਾ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "ਪਿਆਰ ਦੇ ਪੜਾਅ ਨੂੰ ਪ੍ਰਗਤੀਸ਼ੀਲ ਚੰਦਰਮਾ, ਸ਼ੁੱਕਰ, ਮੰਗਲ ਅਤੇ ਜਨਮ ਦੇ ਚੰਦਰਮਾ, ਸ਼ੁੱਕਰ, ਮੰਗਲ ਅਤੇ 7ਵੇਂ ਘਰ ਦੇ ਪਹਿਲੂਆਂ ਤੋਂ ਨਿਰਣਾ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "ਪੈਸੇ ਦੇ ਪੜਾਅ ਨੂੰ ਪ੍ਰਗਤੀਸ਼ੀਲ ਚੰਦਰਮਾ, ਸ਼ੁੱਕਰ, ਜੁਪੀਟਰ ਅਤੇ ਜਨਮ ਦੇ ਦੂਜੇ, 8ਵੇਂ ਅਤੇ 11ਵੇਂ ਘਰ ਦੇ ਸਬੰਧਾਂ ਤੋਂ ਨਿਰਣਾ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "Western Astrology - Kundlistar": "ਪੱਛਮੀ ਜੋਤਿਸ਼ - Kundlistar",
    "No chart data available for preview": "ਪੂਰਵਦਰਸ਼ਨ ਲਈ ਕੋਈ ਚਾਰਟ ਡੇਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    "Failed to load chart": "ਚਾਰਟ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Chart not found": "ਚਾਰਟ ਨਹੀਂ ਮਿਲਿਆ",
    "Western Astrology Module | Kundlistar": "ਪੱਛਮੀ ਜੋਤਿਸ਼ ਮੌਡਿਊਲ | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "Kundlistar ਦੇ ਅੰਦਰ ਨੈਟਲ ਚਾਰਟ ਸਥਿਤੀਆਂ, ਪਲੇਸੀਡਸ ਹਾਉਸ ਕਪਸ, ਬਾਹਰੀ ਗ੍ਰਹਿ ਅਤੇ ਪ੍ਰੀਮੀਅਮ ਟ੍ਰਾਂਜਿਟ, ਸੂਰਜੀ ਵਾਪਸੀ ਅਤੇ ਸਿਨੇਸਟ੍ਰੀ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਦੇ ਨਾਲ ਪੱਛਮੀ ਜੋਤਿਸ਼ ਦੀ ਪੜਚੋਲ ਕਰੋ।",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "ਪੱਛਮੀ ਜੋਤਿਸ਼, ਨੇਟਲ ਚਾਰਟ, ਟ੍ਰਾਂਜਿਟ, ਸੂਰਜੀ ਵਾਪਸੀ, ਸਿਨੇਸਟ੍ਰੀ, Kundlistar",
    "New section": "ਨਵਾਂ ਭਾਗ",
    "Premium active": "ਪ੍ਰੀਮੀਅਮ ਕਿਰਿਆਸ਼ੀਲ",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "ਹਾਊਸ ਸਿਸਟਮ",
    "Placidus cusps": "ਪਲੇਸੀਡਸ ਕਪਸ",
    "Part of Fortune": "ਕਿਸਮਤ ਦਾ ਹਿੱਸਾ",
    "Natal Western Aspects": "ਨੇਟਲ ਪੱਛਮੀ ਪਹਿਲੂ",
    "No major Western aspects found within the configured orbs.": "ਕੌਂਫਿਗਰ ਕੀਤੇ ਔਰਬਸ ਦੇ ਅੰਦਰ ਕੋਈ ਪ੍ਰਮੁੱਖ ਪੱਛਮੀ ਪਹਿਲੂ ਨਹੀਂ ਮਿਲੇ ਹਨ।",
    "Western natal astrology wheel": "ਪੱਛਮੀ ਜਨਮ ਜੋਤਿਸ਼ ਚੱਕਰ",
    "Western Transits": "ਪੱਛਮੀ ਆਵਾਜਾਈ",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "ਲੋਡ ਕੀਤੇ ਚਾਰਟ ਦੇ ਜਨਮ ਸਥਾਨ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹੋਏ ਮੌਜੂਦਾ ਟ੍ਰਾਂਜਿਟ-ਟੂ-ਨੇਟਲ ਗਣਨਾਵਾਂ।",
    "Natal points available": "ਨੈਟਲ ਪੁਆਇੰਟ ਉਪਲਬਧ ਹਨ",
    "Transit planets loaded": "ਆਵਾਜਾਈ ਗ੍ਰਹਿ ਲੋਡ ਹੋਏ",
    "Loading current transit positions...": "ਮੌਜੂਦਾ ਆਵਾਜਾਈ ਸਥਿਤੀਆਂ ਨੂੰ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Aspect method": "ਪੱਖ ਵਿਧੀ",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "ਪੱਛਮੀ orbs ਦੇ ਨਾਲ ਸੰਯੋਜਨ, ਸੈਕਸਟਾਈਲ, ਵਰਗ, ਤ੍ਰਿਏਕ ਅਤੇ ਵਿਰੋਧ",
    "Primary focus": "ਪ੍ਰਾਇਮਰੀ ਫੋਕਸ",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "ਜਨਮ ਦੇ ਸੂਰਜ, ਚੰਦਰਮਾ, ਚੜ੍ਹਾਈ, ਸ਼ੁੱਕਰ, ਮੰਗਲ, ਜੁਪੀਟਰ, ਸ਼ਨੀ ਅਤੇ ਬਾਹਰੀ ਗ੍ਰਹਿਆਂ ਨਾਲ ਸੰਪਰਕ",
    "Natal inner wheel": "ਨੇਟਲ ਅੰਦਰੂਨੀ ਚੱਕਰ",
    "Transit outer wheel": "ਆਵਾਜਾਈ ਬਾਹਰੀ ਪਹੀਏ",
    "Current Transit Positions": "ਮੌਜੂਦਾ ਟ੍ਰਾਂਜ਼ਿਟ ਸਥਿਤੀਆਂ",
    "Transit positions are not available.": "ਟ੍ਰਾਂਜ਼ਿਟ ਸਥਿਤੀਆਂ ਉਪਲਬਧ ਨਹੀਂ ਹਨ।",
    "Current Transit Aspects to Natal Chart": "ਨੈਟਲ ਚਾਰਟ ਦੇ ਮੌਜੂਦਾ ਟ੍ਰਾਂਜ਼ਿਟ ਪਹਿਲੂ",
    "Loading transit aspects...": "ਆਵਾਜਾਈ ਦੇ ਪਹਿਲੂ ਲੋਡ ਕੀਤੇ ਜਾ ਰਹੇ ਹਨ...",
    "No major transit aspects found within the configured orbs.": "ਕੌਂਫਿਗਰ ਕੀਤੇ ਔਰਬਸ ਦੇ ਅੰਦਰ ਕੋਈ ਪ੍ਰਮੁੱਖ ਆਵਾਜਾਈ ਪਹਿਲੂ ਨਹੀਂ ਮਿਲੇ ਹਨ।",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "ਨੇਟਲ ਸੂਰਜ ਤੋਂ ਸਲਾਨਾ ਪੱਛਮੀ ਰਿਟਰਨ ਸੰਦਰਭ, ਸਮਰਥਕ ਨੇਟਲ ਪਹਿਲੂ ਸੰਦਰਭ ਦੇ ਨਾਲ।",
    "Solar return date": "ਸੂਰਜੀ ਵਾਪਸੀ ਦੀ ਮਿਤੀ",
    "Calculation time": "ਗਣਨਾ ਦਾ ਸਮਾਂ",
    "Birth date not available": "ਜਨਮ ਮਿਤੀ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
    "Natal Sun": "ਨੇਟਲ ਸੂਰਜ",
    "Natal Sun house": "ਨੇਟਲ ਸੂਰਜ ਘਰ",
    "Return planets loaded": "ਲੋਡ ਕੀਤੇ ਗ੍ਰਹਿ ਵਾਪਸ ਕਰੋ",
    "Loading solar return chart...": "ਸੂਰਜੀ ਵਾਪਸੀ ਚਾਰਟ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Annual focus": "ਸਲਾਨਾ ਫੋਕਸ",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "ਸੂਰਜੀ ਥੀਮ ਜਨਮ ਸੂਰਜ, ਵਾਪਸੀ ਚੜ੍ਹਾਈ ਅਤੇ ਸਾਲਾਨਾ ਵਾਪਸੀ ਚਾਰਟ ਤੋਂ ਪੜ੍ਹੇ ਜਾਂਦੇ ਹਨ।",
    "Solar Return Planet Positions": "ਸੂਰਜੀ ਵਾਪਸੀ ਗ੍ਰਹਿ ਸਥਿਤੀਆਂ",
    "Loading solar return planets...": "ਸੂਰਜੀ ਵਾਪਸੀ ਗ੍ਰਹਿਆਂ ਨੂੰ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Solar return positions are not available.": "ਸੂਰਜੀ ਵਾਪਸੀ ਦੀਆਂ ਸਥਿਤੀਆਂ ਉਪਲਬਧ ਨਹੀਂ ਹਨ।",
    "Solar Return House Cusps": "ਸੋਲਰ ਰਿਟਰਨ ਹਾਊਸ ਕਪਸ",
    "Loading solar return cusps...": "ਸੋਲਰ ਰਿਟਰਨ ਕਪਸ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Solar return house cusps are not available.": "ਸੋਲਰ ਰਿਟਰਨ ਹਾਊਸ ਕਪਸ ਉਪਲਬਧ ਨਹੀਂ ਹਨ।",
    "Solar Return Aspects to Natal Chart": "ਨੇਟਲ ਚਾਰਟ ਲਈ ਸੂਰਜੀ ਵਾਪਸੀ ਦੇ ਪਹਿਲੂ",
    "Loading solar return aspects...": "ਸੂਰਜੀ ਵਾਪਸੀ ਦੇ ਪਹਿਲੂ ਲੋਡ ਕੀਤੇ ਜਾ ਰਹੇ ਹਨ...",
    "No major solar return aspects found within the configured orbs.": "ਕੌਂਫਿਗਰ ਕੀਤੇ ਔਰਬਸ ਦੇ ਅੰਦਰ ਕੋਈ ਮੁੱਖ ਸੂਰਜੀ ਵਾਪਸੀ ਪਹਿਲੂ ਨਹੀਂ ਮਿਲੇ ਹਨ।",
    "Natal Sun Aspects for Solar Return Focus": "ਸੂਰਜੀ ਵਾਪਸੀ ਫੋਕਸ ਲਈ ਨੇਟਲ ਸੂਰਜ ਦੇ ਪਹਿਲੂ",
    "No major natal Sun aspects found within the configured orbs.": "ਕੌਂਫਿਗਰ ਕੀਤੇ ਔਰਬਸ ਦੇ ਅੰਦਰ ਕੋਈ ਮੁੱਖ ਨੇਟਲ ਸੂਰਜ ਪਹਿਲੂ ਨਹੀਂ ਮਿਲੇ ਹਨ।",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "ਗ੍ਰਹਿ-ਤੋਂ-ਗ੍ਰਹਿ ਪਹਿਲੂਆਂ, ਕੋਣ ਸੰਪਰਕਾਂ ਅਤੇ ਘਰ ਦੇ ਓਵਰਲੇਅ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹੋਏ ਰਿਸ਼ਤਾ ਓਵਰਲੇ ਫਰੇਮਵਰਕ।",
    "Loaded first chart": "ਪਹਿਲਾ ਚਾਰਟ ਲੋਡ ਕੀਤਾ ਗਿਆ",
    "Second chart": "ਦੂਜਾ ਚਾਰਟ",
    "Select or load partner chart to calculate full synastry overlay": "ਪੂਰੇ ਸਿਨੇਸਟ੍ਰੀ ਓਵਰਲੇ ਦੀ ਗਣਨਾ ਕਰਨ ਲਈ ਪਾਰਟਨਰ ਚਾਰਟ ਨੂੰ ਚੁਣੋ ਜਾਂ ਲੋਡ ਕਰੋ",
    "Major inter-chart aspects with tight orb priority": "ਤੰਗ ਔਰਬ ਤਰਜੀਹ ਦੇ ਨਾਲ ਮੁੱਖ ਅੰਤਰ-ਚਾਰਟ ਪਹਿਲੂ",
    "House overlay method": "ਹਾਊਸ ਓਵਰਲੇਅ ਵਿਧੀ",
    "Partner planets are placed into the first chart houses after second chart is selected": "ਦੂਜੇ ਚਾਰਟ ਦੀ ਚੋਣ ਕਰਨ ਤੋਂ ਬਾਅਦ ਸਾਥੀ ਗ੍ਰਹਿਆਂ ਨੂੰ ਪਹਿਲੇ ਚਾਰਟ ਘਰਾਂ ਵਿੱਚ ਰੱਖਿਆ ਜਾਂਦਾ ਹੈ",
    "Relationship Pattern Aspects from Loaded Chart": "ਲੋਡ ਕੀਤੇ ਚਾਰਟ ਤੋਂ ਰਿਸ਼ਤਾ ਪੈਟਰਨ ਪਹਿਲੂ",
    "No major relationship-focused natal aspects found within the configured orbs.": "ਕੌਂਫਿਗਰ ਕੀਤੇ ਔਰਬਸ ਦੇ ਅੰਦਰ ਕੋਈ ਪ੍ਰਮੁੱਖ ਸਬੰਧ-ਕੇਂਦ੍ਰਿਤ ਨੇਟਲ ਪਹਿਲੂ ਨਹੀਂ ਮਿਲੇ ਹਨ।",
    "Understand your current inner life phase through Western Secondary Progressions.": "ਪੱਛਮੀ ਸੈਕੰਡਰੀ ਤਰੱਕੀ ਦੁਆਰਾ ਆਪਣੇ ਮੌਜੂਦਾ ਅੰਦਰੂਨੀ ਜੀਵਨ ਪੜਾਅ ਨੂੰ ਸਮਝੋ।",
    "Secondary Progression": "ਸੈਕੰਡਰੀ ਤਰੱਕੀ",
    "1 day after birth = 1 year of life": "ਜਨਮ ਤੋਂ ਬਾਅਦ 1 ਦਿਨ = ਜੀਵਨ ਦਾ 1 ਸਾਲ",
    "Current age used": "ਵਰਤਮਾਨ ਉਮਰ ਵਰਤੀ ਜਾਂਦੀ ਹੈ",
    "Progressed date": "ਤਰੱਕੀ ਦੀ ਮਿਤੀ",
    "Progressed Moon": "ਤਰੱਕੀ ਕੀਤੀ ਚੰਦਰਮਾ",
    "Loading progressed Moon...": "ਪ੍ਰਗਤੀਸ਼ੀਲ ਚੰਦਰਮਾ ਨੂੰ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Progressed Moon phase": "ਅੱਗੇ ਵਧਿਆ ਚੰਦਰਮਾ ਪੜਾਅ",
    "Loading Moon phase...": "ਚੰਦਰਮਾ ਦਾ ਪੜਾਅ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Current Life Phase": "ਵਰਤਮਾਨ ਜੀਵਨ ਪੜਾਅ",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "ਸੈਕੰਡਰੀ ਤਰੱਕੀ ਜੀਵਨ ਦੇ ਅੰਦਰੂਨੀ ਪੜਾਅ, ਭਾਵਨਾਤਮਕ ਪਰਿਪੱਕਤਾ, ਪਛਾਣ ਦੇ ਵਿਕਾਸ ਅਤੇ ਬਦਲਦੀਆਂ ਤਰਜੀਹਾਂ ਨੂੰ ਦਰਸਾਉਂਦੀ ਹੈ।",
    "Progressed Career Phase": "ਤਰੱਕੀ ਕੀਤੀ ਕਰੀਅਰ ਪੜਾਅ",
    "Progressed Love Phase": "ਅੱਗੇ ਵਧਿਆ ਪਿਆਰ ਪੜਾਅ",
    "Progressed Money Phase": "ਅੱਗੇ ਵਧਿਆ ਪੈਸਾ ਪੜਾਅ",
    "Loading progressed planets...": "ਪ੍ਰਗਤੀਸ਼ੀਲ ਗ੍ਰਹਿਆਂ ਨੂੰ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Progressed planets are not available.": "ਅਗਿਆਤ ਗ੍ਰਹਿ ਉਪਲਬਧ ਨਹੀਂ ਹਨ।",
    "Loading progressed aspects...": "ਪ੍ਰਗਤੀਸ਼ੀਲ ਪਹਿਲੂਆਂ ਨੂੰ ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "No tight progressed-to-natal aspects found right now.": "ਇਸ ਸਮੇਂ ਕੋਈ ਤੰਗ ਪ੍ਰਗਤੀ-ਤੋਂ-ਜਨਮ ਪਹਿਲੂ ਨਹੀਂ ਮਿਲੇ ਹਨ।",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "ਇਸ ਪੜਾਅ ਨੂੰ ਪ੍ਰਗਤੀਸ਼ੀਲ ਗ੍ਰਹਿਆਂ, ਪ੍ਰਗਤੀਸ਼ੀਲ ਚੰਦਰਮਾ ਪੜਾਅ ਅਤੇ ਤੰਗ ਪ੍ਰਗਤੀ ਤੋਂ ਜਨਮ ਦੇ ਪਹਿਲੂਆਂ ਤੋਂ ਨਿਰਣਾ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "Vastu Analysis - Kundlistar": "ਵਾਸਤੂ ਵਿਸ਼ਲੇਸ਼ਣ - Kundlistar",
    "Failed to load selected chart.": "ਚੁਣੇ ਹੋਏ ਚਾਰਟ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
    "Facing Direction": "ਦਿਸ਼ਾ ਦਾ ਸਾਹਮਣਾ ਕਰਨਾ",
    "Entrance Direction": "ਪ੍ਰਵੇਸ਼ ਦੀ ਦਿਸ਼ਾ",
    "Kitchen Direction": "ਰਸੋਈ ਦੀ ਦਿਸ਼ਾ",
    "Master Bedroom": "ਮਾਸਟਰ ਬੈੱਡਰੂਮ",
    "Children Bedroom": "ਬੱਚਿਆਂ ਦਾ ਬੈਡਰੂਮ",
    "Toilet Direction": "ਟਾਇਲਟ ਦਿਸ਼ਾ",
    "Pooja Direction": "ਪੂਜਾ ਦਿਸ਼ਾ",
    "Water Tank": "ਪਾਣੀ ਦੀ ਟੈਂਕੀ",
    "Underground Water": "ਭੂਮੀਗਤ ਪਾਣੀ",
    "Heavy Storage": "ਭਾਰੀ ਸਟੋਰੇਜ",
    "Living Room": "ਰਿਹਣ ਵਾਲਾ ਕਮਰਾ",
    "Study Room": "ਸਟੱਡੀ ਰੂਮ",
    "Vastu report generation failed.": "ਵਾਸਤੂ ਰਿਪੋਰਟ ਬਣਾਉਣਾ ਅਸਫਲ ਰਿਹਾ।",
    "Please generate the Vastu report before downloading.": "ਕਿਰਪਾ ਕਰਕੇ ਡਾਊਨਲੋਡ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਵਾਸਤੂ ਰਿਪੋਰਟ ਤਿਆਰ ਕਰੋ।",
    "Failed to download Vastu report.": "ਵਾਸਤੂ ਰਿਪੋਰਟ ਨੂੰ ਡਾਊਨਲੋਡ ਕਰਨਾ ਅਸਫਲ ਰਿਹਾ।",
    "Premium Feature": "ਪ੍ਰੀਮੀਅਮ ਵਿਸ਼ੇਸ਼ਤਾ",
    "Selected Chart": "ਚੁਣਿਆ ਗਿਆ ਚਾਰਟ",
    "Basic + KP + BNN from chart": "ਚਾਰਟ ਤੋਂ ਮੂਲ + KP + BNN",
    "Basic shown, KP + BNN locked": "ਮੂਲ ਦਿਖਾਇਆ ਗਿਆ, KP + BNN ਲਾਕ ਕੀਤਾ ਗਿਆ",
    "Property Type": "ਸੰਪਤੀ ਦੀ ਕਿਸਮ",
    "Center Area": "ਕੇਂਦਰ ਖੇਤਰ",
    "Generate Vastu Report": "ਵਾਸਤੂ ਰਿਪੋਰਟ ਤਿਆਰ ਕਰੋ",
    "Basic Vastu Analysis": "ਬੁਨਿਆਦੀ ਵਾਸਤੂ ਵਿਸ਼ਲੇਸ਼ਣ",
    "KP Vastu Analysis": "ਕੇਪੀ ਵਾਸਤੂ ਵਿਸ਼ਲੇਸ਼ਣ",
    "BNN Vastu Analysis": "BNN ਵਸਤੂ ਵਿਸ਼ਲੇਸ਼ਣ",
    "North East": "ਉੱਤਰ ਪੂਰਬ",
    "South East": "ਦੱਖਣ ਪੂਰਬ",
    "South West": "ਦੱਖਣ ਪੱਛਮ",
    "North West": "ਉੱਤਰ ਪੱਛਮ",
    "Red Coral": "ਲਾਲ ਕੋਰਲ",
    "Yellow Sapphire": "ਪੀਲਾ ਨੀਲਮ",
    "Blue Sapphire": "ਨੀਲਾ ਨੀਲਮ",
    "Cat's Eye": "ਬਿੱਲੀ ਦੀ ਅੱਖ",
    "Additional Option": "ਵਧੀਕ ਵਿਕਲਪ",
    "Lagna rule supports this gemstone option.": "ਲਗਨਾ ਨਿਯਮ ਇਸ ਰਤਨ ਦੇ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Moon sign rule supports this gemstone option.": "ਚੰਦਰਮਾ ਚਿੰਨ੍ਹ ਨਿਯਮ ਇਸ ਰਤਨ ਦੇ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Birth date rule supports this gemstone option.": "ਜਨਮ ਮਿਤੀ ਨਿਯਮ ਇਸ ਰਤਨ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Birth weekday rule supports this gemstone option.": "ਜਨਮ ਦਿਨ ਦਾ ਨਿਯਮ ਇਸ ਰਤਨ ਦੇ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Current dasha rule supports this gemstone option.": "ਮੌਜੂਦਾ ਦਸ਼ਾ ਨਿਯਮ ਇਸ ਰਤਨ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Age-band rule supports this gemstone option.": "ਉਮਰ-ਬੈਂਡ ਨਿਯਮ ਇਸ ਰਤਨ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Selected goal supports this gemstone option.": "ਚੁਣਿਆ ਗਿਆ ਟੀਚਾ ਇਸ ਰਤਨ ਚੋਣ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Profession rule supports this gemstone option.": "ਪੇਸ਼ੇ ਦਾ ਨਿਯਮ ਇਸ ਰਤਨ ਦੇ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ.",
    "Name-initial rule supports this gemstone option.": "ਨਾਮ-ਸ਼ੁਰੂਆਤੀ ਨਿਯਮ ਇਸ ਰਤਨ ਚੋਣ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Moolank rule supports this gemstone option.": "ਮੂਲੰਕ ਨਿਯਮ ਇਸ ਰਤਨ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Chart condition check was considered for this option.": "ਇਸ ਵਿਕਲਪ ਲਈ ਚਾਰਟ ਸਥਿਤੀ ਜਾਂਚ 'ਤੇ ਵਿਚਾਰ ਕੀਤਾ ਗਿਆ ਸੀ।",
    "Rule-based chart match supports this gemstone option.": "ਨਿਯਮ-ਅਧਾਰਿਤ ਚਾਰਟ ਮੈਚ ਇਸ ਰਤਨ ਵਿਕਲਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ।",
    "Expert kundli review is recommended before wearing this gemstone.": "ਇਸ ਰਤਨ ਨੂੰ ਪਹਿਨਣ ਤੋਂ ਪਹਿਲਾਂ ਮਾਹਰ ਕੁੰਡਲੀ ਦੀ ਸਮੀਖਿਆ ਕਰਨ ਦੀ ਸਿਫਾਰਸ਼ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
    "Ring finger": "ਰਿੰਗ ਫਿੰਗਰ",
    "Little finger": "ਛੋਟੀ ਉਂਗਲ",
    "Index finger": "ਇੰਡੈਕਸ ਫਿੰਗਰ",
    "Middle finger": "ਵਿਚਕਾਰਲੀ ਉਂਗਲੀ",
    "Why recommended": "ਕਿਉਂ ਸਿਫਾਰਸ਼ ਕੀਤੀ",
    "Approx weight": "ਲਗਭਗ ਭਾਰ",
    "Could not load chart.": "ਚਾਰਟ ਲੋਡ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।",
    "Gemstone Recommendations | Kundlistar": "ਰਤਨ ਸਿਫ਼ਾਰਿਸ਼ਾਂ | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar ਦੇ ਨਿਯਮ-ਅਧਾਰਿਤ ਕੁੰਡਲੀ ਵਿਸ਼ਲੇਸ਼ਣ ਇੰਜਣ ਤੋਂ ਵੈਦਿਕ ਰਤਨ ਸਿਫ਼ਾਰਸ਼ਾਂ ਦੀ ਪੜਚੋਲ ਕਰੋ।",
    "noindex,nofollow": "noindex, nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "ਰਤਨ ਦੀ ਸਿਫ਼ਾਰਿਸ਼, ਵੈਦਿਕ ਰਤਨ, ਕੁੰਡਲੀ ਰਤਨ, Kundlistar",
    "Gemstone Recommendations": "ਰਤਨ ਸਿਫ਼ਾਰਿਸ਼ਾਂ",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "ਲਗਨਾ, ਚੰਦਰ ਰਾਸ਼ੀ, ਦਸ਼ਾ, DOB, ਪੇਸ਼ੇ ਅਤੇ ਟੀਚਿਆਂ 'ਤੇ ਆਧਾਰਿਤ ਵੈਦਿਕ ਰਤਨ ਮਾਰਗ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਵੱਖਰਾ Kundlistar ਮੋਡੀਊਲ।",
    "Personalized Gemstone Recommendations are available for Premium users.": "ਪ੍ਰੀਮੀਅਮ ਉਪਭੋਗਤਾਵਾਂ ਲਈ ਵਿਅਕਤੀਗਤ ਰਤਨ ਸਿਫ਼ਾਰਸ਼ਾਂ ਉਪਲਬਧ ਹਨ।",
    "Upgrade to Premium": "ਪ੍ਰੀਮੀਅਮ 'ਤੇ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
    "Login to Upgrade": "ਅੱਪਗ੍ਰੇਡ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ",
    "Select Goal": "ਟੀਚਾ ਚੁਣੋ",
    "Business, government job, teacher...": "ਵਪਾਰ, ਸਰਕਾਰੀ ਨੌਕਰੀ, ਅਧਿਆਪਕ...",
    "Weight kg": "ਭਾਰ ਕਿਲੋ",
    "वजन kg": "ਭਾਰ ਕਿਲੋ",
    "Optional ratti estimate": "ਵਿਕਲਪਿਕ ਰੱਤੀ ਅਨੁਮਾਨ",
    "Click Calculate to apply these values.": "ਇਹਨਾਂ ਮੁੱਲਾਂ ਨੂੰ ਲਾਗੂ ਕਰਨ ਲਈ ਗਣਨਾ ਕਰੋ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi?",
    "Nadi Analysis": "ਨਦੀ ਵਿਸ਼ਲੇਸ਼ਣ",
    "KP Analysis": "ਕੇਪੀ ਵਿਸ਼ਲੇਸ਼ਣ",
    "Vedic Analysis": "ਵੈਦਿਕ ਵਿਸ਼ਲੇਸ਼ਣ",
    "BNN Analysis": "BNN ਵਿਸ਼ਲੇਸ਼ਣ",
    "Jaimini Analysis": "ਜੈਮਿਨੀ ਵਿਸ਼ਲੇਸ਼ਣ",
    "Western Astrology": "ਪੱਛਮੀ ਜੋਤਿਸ਼",
    "Panch Pakshi": "ਪੰਚ ਪੱਖੀ",
    "Tithi Pravesh": "ਤਿਥੀ ਪ੍ਰਵੇਸ਼",
    "Lal Kitab": "ਲਾਲ ਕਿਤਾਬ",
    "Astro Logo": "ਐਸਟ੍ਰੋ ਲੋਗੋ",
    "Download failed": "ਡਾਊਨਲੋਡ ਅਸਫਲ ਰਿਹਾ",
    "Could not download PDF report.": "PDF ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ।",
    "Please login to download PDF reports.": "ਕਿਰਪਾ ਕਰਕੇ PDF ਰਿਪੋਰਟਾਂ ਨੂੰ ਡਾਊਨਲੋਡ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ।",
    "Failed to generate personalised report": "ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    "Could not download personalised report.": "ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਨੂੰ ਡਾਊਨਲੋਡ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "ਕੈਲਕ(100vh - var(--ਕੁੰਡਲਿਸਟਰ-ਨਵਬਾਰ-ਉਚਾਈ, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "ਕੈਲਕ(100vh - var(--ਕੁੰਡਲਿਸਟਰ-ਨਵਬਾਰ-ਉਚਾਈ, 160px))",
    "width 0.2s ease": "ਚੌੜਾਈ 0.2s ਆਸਾਨੀ",
    "Collapse sidebar": "ਸਾਈਡਬਾਰ ਨੂੰ ਸਮੇਟੋ",
    "Expand sidebar": "ਸਾਈਡਬਾਰ ਦਾ ਵਿਸਤਾਰ ਕਰੋ",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-ਰੂਟ",
    "Download PDF Report": "PDF ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "Login to download": "ਡਾਊਨਲੋਡ ਕਰਨ ਲਈ ਲੌਗਇਨ ਕਰੋ",
    "PDF Report": "PDF ਰਿਪੋਰਟ",
    "Download Personal Report": "ਨਿੱਜੀ ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "Buy Premium to download": "ਡਾਊਨਲੋਡ ਕਰਨ ਲਈ ਪ੍ਰੀਮੀਅਮ ਖਰੀਦੋ",
    "Login to buy Premium": "ਪ੍ਰੀਮੀਅਮ ਖਰੀਦਣ ਲਈ ਲੌਗਇਨ ਕਰੋ",
    "Buy Premium": "ਪ੍ਰੀਮੀਅਮ ਖਰੀਦੋ",
    "& .MuiTab-root": "& .MuiTab-ਰੂਟ",
    "& .Mui-selected": "& .Mui-ਚੁਣਿਆ ਗਿਆ",
    "Unable to load Client Management data.": "ਕਲਾਇੰਟ ਪ੍ਰਬੰਧਨ ਡੇਟਾ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Unable to download PDF.": "PDF ਡਾਊਨਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Free client limit reached": "ਮੁਫਤ ਗਾਹਕ ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ ਹੈ",
    "Welcome": "ਸੁਆਗਤ ਹੈ",
    "Hello": "ਸਤ ਸ੍ਰੀ ਅਕਾਲ",
    "Your saved charts are shown below.": "ਤੁਹਾਡੇ ਸੁਰੱਖਿਅਤ ਕੀਤੇ ਚਾਰਟ ਹੇਠਾਂ ਦਿਖਾਏ ਗਏ ਹਨ।",
    "All Features": "ਸਾਰੀਆਂ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
    "New Chart": "ਨਵਾਂ ਚਾਰਟ",
    "Vedic Chart": "ਵੈਦਿਕ ਚਾਰਟ",
    "Chakra": "ਚੱਕਰ",
    "Daily Panchang": "ਰੋਜ਼ਾਨਾ ਪੰਚਾਂਗ",
    "Choghadiya": "ਚੋਘੜੀਆ",
    "Daily Horoscope": "ਰੋਜ਼ਾਨਾ ਕੁੰਡਲੀ",
    "Gochar Alerts": "ਗੋਚਰ ਚੇਤਾਵਨੀਆਂ",
    "Matching": "ਮੇਲ ਖਾਂਦਾ ਹੈ",
    "Ruling Planets": "ਸੱਤਾਧਾਰੀ ਗ੍ਰਹਿ",
    "Horary Chart": "Horary ਚਾਰਟ",
    "Astro-Vastu": "ਖਗੋਲ-ਵਾਸਤੂ",
    "Vedic Numerology": "ਵੈਦਿਕ ਅੰਕ ਵਿਗਿਆਨ",
    "My Charts": "ਮੇਰੇ ਚਾਰਟਸ",
    "Search by Name": "ਨਾਮ ਦੁਆਰਾ ਖੋਜ ਕਰੋ",
    "Type": "ਟਾਈਪ ਕਰੋ",
    "All": "ਸਾਰੇ",
    "Individual": "ਵਿਅਕਤੀਗਤ",
    "Horary": "ਹੌਰਰੀ",
    "Clear": "ਸਾਫ਼",
    "Name": "ਨਾਮ",
    "DOB": "ਡੀ.ਓ.ਬੀ",
    "Place": "ਸਥਾਨ",
    "Gender": "ਲਿੰਗ",
    "Created": "ਬਣਾਇਆ",
    "Actions": "ਕਾਰਵਾਈਆਂ",
    "Male": "ਨਰ",
    "Female": "ਔਰਤ",
    "No matching charts found": "ਕੋਈ ਮੇਲ ਖਾਂਦਾ ਚਾਰਟ ਨਹੀਂ ਮਿਲਿਆ",
    "Create First Chart": "ਪਹਿਲਾ ਚਾਰਟ ਬਣਾਓ",
    "View Chart": "ਚਾਰਟ ਦੇਖੋ",
    "Copy Share Link": "ਸ਼ੇਅਰ ਲਿੰਕ ਕਾਪੀ ਕਰੋ",
    "Use premium credit: Download PDF Report": "ਪ੍ਰੀਮੀਅਮ ਕ੍ਰੈਡਿਟ ਦੀ ਵਰਤੋਂ ਕਰੋ: PDF ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "Download Personalised Report": "ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "Premium: Download Personalised Report": "ਪ੍ਰੀਮੀਅਮ: ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "Hide Chart": "ਚਾਰਟ ਲੁਕਾਓ",
    "Personalised": "ਵਿਅਕਤੀਗਤ",
    "Generating your Personalised Report": "ਤੁਹਾਡੀ ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਤਿਆਰ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ",
    "Please do not leave this page till the report is generated. This can take a little while.": "ਕਿਰਪਾ ਕਰਕੇ ਰਿਪੋਰਟ ਤਿਆਰ ਹੋਣ ਤੱਕ ਇਸ ਪੰਨੇ ਨੂੰ ਨਾ ਛੱਡੋ। ਇਸ ਵਿੱਚ ਥੋੜ੍ਹਾ ਸਮਾਂ ਲੱਗ ਸਕਦਾ ਹੈ।",
    "Please don't leave this page till the report is generated. This can take a little while.": "ਰਿਪੋਰਟ ਤਿਆਰ ਹੋਣ ਤੱਕ ਕਿਰਪਾ ਕਰਕੇ ਇਸ ਪੰਨੇ ਨੂੰ ਨਾ ਛੱਡੋ। ਇਸ ਵਿੱਚ ਥੋੜ੍ਹਾ ਸਮਾਂ ਲੱਗ ਸਕਦਾ ਹੈ।",
    "Update": "ਅੱਪਡੇਟ ਕਰੋ",
    "Complete your billing address. Required for generating invoice.": "ਆਪਣਾ ਬਿਲਿੰਗ ਪਤਾ ਪੂਰਾ ਕਰੋ। ਇਨਵੌਇਸ ਬਣਾਉਣ ਲਈ ਲੋੜੀਂਦਾ ਹੈ।",
    "Report this report": "ਇਸ ਰਿਪੋਰਟ ਦੀ ਰਿਪੋਰਟ ਕਰੋ",
    "Reason": "ਕਾਰਨ",
    "Optional comment": "ਵਿਕਲਪਿਕ ਟਿੱਪਣੀ",
    "Submit": "ਜਮ੍ਹਾਂ ਕਰੋ",
    "Incorrect info": "ਗਲਤ ਜਾਣਕਾਰੀ",
    "Offensive": "ਅਪਮਾਨਜਨਕ",
    "Harmful": "ਹਾਨੀਕਾਰਕ",
    "This report has been sent for review.": "ਇਹ ਰਿਪੋਰਟ ਸਮੀਖਿਆ ਲਈ ਭੇਜ ਦਿੱਤੀ ਗਈ ਹੈ।",
    "Failed to submit report feedback": "ਰਿਪੋਰਟ ਫੀਡਬੈਕ ਸਪੁਰਦ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Failed to download PDF": "PDF ਡਾਊਨਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Failed to download personalised report": "ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਨੂੰ ਡਾਊਨਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Failed to load charts": "ਚਾਰਟ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    "Failed to hide chart": "ਚਾਰਟ ਨੂੰ ਲੁਕਾਉਣ ਵਿੱਚ ਅਸਫਲ",
    "Failed to delete chart": "ਚਾਰਟ ਨੂੰ ਮਿਟਾਉਣਾ ਅਸਫਲ ਰਿਹਾ",
    "Share link copied to clipboard!": "ਸ਼ੇਅਰ ਲਿੰਕ ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕੀਤਾ ਗਿਆ!",
    "Delete Chart": "ਚਾਰਟ ਮਿਟਾਓ",
    "Delete chart": "ਚਾਰਟ ਮਿਟਾਓ",
    "Error": "ਗਲਤੀ",
    "OK": "ਠੀਕ ਹੈ",
    "Thanks": "ਧੰਨਵਾਦ",
    "Report failed": "ਰਿਪੋਰਟ ਅਸਫਲ ਰਹੀ",
    "Could not submit report feedback.": "ਰਿਪੋਰਟ ਫੀਡਬੈਕ ਸਪੁਰਦ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।",
    "Personalised report ready": "ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਤਿਆਰ ਹੈ",
    "Personalised report failed": "ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਅਸਫਲ ਰਹੀ",
    "Could not generate personalised report.": "ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਤਿਆਰ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ।",
    "Could not generate personalised PDF report.": "ਵਿਅਕਤੀਗਤ PDF ਰਿਪੋਰਟ ਤਿਆਰ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ।",
    "Monthly limit reached": "ਮਹੀਨਾਵਾਰ ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ ਹੈ",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "ਤੁਹਾਡੀ ਮਾਸਿਕ ਵਿਅਕਤੀਗਤ ਰਿਪੋਰਟ ਦੀ ਸੀਮਾ ਪੂਰੀ ਹੋ ਗਈ ਹੈ। ਐਡ-ਆਨ ਦੀ ਗਾਹਕੀ ਲਓ: 20 ਰਿਪੋਰਟਾਂ ਲਈ ₹299/ਮਹੀਨਾ ਜਾਂ 40 ਰਿਪੋਰਟਾਂ ਲਈ ₹499/ਮਹੀਨਾ।",
    "Buy Add-on": "ਐਡ-ਆਨ ਖਰੀਦੋ",
    "Manage": "ਪ੍ਰਬੰਧਿਤ ਕਰੋ",
    "Add-on active: Unlimited reports": "ਐਡ-ਆਨ ਕਿਰਿਆਸ਼ੀਲ: ਅਸੀਮਤ ਰਿਪੋਰਟਾਂ",
    "Add-on active: 40 reports/month": "ਐਡ-ਆਨ ਕਿਰਿਆਸ਼ੀਲ: 40 ਰਿਪੋਰਟਾਂ/ਮਹੀਨਾ",
    "Add-on active: 20 reports/month": "ਐਡ-ਆਨ ਕਿਰਿਆਸ਼ੀਲ: 20 ਰਿਪੋਰਟਾਂ/ਮਹੀਨਾ",
    "reports remaining this cycle": "ਰਿਪੋਰਟਾਂ ਇਸ ਚੱਕਰ ਵਿੱਚ ਬਾਕੀ ਰਹਿੰਦੀਆਂ ਹਨ",
    "Add-on active": "ਐਡ-ਆਨ ਕਿਰਿਆਸ਼ੀਲ ਹੈ",
    "Personalised reports remaining this month": "ਵਿਅਕਤੀਗਤ ਬਣਾਈਆਂ ਗਈਆਂ ਰਿਪੋਰਟਾਂ ਇਸ ਮਹੀਨੇ ਬਾਕੀ ਹਨ",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "ਪ੍ਰੀਮੀਅਮ ਵਿੱਚ 2/ਮਹੀਨਾ ਸ਼ਾਮਲ ਹੈ। ਐਡ-ਆਨ: 20 ਰਿਪੋਰਟਾਂ/ਮਹੀਨੇ ਲਈ ₹299/ਮਹੀਨਾ ਜਾਂ 40 ਰਿਪੋਰਟਾਂ/ਮਹੀਨੇ ਲਈ ₹499/ਮਹੀਨਾ।",
    "AI Disclaimer": "AI ਬੇਦਾਅਵਾ",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "ਇਹ ਰਿਪੋਰਟ AI ਅਤੇ ਜੋਤਸ਼ੀ ਵਿਆਖਿਆਵਾਂ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਤਿਆਰ ਕੀਤੀ ਗਈ ਹੈ। ਇਹ ਸਿਰਫ ਜਾਣਕਾਰੀ ਅਤੇ ਮਨੋਰੰਜਨ ਦੇ ਉਦੇਸ਼ਾਂ ਲਈ ਹੈ। ਇਸ ਨੂੰ ਡਾਕਟਰੀ, ਕਾਨੂੰਨੀ, ਜਾਂ ਵਿੱਤੀ ਸਲਾਹ ਨਹੀਂ ਮੰਨਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
    "A copy of this report has also been sent to your registered email address as a PDF.": "ਇਸ ਰਿਪੋਰਟ ਦੀ ਇੱਕ ਕਾਪੀ PDF ਦੇ ਰੂਪ ਵਿੱਚ ਤੁਹਾਡੇ ਰਜਿਸਟਰਡ ਈਮੇਲ ਪਤੇ 'ਤੇ ਵੀ ਭੇਜੀ ਗਈ ਹੈ।",
    "Report this AI-generated report?": "ਇਸ AI ਦੁਆਰਾ ਤਿਆਰ ਕੀਤੀ ਗਈ ਰਿਪੋਰਟ ਦੀ ਰਿਪੋਰਟ ਕਰੋ?",
    "charts": "ਚਾਰਟ",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "ਸੁਤੰਤਰ ਨੋਟਸ, ਮਿਤੀ ਅਤੇ ਸਮੇਂ ਦੀ ਯੋਜਨਾਬੰਦੀ। ਸੰਭਾਲਣ ਲਈ ਲੌਗਇਨ ਦੀ ਲੋੜ ਹੈ; ਮੁਫਤ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਪੂਰੀ ਯੋਜਨਾਕਾਰ ਪਹੁੰਚ ਮਿਲਦੀ ਹੈ।",
    "Independent notes, date and time planning.": "ਸੁਤੰਤਰ ਨੋਟਸ, ਮਿਤੀ ਅਤੇ ਸਮੇਂ ਦੀ ਯੋਜਨਾਬੰਦੀ।",
    "Add Plan": "ਯੋਜਨਾ ਸ਼ਾਮਲ ਕਰੋ",
    "Save Plan": "ਯੋਜਨਾ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    "Saved Plans": "ਰੱਖਿਅਤ ਯੋਜਨਾਵਾਂ",
    "Planner Entry": "ਪਲੈਨਰ ​​ਐਂਟਰੀ",
    "Plan": "ਯੋਜਨਾ",
    "Saving...": "ਰੱਖਿਅਤ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "Refresh": "ਤਾਜ਼ਾ ਕਰੋ",
    "No plans saved yet.": "ਅਜੇ ਤੱਕ ਕੋਈ ਯੋਜਨਾਵਾਂ ਸੁਰੱਖਿਅਤ ਨਹੀਂ ਕੀਤੀਆਂ ਗਈਆਂ ਹਨ।",
    "Planner layout is available. Login only when you want to save.": "ਯੋਜਨਾਕਾਰ ਖਾਕਾ ਉਪਲਬਧ ਹੈ। ਉਦੋਂ ਹੀ ਲੌਗਇਨ ਕਰੋ ਜਦੋਂ ਤੁਸੀਂ ਸੇਵ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ।",
    "No matching plans.": "ਕੋਈ ਮੇਲ ਖਾਂਦੀਆਂ ਯੋਜਨਾਵਾਂ ਨਹੀਂ ਹਨ।",
    "Search Plans": "ਖੋਜ ਯੋਜਨਾਵਾਂ",
    "Search title, note, date or status": "ਸਿਰਲੇਖ, ਨੋਟ, ਮਿਤੀ ਜਾਂ ਸਥਿਤੀ ਦੀ ਖੋਜ ਕਰੋ",
    "Login is required only when you want to save planner entries.": "ਲੌਗਇਨ ਸਿਰਫ਼ ਉਦੋਂ ਹੀ ਲੋੜੀਂਦਾ ਹੈ ਜਦੋਂ ਤੁਸੀਂ ਯੋਜਨਾਕਾਰ ਐਂਟਰੀਆਂ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ।",
    "Planner entry saved.": "ਪਲੈਨਰ ​​ਐਂਟਰੀ ਸੁਰੱਖਿਅਤ ਕੀਤੀ ਗਈ।",
    "Unable to load planner.": "ਯੋਜਨਾਕਾਰ ਨੂੰ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Unable to save planner entry.": "ਯੋਜਨਾਕਾਰ ਐਂਟਰੀ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Could not load planner.": "ਪਲੈਨਰ ​​ਲੋਡ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।",
    "Could not save planner entry.": "ਯੋਜਨਾਕਾਰ ਐਂਟਰੀ ਨੂੰ ਸੁਰੱਖਿਅਤ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।",
    "Login required to save": "ਸੁਰੱਖਿਅਤ ਕਰਨ ਲਈ ਲੌਗਇਨ ਲੋੜੀਂਦਾ ਹੈ",
    "You can explore Planner now. Login when you want to save entries.": "ਤੁਸੀਂ ਹੁਣ ਪਲੈਨਰ ​​ਦੀ ਪੜਚੋਲ ਕਰ ਸਕਦੇ ਹੋ। ਜਦੋਂ ਤੁਸੀਂ ਐਂਟਰੀਆਂ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ ਤਾਂ ਲੌਗਇਨ ਕਰੋ।",
    "Prev": "ਪਿਛਲਾ",
    "Next": "ਅਗਲਾ",
    "Page": "ਪੰਨਾ",
    "of": "ਦੇ",
    "Child Birth Mahoorat": "ਬਾਲ ਜਨਮ ਮਹੂਰਤ",
    "Child Birth Mahoorat | Kundlistar Premium": "ਬਾਲ ਜਨਮ ਮਹੂਰਤ | ਕੁੰਡਲਿਸਟਾਰ ਪ੍ਰੀਮੀਅਮ",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "ਪ੍ਰੀਮੀਅਮ ਬਾਲ ਜਨਮ ਮਹੂਰਤ ਵਿੰਡੋਜ਼ ਪੰਚਾਂਗ, ਚੋਘੜੀਆ ਅਤੇ ਹੋਰਾ ਅਧਾਰਤ ਮਾਰਗਦਰਸ਼ਨ ਨਾਲ।",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "ਯੋਜਨਾਬੱਧ ਬੱਚੇ ਦੇ ਜਨਮ ਸਮੇਂ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਸ਼ੁਭ ਉਪਲਬਧ ਵਿੰਡੋਜ਼ ਦੀ ਪੜਚੋਲ ਕਰਨ ਲਈ ਇੱਕ ਮਿਤੀ ਅਤੇ ਸਥਾਨ ਚੁਣੋ।",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "ਬਾਲ ਜਨਮ ਮਹੂਰਤ ਕੇਵਲ ਅਧਿਆਤਮਿਕ ਅਤੇ ਜੋਤਸ਼ੀ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਹੈ।",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "ਬਾਲ ਜਨਮ ਮਹੂਰਤ ਇੱਕ ਪ੍ਰੀਮੀਅਮ ਵਿਸ਼ੇਸ਼ਤਾ ਹੈ। ਪੰਚਾਂਗ, ਚੋਘੜੀਆ ਅਤੇ ਹੋਰਾ ਚੈਕਾਂ ਨਾਲ ਸ਼ੁਭ ਮਾਰਗਦਰਸ਼ਨ ਵਿੰਡੋਜ਼ ਨੂੰ ਅਨਲੌਕ ਕਰਨ ਲਈ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "ਬਾਲ ਜਨਮ ਮਹੂਰਤ ਇੱਕ ਪ੍ਰੀਮੀਅਮ ਵਿਸ਼ੇਸ਼ਤਾ ਹੈ। ਪੰਚਾਂਗ, ਚੋਘੜੀਆ ਅਤੇ ਹੋਰਾ ਜਾਂਚਾਂ ਨਾਲ ਮਾਰਗਦਰਸ਼ਨ ਵਿੰਡੋਜ਼ ਨੂੰ ਅਨਲੌਕ ਕਰਨ ਲਈ ਅੱਪਗ੍ਰੇਡ ਕਰੋ।",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "ਮਿਤੀ, ਸਥਾਨ, ਪੰਚਾਂਗ, ਚੋਘੜੀਆ ਅਤੇ ਹੋਰਾ ਦੁਆਰਾ ਪ੍ਰੀਮੀਅਮ ਮਾਰਗਦਰਸ਼ਨ ਵਿੰਡੋਜ਼।",
    "Premium feature": "ਪ੍ਰੀਮੀਅਮ ਵਿਸ਼ੇਸ਼ਤਾ",
    "Upgrade to Kundlistar Premium": "ਕੁੰਡਲਿਸਟਾਰ ਪ੍ਰੀਮੀਅਮ 'ਤੇ ਅੱਪਗ੍ਰੇਡ ਕਰੋ",
    "Previous": "ਪਿਛਲਾ",
    "Today": "ਅੱਜ",
    "Birth place / City": "ਜਨਮ ਸਥਾਨ / ਸ਼ਹਿਰ",
    "Birth place / city": "ਜਨਮ ਸਥਾਨ/ਸ਼ਹਿਰ",
    "Select country, then search city": "ਦੇਸ਼ ਚੁਣੋ, ਫਿਰ ਸ਼ਹਿਰ ਦੀ ਖੋਜ ਕਰੋ",
    "Preferred start": "ਤਰਜੀਹੀ ਸ਼ੁਰੂਆਤ",
    "Preferred end": "ਤਰਜੀਹੀ ਅੰਤ",
    "Mother Moon sign (optional)": "ਮਾਤਾ ਚੰਦਰਮਾ ਚਿੰਨ੍ਹ (ਵਿਕਲਪਿਕ)",
    "Cancer": "ਕੈਂਸਰ",
    "Load Kundli": "ਕੁੰਡਲੀ ਲੋਡ ਕਰੋ",
    "Find Premium Windows": "ਪ੍ਰੀਮੀਅਮ ਵਿੰਡੋਜ਼ ਲੱਭੋ",
    "Date (DD/MM/YYYY)": "ਮਿਤੀ (DD/MM/YYYY)",
    "Invalid Date": "ਅਵੈਧ ਮਿਤੀ",
    "Date must be in DD/MM/YYYY format.": "ਮਿਤੀ DD/MM/YYYY ਫਾਰਮੈਟ ਵਿੱਚ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ।",
    "Required": "ਲੋੜੀਂਦਾ ਹੈ",
    "Please select a city.": "ਕਿਰਪਾ ਕਰਕੇ ਇੱਕ ਸ਼ਹਿਰ ਚੁਣੋ।",
    "Kundli": "ਕੁੰਡਲੀ",
    "Unable to load kundli.": "ਕੁੰਡਲੀ ਲੋਡ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Unable to calculate Child Birth Mahoorat.": "ਬਾਲ ਜਨਮ ਮਹੂਰਤ ਦੀ ਗਣਨਾ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ।",
    "Kundli Preview": "ਕੁੰਡਲੀ ਝਲਕ",
    "Loaded for": "ਲਈ ਲੋਡ ਕੀਤਾ ਗਿਆ",
    "Doshas & Yogas": "ਦੋਸ਼ ਅਤੇ ਯੋਗ",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "ਲੋਡ ਹੋਈ ਲਹਿਰੀ ਕੁੰਡਲੀ ਤੋਂ ਨਿਯਮ-ਆਧਾਰਿਤ ਸੰਕੇਤ। ਉਹਨਾਂ ਨੂੰ ਸਮੀਖਿਆ ਅਤੇ ਅਧਿਆਤਮਿਕ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਵਰਤੋ, ਅੰਤਿਮ ਨਿਰਣੇ ਵਜੋਂ ਨਹੀਂ।",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "ਲੋਡ ਹੋਈ ਲਹਿਰੀ ਕੁੰਡਲੀ ਤੋਂ ਨਿਯਮ-ਆਧਾਰਿਤ ਸੰਕੇਤ। ਸਮੀਖਿਆ ਅਤੇ ਅਧਿਆਤਮਿਕ ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਵਰਤੋਂ।",
    "Detected": "ਖੋਜਿਆ ਗਿਆ",
    "Not detected": "ਪਤਾ ਨਹੀਂ ਲੱਗਾ",
    "Review": "ਸਮੀਖਿਆ",
    "Dosha": "ਦੋਸਾ",
    "Yoga": "ਯੋਗਾ",
    "Full Yoga Scan": "ਪੂਰਾ ਯੋਗਾ ਸਕੈਨ",
    "Checking yogas...": "ਯੋਗਾ ਦੀ ਜਾਂਚ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ...",
    "No major yogas were detected by the premium yoga scan.": "ਪ੍ਰੀਮੀਅਮ ਯੋਗਾ ਸਕੈਨ ਦੁਆਰਾ ਕੋਈ ਵੱਡੇ ਯੋਗਾ ਦਾ ਪਤਾ ਨਹੀਂ ਲਗਾਇਆ ਗਿਆ ਸੀ।",
    "No suitable premium windows found for the selected date and time range.": "ਚੁਣੀ ਗਈ ਮਿਤੀ ਅਤੇ ਸਮਾਂ ਸੀਮਾ ਲਈ ਕੋਈ ਢੁਕਵੀਂ ਪ੍ਰੀਮੀਅਮ ਵਿੰਡੋਜ਼ ਨਹੀਂ ਲੱਭੀਆਂ।",
    "No suitable windows found": "ਕੋਈ ਢੁਕਵੀਂ ਵਿੰਡੋ ਨਹੀਂ ਮਿਲੀ",
    "Try changing the time range or select previous/next date.": "ਸਮਾਂ ਸੀਮਾ ਬਦਲਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਪਿਛਲੀ/ਅਗਲੀ ਮਿਤੀ ਚੁਣੋ।",
    "Try changing the date or time range.": "ਮਿਤੀ ਜਾਂ ਸਮਾਂ ਸੀਮਾ ਬਦਲਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    "Try the Previous or Next date button to find a better option.": "ਇੱਕ ਬਿਹਤਰ ਵਿਕਲਪ ਲੱਭਣ ਲਈ ਪਿਛਲੀ ਜਾਂ ਅਗਲੀ ਤਾਰੀਖ ਬਟਨ ਨੂੰ ਅਜ਼ਮਾਓ।",
    "Use Previous or Next date to find a better option.": "ਇੱਕ ਬਿਹਤਰ ਵਿਕਲਪ ਲੱਭਣ ਲਈ ਪਿਛਲੀ ਜਾਂ ਅਗਲੀ ਤਾਰੀਖ ਦੀ ਵਰਤੋਂ ਕਰੋ।",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "ਚੁਣੀ ਗਈ ਮਿਤੀ ਅਤੇ ਸ਼ਹਿਰ ਲਈ ਸਭ ਤੋਂ ਵਧੀਆ ਪ੍ਰੀਮੀਅਮ ਵਿੰਡੋਜ਼ ਦੀ ਗਣਨਾ ਕਰਨ ਲਈ ਪ੍ਰੀਮੀਅਮ ਵਿੰਡੋਜ਼ ਲੱਭੋ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
    "Tap Find Premium Windows for the selected date and city.": "ਚੁਣੀ ਗਈ ਮਿਤੀ ਅਤੇ ਸ਼ਹਿਰ ਲਈ ਪ੍ਰੀਮੀਅਮ ਵਿੰਡੋਜ਼ ਲੱਭੋ 'ਤੇ ਟੈਪ ਕਰੋ।",
    "Good tithi": "ਚੰਗੀ ਤਿਥੀ",
    "Supportive nakshatra": "ਸਹਾਇਕ ਨਕਸ਼ਤਰ",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "ਨਕਸ਼ਤਰ ਸੰਵੇਦਨਸ਼ੀਲ ਹੈ। ਪੱਡਾ ਅਤੇ ਗੰਦੰਤਾ ਨੂੰ ਧਿਆਨ ਨਾਲ ਚੈੱਕ ਕਰੋ।",
    "Supportive weekday": "ਸਹਾਇਕ ਹਫ਼ਤੇ ਦਾ ਦਿਨ",
    "Good Choghadiya": "ਚੰਗੀ ਚੋਗੜੀਏ",
    "Weak Choghadiya": "ਕਮਜ਼ੋਰ ਚੋਘੜੀਆ",
    "Supportive Hora": "ਸਹਾਇਕ ਹੋਰਾ",
    "Baby Moon matches mother's Moon sign.": "ਬੇਬੀ ਮੂਨ ਮਾਂ ਦੇ ਚੰਦਰਮਾ ਦੇ ਚਿੰਨ੍ਹ ਨਾਲ ਮੇਲ ਖਾਂਦਾ ਹੈ।",
    "Hora": "ਹੋਰਾ",
    "slots": "ਸਲਾਟ",
    "min": "ਮਿੰਟ",
    "Good": "ਚੰਗਾ",
    "Excellent": "ਸ਼ਾਨਦਾਰ",
    "Usable": "ਵਰਤੋਂ ਯੋਗ",
    "Rejected": "ਰੱਦ ਕਰ ਦਿੱਤਾ",
    "Sunday": "ਐਤਵਾਰ",
    "Monday": "ਸੋਮਵਾਰ",
    "Tuesday": "ਮੰਗਲਵਾਰ",
    "Wednesday": "ਬੁੱਧਵਾਰ",
    "Thursday": "ਵੀਰਵਾਰ",
    "Friday": "ਸ਼ੁੱਕਰਵਾਰ",
    "Saturday": "ਸ਼ਨੀਵਾਰ",
    "Sun": "ਸੂਰਜ",
    "Moon": "ਚੰਦ",
    "Mars": "ਮੰਗਲ",
    "Mercury": "ਪਾਰਾ",
    "Jupiter": "ਜੁਪੀਟਰ",
    "Venus": "ਵੀਨਸ",
    "Saturn": "ਸ਼ਨੀ",
    "Rahu": "ਰਹਾਉ",
    "Ketu": "ਕੇਤੂ",
    "Chal": "ਚਲ",
    "Labh": "ਲਭ",
    "Amrit": "ਅੰਮ੍ਰਿਤ",
    "Shubh": "ਸ਼ੁਭ",
    "Udveg": "ਉਦਵੇਗ",
    "Rog": "ਰੋਗ",
    "Kaal": "ਕਾਲ",
    "Krishna Navami": "ਕ੍ਰਿਸ਼ਨਾ ਨਵਮੀ",
    "Ashwini": "ਅਸ਼ਵਿਨੀ",
    "Bharani": "ਭਰਨੀ",
    "Krittika": "ਕ੍ਰਿਤਿਕਾ",
    "Rohini": "ਰੋਹਿਣੀ",
    "Mrigashira": "ਮ੍ਰਿਗਾਸ਼ਿਰਾ",
    "Ardra": "ਅਰਦਰਾ",
    "Punarvasu": "ਪੁਨਰਵਾਸੁ",
    "Pushya": "ਪੁਸ਼ਯ",
    "Ashlesha": "ਅਸ਼ਲੇਸ਼ਾ",
    "Magha": "ਮਾਘ",
    "Jyeshtha": "ਜ੍ਯੇਸ਼੍ਠਾ",
    "Moola": "ਮੂਲਾ",
    "Mula": "ਮੂਲਾ",
    "Revati": "ਰੇਵਤੀ"
  },
  "or": {
    "Client Management": "କ୍ଲାଏଣ୍ଟ ପରିଚାଳନା",
    "Dashboard": "ଡ୍ୟାସବୋର୍ଡ |",
    "Clients": "ଗ୍ରାହକ",
    "Consultations": "ପରାମର୍ଶ |",
    "Notes": "ଟିପ୍ପଣୀ |",
    "Follow-ups": "ଅନୁସରଣ",
    "Reports": "ରିପୋର୍ଟଗୁଡିକ",
    "Remedies": "ପ୍ରତିକାର |",
    "Predictions": "ଭବିଷ୍ୟବାଣୀ",
    "Planner": "ଯୋଜନାକାରୀ |",
    "Templates": "ଟେମ୍ପଲେଟ୍ |",
    "Analytics": "ଆନାଲିଟିକ୍ସ |",
    "Payments": "ଦେୟ",
    "Settings": "ସେଟିଂସମୂହ",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings ରେ ଡିଫଲ୍ଟ ସହର ସେଭ୍ କରିପାରିବେ। ଚୟନ ହେଉଅ ପର୍ଯ୍ୟନ୍ତ ସହର ଫିଲ୍ଡ ଖାଲି ରହିବ।",
    "is now your default city.": "ଏବେ ଆପଣଙ୍କ ଡିଫଲ୍ଟ ସହର।",
    "Search your default city": "ଆପଣଙ୍କ ଡିଫଲ୍ଟ ସହର ଖୋଜନ୍ତୁ",
    "This color is saved for the website theme and PDF report accent.": "ଏହି ରଙ୍ଗ ୱେବସାଇଟ୍ ଥିମ୍ ଏବଂ PDF ରିପୋର୍ଟ accent ପାଇଁ ସେଭ୍ ହେବ।",
    "Turn All off to include only the checked modules in the report.": "ରିପୋର୍ଟରେ କେବଳ ଚୟନିତ ମଡ୍ୟୁଲ୍ ପାଇଁ All ବନ୍ଦ କରନ୍ତୁ।",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All ଚାଲୁ ଥିଲେ PDF ରେ ସମସ୍ତ ମଡ୍ୟୁଲ୍ ଥାଏ। କେବଳ ଚୟନିତ ମଡ୍ୟୁଲ୍ ପାଇଁ ଏହାକୁ ବନ୍ଦ କରନ୍ତୁ।",
    "Uranus, Neptune and Pluto stay hidden by default.": "ୟୁରେନସ୍, ନେପଚ୍ୟୁନ୍ ଏବଂ ପ୍ଲୁଟୋ ଡିଫଲ୍ଟ ଭାବେ ଲୁଚି ରହେ।",
    "Show Uranus, Neptune and Pluto": "ୟୁରେନସ୍, ନେପଚ୍ୟୁନ୍ ଏବଂ ପ୍ଲୁଟୋ ଦେଖାନ୍ତୁ",
    "When off, Nadi and KP also use the selected global ayanamsha.": "ବନ୍ଦ ଥିଲେ, ନାଡି ଏବଂ KP ମଧ୍ୟ ଚୟନିତ ଗ୍ଲୋବାଲ୍ ଅୟନାଂଶ ବ୍ୟବହାର କରିବେ।",
    "Use KP for Nadi and KP": "ନାଡି ଏବଂ KP ପାଇଁ KP ବ୍ୟବହାର କରନ୍ତୁ",
    "Use KP ayanamsha for Nadi and KP": "ନାଡି ଏବଂ KP ପାଇଁ KP ଅୟନାଂଶ ବ୍ୟବହାର କରନ୍ତୁ",
    "Night": "ନାଇଟ୍",
    "Dark": "ଡାର୍କ",
    "Light": "ଲାଇଟ୍",
    "Clear default city": "ଡିଫଲ୍ଟ ସହର ହଟାନ୍ତୁ",
    "Default City": "ଡିଫଲ୍ଟ ସହର",
    "Default city": "ଡିଫଲ୍ଟ ସହର",
    "Theme Color": "ଥିମ୍ ରଙ୍ଗ",
    "Theme color": "ଥିମ୍ ରଙ୍ଗ",
    "Include all modules": "ସମସ୍ତ ମଡ୍ୟୁଲ୍ ସାମିଲ କରନ୍ତୁ",
    "PDF Report Modules": "PDF ରିପୋର୍ଟ ମଡ୍ୟୁଲ୍",
    "PDF report modules": "PDF ରିପୋର୍ଟ ମଡ୍ୟୁଲ୍",
    "Show": "ଦେଖାନ୍ତୁ",
    "Hide": "ଲୁଚାନ୍ତୁ",
    "Outer Planets": "ବାହ୍ୟ ଗ୍ରହ",
    "Outer planets": "ବାହ୍ୟ ଗ୍ରହ",
    "Ayanamsha": "ଅୟନାଂଶ",
    "Mean Node": "ମିନ୍ ନୋଡ୍",
    "True Node": "ଟ୍ରୁ ନୋଡ୍",
    "Rahu/Ketu Calculation": "ରାହୁ/କେତୁ ଗଣନା",
    "Rahu/Ketu calculation": "ରାହୁ/କେତୁ ଗଣନା",
    "East": "ପୂର୍ବ ଭାରତୀୟ",
    "South": "ଦକ୍ଷିଣ ଭାରତୀୟ",
    "North": "ଉତ୍ତର ଭାରତୀୟ",
    "Chart Style": "ଚାର୍ଟ ଶୈଳୀ",
    "Chart style": "ଚାର୍ଟ ଶୈଳୀ",
    "Language": "ଭାଷା",
    "Records": "ରେକର୍ଡଗୁଡିକ",
    "Relations": "ସମ୍ପର୍କ",
    "Relation": "ସମ୍ପର୍କ",
    "Add Client": "କ୍ଲାଏଣ୍ଟ ଯୋଡନ୍ତୁ |",
    "Add Consultation": "ପରାମର୍ଶ ଯୋଡନ୍ତୁ |",
    "Add Note": "ଟିପ୍ପଣୀ ଯୋଡନ୍ତୁ |",
    "Add Follow-up": "ଅନୁସରଣ ଯୋଡନ୍ତୁ |",
    "Create Report": "ରିପୋର୍ଟ ସୃଷ୍ଟି କରନ୍ତୁ |",
    "Assign Remedy": "ପ୍ରତିକାର ନ୍ୟସ୍ତ କରନ୍ତୁ |",
    "Add Prediction": "ଭବିଷ୍ୟବାଣୀ ଯୋଡନ୍ତୁ |",
    "Add Payment": "ଦେୟ ଯୋଡନ୍ତୁ |",
    "Assign Chart": "ଚାର୍ଟ ନ୍ୟସ୍ତ କରନ୍ତୁ |",
    "Add Relation": "ସମ୍ପର୍କ ଯୋଡନ୍ତୁ |",
    "CMS Action": "CMS କାର୍ଯ୍ୟ",
    "Client": "ଗ୍ରାହକ",
    "Chart": "ଚାର୍ଟ",
    "Related Client": "ସମ୍ବନ୍ଧୀୟ କ୍ଲାଏଣ୍ଟ |",
    "Full Name": "ପୂର୍ଣ୍ଣ ନାମ",
    "Phone Number": "ଫୋନ୍ ନମ୍ବର |",
    "WhatsApp Number": "ହ୍ ats ାଟସ୍ ଆପ୍ ନମ୍ବର",
    "Email": "ଇମେଲ୍ କରନ୍ତୁ |",
    "Birth Place": "ଜନ୍ମ ସ୍ଥାନ",
    "Current City": "ସାମ୍ପ୍ରତିକ ସହର |",
    "Main Topic": "ମୁଖ୍ୟ ବିଷୟ |",
    "Status": "ସ୍ଥିତି",
    "Source": "ଉତ୍ସ",
    "Tags": "ଟ୍ୟାଗ୍ସ",
    "Internal Note": "ଆଭ୍ୟନ୍ତରୀଣ ଟିପ୍ପଣୀ |",
    "Purpose": "ଉଦ୍ଦେଶ୍ୟ",
    "Relation Type": "ସମ୍ପର୍କ ପ୍ରକାର |",
    "Title": "ଆଖ୍ୟା",
    "Topic": "ବିଷୟ",
    "Date": "ତାରିଖ",
    "Time": "ସମୟ",
    "Amount": "ପରିମାଣ",
    "Mode": "ମୋଡ୍",
    "Payment Status": "ଦେୟ ସ୍ଥିତି",
    "Note / Summary": "ଟିପ୍ପଣୀ / ସାରାଂଶ",
    "Close": "ବନ୍ଦ",
    "Cancel": "ବାତିଲ୍ କରନ୍ତୁ |",
    "Save": "ସଞ୍ଚୟ କରନ୍ତୁ |",
    "Saving": "ସଞ୍ଚୟ",
    "Save Changes": "ପରିବର୍ତ୍ତନଗୁଡିକ ସଞ୍ଚୟ କରନ୍ତୁ |",
    "Edit Client": "କ୍ଲାଏଣ୍ଟ ସଂପାଦନ କରନ୍ତୁ |",
    "Client Chart": "କ୍ଲାଏଣ୍ଟ ଚାର୍ଟ",
    "Comma separated": "କମା ଅଲଗା |",
    "Search by name, phone, email, topic, or tag": "ନାମ, ଫୋନ୍, ଇମେଲ୍, ପ୍ରସଙ୍ଗ, କିମ୍ବା ଟ୍ୟାଗ୍ ଦ୍ୱାରା ସନ୍ଧାନ କରନ୍ତୁ |",
    "Search clients, phone, topic": "ଗ୍ରାହକ, ଫୋନ୍, ବିଷୟ ଖୋଜ |",
    "Search your saved charts by chart name": "ଚାର୍ଟ ନାମ ଅନୁଯାୟୀ ଆପଣଙ୍କର ସଞ୍ଚିତ ଚାର୍ଟଗୁଡିକ ସନ୍ଧାନ କରନ୍ତୁ |",
    "Linked Chart": "ଲିଙ୍କ୍ ହୋଇଥିବା ଚାର୍ଟ |",
    "Select linked chart": "ଲିଙ୍କ୍ ହୋଇଥିବା ଚାର୍ଟ ଚୟନ କରନ୍ତୁ |",
    "Link a chart to this client before adding records.": "ରେକର୍ଡ ଯୋଡିବା ପୂର୍ବରୁ ଏହି କ୍ଲାଏଣ୍ଟ ସହିତ ଏକ ଚାର୍ଟ ଲିଙ୍କ୍ କରନ୍ତୁ |",
    "Connect this client with another saved client profile": "ଏହି କ୍ଲାଏଣ୍ଟକୁ ଅନ୍ୟ ଏକ ସଞ୍ଚିତ କ୍ଲାଏଣ୍ଟ ପ୍ରୋଫାଇଲ ସହିତ ସଂଯୋଗ କରନ୍ତୁ |",
    "CMS for astrologer client work": "ଜ୍ୟୋତିଷ କ୍ଲାଏଣ୍ଟ କାର୍ଯ୍ୟ ପାଇଁ CMS |",
    "Premium Pro unlocks Client Management": "ପ୍ରିମିୟମ୍ ପ୍ରୋ କ୍ଲାଏଣ୍ଟ ମ୍ୟାନେଜମେଣ୍ଟକୁ ଅନଲକ୍ କରେ |",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ଗୋଟିଏ କାର୍ଯ୍ୟକ୍ଷେତ୍ରରେ କ୍ଲାଏଣ୍ଟ ପ୍ରୋଫାଇଲ୍, ପରାମର୍ଶ, ନୋଟ୍, ଅନୁସରଣ, ରିପୋର୍ଟ, ପ୍ରତିକାର, ଭବିଷ୍ୟବାଣୀ, ଆନାଲିଟିକ୍ସ ଏବଂ ପେମେଣ୍ଟ ଟ୍ରାକିଂ ପରିଚାଳନା କରିବାକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "Upgrade to Premium Pro": "ପ୍ରିମିୟମ୍ ପ୍ରୋକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "CMS modules included": "CMS ମଡ୍ୟୁଲ୍ ଅନ୍ତର୍ଭୁକ୍ତ |",
    "Please login to use Client Management. CMS data is stored per account.": "କ୍ଲାଏଣ୍ଟ ମ୍ୟାନେଜମେଣ୍ଟ ବ୍ୟବହାର କରିବାକୁ ଦୟାକରି ଲଗଇନ୍ କରନ୍ତୁ | ଖାତା ପ୍ରତି CMS ତଥ୍ୟ ଗଚ୍ଛିତ ଅଛି |",
    "Login": "ଲଗଇନ୍ କରନ୍ତୁ |",
    "Loading live CMS data...": "ଲାଇଭ୍ CMS ଡାଟା ଲୋଡ୍ କରୁଛି ...",
    "Quick Actions": "ଦ୍ରୁତ କାର୍ଯ୍ୟ",
    "Client Records": "କ୍ଲାଏଣ୍ଟ ରେକର୍ଡସ",
    "Client Record": "କ୍ଲାଏଣ୍ଟ ରେକର୍ଡ |",
    "Client Profile": "କ୍ଲାଏଣ୍ଟ ପ୍ରୋଫାଇଲ୍ |",
    "Back to Clients": "ଗ୍ରାହକମାନଙ୍କୁ ଫେରନ୍ତୁ |",
    "View": "ଦର୍ଶନ କରନ୍ତୁ |",
    "Edit": "ସଂପାଦନା କରନ୍ତୁ |",
    "Delete": "ବିଲୋପ କରନ୍ତୁ |",
    "Note": "ଟିପ୍ପଣୀ |",
    "Archive": "ଅଭିଲେଖାଗାର",
    "Download PDF": "PDF ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
    "Delete this record?": "ଏହି ରେକର୍ଡ ବିଲୋପ କରିବେ କି?",
    "Unable to edit this CMS record.": "ଏହି CMS ରେକର୍ଡ ସଂପାଦନ କରିବାରେ ଅସମର୍ଥ |",
    "Unable to update CMS record.": "CMS ରେକର୍ଡ ଅଦ୍ୟତନ କରିବାକୁ ଅସମର୍ଥ |",
    "Unable to delete CMS record.": "CMS ରେକର୍ଡ ବିଲୋପ କରିବାରେ ଅସମର୍ଥ |",
    "No contact added": "କ contact ଣସି ଯୋଗାଯୋଗ ଯୋଗ କରାଯାଇ ନାହିଁ |",
    "No topic": "କ topic ଣସି ପ୍ରସଙ୍ଗ ନାହିଁ |",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "କ No ଣସି ଗ୍ରାହକ ଏପର୍ଯ୍ୟନ୍ତ ପାଇଲେ ନାହିଁ | CMS ଡ୍ୟାସବୋର୍ଡ ପୂରଣ କରିବା ପାଇଁ ଆପଣଙ୍କର ପ୍ରଥମ ପ୍ରକୃତ କ୍ଲାଏଣ୍ଟ ଯୋଡନ୍ତୁ |",
    "Last Consultation": "ଶେଷ ପରାମର୍ଶ |",
    "Next Follow-up": "ପରବର୍ତ୍ତୀ ଅନୁସରଣ |",
    "Date of Birth": "ଜନ୍ମ ତାରିଖ",
    "Time of Birth": "ଜନ୍ମ ସମୟ",
    "Client Details": "କ୍ଲାଏଣ୍ଟ ବିବରଣୀ",
    "No connected profiles yet.": "ଏପର୍ଯ୍ୟନ୍ତ କ connected ଣସି ସଂଯୁକ୍ତ ପ୍ରୋଫାଇଲ୍ ନାହିଁ |",
    "Select a client record to view details.": "ବିବରଣୀ ଦେଖିବାକୁ ଏକ କ୍ଲାଏଣ୍ଟ ରେକର୍ଡ ଚୟନ କରନ୍ତୁ |",
    "Record": "ରେକର୍ଡ କରନ୍ତୁ |",
    "Consultation Summary": "ପରାମର୍ଶ ସାରାଂଶ",
    "Client Note": "କ୍ଲାଏଣ୍ଟ ଟିପ୍ପଣୀ |",
    "Start a consultation record with summary, topic, mode and payment fields.": "ସାରାଂଶ, ବିଷୟ, ମୋଡ୍ ଏବଂ ଦେୟ କ୍ଷେତ୍ର ସହିତ ଏକ ପରାମର୍ଶ ରେକର୍ଡ ଆରମ୍ଭ କରନ୍ତୁ |",
    "Start a private note attached to a client profile.": "ଏକ କ୍ଲାଏଣ୍ଟ ପ୍ରୋଫାଇଲରେ ସଂଲଗ୍ନ ହୋଇଥିବା ଏକ ବ୍ୟକ୍ତିଗତ ନୋଟ୍ ଆରମ୍ଭ କରନ୍ତୁ |",
    "Start a pending follow-up with due date and topic.": "ଧାର୍ଯ୍ୟ ତାରିଖ ଏବଂ ପ୍ରସଙ୍ଗ ସହିତ ଏକ ବିଚାରାଧୀନ ଅନୁସରଣ ଆରମ୍ଭ କରନ୍ତୁ |",
    "Start a report record connected to the client timeline.": "କ୍ଲାଏଣ୍ଟ ଟାଇମଲାଇନ ସହିତ ସଂଯୁକ୍ତ ଏକ ରିପୋର୍ଟ ରେକର୍ଡ ଆରମ୍ଭ କରନ୍ତୁ |",
    "Start an active remedy record for client guidance.": "କ୍ଲାଏଣ୍ଟ ମାର୍ଗଦର୍ଶନ ପାଇଁ ଏକ ସକ୍ରିୟ ପ୍ରତିକାର ରେକର୍ଡ ଆରମ୍ଭ କରନ୍ତୁ |",
    "Start an open prediction record with notes and follow-up date.": "ନୋଟ୍ ଏବଂ ଅନୁସରଣ ତାରିଖ ସହିତ ଏକ ଖୋଲା ଭବିଷ୍ୟବାଣୀ ରେକର୍ଡ ଆରମ୍ଭ କରନ୍ତୁ |",
    "Statuses": "ସ୍ଥିତି",
    "Topics": "ବିଷୟଗୁଡିକ",
    "Sources": "ଉତ୍ସ",
    "No records found for the current filters.": "ସାମ୍ପ୍ରତିକ ଫିଲ୍ଟର୍ ପାଇଁ କ records ଣସି ରେକର୍ଡ ମିଳିଲା ନାହିଁ |",
    "Total Clients": "ମୋଟ ଗ୍ରାହକ",
    "New Clients This Month": "ଏହି ମାସରେ ନୂତନ ଗ୍ରାହକ |",
    "Consultations This Month": "ଏହି ମାସରେ ପରାମର୍ଶ |",
    "Today's Consultations": "ଆଜିର ପରାମର୍ଶ |",
    "Consultations scheduled for today from real client records.": "ପ୍ରକୃତ କ୍ଲାଏଣ୍ଟ ରେକର୍ଡରୁ ଆଜି ପାଇଁ ପରାମର୍ଶ ଧାର୍ଯ୍ୟ କରାଯାଇଛି |",
    "No consultations scheduled for today.": "ଆଜି ପାଇଁ କ No ଣସି ପରାମର୍ଶ ଧାର୍ଯ୍ୟ କରାଯାଇ ନାହିଁ |",
    "Pending Follow-ups": "ବିଚାରାଧୀନ ଅନୁସରଣଗୁଡିକ |",
    "Reports Created": "ରିପୋର୍ଟଗୁଡିକ ସୃଷ୍ଟି ହୋଇଛି |",
    "Active Remedies": "ସକ୍ରିୟ ପ୍ରତିକାର |",
    "Open Predictions": "ଭବିଷ୍ୟବାଣୀ ଖୋଲନ୍ତୁ |",
    "Pending Payments": "ଦେୟ ବିଚାରାଧୀନ ଅଛି |",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "ଗୋଟିଏ ସ୍ଥାନରେ କ୍ଲାଏଣ୍ଟ କାର୍ଯ୍ୟକଳାପ, ସାମ୍ପ୍ରତିକ କାର୍ଯ୍ୟ, ଅନୁସରଣ, ରିପୋର୍ଟ, ଭବିଷ୍ୟବାଣୀ, ପ୍ରତିକାର ଏବଂ ବିଚାରାଧୀନ ଦେୟ ଦେଖନ୍ତୁ |",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "ଜନ୍ମ ବିବରଣୀ, ବିଷୟ, ଟ୍ୟାଗ୍, ସ୍ଥିତି ଏବଂ ଅଭିଲେଖାଗାର / ପୁନରୁଦ୍ଧାର କାର୍ଯ୍ୟ ସହିତ ଜ୍ୟୋତିଷ କ୍ଲାଏଣ୍ଟ ରେକର୍ଡଗୁଡିକ ପରିଚାଳନା କରନ୍ତୁ |",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "ଅଧିବେଶନ ବିବରଣୀ, ଲିଙ୍କ୍ ହୋଇଥିବା ଚାର୍ଟ, ବିଷୟ, ପର୍ଯ୍ୟବେକ୍ଷଣ, ଭବିଷ୍ୟବାଣୀ, ପ୍ରତିକାର ଏବଂ ଅନୁସରଣ ତାରିଖ ଗଚ୍ଛିତ କରନ୍ତୁ |",
    "Keep private consultation notes and chart observations attached to client profiles.": "ବ୍ୟକ୍ତିଗତ ପରାମର୍ଶ ନୋଟ୍ ଏବଂ କ୍ଲାଏଣ୍ଟ ପ୍ରୋଫାଇଲ ସହିତ ଚାର୍ଟ ପର୍ଯ୍ୟବେକ୍ଷଣଗୁଡିକ ରଖନ୍ତୁ |",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "ଆଜି ଏବଂ କ୍ଲାସ୍ ମ୍ୟାନେଜମେଣ୍ଟ ଭିତରେ ପୁସ୍, SMS, ଇମେଲ୍ କିମ୍ବା ହ୍ ats ାଟସ୍ ଆପ୍ ଆଲର୍ଟ ବିନା ଟ୍ରାକ୍ କରନ୍ତୁ |",
    "Create and organize client reports generated from saved charts and consultation context.": "ସଞ୍ଚିତ ଚାର୍ଟ ଏବଂ ପରାମର୍ଶ ପ୍ରସଙ୍ଗରୁ ସୃଷ୍ଟି ହୋଇଥିବା କ୍ଲାଏଣ୍ଟ ରିପୋର୍ଟଗୁଡିକ ସୃଷ୍ଟି ଏବଂ ସଂଗଠିତ କରନ୍ତୁ |",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "ପ୍ରତିକାରଗୁଡିକ ନ୍ୟସ୍ତ କରନ୍ତୁ, ସକ୍ରିୟ ମାର୍ଗଦର୍ଶନ ଚିହ୍ନଟ କରନ୍ତୁ ଏବଂ ପ୍ରତିକାର ଇତିହାସକୁ କ୍ଲାଏଣ୍ଟ ଟାଇମଲାଇନ୍ ସହିତ ସଂଯୁକ୍ତ ରଖନ୍ତୁ |",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "ପ୍ରତ୍ୟେକ ଗ୍ରାହକଙ୍କ ପାଇଁ ଖୋଲା ଭବିଷ୍ୟବାଣୀ, ତାରିଖ, ଆତ୍ମବିଶ୍ୱାସ ନୋଟ୍ ଏବଂ ଫଳାଫଳ ଅଦ୍ୟତନଗୁଡିକ ଟ୍ରାକ୍ କରନ୍ତୁ |",
    "Plan consultations, follow-ups and payment dates in one working view.": "ଗୋଟିଏ କାର୍ଯ୍ୟ ଦୃଶ୍ୟରେ ପରାମର୍ଶ, ଅନୁସରଣ ଏବଂ ଦେୟ ତାରିଖ ଯୋଜନା କରନ୍ତୁ |",
    "Prepare reusable consultation, report, remedy and prediction templates.": "ପୁନ us ବ୍ୟବହାର ଯୋଗ୍ୟ ପରାମର୍ଶ, ରିପୋର୍ଟ, ପ୍ରତିକାର ଏବଂ ଭବିଷ୍ୟବାଣୀ ଟେମ୍ପଲେଟ୍ ପ୍ରସ୍ତୁତ କରନ୍ତୁ |",
    "Review client activity, consultation volume, reports created and pending work.": "କ୍ଲାଏଣ୍ଟ କାର୍ଯ୍ୟକଳାପ, ପରାମର୍ଶ ପରିମାଣ, ସୃଷ୍ଟି ହୋଇଥିବା ଏବଂ ବିଚାରାଧୀନ କାର୍ଯ୍ୟ ସମୀକ୍ଷା କରନ୍ତୁ |",
    "Track consultation amounts and payment status without plan or pricing rules.": "ଯୋଜନା କିମ୍ବା ମୂଲ୍ୟ ନିୟମ ବିନା ପରାମର୍ଶ ପରିମାଣ ଏବଂ ଦେୟ ସ୍ଥିତିକୁ ଟ୍ରାକ୍ କରନ୍ତୁ |",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "କ୍ଲାଏଣ୍ଟ ଉତ୍ସ, ସ୍ଥିତି, ପ୍ରସଙ୍ଗ, ଟ୍ୟାଗ ଏବଂ ଆଭ୍ୟନ୍ତରୀଣ CMS ପସନ୍ଦକୁ ବିନ୍ୟାସ କରନ୍ତୁ |",
    "Showing saved records connected to client records.": "କ୍ଲାଏଣ୍ଟ ରେକର୍ଡ ସହିତ ସଂଯୁକ୍ତ ସଞ୍ଚିତ ରେକର୍ଡଗୁଡିକ ଦେଖାଉଛି |",
    "No Status": "କ No ଣସି ସ୍ଥିତି ନାହିଁ |",
    "No Mode": "କ Mode ଣସି ଧାରା ନାହିଁ |",
    "No Payment Status": "କ Pay ଣସି ଦେୟ ସ୍ଥିତି ନାହିଁ |",
    "No Topic": "କ Top ଣସି ବିଷୟ ନାହିଁ |",
    "No Source": "କ Source ଣସି ଉତ୍ସ ନାହିଁ |",
    "All Statuses": "ସମସ୍ତ ସ୍ଥିତି",
    "All Topics": "ସମସ୍ତ ବିଷୟଗୁଡିକ |",
    "No clients found": "କ No ଣସି ଗ୍ରାହକ ପାଇଲେ ନାହିଁ |",
    "Type to search clients": "ଗ୍ରାହକମାନଙ୍କୁ ଖୋଜିବା ପାଇଁ ଟାଇପ୍ କରନ୍ତୁ |",
    "No charts found": "କ No ଣସି ଚାର୍ଟ ମିଳିଲା ନାହିଁ |",
    "Type to search saved charts": "ସଞ୍ଚିତ ଚାର୍ଟ ଖୋଜିବା ପାଇଁ ଟାଇପ୍ କରନ୍ତୁ |",
    "Type to search related client": "ସମ୍ପର୍କିତ କ୍ଲାଏଣ୍ଟ ଖୋଜିବା ପାଇଁ ଟାଇପ୍ କରନ୍ତୁ |",
    "Open": "ଖୋଲନ୍ତୁ |",
    "Pending": "ବିଚାରାଧୀନ ଅଛି",
    "Scheduled": "ଅନୁସୂଚିତ",
    "Completed": "ସମାପ୍ତ",
    "Follow-up Pending": "ଅନୁସରଣ ବିଚାରାଧୀନ ଅଛି |",
    "Cancelled": "ବାତିଲ",
    "Closed": "ବନ୍ଦ |",
    "No-show": "ନୋ-ସୋ |",
    "Not Applicable": "ପ୍ରଯୁଜ୍ୟ ନୁହେଁ |",
    "Paid": "ଦେୟ",
    "Partially Paid": "ଆଂଶିକ ଦେୟ",
    "Refunded": "ଫେରସ୍ତ",
    "Phone": "ଫୋନ୍ |",
    "WhatsApp Call": "ହ୍ ats ାଟସ୍ ଆପ୍ କଲ୍",
    "Video Call": "ଭିଡିଓ କଲ୍ |",
    "In-person": "ବ୍ୟକ୍ତିଗତ ଭାବରେ |",
    "Chat": "ଚାଟ୍ କରନ୍ତୁ |",
    "Other": "ଅନ୍ୟମାନେ |",
    "New": "ନୂତନ",
    "VIP": "VIP",
    "Inactive": "ନିଷ୍କ୍ରିୟ |",
    "Consultation Completed": "ପରାମର୍ଶ ସମାପ୍ତ ହୋଇଛି |",
    "WhatsApp": "ହ୍ ats ାଟସ୍ ଆପ୍",
    "Instagram": "ଇନଷ୍ଟାଗ୍ରାମ |",
    "YouTube": "ୟୁଟ୍ୟୁବ୍",
    "Referral": "ରେଫରାଲ୍ |",
    "Website": "ୱେବସାଇଟ୍",
    "Walk-in": "ଚାଲ-ଇନ୍ |",
    "Repeat Client": "କ୍ଲାଏଣ୍ଟ ପୁନରାବୃତ୍ତି କରନ୍ତୁ |",
    "Family Referral": "ପରିବାର ରେଫରାଲ୍ |",
    "Business": "ବ୍ୟବସାୟ",
    "Finance": "ଅର୍ଥ",
    "Property": "ସମ୍ପତ୍ତି",
    "Children": "ପିଲାମାନେ",
    "Foreign Settlement": "ବିଦେଶୀ ସମାଧାନ",
    "Legal": "ଆଇନଗତ |",
    "Remedy": "ପ୍ରତିକାର",
    "General": "ଜେନେରାଲ୍ |",
    "Active": "ସକ୍ରିୟ |",
    "Past": "ଅତୀତ",
    "Potential": "ସମ୍ଭାବ୍ୟ |",
    "Archived": "ସଂଗୃହିତ",
    "Spouse": "ପତି",
    "Husband": "ସ୍ୱାମୀ",
    "Wife": "ପତ୍ନୀ",
    "Child": "ପିଲା",
    "Son": "ପୁଅ",
    "Daughter": "Ughter ିଅ",
    "Father": "ପିତା",
    "Mother": "ମା",
    "Sibling": "ଭାଇଭଉଣୀ |",
    "Brother": "ଭାଇ",
    "Sister": "ଭଉଣୀ |",
    "Marriage Prospect": "ବିବାହ ଆଶା",
    "Fiance": "ଫ୍ୟାନ୍ସ",
    "Business Partner": "ବ୍ୟବସାୟ ସହଭାଗୀ |",
    "Friend": "ବନ୍ଧୁ",
    "Relative": "ସମ୍ପର୍କୀୟ",
    "Upgrade": "ନବୀକରଣ କରନ୍ତୁ |",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "ଆପଣ କେବଳ 2 ଗ୍ରାହକ ଯୋଗ କରିପାରିବେ | ଅଧିକ ଗ୍ରାହକଙ୍କ ପାଇଁ ପ୍ରିମିୟମକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "None": "କିଛି ନୁହେଁ",
    "Education": "ଶିକ୍ଷା",
    "Awards": "ପୁରସ୍କାର",
    "Prize": "ପୁରସ୍କାର",
    "Career": "ବୃତ୍ତି",
    "Love": "ପ୍ରେମ",
    "Marriage": "ବିବାହ",
    "Dowry or Legacy": "ବିବାହ କିମ୍ବା ଉତ୍ତରାଧିକାରୀ",
    "Divorce": "ଛାଡପତ୍ର",
    "Abortion": "ଗର୍ଭପାତ",
    "Child Birth": "ଶିଶୁ ଜନ୍ମ",
    "Property/Vehicle Purchase": "ସମ୍ପତ୍ତି / ଯାନ କ୍ରୟ",
    "Property/Vehicle Sale": "ସମ୍ପତ୍ତି / ଯାନ ବିକ୍ରୟ",
    "Love and Caring": "ପ୍ରେମ ଏବଂ ଯତ୍ନ",
    "Depression": "ଉଦାସୀନତା",
    "Aggression": "ଆକ୍ରୋଶ",
    "Health": "ସ୍ୱାସ୍ଥ୍ୟ",
    "Travel": "ଭ୍ରମଣ",
    "Homecoming": "ହୋମଗାର୍ଡ",
    "Litigation": "ମକଦ୍ଦମା",
    "Arrest": "ଗିରଫ",
    "Locked": "ତାଲା ପଡିଛି",
    "Strong": "ଶକ୍ତିଶାଳୀ",
    "Weak": "ଦୁର୍ବଳ |",
    "Supportive": "ସହାୟକ",
    "Avoid": "ଏଡ଼ାନ୍ତୁ",
    "Premium": "ପ୍ରିମିୟମ୍",
    " UTC": "UTC",
    "Unable to calculate Tithi Pravesh": "ତିଥି ପ୍ରଭେଶ ଗଣନା କରିବାରେ ଅସମର୍ଥ |",
    "IANA timezone": "IANA ସମୟ ମଣ୍ଡଳ |",
    "TP Local": "ଟିପି ଲୋକାଲ୍ |",
    "TP UTC": "TP UTC",
    "Next TP Local": "ପରବର୍ତ୍ତୀ TP ଲୋକାଲ୍ |",
    "Models: KP + Vedic": "ମଡେଲଗୁଡିକ: KP + ବ ed ଦିକ |",
    "Overall Year Theme": "ମୋଟାମୋଟି ବର୍ଷ ଥିମ୍ |",
    "Career & Job": "ବୃତ୍ତି ଏବଂ କାର୍ଯ୍ୟ",
    "Finance & Savings": "ଅର୍ଥ ଏବଂ ସଞ୍ଚୟ",
    "Relationship & Marriage": "ସମ୍ପର୍କ ଏବଂ ବିବାହ",
    "Family Matters": "ପାରିବାରିକ ବିଷୟ |",
    "Property & Vehicle": "ସମ୍ପତ୍ତି ଏବଂ ଯାନ",
    "Health & Wellness": "ସ୍ୱାସ୍ଥ୍ୟ ଏବଂ ସୁସ୍ଥତା",
    "Spiritual Growth": "ଆଧ୍ୟାତ୍ମିକ ଅଭିବୃଦ୍ଧି |",
    "Social Status & Recognition": "ସାମାଜିକ ସ୍ଥିତି ଏବଂ ସ୍ୱୀକୃତି",
    "Please select a saved chart first.": "ଦୟାକରି ପ୍ରଥମେ ଏକ ସଞ୍ଚିତ ଚାର୍ଟ ଚୟନ କରନ୍ତୁ |",
    "Unable to generate Tajika Varshphal": "ତାଜିକା ଭାରସଫାଲ ସୃଷ୍ଟି କରିବାରେ ଅସମର୍ଥ |",
    "Premium yearly module": "ପ୍ରିମିୟମ୍ ବାର୍ଷିକ ମଡ୍ୟୁଲ୍ |",
    "Tajika Varshphal": "ତାଜିକା ଭାରସଫାଲ |",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "ଏହି ସଞ୍ଚିତ କୁଣ୍ଡଲିରୁ ବ୍ୟକ୍ତିଗତ ହୋଇଥିବା ଭର୍ସା ଲାଗନା, ମୁନ୍ଥା, ଭର୍ସା ପ୍ରଭୁ, ସାହାମସ୍, ମାସିକ ମାର୍ଗଦର୍ଶନ, ପ୍ରତିକାର ଏବଂ ବ୍ୟବହାରିକ ଜୀବନ ଥିମ୍ ସହିତ ସୋଲାର୍ ରିଟର୍ନ ଆଧାରିତ ବାର୍ଷିକ ରାଶିଫଳ |",
    "Saved chart": "ସଞ୍ଚିତ ଚାର୍ଟ |",
    "Untitled Chart": "ଆଖ୍ୟାବିହୀନ ଚାର୍ଟ |",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "ଆପଣଙ୍କର 4 ମାଗଣା ପ୍ରିମିୟମ୍ କ୍ରେଡିଟ୍ ବ୍ୟବହୃତ ହୁଏ | ଅସୀମିତ ପ୍ରିମିୟମ ପ୍ରବେଶ ପାଇଁ Kundlistar ପ୍ରିମିୟମକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हैं हैं। असीमित प्रीमियम एक्सेस के __ Kundlistar ପ୍ରିମିୟମ୍ लें |",
    "Core Year Markers": "ମୂଳ ବର୍ଷ ମାର୍କର୍ସ |",
    "Solar Return": "ସ olar ର ପ୍ରତ୍ୟାବର୍ତ୍ତନ |",
    "Varsha Lagna": "Varsha Lagna",
    "Muntha Lord": "ମୁନ୍ଥା ପ୍ରଭୁ |",
    "Varsha Lord": "Varsha Lord",
    "Varshesh Method": "ଭର୍ଶେଶ ପଦ୍ଧତି |",
    "Yearly Summary": "ବାର୍ଷିକ ସାରାଂଶ",
    "Not available yet.": "ଏପର୍ଯ୍ୟନ୍ତ ଉପଲବ୍ଧ ନାହିଁ |",
    "Varshesh Candidates": "ଭର୍ଶେଶ ପ୍ରାର୍ଥୀ |",
    "Risk Areas": "ବିପଦ କ୍ଷେତ୍ରଗୁଡିକ |",
    "Favourable Periods": "ଅନୁକୂଳ ସମୟଗୁଡିକ |",
    "Challenging Periods": "ଚ୍ୟାଲେଞ୍ଜିଂ ସମୟଗୁଡିକ |",
    "Remedies & Final Advice": "ପ୍ରତିକାର ଏବଂ ଅନ୍ତିମ ଉପଦେଶ |",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "ତାଜିକା ଭାରସଫାଲ ବାର୍ଷିକ ବ୍ୟାଖ୍ୟାକାରୀ ମାର୍ଗଦର୍ଶନ ଦିଅନ୍ତି | ଏହାକୁ ଚିକିତ୍ସା, ଆଇନଗତ, ଆର୍ଥିକ କିମ୍ବା କିଛି ଭବିଷ୍ୟବାଣୀ ପରାମର୍ଶ ଭାବରେ ଗ୍ରହଣ କରାଯିବା ଉଚିତ୍ ନୁହେଁ |",
    "Griha Pravesh": "ଗ୍ରିହା ପ୍ରଭେଶ |",
    "Purva Phalguni": "ପୁରଭା ଫାଲଗୁନି |",
    "Uttara Phalguni": "ଉତ୍ତରା ଫାଲଗୁନି |",
    "Purva Ashadha": "ପୁରଭା ଆଶା",
    "Uttara Ashadha": "ଉତ୍ତରା ଆଶା",
    "Purva Bhadrapada": "ପୁରଭ ଭଦ୍ରାପଡା |",
    "Uttara Bhadrapada": "ଉତ୍ତରା ଭଦ୍ରାପଡା |",
    "Param Mitra": "ପରମ ମିତ୍ର |",
    "Kundli birthplace": "କୁଣ୍ଡଲି ଜନ୍ମସ୍ଥାନ |",
    "Selected city": "ମନୋନୀତ ସହର |",
    "Muhurat - Kundlistar": "ମୁହୁରାଟ - Kundlistar",
    "Please select a city first.": "ଦୟାକରି ପ୍ରଥମେ ଏକ ସହର ବାଛନ୍ତୁ |",
    "Unable to calculate Muhurat.": "ମୁହୁରତ ଗଣନା କରିବାରେ ଅସମର୍ଥ |",
    "Unable to calculate personalized Muhurat.": "ବ୍ୟକ୍ତିଗତ ମୁହୁରତ ଗଣନା କରିବାରେ ଅସମର୍ଥ |",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "ପଞ୍ଚାଙ୍ଗ, ଚୋଗାଡିଆ, ହୋରା, ତରବାଲା ଏବଂ ଚନ୍ଦ୍ରବାଲା ବ୍ୟବହାର କରି ସାଧାରଣ ଏବଂ ବ୍ୟକ୍ତିଗତ ମୁହୁରାଟ ଖୋଜ |",
    "Muhurat Finder": "ମୁହୁରାଟ ସନ୍ଧାନକାରୀ |",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "ପଞ୍ଚାଙ୍ଗ, ଚୋଗାଡିଆ ଏବଂ ପ୍ରିମିୟମ୍ ବ୍ୟକ୍ତିଗତ ଜନ୍ମ କାରକ ବ୍ୟବହାର କରି ଉପଯୋଗୀ ସମୟ ୱିଣ୍ଡୋ ଖୋଜ |",
    "Search city...": "ସହର ଖୋଜ ...",
    "Using selected Kundli": "ମନୋନୀତ କୁଣ୍ଡଲି ବ୍ୟବହାର କରି |",
    "Find Free": "ମାଗଣା ଖୋଜ |",
    "Free General Muhurat": "ମାଗଣା ଜେନେରାଲ୍ ମୁହୁରାଟ |",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "ଆଗାମୀ 7 ଦିନ ପାଇଁ ଟପ୍ 3 ସ୍ଲଟ୍ | ରାହୁ କାଲ, ୟାମାଗଣ୍ଡା ଏବଂ ଗୁଲିକାଙ୍କୁ ହଟାଇ ଦିଆଯାଇଛି |",
    "Today's Muhurat": "ଆଜିର ମୁହୁରାଟ |",
    "Daily Muhurat by Kundlistar": "Kundlistar ଦ୍ୱାରା ଦ Daily ନିକ ମୁହୁରାଟ |",
    "Shared via Kundlistar": "Kundlistar ମାଧ୍ୟମରେ ଅଂଶୀଦାର |",
    "Kundlistar Muhurat": "Kundlistar ମୁହୁରାଟ |",
    "Share Image": "ପ୍ରତିଛବି ଅଂଶୀଦାର କରନ୍ତୁ |",
    "Share Text": "ପାଠ୍ୟ ଅଂଶୀଦାର କରନ୍ତୁ |",
    "Copy Text": "ପାଠ୍ୟ କପି କରନ୍ତୁ |",
    "Click Find Free to use the selected Kundli birthplace.": "ମନୋନୀତ କୁଣ୍ଡଲି ଜନ୍ମସ୍ଥାନ ବ୍ୟବହାର କରିବାକୁ ମାଗଣା ସନ୍ଧାନ କ୍ଲିକ୍ କରନ୍ତୁ |",
    "Select a city and click Find Free.": "ଏକ ସହର ଚୟନ କରନ୍ତୁ ଏବଂ ମାଗଣା ଖୋଜ କ୍ଲିକ୍ କରନ୍ତୁ |",
    "Premium Personalized Muhurat": "ପ୍ରିମିୟମ୍ ବ୍ୟକ୍ତିଗତ ମୁହୁରାଟ |",
    "Loading Kundli details...": "କୁଣ୍ଡଲି ବିବରଣୀ ଲୋଡ୍ କରୁଛି ...",
    "Birth Nakshatra": "ଜନ୍ମ ନକ୍ଷତ୍ର |",
    "Birth Moon Rashi": "ଜନ୍ମ ଚନ୍ଦ୍ର ରାଶି |",
    "Include night slots": "ନାଇଟ୍ ସ୍ଲଟ୍ ଅନ୍ତର୍ଭୂକ୍ତ କରନ୍ତୁ |",
    "Find Premium": "ପ୍ରିମିୟମ୍ ଖୋଜ |",
    "Your grounding and foundation energy appears strong in this chart.": "ଏହି ଗ୍ରାଉଣ୍ଡରେ ତୁମର ଗ୍ରାଉଣ୍ଡିଂ ଏବଂ ଫାଉଣ୍ଡେସନ୍ ଶକ୍ତି ଦୃ strong ଦେଖାଯାଏ |",
    "Your grounding energy appears generally balanced in this chart.": "ଏହି ଗ୍ରାଉଣ୍ଡରେ ତୁମର ଗ୍ରାଉଣ୍ଡ୍ ଶକ୍ତି ସାଧାରଣତ bal ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on routine, discipline, and inner stability may be useful.": "ନିତ୍ୟକର୍ମ, ଅନୁଶାସନ ଏବଂ ଆଭ୍ୟନ୍ତରୀଣ ସ୍ଥିରତା ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "Your creative and emotional flow energy appears strong in this chart.": "ତୁମର ସୃଜନଶୀଳ ଏବଂ ଭାବପ୍ରବଣ ପ୍ରବାହ ଶକ୍ତି ଏହି ଚାର୍ଟରେ ଦୃ strong ଦେଖାଯାଏ |",
    "Your creative energy appears balanced in this chart.": "ତୁମର ସୃଜନଶୀଳ ଶକ୍ତି ଏହି ଚାର୍ଟରେ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "ସୃଜନଶୀଳତା, ଭାବପ୍ରବଣତା ଏବଂ ଆଭ୍ୟନ୍ତରୀଣ ପ୍ରବାହ ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "Your confidence and willpower energy appears strong in this chart.": "ଏହି ଚାର୍ଟରେ ତୁମର ଆତ୍ମବିଶ୍ୱାସ ଏବଂ ଇଚ୍ଛାଶକ୍ତି ଶକ୍ତି ଦୃ strong ଦେଖାଯାଏ |",
    "Your action-taking energy appears balanced in this chart.": "ତୁମର କ୍ରିୟାଶୀଳ ଶକ୍ତି ଏହି ଚାର୍ଟରେ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on confidence, discipline, and decision power may be useful.": "ଆତ୍ମବିଶ୍ୱାସ, ଅନୁଶାସନ ଏବଂ ନିଷ୍ପତ୍ତି ଶକ୍ତି ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "Your connection and compassion energy appears strong in this chart.": "ଏହି ସଂଯୋଗରେ ତୁମର ସଂଯୋଗ ଏବଂ କରୁଣା ଶକ୍ତି ଦୃ strong ଦେଖାଯାଏ |",
    "Your emotional connection energy appears balanced in this chart.": "ତୁମର ଭାବପ୍ରବଣ ସଂଯୋଗ ଶକ୍ତି ଏହି ଚାର୍ଟରେ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "ସମନ୍ୱୟ, କ୍ଷମା ଏବଂ ଭାବପ୍ରବଣତା ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "Your communication and expression energy appears strong in this chart.": "ଏହି ଯୋଗାଯୋଗରେ ଆପଣଙ୍କର ଯୋଗାଯୋଗ ଏବଂ ଅଭିବ୍ୟକ୍ତି ଶକ୍ତି ଦୃ strong ଦେଖାଯାଏ |",
    "Your expression energy appears balanced in this chart.": "ତୁମର ଅଭିବ୍ୟକ୍ତି ଶକ୍ତି ଏହି ଚାର୍ଟରେ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on clear communication and self-expression may be useful.": "ସ୍ୱଚ୍ଛ ଯୋଗାଯୋଗ ଏବଂ ଆତ୍ମ-ଅଭିବ୍ୟକ୍ତି ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "Your intuition and inner clarity appears strong in this chart.": "ଏହି ଚାର୍ଟରେ ତୁମର ଅନ୍ତର୍ନିହିତତା ଏବଂ ଭିତରର ସ୍ୱଚ୍ଛତା ଦୃ strong ଦେଖାଯାଏ |",
    "Your intuitive clarity appears balanced in this chart.": "ଏହି ଅନ୍ତର୍ନିହିତ ସ୍ୱଚ୍ଛତା ଏହି ଚାର୍ଟରେ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on focus, intuition, and inner guidance may be useful.": "ଧ୍ୟାନ, ଆନ୍ତରିକତା ଏବଂ ଆଭ୍ୟନ୍ତରୀଣ ମାର୍ଗଦର୍ଶନ ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "A strong Fire element supports action, courage, and leadership energy.": "ଏକ ଶକ୍ତିଶାଳୀ ଅଗ୍ନି ଉପାଦାନ କାର୍ଯ୍ୟ, ସାହସ ଏବଂ ନେତୃତ୍ୱ ଶକ୍ତିକୁ ସମର୍ଥନ କରେ |",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "କାର୍ଯ୍ୟ ସନ୍ତୁଳିତ ଦେଖାଯାଏ, କାର୍ଯ୍ୟ ଏବଂ ଧ patience ର୍ଯ୍ୟ ମଧ୍ୟରେ ଏକ ସ୍ଥିର ଗୀତକୁ ସମର୍ଥନ କରେ |",
    "Reflection on confidence and action-taking may be useful.": "ଆତ୍ମବିଶ୍ୱାସ ଏବଂ କାର୍ଯ୍ୟାନୁଷ୍ଠାନ ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "A strong Earth element supports practicality, patience, and stability.": "ଏକ ଶକ୍ତିଶାଳୀ ପୃଥିବୀ ଉପାଦାନ ବ୍ୟବହାରିକତା, ଧ patience ର୍ଯ୍ୟ ଏବଂ ସ୍ଥିରତାକୁ ସମର୍ଥନ କରେ |",
    "Earth appears balanced, supporting practical thinking with flexibility.": "ନମନୀୟତା ସହିତ ବ୍ୟବହାରିକ ଚିନ୍ତାଧାରାକୁ ସମର୍ଥନ କରି ପୃଥିବୀ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on grounding, consistency, and planning may be useful.": "ଗ୍ରାଉଣ୍ଡିଂ, ସ୍ଥିରତା, ଏବଂ ଯୋଜନା ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "A strong Air element supports ideas, communication, and adaptability.": "ଏକ ଶକ୍ତିଶାଳୀ ବାୟୁ ଉପାଦାନ ଧାରଣା, ଯୋଗାଯୋଗ ଏବଂ ଅନୁକୂଳତାକୁ ସମର୍ଥନ କରେ |",
    "Air appears balanced, supporting harmony between thinking and action.": "ଚିନ୍ତା ଏବଂ କାର୍ଯ୍ୟ ମଧ୍ୟରେ ସମନ୍ୱୟକୁ ସମର୍ଥନ କରି ବାୟୁ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on communication and flexibility may be useful.": "ଯୋଗାଯୋଗ ଏବଂ ନମନୀୟତା ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "ଏକ ଶକ୍ତିଶାଳୀ ଜଳ ଉପାଦାନ ଅନ୍ତ u କରଣ, ସମ୍ବେଦନଶୀଳତା ଏବଂ ଭାବପ୍ରବଣତାକୁ ସମର୍ଥନ କରେ |",
    "Water appears balanced, supporting harmony between emotions and logic.": "ଭାବନା ଏବଂ ତର୍କ ମଧ୍ୟରେ ସମନ୍ୱୟକୁ ସମର୍ଥନ କରି ଜଳ ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection on emotional expression and inner connection may be useful.": "ଭାବପ୍ରବଣ ଅଭିବ୍ୟକ୍ତି ଏବଂ ଭିତର ସଂଯୋଗ ଉପରେ ପ୍ରତିଫଳନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "A strong Ether element supports spiritual awareness and broader vision.": "ଏକ ଶକ୍ତିଶାଳୀ ଇଥର ଉପାଦାନ ଆଧ୍ୟାତ୍ମିକ ସଚେତନତା ଏବଂ ବ୍ୟାପକ ଦର୍ଶନକୁ ସମର୍ଥନ କରେ |",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ଆଧ୍ୟାତ୍ମିକ ଏବଂ ବ୍ୟବହାରିକ ଆଭିମୁଖ୍ୟ ମଧ୍ୟରେ ସମନ୍ୱୟକୁ ସମର୍ଥନ କରି ଇଥର ସନ୍ତୁଳିତ ଦେଖାଯାଏ |",
    "Reflection, silence, and spiritual discipline may be useful.": "ପ୍ରତିଫଳନ, ନୀରବତା ଏବଂ ଆଧ୍ୟାତ୍ମିକ ଅନୁଶାସନ ଉପଯୋଗୀ ହୋଇପାରେ |",
    "For inner confidence, clarity, and soul strength.": "ଆଭ୍ୟନ୍ତରୀଣ ଆତ୍ମବିଶ୍ୱାସ, ସ୍ୱଚ୍ଛତା ଏବଂ ଆତ୍ମା ​​ଶକ୍ତି ପାଇଁ |",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "ଏହି ଇସ୍ତା ଦେବତା ସୂଚକ ଗ୍ରହ ଶକ୍ତି, ଲଗନା ପ୍ରଭୁ, ଚନ୍ଦ୍ର ଚିହ୍ନ ପ୍ରଭୁ ଏବଂ ଜନ୍ମ ଚାର୍ଟରୁ ଆଟମାକାରା ଉପରେ ଆଧାରିତ |",
    "For calmness, emotional balance, and softness.": "ଶାନ୍ତତା, ଭାବପ୍ରବଣତା ଏବଂ କୋମଳତା ପାଇଁ |",
    "For courage, protection, and discipline.": "ସାହସ, ସୁରକ୍ଷା ଏବଂ ଅନୁଶାସନ ପାଇଁ |",
    "For intellect, speech, learning, and obstacle removal.": "ବୁଦ୍ଧି, ବକ୍ତବ୍ୟ, ଶିକ୍ଷା, ଏବଂ ପ୍ରତିବନ୍ଧକ ଅପସାରଣ ପାଇଁ |",
    "For knowledge, guidance, dharma, and blessings.": "ଜ୍ଞାନ, ମାର୍ଗଦର୍ଶନ, ଧର୍ମ ଏବଂ ଆଶୀର୍ବାଦ ପାଇଁ |",
    "Mahalakshmi Ji": "ମହାଲକ୍ଷ୍ମୀ ଜୀ",
    "For harmony, beauty, comfort, and prosperity.": "ସମନ୍ୱୟ, ସ beauty ନ୍ଦର୍ଯ୍ୟ, ଆରାମ ଏବଂ ସମୃଦ୍ଧତା ପାଇଁ |",
    "For karma, patience, discipline, and protection.": "କର୍ମ, ଧ patience ର୍ଯ୍ୟ, ଅନୁଶାସନ ଏବଂ ସୁରକ୍ଷା ପାଇଁ |",
    "For protection from confusion, fear, and illusion.": "ଦ୍ୱନ୍ଦ୍ୱ, ଭୟ ଏବଂ ଭ୍ରମରୁ ସୁରକ୍ଷା ପାଇଁ |",
    "Lord Ganesha": "ଭଗବାନ ଗଣେଶ",
    "For spiritual clarity, detachment, and obstacle removal.": "ଆଧ୍ୟାତ୍ମିକ ସ୍ୱଚ୍ଛତା, ବିଚ୍ଛିନ୍ନତା ଏବଂ ପ୍ରତିବନ୍ଧକ ହଟାଇବା ପାଇଁ |",
    "& .MuiLinearProgress-bar": "& .MuiLinearPresent-bar",
    "Chart data is required for Chakra insight.": "ଚକ୍ର ଜ୍ଞାନ ପାଇଁ ଚାର୍ଟ ତଥ୍ୟ ଆବଶ୍ୟକ |",
    "Unable to load Chakra insight.": "ଚକ୍ର ଅନ୍ତର୍ନିହିତ ଲୋଡ୍ କରିବାକୁ ଅସମର୍ଥ |",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "Insight केवल जन्म आध्यात्मिक आध्यात्मिक insight ଶକ୍ତି ଜ୍ଞାନ और ଆତ୍ମ-ପ୍ରତିଫଳନ है | यह ବୃତ୍ତିଗତ ପରାମର୍ଶ नहीं है।",
    "Spiritual energy insights from Kundli": "କୁଣ୍ଡଲିରୁ ଆଧ୍ୟାତ୍ମିକ ଶକ୍ତି ଜ୍ଞାନ |",
    "Calculated from your individual birth chart": "ତୁମର ବ୍ୟକ୍ତିଗତ ଜନ୍ମ ଚାର୍ଟରୁ ଗଣନା କରାଯାଇଛି |",
    "Chakra Balance": "ଚକ୍ର ସନ୍ତୁଳନ |",
    "Panch Tatva Balance": "ପଞ୍ଚ ଟାଟଭା ବାଲାନ୍ସ |",
    "Ishta Devata": "ଇସ୍ତା ଦେବତା",
    "Signal planet": "ସଙ୍କେତ ଗ୍ରହ |",
    "Very Good": "ବହୁତ ଭଲ",
    "Very Bad": "ବହୁତ ଖରାପ |",
    "Panch Pakshi Calculator - Kundlistar": "ପଞ୍ଚ ପାକ୍ସି କାଲକୁଲେଟର - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "ଚାର୍ଟରୁ ପଞ୍ଚ ପାକ୍ସି ପ୍ରିଫିଲ୍ କରିପାରିଲା ନାହିଁ | ଆପଣ ତଥାପି ମାନୁଆଲ ହିସାବ କରିପାରିବେ |",
    "Could not load sunrise and sunset from Panchang for this chart location.": "ଏହି ଚାର୍ଟ ଅବସ୍ଥାନ ପାଇଁ ପଞ୍ଚାଙ୍ଗରୁ ସୂର୍ଯ୍ୟୋଦୟ ଏବଂ ସୂର୍ଯ୍ୟାସ୍ତ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ |",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "ପଞ୍ଚଙ୍ଗରୁ ସୂର୍ଯ୍ୟୋଦୟ, ସୂର୍ଯ୍ୟାସ୍ତ ଏବଂ ପରବର୍ତ୍ତୀ ସୂର୍ଯ୍ୟୋଦୟ ଲୋଡ୍ କରିବାରେ ଅସମର୍ଥ |",
    "Panch Pakshi calculation failed.": "ପଞ୍ଚ ପାକ୍ସି ଗଣନା ବିଫଳ ହେଲା |",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "ପଞ୍ଚ ପାକ୍ସି ପକ୍ଷୀ, କାର୍ଯ୍ୟକଳାପ, ୟାମାମ, ଆପାହରା ଅବଧି, ସମ୍ପର୍କ, ସ୍କୋର ଏବଂ ଫଳାଫଳ ଗଣନା କରନ୍ତୁ |",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "ତୁମର ମାଗଣା ପ୍ରିମିୟମ୍ କ୍ରେଡିଟ୍ ସମାପ୍ତ ହୋଇଛି | ଜାରି ରଖିବାକୁ ପ୍ରିମିୟମକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "This is a premium feature. You can use 1 free premium credit to continue.": "ଏହା ଏକ ପ୍ରିମିୟମ୍ ବ feature ଶିଷ୍ଟ୍ୟ | ଜାରି ରଖିବାକୁ ଆପଣ 1 ମାଗଣା ପ୍ରିମିୟମ୍ କ୍ରେଡିଟ୍ ବ୍ୟବହାର କରିପାରିବେ |",
    "Selected Date": "ମନୋନୀତ ତାରିଖ |",
    "repeat(3, 1fr)": "ପୁନରାବୃତ୍ତି (3, 1fr)",
    "Birth Paksha": "ଜନ୍ମ ପାକ୍",
    "Current Paksha": "ସାମ୍ପ୍ରତିକ ପାକ୍",
    "repeat(4, 1fr)": "ପୁନରାବୃତ୍ତି (4, 1fr)",
    "Target Date Time": "ଲକ୍ଷ୍ୟ ତାରିଖ ସମୟ |",
    "Next Sunrise": "ପରବର୍ତ୍ତୀ ସୂର୍ଯ୍ୟୋଦୟ |",
    "Calculate Panch Pakshi": "ପଞ୍ଚ ପାକ୍ସି ଗଣନା କରନ୍ତୁ |",
    "repeat(2, 1fr)": "ପୁନରାବୃତ୍ତି (2, 1fr)",
    "repeat(6, 1fr)": "ପୁନରାବୃତ୍ତି (6, 1fr)",
    "Birth Pakshi": "ଜନ୍ମ ପାକ୍ସି |",
    "Current Period": "ସାମ୍ପ୍ରତିକ ଅବଧି",
    "Current Yamam": "ସାମ୍ପ୍ରତିକ ୟାମାମ |",
    "Main Activity": "ମୁଖ୍ୟ କାର୍ଯ୍ୟକଳାପ",
    "Natal Western Chart": "ନାଟାଲ୍ ୱେଷ୍ଟର୍ଣ୍ଣ ଚାର୍ଟ |",
    "Life Phase Progression": "ଜୀବନ ଚରଣ ପ୍ରଗତି |",
    "Self-focus, identity change, body awareness and personal reset.": "ଆତ୍ମ-ଧ୍ୟାନ, ପରିଚୟ ପରିବର୍ତ୍ତନ, ଶରୀର ସଚେତନତା ଏବଂ ବ୍ୟକ୍ତିଗତ ପୁନ et ସେଟ୍ |",
    "Money, values, family, speech and security become emotionally important.": "ଅର୍ଥ, ମୂଲ୍ୟବୋଧ, ପରିବାର, ବକ୍ତବ୍ୟ ଏବଂ ସୁରକ୍ଷା ଭାବପ୍ରବଣ ହୋଇଯାଏ |",
    "Communication, learning, siblings, writing and short travel become important.": "ଯୋଗାଯୋଗ, ଶିକ୍ଷା, ଭାଇଭଉଣୀ, ଲେଖା ଏବଂ ସ୍ୱଳ୍ପ ଯାତ୍ରା ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Home, mother, property, family and emotional roots become important.": "ଘର, ମା, ସମ୍ପତ୍ତି, ପରିବାର ଏବଂ ଭାବପ୍ରବଣ ମୂଳ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Creativity, romance, children, hobbies and self-expression become important.": "ସୃଜନଶୀଳତା, ରୋମାନ୍ସ, ପିଲା, ଶବ୍ଦ ଏବଂ ଆତ୍ମ-ଅଭିବ୍ୟକ୍ତି ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Work routine, health habits, service and discipline become important.": "କାର୍ଯ୍ୟ ନିତ୍ୟକର୍ମ, ସ୍ୱାସ୍ଥ୍ୟ ଅଭ୍ୟାସ, ସେବା ଏବଂ ଅନୁଶାସନ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Relationship, marriage, partnership and public dealing become important.": "ସମ୍ପର୍କ, ବିବାହ, ସହଭାଗୀତା ଏବଂ ସର୍ବସାଧାରଣ କାରବାର ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Deep emotional change, intimacy, shared money and transformation become important.": "ଗଭୀର ଭାବନାତ୍ମକ ପରିବର୍ତ୍ତନ, ଅନ୍ତରଙ୍ଗତା, ଅଂଶୀଦାର ଅର୍ଥ ଏବଂ ପରିବର୍ତ୍ତନ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Learning, travel, teaching, belief and higher wisdom become important.": "ଶିକ୍ଷା, ଭ୍ରମଣ, ଶିକ୍ଷାଦାନ, ବିଶ୍ୱାସ ଏବଂ ଉଚ୍ଚ ଜ୍ଞାନ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Career, status, public image and responsibility become emotionally important.": "ବୃତ୍ତି, ସ୍ଥିତି, ସର୍ବସାଧାରଣ ଭାବମୂର୍ତ୍ତି ଏବଂ ଦାୟିତ୍ em ଭାବଗତ ଭାବରେ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Income, friends, networking, community and ambitions become important.": "ଆୟ, ବନ୍ଧୁ, ନେଟୱାର୍କିଂ, ସମ୍ପ୍ରଦାୟ ଏବଂ ଅଭିଳାଷ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "ବିଶ୍ରାମ, ବିଚ୍ଛିନ୍ନତା, ଆଧ୍ୟାତ୍ମିକତା, ବିଦେଶୀ ସଂଯୋଗ ଏବଂ ଆଭ୍ୟନ୍ତରୀଣ ଆରୋଗ୍ୟ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Identity development and self-expression are central.": "ପରିଚୟ ବିକାଶ ଏବଂ ଆତ୍ମ-ଅଭିବ୍ୟକ୍ତି କେନ୍ଦ୍ରୀୟ ଅଟେ |",
    "Values, money and self-worth become central.": "ମୂଲ୍ୟ, ଅର୍ଥ ଏବଂ ଆତ୍ମ-ମୂଲ୍ୟ କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Communication, learning and skills become central.": "ଯୋଗାଯୋଗ, ଶିକ୍ଷା ଏବଂ ଦକ୍ଷତା କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Home, roots and emotional foundation become central.": "ଘର, ମୂଳ ଏବଂ ଭାବପ୍ରବଣ ଭିତ୍ତିଭୂମି କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Creativity, love and self-expression become central.": "ସୃଜନଶୀଳତା, ପ୍ରେମ ଏବଂ ଆତ୍ମ-ଅଭିବ୍ୟକ୍ତି କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Work, discipline and health routines become central.": "କାର୍ଯ୍ୟ, ଅନୁଶାସନ ଏବଂ ସ୍ୱାସ୍ଥ୍ୟ ନିତ୍ୟକର୍ମ କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Partnerships and relationship identity become central.": "ସହଭାଗୀତା ଏବଂ ସମ୍ପର୍କ ପରିଚୟ କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Transformation, deep healing and shared resources become central.": "ପରିବର୍ତ୍ତନ, ଗଭୀର ଆରୋଗ୍ୟ ଏବଂ ଅଂଶୀଦାର ଉତ୍ସଗୁଡ଼ିକ କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Wisdom, travel, belief and higher learning become central.": "ଜ୍ଞାନ, ଭ୍ରମଣ, ବିଶ୍ୱାସ ଏବଂ ଉଚ୍ଚଶିକ୍ଷା କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Career, authority and public role become central.": "ବୃତ୍ତି, ପ୍ରାଧିକରଣ ଏବଂ ଜନସାଧାରଣ ଭୂମିକା କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Community, income, goals and networks become central.": "ସମ୍ପ୍ରଦାୟ, ଆୟ, ଲକ୍ଷ୍ୟ ଏବଂ ନେଟୱାର୍କଗୁଡ଼ିକ କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Spirituality, closure, retreat and inner development become central.": "ଆଧ୍ୟାତ୍ମିକତା, ବନ୍ଦ, ପଂଚାୟତ ଏବଂ ଆଭ୍ୟନ୍ତରୀଣ ବିକାଶ କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "This house becomes emotionally important.": "ଏହି ଘର ଭାବପ୍ରବଣ ହୋଇଯାଏ |",
    "This house becomes central for identity development.": "ପରିଚୟ ବିକାଶ ପାଇଁ ଏହି ଘର କେନ୍ଦ୍ରୀୟ ହୋଇଯାଏ |",
    "Thinking, communication, learning and decisions are developing through this house.": "ଚିନ୍ତା, ଯୋଗାଯୋଗ, ଶିକ୍ଷା ଏବଂ ନିଷ୍ପତ୍ତି ଏହି ଘର ମାଧ୍ୟମରେ ବିକାଶ ହେଉଛି |",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "ପ୍ରେମ, ଆରାମ, ମୂଲ୍ୟବୋଧ, ସ beauty ନ୍ଦର୍ଯ୍ୟ ଏବଂ ଅର୍ଥ ପସନ୍ଦ ଏହି ଘର ମାଧ୍ୟମରେ ବିକାଶ ହେଉଛି |",
    "Action style, courage, ambition and drive are developing through this house.": "ଏହି ଘର ମାଧ୍ୟମରେ କାର୍ଯ୍ୟ ଶ style ଳୀ, ସାହସ, ଅଭିଳାଷ ଏବଂ ଡ୍ରାଇଭ୍ ବିକାଶ ହେଉଛି |",
    "Growth, faith, learning and expansion themes develop through this house.": "ଅଭିବୃଦ୍ଧି, ବିଶ୍ୱାସ, ଶିକ୍ଷା ଏବଂ ବିସ୍ତାର ଥିମ୍ ଏହି ଘର ମାଧ୍ୟମରେ ବିକଶିତ ହୁଏ |",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "ପରିପକ୍ୱତା, ଦାୟିତ୍ ,, ଶୃଙ୍ଖଳା ଏବଂ ଦୀର୍ଘକାଳୀନ ଗଠନ ଏହି ଘର ମାଧ୍ୟମରେ ବିକଶିତ ହୁଏ |",
    "This progressed planet shows an inner life phase through this house.": "ଏହି ପ୍ରଗତିଶୀଳ ଗ୍ରହ ଏହି ଘର ମାଧ୍ୟମରେ ଏକ ଆଭ୍ୟନ୍ତରୀଣ ଜୀବନ ପର୍ଯ୍ୟାୟ ଦେଖାଏ |",
    "New Moon Phase": "ଅମାବାସ୍ୟା ଚରଣ |",
    "New beginning, identity reset and fresh internal cycle.": "ନୂତନ ଆରମ୍ଭ, ପରିଚୟ ପୁନ et ସେଟ୍ ଏବଂ ତାଜା ଆଭ୍ୟନ୍ତରୀଣ ଚକ୍ର |",
    "Crescent Phase": "କ୍ରେସେଣ୍ଟ୍ ଚରଣ |",
    "Growth, effort, learning and building confidence.": "ଅଭିବୃଦ୍ଧି, ପ୍ରୟାସ, ଶିକ୍ଷା ଏବଂ ଆତ୍ମବିଶ୍ୱାସ ବ building ାଇବା |",
    "First Quarter Phase": "ପ୍ରଥମ ତ୍ର ar ମାସିକ ପର୍ଯ୍ୟାୟ |",
    "Action, decision-making, pressure and development.": "କାର୍ଯ୍ୟ, ନିଷ୍ପତ୍ତି ନେବା, ଚାପ ଏବଂ ବିକାଶ |",
    "Gibbous Phase": "ଗିବସ୍ ଚରଣ |",
    "Refinement, improvement, preparation and skill-building.": "ପରିଶୋଧନ, ଉନ୍ନତି, ପ୍ରସ୍ତୁତି ଏବଂ ଦକ୍ଷତା ବିକାଶ |",
    "Full Moon Phase": "ପୂର୍ଣ୍ଣଚନ୍ଦ୍ର ଚରଣ |",
    "Visibility, relationship awareness, emotional clarity and results.": "ଦୃଶ୍ୟମାନତା, ସମ୍ପର୍କ ସଚେତନତା, ଭାବପ୍ରବଣତା ଏବଂ ଫଳାଫଳ |",
    "Disseminating Phase": "ପର୍ଯ୍ୟାୟ ବିସ୍ତାର",
    "Sharing, teaching, communication and distributing experience.": "ଅଭିଜ୍ଞତା ବାଣ୍ଟିବା, ଶିକ୍ଷାଦାନ, ଯୋଗାଯୋଗ ଏବଂ ବଣ୍ଟନ ଅଭିଜ୍ଞତା |",
    "Last Quarter Phase": "ଶେଷ ତ୍ର ar ମାସିକ ପର୍ଯ୍ୟାୟ |",
    "Reorientation, correction, release and mature decision-making.": "ପୁନ ori ପରିବର୍ତ୍ତନ, ସଂଶୋଧନ, ମୁକ୍ତି ଏବଂ ପରିପକ୍ୱ ନିଷ୍ପତ୍ତି ନେବା |",
    "Balsamic Phase": "ବାଲସାମିକ୍ ଚରଣ |",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "ବନ୍ଦ, ଆଧ୍ୟାତ୍ମିକ ପ୍ରତିଫଳନ, ବିଶ୍ରାମ ଏବଂ ଏକ ନୂତନ ଚକ୍ର ପାଇଁ ପ୍ରସ୍ତୁତି |",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "ଏକ ପ୍ରମୁଖ ଭାବପ୍ରବଣତା ଏବଂ ପରିଚୟ ପର୍ଯ୍ୟାୟ ଆରମ୍ଭ | ବ୍ୟକ୍ତି ଏକ ନୂତନ ଅଧ୍ୟାୟ ପାଇଁ ପ୍ରସ୍ତୁତ ଅନୁଭବ କରିପାରନ୍ତି |",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "ଭାବପ୍ରବଣ ପୁନ et ସେଟ୍ ଅବଧି | ପରିବାର, ଆରାମ, ଆଭ୍ୟନ୍ତରୀଣ ଶାନ୍ତି ଏବଂ ଭାବପ୍ରବଣତା ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "ପ୍ରେମ, ସମ୍ପର୍କ, ଆରାମ, ସ beauty ନ୍ଦର୍ଯ୍ୟ ଏବଂ ଭାବପ୍ରବଣତା ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "Emotional needs and relationship expectations may need adjustment.": "ଭାବପ୍ରବଣ ଆବଶ୍ୟକତା ଏବଂ ସମ୍ପର୍କ ଆଶା ସଂଶୋଧନ ଆବଶ୍ୟକ କରିପାରନ୍ତି |",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "ଶକ୍ତି, ଉତ୍ସାହ, ଧ ati ର୍ଯ୍ୟହୀନତା ଏବଂ କାର୍ଯ୍ୟ ବୃଦ୍ଧି | ଭାବପ୍ରବଣ ପ୍ରତିକ୍ରିୟା ଶୀଘ୍ର ହୋଇପାରେ |",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "ଭାବପ୍ରବଣ ଅସ୍ଥିରତା, କ୍ରୋଧ, ଦ୍ୱନ୍ଦ୍ୱ କିମ୍ବା ଜରୁରୀ କାର୍ଯ୍ୟ ବ increase ିପାରେ |",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "ଏକ ଗମ୍ଭୀର ଭାବପ୍ରବଣ ପର୍ଯ୍ୟାୟ | ଦାୟିତ୍ୱବୋଧ, ପରିପକ୍ୱତା, ପାରିବାରିକ ଚାପ କିମ୍ବା ଭିତରର ଅନୁଶାସନ ବୃଦ୍ଧି ପାଇପାରେ |",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "ଭାବପ୍ରବଣତା କିମ୍ବା ଦାୟିତ୍ felt ଅନୁଭବ କରାଯାଇପାରେ | ଧ ati ର୍ଯ୍ୟ ଏବଂ ପରିପକ୍ୱତା ଆବଶ୍ୟକ |",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "ସହାୟକ ଭାବନାତ୍ମକ ଅଭିବୃଦ୍ଧି, ଆଶାବାଦୀ, ଯାତ୍ରା, ଶିକ୍ଷା ଏବଂ ଆଶୀର୍ବାଦ ବୃଦ୍ଧି ପାଇପାରେ |",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "ଏକ ଅଭିବୃଦ୍ଧି ଭିତ୍ତିକ ଭାବପ୍ରବଣ ପର୍ଯ୍ୟାୟ | ଶିକ୍ଷା, ବିସ୍ତାର, ସମର୍ଥନ ଏବଂ ସକରାତ୍ମକ ନିଷ୍ପତ୍ତି ପାଇଁ ଭଲ |",
    "Identity, love, beauty, money values and creative expression become highlighted.": "ପରିଚୟ, ପ୍ରେମ, ସ beauty ନ୍ଦର୍ଯ୍ୟ, ଅର୍ଥ ମୂଲ୍ୟ ଏବଂ ସୃଜନଶୀଳ ଅଭିବ୍ୟକ୍ତି ହାଇଲାଇଟ୍ ହୋଇଯାଏ |",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "ଆତ୍ମବିଶ୍ୱାସ, ସାହସ, ଅଭିଳାଷ ଏବଂ କାର୍ଯ୍ୟ ବୃଦ୍ଧି ହୁଏ | ଏକ ନୂତନ ସକ୍ରିୟ ପର୍ଯ୍ୟାୟ ଆରମ୍ଭ କରିବା ପାଇଁ ଭଲ |",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "ଏକ ପରିପକ୍ୱତା ପରୀକ୍ଷା | ଦାୟିତ୍ ibility, ବିଳମ୍ବ, ଚାପ କିମ୍ବା କ୍ୟାରିୟର ପୁନର୍ଗଠନ ହୋଇପାରେ |",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "ଅଭିବୃଦ୍ଧି, ଆତ୍ମବିଶ୍ୱାସ, ଜ୍ଞାନ, ସ୍ୱୀକୃତି ଏବଂ ସୁଯୋଗ ବୃଦ୍ଧି ପାଇପାରେ |",
    "Mental clarity, communication, study, writing and business decisions become important.": "ମାନସିକ ସ୍ୱଚ୍ଛତା, ଯୋଗାଯୋଗ, ଅଧ୍ୟୟନ, ଲେଖା ଏବଂ ବ୍ୟବସାୟିକ ନିଷ୍ପତ୍ତି ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ହୋଇଯାଏ |",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "ଏକ ନୂତନ ମାନସିକ ଚକ୍ର ଆରମ୍ଭ ହୁଏ | ଶିକ୍ଷା, ଯୋଗାଯୋଗ, ଲେଖା ଏବଂ ଦକ୍ଷତା ବିକାଶ ପାଇଁ ଭଲ |",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "ପ୍ରେମ, ସ beauty ନ୍ଦର୍ଯ୍ୟ, ଆରାମ, ସାମାଜିକ ଜୀବନ ଏବଂ ମୂଲ୍ୟବୋଧ ପରିଚୟ ସହିତ ଦୃ strongly ଭାବରେ ସଂଯୁକ୍ତ ହୋଇଯାଏ |",
    "Action, confidence, ambition and personal drive become stronger.": "କାର୍ଯ୍ୟ, ଆତ୍ମବିଶ୍ୱାସ, ଅଭିଳାଷ ଏବଂ ବ୍ୟକ୍ତିଗତ ଡ୍ରାଇଭ୍ ଅଧିକ ଶକ୍ତିଶାଳୀ ହୁଏ |",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "ପ୍ରଗତିଶୀଳ ବୁଧ ଶିକ୍ଷା, ଯୋଗାଯୋଗ, ବ୍ୟବସାୟ, ଲେଖା, ମାର୍କେଟିଂ, କୋଡିଂ କିମ୍ବା ଆନାଲିଟିକାଲ୍ କାର୍ଯ୍ୟକୁ ସମର୍ଥନ କରେ |",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "ପ୍ରଗତିଶୀଳ ମଙ୍ଗଳ କାର୍ଯ୍ୟ, ସାହସ, ପ୍ରତିଯୋଗିତା, ବ technical ଷୟିକ କାର୍ଯ୍ୟ ଏବଂ ସକ୍ରିୟ କ୍ୟାରିୟର ନିଷ୍ପତ୍ତିକୁ ସମର୍ଥନ କରେ |",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "ପ୍ରଗତିଶୀଳ ଶୁକ୍ର ଆର୍ଥିକ ମୂଲ୍ୟ, ଆରାମ, ଲାଭ, ବିଳାସ, କଳା କିମ୍ବା ସମ୍ପର୍କ ଭିତ୍ତିକ ଆୟ ଥିମକୁ ସମର୍ଥନ କରେ |",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "ପ୍ରଗତିଶୀଳ ବୃହସ୍ପତି ଅଭିବୃଦ୍ଧି ଭିତ୍ତିକ ଆର୍ଥିକ ଚିନ୍ତାଧାରା ଏବଂ ଉତ୍ସଗୁଡ଼ିକର ବିସ୍ତାର ଦେଖାଇପାରେ |",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "କ୍ୟାରିୟର ପର୍ଯ୍ୟାୟ ପ୍ରଗତିଶୀଳ ସୂର୍ଯ୍ୟ, ଚନ୍ଦ୍ର, ବୁଧ, ମଙ୍ଗଳ ଏବଂ ଦିଗରୁ ସୂର୍ଯ୍ୟ, ଶନି ଏବଂ ମଧ୍ୟଭାଗ ପର୍ଯ୍ୟନ୍ତ ବିଚାର କରାଯିବା ଉଚିତ୍ |",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "ପ୍ରଗତି ଚନ୍ଦ୍ର, ଶୁକ୍ର, ମଙ୍ଗଳ ଏବଂ ପ୍ରକୃତି ଚନ୍ଦ୍ର, ଶୁକ୍ର, ମଙ୍ଗଳ ଏବଂ ସପ୍ତମ ଘର ପର୍ଯ୍ୟନ୍ତ ପ୍ରେମ ପର୍ଯ୍ୟାୟ ବିଚାର କରାଯିବା ଉଚିତ୍ |",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "ପ୍ରଗତିଶୀଳ ଚନ୍ଦ୍ର, ଶୁକ୍ର, ବୃହସ୍ପତି ଏବଂ ନାଟାଲ୍ ୨ୟ, ଅଷ୍ଟମ ଏବଂ ଏକାଦଶ ଘର ସଂଯୋଗରୁ ଅର୍ଥ ପର୍ଯ୍ୟାୟ ବିଚାର କରାଯିବା ଉଚିତ୍ |",
    "Western Astrology - Kundlistar": "ପାଶ୍ଚାତ୍ୟ ଜ୍ୟୋତିଷ ଶାସ୍ତ୍ର - Kundlistar",
    "No chart data available for preview": "ପୂର୍ବାବଲୋକନ ପାଇଁ କ chart ଣସି ଚାର୍ଟ ତଥ୍ୟ ଉପଲବ୍ଧ ନାହିଁ |",
    "Failed to load chart": "ଚାର୍ଟ ଲୋଡ୍ କରିବାରେ ବିଫଳ |",
    "Chart not found": "ଚାର୍ଟ ମିଳିଲା ନାହିଁ |",
    "Western Astrology Module | Kundlistar": "ପାଶ୍ଚାତ୍ୟ ଜ୍ୟୋତିଷ ଶାସ୍ତ୍ର | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "ନାଟାଲ୍ ଚାର୍ଟ ପୋଜିସନ୍, ପ୍ଲାସିଡସ୍ ହାଉସ୍ କସପ୍ସ, ବାହ୍ୟ ଗ୍ରହ ଏବଂ ପ୍ରିମିୟମ୍ ଟ୍ରାଞ୍ଜିଟ୍, ସୋଲାର ରିଟର୍ନ ଏବଂ ସାଇନାଷ୍ଟ୍ରି ବ features ଶିଷ୍ଟ୍ୟ ସହିତ Kundlistar ଭିତରେ ପାଶ୍ଚାତ୍ୟ ଜ୍ୟୋତିଷ ଶାସ୍ତ୍ର ଅନୁସନ୍ଧାନ କରନ୍ତୁ |",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "ପାଶ୍ଚାତ୍ୟ ଜ୍ୟୋତିଷ, ନାଟାଲ୍ ଚାର୍ଟ, ଗମନାଗମନ, ସ ar ର ରିଟର୍ନ, ସିନେଷ୍ଟ୍ରି, Kundlistar",
    "New section": "ନୂତନ ବିଭାଗ",
    "Premium active": "ପ୍ରିମିୟମ୍ ସକ୍ରିୟ |",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax (360px, 0.85fr) minmax (0, 1.15fr)",
    "House System": "ହାଉସ୍ ସିଷ୍ଟମ୍ |",
    "Placidus cusps": "ପ୍ଲାସିଡସ୍ କସପ୍ସ |",
    "Part of Fortune": "ଭାଗ୍ୟର ଏକ ଅଂଶ |",
    "Natal Western Aspects": "ନାଟାଲ୍ ପାଶ୍ଚାତ୍ୟ ଦିଗଗୁଡିକ |",
    "No major Western aspects found within the configured orbs.": "ବିନ୍ୟାସିତ ଅର୍ବସ୍ ମଧ୍ୟରେ କ Western ଣସି ପ୍ରମୁଖ ପାଶ୍ଚାତ୍ୟ ଦିଗ ମିଳିଲା ନାହିଁ |",
    "Western natal astrology wheel": "ପାଶ୍ଚାତ୍ୟ ନାଟାଲ୍ ଜ୍ୟୋତିଷ ଶାସ୍ତ୍ର |",
    "Western Transits": "ପାଶ୍ଚାତ୍ୟ ଗମନାଗମନ |",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "ଲୋଡ୍ ହୋଇଥିବା ଚାର୍ଟ ଜନ୍ମସ୍ଥାନ ବ୍ୟବହାର କରି ସାମ୍ପ୍ରତିକ ଗମନାଗମନ-ରୁ-ନାଟାଲ୍ ଗଣନା |",
    "Natal points available": "ନାଟାଲ୍ ପଏଣ୍ଟ ଉପଲବ୍ଧ |",
    "Transit planets loaded": "ଗମନାଗମନ ଗ୍ରହଗୁଡ଼ିକ ଲୋଡ୍ ହୋଇଛି |",
    "Loading current transit positions...": "ସାମ୍ପ୍ରତିକ ଗମନାଗମନ ସ୍ଥାନଗୁଡିକ ଲୋଡ୍ କରୁଛି ...",
    "Aspect method": "ଦୃଷ୍ଟିକୋଣ ପଦ୍ଧତି |",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "ପାଶ୍ଚାତ୍ୟ ଅର୍ବସ୍ ସହିତ ସଂଯୋଗ, ସେକ୍ସଟାଇଲ୍, ବର୍ଗ, ଟ୍ରାଇନ୍ ଏବଂ ବିରୋଧ |",
    "Primary focus": "ପ୍ରାଥମିକ ଧ୍ୟାନ |",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "ନାଟାଲ୍ ସୂର୍ଯ୍ୟ, ଚନ୍ଦ୍ର, ଆରୋହଣ, ଶୁକ୍ର, ମଙ୍ଗଳ, ବୃହସ୍ପତି, ଶନି ଏବଂ ବାହ୍ୟ ଗ୍ରହ ସହିତ ଗମନାଗମନ ସମ୍ପର୍କ |",
    "Natal inner wheel": "ନାଟାଲ୍ ଭିତର ଚକ |",
    "Transit outer wheel": "ଗମନାଗମନ ବାହ୍ୟ ଚକ |",
    "Current Transit Positions": "ସାମ୍ପ୍ରତିକ ଗମନାଗମନ ଅବସ୍ଥାନ |",
    "Transit positions are not available.": "ଗମନାଗମନ ସ୍ଥିତି ଉପଲବ୍ଧ ନାହିଁ |",
    "Current Transit Aspects to Natal Chart": "ନାଟାଲ୍ ଚାର୍ଟକୁ ସାମ୍ପ୍ରତିକ ଗମନାଗମନ ଦିଗ |",
    "Loading transit aspects...": "ଗମନାଗମନ ଦିଗଗୁଡିକ ଲୋଡ୍ କରୁଛି ...",
    "No major transit aspects found within the configured orbs.": "ବିନ୍ୟାସିତ ଅର୍ବସ୍ ମଧ୍ୟରେ କ major ଣସି ପ୍ରମୁଖ ଗମନାଗମନ ଦିଗ ମିଳିଲା ନାହିଁ |",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "ନାଟାଲ୍ ଦିଗ ପ୍ରସଙ୍ଗକୁ ସମର୍ଥନ କରି ନାଟାଲ୍ ସୂର୍ଯ୍ୟଙ୍କ ବାର୍ଷିକ ପାଶ୍ଚାତ୍ୟ ରିଟର୍ନ ରେଫରେନ୍ସ |",
    "Solar return date": "ସ olar ର ଫେରସ୍ତ ତାରିଖ |",
    "Calculation time": "ଗଣନା ସମୟ",
    "Birth date not available": "ଜନ୍ମ ତାରିଖ ଉପଲବ୍ଧ ନାହିଁ |",
    "Natal Sun": "ନାଟାଲ୍ ସୂର୍ଯ୍ୟ |",
    "Natal Sun house": "ନାଟାଲ୍ ସୂର୍ଯ୍ୟ ଘର |",
    "Return planets loaded": "ଲୋଡ୍ ହୋଇଥିବା ଗ୍ରହଗୁଡିକ ଫେରସ୍ତ କରନ୍ତୁ |",
    "Loading solar return chart...": "ସ ar ର ରିଟର୍ନ ଚାର୍ଟ ଲୋଡିଂ ...",
    "Annual focus": "ବାର୍ଷିକ ଧ୍ୟାନ |",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "ସ Sun ର ଥିମଗୁଡିକ ନାଟାଲ୍ ସୂର୍ଯ୍ୟ, ରିଟର୍ନ ଆସେଣ୍ଡାଣ୍ଟ ଏବଂ ବାର୍ଷିକ ରିଟର୍ନ ଚାର୍ଟରୁ ପ read ାଯାଏ |",
    "Solar Return Planet Positions": "ସ olar ର ରିଟର୍ନ ଗ୍ରହ ଅବସ୍ଥାନ |",
    "Loading solar return planets...": "ସ ar ର ରିଟର୍ନ ଗ୍ରହଗୁଡିକ ଲୋଡ୍ କରୁଛି ...",
    "Solar return positions are not available.": "ସୋଲାର ରିଟର୍ନ ପୋଜିସନ୍ ଉପଲବ୍ଧ ନାହିଁ |",
    "Solar Return House Cusps": "ସୋଲାର ରିଟର୍ନ ହାଉସ୍ କସପ୍ସ |",
    "Loading solar return cusps...": "ସ ar ର ରିଟର୍ନ କସପ୍ ଲୋଡ୍ କରୁଛି ...",
    "Solar return house cusps are not available.": "ସୋଲାର ରିଟର୍ନ ହାଉସ୍ କସପ୍ସ ଉପଲବ୍ଧ ନାହିଁ |",
    "Solar Return Aspects to Natal Chart": "ନାଟାଲ୍ ଚାର୍ଟକୁ ସ olar ର ଫେରସ୍ତ ଦିଗ |",
    "Loading solar return aspects...": "ସ ar ର ରିଟର୍ନ ଦିଗଗୁଡିକ ଲୋଡ୍ କରୁଛି ...",
    "No major solar return aspects found within the configured orbs.": "ବିନ୍ୟାସିତ ଅର୍ବସ୍ ମଧ୍ୟରେ କ major ଣସି ପ୍ରମୁଖ ସ ar ର ରିଟର୍ନ ଦିଗ ମିଳିଲା ନାହିଁ |",
    "Natal Sun Aspects for Solar Return Focus": "ସ olar ର ରିଟର୍ନ ଫୋକସ୍ ପାଇଁ ନାଟାଲ୍ ସୂର୍ଯ୍ୟ ଦିଗଗୁଡିକ |",
    "No major natal Sun aspects found within the configured orbs.": "ବିନ୍ୟାସିତ ଅର୍ବସ୍ ମଧ୍ୟରେ କ major ଣସି ପ୍ରମୁଖ ନାଟାଲ୍ ସୂର୍ଯ୍ୟ ଦିଗଗୁଡିକ ମିଳିଲା ନାହିଁ |",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "ଗ୍ରହ-ରୁ-ଗ୍ରହ ଦିଗ, କୋଣ ସମ୍ପର୍କ ଏବଂ ଘର ଓଭରଲେଜ୍ ବ୍ୟବହାର କରି ସମ୍ପର୍କ ଓଭର framework ାଞ୍ଚା |",
    "Loaded first chart": "ପ୍ରଥମ ଚାର୍ଟ ଲୋଡ୍ ହୋଇଛି |",
    "Second chart": "ଦ୍ୱିତୀୟ ଚାର୍ଟ |",
    "Select or load partner chart to calculate full synastry overlay": "ପୂର୍ଣ୍ଣ ସିନାଷ୍ଟ୍ରି ଓଭରଲେ ଗଣନା କରିବାକୁ ପାର୍ଟନର ଚାର୍ଟ ଚୟନ କିମ୍ବା ଲୋଡ୍ କରନ୍ତୁ |",
    "Major inter-chart aspects with tight orb priority": "କଠିନ ଅର୍ବ ପ୍ରାଥମିକତା ସହିତ ପ୍ରମୁଖ ଆନ୍ତ chart- ଚାର୍ଟ ଦିଗଗୁଡିକ |",
    "House overlay method": "ଘର ଆଚ୍ଛାଦନ ପଦ୍ଧତି |",
    "Partner planets are placed into the first chart houses after second chart is selected": "ଦ୍ୱିତୀୟ ଚାର୍ଟ ଚୟନ ହେବା ପରେ ସହଭାଗୀ ଗ୍ରହମାନଙ୍କୁ ପ୍ରଥମ ଚାର୍ଟ ହାଉସରେ ରଖାଯାଏ |",
    "Relationship Pattern Aspects from Loaded Chart": "ଲୋଡ୍ ଚାର୍ଟରୁ ସମ୍ପର୍କ ପାଟର୍ନ ଦିଗଗୁଡିକ |",
    "No major relationship-focused natal aspects found within the configured orbs.": "ବିନ୍ୟାସିତ ଅର୍ବସ୍ ମଧ୍ୟରେ କ major ଣସି ପ୍ରମୁଖ ସମ୍ପର୍କ-କେନ୍ଦ୍ରିତ ନାଟାଲ୍ ଦିଗଗୁଡିକ ମିଳିଲା ନାହିଁ |",
    "Understand your current inner life phase through Western Secondary Progressions.": "ପାଶ୍ଚାତ୍ୟ ଦ୍ Secondary ିତୀୟ ପ୍ରଗତି ମାଧ୍ୟମରେ ତୁମର ସାମ୍ପ୍ରତିକ ଆଭ୍ୟନ୍ତରୀଣ ଜୀବନ ପର୍ଯ୍ୟାୟକୁ ବୁ। |",
    "Secondary Progression": "ଦ୍ Secondary ିତୀୟ ପ୍ରଗତି |",
    "1 day after birth = 1 year of life": "ଜନ୍ମର 1 ଦିନ = ଜୀବନର 1 ବର୍ଷ |",
    "Current age used": "ସାମ୍ପ୍ରତିକ ବୟସ ବ୍ୟବହୃତ |",
    "Progressed date": "ଅଗ୍ରଗତି ତାରିଖ |",
    "Progressed Moon": "ପ୍ରଗତିଶୀଳ ଚନ୍ଦ୍ର |",
    "Loading progressed Moon...": "ଅଗ୍ରଗତି କରୁଥିବା ଚନ୍ଦ୍ର ଲୋଡିଂ ...",
    "Progressed Moon phase": "ଅଗ୍ରଗତି ଚନ୍ଦ୍ର ପର୍ଯ୍ୟାୟ |",
    "Loading Moon phase...": "ଚନ୍ଦ୍ର ପର୍ଯ୍ୟାୟ ଲୋଡିଂ ...",
    "Current Life Phase": "ସାମ୍ପ୍ରତିକ ଜୀବନ ଚରଣ |",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "ଦ୍ Secondary ିତୀୟ ଅଗ୍ରଗତି ଜୀବନର ଆଭ୍ୟନ୍ତରୀଣ ପର୍ଯ୍ୟାୟ, ଭାବପ୍ରବଣ ପରିପକ୍ୱତା, ପରିଚୟ ବିକାଶ ଏବଂ ପରିବର୍ତ୍ତନ ପ୍ରାଥମିକତା ଦେଖାଏ |",
    "Progressed Career Phase": "ଉନ୍ନତ ବୃତ୍ତି ଚରଣ |",
    "Progressed Love Phase": "ପ୍ରଗତି ପ୍ରେମ ଚରଣ |",
    "Progressed Money Phase": "ପ୍ରଗତିଶୀଳ ଅର୍ଥ ଚରଣ |",
    "Loading progressed planets...": "ପ୍ରଗତିଶୀଳ ଗ୍ରହଗୁଡ଼ିକୁ ଧାରଣ କରୁଛି ...",
    "Progressed planets are not available.": "ଉନ୍ନତ ଗ୍ରହ ଉପଲବ୍ଧ ନାହିଁ |",
    "Loading progressed aspects...": "ଅଗ୍ରଗତି ଦିଗଗୁଡିକ ଲୋଡ୍ କରୁଛି ...",
    "No tight progressed-to-natal aspects found right now.": "କ tight ଣସି କଠିନ ପ୍ରଗତି-ରୁ-ନାଟାଲ୍ ଦିଗଗୁଡିକ ବର୍ତ୍ତମାନ ମିଳିଲା ନାହିଁ |",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "ଏହି ପର୍ଯ୍ୟାୟଟି ଉନ୍ନତ ଗ୍ରହ, ପ୍ରଗତିଶୀଳ ଚନ୍ଦ୍ର ପର୍ଯ୍ୟାୟ ଏବଂ କଠିନ ପ୍ରଗତି-ରୁ-ନାଟାଲ୍ ଦିଗରୁ ବିଚାର କରାଯିବା ଉଚିତ |",
    "Vastu Analysis - Kundlistar": "ଭସ୍ତୁ ବିଶ୍ଳେଷଣ - Kundlistar",
    "Failed to load selected chart.": "ମନୋନୀତ ଚାର୍ଟ ଲୋଡ୍ କରିବାରେ ବିଫଳ |",
    "Facing Direction": "ନିର୍ଦ୍ଦେଶନା ମୁହାଁ |",
    "Entrance Direction": "ପ୍ରବେଶ ନିର୍ଦ୍ଦେଶ",
    "Kitchen Direction": "ରୋଷେଇ ନିର୍ଦ୍ଦେଶନା |",
    "Master Bedroom": "ମାଷ୍ଟର ବେଡରୁମ୍ |",
    "Children Bedroom": "ପିଲାମାନେ ଶୟନ କକ୍ଷ |",
    "Toilet Direction": "ଶ To ଚାଳୟ ଦିଗ",
    "Pooja Direction": "ପୂଜା ନିର୍ଦ୍ଦେଶନା |",
    "Water Tank": "ପାଣି ଟାଙ୍କି",
    "Underground Water": "ଭୂତଳ ଜଳ |",
    "Heavy Storage": "ଭାରି ଭଣ୍ଡାର |",
    "Living Room": "ଲିଭିଙ୍ଗ୍ ରୁମ୍ |",
    "Study Room": "ଅଧ୍ୟୟନ କକ୍ଷ |",
    "Vastu report generation failed.": "ଭସ୍ତୁ ରିପୋର୍ଟ ଉତ୍ପାଦନ ବିଫଳ ହେଲା |",
    "Please generate the Vastu report before downloading.": "ଡାଉନଲୋଡ୍ କରିବା ପୂର୍ବରୁ ଦୟାକରି ଭସ୍ତୁ ରିପୋର୍ଟ ସୃଷ୍ଟି କରନ୍ତୁ |",
    "Failed to download Vastu report.": "ଭସ୍ତୁ ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରିବାରେ ବିଫଳ |",
    "Premium Feature": "ପ୍ରିମିୟମ୍ ବ ature ଶିଷ୍ଟ୍ୟ |",
    "Selected Chart": "ମନୋନୀତ ଚାର୍ଟ |",
    "Basic + KP + BNN from chart": "ଚାର୍ଟରୁ ମ Basic ଳିକ + KP + BNN |",
    "Basic shown, KP + BNN locked": "ମ Basic ଳିକ ପ୍ରଦର୍ଶିତ, KP + BNN ଲକ୍ ହୋଇଛି |",
    "Property Type": "ସମ୍ପତ୍ତି ପ୍ରକାର",
    "Center Area": "କେନ୍ଦ୍ର କ୍ଷେତ୍ର |",
    "Generate Vastu Report": "ଭସ୍ତୁ ରିପୋର୍ଟ ସୃଷ୍ଟି କରନ୍ତୁ |",
    "Basic Vastu Analysis": "ମ Basic ଳିକ ଭସ୍ତୁ ବିଶ୍ଳେଷଣ |",
    "KP Vastu Analysis": "କେପି ଭସ୍ତୁ ବିଶ୍ଳେଷଣ |",
    "BNN Vastu Analysis": "BNN Vastu ବିଶ୍ଳେଷଣ |",
    "North East": "ଉତ୍ତର ପୂର୍ବ",
    "South East": "ଦକ୍ଷିଣ ପୂର୍ବ",
    "South West": "ଦକ୍ଷିଣ ପଶ୍ଚିମ",
    "North West": "ଉତ୍ତର ପଶ୍ଚିମ",
    "Red Coral": "ଲାଲ୍ କରାଲ୍ |",
    "Yellow Sapphire": "ହଳଦିଆ ନୀଳମଣି |",
    "Blue Sapphire": "ନୀଳ ନୀଳମଣି",
    "Cat's Eye": "ବିଲେଇର ଆଖି |",
    "Additional Option": "ଅତିରିକ୍ତ ବିକଳ୍ପ",
    "Lagna rule supports this gemstone option.": "ଲାଗନା ନିୟମ ଏହି ରତ୍ନ ପଥର ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Moon sign rule supports this gemstone option.": "ଚନ୍ଦ୍ର ଚିହ୍ନ ନିୟମ ଏହି ରତ୍ନ ପଥର ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Birth date rule supports this gemstone option.": "ଜନ୍ମ ତାରିଖ ନିୟମ ଏହି ରତ୍ନ ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Birth weekday rule supports this gemstone option.": "ଜନ୍ମ ସପ୍ତାହ ନିୟମ ଏହି ରତ୍ନ ପଥର ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Current dasha rule supports this gemstone option.": "ସାମ୍ପ୍ରତିକ ଦାଶ ନିୟମ ଏହି ରତ୍ନ ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Age-band rule supports this gemstone option.": "ବୟସ-ବ୍ୟାଣ୍ଡ ନିୟମ ଏହି ରତ୍ନ ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Selected goal supports this gemstone option.": "ମନୋନୀତ ଲକ୍ଷ୍ୟ ଏହି ରତ୍ନ ପଥର ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Profession rule supports this gemstone option.": "ବୃତ୍ତି ନିୟମ ଏହି ରତ୍ନ ପଥର ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Name-initial rule supports this gemstone option.": "ନାମ-ପ୍ରାରମ୍ଭିକ ନିୟମ ଏହି ରତ୍ନ ପଥର ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Moolank rule supports this gemstone option.": "ମଲାନ୍କ ନିୟମ ଏହି ରତ୍ନ ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Chart condition check was considered for this option.": "ଏହି ବିକଳ୍ପ ପାଇଁ ଚାର୍ଟ କଣ୍ଡିଶନ୍ ଯାଞ୍ଚକୁ ବିଚାର କରାଯାଇଥିଲା |",
    "Rule-based chart match supports this gemstone option.": "ନିୟମ-ଆଧାରିତ ଚାର୍ଟ ମ୍ୟାଚ୍ ଏହି ରତ୍ନ ପଥର ବିକଳ୍ପକୁ ସମର୍ଥନ କରେ |",
    "Expert kundli review is recommended before wearing this gemstone.": "ଏହି ରତ୍ନଭଣ୍ଡାର ପିନ୍ଧିବା ପୂର୍ବରୁ ବିଶେଷଜ୍ଞ କୁଣ୍ଡଲି ସମୀକ୍ଷା କରିବାକୁ ପରାମର୍ଶ ଦିଆଯାଇଛି |",
    "Ring finger": "ଆଙ୍ଗୁଠି ରିଙ୍ଗ୍ |",
    "Little finger": "ଛୋଟ ଆଙ୍ଗୁଠି |",
    "Index finger": "ଇଣ୍ଡେକ୍ସ ଆଙ୍ଗୁଠି |",
    "Middle finger": "ମଧ୍ୟମ ଆଙ୍ଗୁଠି |",
    "Why recommended": "କାହିଁକି ସୁପାରିଶ କରାଯାଇଛି |",
    "Approx weight": "ପାଖାପାଖି ଓଜନ |",
    "Could not load chart.": "ଚାର୍ଟ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ |",
    "Gemstone Recommendations | Kundlistar": "ରତ୍ନଭଣ୍ଡାର ସୁପାରିଶ | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "__KDL_MASK_0 __ ର ନିୟମ-ଆଧାରିତ କୁଣ୍ଡଲି ବିଶ୍ଳେଷଣ ଇଞ୍ଜିନରୁ ବ ed ଦିକ ରତ୍ନ ପଥର ସୁପାରିଶଗୁଡିକ ଏକ୍ସପ୍ଲୋର୍ କରନ୍ତୁ |",
    "noindex,nofollow": "noindex, nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "ରତ୍ନ ପଥର ସୁପାରିଶ, ବ ed ଦିକ ରତ୍ନ ପଥର, କୁଣ୍ଡଲି ରତ୍ନ ପଥର, Kundlistar",
    "Gemstone Recommendations": "ରତ୍ନଭଣ୍ଡାର ସୁପାରିଶ |",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "ଲଗନା, ଚନ୍ଦ୍ର ରାଶି, ଦଶା, DOB, ବୃତ୍ତି ଏବଂ ଲକ୍ଷ୍ୟ ଉପରେ ଆଧାର କରି ବ ed ଦିକ ରତ୍ନ ପଥର ମାର୍ଗଦର୍ଶନ ପାଇଁ ପୃଥକ Kundlistar ମଡ୍ୟୁଲ୍ |",
    "Personalized Gemstone Recommendations are available for Premium users.": "ପ୍ରିମିୟମ୍ ବ୍ୟବହାରକାରୀଙ୍କ ପାଇଁ ବ୍ୟକ୍ତିଗତ ରତ୍ନଭଣ୍ଡାର ସୁପାରିଶ ଉପଲବ୍ଧ |",
    "Upgrade to Premium": "ପ୍ରିମିୟମକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "Login to Upgrade": "ଅପଗ୍ରେଡ୍ କୁ ଲଗ୍ଇନ୍ କରନ୍ତୁ |",
    "Select Goal": "ଲକ୍ଷ୍ୟ ଚୟନ କରନ୍ତୁ |",
    "Business, government job, teacher...": "ବ୍ୟବସାୟ, ସରକାରୀ ଚାକିରି, ଶିକ୍ଷକ ...",
    "Weight kg": "ଓଜନ କି.ଗ୍ରା",
    "वजन kg": "वजन କି.ଗ୍ରା",
    "Optional ratti estimate": "ବ tion କଳ୍ପିକ ରେଟି ଆକଳନ |",
    "Click Calculate to apply these values.": "ଏହି ମୂଲ୍ୟଗୁଡିକ ପ୍ରୟୋଗ କରିବାକୁ ଗଣନା କ୍ଲିକ୍ କରନ୍ତୁ |",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant = \"body2\"> • {extra.stone} {isHindi?",
    "Nadi Analysis": "ନାଡି ବିଶ୍ଳେଷଣ |",
    "KP Analysis": "କେପି ବିଶ୍ଳେଷଣ |",
    "Vedic Analysis": "ବ ed ଦିକ ବିଶ୍ଳେଷଣ |",
    "BNN Analysis": "BNN ବିଶ୍ଳେଷଣ |",
    "Jaimini Analysis": "ଜେଇମିନି ବିଶ୍ଳେଷଣ |",
    "Western Astrology": "ପାଶ୍ଚାତ୍ୟ ଜ୍ୟୋତିଷ",
    "Panch Pakshi": "ପଞ୍ଚ ପାକ୍ସି |",
    "Tithi Pravesh": "ତିଥୀ ପ୍ରଭେଶ |",
    "Lal Kitab": "ଲାଲ କିତାବ |",
    "Astro Logo": "ଆଷ୍ଟ୍ରୋ ଲୋଗୋ |",
    "Download failed": "ଡାଉନଲୋଡ୍ ବିଫଳ ହେଲା |",
    "Could not download PDF report.": "PDF ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରିପାରିଲା ନାହିଁ |",
    "Please login to download PDF reports.": "ଦୟାକରି PDF ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରିବାକୁ ଲଗ୍ଇନ୍ କରନ୍ତୁ |",
    "Failed to generate personalised report": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ସୃଷ୍ଟି କରିବାରେ ବିଫଳ |",
    "Could not download personalised report.": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରିପାରିଲା ନାହିଁ |",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc (100vh - var (- kundlistar-navbar-height, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc (100vh - var (- kundlistar-navbar-height, 160px))",
    "width 0.2s ease": "ମୋଟେଇ 0.2s ସହଜ |",
    "Collapse sidebar": "ପାର୍ଶ୍ୱ ପଟି ଭୁଶୁଡ଼ନ୍ତୁ |",
    "Expand sidebar": "ପାର୍ଶ୍ୱ ପଟି ବିସ୍ତାର କରନ୍ତୁ |",
    "& .MuiListItemIcon-root": "& .MuiListItemIcon-root |",
    "Download PDF Report": "PDF ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
    "Login to download": "ଡାଉନଲୋଡ୍ କରିବାକୁ ଲଗ୍ଇନ୍ କରନ୍ତୁ |",
    "PDF Report": "PDF ରିପୋର୍ଟ",
    "Download Personal Report": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
    "Buy Premium to download": "ଡାଉନଲୋଡ୍ କରିବାକୁ ପ୍ରିମିୟମ୍ କିଣ |",
    "Login to buy Premium": "ପ୍ରିମିୟମ୍ କିଣିବା ପାଇଁ ଲଗଇନ୍ କରନ୍ତୁ |",
    "Buy Premium": "ପ୍ରିମିୟମ୍ କିଣ |",
    "& .MuiTab-root": "& .MuiTab- ମୂଳ |",
    "& .Mui-selected": "& .ମୁଇ-ମନୋନୀତ |",
    "Unable to load Client Management data.": "କ୍ଲାଏଣ୍ଟ ମ୍ୟାନେଜମେଣ୍ଟ ଡାଟା ଲୋଡ୍ କରିବାରେ ଅସମର୍ଥ |",
    "Unable to download PDF.": "PDF ଡାଉନଲୋଡ୍ କରିବାକୁ ଅସମର୍ଥ |",
    "Free client limit reached": "ମାଗଣା କ୍ଲାଏଣ୍ଟ ସୀମା ପହଞ୍ଚିଛି |",
    "Welcome": "ସ୍ Welcome ାଗତ",
    "Hello": "ନମସ୍କାର",
    "Your saved charts are shown below.": "ଆପଣଙ୍କର ସଞ୍ଚିତ ଚାର୍ଟଗୁଡିକ ନିମ୍ନରେ ପ୍ରଦର୍ଶିତ ହୋଇଛି |",
    "All Features": "ସମସ୍ତ ବ Features ଶିଷ୍ଟ୍ୟଗୁଡିକ",
    "New Chart": "ନୂତନ ଚାର୍ଟ",
    "Vedic Chart": "ବ ed ଦିକ ଚାର୍ଟ",
    "Chakra": "ଚକ୍ର",
    "Daily Panchang": "ଦ Daily ନିକ ପଞ୍ଚାଙ୍ଗ |",
    "Choghadiya": "ଚୋଗାଡିଆ |",
    "Daily Horoscope": "ଦ Daily ନିକ ରାଶିଫଳ |",
    "Gochar Alerts": "ଗୋଚର ଆଲର୍ଟ |",
    "Matching": "ମେଳ ଖାଉଛି",
    "Ruling Planets": "ଗ୍ରହ ଶାସନ",
    "Horary Chart": "ହୋରି ଚାର୍ଟ |",
    "Astro-Vastu": "ଆଷ୍ଟ୍ରୋ-ଭସ୍ତୁ |",
    "Vedic Numerology": "ବ ed ଦିକ ସଂଖ୍ୟା",
    "My Charts": "ମୋର ଚାର୍ଟ",
    "Search by Name": "ନାମ ଦ୍ୱାରା ସନ୍ଧାନ କରନ୍ତୁ |",
    "Type": "ଟାଇପ୍ କରନ୍ତୁ |",
    "All": "ସମସ୍ତ",
    "Individual": "ବ୍ୟକ୍ତିଗତ",
    "Horary": "ହୋରି",
    "Clear": "ସଫା",
    "Name": "ନାମ",
    "DOB": "DOB",
    "Place": "ସ୍ଥାନ",
    "Gender": "ଲିଙ୍ଗ",
    "Created": "ସୃଷ୍ଟି ହୋଇଛି |",
    "Actions": "କାର୍ଯ୍ୟ",
    "Male": "ପୁରୁଷ",
    "Female": "ମହିଳା",
    "No matching charts found": "କ match ଣସି ମେଳକ ଚାର୍ଟ ମିଳିଲା ନାହିଁ |",
    "Create First Chart": "ପ୍ରଥମ ଚାର୍ଟ ସୃଷ୍ଟି କରନ୍ତୁ |",
    "View Chart": "ଚାର୍ଟ ଦେଖନ୍ତୁ |",
    "Copy Share Link": "ସେୟାର ଲିଙ୍କ୍ କପି କରନ୍ତୁ |",
    "Use premium credit: Download PDF Report": "ପ୍ରିମିୟମ୍ କ୍ରେଡିଟ୍ ବ୍ୟବହାର କରନ୍ତୁ: PDF ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
    "Download Personalised Report": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
    "Premium: Download Personalised Report": "ପ୍ରିମିୟମ୍: ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
    "Hide Chart": "ଚାର୍ଟ ଲୁଚାନ୍ତୁ |",
    "Personalised": "ବ୍ୟକ୍ତିଗତ",
    "Generating your Personalised Report": "ଆପଣଙ୍କର ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ସୃଷ୍ଟି କରିବା |",
    "Please do not leave this page till the report is generated. This can take a little while.": "ରିପୋର୍ଟ ସୃଷ୍ଟି ନହେବା ପର୍ଯ୍ୟନ୍ତ ଦୟାକରି ଏହି ପୃଷ୍ଠା ଛାଡନ୍ତୁ ନାହିଁ | ଏହା ଟିକିଏ ସମୟ ନେଇପାରେ |",
    "Please don't leave this page till the report is generated. This can take a little while.": "ରିପୋର୍ଟ ସୃଷ୍ଟି ନହେବା ପର୍ଯ୍ୟନ୍ତ ଦୟାକରି ଏହି ପୃଷ୍ଠା ଛାଡନ୍ତୁ ନାହିଁ | ଏହା ଟିକିଏ ସମୟ ନେଇପାରେ |",
    "Update": "ଅଦ୍ୟତନ କରନ୍ତୁ |",
    "Complete your billing address. Required for generating invoice.": "ତୁମର ବିଲିଂ ଠିକଣା ସଂପୂର୍ଣ୍ଣ କର | ଇନଭଏସ୍ ସୃଷ୍ଟି ପାଇଁ ଆବଶ୍ୟକ |",
    "Report this report": "ଏହି ରିପୋର୍ଟ ରିପୋର୍ଟ କରନ୍ତୁ |",
    "Reason": "କାରଣ",
    "Optional comment": "ବ tion କଳ୍ପିକ ମନ୍ତବ୍ୟ",
    "Submit": "ଦାଖଲ କରନ୍ତୁ |",
    "Incorrect info": "ଭୁଲ ସୂଚନା",
    "Offensive": "ଆପତ୍ତିଜନକ |",
    "Harmful": "କ୍ଷତିକାରକ |",
    "This report has been sent for review.": "ଏହି ରିପୋର୍ଟ ସମୀକ୍ଷା ପାଇଁ ପଠାଯାଇଛି |",
    "Failed to submit report feedback": "ରିପୋର୍ଟ ମତାମତ ଦାଖଲ କରିବାରେ ବିଫଳ |",
    "Failed to download PDF": "PDF ଡାଉନଲୋଡ୍ କରିବାରେ ବିଫଳ |",
    "Failed to download personalised report": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରିବାରେ ବିଫଳ |",
    "Failed to load charts": "ଚାର୍ଟ ଲୋଡ୍ କରିବାରେ ବିଫଳ |",
    "Failed to hide chart": "ଚାର୍ଟ ଲୁଚାଇବାରେ ବିଫଳ |",
    "Failed to delete chart": "ଚାର୍ଟ ବିଲୋପ କରିବାରେ ବିଫଳ |",
    "Share link copied to clipboard!": "କ୍ଲିପବୋର୍ଡରେ କପି ହୋଇଥିବା ଲିଙ୍କ୍ ଅଂଶୀଦାର କରନ୍ତୁ!",
    "Delete Chart": "ଚାର୍ଟ ଡିଲିଟ୍ କରନ୍ତୁ |",
    "Delete chart": "ଚାର୍ଟ ଡିଲିଟ୍ କରନ୍ତୁ |",
    "Error": "ତ୍ରୁଟି |",
    "OK": "ଠିକ ଅଛି |",
    "Thanks": "ଧନ୍ୟବାଦ",
    "Report failed": "ରିପୋର୍ଟ ବିଫଳ ହୋଇଛି",
    "Could not submit report feedback.": "ରିପୋର୍ଟ ମତାମତ ଦାଖଲ କରିପାରିଲା ନାହିଁ |",
    "Personalised report ready": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ପ୍ରସ୍ତୁତ |",
    "Personalised report failed": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ବିଫଳ ହେଲା |",
    "Could not generate personalised report.": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ସୃଷ୍ଟି କରିପାରିଲା ନାହିଁ |",
    "Could not generate personalised PDF report.": "ବ୍ୟକ୍ତିଗତ ହୋଇଥିବା PDF ରିପୋର୍ଟ ସୃଷ୍ଟି କରିପାରିଲା ନାହିଁ |",
    "Monthly limit reached": "ମାସିକ ସୀମା ପହଞ୍ଚିଛି |",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "ଆପଣଙ୍କର ମାସିକ ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟ ସୀମା ପହଞ୍ଚିଛି | ଏକ ଆଡ୍-ଅନ୍ କୁ ସବସ୍କ୍ରାଇବ କରନ୍ତୁ: 20 ରିପୋର୍ଟ ପାଇଁ 9 299 / ମାସ କିମ୍ବା 40 ରିପୋର୍ଟ ପାଇଁ ₹ 499 / ମାସ |",
    "Buy Add-on": "ଆଡ୍-ଅନ୍ କିଣ |",
    "Manage": "ପରିଚାଳନା କରନ୍ତୁ |",
    "Add-on active: Unlimited reports": "ଆଡ୍-ଅନ୍ ସକ୍ରିୟ: ଅସୀମିତ ରିପୋର୍ଟଗୁଡିକ |",
    "Add-on active: 40 reports/month": "ଆଡ୍-ଅନ୍ ସକ୍ରିୟ: 40 ରିପୋର୍ଟ / ମାସ |",
    "Add-on active: 20 reports/month": "ଆଡ୍-ଅନ୍ ସକ୍ରିୟ: 20 ରିପୋର୍ଟ / ମାସ |",
    "reports remaining this cycle": "ଏହି ଚକ୍ର ଅବଶିଷ୍ଟ ରିପୋର୍ଟଗୁଡିକ |",
    "Add-on active": "ଆଡ୍-ଅନ୍ ସକ୍ରିୟ |",
    "Personalised reports remaining this month": "ବ୍ୟକ୍ତିଗତ ରିପୋର୍ଟଗୁଡିକ ଏହି ମାସରେ ଅବଶିଷ୍ଟ |",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "ପ୍ରିମିୟମ୍ 2 / ମାସ ଅନ୍ତର୍ଭୁକ୍ତ କରେ | ଆଡ୍-ଅନ୍: 20 ରିପୋର୍ଟ / ମାସ ପାଇଁ 9 299 / ମାସ କିମ୍ବା 40 ରିପୋର୍ଟ / ମାସ ପାଇଁ ₹ 499 / ମାସ |",
    "AI Disclaimer": "AI ପ୍ରତ୍ୟାଖ୍ୟାନ |",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "ଏହି ରିପୋର୍ଟ AI ଏବଂ ଜ୍ୟୋତିଷ ଶାସ୍ତ୍ର ବ୍ୟବହାର କରି ସୃଷ୍ଟି ହୋଇଥାଏ | ଏହା କେବଳ ସୂଚନା ଏବଂ ମନୋରଞ୍ଜନ ଉଦ୍ଦେଶ୍ୟ ପାଇଁ | ଏହାକୁ ଚିକିତ୍ସା, ଆଇନଗତ କିମ୍ବା ଆର୍ଥିକ ପରାମର୍ଶ ଭାବରେ ଗ୍ରହଣ କରାଯିବା ଉଚିତ୍ ନୁହେଁ |",
    "A copy of this report has also been sent to your registered email address as a PDF.": "ଏହି ରିପୋର୍ଟର ଏକ କପି ମଧ୍ୟ ଆପଣଙ୍କର ପଞ୍ଜୀକୃତ ଇମେଲ ଠିକଣାକୁ PDF ଭାବରେ ପଠାଯାଇଛି |",
    "Report this AI-generated report?": "ଏହି AI ଉତ୍ପାଦିତ ରିପୋର୍ଟକୁ ରିପୋର୍ଟ କରନ୍ତୁ?",
    "charts": "ଚାର୍ଟ",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "ସ୍ୱାଧୀନ ନୋଟ୍, ତାରିଖ ଏବଂ ସମୟ ଯୋଜନା | ସେଭ୍ ଲଗଇନ୍ ଆବଶ୍ୟକ କରେ; ମାଗଣା ଉପଭୋକ୍ତାମାନେ ପୂର୍ଣ୍ଣ ଯୋଜନାକାରୀ ପ୍ରବେଶ ପ୍ରାପ୍ତ କରନ୍ତି |",
    "Independent notes, date and time planning.": "ସ୍ୱାଧୀନ ନୋଟ୍, ତାରିଖ ଏବଂ ସମୟ ଯୋଜନା |",
    "Add Plan": "ଯୋଜନା ଯୋଡନ୍ତୁ |",
    "Save Plan": "ଯୋଜନା ସଞ୍ଚୟ କରନ୍ତୁ |",
    "Saved Plans": "ସଞ୍ଚିତ ଯୋଜନାଗୁଡିକ |",
    "Planner Entry": "ଯୋଜନାକାରୀ ପ୍ରବେଶ",
    "Plan": "ଯୋଜନା କରନ୍ତୁ |",
    "Saving...": "ସଞ୍ଚୟ ...",
    "Refresh": "ସତେଜ କରନ୍ତୁ |",
    "No plans saved yet.": "ଏପର୍ଯ୍ୟନ୍ତ କ plans ଣସି ଯୋଜନା ସଞ୍ଚୟ ହୋଇନାହିଁ |",
    "Planner layout is available. Login only when you want to save.": "ପ୍ଲାନର୍ ଲେଆଉଟ୍ ଉପଲବ୍ଧ | ଯେତେବେଳେ ଆପଣ ସଞ୍ଚୟ କରିବାକୁ ଚାହୁଁଛନ୍ତି ସେତେବେଳେ ଲଗ୍ଇନ୍ କରନ୍ତୁ |",
    "No matching plans.": "କ No ଣସି ମେଳକ ଯୋଜନା ନାହିଁ |",
    "Search Plans": "ସନ୍ଧାନ ଯୋଜନାଗୁଡିକ |",
    "Search title, note, date or status": "ସନ୍ଧାନ ଆଖ୍ୟା, ଟିପ୍ପଣୀ, ତାରିଖ କିମ୍ବା ସ୍ଥିତି |",
    "Login is required only when you want to save planner entries.": "ଯେତେବେଳେ ଆପଣ ପ୍ଲାନର୍ ଏଣ୍ଟ୍ରିଗୁଡିକ ସେଭ୍ କରିବାକୁ ଚାହୁଁଛନ୍ତି ସେତେବେଳେ ଲଗଇନ୍ ଆବଶ୍ୟକ |",
    "Planner entry saved.": "ପ୍ଲାନର୍ ଏଣ୍ଟ୍ରି ସଞ୍ଚୟ ହୋଇଛି |",
    "Unable to load planner.": "ପ୍ଲାନର୍ ଲୋଡ୍ କରିବାକୁ ଅସମର୍ଥ |",
    "Unable to save planner entry.": "ପ୍ଲାନର୍ ଏଣ୍ଟ୍ରି ସଞ୍ଚୟ କରିବାରେ ଅସମର୍ଥ |",
    "Could not load planner.": "ପ୍ଲାନର୍ ଲୋଡ୍ କରିପାରିଲା ନାହିଁ |",
    "Could not save planner entry.": "ପ୍ଲାନର୍ ଏଣ୍ଟ୍ରି ସଞ୍ଚୟ କରିପାରିଲା ନାହିଁ |",
    "Login required to save": "ସେଭ୍ କରିବାକୁ ଲଗ୍ଇନ୍ ଆବଶ୍ୟକ |",
    "You can explore Planner now. Login when you want to save entries.": "ଆପଣ ବର୍ତ୍ତମାନ ପ୍ଲାନର୍ ଏକ୍ସପ୍ଲୋର୍ କରିପାରିବେ | ଯେତେବେଳେ ଆପଣ ଏଣ୍ଟ୍ରିଗୁଡିକ ସେଭ୍ କରିବାକୁ ଚାହୁଁଛନ୍ତି ଲଗ୍ଇନ୍ କରନ୍ତୁ |",
    "Prev": "ପୂର୍ବ",
    "Next": "ପରବର୍ତ୍ତୀ",
    "Page": "ପୃଷ୍ଠା",
    "of": "ର",
    "Child Birth Mahoorat": "ଶିଶୁ ଜନ୍ମ ମହୋରାଟ |",
    "Child Birth Mahoorat | Kundlistar Premium": "ଶିଶୁ ଜନ୍ମ ମହୋରାଟ | କୁଣ୍ଡଲିଷ୍ଟର ପ୍ରିମିୟମ୍ |",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "ପ cha ୍ଚାଙ୍ଗ, ଚୋଗାଡିଆ ଏବଂ ହୋରା ଆଧାରିତ ଗାଇଡ୍ ସହିତ ପ୍ରିମିୟମ୍ ଶିଶୁ ଜନ୍ମ ମହୋରାଟ ୱିଣ୍ଡୋ |",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "ଯୋଜନାବଦ୍ଧ ଶିଶୁ-ଜନ୍ମ ସମୟ ନିର୍ଦ୍ଦେଶାବଳୀ ପାଇଁ ଶୁଭ ଉପଲବ୍ଧ ୱିଣ୍ଡୋଗୁଡ଼ିକୁ ଅନୁସନ୍ଧାନ କରିବାକୁ ଏକ ତାରିଖ ଏବଂ ସ୍ଥାନ ଚୟନ କରନ୍ତୁ |",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "ଶିଶୁ ଜନ୍ମ ମହୋରାଟ କେବଳ ଆଧ୍ୟାତ୍ମିକ ଏବଂ ଜ୍ୟୋତିଷ ଶାସ୍ତ୍ର ପାଇଁ |",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "ଶିଶୁ ଜନ୍ମ ମହୋରାଟ ଏକ ପ୍ରିମିୟମ୍ ବ feature ଶିଷ୍ଟ୍ୟ | ପଞ୍ଚାଙ୍ଗ, ଚୋଗାଡିଆ ଏବଂ ହୋରା ଚେକ୍ ସହିତ ଶୁଭ ମାର୍ଗଦର୍ଶିକା ୱିଣ୍ଡୋଗୁଡ଼ିକୁ ଅନଲକ୍ କରିବାକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "ଶିଶୁ ଜନ୍ମ ମହୋରାଟ ଏକ ପ୍ରିମିୟମ୍ ବ feature ଶିଷ୍ଟ୍ୟ | ପଞ୍ଚାଙ୍ଗ, ଚୋଗାଡିଆ ଏବଂ ହୋରା ଚେକ୍ ସହିତ ଗାଇଡ୍ ୱିଣ୍ଡୋଗୁଡ଼ିକୁ ଅନଲକ୍ କରିବାକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "ତାରିଖ, ସ୍ଥାନ, ପଞ୍ଚାଙ୍ଗ, ଚୋଗାଡିଆ ଏବଂ ହୋରା ଅନୁଯାୟୀ ପ୍ରିମିୟମ୍ ଗାଇଡ୍ ୱିଣ୍ଡୋ |",
    "Premium feature": "ପ୍ରିମିୟମ୍ ବ feature ଶିଷ୍ଟ୍ୟ |",
    "Upgrade to Kundlistar Premium": "କୁଣ୍ଡଲିଷ୍ଟର ପ୍ରିମିୟମକୁ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ |",
    "Previous": "ପୂର୍ବ",
    "Today": "ଆଜି |",
    "Birth place / City": "ଜନ୍ମ ସ୍ଥାନ / ସହର",
    "Birth place / city": "ଜନ୍ମ ସ୍ଥାନ / ସହର",
    "Select country, then search city": "ଦେଶ ଚୟନ କରନ୍ତୁ, ତାପରେ ସହର ଖୋଜ |",
    "Preferred start": "ପସନ୍ଦ ଆରମ୍ଭ",
    "Preferred end": "ପସନ୍ଦିତ ଶେଷ",
    "Mother Moon sign (optional)": "ମାତା ଚନ୍ଦ୍ର ଚିହ୍ନ (ବ al କଳ୍ପିକ)",
    "Cancer": "କର୍କଟ",
    "Load Kundli": "କୁଣ୍ଡଲି ଲୋଡ୍ କରନ୍ତୁ |",
    "Find Premium Windows": "ପ୍ରିମିୟମ୍ ୱିଣ୍ଡୋଜ୍ ଖୋଜ |",
    "Date (DD/MM/YYYY)": "ତାରିଖ (DD / MM / YYYY)",
    "Invalid Date": "ଅବ val ଧ ତାରିଖ |",
    "Date must be in DD/MM/YYYY format.": "ତାରିଖ DD / MM / YYYY ଫର୍ମାଟରେ ହେବା ଜରୁରୀ |",
    "Required": "ଆବଶ୍ୟକ",
    "Please select a city.": "ଦୟାକରି ଏକ ସହର ଚୟନ କରନ୍ତୁ |",
    "Kundli": "କୁଣ୍ଡଲି |",
    "Unable to load kundli.": "କୁଣ୍ଡଲି ଲୋଡ୍ କରିବାକୁ ଅସମର୍ଥ |",
    "Unable to calculate Child Birth Mahoorat.": "ଶିଶୁ ଜନ୍ମ ମହୋରାଟ ଗଣନା କରିବାରେ ଅସମର୍ଥ |",
    "Kundli Preview": "କୁଣ୍ଡଲି ପୂର୍ବାବଲୋକନ |",
    "Loaded for": "ପାଇଁ ଲୋଡ୍ ହୋଇଛି |",
    "Doshas & Yogas": "ଦୋସା ଏବଂ ଯୋଗ",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "ଲୋଡ୍ ହୋଇଥିବା ଲାହିରି କୁଣ୍ଡଲିରୁ ନିୟମ-ଆଧାରିତ ସୂଚକ | ଅନ୍ତିମ ବିଚାର ଭାବରେ ନୁହେଁ, ସମୀକ୍ଷା ଏବଂ ଆଧ୍ୟାତ୍ମିକ ମାର୍ଗଦର୍ଶନ ପାଇଁ ସେମାନଙ୍କୁ ବ୍ୟବହାର କରନ୍ତୁ |",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "ଲୋଡ୍ ହୋଇଥିବା ଲାହିରି କୁଣ୍ଡଲିରୁ ନିୟମ-ଆଧାରିତ ସୂଚକ | ସମୀକ୍ଷା ଏବଂ ଆଧ୍ୟାତ୍ମିକ ମାର୍ଗଦର୍ଶନ ପାଇଁ ବ୍ୟବହାର କରନ୍ତୁ |",
    "Detected": "ଚିହ୍ନଟ ହେଲା |",
    "Not detected": "ଚିହ୍ନଟ ହୋଇନାହିଁ |",
    "Review": "ସମୀକ୍ଷା କରନ୍ତୁ |",
    "Dosha": "ଦୋସା |",
    "Yoga": "ଯୋଗ",
    "Full Yoga Scan": "ପୂର୍ଣ୍ଣ ଯୋଗ ସ୍କାନ୍ |",
    "Checking yogas...": "ଯୋଗ ଯାଞ୍ଚ ...",
    "No major yogas were detected by the premium yoga scan.": "ପ୍ରିମିୟମ ଯୋଗ ସ୍କାନ ଦ୍ୱାରା କ major ଣସି ପ୍ରମୁଖ ଯୋଗ ଚିହ୍ନଟ ହୋଇପାରିଲା ନାହିଁ |",
    "No suitable premium windows found for the selected date and time range.": "ମନୋନୀତ ତାରିଖ ଏବଂ ସମୟ ସୀମା ପାଇଁ କ suitable ଣସି ଉପଯୁକ୍ତ ପ୍ରିମିୟମ୍ ୱିଣ୍ଡୋ ମିଳିଲା ନାହିଁ |",
    "No suitable windows found": "କ suitable ଣସି ଉପଯୁକ୍ତ ୱିଣ୍ଡୋ ମିଳିଲା ନାହିଁ |",
    "Try changing the time range or select previous/next date.": "ସମୟ ସୀମା ପରିବର୍ତ୍ତନ କରିବାକୁ ଚେଷ୍ଟା କରନ୍ତୁ କିମ୍ବା ପୂର୍ବ / ପରବର୍ତ୍ତୀ ତାରିଖ ଚୟନ କରନ୍ତୁ |",
    "Try changing the date or time range.": "ତାରିଖ କିମ୍ବା ସମୟ ସୀମା ପରିବର୍ତ୍ତନ କରିବାକୁ ଚେଷ୍ଟା କରନ୍ତୁ |",
    "Try the Previous or Next date button to find a better option.": "ଏକ ଉତ୍ତମ ବିକଳ୍ପ ଖୋଜିବା ପାଇଁ ପୂର୍ବ କିମ୍ବା ପରବର୍ତ୍ତୀ ତାରିଖ ବଟନ୍ ଚେଷ୍ଟା କରନ୍ତୁ |",
    "Use Previous or Next date to find a better option.": "ଏକ ଉତ୍ତମ ବିକଳ୍ପ ଖୋଜିବା ପାଇଁ ପୂର୍ବ କିମ୍ବା ପରବର୍ତ୍ତୀ ତାରିଖ ବ୍ୟବହାର କରନ୍ତୁ |",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "ମନୋନୀତ ତାରିଖ ଏବଂ ସହର ପାଇଁ ସର୍ବୋତ୍ତମ ପ୍ରିମିୟମ୍ ୱିଣ୍ଡୋ ଗଣନା କରିବାକୁ ପ୍ରିମିୟମ୍ ୱିଣ୍ଡୋଜ୍ ସନ୍ଧାନ କ୍ଲିକ୍ କରନ୍ତୁ |",
    "Tap Find Premium Windows for the selected date and city.": "ମନୋନୀତ ତାରିଖ ଏବଂ ସହର ପାଇଁ ପ୍ରିମିୟମ୍ ୱିଣ୍ଡୋଜ୍ ଟ୍ୟାପ୍ କରନ୍ତୁ |",
    "Good tithi": "ଭଲ ତିଥି",
    "Supportive nakshatra": "ସହାୟକ ନକ୍ଷତ୍ର |",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "ନକ୍ଷତ୍ର ସମ୍ବେଦନଶୀଳ | ପାଦ ଏବଂ ଗଣ୍ଡାଣ୍ଟକୁ ଭଲଭାବେ ଯାଞ୍ଚ କରନ୍ତୁ |",
    "Supportive weekday": "ସହାୟକ ସପ୍ତାହ ଦିବସ |",
    "Good Choghadiya": "ଭଲ ଚୋଗାଡିଆ |",
    "Weak Choghadiya": "ଦୁର୍ବଳ ଚୋଗାଡିଆ |",
    "Supportive Hora": "ସହାୟକ ହୋରା |",
    "Baby Moon matches mother's Moon sign.": "ଶିଶୁ ଚନ୍ଦ୍ର ମାତାର ଚନ୍ଦ୍ର ଚିହ୍ନ ସହିତ ମେଳ ଖାଏ |",
    "Hora": "ହୋରା |",
    "slots": "ସ୍ଲଟ୍",
    "min": "ମିନିଟ୍",
    "Good": "ଭଲ",
    "Excellent": "ଉତ୍କୃଷ୍ଟ |",
    "Usable": "ବ୍ୟବହାରଯୋଗ୍ୟ",
    "Rejected": "ପ୍ରତ୍ୟାଖ୍ୟାନ",
    "Sunday": "ରବିବାର |",
    "Monday": "ସୋମବାର |",
    "Tuesday": "ମଙ୍ଗଳବାର |",
    "Wednesday": "ବୁଧବାର",
    "Thursday": "ଗୁରୁବାର |",
    "Friday": "ଶୁକ୍ରବାର |",
    "Saturday": "ଶନିବାର |",
    "Sun": "ସୂର୍ଯ୍ୟ |",
    "Moon": "ଚନ୍ଦ୍ର",
    "Mars": "ମଙ୍ଗଳ",
    "Mercury": "ବୁଧ",
    "Jupiter": "ବୃହସ୍ପତି",
    "Venus": "ଶୁକ୍ର",
    "Saturn": "ଶନି |",
    "Rahu": "ରାହୁ",
    "Ketu": "କେଟୁ",
    "Chal": "ଚାଲ୍",
    "Labh": "ଲାବ୍ |",
    "Amrit": "ଅମୃତ",
    "Shubh": "ଶୁଭ",
    "Udveg": "ଉଦଭେଗ",
    "Rog": "ରୋଗ",
    "Kaal": "କାଲ୍ |",
    "Krishna Navami": "କୃଷ୍ଣ ନବମୀ |",
    "Ashwini": "ଅଶ୍ୱିନୀ",
    "Bharani": "ଭରାନୀ",
    "Krittika": "କ୍ରିଟିକା",
    "Rohini": "ରୋହିଣୀ",
    "Mrigashira": "ଶ୍ରୀଗାଶିରା |",
    "Ardra": "ଆର୍ଡ୍ରା |",
    "Punarvasu": "ପୁନାରଭାସୁ |",
    "Pushya": "ପୁଷ୍ପ",
    "Ashlesha": "ଆଶଲେଶା",
    "Magha": "ମାଗା",
    "Jyeshtha": "ଜ୍ୟେଷ୍ଠ",
    "Moola": "ମୋଲା",
    "Mula": "ମୁଲା",
    "Revati": "ରେଭତୀ |"
  },
  "as": {
    "Client Management": "ক্লায়েন্ট ব্যৱস্থাপনা",
    "Dashboard": "ডেচব'ৰ্ড",
    "Clients": "ক্লায়েন্ট",
    "Consultations": "পৰামৰ্শ",
    "Notes": "টোকাসমূহ",
    "Follow-ups": "ফ'ল'-আপ",
    "Reports": "প্ৰতিবেদন",
    "Remedies": "প্ৰতিকাৰ",
    "Predictions": "ভৱিষ্যদ্বাণী",
    "Planner": "পৰিকল্পনাকাৰী",
    "Templates": "টেমপ্লেটসমূহ",
    "Analytics": "বিশ্লেষণ",
    "Payments": "পেমেন্ট",
    "Settings": "ছেটিংছ",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings ত ডিফল্ট চহৰ সংৰক্ষণ কৰিব পাৰে। চহৰ নিৰ্বাচন নকৰালৈকে চহৰ ফিল্ড খালী থাকে।",
    "is now your default city.": "এতিয়া আপোনাৰ ডিফল্ট চহৰ।",
    "Search your default city": "আপোনাৰ ডিফল্ট চহৰ বিচাৰক",
    "This color is saved for the website theme and PDF report accent.": "এই ৰং ৱেবছাইট থিম আৰু PDF ৰিপোৰ্ট accent ৰ বাবে সংৰক্ষণ হয়।",
    "Turn All off to include only the checked modules in the report.": "ৰিপোৰ্টত কেৱল নিৰ্বাচিত মডিউল অন্তর্ভুক্ত কৰিবলৈ All অফ কৰক।",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All অন থাকিলে PDF ত সকলো মডিউল থাকে। কেৱল নিৰ্বাচিত মডিউলৰ বাবে ইয়াক অফ কৰক।",
    "Uranus, Neptune and Pluto stay hidden by default.": "ইউৰেনাছ, নেপচুন আৰু প্লুটো ডিফল্টভাৱে লুকাই থাকে।",
    "Show Uranus, Neptune and Pluto": "ইউৰেনাছ, নেপচুন আৰু প্লুটো দেখুৱাওক",
    "When off, Nadi and KP also use the selected global ayanamsha.": "বন্ধ থাকিলে, নাড়ী আৰু KP-য়েও নিৰ্বাচিত গ্লোবেল অয়নাংশ ব্যৱহাৰ কৰিব।",
    "Use KP for Nadi and KP": "নাড়ী আৰু KP ৰ বাবে KP ব্যৱহাৰ কৰক",
    "Use KP ayanamsha for Nadi and KP": "নাড়ী আৰু KP ৰ বাবে KP অয়নাংশ ব্যৱহাৰ কৰক",
    "Night": "নাইট",
    "Dark": "ডাৰ্ক",
    "Light": "লাইট",
    "Clear default city": "ডিফল্ট চহৰ আঁতৰাওক",
    "Default City": "ডিফল্ট চহৰ",
    "Default city": "ডিফল্ট চহৰ",
    "Theme Color": "থিম ৰং",
    "Theme color": "থিম ৰং",
    "Include all modules": "সকলো মডিউল অন্তর্ভুক্ত কৰক",
    "PDF Report Modules": "PDF ৰিপোৰ্ট মডিউল",
    "PDF report modules": "PDF ৰিপোৰ্ট মডিউল",
    "Show": "দেখুৱাওক",
    "Hide": "লুকুৱাওক",
    "Outer Planets": "বাহ্যিক গ্ৰহ",
    "Outer planets": "বাহ্যিক গ্ৰহ",
    "Ayanamsha": "অয়নাংশ",
    "Mean Node": "মীন নোড",
    "True Node": "ট্ৰু নোড",
    "Rahu/Ketu Calculation": "ৰাহু/কেতু গণনা",
    "Rahu/Ketu calculation": "ৰাহু/কেতু গণনা",
    "East": "পূব ভাৰতীয়",
    "South": "দক্ষিণ ভাৰতীয়",
    "North": "উত্তৰ ভাৰতীয়",
    "Chart Style": "চাৰ্ট শৈলী",
    "Chart style": "চাৰ্ট শৈলী",
    "Language": "ভাষা",
    "Records": "ৰেকৰ্ড",
    "Relations": "সম্পৰ্ক",
    "Relation": "সম্পৰ্ক",
    "Add Client": "ক্লায়েন্ট যোগ কৰক",
    "Add Consultation": "পৰামৰ্শ যোগ কৰক",
    "Add Note": "টোকা যোগ কৰক",
    "Add Follow-up": "ফ'ল'-আপ যোগ কৰক",
    "Create Report": "প্ৰতিবেদন সৃষ্টি কৰক",
    "Assign Remedy": "প্ৰতিকাৰ নিযুক্তি দিয়ক",
    "Add Prediction": "ভৱিষ্যদ্বাণী যোগ কৰক",
    "Add Payment": "পেমেন্ট যোগ কৰক",
    "Assign Chart": "চাৰ্ট নিযুক্ত কৰক",
    "Add Relation": "সম্পৰ্ক যোগ কৰক",
    "CMS Action": "চিএমএছ একচন",
    "Client": "ক্লায়েণ্ট",
    "Chart": "চাৰ্ট",
    "Related Client": "সম্পৰ্কীয় ক্লায়েণ্ট",
    "Full Name": "সম্পূৰ্ণ নাম",
    "Phone Number": "ফোন নম্বৰ",
    "WhatsApp Number": "হোৱাটছএপ নম্বৰ",
    "Email": "ইমেইল",
    "Birth Place": "জন্মস্থান",
    "Current City": "বৰ্তমানৰ চহৰ",
    "Main Topic": "মূল বিষয়",
    "Status": "স্থিতি",
    "Source": "উৎস",
    "Tags": "ট্যাগ",
    "Internal Note": "আভ্যন্তৰীণ টোকা",
    "Purpose": "উদ্দেশ্য",
    "Relation Type": "সম্পৰ্কৰ ধৰণ",
    "Title": "অলপ",
    "Topic": "বিষয়",
    "Date": "তাৰিখ",
    "Time": "সময়",
    "Amount": "পৰিমাণ",
    "Mode": "মোড",
    "Payment Status": "পেমেন্টৰ অৱস্থা",
    "Note / Summary": "টোকা / সাৰাংশ",
    "Close": "বন্ধ কৰক",
    "Cancel": "বাতিল কৰক",
    "Save": "সংৰক্ষণ কৰক",
    "Saving": "সঞ্চয় কৰা",
    "Save Changes": "পৰিবৰ্তনসমূহ সংৰক্ষণ কৰক",
    "Edit Client": "ক্লায়েন্ট সম্পাদনা কৰক",
    "Client Chart": "ক্লায়েন্ট চাৰ্ট",
    "Comma separated": "কমা পৃথক হৈ গ’ল",
    "Search by name, phone, email, topic, or tag": "নাম, ফোন, ইমেইল, বিষয়, বা টেগৰ দ্বাৰা সন্ধান কৰক",
    "Search clients, phone, topic": "ক্লায়েন্ট, ফোন, বিষয় সন্ধান কৰক",
    "Search your saved charts by chart name": "আপোনাৰ সংৰক্ষিত চাৰ্টসমূহ চাৰ্টৰ নাম অনুসৰি সন্ধান কৰক",
    "Linked Chart": "লিংক কৰা চাৰ্ট",
    "Select linked chart": "সংযুক্ত চাৰ্ট নিৰ্ব্বাচন কৰক",
    "Link a chart to this client before adding records.": "ৰেকৰ্ড যোগ কৰাৰ আগতে এটা চাৰ্ট এই ক্লাএন্টৰ সৈতে সংযোগ কৰক।",
    "Connect this client with another saved client profile": "এই ক্লাএন্টক অন্য সংৰক্ষিত ক্লাএন্ট আলেখ্যনৰ সৈতে সংযোগ কৰক",
    "CMS for astrologer client work": "জ্যোতিষী ক্লায়েণ্টৰ কামৰ বাবে চিএমএছ",
    "Premium Pro unlocks Client Management": "প্ৰিমিয়াম প্ৰ'ই ক্লায়েণ্ট ব্যৱস্থাপনা আনলক কৰে",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ক্লায়েন্ট প্ৰ'ফাইল, পৰামৰ্শ, টোকা, অনুসৰণ, প্ৰতিবেদন, প্ৰতিকাৰ, ভৱিষ্যদ্বাণী, বিশ্লেষণ আৰু পেমেণ্ট অনুসৰণ এটা কাৰ্য্যস্থানত পৰিচালনা কৰিবলে উন্নয়ন কৰক।",
    "Upgrade to Premium Pro": "প্ৰিমিয়াম প্ৰ'লৈ উন্নীত কৰক",
    "CMS modules included": "চিএমএছ মডিউলসমূহ অন্তৰ্ভুক্ত কৰা হৈছে",
    "Please login to use Client Management. CMS data is stored per account.": "ক্লাএন্ট ব্যৱস্থাপনা ব্যৱহাৰ কৰিবলৈ অনুগ্ৰহ কৰি লগইন কৰক। প্ৰতিটো একাউণ্টত চিএমএছ ডাটা সংৰক্ষণ কৰা হয়।",
    "Login": "লগইন কৰক",
    "Loading live CMS data...": "লাইভ CMS ডাটা লোড কৰা হৈছে...",
    "Quick Actions": "দ্ৰুত কাৰ্য্যসমূহ",
    "Client Records": "ক্লায়েন্ট ৰেকৰ্ডসমূহ",
    "Client Record": "ক্লায়েন্ট ৰেকৰ্ড",
    "Client Profile": "ক্লায়েন্ট প্ৰফাইল",
    "Back to Clients": "ক্লায়েন্টসমূহলৈ উভতি যাওক",
    "View": "দৃশ্য",
    "Edit": "সম্পাদনা কৰক",
    "Delete": "বিলোপ",
    "Note": "টোকা",
    "Archive": "আৰ্কাইভ",
    "Download PDF": "PDF ডাউনলোড কৰক",
    "Delete this record?": "এই ৰেকৰ্ডটো মচি পেলাওক?",
    "Unable to edit this CMS record.": "এই CMS ৰেকৰ্ড সম্পাদনা কৰিব নোৱাৰি।",
    "Unable to update CMS record.": "CMS ৰেকৰ্ড আপডেইট কৰিব নোৱাৰি।",
    "Unable to delete CMS record.": "CMS ৰেকৰ্ড মচি পেলাব পৰা নাই।",
    "No contact added": "কোনো যোগাযোগ যোগ কৰা হোৱা নাই",
    "No topic": "কোনো বিষয় নাই",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "কোনো ক্লায়েন্ট এতিয়াও পোৱা নগ'ল। CMS ডেচব'ৰ্ড পূৰণ আৰম্ভ কৰিবলে আপোনাৰ প্ৰথম প্ৰকৃত ক্লাএন্ট যোগ কৰক।",
    "Last Consultation": "শেষৰ পৰামৰ্শ",
    "Next Follow-up": "পৰৱৰ্তী অনুসৰণ",
    "Date of Birth": "জন্ম তাৰিখ",
    "Time of Birth": "জন্মৰ সময়",
    "Client Details": "ক্লায়েন্টৰ বিৱৰণ",
    "No connected profiles yet.": "এতিয়াও কোনো সংযুক্ত প্ৰফাইল নাই।",
    "Select a client record to view details.": "বিৱৰণ চাবলৈ এটা ক্লাএন্ট ৰেকৰ্ড নিৰ্ব্বাচন কৰক।",
    "Record": "ৰেকৰ্ড",
    "Consultation Summary": "পৰামৰ্শৰ সাৰাংশ",
    "Client Note": "ক্লায়েন্ট টোকা",
    "Start a consultation record with summary, topic, mode and payment fields.": "সাৰাংশ, বিষয়, ধৰণ আৰু পেমেণ্ট ক্ষেত্ৰসমূহৰ সৈতে এটা পৰামৰ্শ ৰেকৰ্ড আৰম্ভ কৰক।",
    "Start a private note attached to a client profile.": "এটা ক্লাএন্ট আলেখ্যনৰ সৈতে সংযুক্ত এটা ব্যক্তিগত টোকা আৰম্ভ কৰক।",
    "Start a pending follow-up with due date and topic.": "নিৰ্ধাৰিত তাৰিখ আৰু বিষয়ৰ সৈতে এটা বাকী থকা অনুসৰণ আৰম্ভ কৰক।",
    "Start a report record connected to the client timeline.": "ক্লাএন্ট সময়ৰেখাৰ সৈতে সংযুক্ত এটা প্ৰতিবেদন ৰেকৰ্ড আৰম্ভ কৰক।",
    "Start an active remedy record for client guidance.": "ক্লায়েণ্টৰ নিৰ্দেশনাৰ বাবে এটা সক্ৰিয় প্ৰতিকাৰ ৰেকৰ্ড আৰম্ভ কৰক।",
    "Start an open prediction record with notes and follow-up date.": "টোকা আৰু অনুসৰণৰ তাৰিখৰ সৈতে এটা মুকলি ভৱিষ্যদ্বাণী ৰেকৰ্ড আৰম্ভ কৰক।",
    "Statuses": "ষ্টেটাছ",
    "Topics": "বিষয়",
    "Sources": "উৎসসমূহ",
    "No records found for the current filters.": "বৰ্তমানৰ ফিল্টাৰসমূহৰ বাবে কোনো ৰেকৰ্ড পোৱা নগ'ল।",
    "Total Clients": "মুঠ ক্লায়েন্ট",
    "New Clients This Month": "এই মাহত নতুন ক্লায়েণ্ট",
    "Consultations This Month": "এই মাহত পৰামৰ্শ",
    "Today's Consultations": "আজিৰ পৰামৰ্শ",
    "Consultations scheduled for today from real client records.": "প্ৰকৃত ক্লায়েণ্ট ৰেকৰ্ডৰ পৰা আজিৰ বাবে নিৰ্ধাৰিত পৰামৰ্শ।",
    "No consultations scheduled for today.": "আজি কোনো ধৰণৰ পৰামৰ্শৰ দিন নাই।",
    "Pending Follow-ups": "পেণ্ডিং ফ'ল'-আপ",
    "Reports Created": "প্ৰতিবেদন সৃষ্টি কৰা হৈছে",
    "Active Remedies": "সক্ৰিয় প্ৰতিকাৰ",
    "Open Predictions": "মুকলি ভৱিষ্যদ্বাণী",
    "Pending Payments": "পেণ্ডিং পেমেণ্ট",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "ক্লায়েণ্টৰ কাৰ্যকলাপ, শেহতীয়া কাম, অনুসৰণ, প্ৰতিবেদন, ভৱিষ্যদ্বাণী, প্ৰতিকাৰ আৰু বাকী থকা পেমেণ্টসমূহ একে ঠাইতে চাওক।",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "জন্মৰ বিৱৰণ, বিষয়, টেগ, অৱস্থা আৰু আৰ্কাইভ/পুনৰুদ্ধাৰ কাৰ্য্যসমূহৰ সৈতে জ্যোতিষী ক্লায়েণ্ট ৰেকৰ্ডসমূহ পৰিচালনা কৰক।",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "অধিবেশনৰ বিৱৰণ, সংযুক্ত চাৰ্ট, বিষয়, পৰ্যবেক্ষণ, ভৱিষ্যদ্বাণী, প্ৰতিকাৰ আৰু অনুসৰণৰ তাৰিখ সংৰক্ষণ কৰক।",
    "Keep private consultation notes and chart observations attached to client profiles.": "ব্যক্তিগত পৰামৰ্শ টোকা আৰু চাৰ্ট পৰ্যবেক্ষণসমূহ ক্লায়েণ্ট প্ৰ'ফাইলসমূহৰ সৈতে সংযুক্ত ৰাখক।",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "ক্লায়েণ্ট মেনেজমেণ্টৰ ভিতৰত আজি আৰু আগন্তুক ফ’ল’-আপসমূহ পুছ, এছএমএছ, ইমেইল বা হোৱাটছএপ সতৰ্কতা অবিহনে অনুসৰণ কৰক।",
    "Create and organize client reports generated from saved charts and consultation context.": "সংৰক্ষিত চাৰ্ট আৰু পৰামৰ্শ প্ৰসংগৰ পৰা সৃষ্টি কৰা ক্লাএন্ট প্ৰতিবেদন সৃষ্টি আৰু সংগঠিত কৰক।",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "প্ৰতিকাৰসমূহ নিযুক্ত কৰক, সক্ৰিয় নিৰ্দেশনা চিহ্নিত কৰক আৰু প্ৰতিকাৰৰ ইতিহাস ক্লায়েণ্টৰ সময়ৰেখাৰ সৈতে সংযুক্ত ৰাখক।",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "প্ৰতিজন ক্লায়েণ্টৰ বাবে মুকলি ভৱিষ্যদ্বাণী, তাৰিখ, আস্থা টোকা আৰু ফলাফল আপডেটসমূহ অনুসৰণ কৰক।",
    "Plan consultations, follow-ups and payment dates in one working view.": "এটা কামৰ দৃষ্টিভংগীৰে পৰামৰ্শ, অনুসৰণ আৰু পেমেণ্টৰ তাৰিখ পৰিকল্পনা কৰক।",
    "Prepare reusable consultation, report, remedy and prediction templates.": "পুনৰ ব্যৱহাৰযোগ্য পৰামৰ্শ, প্ৰতিবেদন, প্ৰতিকাৰ আৰু ভৱিষ্যদ্বাণীৰ সাঁচ প্ৰস্তুত কৰা।",
    "Review client activity, consultation volume, reports created and pending work.": "ক্লায়েণ্টৰ কাৰ্য্যকলাপ, পৰামৰ্শৰ পৰিমাণ, সৃষ্টি কৰা প্ৰতিবেদন আৰু বাকী থকা কামসমূহ পৰ্যালোচনা কৰা।",
    "Track consultation amounts and payment status without plan or pricing rules.": "পৰিকল্পনা বা মূল্য নিৰ্ধাৰণৰ নিয়ম অবিহনে পৰামৰ্শৰ পৰিমাণ আৰু পেমেণ্টৰ অৱস্থা অনুসৰণ কৰক।",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "ক্লাএন্ট উৎসসমূহ, অৱস্থাসমূহ, বিষয়সমূহ, টেগসমূহ আৰু অভ্যন্তৰীণ CMS পছন্দসমূহ বিন্যাস কৰক।",
    "Showing saved records connected to client records.": "ক্লাএন্ট ৰেকৰ্ডসমূহৰ সৈতে সংযুক্ত সংৰক্ষিত ৰেকৰ্ডসমূহ দেখুৱাইছে।",
    "No Status": "কোনো ষ্টেটাছ নাই",
    "No Mode": "কোনো মোড নাই",
    "No Payment Status": "কোনো পেমেণ্টৰ অৱস্থা নাই",
    "No Topic": "কোনো বিষয় নাই",
    "No Source": "কোনো উৎস নাই",
    "All Statuses": "সকলো অৱস্থা",
    "All Topics": "সকলো বিষয়",
    "No clients found": "কোনো ক্লায়েন্ট পোৱা নগ'ল",
    "Type to search clients": "ক্লায়েন্ট সন্ধান কৰিবলৈ টাইপ কৰক",
    "No charts found": "কোনো চাৰ্ট পোৱা নগ'ল",
    "Type to search saved charts": "সংৰক্ষিত চাৰ্টসমূহ সন্ধান কৰিবলৈ টাইপ কৰক",
    "Type to search related client": "সম্পৰ্কীয় ক্লায়েণ্ট সন্ধান কৰিবলৈ টাইপ কৰক",
    "Open": "খোলা",
    "Pending": "বাকী আছে",
    "Scheduled": "নিৰ্ধাৰিত",
    "Completed": "সম্পূৰ্ণ হ’ল",
    "Follow-up Pending": "ফ'ল'-আপ বাকী আছে",
    "Cancelled": "বাতিল কৰা হৈছে",
    "Closed": "বন্ধ",
    "No-show": "ন’-শ্ব’",
    "Not Applicable": "প্ৰযোজ্য নহয়",
    "Paid": "পেইড",
    "Partially Paid": "আংশিকভাৱে পেইড",
    "Refunded": "ধন ঘূৰাই দিয়া হ’ল",
    "Phone": "ফোন",
    "WhatsApp Call": "হোৱাটছএপ কল",
    "Video Call": "ভিডিঅ' কল",
    "In-person": "ব্যক্তিগতভাৱে",
    "Chat": "আড্ডা",
    "Other": "অন্যান্য",
    "New": "নতুন",
    "VIP": "ভিআইপি",
    "Inactive": "নিষ্ক্ৰিয়",
    "Consultation Completed": "পৰামৰ্শ সম্পূৰ্ণ হৈছে",
    "WhatsApp": "হোৱাটছএপ",
    "Instagram": "ইনষ্টাগ্ৰাম",
    "YouTube": "ইউটিউব",
    "Referral": "ৰেফাৰেল",
    "Website": "ৱেবছাইট",
    "Walk-in": "ৱাক-ইন",
    "Repeat Client": "ক্লায়েণ্ট পুনৰাবৃত্তি কৰক",
    "Family Referral": "পৰিয়ালৰ ৰেফাৰেল",
    "Business": "ব্যৱসায়",
    "Finance": "বিত্ত",
    "Property": "সম্পত্তি",
    "Children": "শিশু",
    "Foreign Settlement": "বিদেশী বসতি",
    "Legal": "আইনী",
    "Remedy": "প্ৰতিকাৰ",
    "General": "সাধাৰণ",
    "Active": "সক্ৰিয়",
    "Past": "অতীত",
    "Potential": "সম্ভাৱনা",
    "Archived": "আৰ্কাইভ কৰা হৈছে",
    "Spouse": "পত্নী",
    "Husband": "স্বামী",
    "Wife": "পত্নী",
    "Child": "শিশু",
    "Son": "পুত্ৰ",
    "Daughter": "ছোৱালী",
    "Father": "দেউতা",
    "Mother": "মা",
    "Sibling": "ভাই-ভনী",
    "Brother": "ভাইটি",
    "Sister": "ভনীয়েক",
    "Marriage Prospect": "বিবাহৰ সম্ভাৱনা",
    "Fiance": "হবু বন্ধু",
    "Business Partner": "ব্যৱসায়িক অংশীদাৰ",
    "Friend": "বন্ধু",
    "Relative": "আপেক্ষিক",
    "Upgrade": "উন্নয়ন কৰক",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "আপুনি মাত্ৰ ২ টা ক্লায়েণ্ট যোগ কৰিব পাৰিব। অধিক ক্লায়েন্টৰ বাবে প্ৰিমিয়ামলৈ উন্নয়ন কৰক।",
    "None": "একো নাই",
    "Education": "শিক্ষা",
    "Awards": "বঁটা",
    "Prize": "পুৰষ্কাৰ",
    "Career": "কেৰিয়াৰ",
    "Love": "ভালপোৱা",
    "Marriage": "বিবাহ",
    "Dowry or Legacy": "যৌতুক বা লিগেচি",
    "Divorce": "বিবাহ বিচ্ছেদ",
    "Abortion": "গৰ্ভপাত কৰা",
    "Child Birth": "শিশু জন্ম",
    "Property/Vehicle Purchase": "সম্পত্তি/বাহন ক্ৰয়",
    "Property/Vehicle Sale": "সম্পত্তি/বাহন বিক্ৰী",
    "Love and Caring": "প্ৰেম আৰু যত্ন লোৱা",
    "Depression": "উদাস",
    "Aggression": "আক্ৰমণাত্মকতা",
    "Health": "স্বাস্থ্য",
    "Travel": "ভ্ৰমণ",
    "Homecoming": "ঘৰলৈ উভতি অহা",
    "Litigation": "মামলা",
    "Arrest": "গ্ৰেপ্তাৰ",
    "Locked": "লক কৰা হৈছে",
    "Strong": "শক্তিশালী",
    "Weak": "দুৰ্বল",
    "Supportive": "সহায়ক",
    "Avoid": "এৰাই চলক",
    "Premium": "প্ৰিমিয়াম",
    " UTC": "ইউটিচি",
    "Unable to calculate Tithi Pravesh": "তিথি প্ৰবেশৰ হিচাপ কৰিব পৰা নাই",
    "IANA timezone": "IANA সময়মণ্ডল",
    "TP Local": "টি পি স্থানীয়",
    "TP UTC": "টি পি ইউটিচি",
    "Next TP Local": "পৰৱৰ্তী টিপি স্থানীয়",
    "Models: KP + Vedic": "আৰ্হি: কে পি + বৈদিক",
    "Overall Year Theme": "সামগ্ৰিক বছৰৰ থিম",
    "Career & Job": "কেৰিয়াৰ আৰু চাকৰি",
    "Finance & Savings": "বিত্ত আৰু সঞ্চয়",
    "Relationship & Marriage": "সম্পৰ্ক আৰু বিবাহ",
    "Family Matters": "পৰিয়ালৰ বিষয়",
    "Property & Vehicle": "সম্পত্তি আৰু বাহন",
    "Health & Wellness": "স্বাস্থ্য আৰু সুস্থতা",
    "Spiritual Growth": "আধ্যাত্মিক বৃদ্ধি",
    "Social Status & Recognition": "সামাজিক অৱস্থা আৰু স্বীকৃতি",
    "Please select a saved chart first.": "অনুগ্ৰহ কৰি প্ৰথমে এটা সংৰক্ষিত লেখচিত্ৰ নিৰ্ব্বাচন কৰক।",
    "Unable to generate Tajika Varshphal": "Tajika Varshphal সৃষ্টি কৰিব পৰা নাই",
    "Premium yearly module": "প্ৰিমিয়াম বছৰেকীয়া মডিউল",
    "Tajika Varshphal": "তাজিকা বছৰফল",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "সৌৰ ৰিটাৰ্ণ ভিত্তিক বাৰ্ষিক ৰাশিফলৰ সৈতে বছৰ লগ্ন, মুন্থা, বছৰ প্ৰভু, সাহাম, মাহেকীয়া নিৰ্দেশনা, প্ৰতিকাৰ, আৰু এই ৰক্ষা কৰা কুণ্ডলীৰ পৰা ব্যক্তিগতকৃত ব্যৱহাৰিক জীৱনৰ বিষয়বস্তু।",
    "Saved chart": "সংৰক্ষিত চাৰ্ট",
    "Untitled Chart": "শিৰোনামহীন চাৰ্ট",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "আপোনাৰ ৪টা বিনামূলীয়া প্ৰিমিয়াম ক্ৰেডিট ব্যৱহাৰ কৰা হয়। সীমাহীন প্ৰিমিয়াম অভিগমৰ বাবে Kundlistar প্ৰিমিয়ামলৈ উন্নয়ন কৰক।",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "4. Kundlistar প্ৰিমিয়াম লেন।",
    "Core Year Markers": "কোৰ ইয়েৰ মাৰ্কাৰ",
    "Solar Return": "সৌৰ ৰিটাৰ্ণ",
    "Varsha Lagna": "বছৰ লগ্ন",
    "Muntha Lord": "মুন্থা প্ৰভু",
    "Varsha Lord": "বছৰ প্ৰভু",
    "Varshesh Method": "বছৰেশ পদ্ধতি",
    "Yearly Summary": "বছৰেকীয়া সাৰাংশ",
    "Not available yet.": "এতিয়াও উপলব্ধ নহয়।",
    "Varshesh Candidates": "বছৰেশ প্ৰাৰ্থী",
    "Risk Areas": "বিপদজনক অঞ্চল",
    "Favourable Periods": "অনুকূল সময়ছোৱা",
    "Challenging Periods": "প্ৰত্যাহ্বানমূলক সময়ছোৱা",
    "Remedies & Final Advice": "প্ৰতিকাৰ আৰু চূড়ান্ত পৰামৰ্শ",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "তাজিকা বছৰফলে ব্যাখ্যাত্মক বছৰেকীয়া পথ প্ৰদৰ্শন কৰে। ইয়াক চিকিৎসা, আইনী, আৰ্থিক বা কিছুমান ভৱিষ্যদ্বাণীমূলক পৰামৰ্শ হিচাপে গণ্য কৰা উচিত নহয়।",
    "Griha Pravesh": "গৃহ প্ৰবেশ",
    "Purva Phalguni": "পূৰ্ব ফালগুনি",
    "Uttara Phalguni": "উত্তৰ ফালগুনি",
    "Purva Ashadha": "পূৰ্ব আষাধা",
    "Uttara Ashadha": "উত্তৰ আশাধা",
    "Purva Bhadrapada": "পূৰ্ব ভদ্ৰপদ",
    "Uttara Bhadrapada": "উত্তৰ ভদ্ৰপদ",
    "Param Mitra": "পৰম মিত্ৰ",
    "Kundli birthplace": "কুণ্ডলীৰ জন্মস্থান",
    "Selected city": "নিৰ্বাচিত চহৰ",
    "Muhurat - Kundlistar": "মুহুৰত - Kundlistar",
    "Please select a city first.": "অনুগ্ৰহ কৰি প্ৰথমে এখন চহৰ বাছি লওক।",
    "Unable to calculate Muhurat.": "মুহুৰাত হিচাপ কৰিব পৰা নাই।",
    "Unable to calculate personalized Muhurat.": "ব্যক্তিগতকৃত মুহুৰাত গণনা কৰিব পৰা নাই।",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "Panchang, Choghadiya, Hora, Tarabala আৰু Chandrabala ব্যৱহাৰ কৰি সাধাৰণ আৰু ব্যক্তিগতকৃত Muhurat বিচাৰি উলিয়াওক।",
    "Muhurat Finder": "মুহুৰাত ফাইণ্ডাৰ",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "Panchang, Choghadiya আৰু প্ৰিমিয়াম ব্যক্তিগত জন্ম কাৰক ব্যৱহাৰ কৰি উপযোগী সময়ৰ উইণ্ড' বিচাৰি উলিয়াওক।",
    "Search city...": "অনুসন্ধান শহর...",
    "Using selected Kundli": "নিৰ্বাচিত কুণ্ডলী ব্যৱহাৰ কৰি",
    "Find Free": "বিনামূলীয়া বিচাৰি পাওক",
    "Free General Muhurat": "মুক্ত জেনেৰেল মুহুৰত",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "অহা ৭ দিনৰ বাবে শীৰ্ষ ৩ টা স্লট। ৰাহু কাল, যমগণ্ডা আৰু গুলিকা আঁতৰাই দিয়া হয়।",
    "Today's Muhurat": "আজিৰ মুহুৰাত",
    "Daily Muhurat by Kundlistar": "দৈনিক মুহুৰত by Kundlistar",
    "Shared via Kundlistar": "Kundlistar ৰ যোগেদি অংশীদাৰী কৰা হৈছে",
    "Kundlistar Muhurat": "Kundlistar মুহুৰাত",
    "Share Image": "শ্বেয়াৰ ইমেজ",
    "Share Text": "টেক্সট শ্বেয়াৰ কৰক",
    "Copy Text": "লিখনী কপি কৰক",
    "Click Find Free to use the selected Kundli birthplace.": "নিৰ্বাচিত কুণ্ডলী জন্মস্থান ব্যৱহাৰ কৰিবলৈ বিনামূলীয়াকৈ বিচাৰি উলিয়াওক ক্লিক কৰক।",
    "Select a city and click Find Free.": "এখন চহৰ নিৰ্বাচন কৰক আৰু বিনামূলীয়া বিচাৰি উলিয়াওক ক্লিক কৰক।",
    "Premium Personalized Muhurat": "প্ৰিমিয়াম ব্যক্তিগতকৃত মুহুৰাত",
    "Loading Kundli details...": "Kundli বিবরণ লোড হচ্ছে...",
    "Birth Nakshatra": "জন্ম নক্ষত্ৰ",
    "Birth Moon Rashi": "জন্ম চন্দ্ৰ ৰাশি",
    "Include night slots": "ৰাতিৰ স্লট অন্তৰ্ভুক্ত কৰক",
    "Find Premium": "প্ৰিমিয়াম বিচাৰি উলিয়াওক",
    "Your grounding and foundation energy appears strong in this chart.": "এই চাৰ্টত আপোনাৰ গ্ৰাউণ্ডিং আৰু ফাউণ্ডেচন শক্তি শক্তিশালী যেন লাগে।",
    "Your grounding energy appears generally balanced in this chart.": "এই চাৰ্টত আপোনাৰ গ্ৰাউণ্ডিং শক্তি সাধাৰণতে সুষম দেখা যায়।",
    "Reflection on routine, discipline, and inner stability may be useful.": "ৰুটিন, অনুশাসন আৰু আভ্যন্তৰীণ স্থিৰতাৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "Your creative and emotional flow energy appears strong in this chart.": "এই চাৰ্টত আপোনাৰ সৃষ্টিশীল আৰু আৱেগিক প্ৰবাহ শক্তি শক্তিশালী যেন লাগে।",
    "Your creative energy appears balanced in this chart.": "এই চাৰ্টত আপোনাৰ সৃষ্টিশীল শক্তি সুষম যেন লাগে।",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "সৃষ্টিশীলতা, আৱেগিক প্ৰকাশ আৰু আভ্যন্তৰীণ প্ৰবাহৰ ওপৰত চিন্তা-চৰ্চা উপযোগী হ’ব পাৰে।",
    "Your confidence and willpower energy appears strong in this chart.": "এই চাৰ্টত আপোনাৰ আত্মবিশ্বাস আৰু ইচ্ছাশক্তি শক্তি শক্তিশালী যেন লাগে।",
    "Your action-taking energy appears balanced in this chart.": "এই চাৰ্টত আপোনাৰ কাৰ্য্য গ্ৰহণ শক্তি সুষম যেন লাগে।",
    "Reflection on confidence, discipline, and decision power may be useful.": "আত্মবিশ্বাস, অনুশাসন আৰু সিদ্ধান্ত লোৱাৰ ক্ষমতাৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "Your connection and compassion energy appears strong in this chart.": "এই চাৰ্টত আপোনাৰ সংযোগ আৰু কৰুণা শক্তি শক্তিশালী যেন লাগে।",
    "Your emotional connection energy appears balanced in this chart.": "এই চাৰ্টত আপোনাৰ আৱেগিক সংযোগ শক্তি সুষম যেন লাগে।",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "সমন্বয়, ক্ষমা আৰু আৱেগিক ভাৰসাম্যৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "Your communication and expression energy appears strong in this chart.": "এই চাৰ্টত আপোনাৰ যোগাযোগ আৰু প্ৰকাশ শক্তি শক্তিশালী যেন লাগে।",
    "Your expression energy appears balanced in this chart.": "এই চাৰ্টত আপোনাৰ প্ৰকাশ শক্তি সুষম দেখা যায়।",
    "Reflection on clear communication and self-expression may be useful.": "স্পষ্ট যোগাযোগ আৰু আত্মপ্ৰকাশৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "Your intuition and inner clarity appears strong in this chart.": "এই চাৰ্টত আপোনাৰ অন্তৰ্দৃষ্টি আৰু আভ্যন্তৰীণ স্পষ্টতা শক্তিশালী যেন লাগে।",
    "Your intuitive clarity appears balanced in this chart.": "আপোনাৰ স্বজ্ঞাত স্পষ্টতা এই চাৰ্টত সুষম যেন লাগে।",
    "Reflection on focus, intuition, and inner guidance may be useful.": "মনোযোগ, অন্তৰ্দৃষ্টি আৰু আভ্যন্তৰীণ নিৰ্দেশনাৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "A strong Fire element supports action, courage, and leadership energy.": "এটা শক্তিশালী Fire উপাদানে কাৰ্য্য, সাহস, আৰু নেতৃত্ব শক্তিক সমৰ্থন কৰে।",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "জুই সুষম যেন লাগে, ক্ৰিয়া আৰু ধৈৰ্য্যৰ মাজত এক স্থিৰ ছন্দক সমৰ্থন কৰে।",
    "Reflection on confidence and action-taking may be useful.": "আত্মবিশ্বাস আৰু কাৰ্য্য গ্ৰহণৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "A strong Earth element supports practicality, patience, and stability.": "পৃথিৱীৰ এটা শক্তিশালী উপাদানে ব্যৱহাৰিকতা, ধৈৰ্য্য আৰু স্থিৰতাক সমৰ্থন কৰে।",
    "Earth appears balanced, supporting practical thinking with flexibility.": "পৃথিৱীখন সুষম যেন লাগে, নমনীয়তাৰে ব্যৱহাৰিক চিন্তাধাৰাক সমৰ্থন কৰে।",
    "Reflection on grounding, consistency, and planning may be useful.": "গ্ৰাউণ্ডিং, সামঞ্জস্যতা আৰু পৰিকল্পনাৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "A strong Air element supports ideas, communication, and adaptability.": "এটা শক্তিশালী Air উপাদানে ধাৰণা, যোগাযোগ, আৰু অভিযোজন ক্ষমতাক সমৰ্থন কৰে।",
    "Air appears balanced, supporting harmony between thinking and action.": "বায়ু সুষম যেন লাগে, চিন্তা আৰু কাৰ্য্যৰ মাজত সমন্বয়ক সমৰ্থন কৰে।",
    "Reflection on communication and flexibility may be useful.": "যোগাযোগ আৰু নমনীয়তাৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "এটা শক্তিশালী জল উপাদানে অন্তৰ্দৃষ্টি, সংবেদনশীলতা, আৰু আৱেগিক গভীৰতাক সমৰ্থন কৰে।",
    "Water appears balanced, supporting harmony between emotions and logic.": "পানী সুষম যেন লাগে, আৱেগ আৰু যুক্তিৰ মাজত সমন্বয়ক সমৰ্থন কৰে।",
    "Reflection on emotional expression and inner connection may be useful.": "আৱেগিক প্ৰকাশ আৰু আভ্যন্তৰীণ সংযোগৰ ওপৰত চিন্তা কৰাটো উপযোগী হ’ব পাৰে।",
    "A strong Ether element supports spiritual awareness and broader vision.": "এটা শক্তিশালী ইথাৰ উপাদানে আধ্যাত্মিক সজাগতা আৰু বহল দৃষ্টিভংগীক সমৰ্থন কৰে।",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ইথাৰ সুষম যেন লাগে, আধ্যাত্মিক আৰু ব্যৱহাৰিক দৃষ্টিভংগীৰ মাজত সমন্বয়ক সমৰ্থন কৰে।",
    "Reflection, silence, and spiritual discipline may be useful.": "চিন্তা, মৌনতা আৰু আধ্যাত্মিক অনুশাসন উপযোগী হ’ব পাৰে।",
    "For inner confidence, clarity, and soul strength.": "আভ্যন্তৰীণ আত্মবিশ্বাস, স্পষ্টতা, আৰু আত্মাৰ শক্তিৰ বাবে।",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "এই ইষ্ট দেৱতা ইংগিত জন্ম তালিকাৰ পৰা গ্ৰহ শক্তি, লগ্ন প্ৰভু, চন্দ্ৰ ৰাশিৰ প্ৰভু, আৰু আত্মকাৰকৰ ওপৰত ভিত্তি কৰি কৰা হৈছে।",
    "For calmness, emotional balance, and softness.": "শান্তি, আৱেগিক ভাৰসাম্য, আৰু কোমলতাৰ বাবে।",
    "For courage, protection, and discipline.": "সাহস, সুৰক্ষা আৰু অনুশাসনৰ বাবে।",
    "For intellect, speech, learning, and obstacle removal.": "বুদ্ধি, বাক্য, শিক্ষণ, আৰু বাধা আঁতৰোৱাৰ বাবে।",
    "For knowledge, guidance, dharma, and blessings.": "জ্ঞান, পথ প্ৰদৰ্শন, ধৰ্ম, আশীৰ্বাদৰ বাবে।",
    "Mahalakshmi Ji": "মহালক্ষ্মী জী",
    "For harmony, beauty, comfort, and prosperity.": "সমন্বয়, সৌন্দৰ্য্য, আৰাম আৰু সমৃদ্ধিৰ বাবে।",
    "For karma, patience, discipline, and protection.": "কৰ্ম, ধৈৰ্য্য, অনুশাসন, আৰু সুৰক্ষাৰ বাবে।",
    "For protection from confusion, fear, and illusion.": "বিভ্ৰান্তি, ভয়, ভ্ৰমৰ পৰা সুৰক্ষাৰ বাবে।",
    "Lord Ganesha": "ভগৱান গণেশ",
    "For spiritual clarity, detachment, and obstacle removal.": "আধ্যাত্মিক স্পষ্টতা, বিচ্ছিন্নতা, আৰু বাধা আঁতৰোৱাৰ বাবে।",
    "& .MuiLinearProgress-bar": "& .MuiLinearProgress-বাৰ",
    "Chart data is required for Chakra insight.": "চক্ৰ অন্তৰ্দৃষ্টিৰ বাবে চাৰ্টৰ তথ্যৰ প্ৰয়োজন।",
    "Unable to load Chakra insight.": "চক্ৰ অন্তৰ্দৃষ্টি লোড কৰিব পৰা নাই।",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "ইয়েই জন্ম কেৱল কুণ্ডলিভী শক্তিৰ দৃষ্টিশক্তি আৰু আত্ম-প্ৰতিফলন है। ইয়াত পেছাদাৰী পৰামৰ্শ নাই है।",
    "Spiritual energy insights from Kundli": "কুণ্ডলীৰ পৰা আধ্যাত্মিক শক্তিৰ অন্তৰ্দৃষ্টি",
    "Calculated from your individual birth chart": "আপোনাৰ ব্যক্তিগত জন্ম তালিকাৰ পৰা গণনা কৰা",
    "Chakra Balance": "চক্ৰৰ ভাৰসাম্য",
    "Panch Tatva Balance": "পঞ্চ তত্ত্ব ভাৰসাম্য",
    "Ishta Devata": "ইষ্ট দেৱতা",
    "Signal planet": "সংকেত গ্ৰহ",
    "Very Good": "বহুত ভাল",
    "Very Bad": "বৰ বেয়া",
    "Panch Pakshi Calculator - Kundlistar": "পঞ্চ পক্ষী কেলকুলেটৰ - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "চাৰ্টৰ পৰা পঞ্চ পক্ষীক প্ৰিফিল কৰিব পৰা নগ’ল। আপুনি এতিয়াও হস্তচালিতভাৱে গণনা কৰিব পাৰে।",
    "Could not load sunrise and sunset from Panchang for this chart location.": "এই চাৰ্ট স্থানৰ বাবে পাঞ্চাঙৰ পৰা সূৰ্য্য উদয় আৰু সূৰ্যাস্ত লোড কৰিব পৰা নগ'ল।",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "পাঞ্চাঙৰ পৰা সূৰ্য্য উদয়, সূৰ্যাস্ত আৰু পৰৱৰ্তী সূৰ্য্য উদয় লোড কৰিব নোৱাৰি।",
    "Panch Pakshi calculation failed.": "পঞ্চ পক্ষী গণনা ব্যৰ্থ।",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "পঞ্চ পক্ষী চৰাই, কাৰ্যকলাপ, যমম, অপহাৰাৰ সময়, সম্পৰ্ক, স্ক'ৰ আৰু ফলাফল গণনা কৰা।",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "আপোনাৰ বিনামূলীয়া প্ৰিমিয়াম ক্ৰেডিট শেষ হৈ গৈছে। আগবাঢ়ি যাবলৈ প্ৰিমিয়ামলৈ উন্নীত কৰক।",
    "This is a premium feature. You can use 1 free premium credit to continue.": "এইটো এটা প্ৰিমিয়াম বৈশিষ্ট্য। আপুনি আগবাঢ়ি যাবলৈ ১টা বিনামূলীয়া প্ৰিমিয়াম ক্ৰেডিট ব্যৱহাৰ কৰিব পাৰে।",
    "Selected Date": "নিৰ্বাচিত তাৰিখ",
    "repeat(3, 1fr)": "পুনৰাবৃত্তি(৩, ১fr)",
    "Birth Paksha": "জন্ম পক্ষ",
    "Current Paksha": "বৰ্তমানৰ পক্ষ",
    "repeat(4, 1fr)": "পুনৰাবৃত্তি(৪, ১fr)",
    "Target Date Time": "লক্ষ্য তাৰিখ সময়",
    "Next Sunrise": "পৰৱৰ্তী সূৰ্য্য উদয়",
    "Calculate Panch Pakshi": "পঞ্চ পক্ষী গণনা কৰা",
    "repeat(2, 1fr)": "পুনৰাবৃত্তি(২, ১fr)",
    "repeat(6, 1fr)": "পুনৰাবৃত্তি(৬, ১fr)",
    "Birth Pakshi": "জন্ম পক্ষী",
    "Current Period": "বৰ্তমানৰ সময়ছোৱা",
    "Current Yamam": "বৰ্তমানৰ য়ামাম",
    "Main Activity": "মূল কাৰ্য্যকলাপ",
    "Natal Western Chart": "নাটাল পশ্চিমীয়া চাৰ্ট",
    "Life Phase Progression": "জীৱন পৰ্যায়ৰ অগ্ৰগতি",
    "Self-focus, identity change, body awareness and personal reset.": "আত্মকেন্দ্ৰিকতা, পৰিচয় পৰিৱৰ্তন, শৰীৰ সচেতনতা আৰু ব্যক্তিগত ৰিছেট।",
    "Money, values, family, speech and security become emotionally important.": "ধন, মূল্যবোধ, পৰিয়াল, বাক্য আৰু নিৰাপত্তা আৱেগিকভাৱে গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Communication, learning, siblings, writing and short travel become important.": "যোগাযোগ, শিক্ষণ, ভাই-ভনী, লিখা আৰু চুটি ভ্ৰমণ গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Home, mother, property, family and emotional roots become important.": "ঘৰ, মাতৃ, সম্পত্তি, পৰিয়াল আৰু আৱেগিক শিপা গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Creativity, romance, children, hobbies and self-expression become important.": "সৃষ্টিশীলতা, ৰোমাঞ্চ, শিশু, চখ আৰু আত্মপ্ৰকাশ গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Work routine, health habits, service and discipline become important.": "কৰ্ম ৰুটিন, স্বাস্থ্যৰ অভ্যাস, সেৱা আৰু অনুশাসন গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Relationship, marriage, partnership and public dealing become important.": "সম্পৰ্ক, বিবাহ, অংশীদাৰিত্ব আৰু ৰাজহুৱা লেনদেন গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Deep emotional change, intimacy, shared money and transformation become important.": "গভীৰ আৱেগিক পৰিৱৰ্তন, ঘনিষ্ঠতা, ভাগ-বতৰা কৰা ধন আৰু ৰূপান্তৰ গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Learning, travel, teaching, belief and higher wisdom become important.": "শিক্ষণ, ভ্ৰমণ, শিক্ষাদান, বিশ্বাস আৰু উচ্চ প্ৰজ্ঞা গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Career, status, public image and responsibility become emotionally important.": "কেৰিয়াৰ, মৰ্যাদা, ৰাজহুৱা ভাবমূৰ্তি আৰু দায়িত্ব আৱেগিকভাৱে গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Income, friends, networking, community and ambitions become important.": "আয়, বন্ধু, নেটৱৰ্কিং, সম্প্ৰদায় আৰু উচ্চাকাংক্ষা গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "জিৰণি, বিচ্ছিন্নতা, আধ্যাত্মিকতা, বিদেশী সংযোগ আৰু আভ্যন্তৰীণ নিৰাময় গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Identity development and self-expression are central.": "পৰিচয় বিকাশ আৰু আত্মপ্ৰকাশ কেন্দ্ৰীয়।",
    "Values, money and self-worth become central.": "মূল্যবোধ, ধন আৰু আত্মমূল্য কেন্দ্ৰীয় হৈ পৰে।",
    "Communication, learning and skills become central.": "যোগাযোগ, শিক্ষণ আৰু দক্ষতা কেন্দ্ৰীয় হৈ পৰে।",
    "Home, roots and emotional foundation become central.": "ঘৰ, শিপা আৰু আৱেগিক ভেটি কেন্দ্ৰীয় হৈ পৰে।",
    "Creativity, love and self-expression become central.": "সৃষ্টিশীলতা, প্ৰেম আৰু আত্মপ্ৰকাশ কেন্দ্ৰীয় হৈ পৰে।",
    "Work, discipline and health routines become central.": "কৰ্ম, অনুশাসন আৰু স্বাস্থ্যৰ ৰুটিন কেন্দ্ৰীয় হৈ পৰে।",
    "Partnerships and relationship identity become central.": "অংশীদাৰিত্ব আৰু সম্পৰ্কৰ পৰিচয় কেন্দ্ৰীয় হৈ পৰে।",
    "Transformation, deep healing and shared resources become central.": "ৰূপান্তৰ, গভীৰ নিৰাময় আৰু ভাগ-বতৰা কৰা সম্পদ কেন্দ্ৰীয় হৈ পৰে।",
    "Wisdom, travel, belief and higher learning become central.": "প্ৰজ্ঞা, ভ্ৰমণ, বিশ্বাস আৰু উচ্চ শিক্ষা কেন্দ্ৰীয় হৈ পৰে।",
    "Career, authority and public role become central.": "কেৰিয়াৰ, কৰ্তৃত্ব আৰু ৰাজহুৱা ভূমিকা কেন্দ্ৰীয় হৈ পৰে।",
    "Community, income, goals and networks become central.": "সম্প্ৰদায়, আয়, লক্ষ্য আৰু নেটৱৰ্ক কেন্দ্ৰীয় হৈ পৰে।",
    "Spirituality, closure, retreat and inner development become central.": "আধ্যাত্মিকতা, বন্ধ, পিছুৱাই যোৱা আৰু আভ্যন্তৰীণ বিকাশ কেন্দ্ৰীয় হৈ পৰে।",
    "This house becomes emotionally important.": "এই ঘৰটো আৱেগিকভাৱে গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "This house becomes central for identity development.": "এই ঘৰটো পৰিচয় বিকাশৰ বাবে কেন্দ্ৰীয় হৈ পৰে।",
    "Thinking, communication, learning and decisions are developing through this house.": "এই ঘৰৰ জৰিয়তে চিন্তা, যোগাযোগ, শিক্ষণ আৰু সিদ্ধান্তৰ বিকাশ ঘটিছে।",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "প্ৰেম, আৰাম, মূল্যবোধ, সৌন্দৰ্য্য আৰু ধনৰ পছন্দ এই ঘৰৰ জৰিয়তে গঢ় লৈ উঠিছে।",
    "Action style, courage, ambition and drive are developing through this house.": "এই ঘৰৰ জৰিয়তে একচন ষ্টাইল, সাহস, উচ্চাকাংক্ষা আৰু ড্ৰাইভৰ বিকাশ ঘটিছে।",
    "Growth, faith, learning and expansion themes develop through this house.": "এই ঘৰৰ জৰিয়তে বৃদ্ধি, বিশ্বাস, শিক্ষণ আৰু সম্প্ৰসাৰণৰ বিষয়বস্তু বিকশিত হয়।",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "এই ঘৰৰ জৰিয়তে পৰিপক্কতা, দায়িত্ব, অনুশাসন আৰু দীৰ্ঘম্যাদী গাঁথনিৰ বিকাশ ঘটে।",
    "This progressed planet shows an inner life phase through this house.": "এই প্ৰগতিশীল গ্ৰহটোৱে এই ঘৰটোৰ মাজেৰেই এটা আভ্যন্তৰীণ জীৱন পৰ্যায় দেখুৱাইছে।",
    "New Moon Phase": "অমাৱস্যাৰ পৰ্যায়",
    "New beginning, identity reset and fresh internal cycle.": "নতুন আৰম্ভণি, পৰিচয় ৰিছেট আৰু সতেজ আভ্যন্তৰীণ চক্ৰ।",
    "Crescent Phase": "ক্ৰেচেণ্ট ফেজ",
    "Growth, effort, learning and building confidence.": "বৃদ্ধি, প্ৰচেষ্টা, শিক্ষণ আৰু আত্মবিশ্বাস গঢ়ি তোলা।",
    "First Quarter Phase": "প্ৰথম ত্ৰৈমাসিক পৰ্যায়",
    "Action, decision-making, pressure and development.": "কাৰ্য্য, সিদ্ধান্ত গ্ৰহণ, হেঁচা আৰু বিকাশ।",
    "Gibbous Phase": "গিবাছ ফেজ",
    "Refinement, improvement, preparation and skill-building.": "পৰিশোধন, উন্নতি, প্ৰস্তুতি আৰু দক্ষতা-নিৰ্মাণ।",
    "Full Moon Phase": "পূৰ্ণিমা পৰ্যায়",
    "Visibility, relationship awareness, emotional clarity and results.": "দৃশ্যমানতা, সম্পৰ্ক সচেতনতা, আৱেগিক স্পষ্টতা আৰু ফলাফল।",
    "Disseminating Phase": "প্ৰচাৰৰ পৰ্যায়",
    "Sharing, teaching, communication and distributing experience.": "অভিজ্ঞতা ভাগ-বতৰা, পাঠদান, যোগাযোগ আৰু বিতৰণ কৰা।",
    "Last Quarter Phase": "শেষ ত্ৰৈমাসিকৰ পৰ্যায়",
    "Reorientation, correction, release and mature decision-making.": "পুনৰ অভিমুখীতা, সংশোধন, মুক্তি আৰু পৰিপক্ক সিদ্ধান্ত গ্ৰহণ।",
    "Balsamic Phase": "বালচামিক পৰ্যায়",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "বন্ধ, আধ্যাত্মিক প্ৰতিফলন, বিশ্ৰাম আৰু নতুন চক্ৰৰ বাবে প্ৰস্তুতি।",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "এটা ডাঙৰ আৱেগিক আৰু পৰিচয়ৰ পৰ্যায় আৰম্ভ হয়। ব্যক্তিজনে নতুন অধ্যায়ৰ বাবে সাজু অনুভৱ কৰিব পাৰে।",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "আৱেগিক ৰিছেটৰ সময়। পৰিয়াল, আৰাম, আভ্যন্তৰীণ শান্তি আৰু আৱেগিক প্ৰয়োজনীয়তা গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "প্ৰেম, সম্পৰ্ক, আৰাম, সৌন্দৰ্য্য আৰু আৱেগিক বন্ধন গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "Emotional needs and relationship expectations may need adjustment.": "আৱেগিক প্ৰয়োজন আৰু সম্পৰ্কৰ আশাৰ সালসলনিৰ প্ৰয়োজন হ’ব পাৰে।",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "শক্তি, আবেগ, অধৈৰ্য্যতা আৰু কৰ্ম বৃদ্ধি পায়। আৱেগিক প্ৰতিক্ৰিয়া দ্ৰুত হ’ব পাৰে।",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "আৱেগিক অস্থিৰতা, খং, সংঘাত বা জৰুৰী পদক্ষেপ বাঢ়িব পাৰে।",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "এটা গুৰুতৰ আৱেগিক পৰ্যায়। দায়িত্ব, পৰিপক্কতা, পৰিয়ালৰ চাপ বা আভ্যন্তৰীণ অনুশাসন বৃদ্ধি পাব পাৰে।",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "আৱেগিক গধুৰতা বা দায়িত্ববোধ অনুভৱ কৰিব পাৰে। ধৈৰ্য্য আৰু পৰিপক্কতাৰ প্ৰয়োজন।",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "সহায়ক আৱেগিক বৃদ্ধি, আশাবাদ, ভ্ৰমণ, শিক্ষণ আৰু আশীৰ্বাদ বৃদ্ধি পাব পাৰে।",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "এটা বৃদ্ধিমুখী আৱেগিক পৰ্যায়। শিক্ষণ, সম্প্ৰসাৰণ, সমৰ্থন আৰু ইতিবাচক সিদ্ধান্তৰ বাবে ভাল।",
    "Identity, love, beauty, money values and creative expression become highlighted.": "পৰিচয়, প্ৰেম, সৌন্দৰ্য্য, ধনৰ মূল্যবোধ আৰু সৃষ্টিশীল প্ৰকাশক উজ্জ্বল হৈ পৰে।",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "আত্মবিশ্বাস, সাহস, উচ্চাকাংক্ষা আৰু কৰ্ম বৃদ্ধি পায়। নতুন সক্ৰিয় পৰ্যায় আৰম্ভ কৰাৰ বাবে ভাল।",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "এটা পৰিপক্কতা পৰীক্ষা। দায়িত্ব, পলম, হেঁচা বা কেৰিয়াৰৰ পুনৰ্গঠন হ’ব পাৰে।",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "বৃদ্ধি, আত্মবিশ্বাস, প্ৰজ্ঞা, স্বীকৃতি আৰু সুযোগ বৃদ্ধি পাব পাৰে।",
    "Mental clarity, communication, study, writing and business decisions become important.": "মানসিক স্পষ্টতা, যোগাযোগ, অধ্যয়ন, লিখা আৰু ব্যৱসায়িক সিদ্ধান্ত গুৰুত্বপূৰ্ণ হৈ পৰে।",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "আৰম্ভ হয় এক নতুন মানসিক চক্ৰ। শিক্ষণ, যোগাযোগ, লিখা আৰু দক্ষতা বিকাশৰ বাবে ভাল।",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "প্ৰেম, সৌন্দৰ্য্য, আৰাম, সামাজিক জীৱন আৰু মূল্যবোধ পৰিচয়ৰ সৈতে শক্তিশালীভাৱে সংযুক্ত হৈ পৰে।",
    "Action, confidence, ambition and personal drive become stronger.": "কাৰ্য্য, আত্মবিশ্বাস, উচ্চাকাংক্ষা আৰু ব্যক্তিগত ড্ৰাইভ অধিক শক্তিশালী হৈ পৰে।",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "প্ৰগ্ৰেছড মাৰ্কিউৰীয়ে শিক্ষণ, যোগাযোগ, ব্যৱসায়, লিখা, বিপণন, ক’ডিং বা বিশ্লেষণাত্মক কামত সহায় কৰে।",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "প্ৰগ্ৰেছড মংগলে কাৰ্য্য, সাহস, প্ৰতিযোগিতা, কাৰিকৰী কাম আৰু সক্ৰিয় কেৰিয়াৰ সিদ্ধান্তক সমৰ্থন কৰে।",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "প্ৰগ্ৰেছড ভেনাছে আৰ্থিক মূল্যবোধ, আৰাম, লাভ, বিলাসীতা, শিল্প বা সম্পৰ্কভিত্তিক আয়ৰ বিষয়বস্তু সমৰ্থন কৰে।",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "প্ৰগতিশীল বৃহস্পতিয়ে বৃদ্ধিমুখী আৰ্থিক চিন্তাধাৰা আৰু সম্পদৰ সম্প্ৰসাৰণ দেখুৱাব পাৰে।",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "কেৰিয়াৰ পৰ্যায়টো প্ৰগতিশীল সূৰ্য্য, চন্দ্ৰ, বুধ, মংগল আৰু জন্মগত সূৰ্য্য, শনি আৰু মধ্যস্বৰ্গলৈকে দিশসমূহৰ পৰা বিচাৰ কৰিব লাগে।",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "প্ৰেমৰ পৰ্যায়টো প্ৰগতিশীল চন্দ্ৰ, শুক্ৰ, মংগল আৰু দিশৰ পৰা জন্ম চন্দ্ৰ, শুক্ৰ, মংগল আৰু ৭ম স্থানলৈকে বিচাৰ কৰিব লাগে।",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "ধনৰ পৰ্যায়টো প্ৰগতিশীল চন্দ্ৰ, শুক্ৰ, বৃহস্পতি আৰু জন্মৰ ২য়, অষ্টম আৰু একাদশ ঘৰৰ সংযোগৰ পৰা বিচাৰ কৰিব লাগে।",
    "Western Astrology - Kundlistar": "পশ্চিম জ্যোতিষ - Kundlistar",
    "No chart data available for preview": "পূৰ্বদৰ্শনৰ বাবে কোনো চাৰ্ট তথ্য উপলব্ধ নহয়",
    "Failed to load chart": "চাৰ্ট লোড কৰাত ব্যৰ্থ",
    "Chart not found": "চাৰ্ট পোৱা নগ'ল",
    "Western Astrology Module | Kundlistar": "পশ্চিমীয়া জ্যোতিষ মডিউল | __কেডিএল_মাস্ক_০__",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "Kundlistar ৰ ভিতৰত পশ্চিমীয়া জ্যোতিষ অন্বেষণ কৰক জন্মৰ চাৰ্টৰ অৱস্থান, প্লেচিডাছ হাউচ কাস্প, বাহিৰৰ গ্ৰহ আৰু প্ৰিমিয়াম ট্ৰেনজিট, সৌৰ ৰিটাৰ্ণ আৰু চিনাষ্ট্ৰি বৈশিষ্ট্যৰ সৈতে।",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "পশ্চিমীয়া জ্যোতিষ, জন্ম তালিকা, ট্ৰেনজিট, সৌৰ উভতি অহা, synastry, Kundlistar",
    "New section": "নতুন শিতান",
    "Premium active": "প্ৰিমিয়াম সক্ৰিয়",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "সৰ্বনিম্ন সৰ্বোচ্চ(৩৬০px, ০.৮৫fr) নূন্যতম সৰ্বোচ্চ(০, ১.১৫fr)",
    "House System": "ঘৰ ব্যৱস্থা",
    "Placidus cusps": "প্লেচিডাছ কাস্প",
    "Part of Fortune": "ফৰ্চুনৰ অংশ",
    "Natal Western Aspects": "নাটাল পশ্চিমীয়া দিশ",
    "No major Western aspects found within the configured orbs.": "বিন্যাস কৰা গোলকসমূহৰ ভিতৰত কোনো ডাঙৰ পশ্চিমীয়া দিশ পোৱা নগ'ল।",
    "Western natal astrology wheel": "পশ্চিমীয়া জন্ম জ্যোতিষ চকা",
    "Western Transits": "পশ্চিমীয়া ট্ৰেনজিট",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "লোড কৰা চাৰ্ট জন্মস্থান ব্যৱহাৰ কৰি বৰ্তমানৰ ট্ৰেনজিট-টু-নেটেল গণনা।",
    "Natal points available": "প্ৰসৱৰ পইণ্ট উপলব্ধ",
    "Transit planets loaded": "ট্ৰেনজিট গ্ৰহ লোড",
    "Loading current transit positions...": "বর্তমান ট্ৰেনজিট অবস্থান লোড...",
    "Aspect method": "দিশ পদ্ধতি",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "পশ্চিমীয়া গোলকৰ সৈতে সংযোগ, যৌনতা, বৰ্গক্ষেত্ৰ, ত্ৰিশ আৰু বিৰোধিতা",
    "Primary focus": "প্ৰাথমিক মনোযোগ",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "জন্মগত সূৰ্য্য, চন্দ্ৰ, আৰোহী, শুক্ৰ, মংগল, বৃহস্পতি, শনি আৰু বাহ্যিক গ্ৰহলৈ ট্ৰেনজিট সংস্পৰ্শ",
    "Natal inner wheel": "নেটাল ভিতৰৰ চকা",
    "Transit outer wheel": "ট্ৰেনজিট বাহিৰৰ চকা",
    "Current Transit Positions": "বৰ্তমানৰ ট্ৰেনজিট অৱস্থান",
    "Transit positions are not available.": "ট্ৰেনজিটৰ পদ উপলব্ধ নহয়।",
    "Current Transit Aspects to Natal Chart": "নেটাল চাৰ্টলৈ বৰ্তমানৰ ট্ৰেনজিট দিশ",
    "Loading transit aspects...": "ট্ৰেনজিট দিশসমূহ লোড কৰি আছে...",
    "No major transit aspects found within the configured orbs.": "বিন্যাস কৰা গোলকসমূহৰ ভিতৰত কোনো ডাঙৰ ট্ৰেনজিট দিশ পোৱা নগ'ল।",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "জন্মসূৰ্য্যৰ পৰা বাৰ্ষিক পশ্চিমীয়া উভতি অহাৰ উল্লেখ, সমৰ্থনকাৰী জন্মগত দিশৰ প্ৰসংগৰ সৈতে।",
    "Solar return date": "সৌৰ ঘূৰি অহাৰ তাৰিখ",
    "Calculation time": "গণনাৰ সময়",
    "Birth date not available": "জন্ম তাৰিখ উপলব্ধ নহয়",
    "Natal Sun": "নাটাল ছান",
    "Natal Sun house": "নাটাল ছান হাউচ",
    "Return planets loaded": "উভতি অহা গ্ৰহবোৰ লোড কৰা",
    "Loading solar return chart...": "সৌৰ ৰিটাৰ্ণ চাৰ্ট লোড কৰা হৈছে...",
    "Annual focus": "বাৰ্ষিক গুৰুত্ব",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "সৌৰ থিমসমূহ জন্মসূৰ্য্য, ৰিটাৰ্ণ এচেণ্ডেণ্ট আৰু বছৰেকীয়া ৰিটাৰ্ণ চাৰ্টৰ পৰা পঢ়া হয়।",
    "Solar Return Planet Positions": "সৌৰ উভতি অহা গ্ৰহৰ অৱস্থান",
    "Loading solar return planets...": "লোডিং সৌৰ ৰিটাৰ্ণ গ্ৰহ...",
    "Solar return positions are not available.": "সৌৰ ঘূৰি অহাৰ স্থান উপলব্ধ নহয়।",
    "Solar Return House Cusps": "সৌৰ ৰিটাৰ্ণ হাউচ Cusps",
    "Loading solar return cusps...": "লোডিং সৌৰ ৰিটাৰ্ণ cusps...",
    "Solar return house cusps are not available.": "সৌৰ ৰিটাৰ্ণ হাউচ কাস্প উপলব্ধ নহয়।",
    "Solar Return Aspects to Natal Chart": "জন্মৰ চাৰ্টলৈ সৌৰ প্ৰত্যাৱৰ্তনৰ দিশ",
    "Loading solar return aspects...": "সৌৰ ৰিটাৰ্ণ দিশসমূহ লোড কৰি আছে...",
    "No major solar return aspects found within the configured orbs.": "কনফিগাৰ কৰা গোলকসমূহৰ ভিতৰত কোনো ডাঙৰ সৌৰ ঘূৰি অহাৰ দিশ পোৱা নাযায়।",
    "Natal Sun Aspects for Solar Return Focus": "সৌৰ ৰিটাৰ্ণ ফ'কাচৰ বাবে নেটাল সূৰ্য্যৰ দিশ",
    "No major natal Sun aspects found within the configured orbs.": "কনফিগাৰ কৰা গোলকসমূহৰ ভিতৰত কোনো ডাঙৰ জন্মগত সূৰ্য্যৰ দিশ পোৱা নগ'ল।",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "গ্ৰহৰ পৰা গ্ৰহলৈ দিশ, কোণৰ সংস্পৰ্শ আৰু ঘৰৰ ওভাৰলে ব্যৱহাৰ কৰি সম্পৰ্ক অভাৰলে কাঠামো।",
    "Loaded first chart": "প্ৰথম চাৰ্ট লোড কৰা হৈছে",
    "Second chart": "দ্বিতীয় চাৰ্ট",
    "Select or load partner chart to calculate full synastry overlay": "সম্পূৰ্ণ চিনেষ্ট্ৰি অভাৰলে গণনা কৰিবলে অংশীদাৰ লেখচিত্ৰ নিৰ্ব্বাচন কৰক বা লোড কৰক",
    "Major inter-chart aspects with tight orb priority": "টাইট অৰ্ব অগ্ৰাধিকাৰৰ সৈতে প্ৰধান আন্তঃ-চাৰ্ট দিশ",
    "House overlay method": "হাউচ অভাৰলে পদ্ধতি",
    "Partner planets are placed into the first chart houses after second chart is selected": "দ্বিতীয় চাৰ্ট নিৰ্বাচন কৰাৰ পিছত অংশীদাৰ গ্ৰহসমূহক প্ৰথম চাৰ্ট হাউচত ৰখা হয়",
    "Relationship Pattern Aspects from Loaded Chart": "লোড কৰা চাৰ্টৰ পৰা সম্পৰ্ক আৰ্হিৰ দিশসমূহ",
    "No major relationship-focused natal aspects found within the configured orbs.": "কনফিগাৰ কৰা গোলকসমূহৰ ভিতৰত কোনো ডাঙৰ সম্পৰ্ক-কেন্দ্ৰিক জন্মগত দিশ পোৱা নাযায়।",
    "Understand your current inner life phase through Western Secondary Progressions.": "পশ্চিমীয়া মাধ্যমিক অগ্ৰগতিৰ জৰিয়তে আপোনাৰ বৰ্তমানৰ আভ্যন্তৰীণ জীৱনৰ পৰ্যায়টো বুজি লওক।",
    "Secondary Progression": "মাধ্যমিক অগ্ৰগতি",
    "1 day after birth = 1 year of life": "জন্মৰ ১ দিন = আয়ুসৰ ১ বছৰ",
    "Current age used": "বৰ্তমান ব্যৱহৃত বয়স",
    "Progressed date": "প্ৰগতিশীল তাৰিখ",
    "Progressed Moon": "প্ৰগতিশীল চন্দ্ৰ",
    "Loading progressed Moon...": "লোডিং অগ্ৰগতি চন্দ্ৰ...",
    "Progressed Moon phase": "প্ৰগতিশীল চন্দ্ৰ পৰ্যায়",
    "Loading Moon phase...": "লোডিং চন্দ্ৰ পৰ্যায়...",
    "Current Life Phase": "বৰ্তমান জীৱন পৰ্যায়",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "গৌণ অগ্ৰগতিই জীৱনৰ আভ্যন্তৰীণ পৰ্যায়, আৱেগিক পৰিপক্কতা, পৰিচয় বিকাশ আৰু পৰিৱৰ্তিত অগ্ৰাধিকাৰ দেখুৱাইছে।",
    "Progressed Career Phase": "প্ৰগতিশীল কেৰিয়াৰ পৰ্যায়",
    "Progressed Love Phase": "প্ৰগতিশীল প্ৰেমৰ পৰ্যায়",
    "Progressed Money Phase": "প্ৰগতিশীল ধনৰ পৰ্যায়",
    "Loading progressed planets...": "লোডিং অগ্ৰগতি গ্ৰহ...",
    "Progressed planets are not available.": "প্ৰগতিশীল গ্ৰহ উপলব্ধ নহয়।",
    "Loading progressed aspects...": "লোডিং অগ্ৰগতি দিশসমূহ...",
    "No tight progressed-to-natal aspects found right now.": "বৰ্তমান কোনো টাইট প্ৰগ্ৰেছড-টু-নেটেল দিশ পোৱা নাযায়।",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "এই পৰ্যায়টো প্ৰগতিশীল গ্ৰহ, প্ৰগতিশীল চন্দ্ৰ পৰ্যায় আৰু টাইট প্ৰগতিশীল-প্ৰসৱৰ দিশৰ পৰা বিচাৰ কৰিব লাগে।",
    "Vastu Analysis - Kundlistar": "বাস্তু বিশ্লেষণ - Kundlistar",
    "Failed to load selected chart.": "নিৰ্বাচিত চাৰ্ট লোড কৰাত ব্যৰ্থ।",
    "Facing Direction": "দিশৰ সন্মুখীন হোৱা",
    "Entrance Direction": "প্ৰৱেশৰ দিশ",
    "Kitchen Direction": "পাকঘৰৰ দিশ",
    "Master Bedroom": "মাষ্টাৰ বেডৰুম",
    "Children Bedroom": "শিশুৰ শোৱা কোঠা",
    "Toilet Direction": "শৌচাগাৰৰ দিশ",
    "Pooja Direction": "পূজাৰ দিশ",
    "Water Tank": "পানীৰ টেংকি",
    "Underground Water": "ভূগৰ্ভস্থ পানী",
    "Heavy Storage": "গধুৰ সংৰক্ষণ",
    "Living Room": "চৰা-ঘৰ",
    "Study Room": "অধ্যয়ন কক্ষ",
    "Vastu report generation failed.": "বাস্তু প্ৰতিবেদন প্ৰজন্ম ব্যৰ্থ।",
    "Please generate the Vastu report before downloading.": "অনুগ্ৰহ কৰি ডাউনলোড কৰাৰ আগতে বাস্তু প্ৰতিবেদন সৃষ্টি কৰক।",
    "Failed to download Vastu report.": "বাস্তু প্ৰতিবেদন ডাউনলোড কৰাত ব্যৰ্থ।",
    "Premium Feature": "প্ৰিমিয়াম বৈশিষ্ট্য",
    "Selected Chart": "নিৰ্বাচিত চাৰ্ট",
    "Basic + KP + BNN from chart": "চাৰ্টৰ পৰা বেচিক + কেপি + বিএনএন",
    "Basic shown, KP + BNN locked": "বেচিক দেখুওৱা হৈছে, KP + BNN লক কৰা হৈছে",
    "Property Type": "বৈশিষ্ট্যৰ ধৰণ",
    "Center Area": "চেণ্টাৰ এৰিয়া",
    "Generate Vastu Report": "বাস্তু প্ৰতিবেদন সৃষ্টি কৰক",
    "Basic Vastu Analysis": "মৌলিক বাস্তু বিশ্লেষণ",
    "KP Vastu Analysis": "কে পি বাস্তু বিশ্লেষণ",
    "BNN Vastu Analysis": "বিএনএন বাস্তু বিশ্লেষণ",
    "North East": "উত্তৰ পূৰ্বাঞ্চল",
    "South East": "দক্ষিণ-পূব",
    "South West": "দক্ষিণ পশ্চিম",
    "North West": "উত্তৰ পশ্চিম",
    "Red Coral": "ৰঙা প্ৰবাল",
    "Yellow Sapphire": "হালধীয়া নীলা",
    "Blue Sapphire": "নীলা নীলা",
    "Cat's Eye": "মেকুৰীৰ চকু",
    "Additional Option": "অতিৰিক্ত বিকল্প",
    "Lagna rule supports this gemstone option.": "লগ্ন নিয়মে এই ৰত্ন বিকল্প সমৰ্থন কৰে।",
    "Moon sign rule supports this gemstone option.": "চন্দ্ৰ ৰাশিৰ নিয়মে এই ৰত্ন বিকল্পটো সমৰ্থন কৰে।",
    "Birth date rule supports this gemstone option.": "জন্ম তাৰিখ নিয়মে এই ৰত্ন বিকল্পটো সমৰ্থন কৰে।",
    "Birth weekday rule supports this gemstone option.": "জন্ম সপ্তাহৰ দিনৰ নিয়মে এই ৰত্ন বিকল্প সমৰ্থন কৰে।",
    "Current dasha rule supports this gemstone option.": "বৰ্তমানৰ দশা নিয়মে এই ৰত্ন বিকল্প সমৰ্থন কৰে।",
    "Age-band rule supports this gemstone option.": "বয়স-বেণ্ড নিয়মে এই ৰত্ন বিকল্পটো সমৰ্থন কৰে।",
    "Selected goal supports this gemstone option.": "নিৰ্বাচিত লক্ষ্যই এই ৰত্ন বিকল্প সমৰ্থন কৰে।",
    "Profession rule supports this gemstone option.": "পেছাৰ নিয়মে এই ৰত্ন বিকল্পটো সমৰ্থন কৰে।",
    "Name-initial rule supports this gemstone option.": "নাম-প্ৰাথমিক নিয়মে এই ৰত্ন বিকল্প সমৰ্থন কৰে।",
    "Moolank rule supports this gemstone option.": "Moolank নিয়মে এই ৰত্ন বিকল্প সমৰ্থন কৰে।",
    "Chart condition check was considered for this option.": "এই বিকল্পৰ বাবে চাৰ্টৰ অৱস্থা পৰীক্ষা কৰাটো বিবেচনা কৰা হৈছিল।",
    "Rule-based chart match supports this gemstone option.": "নিয়ম-ভিত্তিক চাৰ্ট মিলে এই ৰত্ন বিকল্প সমৰ্থন কৰে।",
    "Expert kundli review is recommended before wearing this gemstone.": "এই ৰত্ন পিন্ধাৰ আগতে বিশেষজ্ঞ কুণ্ডলি পৰ্যালোচনা কৰাটো বাঞ্ছনীয়।",
    "Ring finger": "আঙুলিৰ আঙঠি",
    "Little finger": "সৰু আঙুলি",
    "Index finger": "তৰ্জনী আঙুলি",
    "Middle finger": "মধ্যমা আঙুলি",
    "Why recommended": "কিয় পৰামৰ্শ দিয়া হৈছে",
    "Approx weight": "প্ৰায় ওজন",
    "Could not load chart.": "চাৰ্ট লোড কৰিব পৰা নগ'ল।",
    "Gemstone Recommendations | Kundlistar": "ৰত্ন পৰামৰ্শ | __কেডিএল_মাস্ক_০__",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar ৰ নিয়মভিত্তিক কুণ্ডলি বিশ্লেষণ ইঞ্জিনৰ পৰা বৈদিক ৰত্ন পৰামৰ্শসমূহ অন্বেষণ কৰক।",
    "noindex,nofollow": "noindex,nofollow নহয়",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "ৰত্ন পৰামৰ্শ, বৈদিক ৰত্ন, কুণ্ডলী ৰত্ন, Kundlistar",
    "Gemstone Recommendations": "ৰত্নশিলৰ পৰামৰ্শ",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "লগ্ন, চন্দ্ৰ ৰাশি, দশা, DOB, বৃত্তি আৰু লক্ষ্যৰ ওপৰত ভিত্তি কৰি বৈদিক ৰত্ন নিৰ্দেশনাৰ বাবে পৃথক Kundlistar মডিউল।",
    "Personalized Gemstone Recommendations are available for Premium users.": "প্ৰিমিয়াম ব্যৱহাৰকাৰীৰ বাবে ব্যক্তিগতকৃত ৰত্ন পৰামৰ্শ উপলব্ধ।",
    "Upgrade to Premium": "প্ৰিমিয়ামলৈ উন্নীত কৰক",
    "Login to Upgrade": "উন্নয়ন কৰিবলৈ লগইন কৰক",
    "Select Goal": "লক্ষ্য নিৰ্বাচন কৰক",
    "Business, government job, teacher...": "ব্যৱসায়, চৰকাৰী চাকৰি, শিক্ষক...",
    "Weight kg": "ওজন কে.জি",
    "वजन kg": "ত কেজি",
    "Optional ratti estimate": "ঐচ্ছিক ৰাতি অনুমান",
    "Click Calculate to apply these values.": "এই মানসমূহ প্ৰয়োগ কৰিবলে গণনা কৰক ক্লিক কৰক।",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{হিন্দী নেকি ?",
    "Nadi Analysis": "নাদি বিশ্লেষণ",
    "KP Analysis": "কে পি বিশ্লেষণ",
    "Vedic Analysis": "বৈদিক বিশ্লেষণ",
    "BNN Analysis": "বিএনএন বিশ্লেষণ",
    "Jaimini Analysis": "জয়মিণী বিশ্লেষণ",
    "Western Astrology": "পশ্চিমীয়া জ্যোতিষ",
    "Panch Pakshi": "পঞ্চ পক্ষী",
    "Tithi Pravesh": "তিথি প্ৰবেশ",
    "Lal Kitab": "লাল কিতাব",
    "Astro Logo": "এষ্ট্ৰ' ল'গ'",
    "Download failed": "ডাউনলোড বিফল",
    "Could not download PDF report.": "PDF প্ৰতিবেদন ডাউনলোড কৰিব পৰা নগ'ল।",
    "Please login to download PDF reports.": "PDF প্ৰতিবেদন ডাউনলোড কৰিবলৈ অনুগ্ৰহ কৰি লগইন কৰক।",
    "Failed to generate personalised report": "ব্যক্তিগতকৃত প্ৰতিবেদন সৃষ্টি কৰাত ব্যৰ্থ",
    "Could not download personalised report.": "ব্যক্তিগতকৃত প্ৰতিবেদন ডাউনলোড কৰিব পৰা নগ'ল।",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "calc(100vh - var(--kundlistar-navbar-উচ্চতা, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(--kundlistar-navbar-উচ্চতা, 160px))",
    "width 0.2s ease": "প্ৰস্থ ০.২ছেকেণ্ড সহজ",
    "Collapse sidebar": "চাইডবাৰ ভাঙি পেলাওক",
    "Expand sidebar": "চাইডবাৰ প্ৰসাৰিত কৰক",
    "& .MuiListItemIcon-root": "& .MuiListItemআইকন-ৰুট",
    "Download PDF Report": "PDF প্ৰতিবেদন ডাউনলোড কৰক",
    "Login to download": "ডাউনলোড কৰিবলৈ লগইন কৰক",
    "PDF Report": "পিডিএফ প্ৰতিবেদন",
    "Download Personal Report": "ব্যক্তিগত প্ৰতিবেদন ডাউনলোড কৰক",
    "Buy Premium to download": "ডাউনলোড কৰিবলৈ প্ৰিমিয়াম কিনিব",
    "Login to buy Premium": "প্ৰিমিয়াম কিনিবলৈ লগইন কৰক",
    "Buy Premium": "প্ৰিমিয়াম কিনিব",
    "& .MuiTab-root": "& .MuiTab-মূল",
    "& .Mui-selected": "& .মুই-নিৰ্বাচিত",
    "Unable to load Client Management data.": "ক্লাএন্ট ব্যৱস্থাপনা তথ্য লোড কৰিবলে অক্ষম।",
    "Unable to download PDF.": "পিডিএফ ডাউনলোড কৰিব পৰা নাই।",
    "Free client limit reached": "বিনামূলীয়া ক্লায়েণ্ট সীমাত উপনীত হৈছে",
    "Welcome": "স্বাগতম",
    "Hello": "নমস্কাৰ",
    "Your saved charts are shown below.": "আপোনাৰ সংৰক্ষিত চাৰ্টসমূহ তলত দেখুওৱা হৈছে।",
    "All Features": "সকলো বৈশিষ্ট্য",
    "New Chart": "নতুন চাৰ্ট",
    "Vedic Chart": "বৈদিক চাৰ্ট",
    "Chakra": "চক্ৰ",
    "Daily Panchang": "দৈনিক পঞ্চাং",
    "Choghadiya": "চোঘাদিয়া",
    "Daily Horoscope": "দৈনিক ৰাশিফল",
    "Gochar Alerts": "গোচৰ সতৰ্কতা",
    "Matching": "মিল থকা",
    "Ruling Planets": "শাসকীয় গ্ৰহ",
    "Horary Chart": "হৰেৰী চাৰ্ট",
    "Astro-Vastu": "জ্যোতিৰ্-বাস্তু",
    "Vedic Numerology": "বৈদিক সংখ্যা বিজ্ঞান",
    "My Charts": "মোৰ চাৰ্টসমূহ",
    "Search by Name": "নামেৰে সন্ধান কৰক",
    "Type": "প্ৰকাৰ",
    "All": "আটাইবোৰ",
    "Individual": "ব্যক্তিকেন্দ্ৰিক",
    "Horary": "হৰেৰী",
    "Clear": "পৰিষ্কাৰ",
    "Name": "নাম",
    "DOB": "DOB",
    "Place": "স্থান",
    "Gender": "লিংগ",
    "Created": "সৃষ্টি কৰা হৈছে",
    "Actions": "কাৰ্য্য",
    "Male": "পুৰুষ",
    "Female": "মহিলা",
    "No matching charts found": "কোনো মিল থকা চাৰ্ট পোৱা নগ'ল",
    "Create First Chart": "প্ৰথম চাৰ্ট তৈয়াৰ কৰক",
    "View Chart": "চাৰ্ট চাওক",
    "Copy Share Link": "শ্বেয়াৰ লিংক কপি কৰক",
    "Use premium credit: Download PDF Report": "প্ৰিমিয়াম ক্ৰেডিট ব্যৱহাৰ কৰক: পিডিএফ প্ৰতিবেদন ডাউনলোড কৰক",
    "Download Personalised Report": "ব্যক্তিগতকৃত প্ৰতিবেদন ডাউনলোড কৰক",
    "Premium: Download Personalised Report": "প্ৰিমিয়াম: ব্যক্তিগতকৃত প্ৰতিবেদন ডাউনলোড কৰক",
    "Hide Chart": "চাৰ্ট লুকুৱাওক",
    "Personalised": "ব্যক্তিগতকৃত",
    "Generating your Personalised Report": "আপোনাৰ ব্যক্তিগতকৃত প্ৰতিবেদন সৃষ্টি কৰা",
    "Please do not leave this page till the report is generated. This can take a little while.": "প্ৰতিবেদন সৃষ্টি নোহোৱালৈকে এই পৃষ্ঠা এৰি নাযাব। ইয়াৰ বাবে অলপ সময় লাগিব পাৰে।",
    "Please don't leave this page till the report is generated. This can take a little while.": "অনুগ্ৰহ কৰি প্ৰতিবেদন সৃষ্টি নোহোৱালৈকে এই পৃষ্ঠাটো এৰি নাযাব। ইয়াৰ বাবে অলপ সময় লাগিব পাৰে।",
    "Update": "নবীকৰণ",
    "Complete your billing address. Required for generating invoice.": "আপোনাৰ বিলিং ঠিকনা সম্পূৰ্ণ কৰক। চালান সৃষ্টিৰ বাবে প্ৰয়োজনীয়।",
    "Report this report": "এই প্ৰতিবেদনৰ ৰিপৰ্ট কৰক",
    "Reason": "কাৰণ",
    "Optional comment": "ঐচ্ছিক মন্তব্য",
    "Submit": "দাখিল কৰক",
    "Incorrect info": "ভুল তথ্য",
    "Offensive": "আক্ৰমণাত্মক",
    "Harmful": "ক্ষতিকাৰক",
    "This report has been sent for review.": "এই প্ৰতিবেদন পৰ্যালোচনাৰ বাবে প্ৰেৰণ কৰা হৈছে।",
    "Failed to submit report feedback": "প্ৰতিবেদনৰ মতামত দাখিল কৰাত ব্যৰ্থ",
    "Failed to download PDF": "পিডিএফ ডাউনলোড কৰাত ব্যৰ্থ",
    "Failed to download personalised report": "ব্যক্তিগতকৃত প্ৰতিবেদন ডাউনলোড কৰাত ব্যৰ্থ",
    "Failed to load charts": "চাৰ্টসমূহ লোড কৰাত ব্যৰ্থ",
    "Failed to hide chart": "চাৰ্ট লুকুৱাবলৈ ব্যৰ্থ",
    "Failed to delete chart": "চাৰ্ট মচি পেলোৱাত ব্যৰ্থ",
    "Share link copied to clipboard!": "শ্বেয়াৰ লিংক ক্লিপবোৰ্ডলৈ কপি কৰা হৈছে!",
    "Delete Chart": "চাৰ্ট মচি পেলাওক",
    "Delete chart": "চাৰ্ট মচি পেলাওক",
    "Error": "আঁসোৱাহ",
    "OK": "ঠিক আছে",
    "Thanks": "ধন্যবাদ",
    "Report failed": "প্ৰতিবেদন বিফল হ'ল",
    "Could not submit report feedback.": "প্ৰতিবেদনৰ মতামত জমা দিব পৰা নগ'ল।",
    "Personalised report ready": "ব্যক্তিগতকৃত প্ৰতিবেদন সাজু",
    "Personalised report failed": "ব্যক্তিগতকৃত প্ৰতিবেদন বিফল",
    "Could not generate personalised report.": "ব্যক্তিগতকৃত প্ৰতিবেদন সৃষ্টি কৰিব পৰা নগ'ল।",
    "Could not generate personalised PDF report.": "ব্যক্তিগতকৃত পিডিএফ প্ৰতিবেদন সৃষ্টি কৰিব পৰা নগ'ল।",
    "Monthly limit reached": "মাহেকীয়া সীমাত উপনীত হ’ল",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "আপোনাৰ মাহেকীয়া ব্যক্তিগতকৃত প্ৰতিবেদনৰ সীমাত উপনীত হৈছে। এটা এড-অন চাবস্ক্ৰাইব কৰক: ২০টা প্ৰতিবেদনৰ বাবে ₹২৯৯/মাহ বা ৪০টা প্ৰতিবেদনৰ বাবে ₹৪৯৯/মাহ।",
    "Buy Add-on": "এড-অন কিনিব",
    "Manage": "ব্যৱস্থাপনা কৰা",
    "Add-on active: Unlimited reports": "এড-অন সক্ৰিয়: সীমাহীন প্ৰতিবেদন",
    "Add-on active: 40 reports/month": "এড-অন সক্ৰিয়: ৪০টা প্ৰতিবেদন/মাহ",
    "Add-on active: 20 reports/month": "এড-অন সক্ৰিয়: ২০টা প্ৰতিবেদন/মাহ",
    "reports remaining this cycle": "এই চক্ৰত বাকী থকা প্ৰতিবেদনসমূহ",
    "Add-on active": "এড-অন সক্ৰিয়",
    "Personalised reports remaining this month": "এই মাহত বাকী থকা ব্যক্তিগতকৃত প্ৰতিবেদন",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "প্ৰিমিয়ামত ২/মাহ অন্তৰ্ভুক্ত। এড-অন: ২০টা ৰিপৰ্ট/মাহৰ বাবে ₹২৯৯/মাহ বা ৪০টা ৰিপৰ্ট/মাহৰ বাবে ₹৪৯৯/মাহ।",
    "AI Disclaimer": "AI অস্বীকাৰ",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "এই প্ৰতিবেদন এআই আৰু জ্যোতিষৰ ব্যাখ্যা ব্যৱহাৰ কৰি সৃষ্টি কৰা হৈছে। ই কেৱল তথ্য আৰু মনোৰঞ্জনৰ বাবে। ইয়াক চিকিৎসা, আইনী বা আৰ্থিক পৰামৰ্শ বুলি গণ্য কৰা উচিত নহয়।",
    "A copy of this report has also been sent to your registered email address as a PDF.": "এই প্ৰতিবেদনৰ এটা কপি আপোনাৰ পঞ্জীয়নভুক্ত ইমেইল ঠিকনালৈও পিডিএফ হিচাপে প্ৰেৰণ কৰা হৈছে।",
    "Report this AI-generated report?": "এই AI-উৎপন্ন প্ৰতিবেদন প্ৰতিবেদন?",
    "charts": "চাৰ্টসমূহ",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "স্বতন্ত্ৰ টোকা, তাৰিখ আৰু সময়ৰ পৰিকল্পনা। সংৰক্ষণৰ বাবে লগইনৰ প্ৰয়োজন; বিনামূলীয়া ব্যৱহাৰকাৰীসকলে সম্পূৰ্ণ পৰিকল্পনাকাৰী প্ৰৱেশ লাভ কৰে।",
    "Independent notes, date and time planning.": "স্বতন্ত্ৰ টোকা, তাৰিখ আৰু সময়ৰ পৰিকল্পনা।",
    "Add Plan": "পৰিকল্পনা যোগ কৰক",
    "Save Plan": "পৰিকল্পনা সংৰক্ষণ কৰক",
    "Saved Plans": "সংৰক্ষিত পৰিকল্পনা",
    "Planner Entry": "পৰিকল্পনাকাৰী প্ৰৱেশ",
    "Plan": "পৰিকল্পনা",
    "Saving...": "সঞ্চয়...",
    "Refresh": "সতেজ কৰক",
    "No plans saved yet.": "এতিয়াও কোনো পৰিকল্পনা সংৰক্ষণ কৰা হোৱা নাই।",
    "Planner layout is available. Login only when you want to save.": "পৰিকল্পনাকাৰী বিন্যাস উপলব্ধ। কেৱল যেতিয়া আপুনি সংৰক্ষণ কৰিব বিচাৰে তেতিয়াহে লগইন কৰক।",
    "No matching plans.": "কোনো মেচিং প্লেন নাই।",
    "Search Plans": "সন্ধান পৰিকল্পনা",
    "Search title, note, date or status": "শিৰোনাম, টোকা, তাৰিখ বা অৱস্থা সন্ধান কৰক",
    "Login is required only when you want to save planner entries.": "লগইনৰ প্ৰয়োজন কেৱল তেতিয়াহে যেতিয়া আপুনি পৰিকল্পনাকাৰী প্ৰবিষ্টসমূহ সংৰক্ষণ কৰিব বিচাৰে।",
    "Planner entry saved.": "পৰিকল্পনাকাৰী প্ৰৱেশ সংৰক্ষণ কৰা হৈছে।",
    "Unable to load planner.": "পৰিকল্পনাকাৰী লোড কৰিব পৰা নাই।",
    "Unable to save planner entry.": "পৰিকল্পনাকাৰী প্ৰৱেশ সংৰক্ষণ কৰিব পৰা নাই।",
    "Could not load planner.": "প্লেনাৰ লোড কৰিব পৰা নগ'ল।",
    "Could not save planner entry.": "পৰিকল্পনাকাৰীৰ প্ৰৱেশ সংৰক্ষণ কৰিব পৰা নগ'ল।",
    "Login required to save": "সংৰক্ষণ কৰিবলৈ লগইনৰ প্ৰয়োজন",
    "You can explore Planner now. Login when you want to save entries.": "আপুনি এতিয়াই প্লেনাৰ অন্বেষণ কৰিব পাৰিব। যেতিয়া আপুনি প্ৰৱেশসমূহ সংৰক্ষণ কৰিব বিচাৰে তেতিয়া লগইন কৰক।",
    "Prev": "পূৰ্বৰ",
    "Next": "পৰৱৰ্তী",
    "Page": "পৃষ্ঠা",
    "of": "ৰ",
    "Child Birth Mahoorat": "শিশু জন্ম মহুৰাত",
    "Child Birth Mahoorat | Kundlistar Premium": "শিশু জন্ম মহুৰাত | কুণ্ডলিষ্টাৰ প্ৰিমিয়াম",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "পঞ্চাং, চোঘাদিয়া আৰু হোৰা ভিত্তিক গাইডেন্সৰ সৈতে প্ৰিমিয়াম চাইল্ড বাৰ্থ মহুৰাটৰ খিৰিকী।",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "পৰিকল্পিত সন্তান-জন্মৰ সময়ৰ নিৰ্দেশনাৰ বাবে শুভ উপলব্ধ খিৰিকীসমূহ অন্বেষণ কৰিবলৈ এটা তাৰিখ আৰু স্থান নিৰ্বাচন কৰক।",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "শিশু জন্ম মহুৰাত কেৱল আধ্যাত্মিক আৰু জ্যোতিষৰ পথ প্ৰদৰ্শনৰ বাবে।",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "শিশু জন্ম মহুৰাট এটা প্ৰিমিয়াম বৈশিষ্ট্য। পাঞ্চাং, চোঘাদিয়া আৰু হোৰা চেকসমূহৰ সৈতে শুভ গাইডেন্স উইণ্ড'সমূহ আনলক কৰিবলৈ উন্নীত কৰক।",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "শিশু জন্ম মহুৰাট এটা প্ৰিমিয়াম বৈশিষ্ট্য। Panchang, Choghadiya আৰু Hora পৰীক্ষাসমূহৰ সৈতে গাইডেন্স উইণ্ড'সমূহ আনলক কৰিবলে উন্নয়ন কৰক।",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "তাৰিখ, স্থান, পাঞ্চাং, চোঘাদিয়া আৰু হোৰা অনুসৰি প্ৰিমিয়াম গাইডেন্স উইণ্ডো।",
    "Premium feature": "প্ৰিমিয়াম বৈশিষ্ট্য",
    "Upgrade to Kundlistar Premium": "Kundlistar প্ৰিমিয়ামলৈ উন্নীত কৰক",
    "Previous": "পূৰ্ৱবৰ্তী",
    "Today": "আজি",
    "Birth place / City": "জন্মস্থান / নগৰ",
    "Birth place / city": "জন্মস্থান / নগৰ",
    "Select country, then search city": "দেশ নিৰ্বাচন কৰক, তাৰ পিছত চহৰ সন্ধান কৰক",
    "Preferred start": "পছন্দৰ আৰম্ভণি",
    "Preferred end": "পছন্দৰ শেষ",
    "Mother Moon sign (optional)": "মাতৃ চন্দ্ৰ চিন (ঐচ্ছিক)",
    "Cancer": "কৰ্কট",
    "Load Kundli": "লোড কুণ্ডলী",
    "Find Premium Windows": "প্ৰিমিয়াম উইণ্ড'জ বিচাৰি উলিয়াওক",
    "Date (DD/MM/YYYY)": "তাৰিখ (DD/MM/YYYY)",
    "Invalid Date": "অবৈধ তাৰিখ",
    "Date must be in DD/MM/YYYY format.": "তাৰিখ DD/MM/YYYY ফৰ্মেটত হব লাগিব।",
    "Required": "প্ৰয়োজনীয়",
    "Please select a city.": "অনুগ্ৰহ কৰি এখন চহৰ বাছি লওক।",
    "Kundli": "কুণ্ডলী",
    "Unable to load kundli.": "kundli লোড কৰিব পৰা নাই।",
    "Unable to calculate Child Birth Mahoorat.": "সন্তান জন্ম মহুৰাত গণনা কৰিব পৰা নাই।",
    "Kundli Preview": "কুণ্ডলী প্ৰিভিউ",
    "Loaded for": "লোড কৰা হৈছে",
    "Doshas & Yogas": "দোষ আৰু যোগ",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "লোড কৰা লাহিৰি কুণ্ডলীৰ পৰা নিয়মভিত্তিক ইংগিত। চূড়ান্ত বিচাৰ হিচাপে নহয়, পৰ্যালোচনা আৰু আধ্যাত্মিক পথ প্ৰদৰ্শনৰ বাবে সেইবোৰ ব্যৱহাৰ কৰক।",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "লোড কৰা লাহিৰি কুণ্ডলীৰ পৰা নিয়মভিত্তিক ইংগিত। পৰ্যালোচনা আৰু আধ্যাত্মিক পথ প্ৰদৰ্শনৰ বাবে ব্যৱহাৰ কৰক।",
    "Detected": "ধৰা পৰিছে",
    "Not detected": "ধৰা পৰা নাই",
    "Review": "পুনৰীক্ষণ",
    "Dosha": "দোষা",
    "Yoga": "যোগাসন",
    "Full Yoga Scan": "সম্পূৰ্ণ যোগ স্কেন",
    "Checking yogas...": "যোগাসন পরীক্ষা...",
    "No major yogas were detected by the premium yoga scan.": "প্ৰিমিয়াম যোগ স্কেনৰ দ্বাৰা কোনো ডাঙৰ যোগ ধৰা পৰা নাছিল।",
    "No suitable premium windows found for the selected date and time range.": "নিৰ্বাচিত তাৰিখ আৰু সময়ৰ পৰিসৰৰ বাবে কোনো উপযুক্ত প্ৰিমিয়াম উইণ্ড' পোৱা নগ'ল।",
    "No suitable windows found": "কোনো উপযুক্ত খিৰিকী পোৱা নগ’ল",
    "Try changing the time range or select previous/next date.": "সময় পৰিসীমা সলনি কৰিবলৈ চেষ্টা কৰক বা পূৰ্ব/পৰৱৰ্তী তাৰিখ নিৰ্ব্বাচন কৰক।",
    "Try changing the date or time range.": "তাৰিখ বা সময়ৰ পৰিসৰ সলনি কৰি চাওক।",
    "Try the Previous or Next date button to find a better option.": "এটা উন্নত বিকল্প বিচাৰিবলৈ পূৰ্ব বা পৰৱৰ্তী তাৰিখ বুটাম চেষ্টা কৰক।",
    "Use Previous or Next date to find a better option.": "এটা উন্নত বিকল্প বিচাৰিবলৈ পূৰ্বৰ বা পৰৱৰ্তী তাৰিখ ব্যৱহাৰ কৰক।",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "নিৰ্বাচিত তাৰিখ আৰু চহৰৰ বাবে সৰ্বোত্তম প্ৰিমিয়াম উইণ্ড'সমূহ গণনা কৰিবলৈ প্ৰিমিয়াম উইণ্ড'জ বিচাৰি উলিয়াওক ক্লিক কৰক।",
    "Tap Find Premium Windows for the selected date and city.": "নিৰ্বাচিত তাৰিখ আৰু চহৰৰ বাবে প্ৰিমিয়াম উইণ্ড'জ বিচাৰি উলিয়াওক টেপ কৰক।",
    "Good tithi": "ভাল তিথি",
    "Supportive nakshatra": "সহায়ক নক্ষত্ৰ",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "নক্ষত্ৰ সংবেদনশীল। পদা আৰু গণ্ডান্তক ভালদৰে পৰীক্ষা কৰক।",
    "Supportive weekday": "সহায়ক সপ্তাহৰ দিনটো",
    "Good Choghadiya": "ভাল চোঘাদিয়া",
    "Weak Choghadiya": "দুৰ্বল চোঘাদিয়া",
    "Supportive Hora": "সহায়কাৰী হোৰা",
    "Baby Moon matches mother's Moon sign.": "বেবী মুন মাতৃৰ মুন ৰাশিৰ লগত মিলিছে।",
    "Hora": "হোৰা",
    "slots": "স্লটসমূহ",
    "min": "মিনিট",
    "Good": "ভাল",
    "Excellent": "অতি উত্তম",
    "Usable": "ব্যৱহাৰযোগ্য",
    "Rejected": "নাকচ কৰা হৈছে",
    "Sunday": "দেওবাৰ",
    "Monday": "সোমবাৰ",
    "Tuesday": "মঙ্গলবাৰ",
    "Wednesday": "বুধবাৰ",
    "Thursday": "বৃহস্পতিবাৰ",
    "Friday": "শুক্ৰবাৰ",
    "Saturday": "শনিবাৰ",
    "Sun": "সূৰ্য",
    "Moon": "চন্দ্ৰ",
    "Mars": "মংগল গ্ৰহ",
    "Mercury": "বুধ গ্ৰহ",
    "Jupiter": "বৃহস্পতি",
    "Venus": "শুক্ৰ গ্ৰহ",
    "Saturn": "শনি গ্ৰহ",
    "Rahu": "ৰাহু",
    "Ketu": "কেতু",
    "Chal": "চল",
    "Labh": "লাভ",
    "Amrit": "অমৃত",
    "Shubh": "শুভ",
    "Udveg": "উডভেগ",
    "Rog": "ৰগ",
    "Kaal": "কাল",
    "Krishna Navami": "কৃষ্ণ নৱমী",
    "Ashwini": "অশ্বিনী",
    "Bharani": "ভৰণি",
    "Krittika": "কৃত্তিকা",
    "Rohini": "ৰোহিনী",
    "Mrigashira": "মৃগশিৰা",
    "Ardra": "আৰ্দ্ৰা",
    "Punarvasu": "পুনৰ্বসু",
    "Pushya": "পূষ্য",
    "Ashlesha": "অশ্বলেছা",
    "Magha": "মাঘা",
    "Jyeshtha": "জ্যেষ্ঠ",
    "Moola": "মূলা",
    "Mula": "মুলা",
    "Revati": "ৰেৱতী"
  },
  "ur": {
    "Client Management": "کلائنٹ مینجمنٹ",
    "Dashboard": "ڈیش بورڈ",
    "Clients": "کلائنٹس",
    "Consultations": "مشاورت",
    "Notes": "نوٹس",
    "Follow-ups": "فالو اپس",
    "Reports": "رپورٹس",
    "Remedies": "علاج",
    "Predictions": "پیشین گوئیاں",
    "Planner": "منصوبہ ساز",
    "Templates": "ٹیمپلیٹس",
    "Analytics": "تجزیات",
    "Payments": "ادائیگیاں",
    "Settings": "ترتیبات",
    "You can save a default city in Settings. City fields stay blank until a default city is selected.": "Settings میں ڈیفالٹ شہر محفوظ کر سکتے ہیں۔ جب تک ڈیفالٹ شہر منتخب نہ ہو، شہر کے فیلڈ خالی رہیں گے۔",
    "is now your default city.": "اب آپ کا ڈیفالٹ شہر ہے۔",
    "Search your default city": "اپنا ڈیفالٹ شہر تلاش کریں",
    "This color is saved for the website theme and PDF report accent.": "یہ رنگ ویب سائٹ تھیم اور PDF رپورٹ accent کے لیے محفوظ ہوگا۔",
    "Turn All off to include only the checked modules in the report.": "رپورٹ میں صرف منتخب ماڈیولز شامل کرنے کے لیے All آف کریں۔",
    "When All is on, the PDF includes every module. Turn it off to include only the checked modules.": "All آن ہو تو PDF میں تمام ماڈیولز شامل ہوں گے۔ صرف منتخب ماڈیولز کے لیے اسے آف کریں۔",
    "Uranus, Neptune and Pluto stay hidden by default.": "یورینس، نیپچون اور پلوٹو ڈیفالٹ طور پر چھپے رہتے ہیں۔",
    "Show Uranus, Neptune and Pluto": "یورینس، نیپچون اور پلوٹو دکھائیں",
    "When off, Nadi and KP also use the selected global ayanamsha.": "آف ہونے پر نادی اور KP بھی منتخب عالمی ایانامشا استعمال کریں گے۔",
    "Use KP for Nadi and KP": "نادی اور KP کے لیے KP استعمال کریں",
    "Use KP ayanamsha for Nadi and KP": "نادی اور KP کے لیے KP ایانامشا استعمال کریں",
    "Night": "نائٹ",
    "Dark": "ڈارک",
    "Light": "لائٹ",
    "Clear default city": "ڈیفالٹ شہر ہٹائیں",
    "Default City": "ڈیفالٹ شہر",
    "Default city": "ڈیفالٹ شہر",
    "Theme Color": "تھیم رنگ",
    "Theme color": "تھیم رنگ",
    "Include all modules": "تمام ماڈیولز شامل کریں",
    "PDF Report Modules": "PDF رپورٹ ماڈیولز",
    "PDF report modules": "PDF رپورٹ ماڈیولز",
    "Show": "دکھائیں",
    "Hide": "چھپائیں",
    "Outer Planets": "بیرونی سیارے",
    "Outer planets": "بیرونی سیارے",
    "Ayanamsha": "ایانامشا",
    "Mean Node": "مین نوڈ",
    "True Node": "ٹرو نوڈ",
    "Rahu/Ketu Calculation": "راہو/کیتو حساب",
    "Rahu/Ketu calculation": "راہو/کیتو حساب",
    "East": "مشرقی بھارتی",
    "South": "جنوبی بھارتی",
    "North": "شمالی بھارتی",
    "Chart Style": "چارٹ انداز",
    "Chart style": "چارٹ انداز",
    "Language": "زبان",
    "Records": "ریکارڈز",
    "Relations": "رشتے",
    "Relation": "رشتہ",
    "Add Client": "کلائنٹ شامل کریں۔",
    "Add Consultation": "مشاورت شامل کریں۔",
    "Add Note": "نوٹ شامل کریں۔",
    "Add Follow-up": "فالو اپ شامل کریں۔",
    "Create Report": "رپورٹ بنائیں",
    "Assign Remedy": "علاج تفویض کریں۔",
    "Add Prediction": "پیشن گوئی شامل کریں۔",
    "Add Payment": "ادائیگی شامل کریں۔",
    "Assign Chart": "چارٹ تفویض کریں۔",
    "Add Relation": "رشتہ شامل کریں۔",
    "CMS Action": "CMS ایکشن",
    "Client": "کلائنٹ",
    "Chart": "چارٹ",
    "Related Client": "متعلقہ کلائنٹ",
    "Full Name": "پورا نام",
    "Phone Number": "فون نمبر",
    "WhatsApp Number": "واٹس ایپ نمبر",
    "Email": "ای میل",
    "Birth Place": "جائے پیدائش",
    "Current City": "موجودہ شہر",
    "Main Topic": "مرکزی موضوع",
    "Status": "حیثیت",
    "Source": "ماخذ",
    "Tags": "ٹیگز",
    "Internal Note": "اندرونی نوٹ",
    "Purpose": "مقصد",
    "Relation Type": "رشتے کی قسم",
    "Title": "عنوان",
    "Topic": "موضوع",
    "Date": "تاریخ",
    "Time": "وقت",
    "Amount": "رقم",
    "Mode": "موڈ",
    "Payment Status": "ادائیگی کی حیثیت",
    "Note / Summary": "نوٹ / خلاصہ",
    "Close": "بند",
    "Cancel": "منسوخ کریں۔",
    "Save": "محفوظ کریں۔",
    "Saving": "محفوظ کرنا",
    "Save Changes": "تبدیلیاں محفوظ کریں۔",
    "Edit Client": "کلائنٹ میں ترمیم کریں۔",
    "Client Chart": "کلائنٹ چارٹ",
    "Comma separated": "کوما الگ ہو گیا۔",
    "Search by name, phone, email, topic, or tag": "نام، فون، ای میل، موضوع، یا ٹیگ کے ذریعہ تلاش کریں۔",
    "Search clients, phone, topic": "کلائنٹس، فون، موضوع تلاش کریں۔",
    "Search your saved charts by chart name": "اپنے محفوظ کردہ چارٹس کو چارٹ کے نام سے تلاش کریں۔",
    "Linked Chart": "منسلک چارٹ",
    "Select linked chart": "منسلک چارٹ منتخب کریں۔",
    "Link a chart to this client before adding records.": "ریکارڈز شامل کرنے سے پہلے اس کلائنٹ سے چارٹ لنک کریں۔",
    "Connect this client with another saved client profile": "اس کلائنٹ کو دوسرے محفوظ کردہ کلائنٹ پروفائل کے ساتھ جوڑیں۔",
    "CMS for astrologer client work": "نجومی کلائنٹ کے کام کے لیے CMS",
    "Premium Pro unlocks Client Management": "پریمیم پرو کلائنٹ مینجمنٹ کو غیر مقفل کرتا ہے۔",
    "Upgrade to manage client profiles, consultations, notes, follow-ups, reports, remedies, predictions, analytics and payment tracking in one workspace.": "ایک ورک اسپیس میں کلائنٹ پروفائلز، مشاورت، نوٹس، فالو اپس، رپورٹس، علاج، پیشین گوئیاں، تجزیات اور ادائیگی سے باخبر رہنے کے لیے اپ گریڈ کریں۔",
    "Upgrade to Premium Pro": "پریمیم پرو میں اپ گریڈ کریں۔",
    "CMS modules included": "CMS ماڈیولز شامل ہیں۔",
    "Please login to use Client Management. CMS data is stored per account.": "براہ کرم کلائنٹ مینجمنٹ استعمال کرنے کے لیے لاگ ان کریں۔ CMS ڈیٹا فی اکاؤنٹ محفوظ کیا جاتا ہے۔",
    "Login": "لاگ ان",
    "Loading live CMS data...": "لائیو CMS ڈیٹا لوڈ ہو رہا ہے...",
    "Quick Actions": "فوری اقدامات",
    "Client Records": "کلائنٹ ریکارڈز",
    "Client Record": "کلائنٹ کا ریکارڈ",
    "Client Profile": "کلائنٹ پروفائل",
    "Back to Clients": "کلائنٹس پر واپس جائیں۔",
    "View": "دیکھیں",
    "Edit": "ترمیم کریں۔",
    "Delete": "حذف کریں۔",
    "Note": "نوٹ",
    "Archive": "محفوظ شدہ دستاویزات",
    "Download PDF": "پی ڈی ایف ڈاؤن لوڈ کریں۔",
    "Delete this record?": "اس ریکارڈ کو حذف کریں؟",
    "Unable to edit this CMS record.": "اس CMS ریکارڈ میں ترمیم کرنے سے قاصر۔",
    "Unable to update CMS record.": "CMS ریکارڈ کو اپ ڈیٹ کرنے سے قاصر۔",
    "Unable to delete CMS record.": "CMS ریکارڈ کو حذف کرنے سے قاصر۔",
    "No contact added": "کوئی رابطہ شامل نہیں کیا گیا۔",
    "No topic": "کوئی موضوع نہیں۔",
    "No clients found yet. Add your first real client to start filling the CMS dashboard.": "ابھی تک کوئی کلائنٹ نہیں ملا۔ CMS ڈیش بورڈ کو بھرنا شروع کرنے کے لیے اپنا پہلا حقیقی کلائنٹ شامل کریں۔",
    "Last Consultation": "آخری مشاورت",
    "Next Follow-up": "اگلا فالو اپ",
    "Date of Birth": "تاریخ پیدائش",
    "Time of Birth": "پیدائش کا وقت",
    "Client Details": "کلائنٹ کی تفصیلات",
    "No connected profiles yet.": "ابھی تک کوئی مربوط پروفائلز نہیں ہیں۔",
    "Select a client record to view details.": "تفصیلات دیکھنے کے لیے کلائنٹ کا ریکارڈ منتخب کریں۔",
    "Record": "ریکارڈ",
    "Consultation Summary": "مشاورت کا خلاصہ",
    "Client Note": "کلائنٹ نوٹ",
    "Start a consultation record with summary, topic, mode and payment fields.": "خلاصہ، موضوع، موڈ اور ادائیگی کے شعبوں کے ساتھ مشاورتی ریکارڈ شروع کریں۔",
    "Start a private note attached to a client profile.": "کلائنٹ پروفائل کے ساتھ منسلک ایک نجی نوٹ شروع کریں۔",
    "Start a pending follow-up with due date and topic.": "مقررہ تاریخ اور موضوع کے ساتھ زیر التواء فالو اپ شروع کریں۔",
    "Start a report record connected to the client timeline.": "کلائنٹ کی ٹائم لائن سے منسلک رپورٹ ریکارڈ شروع کریں۔",
    "Start an active remedy record for client guidance.": "کلائنٹ کی رہنمائی کے لیے ایک فعال علاج کا ریکارڈ شروع کریں۔",
    "Start an open prediction record with notes and follow-up date.": "نوٹس اور فالو اپ تاریخ کے ساتھ ایک کھلا پیشین گوئی ریکارڈ شروع کریں۔",
    "Statuses": "سٹیٹس",
    "Topics": "موضوعات",
    "Sources": "ذرائع",
    "No records found for the current filters.": "موجودہ فلٹرز کے لیے کوئی ریکارڈ نہیں ملا۔",
    "Total Clients": "کل کلائنٹس",
    "New Clients This Month": "اس مہینے نئے کلائنٹس",
    "Consultations This Month": "اس ماہ مشاورت",
    "Today's Consultations": "آج کی مشاورت",
    "Consultations scheduled for today from real client records.": "حقیقی کلائنٹ کے ریکارڈ سے آج کے لیے مشورے طے ہیں۔",
    "No consultations scheduled for today.": "آج کے لیے کوئی مشاورت طے نہیں ہے۔",
    "Pending Follow-ups": "زیر التواء فالو اپس",
    "Reports Created": "رپورٹس بنائی گئیں۔",
    "Active Remedies": "فعال علاج",
    "Open Predictions": "پیشین گوئیاں کھولیں۔",
    "Pending Payments": "زیر التواء ادائیگیاں",
    "See client activity, recent work, follow-ups, reports, predictions, remedies and pending payments in one place.": "کلائنٹ کی سرگرمی، حالیہ کام، فالو اپ، رپورٹس، پیشین گوئیاں، علاج اور زیر التواء ادائیگیاں ایک جگہ پر دیکھیں۔",
    "Manage astrologer client records with birth details, topics, tags, status and archive/restore actions.": "پیدائش کی تفصیلات، عنوانات، ٹیگز، اسٹیٹس اور آرکائیو/بحالی کے اعمال کے ساتھ نجومی کلائنٹ کے ریکارڈ کا نظم کریں۔",
    "Store session details, linked charts, topics, observations, predictions, remedies and follow-up dates.": "سیشن کی تفصیلات، منسلک چارٹس، عنوانات، مشاہدات، پیشین گوئیاں، علاج اور فالو اپ تاریخوں کو اسٹور کریں۔",
    "Keep private consultation notes and chart observations attached to client profiles.": "نجی مشاورتی نوٹ اور چارٹ مشاہدات کو کلائنٹ پروفائلز کے ساتھ منسلک رکھیں۔",
    "Track today and upcoming follow-ups inside Client Management without push, SMS, email or WhatsApp alerts.": "کلائنٹ مینجمنٹ کے اندر آج اور آنے والے فالو اپس کو پش، ایس ایم ایس، ای میل یا واٹس ایپ الرٹس کے بغیر ٹریک کریں۔",
    "Create and organize client reports generated from saved charts and consultation context.": "محفوظ کردہ چارٹس اور مشاورتی سیاق و سباق سے تیار کردہ کلائنٹ رپورٹس بنائیں اور منظم کریں۔",
    "Assign remedies, mark active guidance and keep remedy history connected to the client timeline.": "علاج تفویض کریں، فعال رہنمائی کو نشان زد کریں اور علاج کی تاریخ کو کلائنٹ کی ٹائم لائن سے منسلک رکھیں۔",
    "Track open predictions, dates, confidence notes and outcome updates for each client.": "ہر کلائنٹ کے لیے کھلی پیشین گوئیوں، تاریخوں، اعتماد کے نوٹس اور نتائج کی تازہ کاریوں کو ٹریک کریں۔",
    "Plan consultations, follow-ups and payment dates in one working view.": "مشورے، فالو اپ اور ادائیگی کی تاریخوں کو ایک ہی ورکنگ ویو میں پلان کریں۔",
    "Prepare reusable consultation, report, remedy and prediction templates.": "دوبارہ قابل استعمال مشاورت، رپورٹ، علاج اور پیشین گوئی کے سانچے تیار کریں۔",
    "Review client activity, consultation volume, reports created and pending work.": "کلائنٹ کی سرگرمی، مشاورتی حجم، رپورٹس کی تخلیق اور زیر التواء کام کا جائزہ لیں۔",
    "Track consultation amounts and payment status without plan or pricing rules.": "منصوبہ بندی یا قیمتوں کے اصولوں کے بغیر مشاورت کی رقم اور ادائیگی کی حیثیت کو ٹریک کریں۔",
    "Configure client sources, statuses, topics, tags and internal CMS preferences.": "کلائنٹ کے ذرائع، حیثیت، عنوانات، ٹیگز اور داخلی CMS ترجیحات کو ترتیب دیں۔",
    "Showing saved records connected to client records.": "کلائنٹ کے ریکارڈ سے منسلک محفوظ شدہ ریکارڈز دکھا رہا ہے۔",
    "No Status": "کوئی حیثیت نہیں۔",
    "No Mode": "کوئی موڈ نہیں۔",
    "No Payment Status": "ادائیگی کی کوئی حیثیت نہیں۔",
    "No Topic": "کوئی موضوع نہیں۔",
    "No Source": "کوئی ماخذ نہیں۔",
    "All Statuses": "تمام سٹیٹس",
    "All Topics": "تمام موضوعات",
    "No clients found": "کوئی کلائنٹ نہیں ملا",
    "Type to search clients": "کلائنٹس کو تلاش کرنے کے لیے ٹائپ کریں۔",
    "No charts found": "کوئی چارٹ نہیں ملا",
    "Type to search saved charts": "محفوظ شدہ چارٹس تلاش کرنے کے لیے ٹائپ کریں۔",
    "Type to search related client": "متعلقہ کلائنٹ کو تلاش کرنے کے لیے ٹائپ کریں۔",
    "Open": "کھولیں۔",
    "Pending": "زیر التواء",
    "Scheduled": "طے شدہ",
    "Completed": "مکمل",
    "Follow-up Pending": "فالو اپ زیر التواء ہے۔",
    "Cancelled": "منسوخ",
    "Closed": "بند",
    "No-show": "نون شو",
    "Not Applicable": "قابل اطلاق نہیں۔",
    "Paid": "ادا کیا",
    "Partially Paid": "جزوی طور پر ادا شدہ",
    "Refunded": "رقم کی واپسی",
    "Phone": "فون",
    "WhatsApp Call": "واٹس ایپ کال",
    "Video Call": "ویڈیو کال",
    "In-person": "ذاتی طور پر",
    "Chat": "گپ شپ",
    "Other": "دیگر",
    "New": "نیا",
    "VIP": "وی آئی پی",
    "Inactive": "غیر فعال",
    "Consultation Completed": "مشاورت مکمل",
    "WhatsApp": "واٹس ایپ",
    "Instagram": "انسٹاگرام",
    "YouTube": "یوٹیوب",
    "Referral": "حوالہ",
    "Website": "ویب سائٹ",
    "Walk-in": "واک ان",
    "Repeat Client": "کلائنٹ کو دہرائیں۔",
    "Family Referral": "فیملی ریفرل",
    "Business": "کاروبار",
    "Finance": "فنانس",
    "Property": "جائیداد",
    "Children": "بچے",
    "Foreign Settlement": "غیر ملکی آباد کاری",
    "Legal": "قانونی",
    "Remedy": "علاج",
    "General": "جنرل",
    "Active": "فعال",
    "Past": "ماضی",
    "Potential": "ممکنہ",
    "Archived": "محفوظ شدہ",
    "Spouse": "میاں بیوی",
    "Husband": "شوہر",
    "Wife": "بیوی",
    "Child": "بچہ",
    "Son": "بیٹا",
    "Daughter": "بیٹی",
    "Father": "باپ",
    "Mother": "ماں",
    "Sibling": "بہن بھائی",
    "Brother": "بھائی",
    "Sister": "بہن",
    "Marriage Prospect": "شادی کا امکان",
    "Fiance": "منگیتر",
    "Business Partner": "بزنس پارٹنر",
    "Friend": "دوست",
    "Relative": "رشتہ دار",
    "Upgrade": "اپ گریڈ کریں۔",
    "You can add only 2 clients. Upgrade to Premium for more clients.": "آپ صرف 2 کلائنٹس کو شامل کر سکتے ہیں۔ مزید کلائنٹس کے لیے پریمیم میں اپ گریڈ کریں۔",
    "None": "کوئی نہیں۔",
    "Education": "تعلیم",
    "Awards": "ایوارڈز",
    "Prize": "انعام",
    "Career": "کیریئر",
    "Love": "محبت",
    "Marriage": "شادی",
    "Dowry or Legacy": "جہیز یا میراث",
    "Divorce": "طلاق",
    "Abortion": "اسقاط حمل",
    "Child Birth": "بچے کی پیدائش",
    "Property/Vehicle Purchase": "پراپرٹی/گاڑی کی خریداری",
    "Property/Vehicle Sale": "پراپرٹی/گاڑی کی فروخت",
    "Love and Caring": "محبت اور دیکھ بھال",
    "Depression": "ڈپریشن",
    "Aggression": "جارحیت",
    "Health": "صحت",
    "Travel": "سفر",
    "Homecoming": "وطن واپسی",
    "Litigation": "مقدمہ بازی",
    "Arrest": "گرفتاری",
    "Locked": "مقفل",
    "Strong": "مضبوط",
    "Weak": "کمزور",
    "Supportive": "معاون",
    "Avoid": "اجتناب کریں۔",
    "Premium": "پریمیم",
    " UTC": "UTC",
    "Unable to calculate Tithi Pravesh": "تیتھی پرویش کا حساب لگانے سے قاصر",
    "IANA timezone": "IANA ٹائم زون",
    "TP Local": "ٹی پی لوکل",
    "TP UTC": "TP UTC",
    "Next TP Local": "اگلا ٹی پی لوکل",
    "Models: KP + Vedic": "ماڈلز: کے پی + ویدک",
    "Overall Year Theme": "مجموعی طور پر سال کی تھیم",
    "Career & Job": "کیریئر اور نوکری",
    "Finance & Savings": "خزانہ اور بچت",
    "Relationship & Marriage": "رشتہ اور شادی",
    "Family Matters": "خاندانی معاملات",
    "Property & Vehicle": "پراپرٹی اور گاڑی",
    "Health & Wellness": "صحت اور تندرستی",
    "Spiritual Growth": "روحانی ترقی",
    "Social Status & Recognition": "سماجی حیثیت اور پہچان",
    "Please select a saved chart first.": "براہ کرم پہلے ایک محفوظ کردہ چارٹ منتخب کریں۔",
    "Unable to generate Tajika Varshphal": "Tajika Varshphal پیدا کرنے سے قاصر",
    "Premium yearly module": "پریمیم سالانہ ماڈیول",
    "Tajika Varshphal": "تاجیکا ورشفال",
    "Solar Return based yearly horoscope with Varsha Lagna, Muntha, Varsha Lord, Sahams, monthly guidance, remedies, and practical life themes personalised from this saved Kundli.": "شمسی واپسی پر مبنی سالانہ زائچہ ورشا لگانا، منتھا، ورشا لارڈ، سہمس، ماہانہ رہنمائی، علاج، اور اس محفوظ شدہ کنڈلی سے ذاتی نوعیت کی عملی زندگی کے موضوعات کے ساتھ۔",
    "Saved chart": "محفوظ شدہ چارٹ",
    "Untitled Chart": "بلا عنوان چارٹ",
    "Your 4 free premium credits are used. Upgrade to Kundlistar Premium for unlimited premium access.": "آپ کے 4 مفت پریمیم کریڈٹ استعمال کیے گئے ہیں۔ لامحدود پریمیم رسائی کے لیے Kundlistar پریمیم میں اپ گریڈ کریں۔",
    "आपके 4 निःशुल्क प्रीमियम क्रेडिट उपयोग हो चुके हैं। असीमित प्रीमियम एक्सेस के लिए Kundlistar Premium लें।": "آپ کا 4 مفت پریمیم کریڈٹ استعمال ہو سکتا ہے۔ غیرمتوقع قیمت تک رسائی کے لیے Kundlistar پریمیم لائیں",
    "Core Year Markers": "بنیادی سال کے نشانات",
    "Solar Return": "شمسی واپسی",
    "Varsha Lagna": "ورشا لگنا",
    "Muntha Lord": "منتھا رب",
    "Varsha Lord": "ورشا لارڈ",
    "Varshesh Method": "ورشیش طریقہ",
    "Yearly Summary": "سالانہ خلاصہ",
    "Not available yet.": "ابھی دستیاب نہیں ہے۔",
    "Varshesh Candidates": "ورشیش امیدوار",
    "Risk Areas": "رسک ایریاز",
    "Favourable Periods": "سازگار ادوار",
    "Challenging Periods": "چیلنجنگ ادوار",
    "Remedies & Final Advice": "علاج اور حتمی مشورہ",
    "Tajika Varshphal gives interpretive yearly guidance. It should not be treated as medical, legal, financial, or certain prediction advice.": "تاجیکا ورشفال تشریحی سالانہ رہنمائی فراہم کرتی ہے۔ اسے طبی، قانونی، مالی، یا کچھ پیشین گوئی کے مشورے کے طور پر نہیں سمجھا جانا چاہیے۔",
    "Griha Pravesh": "گریہ پرویش",
    "Purva Phalguni": "پوروا پھالگونی",
    "Uttara Phalguni": "اترا پھالگونی",
    "Purva Ashadha": "پوروا اشدھا",
    "Uttara Ashadha": "اترا اشدھا",
    "Purva Bhadrapada": "پوروا بھدرپد",
    "Uttara Bhadrapada": "اترا بھدرپد",
    "Param Mitra": "پرم مترا",
    "Kundli birthplace": "کنڈلی جائے پیدائش",
    "Selected city": "منتخب شہر",
    "Muhurat - Kundlistar": "محرمات - Kundlistar",
    "Please select a city first.": "براہ کرم پہلے ایک شہر منتخب کریں۔",
    "Unable to calculate Muhurat.": "محرمات کا حساب لگانے سے قاصر۔",
    "Unable to calculate personalized Muhurat.": "ذاتی نوعیت کا مہرت کا حساب لگانے سے قاصر۔",
    "Find general and personalized Muhurat using Panchang, Choghadiya, Hora, Tarabala and Chandrabala.": "Panchang، Choghadiya، Hora، Tarabala اور Chandrabala کا استعمال کرتے ہوئے عام اور ذاتی نوعیت کا مہورت تلاش کریں۔",
    "Muhurat Finder": "مہر تلاش کرنے والا",
    "Find useful time windows using Panchang, Choghadiya and premium personal birth factors.": "پنچانگ، چوگھڑیا اور پریمیم ذاتی پیدائشی عوامل کا استعمال کرتے ہوئے مفید ٹائم ونڈو تلاش کریں۔",
    "Search city...": "شہر تلاش کریں...",
    "Using selected Kundli": "منتخب کنڈلی کا استعمال",
    "Find Free": "مفت تلاش کریں۔",
    "Free General Muhurat": "مفت جنرل محرمات",
    "Top 3 slots for the next 7 days. Rahu Kaal, Yamaganda and Gulika are removed.": "اگلے 7 دنوں کے لیے ٹاپ 3 سلاٹس۔ راہو کال، یاماگنڈہ اور گلیکا کو ہٹا دیا جاتا ہے۔",
    "Today's Muhurat": "آج کا مہورت",
    "Daily Muhurat by Kundlistar": "یومیہ مہرت از Kundlistar",
    "Shared via Kundlistar": "Kundlistar کے ذریعے اشتراک کیا گیا",
    "Kundlistar Muhurat": "Kundlistar محرمات",
    "Share Image": "تصویر شیئر کریں۔",
    "Share Text": "متن کا اشتراک کریں۔",
    "Copy Text": "متن کاپی کریں۔",
    "Click Find Free to use the selected Kundli birthplace.": "منتخب کنڈلی جائے پیدائش کو استعمال کرنے کے لیے مفت تلاش کریں پر کلک کریں۔",
    "Select a city and click Find Free.": "ایک شہر منتخب کریں اور مفت تلاش کریں پر کلک کریں۔",
    "Premium Personalized Muhurat": "پریمیم پرسنلائزڈ مہورت",
    "Loading Kundli details...": "کنڈلی کی تفصیلات لوڈ ہو رہی ہیں...",
    "Birth Nakshatra": "پیدائشی نکشترا",
    "Birth Moon Rashi": "پیدائش کا چاند راشی",
    "Include night slots": "نائٹ سلاٹ شامل کریں۔",
    "Find Premium": "پریمیم تلاش کریں۔",
    "Your grounding and foundation energy appears strong in this chart.": "اس چارٹ میں آپ کی بنیاد اور بنیاد کی توانائی مضبوط دکھائی دیتی ہے۔",
    "Your grounding energy appears generally balanced in this chart.": "آپ کی گراؤنڈنگ انرجی اس چارٹ میں عام طور پر متوازن نظر آتی ہے۔",
    "Reflection on routine, discipline, and inner stability may be useful.": "روٹین، نظم و ضبط اور اندرونی استحکام پر غور کرنا مفید ہو سکتا ہے۔",
    "Your creative and emotional flow energy appears strong in this chart.": "آپ کی تخلیقی اور جذباتی بہاؤ توانائی اس چارٹ میں مضبوط دکھائی دیتی ہے۔",
    "Your creative energy appears balanced in this chart.": "آپ کی تخلیقی توانائی اس چارٹ میں متوازن دکھائی دیتی ہے۔",
    "Reflection on creativity, emotional expression, and inner flow may be useful.": "تخلیقی صلاحیتوں، جذباتی اظہار اور اندرونی بہاؤ پر غور کرنا مفید ہو سکتا ہے۔",
    "Your confidence and willpower energy appears strong in this chart.": "آپ کا اعتماد اور قوت ارادی اس چارٹ میں مضبوط دکھائی دیتی ہے۔",
    "Your action-taking energy appears balanced in this chart.": "آپ کی کارروائی کرنے والی توانائی اس چارٹ میں متوازن نظر آتی ہے۔",
    "Reflection on confidence, discipline, and decision power may be useful.": "اعتماد، نظم و ضبط اور فیصلہ کرنے کی طاقت پر غور کرنا مفید ہو سکتا ہے۔",
    "Your connection and compassion energy appears strong in this chart.": "آپ کا رابطہ اور ہمدردی کی توانائی اس چارٹ میں مضبوط دکھائی دیتی ہے۔",
    "Your emotional connection energy appears balanced in this chart.": "آپ کے جذباتی تعلق کی توانائی اس چارٹ میں متوازن دکھائی دیتی ہے۔",
    "Reflection on harmony, forgiveness, and emotional balance may be useful.": "ہم آہنگی، معافی، اور جذباتی توازن پر غور کرنا مفید ہو سکتا ہے۔",
    "Your communication and expression energy appears strong in this chart.": "آپ کی بات چیت اور اظہار کی توانائی اس چارٹ میں مضبوط دکھائی دیتی ہے۔",
    "Your expression energy appears balanced in this chart.": "آپ کے اظہار کی توانائی اس چارٹ میں متوازن دکھائی دیتی ہے۔",
    "Reflection on clear communication and self-expression may be useful.": "واضح مواصلات اور خود اظہار پر غور کرنا مفید ہو سکتا ہے۔",
    "Your intuition and inner clarity appears strong in this chart.": "آپ کی بصیرت اور اندرونی وضاحت اس چارٹ میں مضبوط دکھائی دیتی ہے۔",
    "Your intuitive clarity appears balanced in this chart.": "آپ کی بدیہی وضاحت اس چارٹ میں متوازن دکھائی دیتی ہے۔",
    "Reflection on focus, intuition, and inner guidance may be useful.": "توجہ، وجدان، اور اندرونی رہنمائی پر غور کرنا مفید ہو سکتا ہے۔",
    "A strong Fire element supports action, courage, and leadership energy.": "آگ کا ایک مضبوط عنصر عمل، ہمت اور قائدانہ توانائی کی حمایت کرتا ہے۔",
    "Fire appears balanced, supporting a steady rhythm between action and patience.": "آگ متوازن نظر آتی ہے، عمل اور صبر کے درمیان ایک مستحکم تال کی حمایت کرتی ہے۔",
    "Reflection on confidence and action-taking may be useful.": "اعتماد اور عمل پر غور کرنا مفید ہو سکتا ہے۔",
    "A strong Earth element supports practicality, patience, and stability.": "زمین کا ایک مضبوط عنصر عملییت، صبر اور استحکام کی حمایت کرتا ہے۔",
    "Earth appears balanced, supporting practical thinking with flexibility.": "زمین متوازن دکھائی دیتی ہے، لچک کے ساتھ عملی سوچ کی حمایت کرتی ہے۔",
    "Reflection on grounding, consistency, and planning may be useful.": "بنیاد، مستقل مزاجی، اور منصوبہ بندی پر غور کرنا مفید ہو سکتا ہے۔",
    "A strong Air element supports ideas, communication, and adaptability.": "ہوا کا ایک مضبوط عنصر خیالات، مواصلات اور موافقت کی حمایت کرتا ہے۔",
    "Air appears balanced, supporting harmony between thinking and action.": "ہوا متوازن نظر آتی ہے، سوچ اور عمل کے درمیان ہم آہنگی کی حمایت کرتی ہے۔",
    "Reflection on communication and flexibility may be useful.": "مواصلات اور لچک پر غور کرنا مفید ہو سکتا ہے۔",
    "A strong Water element supports intuition, sensitivity, and emotional depth.": "پانی کا ایک مضبوط عنصر وجدان، حساسیت، اور جذباتی گہرائی کی حمایت کرتا ہے۔",
    "Water appears balanced, supporting harmony between emotions and logic.": "پانی متوازن دکھائی دیتا ہے، جذبات اور منطق کے درمیان ہم آہنگی کی حمایت کرتا ہے۔",
    "Reflection on emotional expression and inner connection may be useful.": "جذباتی اظہار اور اندرونی تعلق پر غور کرنا مفید ہو سکتا ہے۔",
    "A strong Ether element supports spiritual awareness and broader vision.": "ایک مضبوط ایتھر عنصر روحانی بیداری اور وسیع تر وژن کی حمایت کرتا ہے۔",
    "Ether appears balanced, supporting harmony between spiritual and practical approach.": "ایتھر متوازن نظر آتا ہے، روحانی اور عملی نقطہ نظر کے درمیان ہم آہنگی کی حمایت کرتا ہے۔",
    "Reflection, silence, and spiritual discipline may be useful.": "عکاسی، خاموشی، اور روحانی نظم و ضبط مفید ہو سکتا ہے۔",
    "For inner confidence, clarity, and soul strength.": "اندرونی اعتماد، وضاحت، اور روح کی طاقت کے لیے۔",
    "This Ishta Devata indication is based on planetary strength, lagna lord, moon sign lord, and atmakaraka from the birth chart.": "یہ اشتہ دیوتا اشارہ سیاروں کی طاقت، لگنا لارڈ، مون سائن لارڈ، اور آتماکارکا پیدائشی چارٹ پر مبنی ہے۔",
    "For calmness, emotional balance, and softness.": "سکون، جذباتی توازن اور نرمی کے لیے۔",
    "For courage, protection, and discipline.": "ہمت، تحفظ، اور نظم و ضبط کے لیے۔",
    "For intellect, speech, learning, and obstacle removal.": "عقل، تقریر، سیکھنے اور رکاوٹوں کو دور کرنے کے لیے۔",
    "For knowledge, guidance, dharma, and blessings.": "علم، رہنمائی، دھرم اور برکت کے لیے۔",
    "Mahalakshmi Ji": "مہالکشمی جی",
    "For harmony, beauty, comfort, and prosperity.": "ہم آہنگی، خوبصورتی، سکون اور خوشحالی کے لیے۔",
    "For karma, patience, discipline, and protection.": "کرم، صبر، نظم و ضبط اور تحفظ کے لیے۔",
    "For protection from confusion, fear, and illusion.": "الجھن، خوف اور وہم سے تحفظ کے لیے۔",
    "Lord Ganesha": "بھگوان گنیش",
    "For spiritual clarity, detachment, and obstacle removal.": "روحانی وضاحت، لاتعلقی، اور رکاوٹ کو دور کرنے کے لیے۔",
    "& .MuiLinearProgress-bar": "اور .MuiLinearProgress-bar",
    "Chart data is required for Chakra insight.": "چکرا بصیرت کے لیے چارٹ کا ڈیٹا درکار ہے۔",
    "Unable to load Chakra insight.": "چکرا بصیرت لوڈ کرنے سے قاصر۔",
    "यह केवल जन्म कुंडली आधारित आध्यात्मिक energy insight और self-reflection है। यह professional advice नहीं है।": "یہ صرف جنم کنڈلی پر مبنی روحانی توانائی کی بصیرت اور خود کی عکاسی ہے۔ یہ پیشہ ورانہ مشورہ نہیں ہے۔",
    "Spiritual energy insights from Kundli": "کنڈلی سے روحانی توانائی کی بصیرت",
    "Calculated from your individual birth chart": "آپ کے انفرادی پیدائشی چارٹ سے شمار کیا جاتا ہے۔",
    "Chakra Balance": "چکرا بیلنس",
    "Panch Tatva Balance": "پنچ تتوا توازن",
    "Ishta Devata": "استا دیوتا",
    "Signal planet": "سگنل سیارہ",
    "Very Good": "بہت اچھا",
    "Very Bad": "بہت برا",
    "Panch Pakshi Calculator - Kundlistar": "پنچ پاکشی کیلکولیٹر - Kundlistar",
    "Could not prefill Panch Pakshi from chart. You can still calculate manually.": "چارٹ سے پنچ پکشی کو پہلے سے نہیں بھرا جا سکا۔ آپ اب بھی دستی طور پر حساب لگا سکتے ہیں۔",
    "Could not load sunrise and sunset from Panchang for this chart location.": "اس چارٹ کے مقام کے لیے Panchang سے طلوع آفتاب اور غروب آفتاب لوڈ نہیں ہو سکا۔",
    "Unable to load sunrise, sunset and next sunrise from Panchang.": "Panchang سے طلوع آفتاب، غروب آفتاب اور اگلا طلوع آفتاب لوڈ کرنے سے قاصر ہے۔",
    "Panch Pakshi calculation failed.": "پنچ پکشی کا حساب ناکام ہو گیا۔",
    "Calculate Panch Pakshi bird, activity, Yamam, Apahara period, relationship, score and result.": "پنچ پکشی پرندے، سرگرمی، یمام، اپاہارا مدت، تعلق، سکور اور نتیجہ کا حساب لگائیں۔",
    "Your free premium credits are finished. Upgrade to Premium to continue.": "آپ کے مفت پریمیم کریڈٹس ختم ہو گئے ہیں۔ جاری رکھنے کے لیے Premium میں اپ گریڈ کریں۔",
    "This is a premium feature. You can use 1 free premium credit to continue.": "یہ ایک پریمیم خصوصیت ہے۔ جاری رکھنے کے لیے آپ 1 مفت پریمیم کریڈٹ استعمال کر سکتے ہیں۔",
    "Selected Date": "منتخب تاریخ",
    "repeat(3, 1fr)": "دہرائیں (3, 1fr)",
    "Birth Paksha": "پیدائش پاکشا",
    "Current Paksha": "موجودہ پاکشا",
    "repeat(4, 1fr)": "دہرائیں (4, 1fr)",
    "Target Date Time": "ہدف کی تاریخ کا وقت",
    "Next Sunrise": "اگلا طلوع آفتاب",
    "Calculate Panch Pakshi": "پنچ پکشی کا حساب لگائیں۔",
    "repeat(2, 1fr)": "دہرائیں (2, 1fr)",
    "repeat(6, 1fr)": "دہرائیں (6, 1fr)",
    "Birth Pakshi": "پیدائش پاکشی",
    "Current Period": "موجودہ دور",
    "Current Yamam": "موجودہ یمام",
    "Main Activity": "اہم سرگرمی",
    "Natal Western Chart": "نیٹل ویسٹرن چارٹ",
    "Life Phase Progression": "زندگی کے مرحلے کی ترقی",
    "Self-focus, identity change, body awareness and personal reset.": "خود توجہ مرکوز، شناخت میں تبدیلی، جسم سے آگاہی اور ذاتی ری سیٹ۔",
    "Money, values, family, speech and security become emotionally important.": "پیسہ، اقدار، خاندان، تقریر اور سلامتی جذباتی طور پر اہم ہو جاتے ہیں۔",
    "Communication, learning, siblings, writing and short travel become important.": "بات چیت، سیکھنا، بہن بھائی، لکھنا اور مختصر سفر اہم ہو جاتا ہے۔",
    "Home, mother, property, family and emotional roots become important.": "گھر، ماں، جائیداد، خاندان اور جذباتی جڑیں اہم ہو جاتی ہیں۔",
    "Creativity, romance, children, hobbies and self-expression become important.": "تخلیقی صلاحیتیں، رومانس، بچے، مشاغل اور خود اظہار اہم ہو جاتے ہیں۔",
    "Work routine, health habits, service and discipline become important.": "کام کا معمول، صحت کی عادات، خدمت اور نظم و ضبط اہم ہو جاتے ہیں۔",
    "Relationship, marriage, partnership and public dealing become important.": "رشتہ، شادی، شراکت داری اور پبلک ڈیلنگ اہم ہو جاتی ہے۔",
    "Deep emotional change, intimacy, shared money and transformation become important.": "گہری جذباتی تبدیلی، قربت، مشترکہ رقم اور تبدیلی اہم ہو جاتی ہے۔",
    "Learning, travel, teaching, belief and higher wisdom become important.": "سیکھنا، سفر، تعلیم، یقین اور اعلیٰ حکمت اہم ہو جاتی ہے۔",
    "Career, status, public image and responsibility become emotionally important.": "کیریئر، حیثیت، عوامی امیج اور ذمہ داری جذباتی طور پر اہم ہو جاتی ہے۔",
    "Income, friends, networking, community and ambitions become important.": "آمدنی، دوست، نیٹ ورکنگ، کمیونٹی اور عزائم اہم ہو جاتے ہیں۔",
    "Rest, isolation, spirituality, foreign connection and inner healing become important.": "آرام، تنہائی، روحانیت، غیر ملکی تعلق اور اندرونی شفاء اہم ہو جاتی ہے۔",
    "Identity development and self-expression are central.": "شناخت کی نشوونما اور خود اظہار خیال مرکزی حیثیت رکھتے ہیں۔",
    "Values, money and self-worth become central.": "اقدار، پیسہ اور خود کی قیمت مرکزی بن جاتے ہیں.",
    "Communication, learning and skills become central.": "مواصلات، سیکھنے اور مہارتیں مرکزی بن جاتی ہیں۔",
    "Home, roots and emotional foundation become central.": "گھر، جڑیں اور جذباتی بنیاد مرکزی بن جاتی ہے۔",
    "Creativity, love and self-expression become central.": "تخلیقی صلاحیت، محبت اور خود اظہار مرکزی بن جاتے ہیں۔",
    "Work, discipline and health routines become central.": "کام، نظم و ضبط اور صحت کے معمولات مرکزی بن جاتے ہیں۔",
    "Partnerships and relationship identity become central.": "شراکت داری اور تعلقات کی شناخت مرکزی بن جاتی ہے۔",
    "Transformation, deep healing and shared resources become central.": "تبدیلی، گہری شفا اور مشترکہ وسائل مرکزی بن جاتے ہیں.",
    "Wisdom, travel, belief and higher learning become central.": "حکمت، سفر، یقین اور اعلیٰ تعلیم کو مرکزی حیثیت حاصل ہے۔",
    "Career, authority and public role become central.": "کیریئر، اتھارٹی اور عوامی کردار مرکزی بن جاتے ہیں۔",
    "Community, income, goals and networks become central.": "کمیونٹی، آمدنی، اہداف اور نیٹ ورک مرکزی بن جاتے ہیں۔",
    "Spirituality, closure, retreat and inner development become central.": "روحانیت، بندش، اعتکاف اور باطنی ترقی کو مرکزی حیثیت حاصل ہے۔",
    "This house becomes emotionally important.": "یہ گھر جذباتی طور پر اہم ہو جاتا ہے۔",
    "This house becomes central for identity development.": "یہ گھر شناخت کی ترقی کے لیے مرکزی بن جاتا ہے۔",
    "Thinking, communication, learning and decisions are developing through this house.": "سوچ، ابلاغ، سیکھنے اور فیصلے اس گھر کے ذریعے ترقی کر رہے ہیں۔",
    "Love, comfort, values, beauty and money preferences are developing through this house.": "اس گھر کے ذریعے محبت، سکون، اقدار، خوبصورتی اور پیسے کی ترجیحات پروان چڑھ رہی ہیں۔",
    "Action style, courage, ambition and drive are developing through this house.": "ایکشن اسٹائل، ہمت، امنگ اور ڈرائیو اس گھر کے ذریعے پروان چڑھ رہی ہے۔",
    "Growth, faith, learning and expansion themes develop through this house.": "ترقی، ایمان، سیکھنے اور توسیع کے موضوعات اس گھر کے ذریعے تیار ہوتے ہیں۔",
    "Maturity, responsibility, discipline and long-term structure develop through this house.": "اس گھر کے ذریعے پختگی، ذمہ داری، نظم و ضبط اور طویل مدتی ڈھانچہ تیار ہوتا ہے۔",
    "This progressed planet shows an inner life phase through this house.": "یہ ترقی یافتہ سیارہ اس گھر کے ذریعے زندگی کا ایک اندرونی مرحلہ دکھاتا ہے۔",
    "New Moon Phase": "نئے چاند کا مرحلہ",
    "New beginning, identity reset and fresh internal cycle.": "نئی شروعات، شناخت کی دوبارہ ترتیب اور تازہ داخلی چکر۔",
    "Crescent Phase": "کریسنٹ فیز",
    "Growth, effort, learning and building confidence.": "ترقی، کوشش، سیکھنے اور اعتماد پیدا کرنا۔",
    "First Quarter Phase": "پہلا سہ ماہی مرحلہ",
    "Action, decision-making, pressure and development.": "عمل، فیصلہ سازی، دباؤ اور ترقی۔",
    "Gibbous Phase": "گبس فیز",
    "Refinement, improvement, preparation and skill-building.": "تطہیر، بہتری، تیاری اور مہارت کی تعمیر۔",
    "Full Moon Phase": "پورے چاند کا مرحلہ",
    "Visibility, relationship awareness, emotional clarity and results.": "مرئیت، تعلق سے آگاہی، جذباتی وضاحت اور نتائج۔",
    "Disseminating Phase": "پھیلانے والا مرحلہ",
    "Sharing, teaching, communication and distributing experience.": "اشتراک، تعلیم، مواصلات اور تقسیم کا تجربہ۔",
    "Last Quarter Phase": "آخری سہ ماہی کا مرحلہ",
    "Reorientation, correction, release and mature decision-making.": "از سر نو ترتیب، اصلاح، رہائی اور بالغ فیصلہ سازی۔",
    "Balsamic Phase": "بالسامک مرحلہ",
    "Closure, spiritual reflection, rest and preparation for a new cycle.": "بندش، روحانی عکاسی، آرام اور ایک نئے چکر کے لیے تیاری۔",
    "A major emotional and identity phase begins. The person may feel ready for a new chapter.": "ایک اہم جذباتی اور شناختی مرحلہ شروع ہوتا ہے۔ وہ شخص ایک نئے باب کے لیے تیار محسوس کر سکتا ہے۔",
    "Emotional reset period. Family, comfort, inner peace and emotional needs become important.": "جذباتی ری سیٹ کی مدت۔ خاندان، سکون، اندرونی سکون اور جذباتی ضروریات اہم ہو جاتی ہیں۔",
    "Love, relationship, comfort, beauty and emotional bonding become important.": "محبت، رشتہ، سکون، خوبصورتی اور جذباتی بندھن اہم ہو جاتے ہیں۔",
    "Emotional needs and relationship expectations may need adjustment.": "جذباتی ضروریات اور تعلقات کی توقعات کو ایڈجسٹمنٹ کی ضرورت ہو سکتی ہے۔",
    "Energy, passion, impatience and action increase. Emotional reactions may become quick.": "توانائی، جذبہ، بے صبری اور عمل میں اضافہ ہوتا ہے۔ جذباتی رد عمل فوری ہو سکتا ہے۔",
    "Emotional restlessness, anger, conflict or urgent action can increase.": "جذباتی بے چینی، غصہ، تنازعہ یا فوری اقدام بڑھ سکتا ہے۔",
    "A serious emotional phase. Responsibility, maturity, family pressure or inner discipline may increase.": "ایک سنگین جذباتی مرحلہ۔ ذمہ داری، پختگی، خاندانی دباؤ یا اندرونی نظم و ضبط بڑھ سکتا ہے۔",
    "Emotional heaviness or responsibility may be felt. Patience and maturity are required.": "جذباتی بوجھ یا ذمہ داری محسوس کی جا سکتی ہے۔ صبر اور پختگی کی ضرورت ہے۔",
    "Supportive emotional growth, optimism, travel, learning and blessings can increase.": "معاون جذباتی نشوونما، رجائیت، سفر، سیکھنے اور برکتیں بڑھ سکتی ہیں۔",
    "A growth-oriented emotional phase. Good for learning, expansion, support and positive decisions.": "ترقی پر مبنی جذباتی مرحلہ۔ سیکھنے، توسیع، حمایت اور مثبت فیصلوں کے لیے اچھا ہے۔",
    "Identity, love, beauty, money values and creative expression become highlighted.": "شناخت، محبت، خوبصورتی، پیسے کی قدریں اور تخلیقی اظہار نمایاں ہو جاتا ہے۔",
    "Confidence, courage, ambition and action increase. Good for starting a new active phase.": "اعتماد، ہمت، امنگ اور عمل میں اضافہ ہوتا ہے۔ ایک نیا فعال مرحلہ شروع کرنے کے لیے اچھا ہے۔",
    "A maturity test. Responsibility, delay, pressure or career restructuring may occur.": "ایک میچورٹی ٹیسٹ۔ ذمہ داری، تاخیر، دباؤ یا کیریئر کی تنظیم نو ہو سکتی ہے۔",
    "Growth, confidence, wisdom, recognition and opportunity can increase.": "ترقی، اعتماد، حکمت، پہچان اور مواقع میں اضافہ ہو سکتا ہے۔",
    "Mental clarity, communication, study, writing and business decisions become important.": "ذہنی وضاحت، مواصلات، مطالعہ، تحریری اور کاروباری فیصلے اہم ہو جاتے ہیں۔",
    "A new mental cycle begins. Good for learning, communication, writing and skill development.": "ایک نیا ذہنی چکر شروع ہوتا ہے۔ سیکھنے، مواصلات، تحریری اور مہارت کی ترقی کے لئے اچھا ہے.",
    "Love, beauty, comfort, social life and values become strongly connected to identity.": "محبت، خوبصورتی، سکون، سماجی زندگی اور اقدار شناخت سے مضبوطی سے جڑے ہوئے ہیں۔",
    "Action, confidence, ambition and personal drive become stronger.": "عمل، اعتماد، امنگ اور ذاتی ڈرائیو مضبوط ہو جاتی ہے۔",
    "Progressed Mercury supports learning, communication, business, writing, marketing, coding or analytical work.": "ترقی یافتہ مرکری سیکھنے، مواصلات، کاروبار، تحریر، مارکیٹنگ، کوڈنگ یا تجزیاتی کام کی حمایت کرتا ہے۔",
    "Progressed Mars supports action, courage, competition, technical work and active career decisions.": "ترقی یافتہ مریخ عمل، ہمت، مقابلہ، تکنیکی کام اور فعال کیریئر کے فیصلوں کی حمایت کرتا ہے۔",
    "Progressed Venus supports financial values, comfort, gains, luxury, art or relationship-based income themes.": "ترقی یافتہ زہرہ مالی اقدار، آرام، فوائد، عیش و عشرت، آرٹ یا تعلقات پر مبنی آمدنی کے موضوعات کی حمایت کرتا ہے۔",
    "Progressed Jupiter can show growth-oriented financial thinking and expansion of resources.": "ترقی یافتہ مشتری ترقی پر مبنی مالی سوچ اور وسائل کی توسیع دکھا سکتا ہے۔",
    "Career phase should be judged from Progressed Sun, Moon, Mercury, Mars and aspects to natal Sun, Saturn and Midheaven.": "کیریئر کے مرحلے کا اندازہ سورج، چاند، عطارد، مریخ اور پیدائشی سورج، زحل اور مدھیہون کے پہلوؤں سے کیا جانا چاہیے۔",
    "Love phase should be judged from Progressed Moon, Venus, Mars and aspects to natal Moon, Venus, Mars and the 7th house.": "محبت کے مرحلے کو ترقی یافتہ چاند، زہرہ، مریخ اور پیدائشی چاند، زہرہ، مریخ اور ساتویں گھر کے پہلوؤں سے پرکھنا چاہیے۔",
    "Money phase should be judged from Progressed Moon, Venus, Jupiter and natal 2nd, 8th and 11th house connections.": "رقم کے مرحلے کا اندازہ ترقی یافتہ چاند، زہرہ، مشتری اور پیدائش کے دوسرے، آٹھویں اور گیارہویں گھر کے کنکشن سے کیا جانا چاہیے۔",
    "Western Astrology - Kundlistar": "مغربی علم نجوم - Kundlistar",
    "No chart data available for preview": "پیش نظارہ کے لیے کوئی چارٹ ڈیٹا دستیاب نہیں ہے۔",
    "Failed to load chart": "چارٹ لوڈ کرنے میں ناکام",
    "Chart not found": "چارٹ نہیں ملا",
    "Western Astrology Module | Kundlistar": "مغربی نجومی ماڈیول | Kundlistar",
    "Explore Western Astrology inside Kundlistar with natal chart positions, Placidus house cusps, outer planets and premium Transits, Solar Return and Synastry features.": "Kundlistar کے اندر نیٹل چارٹ پوزیشنز، Placidus house cusps، بیرونی سیارے اور پریمیم ٹرانزٹ، Solar Return اور Synastry خصوصیات کے ساتھ مغربی علم نجوم کو دریافت کریں۔",
    "Western astrology, natal chart, transits, solar return, synastry, Kundlistar": "مغربی علم نجوم، پیدائشی چارٹ، ٹرانزٹ، سولر ریٹرن، سنسٹری، Kundlistar",
    "New section": "نیا سیکشن",
    "Premium active": "پریمیم فعال",
    "minmax(360px, 0.85fr) minmax(0, 1.15fr)": "minmax(360px, 0.85fr) minmax(0, 1.15fr)",
    "House System": "ہاؤس سسٹم",
    "Placidus cusps": "Placidus cusps",
    "Part of Fortune": "قسمت کا حصہ",
    "Natal Western Aspects": "قدرتی مغربی پہلو",
    "No major Western aspects found within the configured orbs.": "تشکیل شدہ اوربس کے اندر کوئی بڑا مغربی پہلو نہیں ملا۔",
    "Western natal astrology wheel": "مغربی پیدائشی علم نجوم کا پہیہ",
    "Western Transits": "مغربی ٹرانزٹ",
    "Current transit-to-natal calculations using the loaded chart birthplace.": "بھری ہوئی چارٹ پیدائش کی جگہ کا استعمال کرتے ہوئے موجودہ ٹرانزٹ سے لے کر پیدائش کے حسابات۔",
    "Natal points available": "نیٹل پوائنٹس دستیاب ہیں۔",
    "Transit planets loaded": "ٹرانزٹ سیارے بھرے ہوئے ہیں۔",
    "Loading current transit positions...": "موجودہ ٹرانزٹ پوزیشنز لوڈ ہو رہی ہیں...",
    "Aspect method": "پہلو کا طریقہ",
    "Conjunction, sextile, square, trine and opposition with Western orbs": "کنکشن، سیکسٹائل، مربع، ٹرائن اور مغربی اوربس کے ساتھ مخالفت",
    "Primary focus": "بنیادی توجہ",
    "Transit contacts to natal Sun, Moon, Ascendant, Venus, Mars, Jupiter, Saturn and outer planets": "پیدائشی سورج، چاند، چڑھنے والے، زہرہ، مریخ، مشتری، زحل اور بیرونی سیاروں سے رابطے",
    "Natal inner wheel": "نیٹل اندرونی پہیہ",
    "Transit outer wheel": "ٹرانزٹ بیرونی پہیہ",
    "Current Transit Positions": "موجودہ ٹرانزٹ پوزیشنز",
    "Transit positions are not available.": "ٹرانزٹ پوزیشنز دستیاب نہیں ہیں۔",
    "Current Transit Aspects to Natal Chart": "نیٹل چارٹ کے موجودہ ٹرانزٹ پہلو",
    "Loading transit aspects...": "ٹرانزٹ کے پہلو لوڈ ہو رہے ہیں...",
    "No major transit aspects found within the configured orbs.": "ترتیب شدہ orbs کے اندر کوئی اہم ٹرانزٹ پہلو نہیں ملا۔",
    "Annual Western return reference from the natal Sun, with supporting natal aspect context.": "پیدائشی سورج کی طرف سے سالانہ مغربی واپسی کا حوالہ، معاون پیدائشی پہلو کے سیاق و سباق کے ساتھ۔",
    "Solar return date": "شمسی واپسی کی تاریخ",
    "Calculation time": "حساب کا وقت",
    "Birth date not available": "تاریخ پیدائش دستیاب نہیں ہے۔",
    "Natal Sun": "نٹل سن",
    "Natal Sun house": "نٹل سن ہاؤس",
    "Return planets loaded": "بھری ہوئی سیارے واپس کریں۔",
    "Loading solar return chart...": "سولر ریٹرن چارٹ لوڈ ہو رہا ہے...",
    "Annual focus": "سالانہ فوکس",
    "Solar themes are read from the natal Sun, return Ascendant and yearly return chart.": "شمسی موضوعات کو پیدائشی سورج، واپسی چڑھائی اور سالانہ واپسی چارٹ سے پڑھا جاتا ہے۔",
    "Solar Return Planet Positions": "شمسی واپسی سیارے کی پوزیشنیں۔",
    "Loading solar return planets...": "شمسی واپسی والے سیاروں کو لوڈ کیا جا رہا ہے...",
    "Solar return positions are not available.": "شمسی توانائی سے واپسی کی پوزیشنیں دستیاب نہیں ہیں۔",
    "Solar Return House Cusps": "سولر ریٹرن ہاؤس Cusps",
    "Loading solar return cusps...": "سولر ریٹرن کپ لوڈ ہو رہا ہے...",
    "Solar return house cusps are not available.": "سولر ریٹرن ہاؤس cusps دستیاب نہیں ہیں۔",
    "Solar Return Aspects to Natal Chart": "نےٹل چارٹ میں شمسی واپسی کے پہلو",
    "Loading solar return aspects...": "شمسی توانائی کی واپسی کے پہلوؤں کو لوڈ کیا جا رہا ہے...",
    "No major solar return aspects found within the configured orbs.": "ترتیب شدہ اوربس کے اندر شمسی واپسی کے کوئی بڑے پہلو نہیں ملے۔",
    "Natal Sun Aspects for Solar Return Focus": "شمسی واپسی فوکس کے لیے نیٹل سورج کے پہلو",
    "No major natal Sun aspects found within the configured orbs.": "تشکیل شدہ اوربس کے اندر کوئی اہم پیدائشی سورج کے پہلو نہیں ملے۔",
    "Relationship overlay framework using planet-to-planet aspects, angle contacts and house overlays.": "سیارے سے سیارے کے پہلوؤں، زاویہ کے رابطوں اور گھر کے اوورلیز کا استعمال کرتے ہوئے تعلقات کا اوورلے فریم ورک۔",
    "Loaded first chart": "پہلا چارٹ لوڈ کیا گیا۔",
    "Second chart": "دوسرا چارٹ",
    "Select or load partner chart to calculate full synastry overlay": "مکمل سنسٹری اوورلے کا حساب لگانے کے لیے پارٹنر چارٹ کو منتخب کریں یا لوڈ کریں۔",
    "Major inter-chart aspects with tight orb priority": "سخت اورب ترجیح کے ساتھ بڑے انٹر چارٹ پہلو",
    "House overlay method": "گھر کے اوورلے کا طریقہ",
    "Partner planets are placed into the first chart houses after second chart is selected": "دوسرے چارٹ کے انتخاب کے بعد پارٹنر سیاروں کو پہلے چارٹ ہاؤسز میں رکھا جاتا ہے۔",
    "Relationship Pattern Aspects from Loaded Chart": "بھری ہوئی چارٹ سے تعلق کے پیٹرن کے پہلو",
    "No major relationship-focused natal aspects found within the configured orbs.": "تشکیل شدہ اوربس کے اندر کوئی اہم رشتہ پر مرکوز پیدائشی پہلو نہیں ملے۔",
    "Understand your current inner life phase through Western Secondary Progressions.": "مغربی ثانوی ترقی کے ذریعے اپنے موجودہ اندرونی زندگی کے مرحلے کو سمجھیں۔",
    "Secondary Progression": "ثانوی ترقی",
    "1 day after birth = 1 year of life": "پیدائش کے بعد 1 دن = زندگی کا 1 سال",
    "Current age used": "استعمال شدہ موجودہ عمر",
    "Progressed date": "ترقی یافتہ تاریخ",
    "Progressed Moon": "ترقی یافتہ چاند",
    "Loading progressed Moon...": "لوڈ ہو رہا ہے ترقی یافتہ چاند...",
    "Progressed Moon phase": "ترقی یافتہ چاند کا مرحلہ",
    "Loading Moon phase...": "چاند کا مرحلہ لوڈ ہو رہا ہے...",
    "Current Life Phase": "موجودہ زندگی کا مرحلہ",
    "Secondary progressions show the inner phase of life, emotional maturity, identity development and changing priorities.": "ثانوی ترقی زندگی کے اندرونی مرحلے، جذباتی پختگی، شناخت کی نشوونما اور بدلتی ترجیحات کو ظاہر کرتی ہے۔",
    "Progressed Career Phase": "ترقی یافتہ کیریئر کا مرحلہ",
    "Progressed Love Phase": "ترقی یافتہ محبت کا مرحلہ",
    "Progressed Money Phase": "ترقی یافتہ رقم کا مرحلہ",
    "Loading progressed planets...": "ترقی یافتہ سیارے لوڈ ہو رہے ہیں...",
    "Progressed planets are not available.": "ترقی یافتہ سیارے دستیاب نہیں ہیں۔",
    "Loading progressed aspects...": "ترقی یافتہ پہلوؤں کو لوڈ کیا جا رہا ہے...",
    "No tight progressed-to-natal aspects found right now.": "ابھی کوئی سخت ترقی سے لے کر پیدائشی پہلو نہیں ملے۔",
    "This phase should be judged from progressed planets, progressed Moon phase and tight progressed-to-natal aspects.": "اس مرحلے کا اندازہ ترقی یافتہ سیاروں، ترقی یافتہ چاند کے مرحلے اور سخت ترقی سے پیدائش کے پہلوؤں سے کیا جانا چاہیے۔",
    "Vastu Analysis - Kundlistar": "واستو تجزیہ - Kundlistar",
    "Failed to load selected chart.": "منتخب کردہ چارٹ لوڈ کرنے میں ناکام۔",
    "Facing Direction": "سمت کا سامنا کرنا",
    "Entrance Direction": "داخلے کی سمت",
    "Kitchen Direction": "باورچی خانے کی سمت",
    "Master Bedroom": "ماسٹر بیڈروم",
    "Children Bedroom": "بچوں کا بیڈروم",
    "Toilet Direction": "ٹوائلٹ کی سمت",
    "Pooja Direction": "پوجا ڈائریکشن",
    "Water Tank": "واٹر ٹینک",
    "Underground Water": "زیر زمین پانی",
    "Heavy Storage": "بھاری ذخیرہ",
    "Living Room": "لونگ روم",
    "Study Room": "مطالعہ کا کمرہ",
    "Vastu report generation failed.": "واستو رپورٹ کی تیاری ناکام ہوگئی۔",
    "Please generate the Vastu report before downloading.": "براہ کرم ڈاؤن لوڈ کرنے سے پہلے واستو رپورٹ تیار کریں۔",
    "Failed to download Vastu report.": "واستو رپورٹ ڈاؤن لوڈ کرنے میں ناکام۔",
    "Premium Feature": "پریمیم فیچر",
    "Selected Chart": "منتخب کردہ چارٹ",
    "Basic + KP + BNN from chart": "چارٹ سے بنیادی + KP + BNN",
    "Basic shown, KP + BNN locked": "بنیادی دکھایا گیا، KP + BNN مقفل ہے۔",
    "Property Type": "پراپرٹی کی قسم",
    "Center Area": "سینٹر ایریا",
    "Generate Vastu Report": "واستو رپورٹ بنائیں",
    "Basic Vastu Analysis": "بنیادی واستو تجزیہ",
    "KP Vastu Analysis": "کے پی واستو تجزیہ",
    "BNN Vastu Analysis": "بی این این واستو تجزیہ",
    "North East": "شمال مشرق",
    "South East": "جنوب مشرقی",
    "South West": "جنوب مغرب",
    "North West": "شمال مغرب",
    "Red Coral": "سرخ مرجان",
    "Yellow Sapphire": "پیلا نیلم",
    "Blue Sapphire": "نیلا نیلم",
    "Cat's Eye": "کیٹ آئی",
    "Additional Option": "اضافی آپشن",
    "Lagna rule supports this gemstone option.": "لگنا اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Moon sign rule supports this gemstone option.": "چاند کے نشان کا اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Birth date rule supports this gemstone option.": "تاریخ پیدائش کا اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Birth weekday rule supports this gemstone option.": "یوم پیدائش کا قاعدہ اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Current dasha rule supports this gemstone option.": "موجودہ dasha اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Age-band rule supports this gemstone option.": "عمر بینڈ اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Selected goal supports this gemstone option.": "منتخب کردہ گول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Profession rule supports this gemstone option.": "پیشہ ورانہ اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Name-initial rule supports this gemstone option.": "نام کا ابتدائی اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Moolank rule supports this gemstone option.": "Moolank اصول اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Chart condition check was considered for this option.": "اس اختیار کے لیے چارٹ کنڈیشن چیک پر غور کیا گیا۔",
    "Rule-based chart match supports this gemstone option.": "اصول پر مبنی چارٹ میچ اس قیمتی پتھر کے اختیار کی حمایت کرتا ہے۔",
    "Expert kundli review is recommended before wearing this gemstone.": "اس قیمتی پتھر کو پہننے سے پہلے ماہر کنڈلی کا جائزہ لینے کی سفارش کی جاتی ہے۔",
    "Ring finger": "انگوٹھی کی انگلی",
    "Little finger": "چھوٹی انگلی",
    "Index finger": "شہادت کی انگلی",
    "Middle finger": "درمیانی انگلی",
    "Why recommended": "کیوں سفارش کی",
    "Approx weight": "تقریباً وزن",
    "Could not load chart.": "چارٹ لوڈ نہیں ہو سکا۔",
    "Gemstone Recommendations | Kundlistar": "قیمتی پتھر کی سفارشات | Kundlistar",
    "Explore Vedic gemstone recommendations from Kundlistar's rule-based kundli analysis engine.": "Kundlistar کے اصول پر مبنی کنڈلی تجزیہ انجن سے ویدک قیمتی پتھر کی سفارشات دریافت کریں۔",
    "noindex,nofollow": "noindex، nofollow",
    "gemstone recommendation, Vedic gemstones, kundli gemstone, Kundlistar": "قیمتی پتھر کی سفارش، ویدک قیمتی پتھر، کنڈلی قیمتی پتھر، Kundlistar",
    "Gemstone Recommendations": "قیمتی پتھر کی سفارشات",
    "Separate Kundlistar module for Vedic gemstone guidance based on lagna, Chandra Rashi, dasha, DOB, profession and goals.": "لگنا، چندر راشی، دشا، DOB، پیشہ اور اہداف پر مبنی ویدک قیمتی پتھر کی رہنمائی کے لیے الگ Kundlistar ماڈیول۔",
    "Personalized Gemstone Recommendations are available for Premium users.": "پریمیم صارفین کے لیے ذاتی نوعیت کی قیمتی پتھر کی سفارشات دستیاب ہیں۔",
    "Upgrade to Premium": "پریمیم میں اپ گریڈ کریں۔",
    "Login to Upgrade": "اپ گریڈ کرنے کے لیے لاگ ان کریں۔",
    "Select Goal": "گول منتخب کریں۔",
    "Business, government job, teacher...": "کاروبار، سرکاری نوکری، استاد...",
    "Weight kg": "وزن کلو",
    "वजन kg": "2 کلوگرام",
    "Optional ratti estimate": "اختیاری رتی تخمینہ",
    "Click Calculate to apply these values.": "ان اقدار کو لاگو کرنے کے لیے کیلکولیٹ پر کلک کریں۔",
    "} variant=\"body2\">• {extra.stone}{isHindi ? ": "} variant=\"body2\">• {extra.stone}{isHindi ?",
    "Nadi Analysis": "نادی تجزیہ",
    "KP Analysis": "کے پی تجزیہ",
    "Vedic Analysis": "ویدک تجزیہ",
    "BNN Analysis": "بی این این تجزیہ",
    "Jaimini Analysis": "جیمنی تجزیہ",
    "Western Astrology": "مغربی علم نجوم",
    "Panch Pakshi": "پنچ پکشی",
    "Tithi Pravesh": "تیتھی پرویش",
    "Lal Kitab": "لال کتاب",
    "Astro Logo": "ایسٹرو لوگو",
    "Download failed": "ڈاؤن لوڈ ناکام ہو گیا۔",
    "Could not download PDF report.": "PDF رپورٹ ڈاؤن لوڈ نہیں ہو سکی۔",
    "Please login to download PDF reports.": "براہ کرم پی ڈی ایف رپورٹس ڈاؤن لوڈ کرنے کے لیے لاگ ان کریں۔",
    "Failed to generate personalised report": "ذاتی نوعیت کی رپورٹ بنانے میں ناکام",
    "Could not download personalised report.": "ذاتی نوعیت کی رپورٹ ڈاؤن لوڈ نہیں ہو سکی۔",
    "calc(100vh - var(--kundlistar-navbar-height, 64px))": "کیلک(100vh - var(-kundlistar-navbar-height, 64px))",
    "calc(100vh - var(--kundlistar-navbar-height, 160px))": "calc(100vh - var(-kundlistar-navbar-height, 160px))",
    "width 0.2s ease": "چوڑائی 0.2s آسانی",
    "Collapse sidebar": "سائڈبار کو سکیڑیں۔",
    "Expand sidebar": "سائڈبار کو پھیلائیں۔",
    "& .MuiListItemIcon-root": "اور .MuiListItemIcon-root",
    "Download PDF Report": "پی ڈی ایف رپورٹ ڈاؤن لوڈ کریں۔",
    "Login to download": "ڈاؤن لوڈ کرنے کے لیے لاگ ان کریں۔",
    "PDF Report": "پی ڈی ایف رپورٹ",
    "Download Personal Report": "ذاتی رپورٹ ڈاؤن لوڈ کریں۔",
    "Buy Premium to download": "ڈاؤن لوڈ کرنے کے لیے پریمیم خریدیں۔",
    "Login to buy Premium": "پریمیم خریدنے کے لیے لاگ ان کریں۔",
    "Buy Premium": "پریمیم خریدیں۔",
    "& .MuiTab-root": "اور .MuiTab-root",
    "& .Mui-selected": "اور .Mui منتخب کردہ",
    "Unable to load Client Management data.": "کلائنٹ مینجمنٹ ڈیٹا لوڈ کرنے سے قاصر۔",
    "Unable to download PDF.": "PDF ڈاؤن لوڈ کرنے سے قاصر۔",
    "Free client limit reached": "مفت کلائنٹ کی حد پوری ہوگئی",
    "Welcome": "خوش آمدید",
    "Hello": "ہیلو",
    "Your saved charts are shown below.": "آپ کے محفوظ کردہ چارٹس نیچے دکھائے گئے ہیں۔",
    "All Features": "تمام خصوصیات",
    "New Chart": "نیا چارٹ",
    "Vedic Chart": "ویدک چارٹ",
    "Chakra": "چکرا۔",
    "Daily Panchang": "ڈیلی پنچانگ",
    "Choghadiya": "چوگھڑیا۔",
    "Daily Horoscope": "روزانہ زائچہ",
    "Gochar Alerts": "گوچر الرٹس",
    "Matching": "ملاپ کرنا",
    "Ruling Planets": "حاکم سیارے",
    "Horary Chart": "ہوری چارٹ",
    "Astro-Vastu": "آسٹرو واستو",
    "Vedic Numerology": "ویدک شماریات",
    "My Charts": "میرے چارٹس",
    "Search by Name": "نام سے تلاش کریں۔",
    "Type": "قسم",
    "All": "تمام",
    "Individual": "انفرادی",
    "Horary": "ہوری",
    "Clear": "صاف",
    "Name": "نام",
    "DOB": "ڈی او بی",
    "Place": "جگہ",
    "Gender": "جنس",
    "Created": "بنایا",
    "Actions": "اعمال",
    "Male": "مرد",
    "Female": "خاتون",
    "No matching charts found": "کوئی مماثل چارٹس نہیں ملے",
    "Create First Chart": "پہلا چارٹ بنائیں",
    "View Chart": "چارٹ دیکھیں",
    "Copy Share Link": "شیئر لنک کاپی کریں۔",
    "Use premium credit: Download PDF Report": "پریمیم کریڈٹ استعمال کریں: پی ڈی ایف رپورٹ ڈاؤن لوڈ کریں۔",
    "Download Personalised Report": "ذاتی نوعیت کی رپورٹ ڈاؤن لوڈ کریں۔",
    "Premium: Download Personalised Report": "پریمیم: ذاتی نوعیت کی رپورٹ ڈاؤن لوڈ کریں۔",
    "Hide Chart": "چارٹ چھپائیں۔",
    "Personalised": "ذاتی نوعیت کا",
    "Generating your Personalised Report": "آپ کی ذاتی نوعیت کی رپورٹ تیار کرنا",
    "Please do not leave this page till the report is generated. This can take a little while.": "رپورٹ آنے تک اس صفحہ کو مت چھوڑیں۔ اس میں تھوڑا وقت لگ سکتا ہے۔",
    "Please don't leave this page till the report is generated. This can take a little while.": "رپورٹ آنے تک اس صفحہ کو مت چھوڑیں۔ اس میں تھوڑا وقت لگ سکتا ہے۔",
    "Update": "اپڈیٹ کریں۔",
    "Complete your billing address. Required for generating invoice.": "اپنا بلنگ ایڈریس مکمل کریں۔ انوائس بنانے کے لیے درکار ہے۔",
    "Report this report": "اس رپورٹ کو رپورٹ کریں۔",
    "Reason": "وجہ",
    "Optional comment": "اختیاری تبصرہ",
    "Submit": "جمع کروائیں۔",
    "Incorrect info": "غلط معلومات",
    "Offensive": "جارحانہ",
    "Harmful": "نقصان دہ",
    "This report has been sent for review.": "یہ رپورٹ جائزہ کے لیے بھیج دی گئی ہے۔",
    "Failed to submit report feedback": "رپورٹ فیڈ بیک جمع کرانے میں ناکام",
    "Failed to download PDF": "PDF ڈاؤن لوڈ کرنے میں ناکام",
    "Failed to download personalised report": "ذاتی نوعیت کی رپورٹ ڈاؤن لوڈ کرنے میں ناکام",
    "Failed to load charts": "چارٹس لوڈ کرنے میں ناکام",
    "Failed to hide chart": "چارٹ چھپانے میں ناکام",
    "Failed to delete chart": "چارٹ کو حذف کرنے میں ناکام",
    "Share link copied to clipboard!": "لنک کا اشتراک کلپ بورڈ پر کاپی ہو گیا!",
    "Delete Chart": "چارٹ کو حذف کریں۔",
    "Delete chart": "چارٹ حذف کریں۔",
    "Error": "خرابی",
    "OK": "ٹھیک ہے",
    "Thanks": "شکریہ",
    "Report failed": "رپورٹ ناکام ہوگئی",
    "Could not submit report feedback.": "رپورٹ فیڈ بیک جمع نہیں کر سکا۔",
    "Personalised report ready": "ذاتی رپورٹ تیار ہے۔",
    "Personalised report failed": "ذاتی نوعیت کی رپورٹ ناکام ہو گئی۔",
    "Could not generate personalised report.": "ذاتی نوعیت کی رپورٹ نہیں بن سکی۔",
    "Could not generate personalised PDF report.": "ذاتی نوعیت کی PDF رپورٹ نہیں بن سکی۔",
    "Monthly limit reached": "ماہانہ حد تک پہنچ گئی۔",
    "Your monthly personalised report limit is reached. Subscribe to an add-on: ₹299/month for 20 reports or ₹499/month for 40 reports.": "آپ کی ماہانہ ذاتی رپورٹ کی حد پوری ہو گئی ہے۔ ایک ایڈ آن کو سبسکرائب کریں: 20 رپورٹس کے لیے ₹299/ماہ یا 40 رپورٹس کے لیے ₹499/ماہ۔",
    "Buy Add-on": "ایڈ آن خریدیں۔",
    "Manage": "انتظام کریں۔",
    "Add-on active: Unlimited reports": "ایڈ آن فعال: لامحدود رپورٹس",
    "Add-on active: 40 reports/month": "ایڈ آن فعال: 40 رپورٹس/مہینہ",
    "Add-on active: 20 reports/month": "ایڈ آن فعال: 20 رپورٹس/ماہ",
    "reports remaining this cycle": "رپورٹس اس چکر میں باقی ہیں۔",
    "Add-on active": "ایڈ آن فعال",
    "Personalised reports remaining this month": "اس مہینے کی ذاتی نوعیت کی رپورٹس باقی ہیں۔",
    "Premium includes 2/month. Add-ons: ₹299/month for 20 reports/month or ₹499/month for 40 reports/month.": "پریمیم میں 2/مہینہ شامل ہے۔ ایڈ آنز: 20 رپورٹس/ماہ کے لیے ₹299/ماہ یا 40 رپورٹس/ماہ کے لیے ₹499/ماہ۔",
    "AI Disclaimer": "AI ڈس کلیمر",
    "This report is generated using AI and astrological interpretations. It is for informational and entertainment purposes only. It should not be considered medical, legal, or financial advice.": "یہ رپورٹ AI اور علم نجوم کی تشریحات کا استعمال کرتے ہوئے تیار کی گئی ہے۔ یہ صرف معلوماتی اور تفریحی مقاصد کے لیے ہے۔ اسے طبی، قانونی، یا مالی مشورہ نہیں سمجھا جانا چاہیے۔",
    "A copy of this report has also been sent to your registered email address as a PDF.": "اس رپورٹ کی ایک کاپی پی ڈی ایف کے طور پر آپ کے رجسٹرڈ ای میل ایڈریس پر بھی بھیج دی گئی ہے۔",
    "Report this AI-generated report?": "AI سے تیار کردہ اس رپورٹ کی اطلاع دیں؟",
    "charts": "چارٹس",
    "Independent notes, date and time planning. Save requires login; free users get full planner access.": "آزاد نوٹ، تاریخ اور وقت کی منصوبہ بندی۔ محفوظ کرنے کے لیے لاگ ان کی ضرورت ہے۔ مفت صارفین کو مکمل منصوبہ ساز تک رسائی حاصل ہے۔",
    "Independent notes, date and time planning.": "آزاد نوٹ، تاریخ اور وقت کی منصوبہ بندی۔",
    "Add Plan": "منصوبہ شامل کریں۔",
    "Save Plan": "منصوبہ محفوظ کریں۔",
    "Saved Plans": "محفوظ شدہ منصوبے",
    "Planner Entry": "منصوبہ ساز اندراج",
    "Plan": "منصوبہ",
    "Saving...": "محفوظ کر رہا ہے...",
    "Refresh": "ریفریش کریں۔",
    "No plans saved yet.": "ابھی تک کوئی منصوبہ محفوظ نہیں ہوا۔",
    "Planner layout is available. Login only when you want to save.": "منصوبہ ساز لے آؤٹ دستیاب ہے۔ صرف اس وقت لاگ ان کریں جب آپ محفوظ کرنا چاہتے ہیں۔",
    "No matching plans.": "کوئی مماثل منصوبہ نہیں ہے۔",
    "Search Plans": "منصوبے تلاش کریں۔",
    "Search title, note, date or status": "عنوان، نوٹ، تاریخ یا حیثیت تلاش کریں۔",
    "Login is required only when you want to save planner entries.": "لاگ ان صرف اس وقت درکار ہے جب آپ منصوبہ ساز اندراجات کو محفوظ کرنا چاہتے ہیں۔",
    "Planner entry saved.": "منصوبہ ساز اندراج محفوظ ہو گیا۔",
    "Unable to load planner.": "پلانر لوڈ کرنے سے قاصر۔",
    "Unable to save planner entry.": "پلانر کے اندراج کو محفوظ کرنے سے قاصر۔",
    "Could not load planner.": "پلانر لوڈ نہیں ہو سکا۔",
    "Could not save planner entry.": "پلانر کے اندراج کو محفوظ نہیں کیا جا سکا۔",
    "Login required to save": "محفوظ کرنے کے لیے لاگ ان درکار ہے۔",
    "You can explore Planner now. Login when you want to save entries.": "آپ ابھی پلانر کو دریافت کر سکتے ہیں۔ جب آپ اندراجات کو محفوظ کرنا چاہتے ہیں تو لاگ ان کریں۔",
    "Prev": "پچھلا",
    "Next": "اگلا",
    "Page": "صفحہ",
    "of": "کی",
    "Child Birth Mahoorat": "بچے کی پیدائش کی مہورت",
    "Child Birth Mahoorat | Kundlistar Premium": "بچے کی پیدائش کی مہورت | کنڈلسٹار پریمیم",
    "Premium Child Birth Mahoorat windows with Panchang, Choghadiya and Hora based guidance.": "پنچانگ، چوگھڑیا اور ہورا پر مبنی رہنمائی کے ساتھ پریمیم چائلڈ برتھ ماہورٹ ونڈوز۔",
    "Select a date and place to explore auspicious available windows for planned child-birth timing guidance.": "منصوبہ بند بچے کی پیدائش کے وقت کی رہنمائی کے لیے ایک تاریخ اور جگہ کا انتخاب کریں۔",
    "Child Birth Mahoorat is for spiritual and astrological guidance only.": "بچے کی پیدائش کی مہورت صرف روحانی اور نجومی رہنمائی کے لیے ہے۔",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock auspicious guidance windows with Panchang, Choghadiya and Hora checks.": "بچے کی پیدائش کی مہورت ایک بہترین خصوصیت ہے۔ پنچانگ، چوگھڑیا اور ہورا چیکس کے ساتھ نیک گائیڈنس ونڈوز کو غیر مقفل کرنے کے لیے اپ گریڈ کریں۔",
    "Child Birth Mahoorat is a premium feature. Upgrade to unlock guidance windows with Panchang, Choghadiya and Hora checks.": "بچے کی پیدائش کی مہورت ایک بہترین خصوصیت ہے۔ Panchang، Choghadiya اور Hora چیک کے ساتھ رہنمائی کی کھڑکیوں کو غیر مقفل کرنے کے لیے اپ گریڈ کریں۔",
    "Premium guidance windows by date, place, Panchang, Choghadiya and Hora.": "تاریخ، جگہ، پنچانگ، چوگھڑیا اور ہورہ کے لحاظ سے پریمیم گائیڈنس ونڈوز۔",
    "Premium feature": "پریمیم خصوصیت",
    "Upgrade to Kundlistar Premium": "Kundlistar Premium میں اپ گریڈ کریں۔",
    "Previous": "پچھلا",
    "Today": "آج",
    "Birth place / City": "جائے پیدائش/شہر",
    "Birth place / city": "جائے پیدائش/شہر",
    "Select country, then search city": "ملک منتخب کریں، پھر شہر تلاش کریں۔",
    "Preferred start": "ترجیحی آغاز",
    "Preferred end": "ترجیحی اختتام",
    "Mother Moon sign (optional)": "ماں چاند کا نشان (اختیاری)",
    "Cancer": "کینسر",
    "Load Kundli": "کنڈلی لوڈ کریں۔",
    "Find Premium Windows": "پریمیم ونڈوز تلاش کریں۔",
    "Date (DD/MM/YYYY)": "تاریخ (DD/MM/YYYY)",
    "Invalid Date": "غلط تاریخ",
    "Date must be in DD/MM/YYYY format.": "تاریخ DD/MM/YYYY فارمیٹ میں ہونی چاہیے۔",
    "Required": "درکار ہے۔",
    "Please select a city.": "براہ کرم ایک شہر منتخب کریں۔",
    "Kundli": "کنڈلی",
    "Unable to load kundli.": "کنڈلی لوڈ کرنے سے قاصر۔",
    "Unable to calculate Child Birth Mahoorat.": "بچے کی پیدائش کی مہورت کا حساب لگانے سے قاصر۔",
    "Kundli Preview": "کنڈلی پیش نظارہ",
    "Loaded for": "کے لیے بھری ہوئی ہے۔",
    "Doshas & Yogas": "دوش اور یوگاس",
    "Rule-based indications from the loaded Lahiri kundli. Use them for review and spiritual guidance, not as a final judgement.": "بھری ہوئی لاہری کنڈلی سے اصول پر مبنی اشارے۔ ان کا جائزہ لینے اور روحانی رہنمائی کے لیے استعمال کریں، حتمی فیصلے کے طور پر نہیں۔",
    "Rule-based indications from the loaded Lahiri kundli. Use for review and spiritual guidance.": "بھری ہوئی لاہری کنڈلی سے اصول پر مبنی اشارے۔ جائزہ لینے اور روحانی رہنمائی کے لیے استعمال کریں۔",
    "Detected": "پتہ چلا",
    "Not detected": "پتہ نہیں چلا",
    "Review": "جائزہ لیں",
    "Dosha": "دوشہ",
    "Yoga": "یوگا",
    "Full Yoga Scan": "مکمل یوگا اسکین",
    "Checking yogas...": "یوگا چیک کر رہا ہے...",
    "No major yogas were detected by the premium yoga scan.": "پریمیم یوگا اسکین کے ذریعہ کسی بڑے یوگا کا پتہ نہیں چلا۔",
    "No suitable premium windows found for the selected date and time range.": "منتخب کردہ تاریخ اور وقت کی حد کے لیے کوئی مناسب پریمیم ونڈوز نہیں ملی۔",
    "No suitable windows found": "کوئی مناسب ونڈوز نہیں ملی",
    "Try changing the time range or select previous/next date.": "وقت کی حد کو تبدیل کرنے کی کوشش کریں یا پچھلی/اگلی تاریخ منتخب کریں۔",
    "Try changing the date or time range.": "تاریخ یا وقت کی حد کو تبدیل کرنے کی کوشش کریں۔",
    "Try the Previous or Next date button to find a better option.": "بہتر آپشن تلاش کرنے کے لیے پچھلی یا اگلی تاریخ کا بٹن آزمائیں۔",
    "Use Previous or Next date to find a better option.": "بہتر آپشن تلاش کرنے کے لیے پچھلی یا اگلی تاریخ کا استعمال کریں۔",
    "Click Find Premium Windows to calculate the best premium windows for the selected date and city.": "منتخب کردہ تاریخ اور شہر کے لیے بہترین پریمیم ونڈوز کا حساب لگانے کے لیے پریمیم ونڈوز ڈھونڈیں پر کلک کریں۔",
    "Tap Find Premium Windows for the selected date and city.": "منتخب کردہ تاریخ اور شہر کے لیے پریمیم ونڈوز تلاش کریں پر ٹیپ کریں۔",
    "Good tithi": "اچھی تیتھی",
    "Supportive nakshatra": "معاون نکشتر",
    "nakshatra is sensitive. Check pada and Gandanta carefully.": "نکشترا حساس ہے۔ پڈا اور گنڈاتا کو احتیاط سے چیک کریں۔",
    "Supportive weekday": "معاون ہفتے کا دن",
    "Good Choghadiya": "اچھا چوگھڑیا۔",
    "Weak Choghadiya": "کمزور چوگھڑیا۔",
    "Supportive Hora": "حامی ہورا",
    "Baby Moon matches mother's Moon sign.": "بیبی مون ماں کے چاند کے نشان سے میل کھاتا ہے۔",
    "Hora": "ہورا",
    "slots": "سلاٹ",
    "min": "منٹ",
    "Good": "اچھا",
    "Excellent": "بہترین",
    "Usable": "قابل استعمال",
    "Rejected": "مسترد",
    "Sunday": "اتوار",
    "Monday": "پیر",
    "Tuesday": "منگل",
    "Wednesday": "بدھ",
    "Thursday": "جمعرات",
    "Friday": "جمعہ",
    "Saturday": "ہفتہ",
    "Sun": "سورج",
    "Moon": "چاند",
    "Mars": "مریخ",
    "Mercury": "مرکری",
    "Jupiter": "مشتری",
    "Venus": "زہرہ",
    "Saturn": "زحل",
    "Rahu": "راہو",
    "Ketu": "کیتو",
    "Chal": "چل",
    "Labh": "لبھ",
    "Amrit": "امرت",
    "Shubh": "شبھ",
    "Udveg": "اڈویج",
    "Rog": "روگ",
    "Kaal": "کال",
    "Krishna Navami": "کرشنا نومی ۔",
    "Ashwini": "اشونی",
    "Bharani": "بھرانی",
    "Krittika": "کریتکا",
    "Rohini": "روہنی",
    "Mrigashira": "مریگاشیرا۔",
    "Ardra": "اردرا",
    "Punarvasu": "پنرواسو",
    "Pushya": "پشیا۔",
    "Ashlesha": "اشلیشہ",
    "Magha": "ماگھا۔",
    "Jyeshtha": "جیشتھا",
    "Moola": "مولا۔",
    "Mula": "مولا",
    "Revati": "ریوتی"
  }
} as const;

const NADI_LIFE_EVENT_TRANSLATIONS: Partial<Record<SupportedLanguage, Record<string, string>>> = {
  hi: { 'Stolen / Lost Item Recovery': 'चोरी हुई / खोई वस्तु की बरामदगी' },
  ta: { 'Stolen / Lost Item Recovery': 'திருடப்பட்ட / தொலைந்த பொருள் மீட்பு' },
  te: { 'Stolen / Lost Item Recovery': 'దొంగిలించబడిన / పోయిన వస్తువు తిరిగి పొందడం' },
  mr: { 'Stolen / Lost Item Recovery': 'चोरीला गेलेली / हरवलेली वस्तू परत मिळणे' },
  gu: { 'Stolen / Lost Item Recovery': 'ચોરાયેલી / ખોવાયેલી વસ્તુની પુનઃપ્રાપ્તિ' },
  bn: { 'Stolen / Lost Item Recovery': 'চুরি হওয়া / হারানো জিনিস উদ্ধার' },
  kn: { 'Stolen / Lost Item Recovery': 'ಕಳುವಾದ / ಕಳೆದುಹೋದ ವಸ್ತುವಿನ ಮರುಪಡೆಯುವಿಕೆ' },
  ml: { 'Stolen / Lost Item Recovery': 'മോഷ്ടിക്കപ്പെട്ട / നഷ്ടപ്പെട്ട വസ്തു വീണ്ടെടുക്കൽ' },
  pa: { 'Stolen / Lost Item Recovery': 'ਚੋਰੀ ਹੋਈ / ਗੁੰਮ ਹੋਈ ਵਸਤੂ ਦੀ ਬਰਾਮਦਗੀ' },
  or: { 'Stolen / Lost Item Recovery': 'ଚୋରି / ହଜିଥିବା ବସ୍ତୁ ଉଦ୍ଧାର' },
  as: { 'Stolen / Lost Item Recovery': 'চুৰি হোৱা / হেৰোৱা বস্তু উদ্ধাৰ' },
  ur: { 'Stolen / Lost Item Recovery': 'چوری شدہ / گمشدہ چیز کی بازیابی' },
};

const PDF_TAJIK_YEAR_TRANSLATIONS: Partial<Record<SupportedLanguage, Record<string, string>>> = {
  hi: { 'PDF Tajik Default Year': 'PDF ताजिक डिफ़ॉल्ट वर्ष', 'Only the selected Tajik year will be included in the PDF report.': 'PDF रिपोर्ट में केवल चयनित ताजिक वर्ष शामिल होगा।' },
  ta: { 'PDF Tajik Default Year': 'PDF தாஜிக் இயல்புநிலை ஆண்டு', 'Only the selected Tajik year will be included in the PDF report.': 'PDF அறிக்கையில் தேர்ந்தெடுக்கப்பட்ட தாஜிக் ஆண்டு மட்டுமே சேர்க்கப்படும்.' },
  te: { 'PDF Tajik Default Year': 'PDF తాజిక్ డిఫాల్ట్ సంవత్సరం', 'Only the selected Tajik year will be included in the PDF report.': 'PDF నివేదికలో ఎంచుకున్న తాజిక్ సంవత్సరం మాత్రమే చేర్చబడుతుంది.' },
  mr: { 'PDF Tajik Default Year': 'PDF ताजिक डीफॉल्ट वर्ष', 'Only the selected Tajik year will be included in the PDF report.': 'PDF अहवालात फक्त निवडलेले ताजिक वर्ष समाविष्ट केले जाईल.' },
  gu: { 'PDF Tajik Default Year': 'PDF તાજિક ડિફૉલ્ટ વર્ષ', 'Only the selected Tajik year will be included in the PDF report.': 'PDF રિપોર્ટમાં ફક્ત પસંદ કરેલું તાજિક વર્ષ સામેલ થશે.' },
  bn: { 'PDF Tajik Default Year': 'PDF তাজিক ডিফল্ট বছর', 'Only the selected Tajik year will be included in the PDF report.': 'PDF রিপোর্টে শুধু নির্বাচিত তাজিক বছর অন্তর্ভুক্ত হবে।' },
  kn: { 'PDF Tajik Default Year': 'PDF ತಾಜಿಕ್ ಡೀಫಾಲ್ಟ್ ವರ್ಷ', 'Only the selected Tajik year will be included in the PDF report.': 'PDF ವರದಿಯಲ್ಲಿ ಆಯ್ಕೆ ಮಾಡಿದ ತಾಜಿಕ್ ವರ್ಷವನ್ನು ಮಾತ್ರ ಸೇರಿಸಲಾಗುತ್ತದೆ.' },
  ml: { 'PDF Tajik Default Year': 'PDF താജിക് ഡിഫോൾട്ട് വർഷം', 'Only the selected Tajik year will be included in the PDF report.': 'PDF റിപ്പോർട്ടിൽ തിരഞ്ഞെടുത്ത താജിക് വർഷം മാത്രം ഉൾപ്പെടുത്തും.' },
  pa: { 'PDF Tajik Default Year': 'PDF ਤਾਜਿਕ ਡਿਫਾਲਟ ਸਾਲ', 'Only the selected Tajik year will be included in the PDF report.': 'PDF ਰਿਪੋਰਟ ਵਿੱਚ ਸਿਰਫ਼ ਚੁਣਿਆ ਹੋਇਆ ਤਾਜਿਕ ਸਾਲ ਸ਼ਾਮਲ ਕੀਤਾ ਜਾਵੇਗਾ।' },
  or: { 'PDF Tajik Default Year': 'PDF ତାଜିକ ଡିଫଲ୍ଟ ବର୍ଷ', 'Only the selected Tajik year will be included in the PDF report.': 'PDF ରିପୋର୍ଟରେ କେବଳ ଚୟନିତ ତାଜିକ ବର୍ଷ ସାମିଲ ହେବ।' },
  as: { 'PDF Tajik Default Year': 'PDF তাজিক ডিফল্ট বৰ্ষ', 'Only the selected Tajik year will be included in the PDF report.': 'PDF প্ৰতিবেদনখনত কেৱল নিৰ্বাচিত তাজিক বৰ্ষ অন্তৰ্ভুক্ত হ’ব।' },
  ur: { 'PDF Tajik Default Year': 'PDF تاجک ڈیفالٹ سال', 'Only the selected Tajik year will be included in the PDF report.': 'PDF رپورٹ میں صرف منتخب تاجک سال شامل ہوگا۔' },
};

const GEMSTONE_LABEL_TRANSLATIONS: Partial<Record<SupportedLanguage, Record<string, string>>> = {
  ta: { Primary: 'முதன்மை', Alternative: 'மாற்று', Parent: 'மூல ரத்தினம்', Caution: 'எச்சரிக்கை', Metal: 'உலோகம்', Finger: 'விரல்', Day: 'நாள்', Copper: 'செம்பு', Silver: 'வெள்ளி', Bronze: 'வெண்கலம்', Brass: 'பித்தளை', Gold: 'தங்கம்', Iron: 'இரும்பு', Panchdhatu: 'பஞ்சலோகம்', Ashtadhatu: 'அஷ்டதாது', Ruby: 'மாணிக்கம்', Pearl: 'முத்து', Emerald: 'மரகதம்', Diamond: 'வைரம்', Hessonite: 'கோமேதகம்', General: 'பொது', Money: 'பணம்', Spirituality: 'ஆன்மிகம்', Protection: 'பாதுகாப்பு', Calculate: 'கணக்கிடு' },
  te: { Primary: 'ప్రధానం', Alternative: 'ప్రత్యామ్నాయం', Parent: 'మూల రత్నం', Caution: 'జాగ్రత్త', Metal: 'లోహం', Finger: 'వేలు', Day: 'రోజు', Copper: 'రాగి', Silver: 'వెండి', Bronze: 'కంచు', Brass: 'ఇత్తడి', Gold: 'బంగారం', Iron: 'ఇనుము', Panchdhatu: 'పంచలోహం', Ashtadhatu: 'అష్టధాతువు', Ruby: 'మాణిక్యం', Pearl: 'ముత్యం', Emerald: 'పచ్చ', Diamond: 'వజ్రం', Hessonite: 'గోమేధికం', General: 'సాధారణం', Money: 'ధనం', Spirituality: 'ఆధ్యాత్మికత', Protection: 'రక్షణ', Calculate: 'లెక్కించు' },
  mr: { Primary: 'मुख्य', Alternative: 'पर्यायी', Parent: 'मूळ रत्न', Caution: 'सावधगिरी', Metal: 'धातू', Finger: 'बोट', Day: 'दिवस', Copper: 'तांबे', Silver: 'चांदी', Bronze: 'कांस्य', Brass: 'पितळ', Gold: 'सोने', Iron: 'लोखंड', Panchdhatu: 'पंचधातू', Ashtadhatu: 'अष्टधातू', Ruby: 'माणिक', Pearl: 'मोती', Emerald: 'पाचू', Diamond: 'हिरा', Hessonite: 'गोमेद', General: 'सामान्य', Money: 'पैसा', Spirituality: 'अध्यात्म', Protection: 'संरक्षण', Calculate: 'गणना करा' },
  gu: { Primary: 'મુખ્ય', Alternative: 'વૈકલ્પિક', Parent: 'મૂળ રત્ન', Caution: 'સાવચેતી', Metal: 'ધાતુ', Finger: 'આંગળી', Day: 'દિવસ', Copper: 'તાંબું', Silver: 'ચાંદી', Bronze: 'કાંસું', Brass: 'પિત્તળ', Gold: 'સોનું', Iron: 'લોખંડ', Panchdhatu: 'પંચધાતુ', Ashtadhatu: 'અષ્ટધાતુ', Ruby: 'માણેક', Pearl: 'મોતી', Emerald: 'પન્ના', Diamond: 'હીરો', Hessonite: 'ગોમેદ', General: 'સામાન્ય', Money: 'ધન', Spirituality: 'આધ્યાત્મિકતા', Protection: 'સુરક્ષા', Calculate: 'ગણતરી કરો' },
  bn: { Primary: 'প্রধান', Alternative: 'বিকল্প', Parent: 'মূল রত্ন', Caution: 'সতর্কতা', Metal: 'ধাতু', Finger: 'আঙুল', Day: 'দিন', Copper: 'তামা', Silver: 'রূপা', Bronze: 'ব্রোঞ্জ', Brass: 'পিতল', Gold: 'সোনা', Iron: 'লোহা', Panchdhatu: 'পঞ্চধাতু', Ashtadhatu: 'অষ্টধাতু', Ruby: 'চুনি', Pearl: 'মুক্তা', Emerald: 'পান্না', Diamond: 'হীরা', Hessonite: 'গোমেদ', General: 'সাধারণ', Money: 'অর্থ', Spirituality: 'আধ্যাত্মিকতা', Protection: 'সুরক্ষা', Calculate: 'গণনা করুন' },
  kn: { Primary: 'ಪ್ರಧಾನ', Alternative: 'ಪರ್ಯಾಯ', Parent: 'ಮೂಲ ರತ್ನ', Caution: 'ಎಚ್ಚರಿಕೆ', Metal: 'ಲೋಹ', Finger: 'ಬೆರಳು', Day: 'ದಿನ', Copper: 'ತಾಮ್ರ', Silver: 'ಬೆಳ್ಳಿ', Bronze: 'ಕಂಚು', Brass: 'ಹಿತ್ತಾಳೆ', Gold: 'ಚಿನ್ನ', Iron: 'ಕಬ್ಬಿಣ', Panchdhatu: 'ಪಂಚಲೋಹ', Ashtadhatu: 'ಅಷ್ಟಧಾತು', Ruby: 'ಮಾಣಿಕ್ಯ', Pearl: 'ಮುತ್ತು', Emerald: 'ಪಚ್ಚೆ', Diamond: 'ವಜ್ರ', Hessonite: 'ಗೋಮೇದ', General: 'ಸಾಮಾನ್ಯ', Money: 'ಹಣ', Spirituality: 'ಆಧ್ಯಾತ್ಮಿಕತೆ', Protection: 'ರಕ್ಷಣೆ', Calculate: 'ಲೆಕ್ಕ ಹಾಕಿ' },
  ml: { Primary: 'പ്രധാനം', Alternative: 'പകരം', Parent: 'മൂല രത്നം', Caution: 'ശ്രദ്ധിക്കുക', Metal: 'ലോഹം', Finger: 'വിരൽ', Day: 'ദിവസം', Copper: 'ചെമ്പ്', Silver: 'വെള്ളി', Bronze: 'വെങ്കലം', Brass: 'പിച്ചള', Gold: 'സ്വർണം', Iron: 'ഇരുമ്പ്', Panchdhatu: 'പഞ്ചലോഹം', Ashtadhatu: 'അഷ്ടധാതു', Ruby: 'മാണിക്യം', Pearl: 'മുത്ത്', Emerald: 'മരതകം', Diamond: 'വജ്രം', Hessonite: 'ഗോമേദകം', General: 'പൊതുവായത്', Money: 'ധനം', Spirituality: 'ആത്മീയത', Protection: 'സംരക്ഷണം', Calculate: 'കണക്കാക്കുക' },
  pa: { Primary: 'ਮੁੱਖ', Alternative: 'ਵਿਕਲਪ', Parent: 'ਮੂਲ ਰਤਨ', Caution: 'ਸਾਵਧਾਨੀ', Metal: 'ਧਾਤੂ', Finger: 'ਉਂਗਲ', Day: 'ਦਿਨ', Copper: 'ਤਾਂਬਾ', Silver: 'ਚਾਂਦੀ', Bronze: 'ਕਾਂਸੀ', Brass: 'ਪਿੱਤਲ', Gold: 'ਸੋਨਾ', Iron: 'ਲੋਹਾ', Panchdhatu: 'ਪੰਚਧਾਤੂ', Ashtadhatu: 'ਅਸ਼ਟਧਾਤੂ', Ruby: 'ਮਾਣਕ', Pearl: 'ਮੋਤੀ', Emerald: 'ਪੰਨਾ', Diamond: 'ਹੀਰਾ', Hessonite: 'ਗੋਮੇਦ', General: 'ਆਮ', Money: 'ਧਨ', Spirituality: 'ਆਧਿਆਤਮਿਕਤਾ', Protection: 'ਸੁਰੱਖਿਆ', Calculate: 'ਗਣਨਾ ਕਰੋ' },
  or: { Primary: 'ମୁଖ୍ୟ', Alternative: 'ବିକଳ୍ପ', Parent: 'ମୂଳ ରତ୍ନ', Caution: 'ସାବଧାନତା', Metal: 'ଧାତୁ', Finger: 'ଆଙ୍ଗୁଠି', Day: 'ଦିନ', Copper: 'ତମ୍ବା', Silver: 'ରୂପା', Bronze: 'କାଂସ୍ୟ', Brass: 'ପିତ୍ତଳ', Gold: 'ସୁନା', Iron: 'ଲୁହା', Panchdhatu: 'ପଞ୍ଚଧାତୁ', Ashtadhatu: 'ଅଷ୍ଟଧାତୁ', Ruby: 'ମାଣିକ୍ୟ', Pearl: 'ମୁକ୍ତା', Emerald: 'ପନ୍ନା', Diamond: 'ହୀରା', Hessonite: 'ଗୋମେଦ', General: 'ସାଧାରଣ', Money: 'ଧନ', Spirituality: 'ଆଧ୍ୟାତ୍ମିକତା', Protection: 'ସୁରକ୍ଷା', Calculate: 'ଗଣନା କରନ୍ତୁ' },
  as: { Primary: 'মুখ্য', Alternative: 'বিকল্প', Parent: 'মূল ৰত্ন', Caution: 'সাৱধানতা', Metal: 'ধাতু', Finger: 'আঙুলি', Day: 'দিন', Copper: 'তাম', Silver: 'ৰূপ', Bronze: 'ব্ৰঞ্জ', Brass: 'পিতল', Gold: 'সোণ', Iron: 'লোহা', Panchdhatu: 'পঞ্চধাতু', Ashtadhatu: 'অষ্টধাতু', Ruby: 'মাণিক', Pearl: 'মুকুতা', Emerald: 'পান্না', Diamond: 'হীৰা', Hessonite: 'গোমেদ', General: 'সাধাৰণ', Money: 'ধন', Spirituality: 'আধ্যাত্মিকতা', Protection: 'সুৰক্ষা', Calculate: 'গণনা কৰক' },
  ur: { Primary: 'بنیادی', Alternative: 'متبادل', Parent: 'اصل نگینہ', Caution: 'احتیاط', Metal: 'دھات', Finger: 'انگلی', Day: 'دن', Copper: 'تانبا', Silver: 'چاندی', Bronze: 'کانسی', Brass: 'پیتل', Gold: 'سونا', Iron: 'لوہا', Panchdhatu: 'پنچ دھاتو', Ashtadhatu: 'اشٹ دھاتو', Ruby: 'یاقوت', Pearl: 'موتی', Emerald: 'زمرد', Diamond: 'ہیرا', Hessonite: 'گومید', General: 'عمومی', Money: 'دولت', Spirituality: 'روحانیت', Protection: 'تحفظ', Calculate: 'حساب کریں' },
};

export const translateInline = (language: string | null | undefined, english: string, hindi?: string) => {
  const normalized = normalizeLanguage(language);
  const leading = english.match(/^\s*/)?.[0] || '';
  const trailing = english.match(/\s*$/)?.[0] || '';
  const source = english.trim();
  if (!source || normalized === 'en') return english;
  const defaultChartSectionTranslations = DEFAULT_CHART_SECTION_TRANSLATIONS[normalized];
  const defaultChartSectionTranslation = defaultChartSectionTranslations
    ? defaultChartSectionTranslations[source]
    : undefined;
  if (defaultChartSectionTranslation) return `${leading}${defaultChartSectionTranslation}${trailing}`;
  if (KP_AYANAMSHA_PREFERENCE_TRANSLATIONS[normalized]?.[source]) return `${leading}${KP_AYANAMSHA_PREFERENCE_TRANSLATIONS[normalized][source]}${trailing}`;
  if (normalized === 'hi') return `${leading}${hindi || NADI_LIFE_EVENT_TRANSLATIONS.hi?.[source] || PDF_TAJIK_YEAR_TRANSLATIONS.hi?.[source] || INLINE_TRANSLATIONS.hi?.[source] || source}${trailing}`;
  return `${leading}${NADI_LIFE_EVENT_TRANSLATIONS[normalized]?.[source] || PDF_TAJIK_YEAR_TRANSLATIONS[normalized]?.[source] || INLINE_TRANSLATIONS[normalized]?.[source] || MODULE_INLINE_TRANSLATIONS[normalized]?.[source] || GEMSTONE_LABEL_TRANSLATIONS[normalized]?.[source] || source}${trailing}`;
};

export const inlineLocale = (language: string | null | undefined) => {
  const normalized = normalizeLanguage(language);
  return normalized === 'en' ? 'en-IN' : normalized === 'hi' ? 'hi-IN' : normalized;
};

export const reportLanguageFromPreference = (language: string | null | undefined) => normalizeLanguage(language);
